(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb7c5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb7c5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gtaQ6", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $17ce04f87c0238a0$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "proxyPrototype", function () { return $17ce04f87c0238a0$export$2a489b3f92f4996a; });
$parcel$export(module.exports, "toHyphenCase", function () { return $17ce04f87c0238a0$export$3f34ca2fef821bbd; });
$parcel$export(module.exports, "toCamelCase", function () { return $17ce04f87c0238a0$export$86f54f62aa7a7514; });
$parcel$export(module.exports, "uniqueID", function () { return $17ce04f87c0238a0$export$89912e019eef22aa; });
$parcel$export(module.exports, "likeArray", function () { return $17ce04f87c0238a0$export$b5a4d6f439a5044d; });
$parcel$export(module.exports, "isTypedArray", function () { return $17ce04f87c0238a0$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "splitArray", function () { return $17ce04f87c0238a0$export$697c3df919c0e61a; });
$parcel$export(module.exports, "countBy", function () { return $17ce04f87c0238a0$export$1d012a0dff3dab06; });
$parcel$export(module.exports, "createAsyncIterator", function () { return $17ce04f87c0238a0$export$86c18c6347f4a8c4; });
$parcel$export(module.exports, "ByteSize", function () { return $17ce04f87c0238a0$export$271f7c16f175f804; });
$parcel$export(module.exports, "Second", function () { return $17ce04f87c0238a0$export$c489aa6f7fd82b1a; });
$parcel$export(module.exports, "parseJSON", function () { return $17ce04f87c0238a0$export$27924e57e9afff7f; });
$parcel$export(module.exports, "parseDOM", function () { return $17ce04f87c0238a0$export$d66b332881d9723f; });
$parcel$export(module.exports, "stringifyDOM", function () { return $17ce04f87c0238a0$export$b0709844452f8b6b; });
$parcel$export(module.exports, "formToJSON", function () { return $17ce04f87c0238a0$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "serviceWorkerUpdate", function () { return $17ce04f87c0238a0$export$d635d04af3887bbe; });

var $jAEAr = parcelRequire("jAEAr");

var $dafVd = parcelRequire("dafVd");

var $3gP77 = parcelRequire("3gP77");

var $dm3mz = parcelRequire("dm3mz");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $7t5yo = parcelRequire("7t5yo");

var $13u2V = parcelRequire("13u2V");

var $Csf8W = parcelRequire("Csf8W");
function $17ce04f87c0238a0$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $17ce04f87c0238a0$var$$9b05bcda60cc529c$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $17ce04f87c0238a0$export$61cc6ed0f143570b;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $17ce04f87c0238a0$export$dd1bc94b04021eeb;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $17ce04f87c0238a0$export$a09f818797e212c4;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $17ce04f87c0238a0$export$170f4e08cad8229d;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $17ce04f87c0238a0$export$2a489b3f92f4996a;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $17ce04f87c0238a0$export$67a6ce548ae77071;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $17ce04f87c0238a0$export$a48f0734ac7c2329;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $17ce04f87c0238a0$export$3f34ca2fef821bbd;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $17ce04f87c0238a0$export$86f54f62aa7a7514;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $17ce04f87c0238a0$export$89912e019eef22aa;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $17ce04f87c0238a0$export$8fb536984ec8b4d7;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "toBase64", function() {
    return $17ce04f87c0238a0$export$37cc283d8fbd3462;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $17ce04f87c0238a0$export$94fdf11bafc8de6b;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $17ce04f87c0238a0$export$1c8ba402144543e5;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $17ce04f87c0238a0$export$2ddabb89308e1a22;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $17ce04f87c0238a0$export$14527669107aa301;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $17ce04f87c0238a0$export$3f063810d7bf01bd;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $17ce04f87c0238a0$export$b5a4d6f439a5044d;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $17ce04f87c0238a0$export$b119cc7e1840e59c;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $17ce04f87c0238a0$export$7b85fd78dd236198;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $17ce04f87c0238a0$export$697c3df919c0e61a;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $17ce04f87c0238a0$export$1d012a0dff3dab06;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $17ce04f87c0238a0$export$e6b5ff3168b5942b;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $17ce04f87c0238a0$export$9cd59f9826255e47;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $17ce04f87c0238a0$export$fbc9cd6af26fa64f;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $17ce04f87c0238a0$export$69a3209f1a06c04d;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $17ce04f87c0238a0$export$86c18c6347f4a8c4;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $17ce04f87c0238a0$export$dce9414bed0662c;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $17ce04f87c0238a0$export$271f7c16f175f804;
});
var $17ce04f87c0238a0$var$$6a9944941b4c1893$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$6a9944941b4c1893$exports, "sum", function() {
    return $17ce04f87c0238a0$export$8a63f25cc62965f1;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $17ce04f87c0238a0$export$e1f36757ecda301d;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $17ce04f87c0238a0$export$8e694e1eafd55acb;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $17ce04f87c0238a0$export$57d7c52a66287430;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $17ce04f87c0238a0$export$2b4693832ca3ce16;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $17ce04f87c0238a0$export$5b784e078da1ce6;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $17ce04f87c0238a0$export$17ec9c9f4f23588c;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $17ce04f87c0238a0$export$595dbf49c602a1f;
});
function $17ce04f87c0238a0$export$8a63f25cc62965f1() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return data.reduce(function(sum, item) {
        return sum + item;
    }, 0);
}
function $17ce04f87c0238a0$export$e1f36757ecda301d() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return $17ce04f87c0238a0$export$8a63f25cc62965f1.apply(void 0, (0, $aUGqu._)(data)) / data.length;
}
function $17ce04f87c0238a0$export$8e694e1eafd55acb(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var average = $17ce04f87c0238a0$export$e1f36757ecda301d.apply(void 0, (0, $aUGqu._)(data));
    var summary = $17ce04f87c0238a0$export$8a63f25cc62965f1.apply(void 0, (0, $aUGqu._)(data.map(function(item) {
        return Math.pow(item - average, 2);
    })));
    return summary / (data.length - (sample ? 1 : 0));
}
function $17ce04f87c0238a0$export$57d7c52a66287430(data) {
    var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Math.sqrt($17ce04f87c0238a0$export$8e694e1eafd55acb(data, sample));
}
function $17ce04f87c0238a0$export$2b4693832ca3ce16() {
    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
        data[_key] = arguments[_key];
    }
    return Math.sqrt($17ce04f87c0238a0$export$8a63f25cc62965f1.apply(void 0, (0, $aUGqu._)(data.map(function(item) {
        return Math.pow(item, 2);
    }))));
}
function $17ce04f87c0238a0$export$5b784e078da1ce6(raw, length) {
    var text = raw.toFixed(length + 2);
    var offset = text.indexOf('.') + length + 1;
    var cut = function(text) {
        return text.slice(0, offset - (length ? 0 : 1));
    };
    if (!+text.slice(offset)) return cut(text);
    var result = cut((+cut(text) + Math.pow(10, -length)).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $17ce04f87c0238a0$export$17ec9c9f4f23588c(raw) {
    var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    var text = raw.toFixed(length + 2);
    var floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? "".concat(text, ".").concat('0'.repeat(length)) : text;
    var offset = floatOffset + length + 1;
    var before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    var carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $17ce04f87c0238a0$export$5b784e078da1ce6(raw, length);
    var result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
var $17ce04f87c0238a0$export$595dbf49c602a1f = /*#__PURE__*/ function() {
    "use strict";
    function $6a9944941b4c1893$export$595dbf49c602a1f(value) {
        (0, $173N4._)(this, $6a9944941b4c1893$export$595dbf49c602a1f);
        this.value = value;
    }
    (0, $cFHGC._)($6a9944941b4c1893$export$595dbf49c602a1f, [
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        },
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
                var _this = this, units = _this.units, value = _this.value;
                var _ref = (0, $aUGqu._)(units).reverse().find(function(param) {
                    var base = param.base;
                    return Math.abs(value) >= base;
                }) || units[0], base = _ref.base, name = _ref.name;
                return "".concat((value / base).toFixed(fractionDigits), " ").concat(name);
            }
        }
    ], [
        {
            key: "distanceOf",
            value: function distanceOf(a, b) {
                return Reflect.construct(this, [
                    a - b
                ]);
            }
        }
    ]);
    return $6a9944941b4c1893$export$595dbf49c602a1f;
}();
var $17ce04f87c0238a0$export$61cc6ed0f143570b = function(value) {
    return !(value != null) || Number.isNaN(value);
};
var $17ce04f87c0238a0$export$dd1bc94b04021eeb = function(value) {
    return $17ce04f87c0238a0$export$61cc6ed0f143570b(value) || ((typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === 'object' ? !Object.keys(value).length : value === '');
};
var $17ce04f87c0238a0$export$a09f818797e212c4 = function(data) {
    return Object.prototype.toString.call(data).slice(8, -1);
};
var $17ce04f87c0238a0$export$170f4e08cad8229d = function(Sub, Super) {
    return Sub.prototype instanceof Super;
};
function $17ce04f87c0238a0$export$2a489b3f92f4996a(target, dataStore, setter) {
    var prototype = Object.getPrototypeOf(target);
    var prototypeProxy = new Proxy(prototype, {
        set: function(_, key, value, receiver) {
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter === null || setter === void 0 ? void 0 : setter(key, value);
            return true;
        },
        get: function(prototype, key, receiver) {
            return key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver);
        }
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
var $17ce04f87c0238a0$export$67a6ce548ae77071 = function(raw) {
    return /^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
};
var $17ce04f87c0238a0$export$a48f0734ac7c2329 = function(raw) {
    return raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
};
var $17ce04f87c0238a0$export$3f34ca2fef821bbd = function(raw) {
    return raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return "".concat(offset ? '-' : '').concat((match[1] || match[0]).toLowerCase());
    });
};
var $17ce04f87c0238a0$export$86f54f62aa7a7514 = function(raw) {
    var large = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, function(match, offset) {
        return offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase();
    });
};
var $17ce04f87c0238a0$export$89912e019eef22aa = function() {
    return (Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
};
var $17ce04f87c0238a0$export$8fb536984ec8b4d7 = function(input) {
    return new TextEncoder().encode(input).toBase64();
};
function $17ce04f87c0238a0$export$37cc283d8fbd3462(input) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (typeof input === 'string') return [
                        2,
                        $17ce04f87c0238a0$export$8fb536984ec8b4d7(input)
                    ];
                    if (!(input instanceof Blob)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        input.arrayBuffer()
                    ];
                case 1:
                    input = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        new Uint8Array(input).toBase64()
                    ];
            }
        });
    })();
}
var $17ce04f87c0238a0$export$94fdf11bafc8de6b = function(input) {
    return new TextDecoder().decode(Uint8Array.fromBase64(input));
};
var $17ce04f87c0238a0$export$1c8ba402144543e5 = function(values, keys) {
    return Object.fromEntries(values.map(function(value, index) {
        return [
            keys[index],
            value
        ];
    }));
};
var $17ce04f87c0238a0$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $17ce04f87c0238a0$export$14527669107aa301(oldList, newList) {
    var oldSet = new Set(oldList), newSet = new Set(newList);
    var map = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = oldSet.difference(newSet)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item] = -1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = oldSet.intersection(newSet)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            map[item1] = 0;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = newSet.difference(oldSet)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var item2 = _step2.value;
            map[item2] = 1;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return {
        map: map,
        group: $17ce04f87c0238a0$export$3f063810d7bf01bd(Object.entries(map), function(param) {
            var _param = (0, $f9AOD._)(param, 2), key = _param[0], status = _param[1];
            return status;
        })
    };
}
function $17ce04f87c0238a0$export$b5a4d6f439a5044d(data) {
    if ($17ce04f87c0238a0$export$61cc6ed0f143570b(data)) return false;
    var length = data.length;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
var $17ce04f87c0238a0$export$b119cc7e1840e59c = function(data) {
    return data instanceof Object.getPrototypeOf(Int8Array);
};
function $17ce04f87c0238a0$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($17ce04f87c0238a0$export$61cc6ed0f143570b(data)) return Array();
    if ($17ce04f87c0238a0$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
var $17ce04f87c0238a0$export$697c3df919c0e61a = function(array, unitLength) {
    return array.reduce(function(grid, item, index) {
        var _grid, _ref;
        ((_grid = grid)[_ref = ~~(index / unitLength)] || (_grid[_ref] = []))[index % unitLength] = item;
        return grid;
    }, []);
};
function $17ce04f87c0238a0$export$3f063810d7bf01bd(list, iteratee) {
    var data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
            if (!(keys instanceof Array)) keys = [
                keys
            ];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = new Set(keys.filter(function(key) {
                    return key != null;
                }))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key = _step1.value;
                    (data[key] = data[key] || []).push(item);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
function $17ce04f87c0238a0$export$1d012a0dff3dab06(list, iteratee) {
    var group = $17ce04f87c0238a0$export$3f063810d7bf01bd(list, iteratee);
    var sortedList = Object.entries(group).map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], _param_ = _param[1], length = _param_.length;
        return [
            key,
            length
        ];
    });
    return Object.fromEntries(sortedList);
}
function $17ce04f87c0238a0$export$e6b5ff3168b5942b(list, subKey, handler) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (handler(item)) return [
                item
            ];
            if (item[subKey] instanceof Array) {
                var result = $17ce04f87c0238a0$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
                if (result.length) return [
                    item
                ].concat((0, $aUGqu._)(result));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}
function $17ce04f87c0238a0$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch (e) {
        return JSON.parse(JSON.stringify(data));
    }
}
function $17ce04f87c0238a0$export$fbc9cd6af26fa64f(list) {
    var idKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'id', parentIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'parentId', childrenKey = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'children';
    list = $17ce04f87c0238a0$export$9cd59f9826255e47(list);
    var map = {};
    var roots = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            map[item[idKey]] = item;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = list[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var item1 = _step1.value;
            var parent = map[item1[parentIdKey]];
            if (!parent) roots.push(item1);
            else {
                var _parent, _childrenKey;
                (_parent = parent)[_childrenKey = childrenKey] || (_parent[_childrenKey] = []);
                parent[childrenKey].push(item1);
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $17ce04f87c0238a0$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function() {
        for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++){
            data[_key] = arguments[_key];
        }
        var _executor;
        if (cacheData != null) return cacheData;
        console.trace("[Cache] execute: ".concat(title));
        cacheData = (_executor = executor).call.apply(_executor, [
            this,
            function() {
                return cacheData = undefined;
            }
        ].concat((0, $aUGqu._)(data)));
        Promise.resolve(cacheData).then(function(data) {
            return console.log("[Cache] refreshed: ".concat(title, " => ").concat(data));
        }, function(error) {
            return console.error("[Cache] failed: ".concat((error === null || error === void 0 ? void 0 : error.message) || error));
        });
        return cacheData;
    };
}
function $17ce04f87c0238a0$export$86c18c6347f4a8c4(executor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var _Promise_withResolvers, promise, resolve, reject, doneSymbol, done, disposer, value, ref;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _Promise_withResolvers = Promise.withResolvers(), promise = _Promise_withResolvers.promise, resolve = _Promise_withResolvers.resolve, reject = _Promise_withResolvers.reject;
                    doneSymbol = Symbol('done'), done = Promise.withResolvers();
                    disposer = executor({
                        next: function(value) {
                            return resolve(value);
                        },
                        error: function(error) {
                            reject(error);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        },
                        complete: function() {
                            done.resolve(doneSymbol);
                            // @ts-ignore
                            disposer === null || disposer === void 0 ? void 0 : disposer();
                        }
                    });
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (0, $dm3mz._)(Promise.race([
                            promise,
                            done.promise
                        ]))
                    ];
                case 2:
                    value = _state.sent();
                    if (value === doneSymbol) return [
                        2
                    ];
                    return [
                        4,
                        value
                    ];
                case 3:
                    _state.sent();
                    ref = Promise.withResolvers(), promise = ref.promise, resolve = ref.resolve, reject = ref.reject, ref;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $17ce04f87c0238a0$export$dce9414bed0662c() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++){
        sources[_key] = arguments[_key];
    }
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var _loop, iterators;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function() {
                        var dones, i, iterator, _ref, done, value;
                        return (0, $13u2V._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    dones = [];
                                    i = 0, iterator = void 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(iterator = iterators[i])) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        (0, $dm3mz._)(iterator.next())
                                    ];
                                case 2:
                                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                                    if (!!done) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        value
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    dones.push(i);
                                    _state.label = 5;
                                case 5:
                                    i++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 6:
                                    iterators = iterators.filter(function(_, i) {
                                        return !dones.includes(i);
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    iterators = sources.map(function(item) {
                        return item();
                    });
                    _state.label = 1;
                case 1:
                    if (!iterators[0]) return [
                        3,
                        3
                    ];
                    return [
                        5,
                        (0, $Csf8W.__values)(_loop())
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $17ce04f87c0238a0$export$271f7c16f175f804 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $hdIku._)($9b05bcda60cc529c$export$271f7c16f175f804, $6a9944941b4c1893$export$595dbf49c602a1f);
    function $9b05bcda60cc529c$export$271f7c16f175f804() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $9b05bcda60cc529c$export$271f7c16f175f804);
        var _this;
        _this = (0, $7qXGD._)(this, $9b05bcda60cc529c$export$271f7c16f175f804, (0, $aUGqu._)(args)), _this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map(function(name, i) {
            return {
                base: Math.pow(1024, i),
                name: name + 'B'
            };
        });
        return _this;
    }
    return $9b05bcda60cc529c$export$271f7c16f175f804;
}($17ce04f87c0238a0$export$595dbf49c602a1f);
var $17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $17ce04f87c0238a0$export$c489aa6f7fd82b1a;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $17ce04f87c0238a0$export$cbd942915f33be50;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $17ce04f87c0238a0$export$9b886f8493244014;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $17ce04f87c0238a0$export$e99cbb807a5bb10d;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $17ce04f87c0238a0$export$7a9a31a911eb9a20;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $17ce04f87c0238a0$export$fca4f8121099df57;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $17ce04f87c0238a0$export$6ce2f08d515512;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $17ce04f87c0238a0$export$951c8378cdfec6e6;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $17ce04f87c0238a0$export$1a4097b876a13bf7;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $17ce04f87c0238a0$export$d9bcbd5e1ff81430;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $17ce04f87c0238a0$export$506c8e8f8c8edda;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $17ce04f87c0238a0$export$3ae94a2503e890a1;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $17ce04f87c0238a0$export$7e1c707225b48c34;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $17ce04f87c0238a0$export$62ad822b3a5fd9a0;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $17ce04f87c0238a0$export$9e85258502147ffb;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $17ce04f87c0238a0$export$3c1f2e5bc03748e2;
});
var $17ce04f87c0238a0$export$c489aa6f7fd82b1a = 1000;
var $17ce04f87c0238a0$export$cbd942915f33be50 = $17ce04f87c0238a0$export$c489aa6f7fd82b1a * 60;
var $17ce04f87c0238a0$export$9b886f8493244014 = $17ce04f87c0238a0$export$cbd942915f33be50 * 15;
var $17ce04f87c0238a0$export$e99cbb807a5bb10d = $17ce04f87c0238a0$export$9b886f8493244014 * 4;
var $17ce04f87c0238a0$export$7a9a31a911eb9a20 = $17ce04f87c0238a0$export$e99cbb807a5bb10d * 24;
var $17ce04f87c0238a0$export$fca4f8121099df57 = $17ce04f87c0238a0$export$7a9a31a911eb9a20 * 7;
var $17ce04f87c0238a0$export$6ce2f08d515512 = $17ce04f87c0238a0$export$7a9a31a911eb9a20 * 365;
var $17ce04f87c0238a0$export$951c8378cdfec6e6 = $17ce04f87c0238a0$export$6ce2f08d515512 / 12;
var $17ce04f87c0238a0$export$1a4097b876a13bf7 = $17ce04f87c0238a0$export$951c8378cdfec6e6 * 3;
var $17ce04f87c0238a0$export$d9bcbd5e1ff81430 = /*#__PURE__*/ function($6a9944941b4c1893$export$595dbf49c602a1f) {
    "use strict";
    (0, $hdIku._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, $6a9944941b4c1893$export$595dbf49c602a1f);
    function $f872d8bba1c0f79f$export$d9bcbd5e1ff81430() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $173N4._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430);
        var _this;
        _this = (0, $7qXGD._)(this, $f872d8bba1c0f79f$export$d9bcbd5e1ff81430, (0, $aUGqu._)(args)), _this.units = [
            {
                base: $17ce04f87c0238a0$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $17ce04f87c0238a0$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $17ce04f87c0238a0$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $17ce04f87c0238a0$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $17ce04f87c0238a0$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $17ce04f87c0238a0$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $17ce04f87c0238a0$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
        return _this;
    }
    (0, $cFHGC._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430, [
        {
            key: "toShortString",
            value: function toShortString() {
                var fractionDigits = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                return (0, $dWsrg._)((0, $kg0zo._)($f872d8bba1c0f79f$export$d9bcbd5e1ff81430.prototype), "toShortString", this).call(this, fractionDigits);
            }
        }
    ]);
    return $f872d8bba1c0f79f$export$d9bcbd5e1ff81430;
}($17ce04f87c0238a0$export$595dbf49c602a1f);
function $17ce04f87c0238a0$export$506c8e8f8c8edda(end) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var timeDistance = $17ce04f87c0238a0$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    var _timeDistance_toShortString_split = (0, $f9AOD._)(timeDistance.toShortString().split(/\s+/), 2), value = _timeDistance_toShortString_split[0], unit = _timeDistance_toShortString_split[1];
    return {
        distance: +value,
        unit: unit
    };
}
function $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return function(template) {
        return (value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
    };
}
function $17ce04f87c0238a0$export$3ae94a2503e890a1() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date(), template = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'YYYY-MM-DD HH:mm:ss';
    var date = new Date(time);
    var localDate = new Date(+date - date.getTimezoneOffset() * $17ce04f87c0238a0$export$cbd942915f33be50);
    var _localDate_toJSON_split = (0, $f9AOD._)(localDate.toJSON().split(/\D/), 7), year = _localDate_toJSON_split[0], month = _localDate_toJSON_split[1], day = _localDate_toJSON_split[2], hour = _localDate_toJSON_split[3], minute = _localDate_toJSON_split[4], second = _localDate_toJSON_split[5], millisecond = _localDate_toJSON_split[6];
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $17ce04f87c0238a0$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $17ce04f87c0238a0$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    var month = date.getMonth() + delta;
    date = $17ce04f87c0238a0$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $17ce04f87c0238a0$export$9e85258502147ffb = function(date, unit, delta) {
    return unit === $17ce04f87c0238a0$export$6ce2f08d515512 ? $17ce04f87c0238a0$export$7e1c707225b48c34(date, delta) : unit === $17ce04f87c0238a0$export$951c8378cdfec6e6 ? $17ce04f87c0238a0$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
};
var $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $17ce04f87c0238a0$export$6ce2f08d515512,
    7: $17ce04f87c0238a0$export$951c8378cdfec6e6,
    10: $17ce04f87c0238a0$export$7a9a31a911eb9a20,
    13: $17ce04f87c0238a0$export$e99cbb807a5bb10d,
    16: $17ce04f87c0238a0$export$cbd942915f33be50,
    19: $17ce04f87c0238a0$export$c489aa6f7fd82b1a
};
function $17ce04f87c0238a0$export$3c1f2e5bc03748e2(value) {
    var defaultValue = "2025-01-01T00:00:00.000Z";
    var startedAt = new Date(value + defaultValue.slice(value.length));
    var endedAt = $17ce04f87c0238a0$export$9e85258502147ffb(startedAt, $17ce04f87c0238a0$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $17ce04f87c0238a0$var$$ba0e5dc395660a7c$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $17ce04f87c0238a0$export$27924e57e9afff7f;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $17ce04f87c0238a0$export$7ea17d45ecdcf634;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $17ce04f87c0238a0$export$bf304e455230454a;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $17ce04f87c0238a0$export$bb8626e4916f587b;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $17ce04f87c0238a0$export$88182f6768071c72;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $17ce04f87c0238a0$export$2427785258f88523;
});
function $17ce04f87c0238a0$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            var date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    var value = parseItem(raw);
    if (typeof value !== 'string' || $17ce04f87c0238a0$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, function(key, value) {
            return parseItem(value);
        });
    } catch (e) {
        return raw;
    }
}
function $17ce04f87c0238a0$export$7ea17d45ecdcf634(raw) {
    var parsed = $17ce04f87c0238a0$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    var number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
var $17ce04f87c0238a0$export$bf304e455230454a = function(data) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    return [
        Object.keys(data[0]).join(separator)
    ].concat((0, $aUGqu._)(data.map(function(item) {
        return Object.values(item).map(function(value) {
            return JSON.stringify(value);
        }).join(separator);
    }))).join('\n');
};
function $17ce04f87c0238a0$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    var quote = raw[0];
    var index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError("A ".concat(quote, " is missing"));
    return raw.slice(1, index);
}
function $17ce04f87c0238a0$var$$ba0e5dc395660a7c$var$parseRow(row) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    var list = [];
    do {
        var value = void 0;
        if (row[0] === '"' || row[0] === "'") {
            value = $17ce04f87c0238a0$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            var index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($17ce04f87c0238a0$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $17ce04f87c0238a0$export$bb8626e4916f587b(raw, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ',';
    var data = raw.trim().split(/[\r\n]+/).map(function(row) {
        return $17ce04f87c0238a0$var$$ba0e5dc395660a7c$var$parseRow(row, separator);
    });
    return !header ? data : data.slice(1).map(function(row) {
        return $17ce04f87c0238a0$export$1c8ba402144543e5(row, data[0]);
    });
}
var $17ce04f87c0238a0$export$88182f6768071c72 = function(raw) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            return [
                2,
                Array.fromAsync($17ce04f87c0238a0$export$2427785258f88523(raw[Symbol.iterator]()))
            ];
        });
    })();
};
function $17ce04f87c0238a0$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $dafVd._)(chunks);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $Csf8W.__values)((0, $jAEAr._)((0, $dafVd._)(chunk)))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.return())
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $17ce04f87c0238a0$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var inQuote, quoteChar, prevChar, cellBuffer, currentRow, completeCell, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, char, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    inQuote = false;
                    quoteChar = '';
                    prevChar = '';
                    cellBuffer = '';
                    currentRow = [];
                    completeCell = function() {
                        currentRow.push($17ce04f87c0238a0$export$7ea17d45ecdcf634(cellBuffer.trim()));
                        cellBuffer = '';
                    };
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        10,
                        11,
                        16
                    ]);
                    _iterator = (0, $dafVd._)(chars);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        9
                    ];
                    _value = _step.value;
                    char = _value;
                    if (!(char === '\n' || char === '\r')) return [
                        3,
                        6
                    ];
                    if (char === '\n' && prevChar === '\r') {
                        prevChar = char;
                        return [
                            3,
                            8
                        ];
                    }
                    completeCell();
                    if (!(currentRow.length > 1 || currentRow[0])) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        currentRow
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    currentRow = [];
                    return [
                        3,
                        7
                    ];
                case 6:
                    if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
                        inQuote = true;
                        quoteChar = char;
                    } else if (char === quoteChar && inQuote) {
                        inQuote = false;
                        quoteChar = '';
                    } else if (inQuote) cellBuffer += char;
                    else if (char === separator) completeCell();
                    else cellBuffer += char;
                    _state.label = 7;
                case 7:
                    prevChar = char;
                    _state.label = 8;
                case 8:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 9:
                    return [
                        3,
                        16
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        16
                    ];
                case 11:
                    _state.trys.push([
                        11,
                        ,
                        14,
                        15
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.return())
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 15:
                    return [
                        7
                    ];
                case 16:
                    if (!(cellBuffer || currentRow.length > 0)) return [
                        3,
                        18
                    ];
                    completeCell();
                    if (!(currentRow.length > 1 || currentRow[0])) return [
                        3,
                        18
                    ];
                    return [
                        4,
                        currentRow
                    ];
                case 17:
                    _state.sent();
                    _state.label = 18;
                case 18:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $17ce04f87c0238a0$export$2427785258f88523(chunks, header) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ',';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $7t5yo._)(function() {
        var headerRow, isFirstRow, chars, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, row, err;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isFirstRow = true;
                    chars = $17ce04f87c0238a0$var$$ba0e5dc395660a7c$var$characterStream(chunks);
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        14
                    ]);
                    _iterator = (0, $dafVd._)($17ce04f87c0238a0$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        7
                    ];
                    _value = _step.value;
                    row = _value;
                    if (!(header && isFirstRow)) return [
                        3,
                        4
                    ];
                    headerRow = row;
                    isFirstRow = false;
                    return [
                        3,
                        6
                    ];
                case 4:
                    return [
                        4,
                        header && headerRow ? $17ce04f87c0238a0$export$1c8ba402144543e5(row, headerRow) : row
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 7:
                    return [
                        3,
                        14
                    ];
                case 8:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        14
                    ];
                case 9:
                    _state.trys.push([
                        9,
                        ,
                        12,
                        13
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        (0, $dm3mz._)(_iterator.return())
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        13
                    ];
                case 12:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 13:
                    return [
                        7
                    ];
                case 14:
                    return [
                        2
                    ];
            }
        });
    })();
}
var $17ce04f87c0238a0$var$$083124ac4b1a50a0$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $17ce04f87c0238a0$export$71e6483fc2b024eb;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $17ce04f87c0238a0$export$eb9b2aadbe449a20;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $17ce04f87c0238a0$export$13397a83aa5915d6;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $17ce04f87c0238a0$export$fd89523fba250fa4;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $17ce04f87c0238a0$export$504fbde693c1771c;
});
var $17ce04f87c0238a0$export$71e6483fc2b024eb = function(URI) {
    return new URL(URI, document.baseURI).origin !== location.origin;
};
function $17ce04f87c0238a0$export$eb9b2aadbe449a20() {
    var raw = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _globalThis_location;
        return ((_globalThis_location = globalThis.location) === null || _globalThis_location === void 0 ? void 0 : _globalThis_location.search) || '';
    }(), toBuiltIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var rawData = raw.split('#').map(function(URI) {
        var _URI_split = (0, $f9AOD._)(URI.split('?'), 2), before = _URI_split[0], after = _URI_split[1];
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    var data = new URLSearchParams(rawData);
    return Object.fromEntries((0, $aUGqu._)(data.keys()).map(function(key) {
        var list = toBuiltIn ? data.getAll(key).map($17ce04f87c0238a0$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
var $17ce04f87c0238a0$var$$083124ac4b1a50a0$var$stringify = function(value) {
    return typeof value === 'string' ? value : $17ce04f87c0238a0$export$b5a4d6f439a5044d(value) ? $17ce04f87c0238a0$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
};
function $17ce04f87c0238a0$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    var list = map.map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
        return !$17ce04f87c0238a0$export$dd1bc94b04021eeb(value) && [
            key,
            $17ce04f87c0238a0$var$$083124ac4b1a50a0$var$stringify(value)
        ];
    }).filter(Boolean);
    return new URLSearchParams(list);
}
var $17ce04f87c0238a0$export$fd89523fba250fa4 = function(URI) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(URI + '')
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().blob()
                    ];
            }
        });
    })();
};
var $17ce04f87c0238a0$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $17ce04f87c0238a0$export$504fbde693c1771c(URI) {
    var _ref = (0, $f9AOD._)($17ce04f87c0238a0$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [], 5), _ = _ref[0], type = _ref[1], __ = _ref[2], base64 = _ref[3], data = _ref[4];
    return new Blob([
        base64 ? Uint8Array.fromBase64(data) : data
    ], {
        type: type
    });
}
var $17ce04f87c0238a0$var$$d677628cc2ac1e37$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $17ce04f87c0238a0$export$d0eaf3e94be578f6;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $17ce04f87c0238a0$export$110700823644f4a6;
});
var $17ce04f87c0238a0$export$d0eaf3e94be578f6 = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
        var _globalThis_document;
        return (_globalThis_document = globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.cookie;
    }();
    return value ? Object.fromEntries(value.split(/;\s*/).map(function(item) {
        return item.split('=');
    })) : {};
};
function $17ce04f87c0238a0$export$110700823644f4a6(key, value) {
    var attributes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var data = "".concat(key, "=").concat(value), option = Object.entries(attributes).map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), _$key = _param[0], _$value = _param[1];
        return typeof _$value === 'boolean' ? _$value ? _$key : '' : "".concat(_$key, "=").concat(_$value);
    }).filter(Boolean).join('; ');
    document.cookie = "".concat(data, "; expires=").concat(new Date(0));
    return document.cookie = "".concat(data, "; ").concat(option);
}
var $17ce04f87c0238a0$var$$50872bf213056663$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $17ce04f87c0238a0$export$1b9ac4d3de3ffd2e;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$50872bf213056663$exports, "makeSHA", function() {
    return $17ce04f87c0238a0$export$d51f3b55e8d1aa73;
});
var $17ce04f87c0238a0$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), function(_, cell) {
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $17ce04f87c0238a0$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            value = value >> 8 & 0x00ffffff ^ $17ce04f87c0238a0$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if ((typeof self === "undefined" ? "undefined" : (0, $7E0eS._)(self)) === 'object') {
    if ('msCrypto' in globalThis) {
        var $17ce04f87c0238a0$var$_loop = function(key) {
            var origin = $17ce04f87c0238a0$var$subtle[key];
            if (origin instanceof Function) $17ce04f87c0238a0$var$subtle[key] = function() {
                var observer = origin.apply(this, arguments);
                return new Promise(function(resolve, reject) {
                    observer.oncomplete = function(param) {
                        var target = param.target;
                        return resolve(target.result);
                    };
                    observer.onabort = observer.onerror = reject;
                });
            };
        };
        // @ts-expect-error — msCrypto is a non-standard API
        var $17ce04f87c0238a0$var$_ref = globalThis.crypto = globalThis.msCrypto, $17ce04f87c0238a0$var$subtle = $17ce04f87c0238a0$var$_ref.subtle;
        for(var $17ce04f87c0238a0$var$key in $17ce04f87c0238a0$var$subtle)$17ce04f87c0238a0$var$_loop($17ce04f87c0238a0$var$key);
    }
    var $17ce04f87c0238a0$var$crypto1 = globalThis.crypto;
    // @ts-expect-error — webkitSubtle is a non-standard API
    if (!($17ce04f87c0238a0$var$crypto1 === null || $17ce04f87c0238a0$var$crypto1 === void 0 ? void 0 : $17ce04f87c0238a0$var$crypto1.subtle) && ($17ce04f87c0238a0$var$crypto1 === null || $17ce04f87c0238a0$var$crypto1 === void 0 ? void 0 : $17ce04f87c0238a0$var$crypto1['webkitSubtle'])) $17ce04f87c0238a0$var$crypto1.subtle = $17ce04f87c0238a0$var$crypto1['webkitSubtle'];
}
function $17ce04f87c0238a0$export$d51f3b55e8d1aa73(raw) {
    var algorithm = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'SHA-1';
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var buffer;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        crypto.subtle.digest(algorithm, new TextEncoder().encode(raw))
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        2,
                        new Uint8Array(buffer).toHex()
                    ];
            }
        });
    })();
}
var $17ce04f87c0238a0$var$$93a3089d2937b23f$exports = {};
var $17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $17ce04f87c0238a0$export$f5a4056b78c72efa;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $17ce04f87c0238a0$export$2ee022bbbc550b25;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $17ce04f87c0238a0$export$a549dd5cef7f8327;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $17ce04f87c0238a0$export$8eece510bcb9c62c;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $17ce04f87c0238a0$export$b8a1af58c024fefd;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $17ce04f87c0238a0$export$a2cf0d4bb6e06de4;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $17ce04f87c0238a0$export$d66b332881d9723f;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $17ce04f87c0238a0$export$b0709844452f8b6b;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $17ce04f87c0238a0$export$5118471ee5d5453b;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $17ce04f87c0238a0$export$6e196edbcc00e5bc;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $17ce04f87c0238a0$export$be4650432daa84fd;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $17ce04f87c0238a0$export$578e38b4a3e0b255;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $17ce04f87c0238a0$export$7cd14c57bbb84350;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $17ce04f87c0238a0$export$5100419dfae0456d;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $17ce04f87c0238a0$export$28d9d24a8cd0ffc2;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $17ce04f87c0238a0$export$3f99968195accfaf;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $17ce04f87c0238a0$export$eafdbaa868ea9975;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $17ce04f87c0238a0$export$36a0c1ca2ae264fa;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $17ce04f87c0238a0$export$86d7c59254d6a2c9;
});
var $17ce04f87c0238a0$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var $17ce04f87c0238a0$var$$3e0a089cc13f69ad$var$templateMap = {};
function $17ce04f87c0238a0$export$2ee022bbbc550b25(tagName) {
    if ($17ce04f87c0238a0$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $17ce04f87c0238a0$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    var spawn = document.createElement('template');
    spawn.innerHTML = "<".concat(tagName, " />");
    return $17ce04f87c0238a0$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $17ce04f87c0238a0$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    var _tagName_split = (0, $f9AOD._)(tagName.split(':'), 2), prefix = _tagName_split[0], localName = _tagName_split[1];
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    var node = $17ce04f87c0238a0$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
var $17ce04f87c0238a0$export$8eece510bcb9c62c = function(Class) {
    return $17ce04f87c0238a0$export$170f4e08cad8229d(Class, HTMLElement);
};
var $17ce04f87c0238a0$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $17ce04f87c0238a0$export$b8a1af58c024fefd(Class) {
    var name = $17ce04f87c0238a0$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var _ref = new Class(), tagName = _ref.tagName;
    $17ce04f87c0238a0$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $17ce04f87c0238a0$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ var ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    var template = $17ce04f87c0238a0$export$2ee022bbbc550b25(tagName);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = ReadOnly_Properties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AOD._)(_step.value, 2), Class = _step_value[0], keys = _step_value[1];
            if (template instanceof Class && keys.includes(propertyName)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $17ce04f87c0238a0$export$d66b332881d9723f(HTML) {
    var spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return (0, $aUGqu._)(spawn.content.childNodes).map(function(node) {
        node.remove();
        return node;
    });
}
var $17ce04f87c0238a0$export$b0709844452f8b6b = function(node) {
    return new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
};
function $17ce04f87c0238a0$export$5118471ee5d5453b(root, type) {
    var children, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, node, err;
    return (0, $13u2V._)(this, function(_state) {
        switch(_state.label){
            case 0:
                children = (0, $aUGqu._)(root.childNodes);
                if (!($17ce04f87c0238a0$export$dd1bc94b04021eeb(type) || type === root.nodeType)) return [
                    3,
                    2
                ];
                return [
                    4,
                    root
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    8,
                    9,
                    10
                ]);
                _iterator = children[Symbol.iterator]();
                _state.label = 4;
            case 4:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    7
                ];
                node = _step.value;
                return [
                    5,
                    (0, $Csf8W.__values)($17ce04f87c0238a0$export$5118471ee5d5453b(node, type))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    4
                ];
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    10
                ];
            case 9:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function $17ce04f87c0238a0$export$6e196edbcc00e5bc(element) {
    var _element_getBoundingClientRect = element.getBoundingClientRect(), left = _element_getBoundingClientRect.left, top = _element_getBoundingClientRect.top;
    return document.elementFromPoint(left, top) === element;
}
function $17ce04f87c0238a0$export$be4650432daa84fd(root) {
    var text = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $17ce04f87c0238a0$export$5118471ee5d5453b(root)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, nodeType = _step_value.nodeType, parentElement = _step_value.parentElement, nodeValue = _step_value.nodeValue;
            if (nodeType === Node.TEXT_NODE && (parentElement === null || parentElement === void 0 ? void 0 : parentElement.getAttribute('aria-hidden')) !== 'true') {
                var _parentElement_getBoundingClientRect;
                var _ref = (_parentElement_getBoundingClientRect = parentElement === null || parentElement === void 0 ? void 0 : parentElement.getBoundingClientRect()) !== null && _parentElement_getBoundingClientRect !== void 0 ? _parentElement_getBoundingClientRect : {}, width = _ref.width, height = _ref.height;
                if (width && height) text += nodeValue === null || nodeValue === void 0 ? void 0 : nodeValue.trim().replace(/\s+/g, ' ');
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return text;
}
function $17ce04f87c0238a0$export$578e38b4a3e0b255(param) {
    var offsetWidth = param.offsetWidth, children = param.children, pageHeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 841.89, pageWidth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 595.28;
    var scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return (0, $aUGqu._)(children).reduce(function(pages, node) {
        var _pages, _bottomIndex;
        var top = node.offsetTop, height = node.offsetHeight;
        top += offset;
        var bottom = top + height;
        var bottomOffset = bottom / scrollHeight;
        var topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        ((_pages = pages)[_bottomIndex = bottomIndex] || (_pages[_bottomIndex] = [])).push(node);
        return pages;
    }, []);
}
function $17ce04f87c0238a0$export$7cd14c57bbb84350(URI) {
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var alternate = _param.alternate, options = (0, $6acIq._)(_param, [
        "alternate"
    ]);
    var style = (0, $aUGqu._)(document.styleSheets).find(function(param) {
        var href = param.href;
        return href === URI;
    });
    if (style) return Promise.resolve(style);
    var link = document.createElement('link');
    return new Promise(function(resolve, reject) {
        link.onload = function() {
            return resolve(link.sheet);
        };
        link.onerror = function(_1, _2, _3, _4, error) {
            return reject(error);
        };
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $17ce04f87c0238a0$export$5100419dfae0456d(data) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, indent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '    ';
    var padding = indent.repeat(depth);
    return Object.entries(data).map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
        return (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) !== 'object' ? "".concat(padding).concat($17ce04f87c0238a0$export$3f34ca2fef821bbd(key), ": ").concat(value, ";") : "".concat(padding).concat(key, " {\n").concat($17ce04f87c0238a0$export$5100419dfae0456d(value, depth + 1, indent), "\n").concat(padding, "}");
    }).join('\n');
}
function $17ce04f87c0238a0$export$28d9d24a8cd0ffc2() {
    for(var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++){
        nodes[_key] = arguments[_key];
    }
    var _fragment, _node;
    var fragment = document.createDocumentFragment();
    (_fragment = fragment).append.apply(_fragment, (0, $aUGqu._)(nodes));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $17ce04f87c0238a0$export$5118471ee5d5453b(fragment)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var node = _step.value;
            if (![
                1,
                3,
                11
            ].includes(node.nodeType) || [
                'meta',
                'title',
                'link',
                'script'
            ].includes(node.nodeName.toLowerCase())) (_node = node).replaceWith.apply(_node, (0, $aUGqu._)(node.childNodes));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var selection = globalThis.getSelection();
    if (!selection) return;
    var range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $17ce04f87c0238a0$export$3f99968195accfaf(selector, root, align, justify) {
    var _querySelector;
    var _ref = (0, $f9AOD._)(/^#(.+)/.exec(selector) || [], 2), _ = _ref[0], ID = _ref[1];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (_querySelector = (root || document).querySelector(ID ? '[id="'.concat(ID, '"]') : selector)) === null || _querySelector === void 0 ? void 0 : _querySelector.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
var $17ce04f87c0238a0$export$eafdbaa868ea9975 = function(box, handler) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 6;
    return Array.from(box.querySelectorAll(Array.from(new Array(depth), function(_, index) {
        return "h".concat(++index);
    }) + ''), function(header) {
        new IntersectionObserver(function(param) {
            var _param = (0, $f9AOD._)(param, 1), item = _param[0];
            if (!item.isIntersecting) return;
            var target = item.target;
            handler({
                target: target,
                links: (0, $aUGqu._)(target.ownerDocument.querySelectorAll('[href="#'.concat(target.id, '"]')))
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
};
function $17ce04f87c0238a0$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(function(param) {
        var _param = (0, $f9AOD._)(param, 1), _param_ = _param[0], isIntersecting = _param_.isIntersecting;
        return change(isIntersecting ? last | 2 : last & 1);
    }).observe(root);
    document.addEventListener('visibilitychange', function() {
        return change(document.visibilityState === 'visible' ? last | 1 : last & 2);
    });
}
function $17ce04f87c0238a0$export$86d7c59254d6a2c9(form) {
    var elements = form.elements, data = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var field = _step.value;
            var name = field.name, value = field.value, checked = field.checked, defaultValue = field.defaultValue, selectedOptions = field.selectedOptions, files = field.files;
            var type = field.type;
            if (!name || value === '') continue;
            var box = type !== 'fieldset' && field.closest('fieldset');
            if (box && box !== form) continue;
            var parsedValue = value;
            switch(type){
                case 'radio':
                case 'checkbox':
                    if (checked) parsedValue = !defaultValue || $17ce04f87c0238a0$export$7ea17d45ecdcf634(defaultValue);
                    else if ($17ce04f87c0238a0$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                    else parsedValue = false;
                    break;
                case 'select-multiple':
                    parsedValue = Array.from(selectedOptions, function(param) {
                        var value = param.value;
                        return $17ce04f87c0238a0$export$7ea17d45ecdcf634(value);
                    });
                    break;
                case 'fieldset':
                    parsedValue = $17ce04f87c0238a0$export$86d7c59254d6a2c9(field);
                    break;
                case 'file':
                    parsedValue = files && Array.from(files);
                    break;
                case 'date':
                case 'datetime-local':
                case 'month':
                case 'hidden':
                case 'number':
                case 'range':
                case 'select-one':
                    parsedValue = $17ce04f87c0238a0$export$7ea17d45ecdcf634(value);
            }
            var record = data;
            if (name in data) record[name] = [].concat(record[name], parsedValue);
            else record[name] = !(parsedValue instanceof Array) || !$17ce04f87c0238a0$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return data;
}
var $17ce04f87c0238a0$var$$bb23e0c794fefbef$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $17ce04f87c0238a0$export$e772c8ff12451969;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $17ce04f87c0238a0$export$57207d71b8c929c8;
});
function $17ce04f87c0238a0$export$e772c8ff12451969() {
    var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return new Promise(function(resolve) {
        return setTimeout(resolve, seconds * 1000);
    });
}
function $17ce04f87c0238a0$export$57207d71b8c929c8(executor) {
    var seconds = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var stop = false;
    (function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var result;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!stop) return [
                            3,
                            4
                        ];
                        result = executor();
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            $17ce04f87c0238a0$export$e772c8ff12451969(seconds)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            0
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    })();
    return function() {
        return stop = true;
    };
}
var $17ce04f87c0238a0$var$$19ed8aeb7905a045$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $17ce04f87c0238a0$export$10b1921597150314;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $17ce04f87c0238a0$export$3e2b244719956741;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $17ce04f87c0238a0$export$1d1d2ed6b55cf67f;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $17ce04f87c0238a0$export$2155c0b5a4b77fb8;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $17ce04f87c0238a0$export$9d97473344489dfc;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $17ce04f87c0238a0$export$d635d04af3887bbe;
});
function $17ce04f87c0238a0$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
var $17ce04f87c0238a0$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise(function(resolve) {
    var _document;
    function done() {
        var _document;
        (_document = document) === null || _document === void 0 ? void 0 : _document.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        var _document;
        ((_document = document) === null || _document === void 0 ? void 0 : _document.readyState) === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $17ce04f87c0238a0$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise(function(resolve, reject) {
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $17ce04f87c0238a0$export$2155c0b5a4b77fb8(handlers) {
    function server(_param) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _param_data, type, id, source, origin, data, _handlers_type, result;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _param_data = _param.data, type = _param_data.type, id = _param_data.id, source = _param.source, origin = _param.origin, data = (0, $6acIq._)(_param.data, [
                            "type",
                            "id"
                        ]);
                        result = (_handlers_type = handlers[type]) === null || _handlers_type === void 0 ? void 0 : _handlers_type.call(handlers, data);
                        if (!(result instanceof Promise)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            result
                        ];
                    case 1:
                        result = _state.sent();
                        _state.label = 2;
                    case 2:
                        // @ts-ignore
                        source.postMessage((0, $6fpqi._)((0, $1XAnY._)({}, result), {
                            id: id
                        }), origin);
                        return [
                            2
                        ];
                }
            });
        })();
    }
    globalThis.addEventListener('message', server);
    return function() {
        return globalThis.removeEventListener('message', server);
    };
}
function $17ce04f87c0238a0$export$9d97473344489dfc(target) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '*';
    return function(type, data) {
        return new Promise(function(resolve) {
            var UID = $17ce04f87c0238a0$export$89912e019eef22aa();
            function handler(_param) {
                var _param_data = _param.data, id = _param_data.id, _$data = (0, $6acIq._)(_param.data, [
                    "id"
                ]);
                if (id !== UID) return;
                resolve(_$data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage((0, $1XAnY._)({
                id: UID,
                type: type
            }, data), origin);
        });
    };
}
function $17ce04f87c0238a0$export$d635d04af3887bbe(registration) {
    return new Promise(function(resolve) {
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = function() {
            var _registration_installing;
            return (_registration_installing = registration.installing) === null || _registration_installing === void 0 ? void 0 : _registration_installing.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
        };
    });
}
var $17ce04f87c0238a0$var$$7a08303ce13c49c5$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $17ce04f87c0238a0$export$1b88f6b6d432a52a;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $17ce04f87c0238a0$export$b70f6380221b1350;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $17ce04f87c0238a0$export$75d6cbe4503e149;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $17ce04f87c0238a0$export$b2618d51188815c2;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $17ce04f87c0238a0$export$490814474ddbb428;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $17ce04f87c0238a0$export$3ea201dffb50dfef;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $17ce04f87c0238a0$export$d1012c7198c6b460;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $17ce04f87c0238a0$export$a35a418b7b17958e;
});
var $17ce04f87c0238a0$export$1b88f6b6d432a52a = /*#__PURE__*/ function() {
    "use strict";
    function $7a08303ce13c49c5$export$1b88f6b6d432a52a(from, to) {
        (0, $173N4._)(this, $7a08303ce13c49c5$export$1b88f6b6d432a52a);
        this.from = from;
        this.to = to;
    }
    (0, $cFHGC._)($7a08303ce13c49c5$export$1b88f6b6d432a52a, [
        {
            key: "length",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                var _from_z;
                return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - ((_from_z = from.z) !== null && _from_z !== void 0 ? _from_z : 0), 2) : 0));
            }
        },
        {
            key: "direction",
            get: function get() {
                var _this = this, from = _this.from, to = _this.to;
                var _to_z, _from_z;
                var XD = to.x - from.x, YD = to.y - from.y, ZD = ((_to_z = to.z) !== null && _to_z !== void 0 ? _to_z : 0) - ((_from_z = from.z) !== null && _from_z !== void 0 ? _from_z : 0);
                var XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
                switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
                    case XL:
                        return XD > 0 ? 'right' : 'left';
                    case YL:
                        return YD > 0 ? 'forward' : 'backward';
                    case ZL:
                        return ZD > 0 ? 'up' : 'down';
                }
            }
        }
    ]);
    return $7a08303ce13c49c5$export$1b88f6b6d432a52a;
}();
function $17ce04f87c0238a0$export$b70f6380221b1350(from, to) {
    var threshold = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : parseInt(getComputedStyle(document.body).fontSize) * 6;
    var _getSelection;
    var vector = new $17ce04f87c0238a0$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !((_getSelection = getSelection()) === null || _getSelection === void 0 ? void 0 : _getSelection.toString().trim())) return vector;
}
function $17ce04f87c0238a0$export$75d6cbe4503e149(type, element) {
    var _getComputedStyle = getComputedStyle(element), transitionDuration = _getComputedStyle.transitionDuration, animationDuration = _getComputedStyle.animationDuration;
    var duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $17ce04f87c0238a0$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $17ce04f87c0238a0$export$1d1d2ed6b55cf67f(type, element).catch(function(event) {
            return Promise.resolve(event);
        }),
        new Promise(function(resolve) {
            return setTimeout(resolve, $17ce04f87c0238a0$export$75d6cbe4503e149(type, element));
        })
    ]);
}
function $17ce04f87c0238a0$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    var end = $17ce04f87c0238a0$export$b2618d51188815c2(type, element);
    return new Promise(function(resolve) {
        return requestAnimationFrame(function() {
            element.classList.add(className);
            end.then(resolve);
        });
    });
}
function $17ce04f87c0238a0$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var end;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    end = $17ce04f87c0238a0$export$b2618d51188815c2(type, element);
                    element.classList.remove(className);
                    return [
                        4,
                        end
                    ];
                case 1:
                    _state.sent();
                    if (remove) element.remove();
                    else element.style.display = 'none';
                    return [
                        2
                    ];
            }
        });
    })();
}
function $17ce04f87c0238a0$export$490814474ddbb428(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'block';
    return $17ce04f87c0238a0$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $17ce04f87c0238a0$export$3ea201dffb50dfef(element, className) {
    var display = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'block';
    return $17ce04f87c0238a0$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $17ce04f87c0238a0$export$d1012c7198c6b460(element, className, remove) {
    return $17ce04f87c0238a0$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $17ce04f87c0238a0$export$a35a418b7b17958e(element, className, remove) {
    return $17ce04f87c0238a0$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $17ce04f87c0238a0$var$$69bd9f0117925302$exports = {};
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$69bd9f0117925302$exports, "describe", function() {
    return $17ce04f87c0238a0$export$cd5450f3a47e3789;
});
$17ce04f87c0238a0$var$$parcel$export($17ce04f87c0238a0$var$$69bd9f0117925302$exports, "it", function() {
    return $17ce04f87c0238a0$export$3486a10f30cf1ee4;
});
function $17ce04f87c0238a0$export$cd5450f3a47e3789(title, cases) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    console.log(title);
                    console.time(title);
                    return [
                        4,
                        cases()
                    ];
                case 1:
                    _state.sent();
                    console.timeEnd(title);
                    return [
                        2
                    ];
            }
        });
    })();
}
function $17ce04f87c0238a0$export$3486a10f30cf1ee4(title, userCase) {
    var secondsOut = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var expect, timeOut;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    title = '    ' + title;
                    console.time(title);
                    expect = function(status) {
                        var assert = typeof status === 'function' ? status : undefined;
                        var _assert;
                        status = (_assert = assert === null || assert === void 0 ? void 0 : assert()) !== null && _assert !== void 0 ? _assert : status;
                        if (!status) throw new Error("Assertion failed: ".concat(title, "\n\n").concat(assert || ''));
                    };
                    timeOut = function() {
                        return $17ce04f87c0238a0$export$e772c8ff12451969(secondsOut).then(function() {
                            return Promise.reject(new RangeError('Timed out'));
                        });
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        3,
                        4
                    ]);
                    return [
                        4,
                        Promise.race([
                            userCase(expect),
                            timeOut()
                        ])
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    console.timeEnd(title);
                    return [
                        7
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}

});
parcelRegister("jAEAr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e430dccebb6451d6$export$71511d61b312f219; });

var $4z2hM = parcelRequire("4z2hM");
function $e430dccebb6451d6$export$71511d61b312f219(inner) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: new (0, $4z2hM._)(value, /* kind: delegate */ 1)
        };
    }
    iter[typeof Symbol !== "undefined" && Symbol.iterator || "@@iterator"] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("return", value);
    };
    return iter;
}

});
parcelRegister("4z2hM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $352c343ccd91c3ff$export$71511d61b312f219; });
function $352c343ccd91c3ff$export$71511d61b312f219(value, /** 0: await 1: delegate */ kind) {
    this.v = value;
    this.k = kind;
}

});


parcelRegister("dafVd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99588f40b3d122b6$export$71511d61b312f219; });
function $99588f40b3d122b6$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $99588f40b3d122b6$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $99588f40b3d122b6$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $99588f40b3d122b6$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $99588f40b3d122b6$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $99588f40b3d122b6$var$AsyncFromSyncIterator(s);
}

});

parcelRegister("3gP77", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $261a83dce9699282$export$71511d61b312f219; });
function $261a83dce9699282$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $261a83dce9699282$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $261a83dce9699282$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $261a83dce9699282$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("dm3mz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9b8ff03e39f7914e$export$71511d61b312f219; });

var $4z2hM = parcelRequire("4z2hM");
function $9b8ff03e39f7914e$export$71511d61b312f219(value) {
    return new (0, $4z2hM._)(value, /* kind: await */ 0);
}

});

parcelRegister("7qXGD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5699429d06f3bb79$export$71511d61b312f219; });

var $kg0zo = parcelRequire("kg0zo");

var $euUQR = parcelRequire("euUQR");

var $fdc2U = parcelRequire("fdc2U");
function $5699429d06f3bb79$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $kg0zo._)(derived);
    return (0, $fdc2U._)(_this, (0, $euUQR._)() ? Reflect.construct(derived, args || [], (0, $kg0zo._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("kg0zo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ebf5be710afaab4a$export$71511d61b312f219; });
function $ebf5be710afaab4a$export$71511d61b312f219(o) {
    $ebf5be710afaab4a$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ebf5be710afaab4a$export$71511d61b312f219(o);
}

});

parcelRegister("euUQR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a8dff79067a3c1ae$export$71511d61b312f219; });
function $a8dff79067a3c1ae$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($a8dff79067a3c1ae$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("fdc2U", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b13169fb786eb9c8$export$71511d61b312f219; });

var $gXzGB = parcelRequire("gXzGB");

var $7E0eS = parcelRequire("7E0eS");
function $b13169fb786eb9c8$export$71511d61b312f219(self, call) {
    if (call && ((0, $7E0eS._)(call) === "object" || typeof call === "function")) return call;
    return (0, $gXzGB._)(self);
}

});
parcelRegister("gXzGB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c58dd68f03809c9f$export$71511d61b312f219; });
function $c58dd68f03809c9f$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("7E0eS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $590c744aa6eb78fe$export$71511d61b312f219; });
function $590c744aa6eb78fe$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("173N4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0cf96292990469e4$export$71511d61b312f219; });
function $0cf96292990469e4$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cFHGC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $939b339a0d69884d$export$71511d61b312f219; });
function $939b339a0d69884d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $939b339a0d69884d$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $939b339a0d69884d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $939b339a0d69884d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("dWsrg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a266c07c539ac56a$export$71511d61b312f219; });

var $7BbpS = parcelRequire("7BbpS");
function $a266c07c539ac56a$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $a266c07c539ac56a$export$71511d61b312f219 = Reflect.get;
    else $a266c07c539ac56a$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $7BbpS._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $a266c07c539ac56a$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("7BbpS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5884d826e884657a$export$71511d61b312f219; });

var $kg0zo = parcelRequire("kg0zo");
function $5884d826e884657a$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $kg0zo._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("hdIku", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c896097e7c10d773$export$71511d61b312f219; });

var $fyVjP = parcelRequire("fyVjP");
function $c896097e7c10d773$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $fyVjP._)(subClass, superClass);
}

});
parcelRegister("fyVjP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b5467e4dcf9df57b$export$71511d61b312f219; });
function $b5467e4dcf9df57b$export$71511d61b312f219(o, p) {
    $b5467e4dcf9df57b$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b5467e4dcf9df57b$export$71511d61b312f219(o, p);
}

});


parcelRegister("1XAnY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $16d7868dc491f7c4$export$71511d61b312f219; });

var $7Pjls = parcelRequire("7Pjls");
function $16d7868dc491f7c4$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $7Pjls._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("7Pjls", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5b2c4d59510e4c85$export$71511d61b312f219; });
function $5b2c4d59510e4c85$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("6fpqi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $48c7dd510ebacb86$export$71511d61b312f219; });
function $48c7dd510ebacb86$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $48c7dd510ebacb86$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $48c7dd510ebacb86$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("6acIq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $47cd8a44b5fc4469$export$71511d61b312f219; });

var $5sh6U = parcelRequire("5sh6U");
function $47cd8a44b5fc4469$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $5sh6U._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("5sh6U", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3f8cd710f9652db5$export$71511d61b312f219; });
function $3f8cd710f9652db5$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("f9AOD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b08441208992b1a4$export$71511d61b312f219; });

var $9366V = parcelRequire("9366V");

var $faN4O = parcelRequire("faN4O");

var $2aJ1i = parcelRequire("2aJ1i");

var $dyckk = parcelRequire("dyckk");
function $b08441208992b1a4$export$71511d61b312f219(arr, i) {
    return (0, $9366V._)(arr) || (0, $faN4O._)(arr, i) || (0, $dyckk._)(arr, i) || (0, $2aJ1i._)();
}

});
parcelRegister("9366V", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6969224e78caffb5$export$71511d61b312f219; });
function $6969224e78caffb5$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("faN4O", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0bddbcdf915a311$export$71511d61b312f219; });
function $b0bddbcdf915a311$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("2aJ1i", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $194f6ff112bed8c6$export$71511d61b312f219; });
function $194f6ff112bed8c6$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("dyckk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dd80339453197e0$export$71511d61b312f219; });

var $mEET1 = parcelRequire("mEET1");
function $9dd80339453197e0$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $mEET1._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $mEET1._)(o, minLen);
}

});
parcelRegister("mEET1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0441981c80ae0b4b$export$71511d61b312f219; });
function $0441981c80ae0b4b$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("aUGqu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7f200b52cf078100$export$71511d61b312f219; });

var $dbiLi = parcelRequire("dbiLi");

var $fSnLV = parcelRequire("fSnLV");

var $1ZfL4 = parcelRequire("1ZfL4");

var $dyckk = parcelRequire("dyckk");
function $7f200b52cf078100$export$71511d61b312f219(arr) {
    return (0, $dbiLi._)(arr) || (0, $fSnLV._)(arr) || (0, $dyckk._)(arr) || (0, $1ZfL4._)();
}

});
parcelRegister("dbiLi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $998adb2694c8379f$export$71511d61b312f219; });

var $mEET1 = parcelRequire("mEET1");
function $998adb2694c8379f$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $mEET1._)(arr);
}

});

parcelRegister("fSnLV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b8ee56c891a3392b$export$71511d61b312f219; });
function $b8ee56c891a3392b$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("1ZfL4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1727b62e6036c392$export$71511d61b312f219; });
function $1727b62e6036c392$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("7t5yo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $56ff8cb30caacb19$export$71511d61b312f219; });

var $jKMwY = parcelRequire("jKMwY");
function $56ff8cb30caacb19$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $jKMwY._)(fn.apply(this, arguments));
    };
}

});
parcelRegister("jKMwY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e617f567554d6241$export$71511d61b312f219; });

var $4z2hM = parcelRequire("4z2hM");
function $e617f567554d6241$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var overloaded = value instanceof (0, $4z2hM._);
            Promise.resolve(overloaded ? value.v : value).then(function(arg) {
                if (overloaded) {
                    var nextKey = key === "return" ? "return" : "next";
                    if (!value.k || arg.done) return resume(nextKey, arg);
                    else arg = gen[nextKey](arg).value;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
$e617f567554d6241$export$71511d61b312f219.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
};
$e617f567554d6241$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$e617f567554d6241$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$e617f567554d6241$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};

});


parcelRegister("13u2V", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0c4d60c8eb03fee1$export$71511d61b312f219; });
function $0c4d60c8eb03fee1$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("Csf8W", function(module, exports) {

$parcel$export(module.exports, "__values", function () { return $6fc8008516332bcb$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $7E0eS = parcelRequire("7E0eS");
var $6fc8008516332bcb$var$extendStatics = function extendStatics1(d, b) {
    $6fc8008516332bcb$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $6fc8008516332bcb$var$extendStatics(d, b);
};
function $6fc8008516332bcb$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $6fc8008516332bcb$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $6fc8008516332bcb$export$18ce0697a983be9b = function __assign1() {
    $6fc8008516332bcb$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6fc8008516332bcb$export$18ce0697a983be9b.apply(this, arguments);
};
function $6fc8008516332bcb$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $6fc8008516332bcb$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7E0eS._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $6fc8008516332bcb$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $6fc8008516332bcb$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $7E0eS._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $6fc8008516332bcb$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $6fc8008516332bcb$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $7E0eS._)(x)) === "symbol" ? x : "".concat(x);
}
function $6fc8008516332bcb$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $7E0eS._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $6fc8008516332bcb$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $7E0eS._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $6fc8008516332bcb$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $6fc8008516332bcb$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $6fc8008516332bcb$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $6fc8008516332bcb$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $6fc8008516332bcb$export$45d3717a4c69092e(o, m, p);
}
function $6fc8008516332bcb$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $6fc8008516332bcb$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $6fc8008516332bcb$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($6fc8008516332bcb$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $6fc8008516332bcb$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $6fc8008516332bcb$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $6fc8008516332bcb$export$10c90e4f7922046c(v) {
    return this instanceof $6fc8008516332bcb$export$10c90e4f7922046c ? (this.v = v, this) : new $6fc8008516332bcb$export$10c90e4f7922046c(v);
}
function $6fc8008516332bcb$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $6fc8008516332bcb$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $6fc8008516332bcb$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $6fc8008516332bcb$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $6fc8008516332bcb$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $6fc8008516332bcb$export$19a8beecd37a4c45 === "function" ? $6fc8008516332bcb$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $6fc8008516332bcb$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $6fc8008516332bcb$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $6fc8008516332bcb$var$ownKeys = function ownKeys1(o) {
    $6fc8008516332bcb$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $6fc8008516332bcb$var$ownKeys(o);
};
function $6fc8008516332bcb$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $6fc8008516332bcb$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $6fc8008516332bcb$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $6fc8008516332bcb$var$__setModuleDefault(result, mod);
    return result;
}
function $6fc8008516332bcb$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $6fc8008516332bcb$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $6fc8008516332bcb$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $6fc8008516332bcb$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $7E0eS._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $6fc8008516332bcb$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $6fc8008516332bcb$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $6fc8008516332bcb$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $6fc8008516332bcb$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $6fc8008516332bcb$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $6fc8008516332bcb$export$2e2bcd8739ae039 = {
    __extends: $6fc8008516332bcb$export$a8ba968b8961cb8a,
    __assign: $6fc8008516332bcb$export$18ce0697a983be9b,
    __rest: $6fc8008516332bcb$export$3c9a16f847548506,
    __decorate: $6fc8008516332bcb$export$29e00dfd3077644b,
    __param: $6fc8008516332bcb$export$d5ad3fd78186038f,
    __esDecorate: $6fc8008516332bcb$export$3a84e1ae4e97e9b0,
    __runInitializers: $6fc8008516332bcb$export$d831c04e792af3d,
    __propKey: $6fc8008516332bcb$export$6a2a36740a146cb8,
    __setFunctionName: $6fc8008516332bcb$export$d1a06452d3489bc7,
    __metadata: $6fc8008516332bcb$export$f1db080c865becb9,
    __awaiter: $6fc8008516332bcb$export$1050f835b63b671e,
    __generator: $6fc8008516332bcb$export$67ebef60e6f28a6,
    __createBinding: $6fc8008516332bcb$export$45d3717a4c69092e,
    __exportStar: $6fc8008516332bcb$export$f33643c0debef087,
    __values: $6fc8008516332bcb$export$19a8beecd37a4c45,
    __read: $6fc8008516332bcb$export$8d051b38c9118094,
    __spread: $6fc8008516332bcb$export$afc72e2116322959,
    __spreadArrays: $6fc8008516332bcb$export$6388937ca91ccae8,
    __spreadArray: $6fc8008516332bcb$export$1216008129fb82ed,
    __await: $6fc8008516332bcb$export$10c90e4f7922046c,
    __asyncGenerator: $6fc8008516332bcb$export$e427f37a30a4de9b,
    __asyncDelegator: $6fc8008516332bcb$export$bbd80228419bb833,
    __asyncValues: $6fc8008516332bcb$export$e3b29a3d6162315f,
    __makeTemplateObject: $6fc8008516332bcb$export$4fb47efe1390b86f,
    __importStar: $6fc8008516332bcb$export$c21735bcef00d192,
    __importDefault: $6fc8008516332bcb$export$da59b14a69baef04,
    __classPrivateFieldGet: $6fc8008516332bcb$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $6fc8008516332bcb$export$d40a35129aaff81f,
    __classPrivateFieldIn: $6fc8008516332bcb$export$81fdc39f203e4e04,
    __addDisposableResource: $6fc8008516332bcb$export$88ac25d8e944e405,
    __disposeResources: $6fc8008516332bcb$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $6fc8008516332bcb$export$889dfb5d17574b0b
};

});


parcelRegister("63vlS", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $468b57b05ee90c82$export$ef7acd7185315e22; });
$parcel$export(module.exports, "defineVaporAsyncComponent", function () { return (parcelRequire("51zaq")).defineVaporAsyncComponent; });
/**
  * vue v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $6zvdv = parcelRequire("6zvdv");
parcelRequire("3ewO8");
var $fKAHx = parcelRequire("fKAHx");
var $3ewO8 = parcelRequire("3ewO8");

var $51zaq = parcelRequire("51zaq");
//#region packages/vue/src/dev.ts
function $468b57b05ee90c82$var$initDev() {
    (0, $fKAHx.initCustomFormatter)();
}
var $468b57b05ee90c82$export$ef7acd7185315e22 = function(_template) {
    return 0, $6zvdv.NOOP;
};
$parcel$exportWildcard(module.exports, $3ewO8);
$parcel$exportWildcard(module.exports, $51zaq);

});
parcelRegister("6zvdv", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $4c8e39f3b6f078f4$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $4c8e39f3b6f078f4$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $4c8e39f3b6f078f4$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $4c8e39f3b6f078f4$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $4c8e39f3b6f078f4$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $4c8e39f3b6f078f4$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isNativeOn", function () { return $4c8e39f3b6f078f4$export$2774642b69d5bf8f; });
$parcel$export(module.exports, "isModelListener", function () { return $4c8e39f3b6f078f4$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $4c8e39f3b6f078f4$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $4c8e39f3b6f078f4$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $4c8e39f3b6f078f4$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $4c8e39f3b6f078f4$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $4c8e39f3b6f078f4$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $4c8e39f3b6f078f4$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $4c8e39f3b6f078f4$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $4c8e39f3b6f078f4$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $4c8e39f3b6f078f4$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $4c8e39f3b6f078f4$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $4c8e39f3b6f078f4$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $4c8e39f3b6f078f4$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $4c8e39f3b6f078f4$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $4c8e39f3b6f078f4$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $4c8e39f3b6f078f4$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $4c8e39f3b6f078f4$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInTag", function () { return $4c8e39f3b6f078f4$export$185918b776d5e857; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $4c8e39f3b6f078f4$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $4c8e39f3b6f078f4$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $4c8e39f3b6f078f4$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $4c8e39f3b6f078f4$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $4c8e39f3b6f078f4$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "getModifierPropName", function () { return $4c8e39f3b6f078f4$export$9d73740db27a710b; });
$parcel$export(module.exports, "hasChanged", function () { return $4c8e39f3b6f078f4$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $4c8e39f3b6f078f4$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $4c8e39f3b6f078f4$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $4c8e39f3b6f078f4$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $4c8e39f3b6f078f4$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $4c8e39f3b6f078f4$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "canSetValueDirectly", function () { return $4c8e39f3b6f078f4$export$65fab167189e647e; });
$parcel$export(module.exports, "isGloballyAllowed", function () { return $4c8e39f3b6f078f4$export$f73b8c13b7f97ebf; });
$parcel$export(module.exports, "normalizeStyle", function () { return $4c8e39f3b6f078f4$export$8756898546458274; });
$parcel$export(module.exports, "parseStringStyle", function () { return $4c8e39f3b6f078f4$export$76a205ce979d066a; });
$parcel$export(module.exports, "stringifyStyle", function () { return $4c8e39f3b6f078f4$export$9466a5a0ee6f1479; });
$parcel$export(module.exports, "normalizeClass", function () { return $4c8e39f3b6f078f4$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "normalizeProps", function () { return $4c8e39f3b6f078f4$export$601abcd8103db5e4; });
$parcel$export(module.exports, "isHTMLTag", function () { return $4c8e39f3b6f078f4$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $4c8e39f3b6f078f4$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isMathMLTag", function () { return $4c8e39f3b6f078f4$export$4a46ca4c5be17b20; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $4c8e39f3b6f078f4$export$d186f5eb2e810715; });
$parcel$export(module.exports, "isBooleanAttr", function () { return $4c8e39f3b6f078f4$export$f763ba3b84e9cd8c; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $4c8e39f3b6f078f4$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "isKnownHtmlAttr", function () { return $4c8e39f3b6f078f4$export$f7e7a1cc7da8d5e9; });
$parcel$export(module.exports, "isKnownSvgAttr", function () { return $4c8e39f3b6f078f4$export$80da416f43933831; });
$parcel$export(module.exports, "isRenderableAttrValue", function () { return $4c8e39f3b6f078f4$export$921dd2acf0d386a3; });
$parcel$export(module.exports, "shouldSetAsAttr", function () { return $4c8e39f3b6f078f4$export$49386760b68c7202; });
$parcel$export(module.exports, "getEscapedCssVarName", function () { return $4c8e39f3b6f078f4$export$ad9a320bfb7ba440; });
$parcel$export(module.exports, "looseEqual", function () { return $4c8e39f3b6f078f4$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $4c8e39f3b6f078f4$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $4c8e39f3b6f078f4$export$b5b1545233b45293; });
$parcel$export(module.exports, "getSequence", function () { return $4c8e39f3b6f078f4$export$5c1e203ca018159a; });
$parcel$export(module.exports, "normalizeCssVarValue", function () { return $4c8e39f3b6f078f4$export$97fe3d6453ee2f5e; });
$parcel$export(module.exports, "isForwardedSlot", function () { return $4c8e39f3b6f078f4$export$e021dc44d742adfc; });
$parcel$export(module.exports, "slotInheritsFallback", function () { return $4c8e39f3b6f078f4$export$d569989f3511ae; });
$parcel$export(module.exports, "slotNotifiesBoundary", function () { return $4c8e39f3b6f078f4$export$7cfa9a922d15a615; });
/**
  * @vue/shared v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ //#region packages/shared/src/makeMap.ts
/**
* Make a map and return a function for checking if a key
* is in that map.
* IMPORTANT: all calls of this function must be prefixed with
* \/\*#\_\_PURE\_\_\*\/
* So that they can be tree-shaken if necessary.
*/ /*@__NO_SIDE_EFFECTS__*/ 
var $7Pjls = parcelRequire("7Pjls");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");
function $4c8e39f3b6f078f4$export$b41394a5437791c8(str) {
    var map = Object.create(null);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str.split(",")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            map[key] = 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function(val) {
        return val in map;
    };
}
//#endregion
//#region packages/shared/src/general.ts
var $4c8e39f3b6f078f4$export$cf583d23ab39677c = {};
var $4c8e39f3b6f078f4$export$6bd8558f433f1cc1 = [];
var $4c8e39f3b6f078f4$export$5702a91a6f42969f = function() {};
/**
* Always return true.
*/ var $4c8e39f3b6f078f4$export$a9bd5345eb50aac4 = function() {
    return true;
};
/**
* Always return false.
*/ var $4c8e39f3b6f078f4$export$c01351c0af048e39 = function() {
    return false;
};
var $4c8e39f3b6f078f4$export$1a2d97de39ecbb75 = function(key) {
    return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
};
var $4c8e39f3b6f078f4$export$2774642b69d5bf8f = function(key) {
    return key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
};
var $4c8e39f3b6f078f4$export$793aa5469768d691 = function(key) {
    return key.startsWith("onUpdate:");
};
var $4c8e39f3b6f078f4$export$8b58be045bf06082 = Object.assign;
var $4c8e39f3b6f078f4$export$cd7f480d6b8286c3 = function(arr, el) {
    var i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
var $4c8e39f3b6f078f4$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $4c8e39f3b6f078f4$export$b5a638e9b3fff9f3 = function(val, key) {
    return $4c8e39f3b6f078f4$var$hasOwnProperty.call(val, key);
};
var $4c8e39f3b6f078f4$export$43bee75e5e14138e = Array.isArray;
var $4c8e39f3b6f078f4$export$5c90113a285f2241 = function(val) {
    return $4c8e39f3b6f078f4$export$1dccc787cc36538b(val) === "[object Map]";
};
var $4c8e39f3b6f078f4$export$6750766a7c7ec627 = function(val) {
    return $4c8e39f3b6f078f4$export$1dccc787cc36538b(val) === "[object Set]";
};
var $4c8e39f3b6f078f4$export$871608497c498473 = function(val) {
    return $4c8e39f3b6f078f4$export$1dccc787cc36538b(val) === "[object Date]";
};
var $4c8e39f3b6f078f4$export$49841c62b9eff15 = function(val) {
    return $4c8e39f3b6f078f4$export$1dccc787cc36538b(val) === "[object RegExp]";
};
var $4c8e39f3b6f078f4$export$f6e2535fb5126e54 = function(val) {
    return typeof val === "function";
};
var $4c8e39f3b6f078f4$export$844ec244b1367d54 = function(val) {
    return typeof val === "string";
};
var $4c8e39f3b6f078f4$export$a244864fd9645c7f = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $7E0eS._)(val)) === "symbol";
};
var $4c8e39f3b6f078f4$export$a6cdc56e425d0d0a = function(val) {
    return val !== null && (typeof val === "undefined" ? "undefined" : (0, $7E0eS._)(val)) === "object";
};
var $4c8e39f3b6f078f4$export$4369c812aac99591 = function(val) {
    return ($4c8e39f3b6f078f4$export$a6cdc56e425d0d0a(val) || $4c8e39f3b6f078f4$export$f6e2535fb5126e54(val)) && $4c8e39f3b6f078f4$export$f6e2535fb5126e54(val.then) && $4c8e39f3b6f078f4$export$f6e2535fb5126e54(val.catch);
};
var $4c8e39f3b6f078f4$export$830c053460e5ddf6 = Object.prototype.toString;
var $4c8e39f3b6f078f4$export$1dccc787cc36538b = function(value) {
    return $4c8e39f3b6f078f4$export$830c053460e5ddf6.call(value);
};
var $4c8e39f3b6f078f4$export$5ad0a3c360b8fbb5 = function(value) {
    return $4c8e39f3b6f078f4$export$1dccc787cc36538b(value).slice(8, -1);
};
var $4c8e39f3b6f078f4$export$53b83ca8eaab0383 = function(val) {
    return $4c8e39f3b6f078f4$export$1dccc787cc36538b(val) === "[object Object]";
};
var $4c8e39f3b6f078f4$export$e2a2b93446ec9fe = function(key) {
    return $4c8e39f3b6f078f4$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $4c8e39f3b6f078f4$export$bf7d3c0236f0aa85 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8(",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
var $4c8e39f3b6f078f4$export$185918b776d5e857 = /*#__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8("slot,component");
var $4c8e39f3b6f078f4$export$a9c1fdb3030c2a6b = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
var $4c8e39f3b6f078f4$var$cacheStringFunction = function(fn) {
    var cache = Object.create(null);
    return function(str) {
        return cache[str] || (cache[str] = fn(str));
    };
};
var $4c8e39f3b6f078f4$var$camelizeRE = /-(\w)/g;
var $4c8e39f3b6f078f4$var$camelizeReplacer = function(_, c) {
    return c ? c.toUpperCase() : "";
};
/**
* @private
*/ var $4c8e39f3b6f078f4$export$161d051f5dd25de7 = $4c8e39f3b6f078f4$var$cacheStringFunction(function(str) {
    return str.replace($4c8e39f3b6f078f4$var$camelizeRE, $4c8e39f3b6f078f4$var$camelizeReplacer);
});
var $4c8e39f3b6f078f4$var$hyphenateRE = /\B([A-Z])/g;
/**
* @private
*/ var $4c8e39f3b6f078f4$export$6e6a0a3676c4b8bb = $4c8e39f3b6f078f4$var$cacheStringFunction(function(str) {
    return str.replace($4c8e39f3b6f078f4$var$hyphenateRE, "-$1").toLowerCase();
});
/**
* @private
*/ var $4c8e39f3b6f078f4$export$9a00dee1beb8f576 = $4c8e39f3b6f078f4$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
* @private
*/ var $4c8e39f3b6f078f4$export$8c022799eeaaefcd = $4c8e39f3b6f078f4$var$cacheStringFunction(function(str) {
    return str ? "on".concat($4c8e39f3b6f078f4$export$9a00dee1beb8f576(str)) : "";
});
/**
* #13070 When v-model and v-model:model directives are used together,
* they will generate the same modelModifiers prop,
* so a `$` suffix is added to avoid conflicts.
* @private
*/ var $4c8e39f3b6f078f4$export$9d73740db27a710b = function(name) {
    return "".concat(name === "modelValue" || name === "model-value" ? "model" : name, "Modifiers").concat(name === "model" ? "$" : "");
};
var $4c8e39f3b6f078f4$export$f619eb8b89076d23 = function(value, oldValue) {
    return !Object.is(value, oldValue);
};
var $4c8e39f3b6f078f4$export$39951422d618a9d3 = function(fns) {
    for(var _len = arguments.length, arg = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        arg[_key - 1] = arguments[_key];
    }
    var _fns;
    for(var i = 0; i < fns.length; i++)(_fns = fns)[i].apply(_fns, (0, $aUGqu._)(arg));
};
var $4c8e39f3b6f078f4$export$8afb76124cf08683 = function(obj, key, value) {
    var writable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
/**
* "123-foo" will be parsed to 123
* This is used for the .number modifier in v-model
*/ var $4c8e39f3b6f078f4$export$d3be7195bcc2f31b = function(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
};
/**
* Only concerns number-like strings
* "123-foo" will be returned as-is
*/ var $4c8e39f3b6f078f4$export$a0a81dc3380ce7d3 = function(val) {
    var n = $4c8e39f3b6f078f4$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
var $4c8e39f3b6f078f4$var$_globalThis;
var $4c8e39f3b6f078f4$export$ff5f2eeb11fc7e14 = function() {
    return $4c8e39f3b6f078f4$var$_globalThis || ($4c8e39f3b6f078f4$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
var $4c8e39f3b6f078f4$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $4c8e39f3b6f078f4$export$53d5e12f9a1d3cde(name) {
    return $4c8e39f3b6f078f4$var$identRE.test(name) ? "__props.".concat(name) : "__props[".concat(JSON.stringify(name), "]");
}
function $4c8e39f3b6f078f4$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, function(_, val) {
        return typeof val === "function" ? val.toString() : val;
    });
}
function $4c8e39f3b6f078f4$export$65fab167189e647e(tagName) {
    return tagName !== "PROGRESS" && !tagName.includes("-");
}
//#endregion
//#region packages/shared/src/patchFlags.ts
/**
* Patch flags are optimization hints generated by the compiler.
* when a block with dynamicChildren is encountered during diff, the algorithm
* enters "optimized mode". In this mode, we know that the vdom is produced by
* a render function generated by the compiler, so the algorithm only needs to
* handle updates explicitly marked by these patch flags.
*
* Patch flags can be combined using the | bitwise operator and can be checked
* using the & operator, e.g.
*
* ```js
* const flag = TEXT | CLASS
* if (flag & TEXT) { ... }
* ```
*
* Check the `patchElement` function in '../../runtime-core/src/renderer.ts' to see how the
* flags are handled during diff.
*/ var $4c8e39f3b6f078f4$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
var $4c8e39f3b6f078f4$var$_obj;
/**
* dev only flag -> name mapping
*/ var $4c8e39f3b6f078f4$export$def7dc2c2e95a08a = ($4c8e39f3b6f078f4$var$_obj = {}, (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 1, "TEXT"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 2, "CLASS"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 4, "STYLE"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 8, "PROPS"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 16, "FULL_PROPS"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 32, "NEED_HYDRATION"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 64, "STABLE_FRAGMENT"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 128, "KEYED_FRAGMENT"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 256, "UNKEYED_FRAGMENT"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 512, "NEED_PATCH"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 1024, "DYNAMIC_SLOTS"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, 2048, "DEV_ROOT_FRAGMENT"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, -1, "CACHED"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj, -2, "BAIL"), $4c8e39f3b6f078f4$var$_obj);
//#endregion
//#region packages/shared/src/shapeFlags.ts
var $4c8e39f3b6f078f4$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
//#endregion
//#region packages/shared/src/slotFlags.ts
var $4c8e39f3b6f078f4$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
var $4c8e39f3b6f078f4$var$_obj1;
/**
* Dev only
*/ var $4c8e39f3b6f078f4$export$624972196ed3745f = ($4c8e39f3b6f078f4$var$_obj1 = {}, (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj1, 1, "STABLE"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj1, 2, "DYNAMIC"), (0, $7Pjls._)($4c8e39f3b6f078f4$var$_obj1, 3, "FORWARDED"), $4c8e39f3b6f078f4$var$_obj1);
var $4c8e39f3b6f078f4$export$f73b8c13b7f97ebf = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8("Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol");
/** @deprecated use `isGloballyAllowed` instead */ var $4c8e39f3b6f078f4$export$d6571a1911e4f27e = $4c8e39f3b6f078f4$export$f73b8c13b7f97ebf;
//#endregion
//#region packages/shared/src/codeframe.ts
var $4c8e39f3b6f078f4$var$range = 2;
function $4c8e39f3b6f078f4$export$f9c0d8b6684a279b(source) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : source.length;
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    var lines = source.split(/(\r?\n)/);
    var newlineSequences = lines.filter(function(_, idx) {
        return idx % 2 === 1;
    });
    lines = lines.filter(function(_, idx) {
        return idx % 2 === 0;
    });
    var count = 0;
    var res = [];
    for(var i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(var j = i - $4c8e39f3b6f078f4$var$range; j <= i + $4c8e39f3b6f078f4$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                var line = j + 1;
                res.push("".concat(line).concat(" ".repeat(Math.max(3 - String(line).length, 0)), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                var newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    var pad = start - (count - (lineLength + newLineSeqLength));
                    var length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        var length1 = Math.max(Math.min(end - count, lineLength), 1);
                        res.push("   |  " + "^".repeat(length1));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
//#endregion
//#region packages/shared/src/normalizeProp.ts
function $4c8e39f3b6f078f4$export$8756898546458274(value) {
    if ($4c8e39f3b6f078f4$export$43bee75e5e14138e(value)) {
        var res = {};
        for(var i = 0; i < value.length; i++){
            var item = value[i];
            var normalized = $4c8e39f3b6f078f4$export$844ec244b1367d54(item) ? $4c8e39f3b6f078f4$export$76a205ce979d066a(item) : $4c8e39f3b6f078f4$export$8756898546458274(item);
            if (normalized) for(var key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($4c8e39f3b6f078f4$export$844ec244b1367d54(value) || $4c8e39f3b6f078f4$export$a6cdc56e425d0d0a(value)) return value;
}
var $4c8e39f3b6f078f4$var$listDelimiterRE = /;(?![^(]*\))/g;
var $4c8e39f3b6f078f4$var$propertyDelimiterRE = /:([^]+)/;
var $4c8e39f3b6f078f4$var$styleCommentRE = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function $4c8e39f3b6f078f4$export$76a205ce979d066a(cssText) {
    var ret = {};
    cssText.replace($4c8e39f3b6f078f4$var$styleCommentRE, function(match) {
        return match.startsWith("/*") ? "" : match;
    }).split($4c8e39f3b6f078f4$var$listDelimiterRE).forEach(function(item) {
        if (item) {
            var tmp = item.split($4c8e39f3b6f078f4$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $4c8e39f3b6f078f4$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($4c8e39f3b6f078f4$export$844ec244b1367d54(styles)) return styles;
    var ret = "";
    for(var key in styles){
        var value = styles[key];
        if ($4c8e39f3b6f078f4$export$844ec244b1367d54(value) || typeof value === "number") {
            var normalizedKey = key.startsWith("--") ? key : $4c8e39f3b6f078f4$export$6e6a0a3676c4b8bb(key);
            ret += "".concat(normalizedKey, ":").concat(value, ";");
        }
    }
    return ret;
}
function $4c8e39f3b6f078f4$export$4f7022d2d68e2c5a(value) {
    var res = "";
    if ($4c8e39f3b6f078f4$export$844ec244b1367d54(value)) res = value;
    else if ($4c8e39f3b6f078f4$export$43bee75e5e14138e(value)) for(var i = 0; i < value.length; i++){
        var normalized = $4c8e39f3b6f078f4$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($4c8e39f3b6f078f4$export$a6cdc56e425d0d0a(value)) {
        for(var name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $4c8e39f3b6f078f4$export$601abcd8103db5e4(props) {
    if (!props) return null;
    var klass = props.class, style = props.style;
    if (klass && !$4c8e39f3b6f078f4$export$844ec244b1367d54(klass)) props.class = $4c8e39f3b6f078f4$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $4c8e39f3b6f078f4$export$8756898546458274(style);
    return props;
}
//#endregion
//#region packages/shared/src/domTagConfig.ts
var $4c8e39f3b6f078f4$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
var $4c8e39f3b6f078f4$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
var $4c8e39f3b6f078f4$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
var $4c8e39f3b6f078f4$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
var $4c8e39f3b6f078f4$var$FORMATTING_TAGS = "a,b,big,code,em,font,i,nobr,s,small,strike,strong,tt,u";
var $4c8e39f3b6f078f4$var$ALWAYS_CLOSE_TAGS = "title,style,script,noscript,template,object,table,button,textarea,select,iframe,fieldset";
var $4c8e39f3b6f078f4$var$INLINE_TAGS = "a,abbr,acronym,b,bdi,bdo,big,br,button,canvas,cite,code,data,datalist,del,dfn,em,embed,i,iframe,img,input,ins,kbd,label,map,mark,meter,noscript,object,output,picture,progress,q,ruby,s,samp,script,select,small,span,strong,sub,sup,svg,textarea,time,u,tt,var,video";
var $4c8e39f3b6f078f4$var$BLOCK_TAGS = "address,article,aside,blockquote,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,hr,li,main,menu,nav,ol,p,pre,section,table,ul";
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ var $4c8e39f3b6f078f4$export$1ccf854a0984f890 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$HTML_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ var $4c8e39f3b6f078f4$export$6328ce7565ea1049 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$SVG_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ var $4c8e39f3b6f078f4$export$4a46ca4c5be17b20 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$MATH_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ var $4c8e39f3b6f078f4$export$e5f2d3d97d9367a4 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$VOID_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ var $4c8e39f3b6f078f4$export$f004a7b38a350495 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$FORMATTING_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ var $4c8e39f3b6f078f4$export$4afe2b5e8b3e6daf = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$ALWAYS_CLOSE_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ var $4c8e39f3b6f078f4$export$61e899969cd8bf24 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$INLINE_TAGS);
/**
* Compiler only.
* Do NOT use in runtime code paths unless behind `!!(process.env.NODE_ENV !== 'production')` flag.
*/ var $4c8e39f3b6f078f4$export$fa426276c4a55e76 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$BLOCK_TAGS);
//#endregion
//#region packages/shared/src/domAttrConfig.ts
/**
* On the client we only need to offer special cases for boolean attributes that
* have different names from their corresponding dom properties:
* - itemscope -> N/A
* - allowfullscreen -> allowFullscreen
* - formnovalidate -> formNoValidate
* - ismap -> isMap
* - nomodule -> noModule
* - novalidate -> noValidate
* - readonly -> readOnly
*/ var $4c8e39f3b6f078f4$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $4c8e39f3b6f078f4$export$d186f5eb2e810715 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$specialBooleanAttrs);
/**
* The full list is needed during SSR to produce the correct initial markup.
*/ var $4c8e39f3b6f078f4$export$f763ba3b84e9cd8c = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8($4c8e39f3b6f078f4$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
/**
* Boolean attributes should be included if the value is truthy or ''.
* e.g. `<select multiple>` compiles to `{ multiple: '' }`
*/ function $4c8e39f3b6f078f4$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
var $4c8e39f3b6f078f4$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u000d\u0020]/;
var $4c8e39f3b6f078f4$var$attrValidationCache = {};
function $4c8e39f3b6f078f4$export$d55ef77660f30d12(name) {
    if ($4c8e39f3b6f078f4$var$attrValidationCache.hasOwnProperty(name)) return $4c8e39f3b6f078f4$var$attrValidationCache[name];
    var isUnsafe = $4c8e39f3b6f078f4$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error("unsafe attribute name: ".concat(name));
    return $4c8e39f3b6f078f4$var$attrValidationCache[name] = !isUnsafe;
}
var $4c8e39f3b6f078f4$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
/**
* Known attributes, this is used for stringification of runtime static nodes
* so that we don't stringify bindings that cannot be set from HTML.
* Don't also forget to allow `data-*` and `aria-*`!
* Generated from https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes
*/ var $4c8e39f3b6f078f4$export$f7e7a1cc7da8d5e9 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8("accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap");
/**
* Generated from https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute
*/ var $4c8e39f3b6f078f4$export$80da416f43933831 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8("xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan");
/**
* Generated from https://developer.mozilla.org/en-US/docs/Web/MathML/Attribute
*/ var $4c8e39f3b6f078f4$export$fc0748a8e0014066 = /*@__PURE__*/ $4c8e39f3b6f078f4$export$b41394a5437791c8("accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns");
/**
* Shared between server-renderer and runtime-core hydration logic
*/ function $4c8e39f3b6f078f4$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
    return type === "string" || type === "number" || type === "boolean";
}
function $4c8e39f3b6f078f4$export$49386760b68c7202(tagName, key) {
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return true;
    if (key === "form") return true;
    if (key === "list" && tagName === "INPUT") return true;
    if (key === "type" && tagName === "TEXTAREA") return true;
    if ((key === "width" || key === "height") && (tagName === "IMG" || tagName === "VIDEO" || tagName === "CANVAS" || tagName === "SOURCE")) return true;
    if (key === "sandbox" && tagName === "IFRAME") return true;
    return false;
}
//#endregion
//#region packages/shared/src/domNamespace.ts
var $4c8e39f3b6f078f4$export$2f21297dc8e7cb72 = {
    "HTML": 0,
    "0": "HTML",
    "SVG": 1,
    "1": "SVG",
    "MATH_ML": 2,
    "2": "MATH_ML"
};
//#endregion
//#region packages/shared/src/escapeHtml.ts
var $4c8e39f3b6f078f4$var$escapeRE = /["'&<>]/;
function $4c8e39f3b6f078f4$export$4cf11838cdc2a8a8(string) {
    var str = "" + string;
    var match = $4c8e39f3b6f078f4$var$escapeRE.exec(str);
    if (!match) return str;
    var html = "";
    var escaped;
    var index;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
var $4c8e39f3b6f078f4$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $4c8e39f3b6f078f4$export$7b105034a53bde5f(src) {
    var prev;
    do {
        prev = src;
        src = src.replace($4c8e39f3b6f078f4$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
var $4c8e39f3b6f078f4$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $4c8e39f3b6f078f4$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($4c8e39f3b6f078f4$export$9320a7246b331080, function(s) {
        return doubleEscape ? s === "\"" ? "\\\\\\\"" : "\\\\".concat(s) : "\\".concat(s);
    });
}
//#endregion
//#region packages/shared/src/looseEqual.ts
function $4c8e39f3b6f078f4$var$looseCompareArrays(a, b, seen) {
    if (a.length !== b.length) return false;
    var equal = true;
    for(var i = 0; equal && i < a.length; i++)equal = $4c8e39f3b6f078f4$export$ae8015769846262c(a[i], b[i], seen);
    return equal;
}
function $4c8e39f3b6f078f4$var$looseCompareCollections(a, b, seen) {
    if (a.size !== b.size) return false;
    var candidates = Array.from(b);
    var matched = new Uint8Array(candidates.length);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var index = -1;
            for(var i = 0; i < candidates.length; i++)if (!matched[i] && $4c8e39f3b6f078f4$export$ae8015769846262c(item, candidates[i], seen)) {
                index = i;
                break;
            }
            if (index < 0) return false;
            matched[index] = 1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $4c8e39f3b6f078f4$var$looseCompareObjects(a, b, seen) {
    var aValidType = $4c8e39f3b6f078f4$export$5c90113a285f2241(a);
    var bValidType = $4c8e39f3b6f078f4$export$5c90113a285f2241(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $4c8e39f3b6f078f4$var$looseCompareCollections(a, b, seen) : false;
    aValidType = $4c8e39f3b6f078f4$export$6750766a7c7ec627(a);
    bValidType = $4c8e39f3b6f078f4$export$6750766a7c7ec627(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $4c8e39f3b6f078f4$var$looseCompareCollections(a, b, seen) : false;
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a){
        var aHasKey = a.hasOwnProperty(key);
        var bHasKey = b.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$4c8e39f3b6f078f4$export$ae8015769846262c(a[key], b[key], seen)) return false;
    }
    return String(a) === String(b);
}
function $4c8e39f3b6f078f4$var$looseCompareNested(a, b, seen, compare) {
    if (!seen) seen = [
        /* @__PURE__ */ new Map(),
        /* @__PURE__ */ new Map()
    ];
    var _seen = (0, $f9AOD._)(seen, 2), seenA = _seen[0], seenB = _seen[1];
    if (seenA.has(a) || seenB.has(b)) return seenA.get(a) === b && seenB.get(b) === a;
    seenA.set(a, b);
    seenB.set(b, a);
    var equal = compare(a, b, seen);
    seenA.delete(a);
    seenB.delete(b);
    return equal;
}
function $4c8e39f3b6f078f4$export$ae8015769846262c(a, b, seen) {
    if (a === b) return true;
    var aValidType = $4c8e39f3b6f078f4$export$871608497c498473(a);
    var bValidType = $4c8e39f3b6f078f4$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $4c8e39f3b6f078f4$export$a244864fd9645c7f(a);
    bValidType = $4c8e39f3b6f078f4$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $4c8e39f3b6f078f4$export$43bee75e5e14138e(a);
    bValidType = $4c8e39f3b6f078f4$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $4c8e39f3b6f078f4$var$looseCompareNested(a, b, seen, $4c8e39f3b6f078f4$var$looseCompareArrays) : false;
    aValidType = $4c8e39f3b6f078f4$export$a6cdc56e425d0d0a(a);
    bValidType = $4c8e39f3b6f078f4$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        return $4c8e39f3b6f078f4$var$looseCompareNested(a, b, seen, $4c8e39f3b6f078f4$var$looseCompareObjects);
    }
    return String(a) === String(b);
}
function $4c8e39f3b6f078f4$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex(function(item) {
        return $4c8e39f3b6f078f4$export$ae8015769846262c(item, val);
    });
}
//#endregion
//#region packages/shared/src/toDisplayString.ts
var $4c8e39f3b6f078f4$var$isRef = function(val) {
    return !!(val && val["__v_isRef"] === true);
};
/**
* For converting {{ interpolation }} values to displayed strings.
* @private
*/ var $4c8e39f3b6f078f4$export$b5b1545233b45293 = function(val) {
    switch(typeof val === "undefined" ? "undefined" : (0, $7E0eS._)(val)){
        case "string":
            return val;
        case "object":
            if (val) {
                if ($4c8e39f3b6f078f4$var$isRef(val)) return $4c8e39f3b6f078f4$export$b5b1545233b45293(val.value);
                else if ($4c8e39f3b6f078f4$export$43bee75e5e14138e(val) || val.toString === $4c8e39f3b6f078f4$export$830c053460e5ddf6 || !$4c8e39f3b6f078f4$export$f6e2535fb5126e54(val.toString)) return JSON.stringify(val, $4c8e39f3b6f078f4$var$replacer, 2);
            }
        default:
            return val == null ? "" : String(val);
    }
};
var $4c8e39f3b6f078f4$var$replacer = function(_key, val) {
    if ($4c8e39f3b6f078f4$var$isRef(val)) return $4c8e39f3b6f078f4$var$replacer(_key, val.value);
    else if ($4c8e39f3b6f078f4$export$5c90113a285f2241(val)) return (0, $7Pjls._)({}, "Map(".concat(val.size, ")"), (0, $aUGqu._)(val.entries()).reduce(function(entries, param, i) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], _$val = _param[1];
        entries[$4c8e39f3b6f078f4$var$stringifySymbol(key, i) + " =>"] = _$val;
        return entries;
    }, {}));
    else if ($4c8e39f3b6f078f4$export$6750766a7c7ec627(val)) return (0, $7Pjls._)({}, "Set(".concat(val.size, ")"), (0, $aUGqu._)(val.values()).map(function(v) {
        return $4c8e39f3b6f078f4$var$stringifySymbol(v);
    }));
    else if ($4c8e39f3b6f078f4$export$a244864fd9645c7f(val)) return $4c8e39f3b6f078f4$var$stringifySymbol(val);
    else if ($4c8e39f3b6f078f4$export$a6cdc56e425d0d0a(val) && !$4c8e39f3b6f078f4$export$43bee75e5e14138e(val) && !$4c8e39f3b6f078f4$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
var $4c8e39f3b6f078f4$var$stringifySymbol = function(v) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var _description;
    return $4c8e39f3b6f078f4$export$a244864fd9645c7f(v) ? "Symbol(".concat((_description = v.description) !== null && _description !== void 0 ? _description : i, ")") : v;
};
//#endregion
//#region packages/shared/src/subSequence.ts
function $4c8e39f3b6f078f4$export$5c1e203ca018159a(arr) {
    var p = arr.slice();
    var result = [
        0
    ];
    var i, j, u, v, c;
    var len = arr.length;
    for(i = 0; i < len; i++){
        var arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v = result.length - 1;
            while(u < v){
                c = u + v >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v = result[u - 1];
    while(u-- > 0){
        result[u] = v;
        v = p[v];
    }
    return result;
}
//#endregion
//#region packages/shared/src/cssVars.ts
/**
* Normalize CSS var value created by `v-bind` in `<style>` block
* See https://github.com/vuejs/core/pull/12461#issuecomment-2495804664
*/ function $4c8e39f3b6f078f4$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}
//#endregion
//#region packages/shared/src/vaporFlags.ts
/**
* Flags to optimize vapor `createFor` runtime behavior, shared between the
* compiler and the runtime
*/ var $4c8e39f3b6f078f4$export$ab45b86c1147712c = {
    "FAST_REMOVE": 1,
    "1": "FAST_REMOVE",
    "IS_COMPONENT": 2,
    "2": "IS_COMPONENT",
    "ONCE": 4,
    "4": "ONCE",
    "IS_SINGLE_NODE": 8,
    "8": "IS_SINGLE_NODE",
    "IS_FRAGMENT": 16,
    "16": "IS_FRAGMENT",
    "SLOT_ROOT": 32,
    "32": "SLOT_ROOT",
    "WRAPPED_ROWS": 64,
    "64": "WRAPPED_ROWS"
};
var $4c8e39f3b6f078f4$export$61e61e9edff331f3 = {
    "EMPTY": 0,
    "0": "EMPTY",
    "SINGLE_ROOT": 1,
    "1": "SINGLE_ROOT",
    "MULTI_ROOT": 2,
    "2": "MULTI_ROOT"
};
/**
* Bit layout for vapor `createIf` flags.
*
* - bits 0-1: true branch VaporBlockShape
* - bits 2-3: false branch VaporBlockShape
* - bit 4: v-once
* - bit 5: true branch is static and can skip branch-owned EffectScope
* - bit 6: false branch is static and can skip branch-owned EffectScope
* - bit 7: v-if sits on a slot content/fallback root chain
* - bits 8+: branch index + 1 for keyed dynamic fragments
*
* Examples:
* - v-once, true single-root, no false branch: 1 | ONCE = 17
* - keyed index 0, true/false single-root: 1 | (1 << 2) | (1 << 8) = 261
*/ var $4c8e39f3b6f078f4$export$86847347b977cccf = {
    "BLOCK_SHAPE": 15,
    "15": "BLOCK_SHAPE",
    "ONCE": 16,
    "16": "ONCE",
    "TRUE_NO_SCOPE": 32,
    "32": "TRUE_NO_SCOPE",
    "FALSE_NO_SCOPE": 64,
    "64": "FALSE_NO_SCOPE",
    "SLOT_ROOT": 128,
    "128": "SLOT_ROOT",
    "INDEX_SHIFT": 8,
    "8": "INDEX_SHIFT"
};
/**
* Flags used by vapor template factories, shared between the compiler and the
* runtime.
*/ var $4c8e39f3b6f078f4$export$57e75f507d329f83 = {
    "ROOT": 1,
    "1": "ROOT",
    "STATIC": 2,
    "2": "STATIC"
};
/**
* Flags used by vapor slot outlets, shared between the compiler and the
* runtime.
*/ var $4c8e39f3b6f078f4$export$4e0aa323b98da897 = {
    "NO_SLOTTED": 1,
    "1": "NO_SLOTTED",
    "ONCE": 2,
    "2": "ONCE",
    "FORWARDED": 4,
    "4": "FORWARDED",
    "SHARED_FALLBACK": 8,
    "8": "SHARED_FALLBACK"
};
function $4c8e39f3b6f078f4$export$e021dc44d742adfc(flags) {
    return !!(flags & 12);
}
function $4c8e39f3b6f078f4$export$d569989f3511ae(flags) {
    return $4c8e39f3b6f078f4$export$e021dc44d742adfc(flags) && !(flags & 8);
}
function $4c8e39f3b6f078f4$export$7cfa9a922d15a615(flags) {
    return $4c8e39f3b6f078f4$export$e021dc44d742adfc(flags) && !(flags & 2);
}
/**
* Per-slot-function metadata attached by the compiler as `fn._`.
*/ var $4c8e39f3b6f078f4$export$bda5b7b0e18bd833 = {
    "NON_STABLE": 1,
    "1": "NON_STABLE"
};
var $4c8e39f3b6f078f4$export$782651ce5501a058 = {
    "SINGLE_ROOT": 1,
    "1": "SINGLE_ROOT",
    "ONCE": 2,
    "2": "ONCE",
    "SLOT_ROOT": 4,
    "4": "SLOT_ROOT",
    "NS_SVG": 8,
    "8": "NS_SVG",
    "NS_MATHML": 16,
    "16": "NS_MATHML"
};

});

parcelRegister("3ewO8", function(module, exports) {

$parcel$export(module.exports, "unsafeToTrustedHTML", function () { return $25ac20cbfb09c042$export$1fdf04608ac1d660; });
$parcel$export(module.exports, "svgNS", function () { return $25ac20cbfb09c042$export$4b7ca16c0c939865; });
$parcel$export(module.exports, "nodeOps", function () { return $25ac20cbfb09c042$export$de4fb7f5030605d3; });
$parcel$export(module.exports, "TransitionPropsValidators", function () { return $25ac20cbfb09c042$export$b899d57baa0167d5; });
$parcel$export(module.exports, "Transition", function () { return $25ac20cbfb09c042$export$be58926105124dd4; });
$parcel$export(module.exports, "resolveTransitionProps", function () { return $25ac20cbfb09c042$export$b349eeb6ed6a6d73; });
$parcel$export(module.exports, "forceReflow", function () { return $25ac20cbfb09c042$export$7d26bbb1236dafd6; });
$parcel$export(module.exports, "patchClass", function () { return $25ac20cbfb09c042$export$de1f6f779b5b44c; });
$parcel$export(module.exports, "vShowOriginalDisplay", function () { return $25ac20cbfb09c042$export$1ce4da46075779d5; });
$parcel$export(module.exports, "vShowHidden", function () { return $25ac20cbfb09c042$export$9899690c5a6aa34e; });
$parcel$export(module.exports, "vShow", function () { return $25ac20cbfb09c042$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "useCssVars", function () { return $25ac20cbfb09c042$export$ef28b76f07940108; });
$parcel$export(module.exports, "setVarsOnNode", function () { return $25ac20cbfb09c042$export$fb351f25830bd233; });
$parcel$export(module.exports, "patchStyle", function () { return $25ac20cbfb09c042$export$1648b8c99f3dead4; });
$parcel$export(module.exports, "xlinkNS", function () { return $25ac20cbfb09c042$export$2574309f616608d7; });
$parcel$export(module.exports, "parseEventName", function () { return $25ac20cbfb09c042$export$ad797ac1f0c6c291; });
$parcel$export(module.exports, "patchProp", function () { return $25ac20cbfb09c042$export$cd4aa0842d13df8b; });
$parcel$export(module.exports, "shouldSetAsProp", function () { return $25ac20cbfb09c042$export$11623ee7ce2794a7; });
$parcel$export(module.exports, "shouldSetAsPropForVueCE", function () { return $25ac20cbfb09c042$export$153823794abe328a; });
$parcel$export(module.exports, "defineCustomElement", function () { return $25ac20cbfb09c042$export$a00e2346eabbdbef; });
$parcel$export(module.exports, "VueElement", function () { return $25ac20cbfb09c042$export$b337c1a55163dbe3; });
$parcel$export(module.exports, "defineSSRCustomElement", function () { return $25ac20cbfb09c042$export$6debb2e68f212638; });
$parcel$export(module.exports, "createSSRApp", function () { return $25ac20cbfb09c042$export$35800275c0037383; });
$parcel$export(module.exports, "VueElementBase", function () { return $25ac20cbfb09c042$export$8aeafd20e0fdd5f4; });
$parcel$export(module.exports, "createApp", function () { return $25ac20cbfb09c042$export$4e373c34abfa8c68; });
$parcel$export(module.exports, "render", function () { return $25ac20cbfb09c042$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "useHost", function () { return $25ac20cbfb09c042$export$da5acfe93a94e37d; });
$parcel$export(module.exports, "useShadowRoot", function () { return $25ac20cbfb09c042$export$64d45095031fa749; });
$parcel$export(module.exports, "useCssModule", function () { return $25ac20cbfb09c042$export$9300d5b90d56e3d1; });
$parcel$export(module.exports, "TransitionGroup", function () { return $25ac20cbfb09c042$export$19ffa8f511f7bc2e; });
$parcel$export(module.exports, "hasCSSTransform", function () { return $25ac20cbfb09c042$export$6488e4a884389379; });
$parcel$export(module.exports, "callPendingCbs", function () { return $25ac20cbfb09c042$export$d5371ae309f51a37; });
$parcel$export(module.exports, "handleMovedChildren", function () { return $25ac20cbfb09c042$export$bb551b8c48d28521; });
$parcel$export(module.exports, "baseApplyTranslation", function () { return $25ac20cbfb09c042$export$61fb5edf31d9f0b8; });
$parcel$export(module.exports, "vModelText", function () { return $25ac20cbfb09c042$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelTextInit", function () { return $25ac20cbfb09c042$export$2d3637690b27facf; });
$parcel$export(module.exports, "vModelTextUpdate", function () { return $25ac20cbfb09c042$export$b171fe2fda8d060a; });
$parcel$export(module.exports, "vModelCheckbox", function () { return $25ac20cbfb09c042$export$8847c2e532b35714; });
$parcel$export(module.exports, "vModelCheckboxInit", function () { return $25ac20cbfb09c042$export$10ad6c0b109fa494; });
$parcel$export(module.exports, "vModelCheckboxUpdate", function () { return $25ac20cbfb09c042$export$bf72bd412424aea; });
$parcel$export(module.exports, "vModelGetValue", function () { return $25ac20cbfb09c042$export$882b439d816257fa; });
$parcel$export(module.exports, "vModelRadio", function () { return $25ac20cbfb09c042$export$b4356c59b38b7aa9; });
$parcel$export(module.exports, "vModelSelect", function () { return $25ac20cbfb09c042$export$87d227567b51ca39; });
$parcel$export(module.exports, "vModelSelectInit", function () { return $25ac20cbfb09c042$export$6755e66381fe27bf; });
$parcel$export(module.exports, "vModelSetSelected", function () { return $25ac20cbfb09c042$export$ff95a38066b55f02; });
$parcel$export(module.exports, "vModelDynamic", function () { return $25ac20cbfb09c042$export$5ad5c0e01ff62c5; });
$parcel$export(module.exports, "withModifiers", function () { return $25ac20cbfb09c042$export$26bd3b8e29e6f273; });
$parcel$export(module.exports, "withKeys", function () { return $25ac20cbfb09c042$export$f691a8759658f782; });
$parcel$export(module.exports, "ensureRenderer", function () { return $25ac20cbfb09c042$export$a0bae4d3eba7c8a0; });
$parcel$export(module.exports, "ensureHydrationRenderer", function () { return $25ac20cbfb09c042$export$70a3ed9a5d6c0c60; });
$parcel$export(module.exports, "hydrate", function () { return $25ac20cbfb09c042$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "normalizeContainer", function () { return $25ac20cbfb09c042$export$fc6b59695d328a27; });
$parcel$export(module.exports, "initDirectivesForSSR", function () { return $25ac20cbfb09c042$export$800b28255aa678d9; });
/**
  * @vue/runtime-dom v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $fKAHx = parcelRequire("fKAHx");
var $6zvdv = parcelRequire("6zvdv");
var $ftLbb = parcelRequire("ftLbb");

var $6zvdv = parcelRequire("6zvdv");
//#region packages/runtime-dom/src/nodeOps.ts
var $25ac20cbfb09c042$var$policy = void 0;
var $25ac20cbfb09c042$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($25ac20cbfb09c042$var$tt) try {
    $25ac20cbfb09c042$var$policy = /*@__PURE__*/ $25ac20cbfb09c042$var$tt.createPolicy("vue", {
        createHTML: function(val) {
            return val;
        }
    });
} catch (e) {}
var $25ac20cbfb09c042$export$1fdf04608ac1d660 = $25ac20cbfb09c042$var$policy ? function(val) {
    return $25ac20cbfb09c042$var$policy.createHTML(val);
} : function(val) {
    return val;
};
var $25ac20cbfb09c042$export$4b7ca16c0c939865 = "http://www.w3.org/2000/svg";
var $25ac20cbfb09c042$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
var $25ac20cbfb09c042$var$doc = typeof document !== "undefined" ? document : null;
var $25ac20cbfb09c042$var$templateContainer = $25ac20cbfb09c042$var$doc && /*@__PURE__*/ $25ac20cbfb09c042$var$doc.createElement("template");
var $25ac20cbfb09c042$export$de4fb7f5030605d3 = {
    insert: function(child, parent, anchor) {
        parent.insertBefore(child, anchor || null);
    },
    remove: function(child) {
        var parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: function(tag, namespace, is, props) {
        var el = namespace === "svg" ? $25ac20cbfb09c042$var$doc.createElementNS($25ac20cbfb09c042$export$4b7ca16c0c939865, tag) : namespace === "mathml" ? $25ac20cbfb09c042$var$doc.createElementNS($25ac20cbfb09c042$var$mathmlNS, tag) : is ? $25ac20cbfb09c042$var$doc.createElement(tag, {
            is: is
        }) : $25ac20cbfb09c042$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: function(text) {
        return $25ac20cbfb09c042$var$doc.createTextNode(text);
    },
    createComment: function(text) {
        return $25ac20cbfb09c042$var$doc.createComment(text);
    },
    setText: function(node, text) {
        node.nodeValue = text;
    },
    setElementText: function(el, text) {
        el.textContent = text;
    },
    parentNode: function(node) {
        return node.parentNode;
    },
    nextSibling: function(node) {
        return node.nextSibling;
    },
    querySelector: function(selector) {
        return $25ac20cbfb09c042$var$doc.querySelector(selector);
    },
    setScopeId: function(el, id) {
        el.setAttribute(id, "");
    },
    insertStaticContent: function(content, parent, anchor, namespace, start, end) {
        var before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $25ac20cbfb09c042$var$templateContainer.innerHTML = $25ac20cbfb09c042$export$1fdf04608ac1d660(namespace === "svg" ? "<svg>".concat(content, "</svg>") : namespace === "mathml" ? "<math>".concat(content, "</math>") : content);
            var template = $25ac20cbfb09c042$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                var wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            before ? before.nextSibling : parent.firstChild,
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
//#endregion
//#region packages/runtime-dom/src/components/Transition.ts
var $25ac20cbfb09c042$var$TRANSITION = "transition";
var $25ac20cbfb09c042$var$ANIMATION = "animation";
var $25ac20cbfb09c042$var$vtcKey = Symbol("_vtc");
var $25ac20cbfb09c042$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
var $25ac20cbfb09c042$export$b899d57baa0167d5 = /*@__PURE__*/ (0, $6zvdv.extend)({}, (0, $fKAHx.BaseTransitionPropsValidators), $25ac20cbfb09c042$var$DOMTransitionPropsValidators);
/**
* Wrap logic that attaches extra properties to Transition in a function
* so that it can be annotated as pure
*/ var $25ac20cbfb09c042$var$decorate$1 = function(t) {
    t.displayName = "Transition";
    t.props = $25ac20cbfb09c042$export$b899d57baa0167d5;
    return t;
};
/**
* DOM Transition is a higher-order-component based on the platform-agnostic
* base Transition component, with DOM-specific logic.
*/ var $25ac20cbfb09c042$export$be58926105124dd4 = /*@__PURE__*/ $25ac20cbfb09c042$var$decorate$1(function(props, param) {
    var slots = param.slots;
    return (0, $fKAHx.h)((0, $fKAHx.BaseTransition), $25ac20cbfb09c042$export$b349eeb6ed6a6d73(props), slots);
});
/**
* #3227 Incoming hooks may be merged into arrays when wrapping Transition
* with custom HOCs.
*/ var $25ac20cbfb09c042$var$callHook = function(hook) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if ((0, $6zvdv.isArray)(hook)) hook.forEach(function(h) {
        return h.apply(void 0, (0, $aUGqu._)(args));
    });
    else if (hook) hook.apply(void 0, (0, $aUGqu._)(args));
};
/**
* Check if a hook expects a callback (2nd arg), which means the user
* intends to explicitly control the end of the transition.
*/ var $25ac20cbfb09c042$var$hasExplicitCallback = function(hook) {
    return hook ? (0, $6zvdv.isArray)(hook) ? hook.some(function(h) {
        return h.length > 1;
    }) : hook.length > 1 : false;
};
function $25ac20cbfb09c042$export$b349eeb6ed6a6d73(rawProps) {
    var baseProps = {};
    for(var key in rawProps)if (!(key in $25ac20cbfb09c042$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    var _rawProps_name = rawProps.name, name = _rawProps_name === void 0 ? "v" : _rawProps_name, type = rawProps.type, duration = rawProps.duration, _rawProps_enterFromClass = rawProps.enterFromClass, enterFromClass = _rawProps_enterFromClass === void 0 ? "".concat(name, "-enter-from") : _rawProps_enterFromClass, _rawProps_enterActiveClass = rawProps.enterActiveClass, enterActiveClass = _rawProps_enterActiveClass === void 0 ? "".concat(name, "-enter-active") : _rawProps_enterActiveClass, _rawProps_enterToClass = rawProps.enterToClass, enterToClass = _rawProps_enterToClass === void 0 ? "".concat(name, "-enter-to") : _rawProps_enterToClass, _rawProps_appearFromClass = rawProps.appearFromClass, appearFromClass = _rawProps_appearFromClass === void 0 ? enterFromClass : _rawProps_appearFromClass, _rawProps_appearActiveClass = rawProps.appearActiveClass, appearActiveClass = _rawProps_appearActiveClass === void 0 ? enterActiveClass : _rawProps_appearActiveClass, _rawProps_appearToClass = rawProps.appearToClass, appearToClass = _rawProps_appearToClass === void 0 ? enterToClass : _rawProps_appearToClass, _rawProps_leaveFromClass = rawProps.leaveFromClass, leaveFromClass = _rawProps_leaveFromClass === void 0 ? "".concat(name, "-leave-from") : _rawProps_leaveFromClass, _rawProps_leaveActiveClass = rawProps.leaveActiveClass, leaveActiveClass = _rawProps_leaveActiveClass === void 0 ? "".concat(name, "-leave-active") : _rawProps_leaveActiveClass, _rawProps_leaveToClass = rawProps.leaveToClass, leaveToClass = _rawProps_leaveToClass === void 0 ? "".concat(name, "-leave-to") : _rawProps_leaveToClass;
    var durations = $25ac20cbfb09c042$var$normalizeDuration(duration);
    var enterDuration = durations && durations[0];
    var leaveDuration = durations && durations[1];
    var onBeforeEnter = baseProps.onBeforeEnter, onEnter = baseProps.onEnter, onEnterCancelled = baseProps.onEnterCancelled, onLeave = baseProps.onLeave, onLeaveCancelled = baseProps.onLeaveCancelled, _baseProps_onBeforeAppear = baseProps.onBeforeAppear, onBeforeAppear = _baseProps_onBeforeAppear === void 0 ? onBeforeEnter : _baseProps_onBeforeAppear, _baseProps_onAppear = baseProps.onAppear, onAppear = _baseProps_onAppear === void 0 ? onEnter : _baseProps_onAppear, _baseProps_onAppearCancelled = baseProps.onAppearCancelled, onAppearCancelled = _baseProps_onAppearCancelled === void 0 ? onEnterCancelled : _baseProps_onAppearCancelled;
    var finishEnter = function(el, isAppear, done, isCancelled) {
        el._enterCancelled = isCancelled;
        $25ac20cbfb09c042$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $25ac20cbfb09c042$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    var finishLeave = function(el, done) {
        el._isLeaving = false;
        $25ac20cbfb09c042$var$removeTransitionClass(el, leaveFromClass);
        $25ac20cbfb09c042$var$removeTransitionClass(el, leaveToClass);
        $25ac20cbfb09c042$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    var makeEnterHook = function(isAppear) {
        return function(el, done) {
            var hook = isAppear ? onAppear : onEnter;
            var resolve = function() {
                return finishEnter(el, isAppear, done);
            };
            $25ac20cbfb09c042$var$callHook(hook, [
                el,
                resolve
            ]);
            $25ac20cbfb09c042$var$nextFrame(function() {
                $25ac20cbfb09c042$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $25ac20cbfb09c042$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$25ac20cbfb09c042$var$hasExplicitCallback(hook)) $25ac20cbfb09c042$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $6zvdv.extend)(baseProps, {
        onBeforeEnter: function(el) {
            $25ac20cbfb09c042$var$callHook(onBeforeEnter, [
                el
            ]);
            $25ac20cbfb09c042$var$addTransitionClass(el, enterFromClass);
            $25ac20cbfb09c042$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear: function(el) {
            $25ac20cbfb09c042$var$callHook(onBeforeAppear, [
                el
            ]);
            $25ac20cbfb09c042$var$addTransitionClass(el, appearFromClass);
            $25ac20cbfb09c042$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave: function(el, done) {
            el._isLeaving = true;
            var resolve = function() {
                return finishLeave(el, done);
            };
            $25ac20cbfb09c042$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $25ac20cbfb09c042$export$7d26bbb1236dafd6(el);
                $25ac20cbfb09c042$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $25ac20cbfb09c042$var$addTransitionClass(el, leaveActiveClass);
                $25ac20cbfb09c042$export$7d26bbb1236dafd6(el);
            }
            $25ac20cbfb09c042$var$nextFrame(function() {
                if (!el._isLeaving) return;
                $25ac20cbfb09c042$var$removeTransitionClass(el, leaveFromClass);
                $25ac20cbfb09c042$var$addTransitionClass(el, leaveToClass);
                if (!$25ac20cbfb09c042$var$hasExplicitCallback(onLeave)) $25ac20cbfb09c042$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $25ac20cbfb09c042$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled: function(el) {
            finishEnter(el, false, void 0, true);
            $25ac20cbfb09c042$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled: function(el) {
            finishEnter(el, true, void 0, true);
            $25ac20cbfb09c042$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled: function(el) {
            finishLeave(el);
            $25ac20cbfb09c042$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $25ac20cbfb09c042$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $6zvdv.isObject)(duration)) return [
        $25ac20cbfb09c042$var$NumberOf(duration.enter),
        $25ac20cbfb09c042$var$NumberOf(duration.leave)
    ];
    else {
        var n = $25ac20cbfb09c042$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $25ac20cbfb09c042$var$NumberOf(val) {
    var res = (0, $6zvdv.toNumber)(val);
    return res;
}
function $25ac20cbfb09c042$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.add(c);
    });
    (el[$25ac20cbfb09c042$var$vtcKey] || (el[$25ac20cbfb09c042$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $25ac20cbfb09c042$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.remove(c);
    });
    var _vtc = el[$25ac20cbfb09c042$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$25ac20cbfb09c042$var$vtcKey] = void 0;
    }
}
function $25ac20cbfb09c042$var$nextFrame(cb) {
    requestAnimationFrame(function() {
        requestAnimationFrame(cb);
    });
}
var $25ac20cbfb09c042$var$endId = 0;
function $25ac20cbfb09c042$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    var id = el._endId = ++$25ac20cbfb09c042$var$endId;
    var resolveIfNotStale = function() {
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    var _getTransitionInfo = $25ac20cbfb09c042$var$getTransitionInfo(el, expectedType), type = _getTransitionInfo.type, timeout = _getTransitionInfo.timeout, propCount = _getTransitionInfo.propCount;
    if (!type) return resolve();
    var endEvent = type + "end";
    var ended = 0;
    var end = function() {
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    var onEnd = function(e) {
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(function() {
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $25ac20cbfb09c042$var$getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    var getStyleProperties = function(key) {
        return (styles[key] || "").split(", ");
    };
    var transitionDelays = getStyleProperties("".concat($25ac20cbfb09c042$var$TRANSITION, "Delay"));
    var transitionDurations = getStyleProperties("".concat($25ac20cbfb09c042$var$TRANSITION, "Duration"));
    var transitionTimeout = $25ac20cbfb09c042$var$getTimeout(transitionDelays, transitionDurations);
    var animationDelays = getStyleProperties("".concat($25ac20cbfb09c042$var$ANIMATION, "Delay"));
    var animationDurations = getStyleProperties("".concat($25ac20cbfb09c042$var$ANIMATION, "Duration"));
    var animationTimeout = $25ac20cbfb09c042$var$getTimeout(animationDelays, animationDurations);
    var type = null;
    var timeout = 0;
    var propCount = 0;
    if (expectedType === $25ac20cbfb09c042$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $25ac20cbfb09c042$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $25ac20cbfb09c042$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $25ac20cbfb09c042$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $25ac20cbfb09c042$var$TRANSITION : $25ac20cbfb09c042$var$ANIMATION : null;
        propCount = type ? type === $25ac20cbfb09c042$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === $25ac20cbfb09c042$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties("".concat($25ac20cbfb09c042$var$TRANSITION, "Property")).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $25ac20cbfb09c042$var$getTimeout(delays, durations) {
    var _Math;
    while(delays.length < durations.length)delays = delays.concat(delays);
    return (_Math = Math).max.apply(_Math, (0, $aUGqu._)(durations.map(function(d, i) {
        return $25ac20cbfb09c042$var$toMs(d) + $25ac20cbfb09c042$var$toMs(delays[i]);
    })));
}
function $25ac20cbfb09c042$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $25ac20cbfb09c042$export$7d26bbb1236dafd6(el) {
    return (el ? el.ownerDocument : document).body.offsetHeight;
}
//#endregion
//#region packages/runtime-dom/src/modules/class.ts
function $25ac20cbfb09c042$export$de1f6f779b5b44c(el, value, isSVG) {
    var transitionClasses = el[$25ac20cbfb09c042$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value
    ].concat((0, $aUGqu._)(transitionClasses)) : (0, $aUGqu._)(transitionClasses)).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
//#endregion
//#region packages/runtime-dom/src/directives/vShow.ts
var $25ac20cbfb09c042$export$1ce4da46075779d5 = Symbol("_vod");
var $25ac20cbfb09c042$export$9899690c5a6aa34e = Symbol("_vsh");
var $25ac20cbfb09c042$export$5cb4fcdc6937d7e1 = {
    name: "show",
    beforeMount: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        el[$25ac20cbfb09c042$export$1ce4da46075779d5] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $25ac20cbfb09c042$var$setDisplay(el, value);
    },
    mounted: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        if (transition && value) transition.enter(el);
    },
    updated: function(el, param, param1) {
        var value = param.value, oldValue = param.oldValue, transition = param1.transition;
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $25ac20cbfb09c042$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, function() {
                $25ac20cbfb09c042$var$setDisplay(el, false);
            });
        } else $25ac20cbfb09c042$var$setDisplay(el, value);
    },
    beforeUnmount: function(el, param) {
        var value = param.value;
        $25ac20cbfb09c042$var$setDisplay(el, value);
    }
};
function $25ac20cbfb09c042$var$setDisplay(el, value) {
    el.style.display = value ? el[$25ac20cbfb09c042$export$1ce4da46075779d5] : "none";
    el[$25ac20cbfb09c042$export$9899690c5a6aa34e] = !value;
}
function $25ac20cbfb09c042$var$initVShowForSSR() {
    $25ac20cbfb09c042$export$5cb4fcdc6937d7e1.getSSRProps = function(param) {
        var value = param.value;
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
//#endregion
//#region packages/runtime-dom/src/helpers/useCssVars.ts
var $25ac20cbfb09c042$var$CSS_VAR_TEXT = Symbol("");
/**
* Runtime helper for SFC's CSS variable injection feature.
* @private
*/ function $25ac20cbfb09c042$export$ef28b76f07940108(getter) {
    var instance = (0, $fKAHx.getCurrentInstance)();
    /* v8 ignore start */ if (!instance) return;
    /* v8 ignore stop */ var getVars = function() {
        return getter(instance.proxy);
    };
    var updateTeleports = instance.ut = function() {
        var vars = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getVars();
        Array.from(document.querySelectorAll('[data-v-owner="'.concat(instance.uid, '"]'))).forEach(function(node) {
            return $25ac20cbfb09c042$export$fb351f25830bd233(node, vars);
        });
    };
    var applyCssVars = function() {
        var vars = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getVars();
        if (instance.ce) $25ac20cbfb09c042$export$fb351f25830bd233(instance.ce, vars);
        else $25ac20cbfb09c042$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $fKAHx.onBeforeUpdate)(function() {
        (0, $fKAHx.queuePostFlushCb)(applyCssVars);
    });
    (0, $fKAHx.onMounted)(function() {
        (0, $fKAHx.watch)(function() {
            var vars = getVars();
            (0, $6zvdv.extend)({}, vars);
            applyCssVars(vars);
        }, (0, $6zvdv.NOOP), {
            flush: "post"
        });
        var ob = new MutationObserver(function() {
            return applyCssVars();
        });
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $fKAHx.onUnmounted)(function() {
            return ob.disconnect();
        });
    });
}
function $25ac20cbfb09c042$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        var suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(function() {
            $25ac20cbfb09c042$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component){
        var component = vnode.component;
        if (component.vapor) {
            component.appContext.vapor.applyCssVars(vnode, vars);
            return;
        }
        vnode = vnode.component.subTree;
    }
    if (vnode.shapeFlag & 1 && vnode.el) $25ac20cbfb09c042$export$fb351f25830bd233(vnode.el, vars);
    else if (vnode.type === (0, $fKAHx.Fragment)) vnode.children.forEach(function(c) {
        return $25ac20cbfb09c042$var$setVarsOnVNode(c, vars);
    });
    else if (vnode.type === (0, $fKAHx.Static)) {
        var el = vnode.el, anchor = vnode.anchor;
        while(el){
            $25ac20cbfb09c042$export$fb351f25830bd233(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
/**
* @internal
* shared between vdom and vapor
*/ function $25ac20cbfb09c042$export$fb351f25830bd233(el, vars) {
    if (el.nodeType === 1) {
        var style = el.style;
        var cssText = "";
        for(var key in vars){
            var value = (0, $6zvdv.normalizeCssVarValue)(vars[key]);
            style.setProperty("--".concat(key), value);
            cssText += "--".concat(key, ": ").concat(value, ";");
        }
        style[$25ac20cbfb09c042$var$CSS_VAR_TEXT] = cssText;
    }
}
//#endregion
//#region packages/runtime-dom/src/modules/style.ts
var $25ac20cbfb09c042$var$displayRE = /(?:^|;)\s*display\s*:/;
function $25ac20cbfb09c042$export$1648b8c99f3dead4(el, prev, next) {
    var style = el.style;
    var isCssString = (0, $6zvdv.isString)(next);
    var hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (!(0, $6zvdv.isString)(prev)) {
                for(var key in prev)if (next[key] == null) $25ac20cbfb09c042$var$setStyle(style, key, "");
            } else try {
                for(var _iterator = prev.split(";")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var prevStyle = _step.value;
                    var key1 = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                    if (next[key1] == null) $25ac20cbfb09c042$var$setStyle(style, key1, "");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        for(var key2 in next){
            if (key2 === "display") hasControlledDisplay = true;
            var value = next[key2];
            if (value != null) {
                if (!$25ac20cbfb09c042$var$shouldPreserveTextareaResizeStyle(el, key2, !(0, $6zvdv.isString)(prev) && prev ? prev[key2] : void 0, value)) $25ac20cbfb09c042$var$setStyle(style, key2, value);
            } else $25ac20cbfb09c042$var$setStyle(style, key2, "");
        }
    } else if (isCssString) {
        if (prev !== next) {
            var cssVarText = style[$25ac20cbfb09c042$var$CSS_VAR_TEXT];
            if (cssVarText) next += ";" + cssVarText;
            style.cssText = next;
            hasControlledDisplay = $25ac20cbfb09c042$var$displayRE.test(next);
        }
    } else if (prev) el.removeAttribute("style");
    if ($25ac20cbfb09c042$export$1ce4da46075779d5 in el) {
        el[$25ac20cbfb09c042$export$1ce4da46075779d5] = hasControlledDisplay ? style.display : "";
        if (el[$25ac20cbfb09c042$export$9899690c5a6aa34e]) style.display = "none";
    }
}
var $25ac20cbfb09c042$var$semicolonRE = /[^\\];\s*$/;
var $25ac20cbfb09c042$var$importantRE = /\s*!important$/;
function $25ac20cbfb09c042$var$setStyle(style, name, rawVal) {
    if ((0, $6zvdv.isArray)(rawVal)) rawVal.forEach(function(v) {
        return $25ac20cbfb09c042$var$setStyle(style, name, v);
    });
    else {
        var val = rawVal == null ? "" : String(rawVal);
        if (name.startsWith("--")) {
            if ($25ac20cbfb09c042$var$importantRE.test(val)) style.setProperty(name, val.replace($25ac20cbfb09c042$var$importantRE, ""), "important");
            else style.setProperty(name, val);
        } else {
            var prefixed = $25ac20cbfb09c042$var$autoPrefix(style, name);
            if ($25ac20cbfb09c042$var$importantRE.test(val)) style.setProperty((0, $6zvdv.hyphenate)(prefixed), val.replace($25ac20cbfb09c042$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
var $25ac20cbfb09c042$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
var $25ac20cbfb09c042$var$prefixCache = {};
function $25ac20cbfb09c042$var$autoPrefix(style, rawName) {
    var cached = $25ac20cbfb09c042$var$prefixCache[rawName];
    if (cached) return cached;
    var name = (0, $6zvdv.camelize)(rawName);
    if (name !== "filter" && name in style) return $25ac20cbfb09c042$var$prefixCache[rawName] = name;
    name = (0, $6zvdv.capitalize)(name);
    for(var i = 0; i < $25ac20cbfb09c042$var$prefixes.length; i++){
        var prefixed = $25ac20cbfb09c042$var$prefixes[i] + name;
        if (prefixed in style) return $25ac20cbfb09c042$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
/**
* Browsers update textarea width/height directly during native resize.
* Only special-case this common textarea path for now; other resize scenarios
* still follow normal vnode style patching.
*/ function $25ac20cbfb09c042$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $6zvdv.isString)(next) && prev === next;
}
//#endregion
//#region packages/runtime-dom/src/modules/attrs.ts
var $25ac20cbfb09c042$export$2574309f616608d7 = "http://www.w3.org/1999/xlink";
function $25ac20cbfb09c042$var$patchAttr(el, key, value, isSVG, instance) {
    var isBoolean = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $6zvdv.isSpecialBooleanAttr)(key);
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($25ac20cbfb09c042$export$2574309f616608d7, key.slice(6, key.length));
        else el.setAttributeNS($25ac20cbfb09c042$export$2574309f616608d7, key, value);
    } else if (value == null || isBoolean && !(0, $6zvdv.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $6zvdv.isSymbol)(value) ? String(value) : value);
}
//#endregion
//#region packages/runtime-dom/src/modules/props.ts
function $25ac20cbfb09c042$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $25ac20cbfb09c042$export$1fdf04608ac1d660(value) : value;
        return;
    }
    var tag = el.tagName;
    if (key === "value" && (0, $6zvdv.canSetValueDirectly)(tag)) {
        var oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        var newValue = value == null ? el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    var needRemove = false;
    if (value === "" || value == null) {
        var type = (0, $7E0eS._)(el[key]);
        if (type === "boolean") value = (0, $6zvdv.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
//#endregion
//#region packages/runtime-dom/src/modules/events.ts
function $25ac20cbfb09c042$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $25ac20cbfb09c042$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
var $25ac20cbfb09c042$var$veiKey = Symbol("_vei");
function $25ac20cbfb09c042$var$patchEvent(el, rawName, prevValue, nextValue) {
    var instance = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var invokers = el[$25ac20cbfb09c042$var$veiKey] || (el[$25ac20cbfb09c042$var$veiKey] = {});
    var existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        var _parseEventName = (0, $f9AOD._)($25ac20cbfb09c042$export$ad797ac1f0c6c291(rawName), 2), name = _parseEventName[0], options = _parseEventName[1];
        if (nextValue) $25ac20cbfb09c042$var$addEventListener(el, name, invokers[rawName] = $25ac20cbfb09c042$var$createInvoker(nextValue, instance), options);
        else if (existingInvoker) {
            $25ac20cbfb09c042$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
var $25ac20cbfb09c042$var$optionsModifierRE = /(Once|Passive|Capture)$/;
var $25ac20cbfb09c042$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $25ac20cbfb09c042$export$ad797ac1f0c6c291(name) {
    var options;
    var m;
    while((m = name.match($25ac20cbfb09c042$var$optionsModifierRE)) && !$25ac20cbfb09c042$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    return [
        name[2] === ":" ? name.slice(3) : (0, $6zvdv.hyphenate)(name.slice(2)),
        options
    ];
}
var $25ac20cbfb09c042$var$cachedNow = 0;
var $25ac20cbfb09c042$var$p = /*@__PURE__*/ Promise.resolve();
var $25ac20cbfb09c042$var$getNow = function() {
    return $25ac20cbfb09c042$var$cachedNow || ($25ac20cbfb09c042$var$p.then(function() {
        return $25ac20cbfb09c042$var$cachedNow = 0;
    }), $25ac20cbfb09c042$var$cachedNow = Date.now());
};
function $25ac20cbfb09c042$var$createInvoker(initialValue, instance) {
    var invoker = function(e) {
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        var value = invoker.value;
        if ((0, $6zvdv.isArray)(value)) {
            var originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = function() {
                originalStop.call(e);
                e._stopped = true;
            };
            var handlers = value.slice();
            var args = [
                e
            ];
            for(var i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                var handler = handlers[i];
                if (handler) (0, $fKAHx.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $fKAHx.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $25ac20cbfb09c042$var$getNow();
    return invoker;
}
function $25ac20cbfb09c042$var$sanitizeEventValue(value, propName) {
    if ((0, $6zvdv.isFunction)(value) || (0, $6zvdv.isArray)(value)) return value;
    (0, $fKAHx.warn)("Wrong type passed as event handler to ".concat(propName, " - did you forget @ or : in front of your prop?\nExpected function or array of functions, received type ").concat(typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value), "."));
    return 0, $6zvdv.NOOP;
}
//#endregion
//#region packages/runtime-dom/src/patchProp.ts
var $25ac20cbfb09c042$export$cd4aa0842d13df8b = function(el, key, prevValue, nextValue, namespace, parentComponent) {
    var isSVG = namespace === "svg";
    if (key === "class") $25ac20cbfb09c042$export$de1f6f779b5b44c(el, nextValue, isSVG);
    else if (key === "style") $25ac20cbfb09c042$export$1648b8c99f3dead4(el, prevValue, nextValue);
    else if ((0, $6zvdv.isOn)(key)) {
        if (!(0, $6zvdv.isModelListener)(key)) $25ac20cbfb09c042$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $25ac20cbfb09c042$export$11623ee7ce2794a7(el, key, nextValue, isSVG)) {
        $25ac20cbfb09c042$var$patchDOMProp(el, key, nextValue, parentComponent);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $25ac20cbfb09c042$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (el._isVueCE && ($25ac20cbfb09c042$export$153823794abe328a(el, key) || el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $6zvdv.isString)(nextValue)))) $25ac20cbfb09c042$var$patchDOMProp(el, (0, $6zvdv.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $25ac20cbfb09c042$var$patchAttr(el, key, nextValue, isSVG, parentComponent);
    }
};
function $25ac20cbfb09c042$export$11623ee7ce2794a7(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && (0, $6zvdv.isNativeOn)(key) && (0, $6zvdv.isFunction)(value)) return true;
        return false;
    }
    if ((0, $6zvdv.shouldSetAsAttr)(el.tagName, key)) return false;
    if ((0, $6zvdv.isNativeOn)(key) && (0, $6zvdv.isString)(value)) return false;
    return key in el;
}
function $25ac20cbfb09c042$export$153823794abe328a(el, key) {
    var props = el._def.props;
    if (!props) return false;
    var camelKey = (0, $6zvdv.camelize)(key);
    return Array.isArray(props) ? props.some(function(prop) {
        return (0, $6zvdv.camelize)(prop) === camelKey;
    }) : Object.keys(props).some(function(prop) {
        return (0, $6zvdv.camelize)(prop) === camelKey;
    });
}
//#endregion
//#region packages/runtime-dom/src/apiCustomElement.ts
var $25ac20cbfb09c042$var$REMOVAL = {};
/*@__NO_SIDE_EFFECTS__*/ function $25ac20cbfb09c042$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    var Comp = (0, $fKAHx.defineComponent)(options, extraOptions);
    if ((0, $6zvdv.isPlainObject)(Comp)) Comp = (0, $6zvdv.extend)({}, Comp, extraOptions);
    var VueCustomElement = /*#__PURE__*/ function(VueElement) {
        "use strict";
        (0, $hdIku._)(VueCustomElement, VueElement);
        function VueCustomElement(initialProps) {
            (0, $173N4._)(this, VueCustomElement);
            return (0, $7qXGD._)(this, VueCustomElement, [
                Comp,
                initialProps,
                _createApp
            ]);
        }
        return VueCustomElement;
    }($25ac20cbfb09c042$export$b337c1a55163dbe3);
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
var $25ac20cbfb09c042$export$6debb2e68f212638 = function(options, extraOptions) {
    return /* @__PURE__ */ $25ac20cbfb09c042$export$a00e2346eabbdbef(options, extraOptions, $25ac20cbfb09c042$export$35800275c0037383);
};
var $25ac20cbfb09c042$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : function _class() {
    "use strict";
    (0, $173N4._)(this, _class);
};
var $25ac20cbfb09c042$export$8aeafd20e0fdd5f4 = /*#__PURE__*/ function(BaseClass) {
    "use strict";
    (0, $hdIku._)(VueElementBase, BaseClass);
    function VueElementBase(def) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, createAppFn = arguments.length > 2 ? arguments[2] : void 0;
        (0, $173N4._)(this, VueElementBase);
        var _this;
        _this = (0, $7qXGD._)(this, VueElementBase);
        _this._isVueCE = true;
        _this._instance = null;
        _this._app = null;
        _this._connected = false;
        _this._resolved = false;
        _this._numberProps = null;
        _this._styleChildren = /* @__PURE__ */ new WeakSet();
        _this._styleAnchors = /* @__PURE__ */ new WeakMap();
        _this._patching = false;
        _this._dirty = false;
        _this._ob = null;
        _this._def = def;
        _this._props = props;
        _this._createApp = createAppFn;
        _this._nonce = def.nonce;
        if (_this._needsHydration()) _this._root = _this.shadowRoot;
        else if (def.shadowRoot !== false) {
            _this.attachShadow((0, $6zvdv.extend)({}, def.shadowRootOptions, {
                mode: "open"
            }));
            _this._root = _this.shadowRoot;
        } else _this._root = _this;
        return _this;
    }
    (0, $cFHGC._)(VueElementBase, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                var _this = this;
                if (!this.isConnected) return;
                if (!this.shadowRoot && !this._resolved) this._parseSlots();
                this._connected = true;
                var parent = this;
                while(parent = parent && (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof VueElementBase) {
                    this._parent = parent;
                    break;
                }
                if (!this._instance) {
                    if (this._resolved) this._mountComponent(this._def);
                    else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(function() {
                        _this._pendingResolve = void 0;
                        if (_this.isConnected) return _this._resolveDef();
                    });
                    else this._resolveDef();
                }
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this = this;
                this._connected = false;
                (0, $fKAHx.nextTick)(function() {
                    if (!_this._connected) {
                        if (_this._ob) {
                            _this._ob.disconnect();
                            _this._ob = null;
                        }
                        _this._unmount();
                        if (_this._teleportTargets) {
                            _this._teleportTargets.clear();
                            _this._teleportTargets = void 0;
                        }
                    }
                });
            }
        },
        {
            key: "_setParent",
            value: function _setParent() {
                var parent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._parent;
                if (parent && this._instance) {
                    this._instance.parent = parent._instance;
                    this._inheritParentContext(parent);
                }
            }
        },
        {
            key: "_inheritParentContext",
            value: function _inheritParentContext() {
                var parent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._parent;
                if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
            }
        },
        {
            key: "_processMutations",
            value: function _processMutations(mutations) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var m = _step.value;
                        this._setAttr(m.attributeName);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
	* resolve inner component definition (handle possible async component)
	*/ key: "_resolveDef",
            value: function _resolveDef() {
                var _this = this;
                if (this._pendingResolve) return this._pendingResolve;
                for(var i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
                this._ob = new MutationObserver(this._processMutations.bind(this));
                this._ob.observe(this, {
                    attributes: true
                });
                var resolve = function(def) {
                    _this._resolved = true;
                    _this._pendingResolve = void 0;
                    var props = def.props, styles = def.styles;
                    var numberProps;
                    if (props && !(0, $6zvdv.isArray)(props)) for(var key in props){
                        var opt = props[key];
                        if (opt === Number || opt && opt.type === Number) {
                            if (key in _this._props) _this._props[key] = (0, $6zvdv.toNumber)(_this._props[key]);
                            (numberProps || (numberProps = Object.create(null)))[(0, $6zvdv.camelize)(key)] = true;
                        }
                    }
                    _this._numberProps = numberProps;
                    _this._resolveProps(def);
                    if (_this.shadowRoot) _this._applyStyles(styles);
                    _this._mountComponent(def);
                };
                var asyncDef = this._def.__asyncLoader;
                if (asyncDef) {
                    var configureApp = this._def.configureApp;
                    this._pendingResolve = asyncDef().then(function(def) {
                        def.configureApp = configureApp;
                        _this._def = def;
                        resolve(def);
                    });
                    return this._pendingResolve;
                } else resolve(this._def);
            }
        },
        {
            key: "_mountComponent",
            value: function _mountComponent(def) {
                this._mount(def);
                this._processExposed();
            }
        },
        {
            key: "_processExposed",
            value: function _processExposed() {
                var _this, _loop = function(key) {
                    if (!(0, $6zvdv.hasOwn)(_this, key)) Object.defineProperty(_this, key, {
                        get: function() {
                            return (0, $ftLbb.unref)(exposed[key]);
                        }
                    });
                };
                var exposed = this._instance && this._instance.exposed;
                if (!exposed) return;
                for(var key in exposed)_this = this, _loop(key);
            }
        },
        {
            key: "_processInstance",
            value: function _processInstance() {
                var _this = this;
                this._instance.ce = this;
                this._instance.isCE = true;
                var newStyles, s;
                var dispatch = function(event, args) {
                    _this.dispatchEvent(new CustomEvent(event, (0, $6zvdv.isPlainObject)(args[0]) ? (0, $6zvdv.extend)({
                        detail: args
                    }, args[0]) : {
                        detail: args
                    }));
                };
                this._instance.emit = function(event) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    dispatch(event, args);
                    if ((0, $6zvdv.hyphenate)(event) !== event) dispatch((0, $6zvdv.hyphenate)(event), args);
                };
                this._setParent();
            }
        },
        {
            key: "_resolveProps",
            value: function _resolveProps(def) {
                var props = def.props;
                var declaredPropKeys = (0, $6zvdv.isArray)(props) ? props : Object.keys(props || {});
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    var _this, _loop = function() {
                        var key = _step1.value;
                        Object.defineProperty(_this, key, {
                            get: function() {
                                return this._getProp(key);
                            },
                            set: function(val) {
                                this._setProp(key, val, true, !this._patching);
                            }
                        });
                    };
                    for(var _iterator1 = declaredPropKeys.map((0, $6zvdv.camelize))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_this = this, _loop();
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_setAttr",
            value: function _setAttr(key) {
                if (key.startsWith("data-v-")) return;
                var has = this.hasAttribute(key);
                var value = has ? this.getAttribute(key) : $25ac20cbfb09c042$var$REMOVAL;
                var camelKey = (0, $6zvdv.camelize)(key);
                if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $6zvdv.toNumber)(value);
                this._setProp(camelKey, value, false, true);
            }
        },
        {
            /**
	* @internal
	*/ key: "_getProp",
            value: function _getProp(key) {
                return this._props[key];
            }
        },
        {
            /**
	* @internal
	*/ key: "_setProp",
            value: function _setProp(key, val) {
                var shouldReflect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, shouldUpdate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                if (val !== this._props[key]) {
                    this._dirty = true;
                    if (val === $25ac20cbfb09c042$var$REMOVAL) delete this._props[key];
                    else {
                        this._props[key] = val;
                        if (key === "key" && this._app && this._app._ceVNode) this._app._ceVNode.key = val;
                    }
                    if (shouldUpdate && this._instance) this._update();
                    if (shouldReflect) {
                        var ob = this._ob;
                        if (ob) {
                            this._processMutations(ob.takeRecords());
                            ob.disconnect();
                        }
                        if (val === true) this.setAttribute((0, $6zvdv.hyphenate)(key), "");
                        else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $6zvdv.hyphenate)(key), val + "");
                        else if (!val) this.removeAttribute((0, $6zvdv.hyphenate)(key));
                        ob && ob.observe(this, {
                            attributes: true
                        });
                    }
                }
            }
        },
        {
            key: "_applyStyles",
            value: function _applyStyles(styles, owner, parentComp) {
                if (!styles) return;
                if (owner) {
                    if (owner === this._def || this._styleChildren.has(owner)) return;
                    this._styleChildren.add(owner);
                }
                var nonce = this._nonce;
                var root = this.shadowRoot;
                var insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
                var last = null;
                for(var i = styles.length - 1; i >= 0; i--){
                    var s = document.createElement("style");
                    if (nonce) s.setAttribute("nonce", nonce);
                    s.textContent = styles[i];
                    root.insertBefore(s, last || insertionAnchor);
                    last = s;
                    if (i === 0) {
                        if (!parentComp) this._styleAnchors.set(this._def, s);
                        if (owner) this._styleAnchors.set(owner, s);
                    }
                }
            }
        },
        {
            key: "_getStyleAnchor",
            value: function _getStyleAnchor(comp) {
                if (!comp) return null;
                var anchor = this._styleAnchors.get(comp);
                if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
                if (anchor) this._styleAnchors.delete(comp);
                return null;
            }
        },
        {
            key: "_getRootStyleInsertionAnchor",
            value: function _getRootStyleInsertionAnchor(root) {
                for(var i = 0; i < root.childNodes.length; i++){
                    var node = root.childNodes[i];
                    if (!(node instanceof HTMLStyleElement)) return node;
                }
                return null;
            }
        },
        {
            /**
	* Only called when shadowRoot is false
	*/ key: "_parseSlots",
            value: function _parseSlots() {
                var slots = this._slots = {};
                var n;
                while(n = this.firstChild){
                    var slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
                    (slots[slotName] || (slots[slotName] = [])).push(n);
                    this.removeChild(n);
                }
            }
        },
        {
            /**
	* Only called when shadowRoot is false
	*/ key: "_renderSlots",
            value: function _renderSlots() {
                var outlets = this._getSlots();
                var scopeId = this._instance.type.__scopeId;
                for(var i = 0; i < outlets.length; i++){
                    var o = outlets[i];
                    var slotName = o.getAttribute("name") || "default";
                    var content = this._slots[slotName];
                    var parent = o.parentNode;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (content) try {
                        for(var _iterator = content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var n = _step.value;
                            if (scopeId && n.nodeType === 1) {
                                var id = scopeId + "-s";
                                var walker = document.createTreeWalker(n, 1);
                                n.setAttribute(id, "");
                                var child = void 0;
                                while(child = walker.nextNode())child.setAttribute(id, "");
                            }
                            parent.insertBefore(n, o);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    else while(o.firstChild)parent.insertBefore(o.firstChild, o);
                    parent.removeChild(o);
                }
            }
        },
        {
            /**
	* @internal
	*/ key: "_getSlots",
            value: function _getSlots() {
                var _roots;
                var roots = [
                    this
                ];
                if (this._teleportTargets) (_roots = roots).push.apply(_roots, (0, $aUGqu._)(this._teleportTargets));
                var slots = /* @__PURE__ */ new Set();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = roots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var root = _step.value;
                        var found = root.querySelectorAll("slot");
                        for(var i = 0; i < found.length; i++)slots.add(found[i]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Array.from(slots);
            }
        },
        {
            /**
	* @internal
	*/ key: "_injectChildStyle",
            value: function _injectChildStyle(comp, parentComp) {
                this._applyStyles(comp.styles, comp, parentComp);
            }
        },
        {
            /**
	* @internal
	*/ key: "_beginPatch",
            value: function _beginPatch() {
                this._patching = true;
                this._dirty = false;
            }
        },
        {
            /**
	* @internal
	*/ key: "_endPatch",
            value: function _endPatch() {
                this._patching = false;
                if (this._dirty && this._instance) this._update();
            }
        },
        {
            /**
	* @internal
	*/ key: "_hasShadowRoot",
            value: function _hasShadowRoot() {
                return this._root !== this;
            }
        },
        {
            /**
	* @internal
	*/ key: "_removeChildStyle",
            value: function _removeChildStyle(comp) {
                var s;
            }
        }
    ]);
    return VueElementBase;
}($25ac20cbfb09c042$var$BaseClass);
var $25ac20cbfb09c042$export$b337c1a55163dbe3 = /*#__PURE__*/ function(VueElementBase) {
    "use strict";
    (0, $hdIku._)(VueElement, VueElementBase);
    function VueElement(def) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, createAppFn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $25ac20cbfb09c042$export$4e373c34abfa8c68;
        (0, $173N4._)(this, VueElement);
        return (0, $7qXGD._)(this, VueElement, [
            def,
            props,
            createAppFn
        ]);
    }
    (0, $cFHGC._)(VueElement, [
        {
            key: "_needsHydration",
            value: function _needsHydration() {
                if (this.shadowRoot && this._createApp !== $25ac20cbfb09c042$export$4e373c34abfa8c68) return true;
                return false;
            }
        },
        {
            key: "_mount",
            value: function _mount(def) {
                if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
                this._app = this._createApp(def);
                this._inheritParentContext();
                if (def.configureApp) def.configureApp(this._app);
                this._app._ceVNode = this._createVNode();
                this._app.mount(this._root);
            }
        },
        {
            key: "_update",
            value: function _update() {
                if (!this._app) return;
                var vnode = this._createVNode();
                vnode.appContext = this._app._context;
                $25ac20cbfb09c042$export$b3890eb0ae9dca99(vnode, this._root);
            }
        },
        {
            key: "_unmount",
            value: function _unmount() {
                if (this._app) this._app.unmount();
                if (this._instance && this._instance.ce) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        },
        {
            key: "_createVNode",
            value: function _createVNode() {
                var _this = this;
                var baseProps = {};
                if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
                var vnode = (0, $fKAHx.createVNode)(this._def, (0, $6zvdv.extend)(baseProps, this._props));
                if (!this._instance) vnode.ce = function(instance) {
                    _this._instance = instance;
                    _this._processInstance();
                };
                return vnode;
            }
        }
    ]);
    return VueElement;
}($25ac20cbfb09c042$export$8aeafd20e0fdd5f4);
function $25ac20cbfb09c042$export$da5acfe93a94e37d(caller) {
    var _useInstanceOption = (0, $fKAHx.useInstanceOption)("ce", true), hasInstance = _useInstanceOption.hasInstance, value = _useInstanceOption.value;
    var el = value;
    if (el) return el;
    else if (false) {
        if (!hasInstance) (0, $fKAHx.warn)("".concat(caller || "useHost", " called without an active component instance."));
        else (0, $fKAHx.warn)("".concat(caller || "useHost", " can only be used in components defined via defineCustomElement."));
    }
    return null;
}
/**
* Retrieve the shadowRoot of the current custom element. Only usable in setup()
* of a `defineCustomElement` component.
*/ function $25ac20cbfb09c042$export$64d45095031fa749() {
    var el = $25ac20cbfb09c042$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
//#endregion
//#region packages/runtime-dom/src/helpers/useCssModule.ts
function $25ac20cbfb09c042$export$9300d5b90d56e3d1() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$style";
    {
        var _useInstanceOption = (0, $fKAHx.useInstanceOption)("type", true), hasInstance = _useInstanceOption.hasInstance, type = _useInstanceOption.value;
        if (!hasInstance) return 0, $6zvdv.EMPTY_OBJ;
        var modules = type.__cssModules;
        if (!modules) return 0, $6zvdv.EMPTY_OBJ;
        var mod = modules[name];
        if (!mod) return 0, $6zvdv.EMPTY_OBJ;
        return mod;
    }
}
//#endregion
//#region packages/runtime-dom/src/components/TransitionGroup.ts
var $25ac20cbfb09c042$var$positionMap = /* @__PURE__ */ new WeakMap();
var $25ac20cbfb09c042$var$newPositionMap = /* @__PURE__ */ new WeakMap();
var $25ac20cbfb09c042$var$moveCbKey = Symbol("_moveCb");
var $25ac20cbfb09c042$var$enterCbKey = Symbol("_enterCb");
/**
* Wrap logic that modifies TransitionGroup properties in a function
* so that it can be annotated as pure
*/ var $25ac20cbfb09c042$var$decorate = function(t) {
    delete t.props.mode;
    return t;
};
var $25ac20cbfb09c042$export$19ffa8f511f7bc2e = /* @__PURE__ */ $25ac20cbfb09c042$var$decorate({
    name: "TransitionGroup",
    props: /*@__PURE__*/ (0, $6zvdv.extend)({}, $25ac20cbfb09c042$export$b899d57baa0167d5, {
        tag: String,
        moveClass: String
    }),
    setup: function(props, param) {
        var slots = param.slots;
        var instance = (0, $fKAHx.getCurrentInstance)();
        var state = (0, $fKAHx.useTransitionState)();
        var prevChildren;
        var children;
        (0, $fKAHx.onUpdated)(function() {
            if (!prevChildren.length) return;
            var moveClass = props.moveClass || "".concat(props.name || "v", "-move");
            if (!$25ac20cbfb09c042$export$6488e4a884389379(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach(function(vnode) {
                return $25ac20cbfb09c042$export$d5371ae309f51a37(vnode.el);
            });
            prevChildren.forEach($25ac20cbfb09c042$var$recordPosition);
            var movedChildren = prevChildren.filter($25ac20cbfb09c042$var$applyTranslation);
            $25ac20cbfb09c042$export$7d26bbb1236dafd6(instance.vnode.el);
            movedChildren.forEach(function(c) {
                var el = c.el;
                $25ac20cbfb09c042$export$bb551b8c48d28521(el, moveClass);
            });
            prevChildren = [];
        });
        return function() {
            var rawProps = (0, $ftLbb.toRaw)(props);
            var cssTransitionProps = $25ac20cbfb09c042$export$b349eeb6ed6a6d73(rawProps);
            var tag = rawProps.tag || (0, $fKAHx.Fragment);
            prevChildren = [];
            if (children) for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.el && child.el instanceof Element && !child.el[$25ac20cbfb09c042$export$9899690c5a6aa34e]) {
                    prevChildren.push(child);
                    (0, $fKAHx.setTransitionHooks)(child, (0, $fKAHx.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $25ac20cbfb09c042$var$positionMap.set(child, $25ac20cbfb09c042$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $fKAHx.getTransitionRawChildren)(slots.default()) : [];
            for(var i1 = 0; i1 < children.length; i1++){
                var child1 = children[i1];
                if (child1.key != null) (0, $fKAHx.setTransitionHooks)(child1, (0, $fKAHx.resolveTransitionHooks)(child1, cssTransitionProps, state, instance));
            }
            return (0, $fKAHx.createVNode)(tag, null, children);
        };
    }
});
function $25ac20cbfb09c042$export$d5371ae309f51a37(el) {
    if (el[$25ac20cbfb09c042$var$moveCbKey]) el[$25ac20cbfb09c042$var$moveCbKey]();
    if (el[$25ac20cbfb09c042$var$enterCbKey]) el[$25ac20cbfb09c042$var$enterCbKey]();
}
function $25ac20cbfb09c042$var$recordPosition(c) {
    $25ac20cbfb09c042$var$newPositionMap.set(c, $25ac20cbfb09c042$var$getPosition(c.el));
}
function $25ac20cbfb09c042$var$applyTranslation(c) {
    if ($25ac20cbfb09c042$export$61fb5edf31d9f0b8($25ac20cbfb09c042$var$positionMap.get(c), $25ac20cbfb09c042$var$newPositionMap.get(c), c.el)) return c;
}
function $25ac20cbfb09c042$export$61fb5edf31d9f0b8(oldPos, newPos, el) {
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        var s = el.style;
        var rect = el.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < .01) scaleX = 1;
        if (Math.abs(scaleY - 1) < .01) scaleY = 1;
        s.transform = s.webkitTransform = "translate(".concat(dx / scaleX, "px,").concat(dy / scaleY, "px)");
        s.transitionDuration = "0s";
        return true;
    }
    return false;
}
function $25ac20cbfb09c042$var$getPosition(el) {
    var rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $25ac20cbfb09c042$export$6488e4a884389379(el, root, moveClass) {
    var clone = el.cloneNode();
    var _vtc = el[$25ac20cbfb09c042$var$vtcKey];
    if (_vtc) _vtc.forEach(function(cls) {
        cls.split(/\s+/).forEach(function(c) {
            return c && clone.classList.remove(c);
        });
    });
    moveClass.split(/\s+/).forEach(function(c) {
        return c && clone.classList.add(c);
    });
    clone.style.display = "none";
    var container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    var hasTransform = $25ac20cbfb09c042$var$getTransitionInfo(clone).hasTransform;
    container.removeChild(clone);
    return hasTransform;
}
var $25ac20cbfb09c042$export$bb551b8c48d28521 = function(el, moveClass) {
    var style = el.style;
    $25ac20cbfb09c042$var$addTransitionClass(el, moveClass);
    style.transform = style.webkitTransform = style.transitionDuration = "";
    var cb = el[$25ac20cbfb09c042$var$moveCbKey] = function(e) {
        if (e && e.target !== el) return;
        if (!e || e.propertyName.endsWith("transform")) {
            el.removeEventListener("transitionend", cb);
            el[$25ac20cbfb09c042$var$moveCbKey] = null;
            $25ac20cbfb09c042$var$removeTransitionClass(el, moveClass);
        }
    };
    el.addEventListener("transitionend", cb);
};
//#endregion
//#region packages/runtime-dom/src/directives/vModel.ts
var $25ac20cbfb09c042$var$getModelAssigner = function(vnode) {
    var fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $6zvdv.isArray)(fn) ? function(value) {
        return (0, $6zvdv.invokeArrayFns)(fn, value);
    } : fn;
};
function $25ac20cbfb09c042$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $25ac20cbfb09c042$var$onCompositionEnd(e) {
    var target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
var $25ac20cbfb09c042$var$assignKey = Symbol("_assign");
var $25ac20cbfb09c042$var$initialValueKey = Symbol("_initialValue");
var $25ac20cbfb09c042$export$f1f88689f5728478 = {
    created: function(el, param, vnode) {
        var _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        if (el.parentNode) {
            if (el.type === "text") el[$25ac20cbfb09c042$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$25ac20cbfb09c042$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$25ac20cbfb09c042$var$assignKey] = $25ac20cbfb09c042$var$getModelAssigner(vnode);
        $25ac20cbfb09c042$export$2d3637690b27facf(el, trim, number || !!(vnode.props && vnode.props.type === "number"), lazy);
    },
    mounted: function(el, param) {
        var value = param.value, _param_modifiers = param.modifiers, trim = _param_modifiers.trim, number = _param_modifiers.number;
        var newValue = value == null ? "" : value;
        var initialValue = el[$25ac20cbfb09c042$var$initialValueKey];
        delete el[$25ac20cbfb09c042$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$25ac20cbfb09c042$var$assignKey]($25ac20cbfb09c042$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue, _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el[$25ac20cbfb09c042$var$assignKey] = $25ac20cbfb09c042$var$getModelAssigner(vnode);
        $25ac20cbfb09c042$export$b171fe2fda8d060a(el, oldValue, value, trim, number, lazy);
    }
};
function $25ac20cbfb09c042$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $6zvdv.looseToNumber)(value);
    return value;
}
/**
* @internal
*/ var $25ac20cbfb09c042$export$2d3637690b27facf = function(el, trim, number, lazy, set) {
    $25ac20cbfb09c042$var$addEventListener(el, lazy ? "change" : "input", function(e) {
        if (e.target.composing) return;
        (set || el[$25ac20cbfb09c042$var$assignKey])($25ac20cbfb09c042$var$castValue(el.value, trim, number || el.type === "number"));
    });
    if (trim || number) $25ac20cbfb09c042$var$addEventListener(el, "change", function() {
        el.value = $25ac20cbfb09c042$var$castValue(el.value, trim, number || el.type === "number");
    });
    if (!lazy) {
        $25ac20cbfb09c042$var$addEventListener(el, "compositionstart", $25ac20cbfb09c042$var$onCompositionStart);
        $25ac20cbfb09c042$var$addEventListener(el, "compositionend", $25ac20cbfb09c042$var$onCompositionEnd);
        $25ac20cbfb09c042$var$addEventListener(el, "change", $25ac20cbfb09c042$var$onCompositionEnd);
    }
};
/**
* @internal
*/ var $25ac20cbfb09c042$export$b171fe2fda8d060a = function(el, oldValue, value, trim, number, lazy) {
    if (el.composing) return;
    var elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $6zvdv.looseToNumber)(el.value) : el.value;
    var newValue = value == null ? "" : value;
    if (elValue === newValue) return;
    var rootNode = el.getRootNode();
    if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
        if (lazy && value === oldValue) return;
        if (trim && el.value.trim() === newValue) return;
    }
    el.value = newValue;
};
var $25ac20cbfb09c042$export$8847c2e532b35714 = {
    deep: true,
    created: function(el, _, vnode) {
        el[$25ac20cbfb09c042$var$assignKey] = $25ac20cbfb09c042$var$getModelAssigner(vnode);
        $25ac20cbfb09c042$export$10ad6c0b109fa494(el);
    },
    mounted: function(el, binding, vnode) {
        $25ac20cbfb09c042$export$bf72bd412424aea(el, binding.oldValue, binding.value, vnode.props.value);
    },
    beforeUpdate: function(el, binding, vnode) {
        el[$25ac20cbfb09c042$var$assignKey] = $25ac20cbfb09c042$var$getModelAssigner(vnode);
        $25ac20cbfb09c042$export$bf72bd412424aea(el, binding.oldValue, binding.value, vnode.props.value);
    }
};
/**
* @internal
*/ var $25ac20cbfb09c042$export$10ad6c0b109fa494 = function(el, set) {
    $25ac20cbfb09c042$var$addEventListener(el, "change", function() {
        var assign = set || el[$25ac20cbfb09c042$var$assignKey];
        var modelValue = el._modelValue;
        var elementValue = $25ac20cbfb09c042$export$882b439d816257fa(el);
        var checked = el.checked;
        if ((0, $6zvdv.isArray)(modelValue)) {
            var index = (0, $6zvdv.looseIndexOf)(modelValue, elementValue);
            var found = index !== -1;
            if (checked && !found) assign(modelValue.concat(elementValue));
            else if (!checked && found) {
                var filtered = (0, $aUGqu._)(modelValue);
                filtered.splice(index, 1);
                assign(filtered);
            }
        } else if ((0, $6zvdv.isSet)(modelValue)) {
            var cloned = new Set(modelValue);
            if (checked) cloned.add(elementValue);
            else cloned.delete(elementValue);
            assign(cloned);
        } else assign($25ac20cbfb09c042$var$getCheckboxValue(el, checked));
    });
};
/**
* @internal
*/ var $25ac20cbfb09c042$export$bf72bd412424aea = function(el, oldValue, value) {
    var rawValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $25ac20cbfb09c042$export$882b439d816257fa(el);
    el._modelValue = value;
    var checked;
    if ((0, $6zvdv.isArray)(value)) checked = (0, $6zvdv.looseIndexOf)(value, rawValue) > -1;
    else if ((0, $6zvdv.isSet)(value)) checked = value.has(rawValue);
    else {
        if (value === oldValue) return;
        checked = (0, $6zvdv.looseEqual)(value, $25ac20cbfb09c042$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
};
var $25ac20cbfb09c042$export$b4356c59b38b7aa9 = {
    created: function(el, param, vnode) {
        var value = param.value;
        el.checked = (0, $6zvdv.looseEqual)(value, vnode.props.value);
        el[$25ac20cbfb09c042$var$assignKey] = $25ac20cbfb09c042$var$getModelAssigner(vnode);
        $25ac20cbfb09c042$var$addEventListener(el, "change", function() {
            el[$25ac20cbfb09c042$var$assignKey]($25ac20cbfb09c042$export$882b439d816257fa(el));
        });
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue;
        el[$25ac20cbfb09c042$var$assignKey] = $25ac20cbfb09c042$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $6zvdv.looseEqual)(value, vnode.props.value);
    }
};
var $25ac20cbfb09c042$export$87d227567b51ca39 = {
    deep: true,
    created: function(el, param, vnode) {
        var value = param.value, number = param.modifiers.number;
        $25ac20cbfb09c042$export$6755e66381fe27bf(el, value, number);
        el[$25ac20cbfb09c042$var$assignKey] = $25ac20cbfb09c042$var$getModelAssigner(vnode);
    },
    mounted: function(el, param) {
        var value = param.value;
        $25ac20cbfb09c042$export$ff95a38066b55f02(el, value);
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value;
        el._modelValue = value;
        el[$25ac20cbfb09c042$var$assignKey] = $25ac20cbfb09c042$var$getModelAssigner(vnode);
    },
    updated: function(el, param) {
        var value = param.value;
        $25ac20cbfb09c042$export$ff95a38066b55f02(el, value);
    }
};
/**
* @internal
*/ var $25ac20cbfb09c042$export$6755e66381fe27bf = function(el, value, number, set) {
    el._modelValue = value;
    $25ac20cbfb09c042$var$addEventListener(el, "change", function() {
        var selectedVal = Array.prototype.filter.call(el.options, function(o) {
            return o.selected;
        }).map(function(o) {
            return number ? (0, $6zvdv.looseToNumber)($25ac20cbfb09c042$export$882b439d816257fa(o)) : $25ac20cbfb09c042$export$882b439d816257fa(o);
        });
        var multiple = el.multiple;
        var assignedValue = multiple ? (0, $6zvdv.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0];
        var pending = el._pendingValue = [
            multiple,
            multiple ? (0, $6zvdv.isArray)(assignedValue) ? selectedVal.slice() : selectedVal : assignedValue
        ];
        try {
            (set || el[$25ac20cbfb09c042$var$assignKey])(assignedValue);
        } finally{
            (0, $fKAHx.nextTick)(function() {
                if (el._pendingValue === pending) el._pendingValue = void 0;
            });
        }
    });
};
function $25ac20cbfb09c042$var$isSameSelectValue(value, assignedValue, multiple) {
    if (!multiple) return (0, $6zvdv.looseEqual)(value, assignedValue);
    if ((0, $6zvdv.isArray)(value)) return (0, $6zvdv.looseEqual)(value, assignedValue);
    if ((0, $6zvdv.isSet)(value)) {
        if (value.size !== assignedValue.length) return false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = assignedValue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (!value.has(item)) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return true;
    }
    return false;
}
/**
* @internal
*/ var $25ac20cbfb09c042$export$ff95a38066b55f02 = function(el, value) {
    el._modelValue = value;
    var pending = el._pendingValue;
    el._pendingValue = void 0;
    if (pending && pending[0] === el.multiple && $25ac20cbfb09c042$var$isSameSelectValue(value, pending[1], pending[0])) return;
    $25ac20cbfb09c042$var$setSelected(el, value);
};
function $25ac20cbfb09c042$var$setSelected(el, value) {
    var _loop = function(i, l) {
        var option = el.options[i];
        var optionValue = $25ac20cbfb09c042$export$882b439d816257fa(option);
        if (isMultiple) {
            if (isArrayValue) {
                var optionType = typeof optionValue === "undefined" ? "undefined" : (0, $7E0eS._)(optionValue);
                if (optionType === "string" || optionType === "number") option.selected = value.some(function(v) {
                    return String(v) === String(optionValue);
                });
                else option.selected = (0, $6zvdv.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $6zvdv.looseEqual)($25ac20cbfb09c042$export$882b439d816257fa(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return {
                v: void void 0
            };
        }
    };
    var isMultiple = el.multiple;
    var isArrayValue = (0, $6zvdv.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $6zvdv.isSet)(value)) return;
    for(var i = 0, l = el.options.length; i < l; i++){
        var _ret = _loop(i, l);
        if ((0, $7E0eS._)(_ret) === "object") return _ret.v;
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
/**
* @internal retrieve raw value set via :value bindings
*/ function $25ac20cbfb09c042$export$882b439d816257fa(el) {
    return "_value" in el ? el._value : el.value;
}
function $25ac20cbfb09c042$var$getCheckboxValue(el, checked) {
    var key = checked ? "_trueValue" : "_falseValue";
    if (key in el) return el[key];
    var attr = checked ? "true-value" : "false-value";
    if (el.hasAttribute(attr)) return el.getAttribute(attr);
    return checked;
}
var $25ac20cbfb09c042$export$5ad5c0e01ff62c5 = {
    created: function(el, binding, vnode) {
        $25ac20cbfb09c042$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted: function(el, binding, vnode) {
        $25ac20cbfb09c042$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate: function(el, binding, vnode, prevVNode) {
        $25ac20cbfb09c042$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated: function(el, binding, vnode, prevVNode) {
        $25ac20cbfb09c042$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $25ac20cbfb09c042$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $25ac20cbfb09c042$export$87d227567b51ca39;
        case "TEXTAREA":
            return $25ac20cbfb09c042$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $25ac20cbfb09c042$export$8847c2e532b35714;
                case "radio":
                    return $25ac20cbfb09c042$export$b4356c59b38b7aa9;
                default:
                    return $25ac20cbfb09c042$export$f1f88689f5728478;
            }
    }
}
function $25ac20cbfb09c042$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    var fn = $25ac20cbfb09c042$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type)[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $25ac20cbfb09c042$var$initVModelForSSR() {
    $25ac20cbfb09c042$export$f1f88689f5728478.getSSRProps = function(param) {
        var value = param.value;
        return {
            value: value
        };
    };
    $25ac20cbfb09c042$export$b4356c59b38b7aa9.getSSRProps = function(param, vnode) {
        var value = param.value;
        if (vnode.props && (0, $6zvdv.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $25ac20cbfb09c042$export$8847c2e532b35714.getSSRProps = function(param, vnode) {
        var value = param.value;
        if ((0, $6zvdv.isArray)(value)) {
            if (vnode.props && (0, $6zvdv.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $6zvdv.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $25ac20cbfb09c042$export$5ad5c0e01ff62c5.getSSRProps = function(binding, vnode) {
        if (typeof vnode.type !== "string") return;
        var modelToUse = $25ac20cbfb09c042$var$resolveDynamicModel(vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
//#endregion
//#region packages/runtime-dom/src/directives/vOn.ts
var $25ac20cbfb09c042$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
var $25ac20cbfb09c042$var$modifierGuards = {
    stop: function(e) {
        return e.stopPropagation();
    },
    prevent: function(e) {
        return e.preventDefault();
    },
    self: function(e) {
        return e.target !== e.currentTarget;
    },
    ctrl: function(e) {
        return !e.ctrlKey;
    },
    shift: function(e) {
        return !e.shiftKey;
    },
    alt: function(e) {
        return !e.altKey;
    },
    meta: function(e) {
        return !e.metaKey;
    },
    left: function(e) {
        return "button" in e && e.button !== 0;
    },
    middle: function(e) {
        return "button" in e && e.button !== 1;
    },
    right: function(e) {
        return "button" in e && e.button !== 2;
    },
    exact: function(e, modifiers) {
        return $25ac20cbfb09c042$var$systemModifiers.some(function(m) {
            return e["".concat(m, "Key")] && !modifiers.includes(m);
        });
    }
};
/**
* @private
*/ var $25ac20cbfb09c042$export$26bd3b8e29e6f273 = function(fn, modifiers) {
    if (!fn) return fn;
    var cache = fn._withMods || (fn._withMods = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        for(var i = 0; i < modifiers.length; i++){
            var guard = $25ac20cbfb09c042$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn.apply(void 0, [
            event
        ].concat((0, $aUGqu._)(args)));
    });
};
var $25ac20cbfb09c042$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
/**
* @private
*/ var $25ac20cbfb09c042$export$f691a8759658f782 = function(fn, modifiers) {
    var cache = fn._withKeys || (fn._withKeys = {});
    var cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = function(event) {
        if (!("key" in event)) return;
        var eventKey = (0, $6zvdv.hyphenate)(event.key);
        if (modifiers.some(function(k) {
            return k === eventKey || $25ac20cbfb09c042$var$keyNames[k] === eventKey;
        })) return fn(event);
    });
};
//#endregion
//#region packages/runtime-dom/src/index.ts
var $25ac20cbfb09c042$var$rendererOptions = /*@__PURE__*/ (0, $6zvdv.extend)({
    patchProp: $25ac20cbfb09c042$export$cd4aa0842d13df8b
}, $25ac20cbfb09c042$export$de4fb7f5030605d3);
var $25ac20cbfb09c042$var$renderer;
var $25ac20cbfb09c042$var$enabledHydration = false;
function $25ac20cbfb09c042$export$a0bae4d3eba7c8a0() {
    return $25ac20cbfb09c042$var$renderer || ($25ac20cbfb09c042$var$renderer = (0, $fKAHx.createRenderer)($25ac20cbfb09c042$var$rendererOptions));
}
function $25ac20cbfb09c042$export$70a3ed9a5d6c0c60() {
    $25ac20cbfb09c042$var$renderer = $25ac20cbfb09c042$var$enabledHydration ? $25ac20cbfb09c042$var$renderer : (0, $fKAHx.createHydrationRenderer)($25ac20cbfb09c042$var$rendererOptions);
    $25ac20cbfb09c042$var$enabledHydration = true;
    return $25ac20cbfb09c042$var$renderer;
}
var $25ac20cbfb09c042$export$b3890eb0ae9dca99 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    (_ensureRenderer = $25ac20cbfb09c042$export$a0bae4d3eba7c8a0()).render.apply(_ensureRenderer, (0, $aUGqu._)(args));
};
var $25ac20cbfb09c042$export$fa8d919ba61d84db = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    (_ensureHydrationRenderer = $25ac20cbfb09c042$export$70a3ed9a5d6c0c60()).hydrate.apply(_ensureHydrationRenderer, (0, $aUGqu._)(args));
};
var $25ac20cbfb09c042$export$4e373c34abfa8c68 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    var app = (_ensureRenderer = $25ac20cbfb09c042$export$a0bae4d3eba7c8a0()).createApp.apply(_ensureRenderer, (0, $aUGqu._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $25ac20cbfb09c042$export$fc6b59695d328a27(containerOrSelector);
        if (!container) return;
        var component = app._component;
        if (!(0, $6zvdv.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        var proxy = mount(container, false, $25ac20cbfb09c042$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
var $25ac20cbfb09c042$export$35800275c0037383 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    (0, $fKAHx.setIsHydratingEnabled)(true);
    var app = (_ensureHydrationRenderer = $25ac20cbfb09c042$export$70a3ed9a5d6c0c60()).createApp.apply(_ensureHydrationRenderer, (0, $aUGqu._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $25ac20cbfb09c042$export$fc6b59695d328a27(containerOrSelector);
        if (container) return mount(container, true, $25ac20cbfb09c042$var$resolveRootNamespace(container));
    };
    return app;
};
function $25ac20cbfb09c042$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $25ac20cbfb09c042$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: function(tag) {
            return (0, $6zvdv.isHTMLTag)(tag) || (0, $6zvdv.isSVGTag)(tag) || (0, $6zvdv.isMathMLTag)(tag);
        },
        writable: false
    });
}
function $25ac20cbfb09c042$var$injectCompilerOptionsCheck(app) {
    if ((0, $fKAHx.isRuntimeOnly)()) {
        var isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get: function() {
                return isCustomElement;
            },
            set: function() {
                (0, $fKAHx.warn)("The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.");
            }
        });
        var compilerOptions = app.config.compilerOptions;
        var msg = "The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka \"full build\"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader's `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc";
        Object.defineProperty(app.config, "compilerOptions", {
            get: function() {
                (0, $fKAHx.warn)(msg);
                return compilerOptions;
            },
            set: function() {
                (0, $fKAHx.warn)(msg);
            }
        });
    }
}
/**
* @internal
*/ function $25ac20cbfb09c042$export$fc6b59695d328a27(container) {
    if ((0, $6zvdv.isString)(container)) {
        var res = document.querySelector(container);
        return res;
    }
    return container;
}
var $25ac20cbfb09c042$var$ssrDirectiveInitialized = false;
/**
* @internal
*/ var $25ac20cbfb09c042$export$800b28255aa678d9 = function() {
    if (!$25ac20cbfb09c042$var$ssrDirectiveInitialized) {
        $25ac20cbfb09c042$var$ssrDirectiveInitialized = true;
        $25ac20cbfb09c042$var$initVModelForSSR();
        $25ac20cbfb09c042$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $fKAHx);

});
parcelRegister("fKAHx", function(module, exports) {

$parcel$export(module.exports, "pushWarningContext", function () { return $b7779ef94f774395$export$eff0ee073d211f48; });
$parcel$export(module.exports, "popWarningContext", function () { return $b7779ef94f774395$export$1f21d88a9fb0fa16; });
$parcel$export(module.exports, "isVNode", function () { return $b7779ef94f774395$export$3868d13f8734ae81; });
$parcel$export(module.exports, "callWithErrorHandling", function () { return $b7779ef94f774395$export$b22fcaf88446e9bf; });
$parcel$export(module.exports, "assertNumber", function () { return $b7779ef94f774395$export$dfbcecb440255e4a; });
$parcel$export(module.exports, "ErrorCodes", function () { return $b7779ef94f774395$export$10e8e1cf990558d7; });
$parcel$export(module.exports, "handleError", function () { return $b7779ef94f774395$export$d3da1ecaf1206c58; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $b7779ef94f774395$export$dae85862a8d94378; });
$parcel$export(module.exports, "SchedulerJobFlags", function () { return $b7779ef94f774395$export$fdec56fe4e195399; });
$parcel$export(module.exports, "nextTick", function () { return $b7779ef94f774395$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "queueJob", function () { return $b7779ef94f774395$export$fba1a0a20887772f; });
$parcel$export(module.exports, "queuePostFlushCb", function () { return $b7779ef94f774395$export$59536a0199721cab; });
$parcel$export(module.exports, "flushOnAppMount", function () { return $b7779ef94f774395$export$3ee27bfcb8f44b9d; });
$parcel$export(module.exports, "getComponentName", function () { return $b7779ef94f774395$export$26727cfcc4d7e0fc; });
$parcel$export(module.exports, "registerHMR", function () { return $b7779ef94f774395$export$2aad669127ef41b0; });
$parcel$export(module.exports, "unregisterHMR", function () { return $b7779ef94f774395$export$5f6a3eaf04e860b3; });
$parcel$export(module.exports, "Fragment", function () { return $b7779ef94f774395$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $b7779ef94f774395$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Comment", function () { return $b7779ef94f774395$export$4d299b491347818a; });
$parcel$export(module.exports, "Static", function () { return $b7779ef94f774395$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "devtoolsComponentAdded", function () { return $b7779ef94f774395$export$a76a9a73068a1a5e; });
$parcel$export(module.exports, "setCurrentRenderingInstance", function () { return $b7779ef94f774395$export$824c074beef4c41b; });
$parcel$export(module.exports, "pushScopeId", function () { return $b7779ef94f774395$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $b7779ef94f774395$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withScopeId", function () { return $b7779ef94f774395$export$15ba313e13f3dd04; });
$parcel$export(module.exports, "withCtx", function () { return $b7779ef94f774395$export$694b237e827a3d23; });
$parcel$export(module.exports, "setBlockTracking", function () { return $b7779ef94f774395$export$c20bee82f26f1e27; });
$parcel$export(module.exports, "withDirectives", function () { return $b7779ef94f774395$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "invokeDirectiveHook", function () { return $b7779ef94f774395$export$91e53aad4f01262; });
$parcel$export(module.exports, "provide", function () { return $b7779ef94f774395$export$abe1e183e22e10ad; });
$parcel$export(module.exports, "currentInstance", function () { return $b7779ef94f774395$export$5d0c78f02672825; });
$parcel$export(module.exports, "inject", function () { return $b7779ef94f774395$export$a976684a0efeb93f; });
$parcel$export(module.exports, "hasInjectionContext", function () { return $b7779ef94f774395$export$caf6761f24fc571a; });
$parcel$export(module.exports, "ssrContextKey", function () { return $b7779ef94f774395$export$f2549a27e18acf2d; });
$parcel$export(module.exports, "useSSRContext", function () { return $b7779ef94f774395$export$6b1c54dc4befcda; });
$parcel$export(module.exports, "watchEffect", function () { return $b7779ef94f774395$export$ede35fc0e5500309; });
$parcel$export(module.exports, "watchPostEffect", function () { return $b7779ef94f774395$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watchSyncEffect", function () { return $b7779ef94f774395$export$2035654f31b0e555; });
$parcel$export(module.exports, "watch", function () { return $b7779ef94f774395$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "queuePostRenderEffect", function () { return $b7779ef94f774395$export$51ec8e020844a97a; });
$parcel$export(module.exports, "setCurrentInstance", function () { return $b7779ef94f774395$export$a5e695a16aa0b6d4; });
$parcel$export(module.exports, "restoreCurrentInstance", function () { return $b7779ef94f774395$export$95e96a1fb881e3e7; });
$parcel$export(module.exports, "isTeleportDisabled", function () { return $b7779ef94f774395$export$44727b5035358778; });
$parcel$export(module.exports, "isTeleportDeferred", function () { return $b7779ef94f774395$export$6f4d6f0c8744b47f; });
$parcel$export(module.exports, "resolveTeleportTarget", function () { return $b7779ef94f774395$export$792b35e9a6a3f24c; });
$parcel$export(module.exports, "Teleport", function () { return $b7779ef94f774395$export$76d55a0304a371f4; });
$parcel$export(module.exports, "leaveCbKey", function () { return $b7779ef94f774395$export$6402c150d41fe6bc; });
$parcel$export(module.exports, "useTransitionState", function () { return $b7779ef94f774395$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $b7779ef94f774395$export$6d1641039221b5cb; });
$parcel$export(module.exports, "onBeforeUnmount", function () { return $b7779ef94f774395$export$40c420df62d2614; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $b7779ef94f774395$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $b7779ef94f774395$export$f13e630aa3915748; });
$parcel$export(module.exports, "resolveTransitionChild", function () { return $b7779ef94f774395$export$bacc260570b6d3ae; });
$parcel$export(module.exports, "checkTransitionMode", function () { return $b7779ef94f774395$export$f7697b49c3204928; });
$parcel$export(module.exports, "prepareTransitionSwitch", function () { return $b7779ef94f774395$export$aee04c50c0dfaf12; });
$parcel$export(module.exports, "BaseTransition", function () { return $b7779ef94f774395$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $b7779ef94f774395$export$76ac1779589cd824; });
$parcel$export(module.exports, "baseResolveTransitionHooks", function () { return $b7779ef94f774395$export$52bce14e5b84ba5b; });
$parcel$export(module.exports, "isKeepAlive", function () { return $b7779ef94f774395$export$a33216a979d8327a; });
$parcel$export(module.exports, "cloneVNode", function () { return $b7779ef94f774395$export$ee4f9e12c0a92a1a; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $b7779ef94f774395$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "createCommentVNode", function () { return $b7779ef94f774395$export$49553837c7236d3c; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $b7779ef94f774395$export$7770a22486565649; });
$parcel$export(module.exports, "prepareTransitionLeave", function () { return $b7779ef94f774395$export$750adf600c62558a; });
$parcel$export(module.exports, "defineComponent", function () { return $b7779ef94f774395$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "useId", function () { return $b7779ef94f774395$export$f680877a34711e37; });
$parcel$export(module.exports, "markAsyncBoundary", function () { return $b7779ef94f774395$export$b9b0eeb564431e5e; });
$parcel$export(module.exports, "knownTemplateRefs", function () { return $b7779ef94f774395$export$f55a8fa3b95033b5; });
$parcel$export(module.exports, "useTemplateRef", function () { return $b7779ef94f774395$export$83a5dbc1f35517ca; });
$parcel$export(module.exports, "isTemplateRefKey", function () { return $b7779ef94f774395$export$950f9ee44cd3c66; });
$parcel$export(module.exports, "setRef", function () { return $b7779ef94f774395$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "isAsyncWrapper", function () { return $b7779ef94f774395$export$4d0901d882427199; });
$parcel$export(module.exports, "createCanSetSetupRefChecker", function () { return $b7779ef94f774395$export$6082a4aa7ed81817; });
$parcel$export(module.exports, "isHydratingEnabled", function () { return $b7779ef94f774395$export$949522c94f173e7e; });
$parcel$export(module.exports, "setIsHydratingEnabled", function () { return $b7779ef94f774395$export$fb2190d8f9a1a092; });
$parcel$export(module.exports, "isHydrating", function () { return $b7779ef94f774395$export$454b4aa5c5ff33b6; });
$parcel$export(module.exports, "logMismatchError", function () { return $b7779ef94f774395$export$7c36cdbb1b0f1a71; });
$parcel$export(module.exports, "getContainerType", function () { return $b7779ef94f774395$export$acc6f3e19803b3dc; });
$parcel$export(module.exports, "isTemplateNode", function () { return $b7779ef94f774395$export$f125a8a2b402ed89; });
$parcel$export(module.exports, "VaporSlot", function () { return $b7779ef94f774395$export$c7c4a6890f1c1342; });
$parcel$export(module.exports, "createVNode", function () { return $b7779ef94f774395$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "createTextVNode", function () { return $b7779ef94f774395$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "isMismatchAllowed", function () { return $b7779ef94f774395$export$89e0dff13906bb59; });
$parcel$export(module.exports, "normalizeVNode", function () { return $b7779ef94f774395$export$a0e1465ad202d515; });
$parcel$export(module.exports, "isSetEqual", function () { return $b7779ef94f774395$export$a8d0d0c8d1c5df64; });
$parcel$export(module.exports, "toClassSet", function () { return $b7779ef94f774395$export$e64691051f3919e5; });
$parcel$export(module.exports, "toStyleMap", function () { return $b7779ef94f774395$export$10b092b355df2060; });
$parcel$export(module.exports, "isMapEqual", function () { return $b7779ef94f774395$export$71029b577818f2bb; });
$parcel$export(module.exports, "isValidHtmlOrSvgAttribute", function () { return $b7779ef94f774395$export$92c55cf0d3a086c0; });
$parcel$export(module.exports, "getAttributeMismatch", function () { return $b7779ef94f774395$export$1a5eb8a5128caad6; });
$parcel$export(module.exports, "warnPropMismatch", function () { return $b7779ef94f774395$export$c6d1c9a52f0379ae; });
$parcel$export(module.exports, "MismatchTypes", function () { return $b7779ef94f774395$export$92e7f8fbf145401a; });
$parcel$export(module.exports, "hydrateOnIdle", function () { return $b7779ef94f774395$export$8bfca283fd254627; });
$parcel$export(module.exports, "hydrateOnVisible", function () { return $b7779ef94f774395$export$2b04cd335e660930; });
$parcel$export(module.exports, "hydrateOnMediaQuery", function () { return $b7779ef94f774395$export$804dbb6002787b74; });
$parcel$export(module.exports, "hydrateOnInteraction", function () { return $b7779ef94f774395$export$288f5a9b4248e114; });
$parcel$export(module.exports, "defineAsyncComponent", function () { return $b7779ef94f774395$export$d75d499b4c16cf21; });
$parcel$export(module.exports, "createAsyncComponentContext", function () { return $b7779ef94f774395$export$1e8f866142774b37; });
$parcel$export(module.exports, "performAsyncHydrate", function () { return $b7779ef94f774395$export$49918ad629c39773; });
$parcel$export(module.exports, "useAsyncComponentState", function () { return $b7779ef94f774395$export$c7a65c52b748d650; });
$parcel$export(module.exports, "onUnmounted", function () { return $b7779ef94f774395$export$13348a43ccacfe58; });
$parcel$export(module.exports, "KeepAlive", function () { return $b7779ef94f774395$export$70eb8a58709972df; });
$parcel$export(module.exports, "activate", function () { return $b7779ef94f774395$export$234c45b355edd85b; });
$parcel$export(module.exports, "deactivate", function () { return $b7779ef94f774395$export$e96c1edfdaf2d1db; });
$parcel$export(module.exports, "resetShapeFlag", function () { return $b7779ef94f774395$export$e88525abd1b19421; });
$parcel$export(module.exports, "matches", function () { return $b7779ef94f774395$export$de994efd351b291c; });
$parcel$export(module.exports, "onUpdated", function () { return $b7779ef94f774395$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onActivated", function () { return $b7779ef94f774395$export$ba52d824b95a2154; });
$parcel$export(module.exports, "onDeactivated", function () { return $b7779ef94f774395$export$bf1440eeaf5fa709; });
$parcel$export(module.exports, "invalidateMount", function () { return $b7779ef94f774395$export$47f10f11906274f2; });
$parcel$export(module.exports, "onBeforeMount", function () { return $b7779ef94f774395$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "onBeforeUpdate", function () { return $b7779ef94f774395$export$ab91988a13872e4c; });
$parcel$export(module.exports, "onServerPrefetch", function () { return $b7779ef94f774395$export$ebf0c601f267bceb; });
$parcel$export(module.exports, "onRenderTriggered", function () { return $b7779ef94f774395$export$898295a813d662eb; });
$parcel$export(module.exports, "onRenderTracked", function () { return $b7779ef94f774395$export$2b41f4235363e921; });
$parcel$export(module.exports, "onErrorCaptured", function () { return $b7779ef94f774395$export$6a3a15856e50ad19; });
$parcel$export(module.exports, "resolveComponent", function () { return $b7779ef94f774395$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "NULL_DYNAMIC_COMPONENT", function () { return $b7779ef94f774395$export$7d1f90a35714b16e; });
$parcel$export(module.exports, "resolveDynamicComponent", function () { return $b7779ef94f774395$export$b44c564a05ca975; });
$parcel$export(module.exports, "resolveDirective", function () { return $b7779ef94f774395$export$a1989e995cd481be; });
$parcel$export(module.exports, "renderList", function () { return $b7779ef94f774395$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "createSlots", function () { return $b7779ef94f774395$export$85738f8fcd0a5430; });
$parcel$export(module.exports, "rawVaporSlotKey", function () { return $b7779ef94f774395$export$3ab367ca01a03fcc; });
$parcel$export(module.exports, "vdomSlotFallbackKey", function () { return $b7779ef94f774395$export$3d218eda79783141; });
$parcel$export(module.exports, "renderSlot", function () { return $b7779ef94f774395$export$4abee4c34694ada1; });
$parcel$export(module.exports, "openBlock", function () { return $b7779ef94f774395$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "createBlock", function () { return $b7779ef94f774395$export$9f2dfe8048dfb22b; });
$parcel$export(module.exports, "ensureValidVNode", function () { return $b7779ef94f774395$export$9fc41f261330971f; });
$parcel$export(module.exports, "ensureVaporSlotFallback", function () { return $b7779ef94f774395$export$48f2e51a96a1a702; });
$parcel$export(module.exports, "toHandlers", function () { return $b7779ef94f774395$export$2fb94ff667a6a1a; });
$parcel$export(module.exports, "defineProps", function () { return $b7779ef94f774395$export$80b33eababae110e; });
$parcel$export(module.exports, "defineEmits", function () { return $b7779ef94f774395$export$51ecece22fc17ddc; });
$parcel$export(module.exports, "defineExpose", function () { return $b7779ef94f774395$export$da25b65ca24b518a; });
$parcel$export(module.exports, "defineOptions", function () { return $b7779ef94f774395$export$77e79129327f3d0d; });
$parcel$export(module.exports, "defineSlots", function () { return $b7779ef94f774395$export$1b3acd4bb805b712; });
$parcel$export(module.exports, "defineModel", function () { return $b7779ef94f774395$export$acd55aa037e791bb; });
$parcel$export(module.exports, "withDefaults", function () { return $b7779ef94f774395$export$4df9c0969a9e0160; });
$parcel$export(module.exports, "useSlots", function () { return $b7779ef94f774395$export$9203a8e84125433c; });
$parcel$export(module.exports, "useAttrs", function () { return $b7779ef94f774395$export$75e29435042cd2ea; });
$parcel$export(module.exports, "mergeDefaults", function () { return $b7779ef94f774395$export$ec60f47d4a8a2e7f; });
$parcel$export(module.exports, "mergeModels", function () { return $b7779ef94f774395$export$ad4f724f587e6828; });
$parcel$export(module.exports, "createPropsRestProxy", function () { return $b7779ef94f774395$export$7c343e855c563faa; });
$parcel$export(module.exports, "withAsyncContext", function () { return $b7779ef94f774395$export$d6d6f7369f1fb104; });
$parcel$export(module.exports, "computed", function () { return $b7779ef94f774395$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "createAppAPI", function () { return $b7779ef94f774395$export$20a32069df128d70; });
$parcel$export(module.exports, "version", function () { return $b7779ef94f774395$export$83d89fbfd8236492; });
$parcel$export(module.exports, "useModel", function () { return $b7779ef94f774395$export$fb78bd113157f1a1; });
$parcel$export(module.exports, "defaultPropGetter", function () { return $b7779ef94f774395$export$ea66d7ac9b8996b6; });
$parcel$export(module.exports, "baseEmit", function () { return $b7779ef94f774395$export$15f4c4319e4e597d; });
$parcel$export(module.exports, "isEmitListener", function () { return $b7779ef94f774395$export$bd525f5264ebdc33; });
$parcel$export(module.exports, "getFunctionalFallthrough", function () { return $b7779ef94f774395$export$f83a77e4c783b3a2; });
$parcel$export(module.exports, "filterModelListeners", function () { return $b7779ef94f774395$export$316c7e1847985a1d; });
$parcel$export(module.exports, "warnExtraneousAttributes", function () { return $b7779ef94f774395$export$b82d7003bc568535; });
$parcel$export(module.exports, "isFunctionalFallthroughKey", function () { return $b7779ef94f774395$export$80ff18eb01272c8e; });
$parcel$export(module.exports, "shouldUpdateComponent", function () { return $b7779ef94f774395$export$225fd36bef19d8c6; });
$parcel$export(module.exports, "createInternalObject", function () { return $b7779ef94f774395$export$1fa0ca5a6375b7; });
$parcel$export(module.exports, "resolvePropValue", function () { return $b7779ef94f774395$export$ba06f8f07b4aa3a7; });
$parcel$export(module.exports, "baseNormalizePropsOptions", function () { return $b7779ef94f774395$export$f0eb979c68386821; });
$parcel$export(module.exports, "validateProps", function () { return $b7779ef94f774395$export$45855e0dd982478b; });
$parcel$export(module.exports, "startMeasure", function () { return $b7779ef94f774395$export$b62aa2130c86b59b; });
$parcel$export(module.exports, "endMeasure", function () { return $b7779ef94f774395$export$97a67d1a5c124236; });
$parcel$export(module.exports, "initFeatureFlags", function () { return $b7779ef94f774395$export$f9d0db67c92b2ab2; });
$parcel$export(module.exports, "MoveType", function () { return $b7779ef94f774395$export$be204faa7b4ee90a; });
$parcel$export(module.exports, "createRenderer", function () { return $b7779ef94f774395$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $b7779ef94f774395$export$200524cf0d997ff0; });
$parcel$export(module.exports, "performTransitionEnter", function () { return $b7779ef94f774395$export$b65fa8a64a2e2d16; });
$parcel$export(module.exports, "getInheritedScopeIds", function () { return $b7779ef94f774395$export$3390f5447109b373; });
$parcel$export(module.exports, "performTransitionLeave", function () { return $b7779ef94f774395$export$6a096a74cfa9e795; });
$parcel$export(module.exports, "Suspense", function () { return $b7779ef94f774395$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "createElementBlock", function () { return $b7779ef94f774395$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $b7779ef94f774395$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "transformVNodeArgs", function () { return $b7779ef94f774395$export$83beccd3afeeb809; });
$parcel$export(module.exports, "normalizeRef", function () { return $b7779ef94f774395$export$8e5958b67b6795b0; });
$parcel$export(module.exports, "guardReactiveProps", function () { return $b7779ef94f774395$export$1f1be0e0e384d7d2; });
$parcel$export(module.exports, "mergeProps", function () { return $b7779ef94f774395$export$9d1611c77c2fe928; });
$parcel$export(module.exports, "createStaticVNode", function () { return $b7779ef94f774395$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "simpleSetCurrentInstance", function () { return $b7779ef94f774395$export$a1b5a29a1999a394; });
$parcel$export(module.exports, "useInstanceOption", function () { return $b7779ef94f774395$export$f94b6c23bf914d02; });
$parcel$export(module.exports, "nextUid", function () { return $b7779ef94f774395$export$be5627916a199b29; });
$parcel$export(module.exports, "validateComponentName", function () { return $b7779ef94f774395$export$4fb1f2dc002bb2d3; });
$parcel$export(module.exports, "registerRuntimeCompiler", function () { return $b7779ef94f774395$export$667bb5a67822b941; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $b7779ef94f774395$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "expose", function () { return $b7779ef94f774395$export$9b7f6e342a8cbd38; });
$parcel$export(module.exports, "h", function () { return $b7779ef94f774395$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $b7779ef94f774395$export$aed4979be6a60047; });
$parcel$export(module.exports, "withMemo", function () { return $b7779ef94f774395$export$2a6d714a4d738ae; });
$parcel$export(module.exports, "isMemoSame", function () { return $b7779ef94f774395$export$bf525184d622787c; });
$parcel$export(module.exports, "warn", function () { return $b7779ef94f774395$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "ErrorTypeStrings", function () { return $b7779ef94f774395$export$795e0ad4a0e2ed30; });
$parcel$export(module.exports, "devtools", function () { return $b7779ef94f774395$export$6922d3b3a607469e; });
$parcel$export(module.exports, "setDevtoolsHook", function () { return $b7779ef94f774395$export$b0c258b32c26c785; });
$parcel$export(module.exports, "ssrUtils", function () { return $b7779ef94f774395$export$a9679033567b336d; });
$parcel$export(module.exports, "resolveFilter", function () { return $b7779ef94f774395$export$83cf26e06ea620e1; });
$parcel$export(module.exports, "compatUtils", function () { return $b7779ef94f774395$export$dc678eddf276286e; });
$parcel$export(module.exports, "DeprecationTypes", function () { return $b7779ef94f774395$export$22072a82865312f6; });
$parcel$export(module.exports, "EffectScope", function () { return (parcelRequire("ftLbb")).EffectScope; });
$parcel$export(module.exports, "ReactiveEffect", function () { return (parcelRequire("ftLbb")).ReactiveEffect; });
$parcel$export(module.exports, "TrackOpTypes", function () { return (parcelRequire("ftLbb")).TrackOpTypes; });
$parcel$export(module.exports, "TriggerOpTypes", function () { return (parcelRequire("ftLbb")).TriggerOpTypes; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("6zvdv")).camelize; });
$parcel$export(module.exports, "capitalize", function () { return (parcelRequire("6zvdv")).capitalize; });
$parcel$export(module.exports, "customRef", function () { return (parcelRequire("ftLbb")).customRef; });
$parcel$export(module.exports, "effect", function () { return (parcelRequire("ftLbb")).effect; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("ftLbb")).effectScope; });
$parcel$export(module.exports, "getCurrentScope", function () { return (parcelRequire("ftLbb")).getCurrentScope; });
$parcel$export(module.exports, "getCurrentWatcher", function () { return (parcelRequire("ftLbb")).getCurrentWatcher; });
$parcel$export(module.exports, "isProxy", function () { return (parcelRequire("ftLbb")).isProxy; });
$parcel$export(module.exports, "isReactive", function () { return (parcelRequire("ftLbb")).isReactive; });
$parcel$export(module.exports, "isReadonly", function () { return (parcelRequire("ftLbb")).isReadonly; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("ftLbb")).isRef; });
$parcel$export(module.exports, "isShallow", function () { return (parcelRequire("ftLbb")).isShallow; });
$parcel$export(module.exports, "markRaw", function () { return (parcelRequire("ftLbb")).markRaw; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("6zvdv")).normalizeClass; });
$parcel$export(module.exports, "normalizeProps", function () { return (parcelRequire("6zvdv")).normalizeProps; });
$parcel$export(module.exports, "normalizeStyle", function () { return (parcelRequire("6zvdv")).normalizeStyle; });
$parcel$export(module.exports, "onScopeDispose", function () { return (parcelRequire("ftLbb")).onScopeDispose; });
$parcel$export(module.exports, "onWatcherCleanup", function () { return (parcelRequire("ftLbb")).onWatcherCleanup; });
$parcel$export(module.exports, "proxyRefs", function () { return (parcelRequire("ftLbb")).proxyRefs; });
$parcel$export(module.exports, "reactive", function () { return (parcelRequire("ftLbb")).reactive; });
$parcel$export(module.exports, "readonly", function () { return (parcelRequire("ftLbb")).readonly; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("ftLbb")).ref; });
$parcel$export(module.exports, "shallowReactive", function () { return (parcelRequire("ftLbb")).shallowReactive; });
$parcel$export(module.exports, "shallowReadonly", function () { return (parcelRequire("ftLbb")).shallowReadonly; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("ftLbb")).shallowRef; });
$parcel$export(module.exports, "stop", function () { return (parcelRequire("ftLbb")).stop; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("6zvdv")).toDisplayString; });
$parcel$export(module.exports, "toHandlerKey", function () { return (parcelRequire("6zvdv")).toHandlerKey; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("ftLbb")).toRaw; });
$parcel$export(module.exports, "toRef", function () { return (parcelRequire("ftLbb")).toRef; });
$parcel$export(module.exports, "toRefs", function () { return (parcelRequire("ftLbb")).toRefs; });
$parcel$export(module.exports, "toValue", function () { return (parcelRequire("ftLbb")).toValue; });
$parcel$export(module.exports, "triggerRef", function () { return (parcelRequire("ftLbb")).triggerRef; });
$parcel$export(module.exports, "unref", function () { return (parcelRequire("ftLbb")).unref; });
/**
  * @vue/runtime-core v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $ftLbb = parcelRequire("ftLbb");

var $6zvdv = parcelRequire("6zvdv");
//#region packages/runtime-core/src/warning.ts
var $b7779ef94f774395$var$stack = [];
/**
* @internal
*/ function $b7779ef94f774395$export$eff0ee073d211f48(ctx) {
    $b7779ef94f774395$var$stack.push(ctx);
}
/**
* @internal
*/ function $b7779ef94f774395$export$1f21d88a9fb0fa16() {
    $b7779ef94f774395$var$stack.pop();
}
var $b7779ef94f774395$var$isWarning = false;
function $b7779ef94f774395$var$warn$1(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if ($b7779ef94f774395$var$isWarning) return;
    $b7779ef94f774395$var$isWarning = true;
    var prevSub = (0, $ftLbb.setActiveSub)();
    var entry = $b7779ef94f774395$var$stack.length ? $b7779ef94f774395$var$stack[$b7779ef94f774395$var$stack.length - 1] : null;
    var instance = $b7779ef94f774395$export$3868d13f8734ae81(entry) ? entry.component : entry;
    var appWarnHandler = instance && instance.appContext.config.warnHandler;
    var trace = $b7779ef94f774395$var$getComponentTrace();
    if (appWarnHandler) $b7779ef94f774395$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        msg + args.map(function(a) {
            var toString = a.toString;
            return toString == null ? JSON.stringify(a) : toString.call(a);
        }).join(""),
        instance && instance.proxy || instance,
        trace.map(function(param) {
            var ctx = param.ctx;
            return "at <".concat($b7779ef94f774395$var$formatComponentName(instance, ctx.type), ">");
        }).join("\n"),
        trace
    ]);
    else {
        var /* v8 ignore next 2 */ _warnArgs, _console;
        var warnArgs = [
            "[Vue warn]: ".concat(msg)
        ].concat((0, $aUGqu._)(args));
        if (trace.length && true) (_warnArgs = warnArgs).push.apply(_warnArgs, [
            "\n"
        ].concat((0, $aUGqu._)($b7779ef94f774395$var$formatTrace(trace))));
        (_console = console).warn.apply(_console, (0, $aUGqu._)(warnArgs));
    }
    (0, $ftLbb.setActiveSub)(prevSub);
    $b7779ef94f774395$var$isWarning = false;
}
function $b7779ef94f774395$var$getComponentTrace() {
    var currentCtx = $b7779ef94f774395$var$stack[$b7779ef94f774395$var$stack.length - 1];
    if (!currentCtx) return [];
    var normalizedStack = [];
    while(currentCtx){
        var last = normalizedStack[0];
        if (last && last.ctx === currentCtx) last.recurseCount++;
        else normalizedStack.push({
            ctx: currentCtx,
            recurseCount: 0
        });
        if ($b7779ef94f774395$export$3868d13f8734ae81(currentCtx)) {
            var parent = currentCtx.component && currentCtx.component.parent;
            currentCtx = parent && parent.vnode || parent;
        } else currentCtx = currentCtx.parent;
    }
    return normalizedStack;
}
/* v8 ignore start */ function $b7779ef94f774395$var$formatTrace(trace) {
    var logs = [];
    trace.forEach(function(entry, i) {
        var _logs;
        (_logs = logs).push.apply(_logs, (0, $aUGqu._)(i === 0 ? [] : [
            "\n"
        ]).concat((0, $aUGqu._)($b7779ef94f774395$var$formatTraceEntry(entry))));
    });
    return logs;
}
function $b7779ef94f774395$var$formatTraceEntry(param) {
    var ctx = param.ctx, recurseCount = param.recurseCount;
    var postfix = recurseCount > 0 ? "... (".concat(recurseCount, " recursive calls)") : "";
    var instance = $b7779ef94f774395$export$3868d13f8734ae81(ctx) ? ctx.component : ctx;
    var isRoot = instance ? instance.parent == null : false;
    var open = " at <".concat($b7779ef94f774395$var$formatComponentName(instance, ctx.type, isRoot));
    var close = ">" + postfix;
    return ctx.props ? [
        open
    ].concat((0, $aUGqu._)($b7779ef94f774395$var$formatProps(ctx.props)), [
        close
    ]) : [
        open + close
    ];
}
function $b7779ef94f774395$var$formatProps(props) {
    var res = [];
    var keys = Object.keys(props);
    keys.slice(0, 3).forEach(function(key) {
        var _res;
        (_res = res).push.apply(_res, (0, $aUGqu._)($b7779ef94f774395$var$formatProp(key, props[key])));
    });
    if (keys.length > 3) res.push(" ...");
    return res;
}
function $b7779ef94f774395$var$formatProp(key, value, raw) {
    if ((0, $6zvdv.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            "".concat(key, "=").concat(value)
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        "".concat(key, "=").concat(value)
    ];
    else if ((0, $ftLbb.isRef)(value)) {
        value = $b7779ef94f774395$var$formatProp(key, (0, $ftLbb.toRaw)(value.value), true);
        return raw ? value : [
            "".concat(key, "=Ref<"),
            value,
            ">"
        ];
    } else if ((0, $6zvdv.isFunction)(value)) return [
        "".concat(key, "=fn").concat(value.name ? "<".concat(value.name, ">") : "")
    ];
    else {
        value = (0, $ftLbb.toRaw)(value);
        return raw ? value : [
            "".concat(key, "="),
            value
        ];
    }
}
/**
* @internal
*/ function $b7779ef94f774395$export$dfbcecb440255e4a(val, type) {
    return;
}
/* v8 ignore stop */ //#endregion
//#region packages/runtime-core/src/errorHandling.ts
var $b7779ef94f774395$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
var $b7779ef94f774395$var$_obj;
var $b7779ef94f774395$var$ErrorTypeStrings$1 = ($b7779ef94f774395$var$_obj = {}, (0, $7Pjls._)($b7779ef94f774395$var$_obj, "sp", "serverPrefetch hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "bc", "beforeCreate hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "c", "created hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "bm", "beforeMount hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "m", "mounted hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "bu", "beforeUpdate hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "u", "updated"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "bum", "beforeUnmount hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "um", "unmounted hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "a", "activated hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "da", "deactivated hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "ec", "errorCaptured hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "rtc", "renderTracked hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, "rtg", "renderTriggered hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 0, "setup function"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 1, "render function"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 2, "watcher getter"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 3, "watcher callback"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 4, "watcher cleanup function"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 5, "native event handler"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 6, "component event handler"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 7, "vnode hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 8, "directive hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 9, "transition hook"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 10, "app errorHandler"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 11, "app warnHandler"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 12, "ref function"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 13, "async component loader"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 14, "scheduler flush"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 15, "component update"), (0, $7Pjls._)($b7779ef94f774395$var$_obj, 16, "app unmount cleanup function"), $b7779ef94f774395$var$_obj);
function $b7779ef94f774395$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn.apply(void 0, (0, $aUGqu._)(args)) : fn();
    } catch (err) {
        $b7779ef94f774395$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $b7779ef94f774395$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $6zvdv.isFunction)(fn)) {
        var res = $b7779ef94f774395$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $6zvdv.isPromise)(res)) res.catch(function(err) {
            $b7779ef94f774395$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $6zvdv.isArray)(fn)) {
        var values = [];
        for(var i = 0; i < fn.length; i++)values.push($b7779ef94f774395$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $b7779ef94f774395$export$d3da1ecaf1206c58(err, instance, type) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var _ref = instance && instance.appContext.config || (0, $6zvdv.EMPTY_OBJ), errorHandler = _ref.errorHandler, throwUnhandledErrorInProduction = _ref.throwUnhandledErrorInProduction;
    if (instance) {
        var cur = instance.parent;
        var exposedInstance = instance.proxy || instance;
        var errorInfo = "https://vuejs.org/error-reference/#runtime-".concat(type);
        while(cur){
            var errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) {
                for(var i = 0; i < errorCapturedHooks.length; i++)if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            var prevSub = (0, $ftLbb.setActiveSub)();
            $b7779ef94f774395$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $ftLbb.setActiveSub)(prevSub);
            return;
        }
    }
    $b7779ef94f774395$var$logError(err, type, instance, throwInDev, throwUnhandledErrorInProduction);
}
function $b7779ef94f774395$var$logError(err, type, instance) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, throwInProd = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (throwInProd) throw err;
    else console.error(err);
}
//#endregion
//#region packages/runtime-core/src/scheduler.ts
var $b7779ef94f774395$export$fdec56fe4e195399 = {
    "QUEUED": 1,
    "1": "QUEUED",
    "ALLOW_RECURSE": 2,
    "2": "ALLOW_RECURSE",
    "DISPOSED": 4,
    "4": "DISPOSED",
    "REQUEUE_ON_SUSPENSE_DISCARD": 8,
    "8": "REQUEUE_ON_SUSPENSE_DISCARD"
};
var $b7779ef94f774395$var$jobs = [];
var $b7779ef94f774395$var$postJobs = [];
var $b7779ef94f774395$var$activePostJobs = null;
var $b7779ef94f774395$var$currentFlushPromise = null;
var $b7779ef94f774395$var$jobsLength = 0;
var $b7779ef94f774395$var$flushIndex = 0;
var $b7779ef94f774395$var$postFlushIndex = 0;
var $b7779ef94f774395$var$resolvedPromise = /*@__PURE__*/ Promise.resolve();
var $b7779ef94f774395$var$RECURSION_LIMIT = 100;
function $b7779ef94f774395$export$bdd553fddd433dcb(fn) {
    var p = $b7779ef94f774395$var$currentFlushPromise || $b7779ef94f774395$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $b7779ef94f774395$var$findInsertionIndex(order, queue, start, end) {
    while(start < end){
        var middle = start + end >>> 1;
        if (queue[middle].order <= order) start = middle + 1;
        else end = middle;
    }
    return start;
}
/**
* @internal for runtime-vapor only
*/ function $b7779ef94f774395$export$fba1a0a20887772f(job, id) {
    var isPre = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, order = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if ($b7779ef94f774395$var$queueJobWorker(job, id === void 0 ? isPre ? -2 : Infinity : isPre ? id * 2 : order ? id * 2 + 1 + order / (order + 1) : id * 2 + 1, $b7779ef94f774395$var$jobs, $b7779ef94f774395$var$jobsLength, $b7779ef94f774395$var$flushIndex)) {
        $b7779ef94f774395$var$jobsLength++;
        $b7779ef94f774395$var$queueFlush();
    }
}
function $b7779ef94f774395$var$queueJobWorker(job, order, queue, length, flushIndex) {
    var flags = job.flags;
    if (!(flags & 1)) {
        job.flags = flags | 1;
        job.order = order;
        if (flushIndex === length || order >= queue[length - 1].order) queue[length] = job;
        else queue.splice($b7779ef94f774395$var$findInsertionIndex(order, queue, flushIndex, length), 0, job);
        return true;
    }
    return false;
}
var $b7779ef94f774395$var$doFlushJobs = function() {
    try {
        $b7779ef94f774395$var$flushJobs();
    } catch (e) {
        $b7779ef94f774395$var$currentFlushPromise = null;
        if ($b7779ef94f774395$var$jobsLength || $b7779ef94f774395$var$postJobs.length) $b7779ef94f774395$var$queueFlush();
        throw e;
    }
};
function $b7779ef94f774395$var$queueFlush() {
    if (!$b7779ef94f774395$var$currentFlushPromise) $b7779ef94f774395$var$currentFlushPromise = $b7779ef94f774395$var$resolvedPromise.then($b7779ef94f774395$var$doFlushJobs);
}
function $b7779ef94f774395$export$59536a0199721cab(jobs) {
    var id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Infinity;
    if (!(0, $6zvdv.isArray)(jobs)) {
        if ($b7779ef94f774395$var$activePostJobs && id === -1) $b7779ef94f774395$var$activePostJobs.splice($b7779ef94f774395$var$postFlushIndex, 0, jobs);
        else $b7779ef94f774395$var$queueJobWorker(jobs, id, $b7779ef94f774395$var$postJobs, $b7779ef94f774395$var$postJobs.length, 0);
    } else for(var i = 0; i < jobs.length; i++)$b7779ef94f774395$var$queueJobWorker(jobs[i], id, $b7779ef94f774395$var$postJobs, $b7779ef94f774395$var$postJobs.length, 0);
    $b7779ef94f774395$var$queueFlush();
}
function $b7779ef94f774395$var$flushPreFlushCbs(instance, seen) {
    for(var i = $b7779ef94f774395$var$flushIndex; i < $b7779ef94f774395$var$jobsLength; i++){
        var cb = $b7779ef94f774395$var$jobs[i];
        if (cb.order & 1 || cb.order === Infinity) continue;
        if (instance && cb.order !== instance.uid * 2) continue;
        $b7779ef94f774395$var$jobs.splice(i, 1);
        i--;
        $b7779ef94f774395$var$jobsLength--;
        if (cb.flags & 2) cb.flags &= -2;
        try {
            cb();
        } finally{
            if (!(cb.flags & 2)) cb.flags &= -2;
        }
    }
}
function $b7779ef94f774395$var$flushPostFlushCbs(seen) {
    if ($b7779ef94f774395$var$postJobs.length) {
        if ($b7779ef94f774395$var$activePostJobs) {
            for(var i = 0; i < $b7779ef94f774395$var$postJobs.length; i++)$b7779ef94f774395$var$activePostJobs.push($b7779ef94f774395$var$postJobs[i]);
            $b7779ef94f774395$var$postJobs.length = 0;
            return;
        }
        $b7779ef94f774395$var$activePostJobs = $b7779ef94f774395$var$postJobs;
        $b7779ef94f774395$var$postJobs = [];
        try {
            while($b7779ef94f774395$var$postFlushIndex < $b7779ef94f774395$var$activePostJobs.length){
                var cb = $b7779ef94f774395$var$activePostJobs[$b7779ef94f774395$var$postFlushIndex++];
                if (cb.flags & 2) cb.flags &= -2;
                if (!(cb.flags & 4)) try {
                    cb();
                } finally{
                    if (!(cb.flags & 2)) cb.flags &= -2;
                }
            }
        } finally{
            while($b7779ef94f774395$var$postFlushIndex < $b7779ef94f774395$var$activePostJobs.length)$b7779ef94f774395$var$activePostJobs[$b7779ef94f774395$var$postFlushIndex++].flags &= -2;
            $b7779ef94f774395$var$activePostJobs = null;
            $b7779ef94f774395$var$postFlushIndex = 0;
        }
    }
}
var $b7779ef94f774395$var$isFlushing = false;
/**
* @internal
*/ function $b7779ef94f774395$export$3ee27bfcb8f44b9d(instance) {
    if (!$b7779ef94f774395$var$isFlushing) {
        $b7779ef94f774395$var$isFlushing = true;
        try {
            $b7779ef94f774395$var$flushPreFlushCbs(instance);
            $b7779ef94f774395$var$flushPostFlushCbs();
        } finally{
            $b7779ef94f774395$var$isFlushing = false;
        }
    }
}
function $b7779ef94f774395$var$flushJobs(seen) {
    try {
        while($b7779ef94f774395$var$flushIndex < $b7779ef94f774395$var$jobsLength){
            var job = $b7779ef94f774395$var$jobs[$b7779ef94f774395$var$flushIndex];
            $b7779ef94f774395$var$jobs[$b7779ef94f774395$var$flushIndex++] = void 0;
            if (!(job.flags & 4)) {
                if (job.flags & 2) job.flags &= -2;
                try {
                    job();
                } catch (err) {
                    $b7779ef94f774395$export$d3da1ecaf1206c58(err, job.i, job.i ? 15 : 14);
                } finally{
                    if (!(job.flags & 2)) job.flags &= -2;
                }
            }
        }
    } finally{
        while($b7779ef94f774395$var$flushIndex < $b7779ef94f774395$var$jobsLength){
            $b7779ef94f774395$var$jobs[$b7779ef94f774395$var$flushIndex].flags &= -2;
            $b7779ef94f774395$var$jobs[$b7779ef94f774395$var$flushIndex++] = void 0;
        }
        $b7779ef94f774395$var$flushIndex = 0;
        $b7779ef94f774395$var$jobsLength = 0;
        $b7779ef94f774395$var$jobs.length = 0;
        $b7779ef94f774395$var$flushPostFlushCbs(seen);
        if ($b7779ef94f774395$var$jobsLength || $b7779ef94f774395$var$postJobs.length) $b7779ef94f774395$var$flushJobs(seen);
        else $b7779ef94f774395$var$currentFlushPromise = null;
    }
}
function $b7779ef94f774395$var$checkRecursiveUpdates(seen, fn) {
    var count = seen.get(fn) || 0;
    if (count > $b7779ef94f774395$var$RECURSION_LIMIT) {
        var instance = fn.i;
        var componentName = instance && $b7779ef94f774395$export$26727cfcc4d7e0fc(instance.type);
        $b7779ef94f774395$export$d3da1ecaf1206c58("Maximum recursive updates exceeded".concat(componentName ? " in component <".concat(componentName, ">") : "", ". This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function."), null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
//#endregion
//#region packages/runtime-core/src/hmr.ts
var $b7779ef94f774395$var$isHmrUpdating = false;
var $b7779ef94f774395$var$setHmrUpdating = function(v1) {
    try {
        return $b7779ef94f774395$var$isHmrUpdating;
    } finally{
        $b7779ef94f774395$var$isHmrUpdating = v1;
    }
};
var $b7779ef94f774395$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
var $b7779ef94f774395$var$hmrDirtyComponentsMode = /* @__PURE__ */ new Map();
function $b7779ef94f774395$var$runWithHmrUpdating(fn) {
    $b7779ef94f774395$var$isHmrUpdating = true;
    var done = false;
    try {
        fn();
        done = true;
    } finally{
        if (done) $b7779ef94f774395$export$bdd553fddd433dcb(function() {
            $b7779ef94f774395$var$isHmrUpdating = false;
        });
        else $b7779ef94f774395$var$isHmrUpdating = false;
    }
}
var $b7779ef94f774395$var$map = /* @__PURE__ */ new Map();
function $b7779ef94f774395$export$2aad669127ef41b0(instance) {
    var id = instance.type.__hmrId;
    var record = $b7779ef94f774395$var$map.get(id);
    if (!record) {
        $b7779ef94f774395$var$createRecord(id, instance.type);
        record = $b7779ef94f774395$var$map.get(id);
    }
    record.instances.add(instance);
}
function $b7779ef94f774395$export$5f6a3eaf04e860b3(instance) {
    $b7779ef94f774395$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $b7779ef94f774395$var$createRecord(id, initialDef) {
    if ($b7779ef94f774395$var$map.has(id)) return false;
    $b7779ef94f774395$var$map.set(id, {
        initialDef: $b7779ef94f774395$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $b7779ef94f774395$var$normalizeClassComponent(component) {
    return $b7779ef94f774395$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $b7779ef94f774395$var$hasDirtyAncestor(instance, dirtyInstances) {
    var parent = instance.parent;
    while(parent){
        if (dirtyInstances.has(parent)) return true;
        parent = parent.parent;
    }
    return false;
}
function $b7779ef94f774395$var$rerender(id, newRender) {
    var record = $b7779ef94f774395$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    (0, $aUGqu._)(record.instances).forEach(function(instance) {
        if (newRender) {
            instance.render = newRender;
            $b7779ef94f774395$var$normalizeClassComponent(instance.type).render = newRender;
        }
        $b7779ef94f774395$var$runWithHmrUpdating(function() {
            if (instance.vapor) {
                if (!instance.isUnmounted) instance.hmrRerender();
            } else {
                var i = instance;
                if (!(i.effect.flags & 1024)) {
                    i.renderCache = [];
                    i.effect.run();
                }
            }
        });
    });
}
function $b7779ef94f774395$var$reload(id, newComp) {
    var record = $b7779ef94f774395$var$map.get(id);
    if (!record) return;
    newComp = $b7779ef94f774395$var$normalizeClassComponent(newComp);
    var isVapor = record.initialDef.__vapor;
    $b7779ef94f774395$var$updateComponentDef(record.initialDef, newComp);
    var instances = (0, $aUGqu._)(record.instances);
    if (isVapor && newComp.__vapor && !instances.some(function(instance) {
        return instance.parent && !instance.parent.vapor;
    }) && !instances.some(function(i) {
        return i.ceReload;
    })) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var instance = _step.value;
                if (instance.root && instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(instance.type);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var dirtyInstances = new Set(instances);
        var rerenderedParents = /* @__PURE__ */ new Set();
        $b7779ef94f774395$var$runWithHmrUpdating(function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var instance = _step.value;
                    var parent = instance.parent;
                    if (parent) {
                        if (!$b7779ef94f774395$var$hasDirtyAncestor(instance, dirtyInstances) && !rerenderedParents.has(parent)) {
                            rerenderedParents.add(parent);
                            parent.hmrRerender();
                        }
                    } else instance.hmrReload(newComp);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    } else {
        var parentUpdates = /* @__PURE__ */ new Map();
        var dirtyInstanceSet = new Set(instances);
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = instances[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var instance1 = _step1.value;
                var oldComp = $b7779ef94f774395$var$normalizeClassComponent(instance1.type);
                var dirtyInstances1 = $b7779ef94f774395$var$hmrDirtyComponents.get(oldComp);
                if (!dirtyInstances1) {
                    if (oldComp !== record.initialDef) $b7779ef94f774395$var$updateComponentDef(oldComp, newComp);
                    $b7779ef94f774395$var$hmrDirtyComponents.set(oldComp, dirtyInstances1 = /* @__PURE__ */ new Set());
                }
                dirtyInstances1.add(instance1);
                $b7779ef94f774395$var$hmrDirtyComponentsMode.set(oldComp, !!isVapor);
                instance1.appContext.propsCache.delete(instance1.type);
                instance1.appContext.emitsCache.delete(instance1.type);
                instance1.appContext.optionsCache.delete(instance1.type);
                if (instance1.ceReload) {
                    dirtyInstances1.add(instance1);
                    instance1.ceReload(newComp.styles);
                    dirtyInstances1.delete(instance1);
                } else if (instance1.parent) {
                    var parent = instance1.parent;
                    if (!$b7779ef94f774395$var$hasDirtyAncestor(instance1, dirtyInstanceSet)) {
                        var updates = parentUpdates.get(parent);
                        if (!updates) parentUpdates.set(parent, updates = []);
                        updates.push([
                            instance1,
                            dirtyInstances1
                        ]);
                    }
                } else if (instance1.appContext.reload) instance1.appContext.reload();
                else if (typeof window !== "undefined") window.location.reload();
                else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
                if (instance1.root.ce && instance1 !== instance1.root) instance1.root.ce._removeChildStyle(oldComp);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        parentUpdates.forEach(function(updates, parent) {
            $b7779ef94f774395$export$fba1a0a20887772f(function() {
                try {
                    $b7779ef94f774395$var$runWithHmrUpdating(function() {
                        if (parent.vapor) parent.hmrRerender();
                        else {
                            var i = parent;
                            if (!(i.effect.flags & 1024)) {
                                i.renderCache = [];
                                i.effect.run();
                            }
                        }
                    });
                } finally{
                    updates.forEach(function(param) {
                        var _param = (0, $f9AOD._)(param, 2), instance = _param[0], dirtyInstances = _param[1];
                        dirtyInstances.delete(instance);
                    });
                }
            });
        });
    }
    $b7779ef94f774395$export$59536a0199721cab(function() {
        $b7779ef94f774395$var$hmrDirtyComponents.clear();
        $b7779ef94f774395$var$hmrDirtyComponentsMode.clear();
    });
}
function $b7779ef94f774395$var$updateComponentDef(oldComp, newComp) {
    (0, $6zvdv.extend)(oldComp, newComp);
    for(var key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $b7779ef94f774395$var$tryWrap(fn) {
    return function(id, arg) {
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
        }
    };
}
//#endregion
//#region packages/runtime-core/src/devtools.ts
var $b7779ef94f774395$var$devtools$1;
var $b7779ef94f774395$var$buffer = [];
var $b7779ef94f774395$var$devtoolsNotInstalled = false;
function $b7779ef94f774395$var$emit$1(event) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _devtools$1;
    if ($b7779ef94f774395$var$devtools$1) (_devtools$1 = $b7779ef94f774395$var$devtools$1).emit.apply(_devtools$1, [
        event
    ].concat((0, $aUGqu._)(args)));
    else if (!$b7779ef94f774395$var$devtoolsNotInstalled) $b7779ef94f774395$var$buffer.push({
        event: event,
        args: args
    });
}
function $b7779ef94f774395$var$setDevtoolsHook$1(hook, target) {
    var _window$navigator;
    $b7779ef94f774395$var$devtools$1 = hook;
    if ($b7779ef94f774395$var$devtools$1) {
        var _devtools$1;
        $b7779ef94f774395$var$devtools$1.enabled = true;
        $b7779ef94f774395$var$buffer.forEach(function(param) {
            var event = param.event, args = param.args;
            return (_devtools$1 = $b7779ef94f774395$var$devtools$1).emit.apply(_devtools$1, [
                event
            ].concat((0, $aUGqu._)(args)));
        });
        $b7779ef94f774395$var$buffer = [];
    } else if (typeof window !== "undefined" && window.HTMLElement && !((_window$navigator = window.navigator) === null || _window$navigator === void 0 || (_window$navigator = _window$navigator.userAgent) === null || _window$navigator === void 0 ? void 0 : _window$navigator.includes("jsdom"))) {
        (target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push(function(newHook) {
            $b7779ef94f774395$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(function() {
            if (!$b7779ef94f774395$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $b7779ef94f774395$var$devtoolsNotInstalled = true;
                $b7779ef94f774395$var$buffer = [];
            }
        }, 3e3);
    } else {
        $b7779ef94f774395$var$devtoolsNotInstalled = true;
        $b7779ef94f774395$var$buffer = [];
    }
}
function $b7779ef94f774395$var$devtoolsInitApp(app, version) {
    $b7779ef94f774395$var$emit$1("app:init", app, version, {
        Fragment: $b7779ef94f774395$export$ffb0004e005737fa,
        Text: $b7779ef94f774395$export$5f1af8db9871e1d6,
        Comment: $b7779ef94f774395$export$4d299b491347818a,
        Static: $b7779ef94f774395$export$c1b9a1d3af45b7b6
    });
}
function $b7779ef94f774395$var$devtoolsUnmountApp(app) {
    $b7779ef94f774395$var$emit$1("app:unmount", app);
}
var $b7779ef94f774395$export$a76a9a73068a1a5e = /*@__PURE__*/ $b7779ef94f774395$var$createDevtoolsComponentHook("component:added");
var $b7779ef94f774395$var$devtoolsComponentUpdated = /*@__PURE__*/ $b7779ef94f774395$var$createDevtoolsComponentHook("component:updated");
var $b7779ef94f774395$var$_devtoolsComponentRemoved = /*@__PURE__*/ $b7779ef94f774395$var$createDevtoolsComponentHook("component:removed");
var $b7779ef94f774395$var$devtoolsComponentRemoved = function(component) {
    if ($b7779ef94f774395$var$devtools$1 && typeof $b7779ef94f774395$var$devtools$1.cleanupBuffer === "function" && !$b7779ef94f774395$var$devtools$1.cleanupBuffer(component)) $b7779ef94f774395$var$_devtoolsComponentRemoved(component);
};
/*@__NO_SIDE_EFFECTS__*/ function $b7779ef94f774395$var$createDevtoolsComponentHook(hook) {
    return function(component) {
        $b7779ef94f774395$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
var $b7779ef94f774395$var$devtoolsPerfStart = /*@__PURE__*/ $b7779ef94f774395$var$createDevtoolsPerformanceHook("perf:start");
var $b7779ef94f774395$var$devtoolsPerfEnd = /*@__PURE__*/ $b7779ef94f774395$var$createDevtoolsPerformanceHook("perf:end");
function $b7779ef94f774395$var$createDevtoolsPerformanceHook(hook) {
    return function(component, type, time) {
        $b7779ef94f774395$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $b7779ef94f774395$var$devtoolsComponentEmit(component, event, params) {
    $b7779ef94f774395$var$emit$1("component:emit", component.appContext.app, component, event, params);
}
//#endregion
//#region packages/runtime-core/src/componentRenderContext.ts
/**
* mark the current rendering instance for asset resolution (e.g.
* resolveComponent, resolveDirective) during render
*/ var $b7779ef94f774395$var$currentRenderingInstance = null;
var $b7779ef94f774395$var$currentScopeId = null;
/**
* Note: rendering calls maybe nested. The function returns the parent rendering
* instance if present, which should be restored after the render is done:
*
* ```js
* const prev = setCurrentRenderingInstance(i)
* // ...render
* setCurrentRenderingInstance(prev)
* ```
*/ function $b7779ef94f774395$export$824c074beef4c41b(instance) {
    var prev = $b7779ef94f774395$var$currentRenderingInstance;
    $b7779ef94f774395$var$currentRenderingInstance = instance;
    $b7779ef94f774395$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
/**
* Set scope id when creating hoisted vnodes.
* @private compiler helper
*/ function $b7779ef94f774395$export$ac020265ca2cc4cd(id) {
    $b7779ef94f774395$var$currentScopeId = id;
}
/**
* Technically we no longer need this after 3.0.8 but we need to keep the same
* API for backwards compat w/ code generated by compilers.
* @private
*/ function $b7779ef94f774395$export$f2dc6805dc11834e() {
    $b7779ef94f774395$var$currentScopeId = null;
}
/**
* Only for backwards compat
* @private
*/ var $b7779ef94f774395$export$15ba313e13f3dd04 = function(_id) {
    return $b7779ef94f774395$export$694b237e827a3d23;
};
/**
* Wrap a slot function to memoize current rendering instance
* @private compiler helper
*/ function $b7779ef94f774395$export$694b237e827a3d23(fn) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b7779ef94f774395$var$currentRenderingInstance, isNonScopedSlot = arguments.length > 2 ? arguments[2] : void 0;
    if (!ctx) return fn;
    if (fn._n) return fn;
    var renderFnWithContext = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (renderFnWithContext._d) $b7779ef94f774395$export$c20bee82f26f1e27(-1);
        var prevInstance = $b7779ef94f774395$export$824c074beef4c41b(ctx);
        var prevStackSize = $b7779ef94f774395$var$blockStack.length;
        var res;
        try {
            res = fn.apply(void 0, (0, $aUGqu._)(args));
        } finally{
            for(var i = $b7779ef94f774395$var$blockStack.length; i > prevStackSize; i--)$b7779ef94f774395$var$closeBlock();
            $b7779ef94f774395$export$824c074beef4c41b(prevInstance);
            if (renderFnWithContext._d) $b7779ef94f774395$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
//#endregion
//#region packages/runtime-core/src/directives.ts
function $b7779ef94f774395$var$validateDirectiveName(name) {
    if ((0, $6zvdv.isBuiltInDirective)(name)) $b7779ef94f774395$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
/**
* Adds directives to a VNode.
*/ function $b7779ef94f774395$export$49729353e7c1e6c5(vnode, directives) {
    if ($b7779ef94f774395$var$currentRenderingInstance === null) return vnode;
    var instance = $b7779ef94f774395$var$getComponentPublicInstance($b7779ef94f774395$var$currentRenderingInstance);
    var bindings = vnode.dirs || (vnode.dirs = []);
    for(var i = 0; i < directives.length; i++){
        var _directives_i = (0, $f9AOD._)(directives[i], 4), dir = _directives_i[0], value = _directives_i[1], arg = _directives_i[2], tmp = _directives_i[3], modifiers = tmp === void 0 ? (0, $6zvdv.EMPTY_OBJ) : tmp;
        if (dir) {
            if ((0, $6zvdv.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $ftLbb.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $b7779ef94f774395$export$91e53aad4f01262(vnode, prevVNode, instance, name) {
    var bindings = vnode.dirs;
    var oldBindings = prevVNode && prevVNode.dirs;
    for(var i = 0; i < bindings.length; i++){
        var binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        var hook = binding.dir[name];
        if (hook) {
            var prevSub = (0, $ftLbb.setActiveSub)();
            $b7779ef94f774395$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $ftLbb.setActiveSub)(prevSub);
        }
    }
}
//#endregion
//#region packages/runtime-core/src/apiInject.ts
function $b7779ef94f774395$export$abe1e183e22e10ad(key, value) {
    if ($b7779ef94f774395$export$5d0c78f02672825) {
        var provides = $b7779ef94f774395$export$5d0c78f02672825.provides;
        var parentProvides = $b7779ef94f774395$export$5d0c78f02672825.parent && $b7779ef94f774395$export$5d0c78f02672825.parent.provides;
        if (parentProvides === provides) provides = $b7779ef94f774395$export$5d0c78f02672825.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $b7779ef94f774395$export$a976684a0efeb93f(key, defaultValue) {
    var treatDefaultAsFactory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var instance = $b7779ef94f774395$var$getCurrentGenericInstance();
    if (instance || $b7779ef94f774395$var$currentApp) {
        var provides = $b7779ef94f774395$var$currentApp ? $b7779ef94f774395$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.appContext && instance.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $6zvdv.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
/**
* Returns true if `inject()` can be used without warning about being called in the wrong place (e.g. outside of
* setup()). This is used by libraries that want to use `inject()` internally without triggering a warning to the end
* user. One example is `useRoute()` in `vue-router`.
*/ function $b7779ef94f774395$export$caf6761f24fc571a() {
    return !!($b7779ef94f774395$var$getCurrentGenericInstance() || $b7779ef94f774395$var$currentApp);
}
//#endregion
//#region packages/runtime-core/src/helpers/useSsrContext.ts
var $b7779ef94f774395$export$f2549a27e18acf2d = Symbol.for("v-scx");
var $b7779ef94f774395$export$6b1c54dc4befcda = function() {
    {
        var ctx = $b7779ef94f774395$export$a976684a0efeb93f($b7779ef94f774395$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
//#endregion
//#region packages/runtime-core/src/apiWatch.ts
function $b7779ef94f774395$export$ede35fc0e5500309(effect, options) {
    return $b7779ef94f774395$var$doWatch(effect, null, options);
}
function $b7779ef94f774395$export$b7f27ea67102d543(effect, options) {
    return $b7779ef94f774395$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $b7779ef94f774395$export$2035654f31b0e555(effect, options) {
    return $b7779ef94f774395$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $b7779ef94f774395$export$3db5d71bdb2d5499(source, cb, options) {
    return $b7779ef94f774395$var$doWatch(source, cb, options);
}
var $b7779ef94f774395$var$RenderWatcherEffect = /*#__PURE__*/ function(WatcherEffect) {
    "use strict";
    (0, $hdIku._)(RenderWatcherEffect, WatcherEffect);
    function RenderWatcherEffect(instance, source, cb, options, flush) {
        (0, $173N4._)(this, RenderWatcherEffect);
        var _this;
        _this = (0, $7qXGD._)(this, RenderWatcherEffect, [
            source,
            cb,
            options
        ]);
        _this.flush = flush;
        var job = function() {
            if (_this.dirty) _this.run();
        };
        if (cb) {
            _this.flags |= 128;
            job.flags |= 2;
        }
        if (instance) job.i = instance;
        _this.job = job;
        return _this;
    }
    (0, $cFHGC._)(RenderWatcherEffect, [
        {
            key: "notify",
            value: function notify() {
                if (!(this.flags & 256)) {
                    var flush = this.flush;
                    var job = this.job;
                    if (flush === "post") $b7779ef94f774395$export$51ec8e020844a97a(job, void 0, job.i ? job.i.suspense : null);
                    else if (flush === "pre") $b7779ef94f774395$export$fba1a0a20887772f(job, job.i ? job.i.uid : void 0, true);
                    else job();
                }
            }
        }
    ]);
    return RenderWatcherEffect;
}((0, $ftLbb.WatcherEffect));
function $b7779ef94f774395$var$doWatch(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $6zvdv.EMPTY_OBJ);
    var immediate = options.immediate, deep = options.deep, _options_flush = options.flush, flush = _options_flush === void 0 ? "pre" : _options_flush, once = options.once;
    var baseWatchOptions = (0, $6zvdv.extend)({}, options);
    var runsImmediately = cb && immediate || !cb && flush !== "post";
    var ssrCleanup;
    if ($b7779ef94f774395$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            var ctx = $b7779ef94f774395$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            var watchStopHandle = function() {};
            watchStopHandle.stop = (0, $6zvdv.NOOP);
            watchStopHandle.resume = (0, $6zvdv.NOOP);
            watchStopHandle.pause = (0, $6zvdv.NOOP);
            return watchStopHandle;
        }
    }
    var instance = $b7779ef94f774395$export$5d0c78f02672825;
    baseWatchOptions.call = function(fn, type, args) {
        return $b7779ef94f774395$export$dae85862a8d94378(fn, instance, type, args);
    };
    var effect = new $b7779ef94f774395$var$RenderWatcherEffect(instance, source, cb, baseWatchOptions, flush);
    if (cb) effect.run(true);
    else if (flush === "post") $b7779ef94f774395$export$51ec8e020844a97a(effect.job, void 0, instance && instance.suspense);
    else effect.run(true);
    var stop = effect.stop.bind(effect);
    stop.pause = effect.pause.bind(effect);
    stop.resume = effect.resume.bind(effect);
    stop.stop = stop;
    if ($b7779ef94f774395$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(stop);
        else if (runsImmediately) stop();
    }
    return stop;
}
function $b7779ef94f774395$var$instanceWatch(source, value, options) {
    var publicThis = this.proxy;
    var getter = (0, $6zvdv.isString)(source) ? source.includes(".") ? $b7779ef94f774395$var$createPathGetter(publicThis, source) : function() {
        return publicThis[source];
    } : source.bind(publicThis, publicThis);
    var cb;
    if ((0, $6zvdv.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    var prev = $b7779ef94f774395$export$a5e695a16aa0b6d4(this);
    var res = $b7779ef94f774395$var$doWatch(getter, cb.bind(publicThis), options);
    $b7779ef94f774395$export$95e96a1fb881e3e7(prev);
    return res;
}
function $b7779ef94f774395$var$createPathGetter(ctx, path) {
    var segments = path.split(".");
    return function() {
        var cur = ctx;
        for(var i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
//#endregion
//#region packages/runtime-core/src/components/Teleport.ts
var $b7779ef94f774395$var$pendingMounts = /* @__PURE__ */ new WeakMap();
var $b7779ef94f774395$var$TeleportEndKey = Symbol("_vte");
var $b7779ef94f774395$var$isTeleport = function(type) {
    return type.__isTeleport;
};
var $b7779ef94f774395$export$44727b5035358778 = function(props) {
    return props && (props.disabled || props.disabled === "");
};
var $b7779ef94f774395$export$6f4d6f0c8744b47f = function(props) {
    return props && (props.defer || props.defer === "");
};
var $b7779ef94f774395$var$isTargetSVG = function(target) {
    return typeof SVGElement !== "undefined" && target instanceof SVGElement;
};
var $b7779ef94f774395$var$isTargetMathML = function(target) {
    return typeof MathMLElement === "function" && target instanceof MathMLElement;
};
var $b7779ef94f774395$export$792b35e9a6a3f24c = function(props, select) {
    var targetSelector = props && props.to;
    if ((0, $6zvdv.isString)(targetSelector)) {
        if (!select) return null;
        else {
            var target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
var $b7779ef94f774395$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        var mountChildren = internals.mc, patchChildren = internals.pc, patchBlockChildren = internals.pbc, _internals_o = internals.o, insert = _internals_o.insert, querySelector = _internals_o.querySelector, createText = _internals_o.createText, createComment = _internals_o.createComment, parentNode = _internals_o.parentNode;
        var disabled = $b7779ef94f774395$export$44727b5035358778(n2.props);
        var dynamicChildren = n2.dynamicChildren;
        var mount = function(vnode, container, anchor) {
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        var mountToTarget = function() {
            var vnode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n2;
            var disabled = $b7779ef94f774395$export$44727b5035358778(vnode.props);
            var target = vnode.target = $b7779ef94f774395$export$792b35e9a6a3f24c(vnode.props, querySelector);
            var targetAnchor = $b7779ef94f774395$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $b7779ef94f774395$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $b7779ef94f774395$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled) {
                    mount(vnode, target, targetAnchor);
                    $b7779ef94f774395$var$updateCssVars(vnode, false);
                }
            }
        };
        var queuePendingMount = function(vnode) {
            var mountJob = function() {
                if ($b7779ef94f774395$var$pendingMounts.get(vnode) !== mountJob) return;
                $b7779ef94f774395$var$pendingMounts.delete(vnode);
                if ($b7779ef94f774395$export$44727b5035358778(vnode.props)) {
                    var mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $b7779ef94f774395$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $b7779ef94f774395$var$pendingMounts.set(vnode, mountJob);
            $b7779ef94f774395$export$51ec8e020844a97a(mountJob, void 0, parentSuspense);
        };
        if (n1 == null) {
            var placeholder = n2.el = createText("");
            var mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($b7779ef94f774395$export$6f4d6f0c8744b47f(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $b7779ef94f774395$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            var mainAnchor1 = n2.anchor = n1.anchor;
            var pendingMount = $b7779ef94f774395$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 4;
                $b7779ef94f774395$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            var target = n2.target = n1.target;
            var targetAnchor = n2.targetAnchor = n1.targetAnchor;
            var wasDisabled = $b7779ef94f774395$export$44727b5035358778(n1.props);
            var currentContainer = wasDisabled ? container : target;
            var currentAnchor = wasDisabled ? mainAnchor1 : targetAnchor;
            if (namespace === "svg" || $b7779ef94f774395$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $b7779ef94f774395$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $b7779ef94f774395$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $b7779ef94f774395$var$moveTeleport(n2, container, mainAnchor1, internals, parentComponent, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                var nextTarget = $b7779ef94f774395$export$792b35e9a6a3f24c(n2.props, querySelector);
                if (nextTarget) {
                    n2.target = nextTarget;
                    $b7779ef94f774395$var$moveTeleport(n2, nextTarget, null, internals, parentComponent, 0);
                }
            } else if (wasDisabled) $b7779ef94f774395$var$moveTeleport(n2, target, targetAnchor, internals, parentComponent, 1);
            $b7779ef94f774395$var$updateCssVars(n2, disabled);
        }
    },
    remove: function(vnode, parentComponent, parentSuspense, param, doRemove) {
        var unmount = param.um, _param_o = param.o, hostRemove = _param_o.remove;
        var shapeFlag = vnode.shapeFlag, children = vnode.children, anchor = vnode.anchor, targetStart = vnode.targetStart, targetAnchor = vnode.targetAnchor, target = vnode.target, props = vnode.props;
        var disabled = $b7779ef94f774395$export$44727b5035358778(props);
        var shouldRemove = doRemove || !disabled;
        var pendingMount = $b7779ef94f774395$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 4;
            $b7779ef94f774395$var$pendingMounts.delete(vnode);
        }
        if (targetStart) hostRemove(targetStart);
        if (targetAnchor) hostRemove(targetAnchor);
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(var i = 0; i < children.length; i++){
            var child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $b7779ef94f774395$var$moveTeleport,
    hydrate: $b7779ef94f774395$var$hydrateTeleport
};
function $b7779ef94f774395$var$moveTeleport(vnode, container, parentAnchor, param, parentComponent) {
    var insert = param.o.insert, move = param.m, moveType = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 2;
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    var el = vnode.el, anchor = vnode.anchor, shapeFlag = vnode.shapeFlag, children = vnode.children, props = vnode.props;
    var isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$b7779ef94f774395$var$pendingMounts.has(vnode) && (!isReorder || $b7779ef94f774395$export$44727b5035358778(props))) {
        if (shapeFlag & 16) for(var i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2, parentComponent);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $b7779ef94f774395$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, param, hydrateChildren) {
    var _param_o = param.o, nextSibling = _param_o.nextSibling, parentNode = _param_o.parentNode, querySelector = _param_o.querySelector, insert = _param_o.insert, createText = _param_o.createText;
    function hydrateAnchor(target, targetNode) {
        var targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node, vnode) {
        vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    var target = vnode.target = $b7779ef94f774395$export$792b35e9a6a3f24c(vnode.props, querySelector);
    var disabled = $b7779ef94f774395$export$44727b5035358778(vnode.props);
    if (target) {
        var targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $b7779ef94f774395$var$prepareAnchor(target, vnode, createText, insert, parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $b7779ef94f774395$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $b7779ef94f774395$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
var $b7779ef94f774395$export$76d55a0304a371f4 = $b7779ef94f774395$var$TeleportImpl;
function $b7779ef94f774395$var$updateCssVars(vnode, isDisabled) {
    var ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        var node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $b7779ef94f774395$var$prepareAnchor(target, vnode, createText, insert) {
    var anchor = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var targetStart = vnode.targetStart = createText("");
    var targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$b7779ef94f774395$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
//#endregion
//#region packages/runtime-core/src/components/BaseTransition.ts
var $b7779ef94f774395$export$6402c150d41fe6bc = Symbol("_leaveCb");
var $b7779ef94f774395$var$enterCbKey = Symbol("_enterCb");
function $b7779ef94f774395$export$d2a0a1bc267c90f6() {
    var state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingNodes: /* @__PURE__ */ new Map()
    };
    $b7779ef94f774395$export$6d1641039221b5cb(function() {
        state.isMounted = true;
    });
    $b7779ef94f774395$export$40c420df62d2614(function() {
        state.isUnmounting = true;
    });
    return state;
}
var $b7779ef94f774395$var$TransitionHookValidator = [
    Function,
    Array
];
var $b7779ef94f774395$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    onBeforeEnter: $b7779ef94f774395$var$TransitionHookValidator,
    onEnter: $b7779ef94f774395$var$TransitionHookValidator,
    onAfterEnter: $b7779ef94f774395$var$TransitionHookValidator,
    onEnterCancelled: $b7779ef94f774395$var$TransitionHookValidator,
    onBeforeLeave: $b7779ef94f774395$var$TransitionHookValidator,
    onLeave: $b7779ef94f774395$var$TransitionHookValidator,
    onAfterLeave: $b7779ef94f774395$var$TransitionHookValidator,
    onLeaveCancelled: $b7779ef94f774395$var$TransitionHookValidator,
    onBeforeAppear: $b7779ef94f774395$var$TransitionHookValidator,
    onAppear: $b7779ef94f774395$var$TransitionHookValidator,
    onAfterAppear: $b7779ef94f774395$var$TransitionHookValidator,
    onAppearCancelled: $b7779ef94f774395$var$TransitionHookValidator
};
var $b7779ef94f774395$var$recursiveGetSubtree = function(instance) {
    var subTree = $b7779ef94f774395$var$isVaporComponent(instance.type) ? instance.block : instance.subTree;
    return subTree.component ? $b7779ef94f774395$var$recursiveGetSubtree(subTree.component) : subTree;
};
var $b7779ef94f774395$var$BaseTransitionImpl = {
    name: "BaseTransition",
    props: $b7779ef94f774395$export$b876c99684f8cf3b,
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $b7779ef94f774395$export$f13e630aa3915748();
        var state = $b7779ef94f774395$export$d2a0a1bc267c90f6();
        var resumeAfterLeave;
        return function() {
            var child = $b7779ef94f774395$export$bacc260570b6d3ae(slots.default && slots.default(), !!instance.subTree);
            if (!child) return;
            var rawProps = (0, $ftLbb.toRaw)(props);
            var mode = rawProps.mode;
            $b7779ef94f774395$export$f7697b49c3204928(mode);
            return $b7779ef94f774395$export$aee04c50c0dfaf12(instance.subTree, child, rawProps, state, instance, mode === "out-in" ? resumeAfterLeave || (resumeAfterLeave = function() {
                if (!(instance.job.flags & 4)) instance.update();
            }) : (0, $6zvdv.NOOP));
        };
    }
};
function $b7779ef94f774395$var$findNonCommentChild(children) {
    var child = children[0];
    if (children.length > 1) {
        var hasFound = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                if (c.type !== $b7779ef94f774395$export$4d299b491347818a) {
                    child = c;
                    hasFound = true;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return child;
}
var $b7779ef94f774395$export$abd95b5f5e8a8837 = $b7779ef94f774395$var$BaseTransitionImpl;
function $b7779ef94f774395$var$getLeavingNodesForType(state, vnode) {
    var leavingNodes = state.leavingNodes;
    var leavingVNodesCache = leavingNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = Object.create(null);
        leavingNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $b7779ef94f774395$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    var key = String(vnode.key);
    var leavingVNodesCache = $b7779ef94f774395$var$getLeavingNodesForType(state, vnode);
    return $b7779ef94f774395$export$52bce14e5b84ba5b({
        isLeaving: function() {
            return leavingVNodesCache[key] === vnode;
        },
        setLeavingNodeCache: function() {
            leavingVNodesCache[key] = vnode;
        },
        unsetLeavingNodeCache: function() {
            if (leavingVNodesCache[key] === vnode) delete leavingVNodesCache[key];
        },
        earlyRemove: function() {
            var leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $b7779ef94f774395$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$b7779ef94f774395$export$6402c150d41fe6bc]) leavingVNode.el[$b7779ef94f774395$export$6402c150d41fe6bc]();
        },
        cloneHooks: function(vnode) {
            var hooks = $b7779ef94f774395$export$76ac1779589cd824(vnode, props, state, instance, postClone);
            if (postClone) postClone(hooks);
            return hooks;
        }
    }, props, state, instance);
}
function $b7779ef94f774395$export$52bce14e5b84ba5b(context, props, state, instance) {
    var isLeaving = context.isLeaving, setLeavingNodeCache = context.setLeavingNodeCache, unsetLeavingNodeCache = context.unsetLeavingNodeCache, earlyRemove = context.earlyRemove, cloneHooks = context.cloneHooks;
    var appear = props.appear, mode = props.mode, _props_persisted = props.persisted, persisted = _props_persisted === void 0 ? false : _props_persisted, onBeforeEnter = props.onBeforeEnter, onEnter = props.onEnter, onAfterEnter = props.onAfterEnter, onEnterCancelled = props.onEnterCancelled, onBeforeLeave = props.onBeforeLeave, onLeave = props.onLeave, onAfterLeave = props.onAfterLeave, onLeaveCancelled = props.onLeaveCancelled, onBeforeAppear = props.onBeforeAppear, onAppear = props.onAppear, onAfterAppear = props.onAfterAppear, onAppearCancelled = props.onAppearCancelled;
    var callHook = function(hook, args) {
        hook && $b7779ef94f774395$export$dae85862a8d94378(hook, instance, 9, args);
    };
    var callAsyncHook = function(hook, args) {
        var done = args[1];
        callHook(hook, args);
        if ((0, $6zvdv.isArray)(hook)) {
            if (hook.every(function(hook) {
                return hook.length <= 1;
            })) done();
        } else if (hook.length <= 1) done();
    };
    var hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter: function(el) {
            var hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$b7779ef94f774395$export$6402c150d41fe6bc]) el[$b7779ef94f774395$export$6402c150d41fe6bc](true);
            earlyRemove();
            callHook(hook, [
                el
            ]);
        },
        enter: function(el) {
            if (!$b7779ef94f774395$var$isHmrUpdating && isLeaving()) return;
            var hook = onEnter;
            var afterHook = onAfterEnter;
            var cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            var called = false;
            el[$b7779ef94f774395$var$enterCbKey] = function(cancelled) {
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$b7779ef94f774395$var$enterCbKey] = void 0;
            };
            var done = el[$b7779ef94f774395$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave: function(el, remove) {
            if (el[$b7779ef94f774395$var$enterCbKey]) el[$b7779ef94f774395$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            var called = false;
            el[$b7779ef94f774395$export$6402c150d41fe6bc] = function(cancelled) {
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$b7779ef94f774395$export$6402c150d41fe6bc] = void 0;
                unsetLeavingNodeCache(el);
            };
            setLeavingNodeCache(el);
            var done = el[$b7779ef94f774395$export$6402c150d41fe6bc].bind(null, false);
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone: function(node) {
            return cloneHooks ? cloneHooks(node) : hooks;
        }
    };
    return hooks;
}
function $b7779ef94f774395$var$emptyPlaceholder(vnode) {
    if ($b7779ef94f774395$export$a33216a979d8327a(vnode)) {
        vnode = $b7779ef94f774395$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $b7779ef94f774395$var$getInnerChild$1(vnode) {
    if (!$b7779ef94f774395$export$a33216a979d8327a(vnode)) {
        if ($b7779ef94f774395$var$isTeleport(vnode.type) && vnode.children) return $b7779ef94f774395$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $6zvdv.isFunction)(children.default)) return children.default();
    }
}
function $b7779ef94f774395$export$bacc260570b6d3ae(children) {
    var renderEmpty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var branches = children && $b7779ef94f774395$export$a67f9b1229c7c97a(children, true);
    return branches && branches.length ? $b7779ef94f774395$var$findNonCommentChild(branches) : renderEmpty ? $b7779ef94f774395$export$49553837c7236d3c() : void 0;
}
/**
* @internal
*/ function $b7779ef94f774395$export$aee04c50c0dfaf12(previous, next, props, state, instance, resumeAfterLeave, delayedLeaveSource) {
    if (state.isLeaving) return $b7779ef94f774395$var$emptyPlaceholder(next);
    var nextInner = $b7779ef94f774395$var$getInnerChild$1(next);
    if (!nextInner) return $b7779ef94f774395$var$emptyPlaceholder(next);
    var enterHooks = $b7779ef94f774395$export$76ac1779589cd824(nextInner, props, state, instance, function(hooks) {
        if (delayedLeaveSource) $b7779ef94f774395$var$forwardDelayedLeave(hooks, delayedLeaveSource);
        enterHooks = hooks;
    });
    if (delayedLeaveSource) $b7779ef94f774395$var$forwardDelayedLeave(enterHooks, delayedLeaveSource);
    if (nextInner.type !== $b7779ef94f774395$export$4d299b491347818a) $b7779ef94f774395$export$7770a22486565649(nextInner, enterHooks);
    var mode = props.mode;
    var previousInner = previous && $b7779ef94f774395$var$getInnerChild$1(previous);
    if (previous && previousInner && previousInner.type !== $b7779ef94f774395$export$4d299b491347818a && !$b7779ef94f774395$var$isSameVNodeType(previousInner, nextInner) && (!previous.component || $b7779ef94f774395$var$recursiveGetSubtree(previous.component).type !== $b7779ef94f774395$export$4d299b491347818a)) {
        var leavingHooks = $b7779ef94f774395$var$prepareLeavingTransitionHooks(previousInner, props, state, instance);
        if (nextInner.type !== $b7779ef94f774395$export$4d299b491347818a && (mode === "out-in" || mode === "in-out") && $b7779ef94f774395$var$applyTransitionModeSwitch(previousInner, leavingHooks, mode === "in-out" ? function() {
            return enterHooks;
        } : void 0, props, state, resumeAfterLeave)) return $b7779ef94f774395$var$emptyPlaceholder(next);
    }
    return next;
}
function $b7779ef94f774395$var$forwardDelayedLeave(hooks, source) {
    var delayedLeave = source && source.delayedLeave;
    if (!delayedLeave) return;
    hooks.delayedLeave = function() {
        if (source.delayedLeave === delayedLeave) delayedLeave();
        delete hooks.delayedLeave;
    };
}
/**
* Prepares an outgoing VNode when the incoming branch belongs to another
* renderer. Returns true when out-in must defer the incoming branch.
*
* @internal
*/ function $b7779ef94f774395$export$750adf600c62558a(previous, enterHooks, props, state, instance, resumeAfterLeave) {
    var previousInner = $b7779ef94f774395$var$getInnerChild$1(previous);
    if (!previousInner || previousInner.type === $b7779ef94f774395$export$4d299b491347818a || previous.component && $b7779ef94f774395$var$recursiveGetSubtree(previous.component).type === $b7779ef94f774395$export$4d299b491347818a) return false;
    return $b7779ef94f774395$var$applyTransitionModeSwitch(previousInner, $b7779ef94f774395$var$prepareLeavingTransitionHooks(previousInner, props, state, instance), enterHooks ? function() {
        return enterHooks;
    } : void 0, props, state, resumeAfterLeave);
}
function $b7779ef94f774395$var$prepareLeavingTransitionHooks(previousInner, props, state, instance) {
    return $b7779ef94f774395$export$7770a22486565649(previousInner, $b7779ef94f774395$export$76ac1779589cd824(previousInner, props, state, instance));
}
function $b7779ef94f774395$var$applyTransitionModeSwitch(leavingVNode, leavingHooks, getEnterHooks, props, state, resumeAfterLeave) {
    if (props.mode === "out-in") {
        state.isLeaving = true;
        leavingHooks.afterLeave = function() {
            state.isLeaving = false;
            resumeAfterLeave();
            delete leavingHooks.afterLeave;
        };
        return true;
    } else if (props.mode === "in-out" && getEnterHooks) {
        var delayedLeavingVNode = leavingVNode;
        leavingHooks.delayLeave = function(el, earlyRemove, delayedLeave) {
            var enterHooks = getEnterHooks();
            if (!enterHooks) {
                delayedLeave();
                return;
            }
            var vnode = delayedLeavingVNode;
            var leavingVNodesCache = $b7779ef94f774395$var$getLeavingNodesForType(state, vnode);
            leavingVNodesCache[String(vnode.key)] = vnode;
            el[$b7779ef94f774395$export$6402c150d41fe6bc] = function() {
                earlyRemove();
                el[$b7779ef94f774395$export$6402c150d41fe6bc] = void 0;
                delete enterHooks.delayedLeave;
                delayedLeavingVNode = void 0;
            };
            enterHooks.delayedLeave = function() {
                delayedLeave();
                delete enterHooks.delayedLeave;
                delayedLeavingVNode = void 0;
            };
        };
    }
    return false;
}
function $b7779ef94f774395$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        if ($b7779ef94f774395$var$isVaporComponent(vnode.type)) $b7779ef94f774395$var$getVaporInterface(vnode.component, vnode).setTransitionHooks(vnode.component, hooks);
        else {
            var subTree = vnode.component.subTree;
            return $b7779ef94f774395$export$7770a22486565649($b7779ef94f774395$var$isTeleport(subTree.type) ? $b7779ef94f774395$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
        }
    } else if (vnode.shapeFlag & 128) {
        var contentHooks = vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        var fallbackHooks = vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
        return vnode.suspense && vnode.suspense.activeBranch === vnode.ssFallback ? fallbackHooks : contentHooks;
    } else vnode.transition = hooks;
    return hooks;
}
function $b7779ef94f774395$export$a67f9b1229c7c97a(children) {
    var keepComment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, parentKey = arguments.length > 2 ? arguments[2] : void 0;
    var ret = [];
    var keyedFragmentCount = 0;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        var key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $b7779ef94f774395$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($b7779ef94f774395$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $b7779ef94f774395$export$4d299b491347818a) ret.push(key != null ? $b7779ef94f774395$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(var i1 = 0; i1 < ret.length; i1++)ret[i1].patchFlag = -2;
    return ret;
}
/**
* dev-only
*/ function $b7779ef94f774395$export$f7697b49c3204928(mode) {}
//#endregion
//#region packages/runtime-core/src/apiDefineComponent.ts
/*@__NO_SIDE_EFFECTS__*/ function $b7779ef94f774395$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $6zvdv.isFunction)(options) ? /*@__PURE__*/ function() {
        return (0, $6zvdv.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        });
    }() : options;
}
//#endregion
//#region packages/runtime-core/src/helpers/useId.ts
function $b7779ef94f774395$export$f680877a34711e37() {
    var i = $b7779ef94f774395$var$getCurrentGenericInstance();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
/**
* There are 3 types of async boundaries:
* - async components
* - components with async setup()
* - components with serverPrefetch
*/ function $b7779ef94f774395$export$b9b0eeb564431e5e(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
//#endregion
//#region packages/runtime-core/src/helpers/useTemplateRef.ts
var $b7779ef94f774395$export$f55a8fa3b95033b5 = /* @__PURE__ */ new WeakSet();
function $b7779ef94f774395$export$83a5dbc1f35517ca(key) {
    var i = $b7779ef94f774395$var$getCurrentGenericInstance();
    var r = (0, $ftLbb.shallowRef)(null);
    if (i) {
        var refs = i.refs === (0, $6zvdv.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: function() {
                return r.value;
            },
            set: function(val) {
                return r.value = val;
            }
        });
    }
    var ret = r;
    return ret;
}
function $b7779ef94f774395$export$950f9ee44cd3c66(refs, key) {
    var desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
//#endregion
//#region packages/runtime-core/src/rendererTemplateRef.ts
var $b7779ef94f774395$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
/**
* Function for handling a template ref
*/ function $b7779ef94f774395$export$4bb192c7cacf928f(rawRef, oldRawRef, parentSuspense, vnode) {
    var isUnmount = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if ((0, $6zvdv.isArray)(rawRef)) {
        rawRef.forEach(function(r, i) {
            return $b7779ef94f774395$export$4bb192c7cacf928f(r, oldRawRef && ((0, $6zvdv.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount);
        });
        return;
    }
    if ($b7779ef94f774395$export$4d0901d882427199(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $b7779ef94f774395$export$4bb192c7cacf928f(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    var refValue = vnode.shapeFlag & 4 ? $b7779ef94f774395$var$getComponentPublicInstance(vnode.component) : vnode.el;
    var value = isUnmount ? null : refValue;
    var owner = rawRef.i, ref = rawRef.r;
    var oldRef = oldRawRef && oldRawRef.r;
    var refs = owner.refs === (0, $6zvdv.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    var setupState = owner.setupState;
    var canSetSetupRef = $b7779ef94f774395$export$6082a4aa7ed81817(setupState, refs);
    var canSetRef = function(ref, key) {
        if (key && $b7779ef94f774395$export$950f9ee44cd3c66(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $b7779ef94f774395$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $6zvdv.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $ftLbb.isRef)(oldRef)) {
            var oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $6zvdv.isFunction)(ref)) $b7779ef94f774395$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        var _isString = (0, $6zvdv.isString)(ref);
        var _isRef = (0, $ftLbb.isRef)(ref);
        if (_isString || _isRef) {
            var doSet = function() {
                if (rawRef.f) {
                    var existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $6zvdv.isArray)(existing) && (0, $6zvdv.remove)(existing, refValue);
                    else if (!(0, $6zvdv.isArray)(existing)) {
                        if (_isString) {
                            refs[ref] = [
                                refValue
                            ];
                            if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                        } else {
                            var newVal = [
                                refValue
                            ];
                            if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                            if (rawRef.k) refs[rawRef.k] = newVal;
                        }
                    } else if (!existing.includes(refValue)) existing.push(refValue);
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                var job = function() {
                    doSet();
                    $b7779ef94f774395$var$pendingSetRefMap.delete(rawRef);
                };
                $b7779ef94f774395$var$pendingSetRefMap.set(rawRef, job);
                $b7779ef94f774395$export$51ec8e020844a97a(job, -1, parentSuspense);
            } else {
                $b7779ef94f774395$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $b7779ef94f774395$export$6082a4aa7ed81817(setupState, refs) {
    var rawSetupState = (0, $ftLbb.toRaw)(setupState);
    return setupState === void 0 || setupState === (0, $6zvdv.EMPTY_OBJ) ? (0, $6zvdv.NO) : function(key) {
        if ($b7779ef94f774395$export$950f9ee44cd3c66(refs, key)) return false;
        return (0, $6zvdv.hasOwn)(rawSetupState, key);
    };
}
function $b7779ef94f774395$var$invalidatePendingSetRef(rawRef) {
    var pendingSetRef = $b7779ef94f774395$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 4;
        $b7779ef94f774395$var$pendingSetRefMap.delete(rawRef);
    }
}
//#endregion
//#region packages/runtime-core/src/hydration.ts
var $b7779ef94f774395$export$949522c94f173e7e = false;
function $b7779ef94f774395$export$fb2190d8f9a1a092(value) {
    $b7779ef94f774395$export$949522c94f173e7e = value;
}
/**
* VDOM hydration state.
* Also used by vapor interop plugin for tree-shaking:
* In non-hydration builds, this is never set to true, so the logic in
* vaporInteropImpl's hydrate/hydrateSlot can be tree-shaken.
*/ var $b7779ef94f774395$export$454b4aa5c5ff33b6 = false;
var $b7779ef94f774395$var$hasLoggedMismatchError = false;
var $b7779ef94f774395$export$7c36cdbb1b0f1a71 = function() {
    if ($b7779ef94f774395$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $b7779ef94f774395$var$hasLoggedMismatchError = true;
};
var $b7779ef94f774395$var$isSVGContainer = function(container) {
    return container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
};
var $b7779ef94f774395$var$isMathMLContainer = function(container) {
    if (!container.namespaceURI.includes("MathML")) return false;
    if (container.tagName !== "annotation-xml") return true;
    var encoding = container.getAttribute("encoding");
    return !encoding || !encoding.includes("html");
};
/**
* Resolve the element namespace a container's children should be created in.
* The live DOM is the source of truth, so this also covers containers that are
* only known at runtime (interop boundaries, teleport targets).
* @internal
*/ var $b7779ef94f774395$export$acc6f3e19803b3dc = function(container) {
    if (container.nodeType !== 1) return void 0;
    if ($b7779ef94f774395$var$isSVGContainer(container)) return "svg";
    if ($b7779ef94f774395$var$isMathMLContainer(container)) return "mathml";
};
var $b7779ef94f774395$var$isComment = function(node) {
    return node.nodeType === 8;
};
function $b7779ef94f774395$var$createHydrationFunctions(rendererInternals) {
    var mountComponent = rendererInternals.mt, patch = rendererInternals.p, _rendererInternals_o = rendererInternals.o, patchProp = _rendererInternals_o.patchProp, createText = _rendererInternals_o.createText, nextSibling = _rendererInternals_o.nextSibling, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove, insert = _rendererInternals_o.insert, createComment = _rendererInternals_o.createComment;
    var hydrate = function(vnode, container) {
        if (!$b7779ef94f774395$export$949522c94f173e7e) return;
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b7779ef94f774395$var$warn$1("Attempting to hydrate existing markup but container is empty. Performing full mount instead.");
            patch(null, vnode, container);
            $b7779ef94f774395$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $b7779ef94f774395$export$454b4aa5c5ff33b6 = true;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $b7779ef94f774395$export$454b4aa5c5ff33b6 = false;
        $b7779ef94f774395$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    var hydrateNode = function(node, vnode, parentComponent, parentSuspense, slotScopeIds) {
        var optimized = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        optimized = optimized || !!vnode.dynamicChildren;
        var isFragmentStart = $b7779ef94f774395$var$isComment(node) && node.data === "[";
        var onMismatch = function() {
            return handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        };
        var type = vnode.type, ref = vnode.ref, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag;
        var domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $6zvdv.def)(node, "__vnode", vnode, true);
            (0, $6zvdv.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        var nextNode = null;
        switch(type){
            case $b7779ef94f774395$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b7779ef94f774395$var$warn$1("Hydration text mismatch in", node.parentNode, "\n  - rendered on server: ".concat(JSON.stringify(node.data), "\n  - expected on client: ").concat(JSON.stringify(vnode.children)));
                        $b7779ef94f774395$export$7c36cdbb1b0f1a71();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $b7779ef94f774395$export$4d299b491347818a:
                if ($b7779ef94f774395$export$f125a8a2b402ed89(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $b7779ef94f774395$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    var needToAdoptContent = !vnode.children.length;
                    for(var i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $b7779ef94f774395$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            case $b7779ef94f774395$export$c7c4a6890f1c1342:
                nextNode = $b7779ef94f774395$var$getVaporInterface(parentComponent, vnode).hydrateSlot(vnode, node, parentComponent, parentSuspense, slotScopeIds);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !$b7779ef94f774395$export$f125a8a2b402ed89(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    var container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($b7779ef94f774395$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    if (vnode.type.__vapor) {
                        var vnodeBeforeMountHook = !$b7779ef94f774395$export$4d0901d882427199(vnode) && vnode.props && vnode.props.onVnodeBeforeMount;
                        $b7779ef94f774395$var$getVaporInterface(parentComponent, vnode).hydrate(vnode, node, container, nextNode, parentComponent, parentSuspense, function() {
                            if (vnode.dirs) {
                                $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "created");
                                $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "beforeMount");
                            }
                        }, function() {
                            if (vnodeBeforeMountHook) $b7779ef94f774395$var$invokeVNodeHook(vnodeBeforeMountHook, parentComponent, vnode);
                        });
                        if (vnode.dirs) $b7779ef94f774395$var$queueEffectWithSuspense(function() {
                            return $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "mounted");
                        }, void 0, parentSuspense);
                        var vnodeMountedHook = !$b7779ef94f774395$export$4d0901d882427199(vnode) && vnode.props && vnode.props.onVnodeMounted;
                        if (vnodeMountedHook) $b7779ef94f774395$var$queueEffectWithSuspense(function() {
                            return $b7779ef94f774395$var$invokeVNodeHook(vnodeMountedHook, parentComponent, vnode);
                        }, void 0, parentSuspense);
                    } else {
                        mountComponent(vnode, container, null, parentComponent, parentSuspense, $b7779ef94f774395$export$acc6f3e19803b3dc(container), optimized);
                        var component = vnode.component;
                        if (!component.subTree && ($b7779ef94f774395$export$4d0901d882427199(vnode) || component.asyncDep)) {
                            var subTree;
                            if (isFragmentStart) {
                                subTree = $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$c1b9a1d3af45b7b6);
                                subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                            } else subTree = node.nodeType === 3 ? $b7779ef94f774395$export$22f9b5ffd89dac9("") : $b7779ef94f774395$export$bf5c4cf060303d58(node.nodeType === 8 ? $b7779ef94f774395$export$4d299b491347818a : "div");
                            subTree.el = node;
                            component.subTree = subTree;
                        }
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $b7779ef94f774395$export$acc6f3e19803b3dc(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $b7779ef94f774395$var$warn$1("Invalid HostVNode type:", type, "(".concat(typeof type === "undefined" ? "undefined" : (0, $7E0eS._)(type), ")"));
        }
        if (ref != null) $b7779ef94f774395$export$4bb192c7cacf928f(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    var hydrateElement = function(el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!vnode.dynamicChildren;
        var type = vnode.type, dynamicProps = vnode.dynamicProps, props = vnode.props, patchFlag = vnode.patchFlag, shapeFlag = vnode.shapeFlag, dirs = vnode.dirs, transition = vnode.transition;
        var forcePatch = type === "input" || type === "option";
        var hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "created");
            var needCallTransitionHooks = false;
            if ($b7779ef94f774395$export$f125a8a2b402ed89(el)) {
                needCallTransitionHooks = $b7779ef94f774395$var$needTransition(null, transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                var content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    var cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && !(props && (props.innerHTML || props.textContent))) {
                var next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$b7779ef94f774395$export$89e0dff13906bb59(el, 1)) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b7779ef94f774395$var$warn$1("Hydration children mismatch on", el, "\nServer rendered element contains more child nodes than client vdom.");
                    $b7779ef94f774395$export$7c36cdbb1b0f1a71();
                }
                while(next){
                    var cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                var clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                var textContent = el.textContent;
                if (textContent !== clientText && textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$b7779ef94f774395$export$89e0dff13906bb59(el, 0)) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b7779ef94f774395$var$warn$1("Hydration text content mismatch on", el, "\n  - rendered on server: ".concat(textContent, "\n  - expected on client: ").concat(clientText));
                        $b7779ef94f774395$export$7c36cdbb1b0f1a71();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    var isCustomElement = el.tagName.includes("-");
                    var namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(var key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !(dirs && dirs.some(function(d) {
                            return d.dir.created;
                        })) && $b7779ef94f774395$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $b7779ef94f774395$export$7c36cdbb1b0f1a71();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $6zvdv.isOn)(key) && !(0, $6zvdv.isReservedProp)(key) || key[0] === "." || isCustomElement && !(0, $6zvdv.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($b7779ef94f774395$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $ftLbb.isReactive)(props.style)) for(var key1 in props.style)props.style[key1];
            }
            var vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $b7779ef94f774395$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $b7779ef94f774395$var$queueEffectWithSuspense(function() {
                vnodeHooks && $b7779ef94f774395$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "mounted");
            }, void 0, parentSuspense);
        }
        return el.nextSibling;
    };
    var hydrateChildren = function(node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!parentVNode.dynamicChildren;
        var children = parentVNode.children;
        var l = children.length;
        var hasCheckedMismatch = false;
        for(var i = 0; i < l; i++){
            var vnode = optimized ? children[i] : children[i] = $b7779ef94f774395$export$a0e1465ad202d515(children[i]);
            var isText = vnode.type === $b7779ef94f774395$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $b7779ef94f774395$export$a0e1465ad202d515(children[i + 1]).type === $b7779ef94f774395$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$b7779ef94f774395$export$89e0dff13906bb59(container, 1)) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b7779ef94f774395$var$warn$1("Hydration children mismatch on", container, "\nServer rendered element contains fewer child nodes than client vdom.");
                        $b7779ef94f774395$export$7c36cdbb1b0f1a71();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $b7779ef94f774395$export$acc6f3e19803b3dc(container), slotScopeIds);
            }
        }
        return node;
    };
    var hydrateFragment = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        var fragmentSlotScopeIds = vnode.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        var container = parentNode(node);
        var next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $b7779ef94f774395$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $b7779ef94f774395$export$7c36cdbb1b0f1a71();
            insert(vnode.anchor = createComment("]"), container, next);
            return next;
        }
    };
    var handleMismatch = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) {
        if (!$b7779ef94f774395$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $b7779ef94f774395$var$warn$1("Hydration node mismatch:\n- rendered on server:", node, node.nodeType === 3 ? "(text)" : $b7779ef94f774395$var$isComment(node) && node.data === "[" ? "(start of fragment)" : "", "\n- expected on client:", vnode.type);
            $b7779ef94f774395$export$7c36cdbb1b0f1a71();
        }
        vnode.el = null;
        if (isFragment) {
            var end = locateClosingAnchor(node);
            while(true){
                var next = nextSibling(node);
                if (next && next !== end) remove(next);
                else break;
            }
        }
        var next1 = nextSibling(node);
        var container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next1, parentComponent, parentSuspense, $b7779ef94f774395$export$acc6f3e19803b3dc(container), slotScopeIds);
        if (parentComponent && parentComponent.vnode) {
            parentComponent.vnode.el = vnode.el;
            $b7779ef94f774395$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next1;
    };
    var locateClosingAnchor = function(node) {
        var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "[", close = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "]";
        var match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $b7779ef94f774395$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    var replaceNode = function(newNode, oldNode, parentComponent) {
        var parentNode = oldNode.parentNode;
        if (parentNode) parentNode.replaceChild(newNode, oldNode);
        var parent = parentComponent;
        while(parent){
            if (parent.vnode && parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    return [
        hydrate,
        hydrateNode
    ];
}
var $b7779ef94f774395$export$f125a8a2b402ed89 = function(node) {
    return node.nodeType === 1 && node.tagName === "TEMPLATE";
};
/**
* Dev only
*/ var $b7779ef94f774395$var$resourceProps = /*@__PURE__*/ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $b7779ef94f774395$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$b7779ef94f774395$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : "".concat(clientValue));
}
function $b7779ef94f774395$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    var mismatchType;
    var mismatchKey;
    var actual;
    var expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $6zvdv.normalizeClass)(clientValue);
        if (!$b7779ef94f774395$export$a8d0d0c8d1c5df64($b7779ef94f774395$export$e64691051f3919e5(actual || ""), $b7779ef94f774395$export$e64691051f3919e5(expected))) {
            mismatchType = 2;
            mismatchKey = "class";
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $6zvdv.isString)(clientValue) ? clientValue : (0, $6zvdv.stringifyStyle)((0, $6zvdv.normalizeStyle)(clientValue));
        var actualMap = $b7779ef94f774395$export$10b092b355df2060(actual);
        var expectedMap = $b7779ef94f774395$export$10b092b355df2060(expected);
        if (vnode.dirs) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = vnode.dirs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _step.value, dir = _step_value.dir, value = _step_value.value;
                    if (dir.name === "show" && !value) expectedMap.set("display", "none");
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (instance) $b7779ef94f774395$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$b7779ef94f774395$export$71029b577818f2bb(actualMap, expectedMap)) {
            mismatchType = 3;
            mismatchKey = "style";
        }
    } else if ($b7779ef94f774395$export$92c55cf0d3a086c0(el, key)) {
        var ref;
        ref = $b7779ef94f774395$export$1a5eb8a5128caad6(el, key, clientValue), actual = ref.actual, expected = ref.expected, ref;
        if (actual !== expected) {
            mismatchType = 4;
            mismatchKey = key;
        }
    }
    return $b7779ef94f774395$export$c6d1c9a52f0379ae(el, mismatchKey, mismatchType, actual, expected);
}
function $b7779ef94f774395$export$1a5eb8a5128caad6(el, key, clientValue) {
    var actual;
    var expected;
    if (key === "hidden") {
        actual = $b7779ef94f774395$var$normalizeHiddenValue(el.getAttribute(key));
        expected = $b7779ef94f774395$var$normalizeHiddenValue(clientValue);
    } else if ((0, $6zvdv.isBooleanAttr)(key)) {
        actual = el.hasAttribute(key);
        expected = (0, $6zvdv.includeBooleanAttr)(clientValue);
    } else if (clientValue == null) {
        actual = el.hasAttribute(key);
        expected = false;
    } else {
        if (el.hasAttribute(key)) actual = el.getAttribute(key);
        else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
        else actual = false;
        expected = (0, $6zvdv.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
    }
    return {
        actual: actual,
        expected: expected
    };
}
function $b7779ef94f774395$export$92c55cf0d3a086c0(el, key) {
    return el instanceof SVGElement && (0, $6zvdv.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $6zvdv.isBooleanAttr)(key) || (0, $6zvdv.isKnownHtmlAttr)(key));
}
function $b7779ef94f774395$export$c6d1c9a52f0379ae(el, mismatchKey, mismatchType, actual, expected) {
    if (mismatchType != null && !$b7779ef94f774395$export$89e0dff13906bb59(el, mismatchType)) {
        var format = function(v1) {
            return v1 === false ? "(not rendered)" : "".concat(mismatchKey, '="').concat(v1, '"');
        };
        $b7779ef94f774395$var$warn$1("Hydration ".concat($b7779ef94f774395$var$MismatchTypeString[mismatchType], " mismatch on"), el, "\n  - rendered on server: ".concat(format(actual), "\n  - expected on client: ").concat(format(expected), "\n  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.\n  You should fix the source of the mismatch."));
        return true;
    }
    return false;
}
function $b7779ef94f774395$var$normalizeHiddenValue(value) {
    if (!(0, $6zvdv.isRenderableAttrValue)(value)) return false;
    if ((0, $6zvdv.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $6zvdv.includeBooleanAttr)(value) ? "" : false;
}
function $b7779ef94f774395$export$e64691051f3919e5(str) {
    return new Set(str.trim().split(/\s+/));
}
function $b7779ef94f774395$export$a8d0d0c8d1c5df64(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var s = _step.value;
            if (!b.has(s)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $b7779ef94f774395$export$10b092b355df2060(str) {
    var styleMap = /* @__PURE__ */ new Map();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = str.split(";")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item_split = (0, $f9AOD._)(item.split(":"), 2), key = _item_split[0], value = _item_split[1];
            key = key.trim();
            value = value && value.trim();
            if (key && value) styleMap.set(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return styleMap;
}
function $b7779ef94f774395$export$71029b577818f2bb(a, b) {
    if (a.size !== b.size) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (value !== b.get(key)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $b7779ef94f774395$var$resolveCssVars(instance, vnode, expectedMap) {
    var root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $b7779ef94f774395$export$ffb0004e005737fa && root.children.includes(vnode))) {
        var cssVars = instance.getCssVars();
        for(var key in cssVars){
            var value = (0, $6zvdv.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set("--".concat((0, $6zvdv.getEscapedCssVarName)(key, false)), value);
        }
    }
    if (vnode === root && instance.parent) $b7779ef94f774395$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
var $b7779ef94f774395$var$allowMismatchAttr = "data-allow-mismatch";
var $b7779ef94f774395$export$92e7f8fbf145401a = {
    "TEXT": 0,
    "0": "TEXT",
    "CHILDREN": 1,
    "1": "CHILDREN",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 3,
    "3": "STYLE",
    "ATTRIBUTE": 4,
    "4": "ATTRIBUTE"
};
var $b7779ef94f774395$var$_obj1;
var $b7779ef94f774395$var$MismatchTypeString = ($b7779ef94f774395$var$_obj1 = {}, (0, $7Pjls._)($b7779ef94f774395$var$_obj1, 0, "text"), (0, $7Pjls._)($b7779ef94f774395$var$_obj1, 1, "children"), (0, $7Pjls._)($b7779ef94f774395$var$_obj1, 2, "class"), (0, $7Pjls._)($b7779ef94f774395$var$_obj1, 3, "style"), (0, $7Pjls._)($b7779ef94f774395$var$_obj1, 4, "attribute"), $b7779ef94f774395$var$_obj1);
function $b7779ef94f774395$export$89e0dff13906bb59(el, allowedType) {
    if (allowedType === 0 || allowedType === 1) while(el && !el.hasAttribute($b7779ef94f774395$var$allowMismatchAttr))el = el.parentElement;
    return $b7779ef94f774395$var$isMismatchAllowedByAttr(el && el.getAttribute($b7779ef94f774395$var$allowMismatchAttr), allowedType);
}
function $b7779ef94f774395$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        var list = allowedAttr.split(",");
        if (allowedType === 0 && list.includes("children")) return true;
        return list.includes($b7779ef94f774395$var$MismatchTypeString[allowedType]);
    }
}
function $b7779ef94f774395$var$isNodeMismatchAllowed(node, vnode) {
    return $b7779ef94f774395$export$89e0dff13906bb59(node.parentElement, 1) || $b7779ef94f774395$var$isMismatchAllowedByNode(node) || $b7779ef94f774395$var$isMismatchAllowedByVNode(vnode);
}
function $b7779ef94f774395$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $b7779ef94f774395$var$isMismatchAllowedByAttr(node.getAttribute($b7779ef94f774395$var$allowMismatchAttr), 1);
}
function $b7779ef94f774395$var$isMismatchAllowedByVNode(param) {
    var props = param.props;
    var allowedAttr = props && props[$b7779ef94f774395$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $b7779ef94f774395$var$isMismatchAllowedByAttr(allowedAttr, 1);
}
//#endregion
//#region packages/runtime-core/src/hydrationStrategies.ts
var $b7779ef94f774395$var$requestIdleCallback;
var $b7779ef94f774395$var$cancelIdleCallback;
function $b7779ef94f774395$var$ensureIdleCallbacks() {
    if (!$b7779ef94f774395$var$requestIdleCallback) {
        var g = (0, $6zvdv.getGlobalThis)();
        $b7779ef94f774395$var$requestIdleCallback = g.requestIdleCallback || function(cb) {
            return setTimeout(cb, 1);
        };
        $b7779ef94f774395$var$cancelIdleCallback = g.cancelIdleCallback || function(id) {
            return clearTimeout(id);
        };
    }
}
var $b7779ef94f774395$export$8bfca283fd254627 = function() {
    var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1e4;
    return function(hydrate) {
        $b7779ef94f774395$var$ensureIdleCallbacks();
        var id = $b7779ef94f774395$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return function() {
            return $b7779ef94f774395$var$cancelIdleCallback(id);
        };
    };
};
function $b7779ef94f774395$var$elementIsVisibleInViewport(el) {
    var _el_getBoundingClientRect = el.getBoundingClientRect(), top = _el_getBoundingClientRect.top, left = _el_getBoundingClientRect.left, bottom = _el_getBoundingClientRect.bottom, right = _el_getBoundingClientRect.right;
    var innerHeight = window.innerHeight, innerWidth = window.innerWidth;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
var $b7779ef94f774395$export$2b04cd335e660930 = function(opts) {
    return function(hydrate, forEach) {
        var ob = new IntersectionObserver(function(entries) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var e = _step.value;
                    if (!e.isIntersecting) continue;
                    ob.disconnect();
                    hydrate();
                    break;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }, opts);
        forEach(function(el) {
            if (!(el instanceof Element)) return;
            if ($b7779ef94f774395$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return function() {
            return ob.disconnect();
        };
    };
};
var $b7779ef94f774395$export$804dbb6002787b74 = function(query) {
    return function(hydrate) {
        if (query) {
            var mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return function() {
                    return mql.removeEventListener("change", hydrate);
                };
            }
        }
    };
};
var $b7779ef94f774395$export$288f5a9b4248e114 = function() {
    var interactions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return function(hydrate, forEach) {
        if ((0, $6zvdv.isString)(interactions)) interactions = [
            interactions
        ];
        var hasHydrated = false;
        var doHydrate = function(e) {
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                if (!("$evt".concat(e.type) in e.target)) e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        var teardown = function() {
            forEach(function(el) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = interactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        el.removeEventListener(i, doHydrate);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        };
        forEach(function(el) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = interactions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    el.addEventListener(i, doHydrate, {
                        once: true
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        return teardown;
    };
};
function $b7779ef94f774395$var$forEachElement(node, cb) {
    if ($b7779ef94f774395$var$isComment(node) && node.data === "[") {
        var depth = 1;
        var next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                if (cb(next) === false) break;
            } else if ($b7779ef94f774395$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
//#endregion
//#region packages/runtime-core/src/apiAsyncComponent.ts
var $b7779ef94f774395$export$4d0901d882427199 = function(i) {
    return !!i.type.__asyncLoader;
};
/*@__NO_SIDE_EFFECTS__*/ function $b7779ef94f774395$export$d75d499b4c16cf21(source) {
    var _createAsyncComponentContext = $b7779ef94f774395$export$1e8f866142774b37(source), load = _createAsyncComponentContext.load, getResolvedComp = _createAsyncComponentContext.getResolvedComp, setPendingRequest = _createAsyncComponentContext.setPendingRequest, _createAsyncComponentContext_source = _createAsyncComponentContext.source, loadingComponent = _createAsyncComponentContext_source.loadingComponent, errorComponent = _createAsyncComponentContext_source.errorComponent, delay = _createAsyncComponentContext_source.delay, hydrateStrategy = _createAsyncComponentContext_source.hydrate, timeout = _createAsyncComponentContext_source.timeout, _createAsyncComponentContext_source_suspensible = _createAsyncComponentContext_source.suspensible, suspensible = _createAsyncComponentContext_source_suspensible === void 0 ? true : _createAsyncComponentContext_source_suspensible;
    return /* @__PURE__ */ $b7779ef94f774395$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate: function(el, instance, hydrate) {
            $b7779ef94f774395$export$49918ad629c39773(el, instance, hydrate, getResolvedComp, load, hydrateStrategy, true);
        },
        get __asyncResolved () {
            return getResolvedComp();
        },
        setup: function() {
            var instance = $b7779ef94f774395$export$5d0c78f02672825;
            $b7779ef94f774395$export$b9b0eeb564431e5e(instance);
            var resolvedComp = getResolvedComp();
            if (resolvedComp) return function() {
                return $b7779ef94f774395$var$createInnerComp(resolvedComp, instance);
            };
            var onError = function(err) {
                setPendingRequest(null);
                $b7779ef94f774395$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $b7779ef94f774395$var$isInSSRComponentSetup) return load().then(function(comp) {
                return function() {
                    return $b7779ef94f774395$var$createInnerComp(comp, instance);
                };
            }).catch(function(err) {
                onError(err);
                return function() {
                    return errorComponent ? $b7779ef94f774395$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
                };
            });
            var _useAsyncComponentState = $b7779ef94f774395$export$c7a65c52b748d650(delay, timeout, onError, instance), loaded = _useAsyncComponentState.loaded, error = _useAsyncComponentState.error, delayed = _useAsyncComponentState.delayed;
            load().then(function() {
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && instance.parent.vnode && $b7779ef94f774395$export$a33216a979d8327a(instance.parent.vnode)) instance.parent.update();
            }).catch(function(err) {
                if (instance.isUnmounted) {
                    setPendingRequest(null);
                    return;
                }
                onError(err);
                error.value = err;
            });
            return function() {
                resolvedComp = getResolvedComp();
                if (loaded.value && resolvedComp) return $b7779ef94f774395$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $b7779ef94f774395$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $b7779ef94f774395$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $b7779ef94f774395$var$createInnerComp(comp, parent) {
    var _parent_vnode = parent.vnode, ref = _parent_vnode.ref, props = _parent_vnode.props, children = _parent_vnode.children, ce = _parent_vnode.ce;
    var vnode = $b7779ef94f774395$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
function $b7779ef94f774395$export$1e8f866142774b37(source) {
    if ((0, $6zvdv.isFunction)(source)) source = {
        loader: source
    };
    var loader = source.loader, userOnError = source.onError;
    var pendingRequest = null;
    var resolvedComp;
    var retries = 0;
    var retry = function() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch(function(err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise(function(resolve, reject) {
                var userRetry = function() {
                    return resolve(retry());
                };
                var userFail = function() {
                    return reject(err);
                };
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then(function(comp) {
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return {
        load: load,
        source: source,
        getResolvedComp: function() {
            return resolvedComp;
        },
        setPendingRequest: function(request) {
            return pendingRequest = request;
        }
    };
}
var $b7779ef94f774395$export$c7a65c52b748d650 = function(delay, timeout, onError) {
    var instance = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : $b7779ef94f774395$export$5d0c78f02672825;
    var loaded = (0, $ftLbb.ref)(false);
    var error = (0, $ftLbb.ref)();
    var delayed = (0, $ftLbb.ref)(!!delay);
    var timeoutTimer;
    var delayTimer;
    if (instance) $b7779ef94f774395$export$13348a43ccacfe58(function() {
        if (timeoutTimer != null) clearTimeout(timeoutTimer);
        if (delayTimer != null) clearTimeout(delayTimer);
    }, instance);
    if (delay) delayTimer = setTimeout(function() {
        if (instance && instance.isUnmounted) return;
        delayed.value = false;
    }, delay);
    if (timeout != null) timeoutTimer = setTimeout(function() {
        if (instance && instance.isUnmounted) return;
        if (!loaded.value && !error.value) {
            var err = /* @__PURE__ */ new Error("Async component timed out after ".concat(timeout, "ms."));
            onError(err);
            error.value = err;
        }
    }, timeout);
    return {
        loaded: loaded,
        error: error,
        delayed: delayed
    };
};
/**
* shared between core and vapor
* @internal
*/ function $b7779ef94f774395$export$49918ad629c39773(el, instance, hydrate, getResolvedComp, load, hydrateStrategy, skipIfUpdated) {
    var wasConnected = el.isConnected;
    var patched = false;
    if (skipIfUpdated) (instance.bu || (instance.bu = [])).push(function() {
        return patched = true;
    });
    var performHydrate = function() {
        if (patched) return;
        if (!el.parentNode || wasConnected && !el.isConnected) return;
        hydrate();
    };
    var doHydrate = hydrateStrategy ? function() {
        var teardown = hydrateStrategy(performHydrate, function(cb) {
            return $b7779ef94f774395$var$forEachElement(el, cb);
        });
        if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
    } : performHydrate;
    if (getResolvedComp()) doHydrate();
    else load().then(function() {
        return !instance.isUnmounted && doHydrate();
    });
}
//#endregion
//#region packages/runtime-core/src/components/KeepAlive.ts
var $b7779ef94f774395$export$a33216a979d8327a = function(vnode) {
    return vnode.type.__isKeepAlive;
};
var $b7779ef94f774395$export$70eb8a58709972df = {
    name: "KeepAlive",
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup: function(props, param) {
        var slots = param.slots;
        var keepAliveInstance = $b7779ef94f774395$export$f13e630aa3915748();
        var sharedContext = keepAliveInstance.ctx;
        if (!sharedContext.renderer) return function() {
            var children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        var cache = /* @__PURE__ */ new Map();
        var keys = /* @__PURE__ */ new Set();
        var current = null;
        if (__VUE_PROD_DEVTOOLS__) keepAliveInstance.__v_cache = cache;
        var parentSuspense = keepAliveInstance.suspense;
        var renderer = sharedContext.renderer;
        var _unmount = renderer.um, createElement = renderer.o.createElement;
        var storageContainer = createElement("div");
        sharedContext.getStorageContainer = function() {
            return storageContainer;
        };
        sharedContext.getCachedComponent = function(vnode) {
            var key = vnode.key == null ? vnode.type : vnode.key;
            return cache.get(key);
        };
        sharedContext.activate = function(vnode, container, anchor, namespace, optimized) {
            $b7779ef94f774395$export$234c45b355edd85b(vnode, container, anchor, renderer, keepAliveInstance, parentSuspense, namespace, optimized);
        };
        sharedContext.deactivate = function(vnode) {
            $b7779ef94f774395$export$e96c1edfdaf2d1db(vnode, storageContainer, renderer, keepAliveInstance, parentSuspense);
        };
        function unmount(vnode) {
            $b7779ef94f774395$export$e88525abd1b19421(vnode);
            _unmount(vnode, keepAliveInstance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach(function(vnode, key) {
                var name = $b7779ef94f774395$export$26727cfcc4d7e0fc($b7779ef94f774395$export$4d0901d882427199(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            var cached = cache.get(key);
            if (cached && (!current || !$b7779ef94f774395$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $b7779ef94f774395$export$e88525abd1b19421(current);
            cache.delete(key);
            keys.delete(key);
        }
        $b7779ef94f774395$export$3db5d71bdb2d5499(function() {
            return [
                props.include,
                props.exclude
            ];
        }, function(param) {
            var _param = (0, $f9AOD._)(param, 2), include = _param[0], exclude = _param[1];
            include && pruneCache(function(name) {
                return $b7779ef94f774395$export$de994efd351b291c(include, name);
            });
            exclude && pruneCache(function(name) {
                return !$b7779ef94f774395$export$de994efd351b291c(exclude, name);
            });
        }, {
            flush: "post",
            deep: true
        });
        var pendingCacheKey = null;
        var cacheSubtree = function() {
            if (pendingCacheKey != null) {
                if ($b7779ef94f774395$var$isSuspense(keepAliveInstance.subTree.type)) $b7779ef94f774395$export$51ec8e020844a97a(function() {
                    var vnode = $b7779ef94f774395$var$getInnerChild(keepAliveInstance.subTree);
                    if (vnode.component) cache.set(pendingCacheKey, vnode);
                }, void 0, keepAliveInstance.subTree.suspense);
                else cache.set(pendingCacheKey, $b7779ef94f774395$var$getInnerChild(keepAliveInstance.subTree));
            }
        };
        $b7779ef94f774395$export$6d1641039221b5cb(cacheSubtree);
        $b7779ef94f774395$export$5876c47052fb88b1(cacheSubtree);
        $b7779ef94f774395$export$40c420df62d2614(function() {
            cache.forEach(function(cached) {
                var subTree = keepAliveInstance.subTree, suspense = keepAliveInstance.suspense;
                var vnode = $b7779ef94f774395$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $b7779ef94f774395$export$e88525abd1b19421(vnode);
                    var da = vnode.component.da;
                    da && $b7779ef94f774395$export$51ec8e020844a97a(da, void 0, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return function() {
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            var children = slots.default();
            var rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$b7779ef94f774395$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            var vnode = $b7779ef94f774395$var$getInnerChild(rawVNode);
            if (vnode.type === $b7779ef94f774395$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            var comp = vnode.type;
            var name = $b7779ef94f774395$export$26727cfcc4d7e0fc($b7779ef94f774395$export$4d0901d882427199(vnode) ? vnode.type.__asyncResolved || {} : comp);
            var include = props.include, exclude = props.exclude, max = props.max;
            if (include && (!name || !$b7779ef94f774395$export$de994efd351b291c(include, name)) || exclude && name && $b7779ef94f774395$export$de994efd351b291c(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            var key = vnode.key == null ? comp : vnode.key;
            var cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $b7779ef94f774395$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $b7779ef94f774395$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $b7779ef94f774395$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
function $b7779ef94f774395$export$de994efd351b291c(pattern, name) {
    if ((0, $6zvdv.isArray)(pattern)) return pattern.some(function(p) {
        return $b7779ef94f774395$export$de994efd351b291c(p, name);
    });
    else if ((0, $6zvdv.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $6zvdv.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    /* v8 ignore next */ return false;
}
function $b7779ef94f774395$export$ba52d824b95a2154(hook, target) {
    $b7779ef94f774395$var$registerKeepAliveHook(hook, "a", target);
}
function $b7779ef94f774395$export$bf1440eeaf5fa709(hook, target) {
    $b7779ef94f774395$var$registerKeepAliveHook(hook, "da", target);
}
function $b7779ef94f774395$var$registerKeepAliveHook(hook, type) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $b7779ef94f774395$var$getCurrentGenericInstance();
    var wrappedHook = hook.__wdc || (hook.__wdc = function() {
        var current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $b7779ef94f774395$var$injectHook(type, wrappedHook, target);
    if (target) {
        var current = target.parent;
        while(current && current.parent){
            var parent = current.parent;
            if ($b7779ef94f774395$export$a33216a979d8327a(parent.vapor ? parent : parent.vnode)) $b7779ef94f774395$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $b7779ef94f774395$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    var injected = $b7779ef94f774395$var$injectHook(type, hook, keepAliveRoot, true);
    $b7779ef94f774395$export$13348a43ccacfe58(function() {
        (0, $6zvdv.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $b7779ef94f774395$export$e88525abd1b19421(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $b7779ef94f774395$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
/**
* shared between runtime-core and runtime-vapor
*/ function $b7779ef94f774395$export$234c45b355edd85b(vnode, container, anchor, param, parentComponent, parentSuspense, namespace, optimized) {
    var patch = param.p, move = param.m;
    var instance = vnode.component;
    move(vnode, container, anchor, 0, parentComponent, parentSuspense);
    patch(instance.vnode, vnode, container, anchor, instance, parentSuspense, namespace, vnode.slotScopeIds, optimized);
    $b7779ef94f774395$export$51ec8e020844a97a(function() {
        instance.isDeactivated = false;
        if (instance.a) (0, $6zvdv.invokeArrayFns)(instance.a);
        var vnodeHook = vnode.props && vnode.props.onVnodeMounted;
        if (vnodeHook) $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
    }, void 0, parentSuspense);
    if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$export$a76a9a73068a1a5e(instance);
}
/**
* shared between runtime-core and runtime-vapor
*/ function $b7779ef94f774395$export$e96c1edfdaf2d1db(vnode, container, param, parentComponent, parentSuspense) {
    var move = param.m;
    var instance = vnode.component;
    $b7779ef94f774395$export$47f10f11906274f2(instance.m);
    $b7779ef94f774395$export$47f10f11906274f2(instance.a);
    move(vnode, container, null, 1, parentComponent, parentSuspense);
    $b7779ef94f774395$export$51ec8e020844a97a(function() {
        if (instance.da) (0, $6zvdv.invokeArrayFns)(instance.da);
        var vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
        if (vnodeHook) $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, instance.parent, vnode);
        instance.isDeactivated = true;
    }, void 0, parentSuspense);
    if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$export$a76a9a73068a1a5e(instance);
}
//#endregion
//#region packages/runtime-core/src/apiLifecycle.ts
function $b7779ef94f774395$var$injectHook(type, hook) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $b7779ef94f774395$export$5d0c78f02672825, prepend = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (target) {
        var hooks = target[type] || (target[type] = []);
        var wrappedHook = hook.__weh || (hook.__weh = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var prevSub = (0, $ftLbb.setActiveSub)();
            var prev = $b7779ef94f774395$export$a5e695a16aa0b6d4(target);
            try {
                return $b7779ef94f774395$export$dae85862a8d94378(hook, target, type, args);
            } finally{
                $b7779ef94f774395$export$95e96a1fb881e3e7(prev);
                (0, $ftLbb.setActiveSub)(prevSub);
            }
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
var $b7779ef94f774395$var$createHook = /* @__NO_SIDE_EFFECTS__ */ function(lifecycle) {
    return function(hook) {
        var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b7779ef94f774395$export$5d0c78f02672825;
        if (!$b7779ef94f774395$var$isInSSRComponentSetup || lifecycle === "sp") $b7779ef94f774395$var$injectHook(lifecycle, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return hook.apply(void 0, (0, $aUGqu._)(args));
        }, target);
    };
};
var $b7779ef94f774395$export$23b7aeb0d671f804 = /* @__PURE__ */ $b7779ef94f774395$var$createHook("bm");
var $b7779ef94f774395$export$6d1641039221b5cb = /* @__PURE__ */ $b7779ef94f774395$var$createHook("m");
var $b7779ef94f774395$export$ab91988a13872e4c = /* @__PURE__ */ $b7779ef94f774395$var$createHook("bu");
var $b7779ef94f774395$export$5876c47052fb88b1 = /* @__PURE__ */ $b7779ef94f774395$var$createHook("u");
var $b7779ef94f774395$export$40c420df62d2614 = /* @__PURE__ */ $b7779ef94f774395$var$createHook("bum");
var $b7779ef94f774395$export$13348a43ccacfe58 = /* @__PURE__ */ $b7779ef94f774395$var$createHook("um");
var $b7779ef94f774395$export$ebf0c601f267bceb = /* @__PURE__ */ $b7779ef94f774395$var$createHook("sp");
var $b7779ef94f774395$export$898295a813d662eb = /* @__PURE__ */ $b7779ef94f774395$var$createHook("rtg");
var $b7779ef94f774395$export$2b41f4235363e921 = /* @__PURE__ */ $b7779ef94f774395$var$createHook("rtc");
function $b7779ef94f774395$export$6a3a15856e50ad19(hook) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b7779ef94f774395$export$5d0c78f02672825;
    $b7779ef94f774395$var$injectHook("ec", hook, target);
}
var $b7779ef94f774395$var$DIRECTIVES = "directives";
/**
* @private
*/ function $b7779ef94f774395$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $b7779ef94f774395$var$resolveAsset("components", name, true, maybeSelfReference) || name;
}
var $b7779ef94f774395$export$7d1f90a35714b16e = Symbol.for("v-ndc");
/**
* @private
*/ function $b7779ef94f774395$export$b44c564a05ca975(component) {
    if ((0, $6zvdv.isString)(component)) return $b7779ef94f774395$var$resolveAsset("components", component, false) || component;
    else return component || $b7779ef94f774395$export$7d1f90a35714b16e;
}
/**
* @private
*/ function $b7779ef94f774395$export$a1989e995cd481be(name) {
    return $b7779ef94f774395$var$resolveAsset($b7779ef94f774395$var$DIRECTIVES, name);
}
function $b7779ef94f774395$var$resolveAsset(type, name) {
    var warnMissing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, maybeSelfReference = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var instance = $b7779ef94f774395$var$currentRenderingInstance || $b7779ef94f774395$export$5d0c78f02672825;
    if (instance) {
        var Component = instance.type;
        if (type === "components") {
            var selfName = $b7779ef94f774395$export$26727cfcc4d7e0fc(Component, false);
            if (selfName && (selfName === name || selfName === (0, $6zvdv.camelize)(name) || selfName === (0, $6zvdv.capitalize)((0, $6zvdv.camelize)(name)))) return Component;
        }
        var res = $b7779ef94f774395$var$resolve(instance[type] || Component[type], name) || $b7779ef94f774395$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $b7779ef94f774395$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $6zvdv.camelize)(name)] || registry[(0, $6zvdv.capitalize)((0, $6zvdv.camelize)(name))]);
}
//#endregion
//#region packages/runtime-core/src/helpers/renderList.ts
/**
* Actual implementation
*/ function $b7779ef94f774395$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    var ret;
    var cached = cache && cache[index];
    var sourceIsArray = (0, $6zvdv.isArray)(source);
    if (sourceIsArray || (0, $6zvdv.isString)(source)) {
        var sourceIsReactiveArray = sourceIsArray && (0, $ftLbb.isReactive)(source);
        var needsWrap = false;
        var isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $ftLbb.isShallow)(source);
            isReadonlySource = (0, $ftLbb.isReadonly)(source);
            source = (0, $ftLbb.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(var i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $ftLbb.toReadonly)((0, $ftLbb.toReactive)(source[i])) : (0, $ftLbb.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(var i1 = 0; i1 < source; i1++)ret[i1] = renderItem(i1 + 1, i1, void 0, cached && cached[i1]);
    } else if ((0, $6zvdv.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, function(item, i) {
            return renderItem(item, i, void 0, cached && cached[i]);
        });
        else {
            var keys = Object.keys(source);
            ret = new Array(keys.length);
            for(var i2 = 0, l1 = keys.length; i2 < l1; i2++){
                var key = keys[i2];
                ret[i2] = renderItem(source[key], key, i2, cached && cached[i2]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
//#endregion
//#region packages/runtime-core/src/helpers/createSlots.ts
/**
* Compiler runtime helper for creating dynamic slots object
* @private
*/ function $b7779ef94f774395$export$85738f8fcd0a5430(slots, dynamicSlots) {
    var _loop = function(i) {
        var slot = dynamicSlots[i];
        if ((0, $6zvdv.isArray)(slot)) for(var j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _slot;
            var res = (_slot = slot).fn.apply(_slot, (0, $aUGqu._)(args));
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    };
    for(var i = 0; i < dynamicSlots.length; i++)_loop(i);
    return slots;
}
//#endregion
//#region packages/runtime-core/src/helpers/renderSlot.ts
/**
* Links a slot function to its raw vapor slot: a raw vapor slot carries
* itself, and the wrapper the interop slots proxy hands out carries the raw
* slot it wraps — one lookup answers both "is this a vapor slot" and
* "which one". Internal to vapor interop.
*/ var $b7779ef94f774395$export$3ab367ca01a03fcc = Symbol("rawVaporSlot");
/**
* Marks a compiler-generated slot fallback as VDOM-rendered so the vapor
* interop fallback chain renders it through the VDOM renderer. Internal to
* vapor interop.
*/ var $b7779ef94f774395$export$3d218eda79783141 = Symbol("vdomSlotFallback");
/**
* Compiler runtime helper for rendering `<slot/>`
* @private
*/ function $b7779ef94f774395$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    var slot = slots[name];
    if (fallback) fallback[$b7779ef94f774395$export$3d218eda79783141] = true;
    var vaporSlot = slot && slot[$b7779ef94f774395$export$3ab367ca01a03fcc];
    if (vaporSlot) {
        var ret = ($b7779ef94f774395$export$e7eaa45e502fe5cc(), $b7779ef94f774395$export$9f2dfe8048dfb22b($b7779ef94f774395$export$c7c4a6890f1c1342, props));
        ret.vs = {
            slot: vaporSlot,
            fallback: fallback
        };
        if (!noSlotted && ret.scopeId) ret.slotScopeIds = [
            ret.scopeId + "-s"
        ];
        return ret;
    }
    if ($b7779ef94f774395$var$currentRenderingInstance && ($b7779ef94f774395$var$currentRenderingInstance.ce || $b7779ef94f774395$var$currentRenderingInstance.parent && $b7779ef94f774395$export$4d0901d882427199($b7779ef94f774395$var$currentRenderingInstance.parent) && $b7779ef94f774395$var$currentRenderingInstance.parent.ce)) {
        var slotProps = branchKey != null && props.key == null ? (0, $6zvdv.extend)({}, props, {
            key: branchKey
        }) : props;
        var hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $b7779ef94f774395$export$e7eaa45e502fe5cc(), $b7779ef94f774395$export$9f2dfe8048dfb22b($b7779ef94f774395$export$ffb0004e005737fa, null, [
            $b7779ef94f774395$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    if (slot && slot._c) slot._d = false;
    var prevStackSize = $b7779ef94f774395$var$blockStack.length;
    $b7779ef94f774395$export$e7eaa45e502fe5cc();
    var rendered;
    try {
        var validSlotContent = slot && $b7779ef94f774395$export$9fc41f261330971f(slot(props));
        $b7779ef94f774395$export$48f2e51a96a1a702(validSlotContent, fallback);
        var slotKey = props.key || branchKey || validSlotContent && validSlotContent.key;
        rendered = $b7779ef94f774395$export$9f2dfe8048dfb22b($b7779ef94f774395$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $6zvdv.isSymbol)(slotKey) ? slotKey : "_".concat(name)) + (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(var i = $b7779ef94f774395$var$blockStack.length; i > prevStackSize; i--)$b7779ef94f774395$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $b7779ef94f774395$export$9fc41f261330971f(vnodes) {
    return vnodes.some(function(child) {
        if (!$b7779ef94f774395$export$3868d13f8734ae81(child)) return true;
        if (child.type === $b7779ef94f774395$export$4d299b491347818a) return false;
        if (child.type === $b7779ef94f774395$export$ffb0004e005737fa && !$b7779ef94f774395$export$9fc41f261330971f(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $b7779ef94f774395$export$48f2e51a96a1a702(vnodes, fallback) {
    var vaporSlot;
    if (vnodes && vnodes.length === 1 && $b7779ef94f774395$export$3868d13f8734ae81(vnodes[0]) && (vaporSlot = vnodes[0].vs)) vaporSlot.outletFallback = fallback;
}
//#endregion
//#region packages/runtime-core/src/helpers/toHandlers.ts
/**
* For prefixing keys in v-on="obj" with "on"
* @private
*/ function $b7779ef94f774395$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    var ret = {};
    for(var key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? "on:".concat(key) : (0, $6zvdv.toHandlerKey)(key)] = obj[key];
    return ret;
}
//#endregion
//#region packages/runtime-core/src/componentPublicInstance.ts
/**
* #2437 In Vue 3, functional components do not have a public instance proxy but
* they exist in the internal parent chain. For code that relies on traversing
* public $parent chains, skip functional ones and go to the parent instead.
*/ var $b7779ef94f774395$var$getPublicInstance = function(i) {
    if (!i || i.vapor) return null;
    if ($b7779ef94f774395$var$isStatefulComponent(i)) return $b7779ef94f774395$var$getComponentPublicInstance(i);
    return $b7779ef94f774395$var$getPublicInstance(i.parent);
};
var $b7779ef94f774395$var$resolveDevRootEl = function(vnode) {
    var found = false;
    while(true){
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048) {
            var root = $b7779ef94f774395$var$filterSingleRoot(vnode.children);
            if (!root) return;
            vnode = root;
            found = true;
            continue;
        }
        var component = vnode.component;
        if (component && component.subTree) {
            vnode = component.subTree;
            continue;
        }
        var suspense = vnode.suspense;
        if (suspense && suspense.activeBranch) {
            vnode = suspense.activeBranch;
            continue;
        }
        return found ? vnode.el : void 0;
    }
};
var $b7779ef94f774395$var$getDevRootFragmentEl = function(i) {
    var el = i.subTree && $b7779ef94f774395$var$resolveDevRootEl(i.subTree);
    return el === void 0 ? i.vnode.el : el;
};
var $b7779ef94f774395$var$publicPropertiesMap;
var $b7779ef94f774395$var$getPublicPropertiesMap = function() {
    if (!$b7779ef94f774395$var$publicPropertiesMap) $b7779ef94f774395$var$publicPropertiesMap = (0, $6zvdv.extend)(Object.create(null), {
        $: function(i) {
            return i;
        },
        $el: function(i) {
            return 0, i.vnode.el;
        },
        $data: function(i) {
            return i.data;
        },
        $props: function(i) {
            return 0, i.props;
        },
        $attrs: function(i) {
            return 0, i.attrs;
        },
        $slots: function(i) {
            return 0, i.slots;
        },
        $refs: function(i) {
            return 0, i.refs;
        },
        $parent: function(i) {
            return $b7779ef94f774395$var$getPublicInstance(i.parent);
        },
        $root: function(i) {
            return $b7779ef94f774395$var$getPublicInstance(i.root);
        },
        $host: function(i) {
            return i.ce;
        },
        $emit: function(i) {
            return i.emit;
        },
        $options: function(i) {
            return __VUE_OPTIONS_API__ ? $b7779ef94f774395$var$resolveMergedOptions(i) : i.type;
        },
        $forceUpdate: function(i) {
            return i.f || (i.f = function() {
                $b7779ef94f774395$export$fba1a0a20887772f(i.update);
            });
        },
        $nextTick: function(i) {
            return i.n || (i.n = $b7779ef94f774395$export$bdd553fddd433dcb.bind(i.proxy));
        },
        $watch: function(i) {
            return __VUE_OPTIONS_API__ ? $b7779ef94f774395$var$instanceWatch.bind(i) : (0, $6zvdv.NOOP);
        }
    });
    return $b7779ef94f774395$var$publicPropertiesMap;
};
var $b7779ef94f774395$var$isReservedPrefix = function(key) {
    return key === "_" || key === "$";
};
var $b7779ef94f774395$var$hasSetupBinding = function(state, key) {
    return state !== (0, $6zvdv.EMPTY_OBJ) && !state.__isScriptSetup && (0, $6zvdv.hasOwn)(state, key);
};
var $b7779ef94f774395$var$PublicInstanceProxyHandlers = {
    get: function(param, key) {
        var instance = param._;
        if (key === "__v_skip") return true;
        var ctx = instance.ctx, setupState = instance.setupState, data = instance.data, props = instance.props, accessCache = instance.accessCache, type = instance.type, appContext = instance.appContext;
        if (key[0] !== "$") {
            var n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1:
                    return setupState[key];
                case 2:
                    return data[key];
                case 4:
                    return ctx[key];
                case 3:
                    return props[key];
            }
            else if ($b7779ef94f774395$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $6zvdv.EMPTY_OBJ) && (0, $6zvdv.hasOwn)(data, key)) {
                accessCache[key] = 2;
                return data[key];
            } else if ((0, $6zvdv.hasOwn)(props, key)) {
                accessCache[key] = 3;
                return props[key];
            } else if (ctx !== (0, $6zvdv.EMPTY_OBJ) && (0, $6zvdv.hasOwn)(ctx, key)) {
                accessCache[key] = 4;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $b7779ef94f774395$var$shouldCacheAccess) accessCache[key] = 0;
        }
        var publicGetter = $b7779ef94f774395$var$getPublicPropertiesMap()[key];
        var cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $ftLbb.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if ((cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $6zvdv.EMPTY_OBJ) && (0, $6zvdv.hasOwn)(ctx, key)) {
            accessCache[key] = 4;
            return ctx[key];
        } else if (globalProperties = appContext.config.globalProperties, (0, $6zvdv.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set: function(param, key, value) {
        var instance = param._;
        var data = instance.data, setupState = instance.setupState, ctx = instance.ctx;
        if ($b7779ef94f774395$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $6zvdv.EMPTY_OBJ) && (0, $6zvdv.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $6zvdv.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has: function(param, key) {
        var _param__ = param._, data = _param__.data, setupState = _param__.setupState, accessCache = _param__.accessCache, ctx = _param__.ctx, appContext = _param__.appContext, props = _param__.props, type = _param__.type;
        var cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $6zvdv.EMPTY_OBJ) && key[0] !== "$" && (0, $6zvdv.hasOwn)(data, key) || $b7779ef94f774395$var$hasSetupBinding(setupState, key) || (0, $6zvdv.hasOwn)(props, key) || (0, $6zvdv.hasOwn)(ctx, key) || (0, $6zvdv.hasOwn)($b7779ef94f774395$var$getPublicPropertiesMap(), key) || (0, $6zvdv.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty: function(target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $6zvdv.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $b7779ef94f774395$var$target;
var $b7779ef94f774395$var$RuntimeCompiledPublicInstanceProxyHandlers = /*@__PURE__*/ (0, $6zvdv.extend)({}, $b7779ef94f774395$var$PublicInstanceProxyHandlers, {
    get: function(target, key) {
        if (key === Symbol.unscopables) return;
        return $b7779ef94f774395$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has: function(_, key) {
        var has = key[0] !== "_" && !(0, $6zvdv.isGloballyAllowed)(key);
        return has;
    }
});
function $b7779ef94f774395$var$createDevRenderContext(instance) {
    var target = {};
    Object.defineProperty(target, "_", {
        configurable: true,
        enumerable: false,
        get: function() {
            return instance;
        }
    });
    Object.keys($b7779ef94f774395$var$getPublicPropertiesMap()).forEach(function(key) {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: function() {
                return $b7779ef94f774395$var$getPublicPropertiesMap()[key](instance);
            },
            set: (0, $6zvdv.NOOP)
        });
    });
    return target;
}
function $b7779ef94f774395$var$exposePropsOnRenderContext(instance) {
    var ctx = instance.ctx, _instance_propsOptions = (0, $f9AOD._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0];
    if (propsOptions) Object.keys(propsOptions).forEach(function(key) {
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return instance.props[key];
            },
            set: (0, $6zvdv.NOOP)
        });
    });
}
function $b7779ef94f774395$var$exposeSetupStateOnRenderContext(instance) {
    var ctx = instance.ctx, setupState = instance.setupState;
    Object.keys((0, $ftLbb.toRaw)(setupState)).forEach(function(key) {
        if (!setupState.__isScriptSetup) {
            if ($b7779ef94f774395$var$isReservedPrefix(key[0])) {
                $b7779ef94f774395$var$warn$1("setup() return property ".concat(JSON.stringify(key), ' should not start with "$" or "_" which are reserved prefixes for Vue internals.'));
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function() {
                    return setupState[key];
                },
                set: (0, $6zvdv.NOOP)
            });
        }
    });
}
//#endregion
//#region packages/runtime-core/src/apiSetupHelpers.ts
var $b7779ef94f774395$var$warnRuntimeUsage = function(method) {
    return $b7779ef94f774395$var$warn$1("".concat(method, "() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect."));
};
function $b7779ef94f774395$export$80b33eababae110e() {
    return null;
}
function $b7779ef94f774395$export$51ecece22fc17ddc() {
    return null;
}
/**
* Vue `<script setup>` compiler macro for declaring a component's exposed
* instance properties when it is accessed by a parent component via template
* refs.
*
* `<script setup>` components are closed by default - i.e. variables inside
* the `<script setup>` scope is not exposed to parent unless explicitly exposed
* via `defineExpose`.
*
* This is only usable inside `<script setup>`, is compiled away in the
* output and should **not** be actually called at runtime.
*
* @see {@link https://vuejs.org/api/sfc-script-setup.html#defineexpose}
*/ function $b7779ef94f774395$export$da25b65ca24b518a(exposed) {}
/**
* Vue `<script setup>` compiler macro for declaring a component's additional
* options. This should be used only for options that cannot be expressed via
* Composition API - e.g. `inheritAttrs`.
*
* @see {@link https://vuejs.org/api/sfc-script-setup.html#defineoptions}
*/ function $b7779ef94f774395$export$77e79129327f3d0d(options) {}
/**
* Vue `<script setup>` compiler macro for providing type hints to IDEs for
* slot name and slot props type checking.
*
* Example usage:
* ```ts
* const slots = defineSlots<{
*   default(props: { msg: string }): any
* }>()
* ```
*
* This is only usable inside `<script setup>`, is compiled away in the
* output and should **not** be actually called at runtime.
*
* @see {@link https://vuejs.org/api/sfc-script-setup.html#defineslots}
*/ function $b7779ef94f774395$export$1b3acd4bb805b712() {
    return null;
}
function $b7779ef94f774395$export$acd55aa037e791bb() {}
/**
* Vue `<script setup>` compiler macro for providing props default values when
* using type-based `defineProps` declaration.
*
* Example usage:
* ```ts
* withDefaults(defineProps<{
*   size?: number
*   labels?: string[]
* }>(), {
*   size: 3,
*   labels: () => ['default label']
* })
* ```
*
* This is only usable inside `<script setup>`, is compiled away in the output
* and should **not** be actually called at runtime.
*
* @see {@link https://vuejs.org/guide/typescript/composition-api.html#typing-component-props}
*/ function $b7779ef94f774395$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $b7779ef94f774395$export$9203a8e84125433c() {
    return $b7779ef94f774395$var$getContext("useSlots").slots;
}
function $b7779ef94f774395$export$75e29435042cd2ea() {
    return $b7779ef94f774395$var$getContext("useAttrs").attrs;
}
function $b7779ef94f774395$var$getContext(calledFunctionName) {
    var i = $b7779ef94f774395$var$getCurrentGenericInstance();
    if (i.vapor) return i;
    else {
        var ii = i;
        return ii.setupContext || (ii.setupContext = $b7779ef94f774395$var$createSetupContext(ii));
    }
}
/**
* @internal
*/ function $b7779ef94f774395$var$normalizePropsOrEmits(props) {
    return (0, $6zvdv.isArray)(props) ? props.reduce(function(normalized, p) {
        return normalized[p] = null, normalized;
    }, {}) : props;
}
/**
* Runtime helper for merging default declarations. Imported by compiled code
* only.
* @internal
*/ function $b7779ef94f774395$export$ec60f47d4a8a2e7f(raw, defaults) {
    var props = $b7779ef94f774395$var$normalizePropsOrEmits(raw);
    for(var key in defaults){
        if (key.startsWith("__skip")) continue;
        var opt = props[key];
        if (opt) {
            if ((0, $6zvdv.isArray)(opt) || (0, $6zvdv.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults["__skip_".concat(key)]) opt.skipFactory = true;
    }
    return props;
}
/**
* Runtime helper for merging model declarations.
* Imported by compiled code only.
* @internal
*/ function $b7779ef94f774395$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $6zvdv.isArray)(a) && (0, $6zvdv.isArray)(b)) return a.concat(b);
    return (0, $6zvdv.extend)({}, $b7779ef94f774395$var$normalizePropsOrEmits(a), $b7779ef94f774395$var$normalizePropsOrEmits(b));
}
/**
* Used to create a proxy for the rest element when destructuring props with
* defineProps().
* @internal
*/ function $b7779ef94f774395$export$7c343e855c563faa(props, excludedKeys) {
    var _loop = function(key) {
        if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
            enumerable: true,
            get: function() {
                return props[key];
            }
        });
    };
    var ret = {};
    for(var key in props)_loop(key);
    return ret;
}
/**
* `<script setup>` helper for persisting the current instance context over
* async/await flows.
*
* `@vue/compiler-sfc` converts the following:
*
* ```ts
* const x = await foo()
* ```
*
* into:
*
* ```ts
* let __temp, __restore
* const x = (([__temp, __restore] = withAsyncContext(() => foo())),__temp=await __temp,__restore(),__temp)
* ```
* @internal
*/ function $b7779ef94f774395$export$d6d6f7369f1fb104(getAwaitable) {
    var ctx = $b7779ef94f774395$var$getCurrentGenericInstance();
    var inSSRSetup = $b7779ef94f774395$var$isInSSRComponentSetup;
    var awaitable = getAwaitable();
    $b7779ef94f774395$export$a5e695a16aa0b6d4(null, void 0);
    if (inSSRSetup) $b7779ef94f774395$var$setInSSRSetupState(false);
    var restore = function() {
        var stoppedScope = ctx && !ctx.scope.active ? ctx.scope : void 0;
        $b7779ef94f774395$export$a5e695a16aa0b6d4(ctx);
        if (inSSRSetup) $b7779ef94f774395$var$setInSSRSetupState(true);
        return stoppedScope;
    };
    var cleanup = function() {
        $b7779ef94f774395$export$a5e695a16aa0b6d4(null, void 0);
        if (inSSRSetup) $b7779ef94f774395$var$setInSSRSetupState(false);
    };
    if ((0, $6zvdv.isPromise)(awaitable)) awaitable = awaitable.catch(function(e) {
        var stoppedScope = restore();
        Promise.resolve().then(function() {
            return Promise.resolve().then(function() {
                if (stoppedScope) stoppedScope.reset();
                cleanup();
            });
        });
        throw e;
    });
    return [
        awaitable,
        function() {
            var stoppedScope = restore();
            Promise.resolve().then(function() {
                if (stoppedScope) stoppedScope.reset();
                cleanup();
            });
        }
    ];
}
//#endregion
//#region packages/runtime-core/src/componentOptions.ts
function $b7779ef94f774395$var$createDuplicateChecker() {
    var cache = Object.create(null);
    return function(type, key) {
        if (cache[key]) $b7779ef94f774395$var$warn$1("".concat(type, ' property "').concat(key, '" is already defined in ').concat(cache[key], "."));
        else cache[key] = type;
    };
}
var $b7779ef94f774395$var$shouldCacheAccess = true;
function $b7779ef94f774395$var$applyOptions(instance) {
    var _loop = function(key1) {
        var opt = computedOptions[key1];
        var get = (0, $6zvdv.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $6zvdv.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $6zvdv.NOOP);
        var set = !(0, $6zvdv.isFunction)(opt) && (0, $6zvdv.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $6zvdv.NOOP);
        var c = $b7779ef94f774395$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key1, {
            enumerable: true,
            configurable: true,
            get: function() {
                return c.value;
            },
            set: function(v1) {
                return c.value = v1;
            }
        });
    };
    var options = $b7779ef94f774395$var$resolveMergedOptions(instance);
    var publicThis = instance.proxy;
    var ctx = instance.ctx;
    $b7779ef94f774395$var$shouldCacheAccess = false;
    if (options.beforeCreate) $b7779ef94f774395$var$callHook(options.beforeCreate, instance, "bc");
    var dataOptions = options.data, computedOptions = options.computed, methods = options.methods, watchOptions = options.watch, provideOptions = options.provide, injectOptions = options.inject, created = options.created, beforeMount = options.beforeMount, mounted = options.mounted, beforeUpdate = options.beforeUpdate, updated = options.updated, activated = options.activated, deactivated = options.deactivated, beforeDestroy = options.beforeDestroy, beforeUnmount = options.beforeUnmount, destroyed = options.destroyed, unmounted = options.unmounted, render = options.render, renderTracked = options.renderTracked, renderTriggered = options.renderTriggered, errorCaptured = options.errorCaptured, serverPrefetch = options.serverPrefetch, expose = options.expose, inheritAttrs = options.inheritAttrs, components = options.components, directives = options.directives, filters = options.filters;
    var checkDuplicateProperties = null;
    if (injectOptions) $b7779ef94f774395$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(var key in methods){
        var methodHandler = methods[key];
        if ((0, $6zvdv.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        var data = dataOptions.call(publicThis, publicThis);
        if (!(0, $6zvdv.isObject)(data)) ;
        else instance.data = (0, $ftLbb.reactive)(data);
    }
    $b7779ef94f774395$var$shouldCacheAccess = true;
    if (computedOptions) for(var key1 in computedOptions)_loop(key1);
    if (watchOptions) for(var key2 in watchOptions)$b7779ef94f774395$var$createWatcher(watchOptions[key2], ctx, publicThis, key2);
    if (provideOptions) {
        var provides = (0, $6zvdv.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach(function(key) {
            $b7779ef94f774395$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $b7779ef94f774395$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $6zvdv.isArray)(hook)) hook.forEach(function(_hook) {
            return register(_hook.bind(publicThis));
        });
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($b7779ef94f774395$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($b7779ef94f774395$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($b7779ef94f774395$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($b7779ef94f774395$export$5876c47052fb88b1, updated);
    registerLifecycleHook($b7779ef94f774395$export$ba52d824b95a2154, activated);
    registerLifecycleHook($b7779ef94f774395$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($b7779ef94f774395$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($b7779ef94f774395$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($b7779ef94f774395$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($b7779ef94f774395$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($b7779ef94f774395$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($b7779ef94f774395$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $6zvdv.isArray)(expose)) {
        if (expose.length) {
            var exposed = instance.exposed || (instance.exposed = {});
            expose.forEach(function(key) {
                Object.defineProperty(exposed, key, {
                    get: function() {
                        return publicThis[key];
                    },
                    set: function(val) {
                        return publicThis[key] = val;
                    },
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $6zvdv.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $b7779ef94f774395$export$b9b0eeb564431e5e(instance);
}
function $b7779ef94f774395$var$resolveInjections(injectOptions, ctx) {
    var _loop = function(key) {
        var opt = injectOptions[key];
        var injected = void 0;
        if ((0, $6zvdv.isObject)(opt)) {
            if ("default" in opt) injected = $b7779ef94f774395$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $b7779ef94f774395$export$a976684a0efeb93f(opt.from || key);
        } else injected = $b7779ef94f774395$export$a976684a0efeb93f(opt);
        if ((0, $ftLbb.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return injected.value;
            },
            set: function(v1) {
                return injected.value = v1;
            }
        });
        else ctx[key] = injected;
    };
    var checkDuplicateProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $6zvdv.NOOP);
    if ((0, $6zvdv.isArray)(injectOptions)) injectOptions = $b7779ef94f774395$var$normalizeInject(injectOptions);
    for(var key in injectOptions)_loop(key);
}
function $b7779ef94f774395$var$callHook(hook, instance, type) {
    $b7779ef94f774395$export$dae85862a8d94378((0, $6zvdv.isArray)(hook) ? hook.map(function(h) {
        return h.bind(instance.proxy);
    }) : hook.bind(instance.proxy), instance, type);
}
function $b7779ef94f774395$var$createWatcher(raw, ctx, publicThis, key) {
    var getter = key.includes(".") ? $b7779ef94f774395$var$createPathGetter(publicThis, key) : function() {
        return publicThis[key];
    };
    if ((0, $6zvdv.isString)(raw)) {
        var handler = ctx[raw];
        if ((0, $6zvdv.isFunction)(handler)) $b7779ef94f774395$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $6zvdv.isFunction)(raw)) $b7779ef94f774395$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $6zvdv.isObject)(raw)) {
        if ((0, $6zvdv.isArray)(raw)) raw.forEach(function(r) {
            return $b7779ef94f774395$var$createWatcher(r, ctx, publicThis, key);
        });
        else {
            var handler1 = (0, $6zvdv.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $6zvdv.isFunction)(handler1)) $b7779ef94f774395$export$3db5d71bdb2d5499(getter, handler1, raw);
        }
    } else ;
}
/**
* Resolve merged options and cache it on the component.
* This is done only once per-component since the merging does not involve
* instances.
*/ function $b7779ef94f774395$var$resolveMergedOptions(instance) {
    var base = instance.type;
    var mixins = base.mixins, extendsOptions = base.extends;
    var _instance_appContext = instance.appContext, globalMixins = _instance_appContext.mixins, cache = _instance_appContext.optionsCache, optionMergeStrategies = _instance_appContext.config.optionMergeStrategies;
    var cached = cache.get(base);
    var resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach(function(m) {
            return $b7779ef94f774395$var$mergeOptions(resolved, m, optionMergeStrategies, true);
        });
        $b7779ef94f774395$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $6zvdv.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $b7779ef94f774395$var$mergeOptions(to, from, strats) {
    var asMixin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var mixins = from.mixins, extendsOptions = from.extends;
    if (extendsOptions) $b7779ef94f774395$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach(function(m) {
        return $b7779ef94f774395$var$mergeOptions(to, m, strats, true);
    });
    for(var key in from)if (asMixin && key === "expose") ;
    else {
        var strat = $b7779ef94f774395$var$internalOptionMergeStrats[key] || strats && strats[key];
        to[key] = strat ? strat(to[key], from[key]) : from[key];
    }
    return to;
}
var $b7779ef94f774395$var$internalOptionMergeStrats = {
    data: $b7779ef94f774395$var$mergeDataFn,
    props: $b7779ef94f774395$var$mergeEmitsOrPropsOptions,
    emits: $b7779ef94f774395$var$mergeEmitsOrPropsOptions,
    methods: $b7779ef94f774395$var$mergeObjectOptions,
    computed: $b7779ef94f774395$var$mergeObjectOptions,
    beforeCreate: $b7779ef94f774395$var$mergeAsArray,
    created: $b7779ef94f774395$var$mergeAsArray,
    beforeMount: $b7779ef94f774395$var$mergeAsArray,
    mounted: $b7779ef94f774395$var$mergeAsArray,
    beforeUpdate: $b7779ef94f774395$var$mergeAsArray,
    updated: $b7779ef94f774395$var$mergeAsArray,
    beforeDestroy: $b7779ef94f774395$var$mergeAsArray,
    beforeUnmount: $b7779ef94f774395$var$mergeAsArray,
    destroyed: $b7779ef94f774395$var$mergeAsArray,
    unmounted: $b7779ef94f774395$var$mergeAsArray,
    activated: $b7779ef94f774395$var$mergeAsArray,
    deactivated: $b7779ef94f774395$var$mergeAsArray,
    errorCaptured: $b7779ef94f774395$var$mergeAsArray,
    serverPrefetch: $b7779ef94f774395$var$mergeAsArray,
    components: $b7779ef94f774395$var$mergeObjectOptions,
    directives: $b7779ef94f774395$var$mergeObjectOptions,
    watch: $b7779ef94f774395$var$mergeWatchOptions,
    provide: $b7779ef94f774395$var$mergeDataFn,
    inject: $b7779ef94f774395$var$mergeInject
};
function $b7779ef94f774395$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $6zvdv.extend)((0, $6zvdv.isFunction)(to) ? to.call(this, this) : to, (0, $6zvdv.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $b7779ef94f774395$var$mergeInject(to, from) {
    return $b7779ef94f774395$var$mergeObjectOptions($b7779ef94f774395$var$normalizeInject(to), $b7779ef94f774395$var$normalizeInject(from));
}
function $b7779ef94f774395$var$normalizeInject(raw) {
    if ((0, $6zvdv.isArray)(raw)) {
        var res = {};
        for(var i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $b7779ef94f774395$var$mergeAsArray(to, from) {
    return to ? (0, $aUGqu._)(new Set([].concat(to, from))) : from;
}
function $b7779ef94f774395$var$mergeObjectOptions(to, from) {
    return to ? (0, $6zvdv.extend)(Object.create(null), to, from) : from;
}
function $b7779ef94f774395$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $6zvdv.isArray)(to) && (0, $6zvdv.isArray)(from)) return (0, $aUGqu._)(/* @__PURE__ */ new Set((0, $aUGqu._)(to).concat((0, $aUGqu._)(from))));
        return (0, $6zvdv.extend)(Object.create(null), $b7779ef94f774395$var$normalizePropsOrEmits(to), $b7779ef94f774395$var$normalizePropsOrEmits(from !== null && from !== void 0 ? from : {}));
    } else return from;
}
function $b7779ef94f774395$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    var merged = (0, $6zvdv.extend)(Object.create(null), to);
    for(var key in from)merged[key] = $b7779ef94f774395$var$mergeAsArray(to[key], from[key]);
    return merged;
}
//#endregion
//#region packages/runtime-core/src/apiCreateApp.ts
function $b7779ef94f774395$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $6zvdv.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
var $b7779ef94f774395$var$uid$1 = 0;
/**
* @internal
*/ function $b7779ef94f774395$export$20a32069df128d70(mount, unmount, getPublicInstance, render) {
    return function createApp(rootComponent) {
        var rootProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!(0, $6zvdv.isFunction)(rootComponent)) rootComponent = (0, $6zvdv.extend)({}, rootComponent);
        if (rootProps != null && !(0, $6zvdv.isObject)(rootProps)) rootProps = null;
        var context = $b7779ef94f774395$var$createAppContext();
        var installedPlugins = /* @__PURE__ */ new WeakSet();
        var pluginCleanupFns = [];
        var isMounted = false;
        var app = context.app = {
            _uid: $b7779ef94f774395$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $b7779ef94f774395$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use: function(plugin) {
                for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    options[_key - 1] = arguments[_key];
                }
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $6zvdv.isFunction)(plugin.install)) {
                    var _plugin;
                    installedPlugins.add(plugin);
                    (_plugin = plugin).install.apply(_plugin, [
                        app
                    ].concat((0, $aUGqu._)(options)));
                } else if ((0, $6zvdv.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin.apply(void 0, [
                        app
                    ].concat((0, $aUGqu._)(options)));
                }
                return app;
            },
            mixin: function(mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component: function(name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive: function(name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount: function(rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    var instance = mount(app, rootContainer, isHydrate, namespace);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = instance;
                        $b7779ef94f774395$var$devtoolsInitApp(app, $b7779ef94f774395$export$83d89fbfd8236492);
                    }
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    return getPublicInstance(instance);
                }
            },
            onUnmount: function(cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount: function() {
                if (isMounted) {
                    $b7779ef94f774395$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    unmount(app);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $b7779ef94f774395$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide: function(key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext: function(fn) {
                var lastApp = $b7779ef94f774395$var$currentApp;
                $b7779ef94f774395$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $b7779ef94f774395$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
/**
* @internal Used to identify the current app when using `inject()` within
* `app.runWithContext()`.
*/ var $b7779ef94f774395$var$currentApp = null;
//#endregion
//#region packages/runtime-core/src/helpers/useModel.ts
function $b7779ef94f774395$export$fb78bd113157f1a1(props, name) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $6zvdv.EMPTY_OBJ);
    var i = $b7779ef94f774395$var$getCurrentGenericInstance();
    var camelizedName = (0, $6zvdv.camelize)(name);
    var hyphenatedName = (0, $6zvdv.hyphenate)(name);
    var modifiers = $b7779ef94f774395$var$getModelModifiers(props, camelizedName, $b7779ef94f774395$export$ea66d7ac9b8996b6);
    var res = (0, $ftLbb.customRef)(function(track, trigger) {
        var localValue;
        var prevSetValue = (0, $6zvdv.EMPTY_OBJ);
        var prevEmittedValue;
        $b7779ef94f774395$export$2035654f31b0e555(function() {
            var propValue = props[camelizedName];
            if ((0, $6zvdv.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get: function() {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set: function(value) {
                var emittedValue = options.set ? options.set(value) : value;
                if (!(0, $6zvdv.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $6zvdv.EMPTY_OBJ) && (0, $6zvdv.hasChanged)(value, prevSetValue))) return;
                var rawPropKeys;
                var parentPassedModelValue = false;
                var parentPassedModelUpdater = false;
                if (i.rawKeys) rawPropKeys = i.rawKeys();
                else {
                    var rawProps = i.vnode.props;
                    rawPropKeys = rawProps && Object.keys(rawProps);
                }
                if (rawPropKeys) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = rawPropKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var key = _step.value;
                            if (key === name || key === camelizedName || key === hyphenatedName) parentPassedModelValue = true;
                            else if (key === "onUpdate:".concat(name) || key === "onUpdate:".concat(camelizedName) || key === "onUpdate:".concat(hyphenatedName)) parentPassedModelUpdater = true;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                var hasVModel = parentPassedModelValue && parentPassedModelUpdater;
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit("update:".concat(name), emittedValue);
                if ((0, $6zvdv.hasChanged)(value, prevSetValue) && ((0, $6zvdv.hasChanged)(value, emittedValue) && !(0, $6zvdv.hasChanged)(emittedValue, prevEmittedValue) || hasVModel && prevSetValue !== (0, $6zvdv.EMPTY_OBJ) && !(0, $6zvdv.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = function() {
        var i = 0;
        return {
            next: function() {
                if (i < 2) return {
                    value: i++ ? modifiers || (0, $6zvdv.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
var $b7779ef94f774395$var$getModelModifiers = function(props, modelName, getter) {
    return getter(props, (0, $6zvdv.getModifierPropName)(modelName)) || getter(props, "".concat((0, $6zvdv.camelize)(modelName), "Modifiers")) || getter(props, "".concat((0, $6zvdv.hyphenate)(modelName), "Modifiers"));
};
//#endregion
//#region packages/runtime-core/src/componentEmits.ts
function $b7779ef94f774395$var$emit(instance, event) {
    for(var _len = arguments.length, rawArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rawArgs[_key - 2] = arguments[_key];
    }
    return $b7779ef94f774395$export$15f4c4319e4e597d.apply(void 0, [
        instance,
        instance.vnode.props || (0, $6zvdv.EMPTY_OBJ),
        $b7779ef94f774395$export$ea66d7ac9b8996b6,
        event
    ].concat((0, $aUGqu._)(rawArgs)));
}
/**
* @internal for vapor only
*/ function $b7779ef94f774395$export$15f4c4319e4e597d(instance, props, getter, event) {
    for(var _len = arguments.length, rawArgs = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
        rawArgs[_key - 4] = arguments[_key];
    }
    if (instance.isUnmounted) return;
    var args = rawArgs;
    var isModelListener = event.startsWith("update:");
    var modifiers = isModelListener && $b7779ef94f774395$var$getModelModifiers(props, event.slice(7), getter);
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map(function(a) {
            return (0, $6zvdv.isString)(a) ? a.trim() : a;
        });
        if (modifiers.number) args = args.map((0, $6zvdv.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$var$devtoolsComponentEmit(instance, event, args);
    var handlerName;
    var handler = getter(props, handlerName = (0, $6zvdv.toHandlerKey)(event)) || getter(props, handlerName = (0, $6zvdv.toHandlerKey)((0, $6zvdv.camelize)(event)));
    if (!handler && isModelListener) handler = getter(props, handlerName = (0, $6zvdv.toHandlerKey)((0, $6zvdv.hyphenate)(event)));
    if (handler) $b7779ef94f774395$export$dae85862a8d94378(handler, instance, 6, args);
    var onceHandler = getter(props, handlerName + "Once");
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $b7779ef94f774395$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $b7779ef94f774395$export$ea66d7ac9b8996b6(props, key) {
    return props[key];
}
var $b7779ef94f774395$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $b7779ef94f774395$var$normalizeEmitsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = __VUE_OPTIONS_API__ && asMixin ? $b7779ef94f774395$var$mixinEmitsCache : appContext.emitsCache;
    var cached = cache.get(comp);
    if (cached !== void 0) return cached;
    var raw = comp.emits;
    var normalized = {};
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $6zvdv.isFunction)(comp)) {
        var extendEmits = function(raw) {
            var normalizedFromExtend = $b7779ef94f774395$var$normalizeEmitsOptions(raw, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $6zvdv.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $6zvdv.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $6zvdv.isArray)(raw)) raw.forEach(function(key) {
        return normalized[key] = null;
    });
    else (0, $6zvdv.extend)(normalized, raw);
    if ((0, $6zvdv.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
/**
* Check if an incoming prop key is a declared emit event listener.
* e.g. With `emits: { click: null }`, props named `onClick` and `onclick` are
* both considered matched listeners.
*
* @internal for vapor only
*/ function $b7779ef94f774395$export$bd525f5264ebdc33(options, key) {
    if (!options || !(0, $6zvdv.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $6zvdv.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $6zvdv.hasOwn)(options, (0, $6zvdv.hyphenate)(key)) || (0, $6zvdv.hasOwn)(options, key);
}
//#endregion
//#region packages/runtime-core/src/componentRenderUtils.ts
/**
* dev only flag to track whether $attrs was used during render.
* If $attrs was used during render then the warning for failed attrs
* fallthrough can be suppressed.
*/ var $b7779ef94f774395$var$accessedAttrs = false;
function $b7779ef94f774395$var$markAttrsAccessed() {
    $b7779ef94f774395$var$accessedAttrs = true;
}
function $b7779ef94f774395$var$renderComponentRoot(instance) {
    var Component = instance.type, vnode = instance.vnode, proxy = instance.proxy, withProxy = instance.withProxy, _instance_propsOptions = (0, $f9AOD._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0], slots = instance.slots, attrs = instance.attrs, emit = instance.emit, render = instance.render, renderCache = instance.renderCache, props = instance.props, data = instance.data, setupState = instance.setupState, ctx = instance.ctx, inheritAttrs = instance.inheritAttrs;
    var prev = $b7779ef94f774395$export$824c074beef4c41b(instance);
    var result;
    var fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            var proxyToUse = withProxy || proxy;
            var thisProxy = proxyToUse;
            result = $b7779ef94f774395$export$a0e1465ad202d515(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            var render1 = Component;
            result = $b7779ef94f774395$export$a0e1465ad202d515(render1.length > 1 ? render1(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render1(props, null));
            fallthroughAttrs = Component.props ? attrs : $b7779ef94f774395$export$f83a77e4c783b3a2(attrs);
        }
    } catch (err) {
        $b7779ef94f774395$var$blockStack.length = 0;
        $b7779ef94f774395$export$d3da1ecaf1206c58(err, instance, 1);
        result = $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$4d299b491347818a);
    }
    var root = result;
    var setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        var keys = Object.keys(fallthroughAttrs);
        var shapeFlag = root.shapeFlag;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $6zvdv.isModelListener))) fallthroughAttrs = $b7779ef94f774395$export$316c7e1847985a1d(fallthroughAttrs, propsOptions);
                root = $b7779ef94f774395$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $b7779ef94f774395$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        var child = $b7779ef94f774395$var$isTeleport(root.type) ? $b7779ef94f774395$var$getInnerChild$1(root) || root : root;
        $b7779ef94f774395$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $b7779ef94f774395$export$824c074beef4c41b(prev);
    return result;
}
/**
* dev only
* In dev mode, template root level comments are rendered, which turns the
* template into a fragment root, but we need to locate the single element
* root for attrs and scope id processing.
*/ var $b7779ef94f774395$var$getChildRoot = function(vnode) {
    var rawChildren = vnode.children;
    var dynamicChildren = vnode.dynamicChildren;
    var childRoot = $b7779ef94f774395$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    var index = rawChildren.indexOf(childRoot);
    var dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    var setRoot = function(updatedRoot) {
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = (0, $aUGqu._)(dynamicChildren).concat([
                updatedRoot
            ]);
        }
    };
    return [
        $b7779ef94f774395$export$a0e1465ad202d515(childRoot),
        setRoot
    ];
};
/**
* Dev only
*/ function $b7779ef94f774395$export$b82d7003bc568535(attrs) {
    var allAttrs = Object.keys(attrs);
    var eventAttrs = [];
    var extraAttrs = [];
    for(var i = 0, l = allAttrs.length; i < l; i++){
        var key = allAttrs[i];
        if ((0, $6zvdv.isOn)(key)) {
            if (!(0, $6zvdv.isModelListener)(key)) eventAttrs.push(key[2].toLowerCase() + key.slice(3));
        } else extraAttrs.push(key);
    }
    if (extraAttrs.length) $b7779ef94f774395$var$warn$1("Extraneous non-props attributes (".concat(extraAttrs.join(", "), ") were passed to component but could not be automatically inherited because component renders fragment or text or teleport root nodes."));
    if (eventAttrs.length) $b7779ef94f774395$var$warn$1("Extraneous non-emits event listeners (".concat(eventAttrs.join(", "), ') were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.'));
}
function $b7779ef94f774395$var$filterSingleRoot(children) {
    var recurse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var singleRoot;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if ($b7779ef94f774395$export$3868d13f8734ae81(child)) {
            if (child.type !== $b7779ef94f774395$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
var $b7779ef94f774395$export$80ff18eb01272c8e = function(key) {
    return key === "class" || key === "style" || (0, $6zvdv.isOn)(key);
};
var $b7779ef94f774395$export$f83a77e4c783b3a2 = function(attrs) {
    var res;
    for(var key in attrs)if ($b7779ef94f774395$export$80ff18eb01272c8e(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
var $b7779ef94f774395$export$316c7e1847985a1d = function(attrs, props) {
    var res = {};
    for(var key in attrs)if (!(0, $6zvdv.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
var $b7779ef94f774395$var$isElementRoot = function(vnode) {
    return vnode.shapeFlag & 7 || vnode.type === $b7779ef94f774395$export$4d299b491347818a;
};
function $b7779ef94f774395$export$225fd36bef19d8c6(prevVNode, nextVNode, optimized) {
    var prevProps = prevVNode.props, prevChildren = prevVNode.children, component = prevVNode.component;
    var nextProps = nextVNode.props, nextChildren = nextVNode.children, patchFlag = nextVNode.patchFlag;
    var emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $b7779ef94f774395$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            var dynamicProps = nextVNode.dynamicProps;
            for(var i = 0; i < dynamicProps.length; i++){
                var key = dynamicProps[i];
                if ($b7779ef94f774395$var$hasPropValueChanged(nextProps, prevProps, key) && !$b7779ef94f774395$export$bd525f5264ebdc33(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $b7779ef94f774395$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $b7779ef94f774395$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    var nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(var i = 0; i < nextKeys.length; i++){
        var key = nextKeys[i];
        if ($b7779ef94f774395$var$hasPropValueChanged(nextProps, prevProps, key) && !$b7779ef94f774395$export$bd525f5264ebdc33(emitsOptions, key)) return true;
    }
    return false;
}
function $b7779ef94f774395$var$hasPropValueChanged(nextProps, prevProps, key) {
    var nextProp = nextProps[key];
    var prevProp = prevProps[key];
    if (key === "style" && (0, $6zvdv.isObject)(nextProp) && (0, $6zvdv.isObject)(prevProp)) return !(0, $6zvdv.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $b7779ef94f774395$var$updateHOCHostEl(param, el) {
    var vnode = param.vnode, parent = param.parent, suspense = param.suspense;
    while(parent && !parent.vapor){
        var root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
//#endregion
//#region packages/runtime-core/src/internalObject.ts
/**
* Used during vnode props/slots normalization to check if the vnode props/slots
* are the internal attrs / slots object of a component via
* `Object.getPrototypeOf`. This is more performant than defining a
* non-enumerable property. (one of the optimizations done for ssr-benchmark)
*/ var $b7779ef94f774395$var$internalObjectProto = {};
var $b7779ef94f774395$export$1fa0ca5a6375b7 = function() {
    return Object.create($b7779ef94f774395$var$internalObjectProto);
};
var $b7779ef94f774395$var$isInternalObject = function(obj) {
    return Object.getPrototypeOf(obj) === $b7779ef94f774395$var$internalObjectProto;
};
//#endregion
//#region packages/runtime-core/src/componentProps.ts
function $b7779ef94f774395$var$initProps(instance, rawProps, isStateful) {
    var isSSR = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = instance.props = {};
    var attrs = $b7779ef94f774395$export$1fa0ca5a6375b7();
    instance.propsDefaults = Object.create(null);
    $b7779ef94f774395$var$setFullProps(instance, rawProps, props, attrs);
    for(var key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $ftLbb.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $b7779ef94f774395$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $b7779ef94f774395$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    var props = instance.props, attrs = instance.attrs, patchFlag = instance.vnode.patchFlag;
    var rawCurrentProps = (0, $ftLbb.toRaw)(props);
    var _instance_propsOptions = (0, $f9AOD._)(instance.propsOptions, 1), options = _instance_propsOptions[0];
    var hasAttrsChanged = false;
    if ((optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            var propsToUpdate = instance.vnode.dynamicProps;
            for(var i = 0; i < propsToUpdate.length; i++){
                var key = propsToUpdate[i];
                if ($b7779ef94f774395$export$bd525f5264ebdc33(instance.emitsOptions, key)) continue;
                var value = rawProps[key];
                if (options) {
                    if ((0, $6zvdv.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        var camelizedKey = (0, $6zvdv.camelize)(key);
                        props[camelizedKey] = $b7779ef94f774395$export$ba06f8f07b4aa3a7(options, camelizedKey, value, instance, $b7779ef94f774395$var$baseResolveDefault);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($b7779ef94f774395$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        var kebabKey;
        for(var key1 in rawCurrentProps)if (!rawProps || !(0, $6zvdv.hasOwn)(rawProps, key1) && ((kebabKey = (0, $6zvdv.hyphenate)(key1)) === key1 || !(0, $6zvdv.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && (rawPrevProps[key1] !== void 0 || rawPrevProps[kebabKey] !== void 0)) props[key1] = $b7779ef94f774395$export$ba06f8f07b4aa3a7(options, key1, void 0, instance, $b7779ef94f774395$var$baseResolveDefault, true);
            } else delete props[key1];
        }
        if (attrs !== rawCurrentProps) {
            for(var key2 in attrs)if (!rawProps || !(0, $6zvdv.hasOwn)(rawProps, key2) && true) {
                delete attrs[key2];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $ftLbb.trigger)(instance.attrs, "set", "");
}
function $b7779ef94f774395$var$setFullProps(instance, rawProps, props, attrs) {
    var _instance_propsOptions = (0, $f9AOD._)(instance.propsOptions, 2), options = _instance_propsOptions[0], needCastKeys = _instance_propsOptions[1];
    var hasAttrsChanged = false;
    var rawCastValues;
    if (rawProps) for(var key in rawProps){
        if ((0, $6zvdv.isReservedProp)(key)) continue;
        var value = rawProps[key];
        var camelKey = void 0;
        if (options && (0, $6zvdv.hasOwn)(options, camelKey = (0, $6zvdv.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$b7779ef94f774395$export$bd525f5264ebdc33(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        var castValues = rawCastValues || (0, $6zvdv.EMPTY_OBJ);
        for(var i = 0; i < needCastKeys.length; i++){
            var key1 = needCastKeys[i];
            props[key1] = $b7779ef94f774395$export$ba06f8f07b4aa3a7(options, key1, castValues[key1], instance, $b7779ef94f774395$var$baseResolveDefault, !(0, $6zvdv.hasOwn)(castValues, key1));
        }
    }
    return hasAttrsChanged;
}
/**
* @internal for runtime-vapor
*/ function $b7779ef94f774395$export$ba06f8f07b4aa3a7(options, key, value, instance, resolveDefault) {
    var isAbsent = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    var opt = options[key];
    if (opt != null) {
        var hasDefault = (0, $6zvdv.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            var defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $6zvdv.isFunction)(defaultValue)) {
                var cachedDefaults = instance.propsDefaults || (instance.propsDefaults = {});
                if ((0, $6zvdv.hasOwn)(cachedDefaults, key)) value = cachedDefaults[key];
                else value = cachedDefaults[key] = resolveDefault(defaultValue, instance, key);
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1] && (value === "" || value === (0, $6zvdv.hyphenate)(key))) value = true;
        }
    }
    return value;
}
/**
* runtime-dom-specific default resolving logic
*/ function $b7779ef94f774395$var$baseResolveDefault(factory, instance, key) {
    var value;
    var prev = $b7779ef94f774395$export$a5e695a16aa0b6d4(instance);
    var props = (0, $ftLbb.toRaw)(instance.props);
    value = factory.call(null, props);
    $b7779ef94f774395$export$95e96a1fb881e3e7(prev);
    return value;
}
var $b7779ef94f774395$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $b7779ef94f774395$var$normalizePropsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = __VUE_OPTIONS_API__ && asMixin ? $b7779ef94f774395$var$mixinPropsCache : appContext.propsCache;
    var cached = cache.get(comp);
    if (cached) return cached;
    var raw = comp.props;
    var normalized = {};
    var needCastKeys = [];
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $6zvdv.isFunction)(comp)) {
        var extendProps = function(raw) {
            var _needCastKeys;
            hasExtends = true;
            var _normalizePropsOptions = (0, $f9AOD._)($b7779ef94f774395$var$normalizePropsOptions(raw, appContext, true), 2), props = _normalizePropsOptions[0], keys = _normalizePropsOptions[1];
            (0, $6zvdv.extend)(normalized, props);
            if (keys) (_needCastKeys = needCastKeys).push.apply(_needCastKeys, (0, $aUGqu._)(keys));
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $6zvdv.isObject)(comp)) cache.set(comp, (0, $6zvdv.EMPTY_ARR));
        return 0, $6zvdv.EMPTY_ARR;
    }
    $b7779ef94f774395$export$f0eb979c68386821(raw, normalized, needCastKeys);
    var res = [
        normalized,
        needCastKeys
    ];
    if ((0, $6zvdv.isObject)(comp)) cache.set(comp, res);
    return res;
}
/**
* @internal for runtime-vapor only
*/ function $b7779ef94f774395$export$f0eb979c68386821(raw, normalized, needCastKeys) {
    if ((0, $6zvdv.isArray)(raw)) for(var i = 0; i < raw.length; i++){
        var normalizedKey = (0, $6zvdv.camelize)(raw[i]);
        if ($b7779ef94f774395$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $6zvdv.EMPTY_OBJ);
    }
    else if (raw) for(var key in raw){
        var normalizedKey1 = (0, $6zvdv.camelize)(key);
        if ($b7779ef94f774395$var$validatePropName(normalizedKey1)) {
            var opt = raw[key];
            var prop = normalized[normalizedKey1] = (0, $6zvdv.isArray)(opt) || (0, $6zvdv.isFunction)(opt) ? {
                type: opt
            } : (0, $6zvdv.extend)({}, opt);
            var propType = prop.type;
            var shouldCast = false;
            var shouldCastTrue = true;
            if ((0, $6zvdv.isArray)(propType)) for(var index = 0; index < propType.length; ++index){
                var type = propType[index];
                var typeName = (0, $6zvdv.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $6zvdv.isFunction)(propType) && propType.name === "Boolean";
            prop[0] = shouldCast;
            prop[1] = shouldCastTrue;
            if (shouldCast || (0, $6zvdv.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey1);
        }
    }
}
function $b7779ef94f774395$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $6zvdv.isReservedProp)(key)) return true;
    return false;
}
function $b7779ef94f774395$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if ((typeof ctor === "undefined" ? "undefined" : (0, $7E0eS._)(ctor)) === "object") return ctor.constructor && ctor.constructor.name || "";
    return "";
}
/**
* dev only
* @internal
*/ function $b7779ef94f774395$export$45855e0dd982478b(rawProps, resolvedProps, options) {
    resolvedProps = (0, $ftLbb.toRaw)(resolvedProps);
    var camelizePropsKey = Object.keys(rawProps).map(function(key) {
        return (0, $6zvdv.camelize)(key);
    });
    for(var key in options){
        var opt = options[key];
        if (opt != null) $b7779ef94f774395$var$validateProp(key, resolvedProps[key], opt, resolvedProps, !camelizePropsKey.includes(key));
    }
}
/**
* dev only
*/ function $b7779ef94f774395$var$validateProp(key, value, propOptions, resolvedProps, isAbsent) {
    var type = propOptions.type, required = propOptions.required, validator = propOptions.validator, skipCheck = propOptions.skipCheck;
    if (required && isAbsent) {
        $b7779ef94f774395$var$warn$1("Missing required prop: \"" + key + "\"");
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        var isValid = false;
        var types = (0, $6zvdv.isArray)(type) ? type : [
            type
        ];
        var expectedTypes = [];
        for(var i = 0; i < types.length && !isValid; i++){
            var _assertType = $b7779ef94f774395$var$assertType(value, types[i]), valid = _assertType.valid, expectedType = _assertType.expectedType;
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $b7779ef94f774395$var$warn$1($b7779ef94f774395$var$getInvalidTypeMessage(key, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, resolvedProps)) $b7779ef94f774395$var$warn$1("Invalid prop: custom validator check failed for prop \"" + key + "\".");
}
var $b7779ef94f774395$var$isSimpleType = /*@__PURE__*/ (0, $6zvdv.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
/**
* dev only
*/ function $b7779ef94f774395$var$assertType(value, type) {
    var valid;
    var expectedType = $b7779ef94f774395$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($b7779ef94f774395$var$isSimpleType(expectedType)) {
        var t = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $6zvdv.isObject)(value);
    else if (expectedType === "Array") valid = (0, $6zvdv.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
/**
* dev only
*/ function $b7779ef94f774395$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return 'Prop type [] for prop "'.concat(name, "\" won't match anything. Did you mean to use type Array instead?");
    var message = 'Invalid prop: type check failed for prop "'.concat(name, '". Expected ').concat(expectedTypes.map((0, $6zvdv.capitalize)).join(" | "));
    var expectedType = expectedTypes[0];
    var receivedType = (0, $6zvdv.toRawType)(value);
    var expectedValue = $b7779ef94f774395$var$styleValue(value, expectedType);
    var receivedValue = $b7779ef94f774395$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $b7779ef94f774395$var$isExplicable(expectedType) && $b7779ef94f774395$var$isCoercible(expectedType, receivedType)) message += " with value ".concat(expectedValue);
    message += ", got ".concat(receivedType, " ");
    if ($b7779ef94f774395$var$isExplicable(receivedType)) message += "with value ".concat(receivedValue, ".");
    return message;
}
/**
* dev only
*/ function $b7779ef94f774395$var$styleValue(value, type) {
    if ((0, $6zvdv.isSymbol)(value)) return value.toString();
    else if (type === "String") return '"'.concat(value, '"');
    else if (type === "Number") return "".concat(Number(value));
    else return "".concat(value);
}
/**
* dev only
*/ function $b7779ef94f774395$var$isExplicable(type) {
    return [
        "string",
        "number",
        "boolean"
    ].some(function(elem) {
        return type.toLowerCase() === elem;
    });
}
/**
* dev only
*/ function $b7779ef94f774395$var$isCoercible() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.every(function(elem) {
        var value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
//#endregion
//#region packages/runtime-core/src/componentSlots.ts
var $b7779ef94f774395$var$isInternalKey = function(key) {
    return key === "_" || key === "_ctx" || key === "$stable";
};
var $b7779ef94f774395$var$normalizeSlotValue = function(value) {
    return (0, $6zvdv.isArray)(value) ? value.map($b7779ef94f774395$export$a0e1465ad202d515) : [
        $b7779ef94f774395$export$a0e1465ad202d515(value)
    ];
};
var $b7779ef94f774395$var$normalizeSlot = function(key, rawSlot, ctx) {
    if (rawSlot._n) return rawSlot;
    var normalized = $b7779ef94f774395$export$694b237e827a3d23(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $b7779ef94f774395$var$normalizeSlotValue(rawSlot.apply(void 0, (0, $aUGqu._)(args)));
    }, ctx);
    normalized._c = false;
    return normalized;
};
var $b7779ef94f774395$var$normalizeObjectSlots = function(rawSlots, slots, instance) {
    var _loop = function(key) {
        if ($b7779ef94f774395$var$isInternalKey(key)) return "continue";
        var value = rawSlots[key];
        if ((0, $6zvdv.isFunction)(value)) slots[key] = $b7779ef94f774395$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            var normalized = $b7779ef94f774395$var$normalizeSlotValue(value);
            slots[key] = function() {
                return normalized;
            };
        }
    };
    var ctx = rawSlots._ctx;
    for(var key in rawSlots)_loop(key);
};
var $b7779ef94f774395$var$normalizeVNodeSlots = function(instance, children) {
    var normalized = $b7779ef94f774395$var$normalizeSlotValue(children);
    instance.slots.default = function() {
        return normalized;
    };
};
var $b7779ef94f774395$var$assignSlots = function(slots, children, optimized) {
    for(var key in children)if (optimized || !$b7779ef94f774395$var$isInternalKey(key)) slots[key] = children[key];
};
var $b7779ef94f774395$var$initSlots = function(instance, children, optimized) {
    var slots = instance.slots = $b7779ef94f774395$export$1fa0ca5a6375b7();
    if (instance.vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            $b7779ef94f774395$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $6zvdv.def)(slots, "_", type, true);
        } else $b7779ef94f774395$var$normalizeObjectSlots(children, slots, instance);
    } else if (children) $b7779ef94f774395$var$normalizeVNodeSlots(instance, children);
};
var $b7779ef94f774395$var$updateSlots = function(instance, children, optimized) {
    var vnode = instance.vnode, slots = instance.slots;
    var needDeletionCheck = true;
    var deletionComparisonTarget = (0, $6zvdv.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $b7779ef94f774395$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $b7779ef94f774395$var$normalizeObjectSlots(children, slots, instance);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $b7779ef94f774395$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(var key in slots)if (!$b7779ef94f774395$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
//#endregion
//#region packages/runtime-core/src/profiling.ts
var $b7779ef94f774395$var$supported;
var $b7779ef94f774395$var$perf;
var $b7779ef94f774395$var$cachedNow = 0;
var $b7779ef94f774395$var$p = /*@__PURE__*/ Promise.resolve();
var $b7779ef94f774395$var$getNow = function() {
    return $b7779ef94f774395$var$cachedNow || ($b7779ef94f774395$var$p.then(function() {
        return $b7779ef94f774395$var$cachedNow = 0;
    }), $b7779ef94f774395$var$cachedNow = $b7779ef94f774395$var$isSupported() ? $b7779ef94f774395$var$perf.now() : Date.now());
};
/**
* @internal
*/ function $b7779ef94f774395$export$b62aa2130c86b59b(instance, type) {
    if (instance.appContext.config.performance && $b7779ef94f774395$var$isSupported()) $b7779ef94f774395$var$perf.mark("vue-".concat(type, "-").concat(instance.uid));
    if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$var$devtoolsPerfStart(instance, type, $b7779ef94f774395$var$getNow());
}
/**
* @internal
*/ function $b7779ef94f774395$export$97a67d1a5c124236(instance, type) {
    if (instance.appContext.config.performance && $b7779ef94f774395$var$isSupported()) {
        var startTag = "vue-".concat(type, "-").concat(instance.uid);
        var endTag = startTag + ":end";
        var measureName = "<".concat($b7779ef94f774395$var$formatComponentName(instance, instance.type), "> ").concat(type);
        $b7779ef94f774395$var$perf.mark(endTag);
        $b7779ef94f774395$var$perf.measure(measureName, startTag, endTag);
        $b7779ef94f774395$var$perf.clearMeasures(measureName);
        $b7779ef94f774395$var$perf.clearMarks(startTag);
        $b7779ef94f774395$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$var$devtoolsPerfEnd(instance, type, $b7779ef94f774395$var$getNow());
}
function $b7779ef94f774395$var$isSupported() {
    if ($b7779ef94f774395$var$supported !== void 0) return $b7779ef94f774395$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $b7779ef94f774395$var$supported = true;
        $b7779ef94f774395$var$perf = window.performance;
    } else $b7779ef94f774395$var$supported = false;
    return $b7779ef94f774395$var$supported;
}
//#endregion
//#region packages/runtime-core/src/featureFlags.ts
var $b7779ef94f774395$var$initialized = false;
/**
* This is only called in esm-bundler builds.
* It is called when a renderer is created, in `baseCreateRenderer` so that
* importing runtime-core is side-effects free.
*/ function $b7779ef94f774395$export$f9d0db67c92b2ab2() {
    if ($b7779ef94f774395$var$initialized) return;
    var needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $6zvdv.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $6zvdv.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $6zvdv.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
    $b7779ef94f774395$var$initialized = true;
}
//#endregion
//#region packages/runtime-core/src/renderer.ts
var $b7779ef94f774395$export$be204faa7b4ee90a = {
    "ENTER": 0,
    "0": "ENTER",
    "LEAVE": 1,
    "1": "LEAVE",
    "REORDER": 2,
    "2": "REORDER"
};
var $b7779ef94f774395$export$51ec8e020844a97a = $b7779ef94f774395$var$queueEffectWithSuspense;
/**
* The createRenderer function accepts two generic arguments:
* HostNode and HostElement, corresponding to Node and Element types in the
* host environment. For example, for runtime-dom, HostNode would be the DOM
* `Node` interface and HostElement would be the DOM `Element` interface.
*
* Custom renderers can pass in the platform specific types like this:
*
* ``` js
* const { render, createApp } = createRenderer<Node, Element>({
*   patchProp,
*   ...nodeOps
* })
* ```
*/ function $b7779ef94f774395$export$53ae2f996c64e9a(options) {
    return $b7779ef94f774395$var$baseCreateRenderer(options);
}
function $b7779ef94f774395$export$200524cf0d997ff0(options) {
    return $b7779ef94f774395$var$baseCreateRenderer(options, $b7779ef94f774395$var$createHydrationFunctions);
}
function $b7779ef94f774395$var$baseCreateRenderer(options, createHydrationFns) {
    $b7779ef94f774395$export$f9d0db67c92b2ab2();
    var target = (0, $6zvdv.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    var hostInsert = options.insert, hostRemove = options.remove, hostPatchProp = options.patchProp, hostCreateElement = options.createElement, hostCreateText = options.createText, hostCreateComment = options.createComment, hostSetText = options.setText, hostSetElementText = options.setElementText, hostParentNode = options.parentNode, hostNextSibling = options.nextSibling, tmp = options.setScopeId, hostSetScopeId = tmp === void 0 ? (0, $6zvdv.NOOP) : tmp, hostInsertStaticContent = options.insertStaticContent;
    var patch = function(n1, n2, container) {
        var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, parentComponent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, parentSuspense = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, namespace = arguments.length > 6 ? arguments[6] : void 0, slotScopeIds = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !!n2.dynamicChildren;
        if (n1 === n2) return;
        if (n1 && !$b7779ef94f774395$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        if (n2.dynamicChildren && n1 && n1.dynamicChildren && n1.dynamicChildren.hasOnce) {
            if (n2.dynamicChildren === (0, $6zvdv.EMPTY_ARR)) n2.dynamicChildren = [];
            n2.dynamicChildren.hasOnce = true;
        }
        var type = n2.type, ref = n2.ref, shapeFlag = n2.shapeFlag;
        switch(type){
            case $b7779ef94f774395$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $b7779ef94f774395$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $b7779ef94f774395$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $b7779ef94f774395$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            case $b7779ef94f774395$export$c7c4a6890f1c1342:
                $b7779ef94f774395$var$getVaporInterface(parentComponent, n2).slot(n1, n2, container, anchor, parentComponent, parentSuspense, slotScopeIds);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $b7779ef94f774395$export$4bb192c7cacf928f(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $b7779ef94f774395$export$4bb192c7cacf928f(n1.ref, null, parentSuspense, n1, true);
    };
    var processText = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            var el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    var processCommentNode = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    var mountStaticNode = function(n2, container, anchor, namespace) {
        var ref;
        ref = (0, $f9AOD._)(hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
    };
    /**
	* Dev / HMR only
	*/ var patchStaticNode = function(n1, n2, container, namespace) {
        if (n2.children !== n1.children) {
            var anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            var ref;
            ref = (0, $f9AOD._)(hostInsertStaticContent(n2.children, container, anchor, namespace), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    var moveStaticNode = function(param, container, nextSibling) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    var removeStaticNode = function(param) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    var processElement = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            var customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    var mountElement = function(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el;
        var vnodeHook;
        var props = vnode.props, shapeFlag = vnode.shapeFlag, transition = vnode.transition, dirs = vnode.dirs;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $b7779ef94f774395$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(var key in props)if (key !== "value" && !(0, $6zvdv.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            /**
			* Special case for setting value on DOM elements:
			* - it can be order-sensitive (e.g. should be set *after* min/max, #2325, #4024)
			* - it needs to be forced (#1471)
			* #2353 proposes adding another renderer option to configure this, but
			* the properties affects are so finite it is worth special casing it
			* here to reduce the complexity. (Special casing it also should not
			* affect non-DOM renderers)
			*/ if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $6zvdv.def)(el, "__vnode", vnode, true);
            (0, $6zvdv.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "beforeMount");
        if (transition) $b7779ef94f774395$export$b65fa8a64a2e2d16(el, transition, function() {
            return hostInsert(el, container, anchor);
        }, parentSuspense);
        else hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || dirs) {
            var isHmr = false;
            $b7779ef94f774395$export$51ec8e020844a97a(function() {
                var prev;
                vnodeHook && $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                dirs && $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "mounted");
            }, void 0, parentSuspense);
        }
    };
    var setScopeId = function(el, vnode, scopeId, slotScopeIds, parentComponent) {
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(var i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        var inheritedScopeIds = $b7779ef94f774395$export$3390f5447109b373(vnode, parentComponent);
        for(var i1 = 0; i1 < inheritedScopeIds.length; i1++)hostSetScopeId(el, inheritedScopeIds[i1]);
    };
    var mountChildren = function(children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var start = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0;
        for(var i = start; i < children.length; i++){
            var child = children[i] = optimized ? $b7779ef94f774395$var$cloneIfMounted(children[i]) : $b7779ef94f774395$export$a0e1465ad202d515(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchElement = function(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, dirs = n2.dirs;
        patchFlag |= n1.patchFlag & 16;
        var oldProps = n1.props || (0, $6zvdv.EMPTY_OBJ);
        var newProps = n2.props || (0, $6zvdv.EMPTY_OBJ);
        var vnodeHook;
        parentComponent && $b7779ef94f774395$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (n2.ibu) n2.ibu();
        if (dirs) $b7779ef94f774395$export$91e53aad4f01262(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $b7779ef94f774395$var$toggleRecurse(parentComponent, true);
        if (dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $b7779ef94f774395$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $b7779ef94f774395$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    var propsToUpdate = n2.dynamicProps;
                    for(var i = 0; i < propsToUpdate.length; i++){
                        var key = propsToUpdate[i];
                        var prev = oldProps[key];
                        var next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs || n2.iu) $b7779ef94f774395$export$51ec8e020844a97a(function() {
            vnodeHook && $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            n2.iu && n2.iu();
            dirs && $b7779ef94f774395$export$91e53aad4f01262(n2, n1, parentComponent, "updated");
        }, void 0, parentSuspense);
    };
    var patchBlockChildren = function(oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds) {
        for(var i = 0; i < newChildren.length; i++){
            var oldVNode = oldChildren[i];
            var newVNode = newChildren[i];
            var container = oldVNode.el && (oldVNode.type === $b7779ef94f774395$export$ffb0004e005737fa || !$b7779ef94f774395$var$isSameVNodeType(oldVNode, newVNode) || oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    var patchProps = function(el, oldProps, newProps, parentComponent, namespace) {
        if (oldProps !== newProps) {
            if (oldProps !== (0, $6zvdv.EMPTY_OBJ)) {
                for(var key in oldProps)if (!(0, $6zvdv.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(var key1 in newProps){
                if ((0, $6zvdv.isReservedProp)(key1)) continue;
                var next = newProps[key1];
                var prev = oldProps[key1];
                if (next !== prev && key1 !== "value") hostPatchProp(el, key1, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    var processFragment = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        var fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, fragmentSlotScopeIds = n2.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (n2.key != null || parentComponent && n2 === parentComponent.subTree) $b7779ef94f774395$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    var processComponent = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        n2.slotScopeIds = slotScopeIds;
        if (n2.type.__vapor) {
            if (n1 == null) {
                if (n2.shapeFlag & 512) $b7779ef94f774395$var$getVaporInterface(parentComponent, n2).activate(n2, container, anchor, parentComponent, parentSuspense);
                else {
                    var vnodeBeforeMountHook = !$b7779ef94f774395$export$4d0901d882427199(n2) && n2.props && n2.props.onVnodeBeforeMount;
                    $b7779ef94f774395$var$getVaporInterface(parentComponent, n2).mount(n2, container, anchor, parentComponent, parentSuspense, function() {
                        if (n2.dirs) {
                            $b7779ef94f774395$export$91e53aad4f01262(n2, null, parentComponent, "created");
                            $b7779ef94f774395$export$91e53aad4f01262(n2, null, parentComponent, "beforeMount");
                        }
                    }, function() {
                        if (vnodeBeforeMountHook) $b7779ef94f774395$var$invokeVNodeHook(vnodeBeforeMountHook, parentComponent, n2);
                    });
                    if (n2.dirs) $b7779ef94f774395$export$51ec8e020844a97a(function() {
                        return $b7779ef94f774395$export$91e53aad4f01262(n2, null, parentComponent, "mounted");
                    }, void 0, parentSuspense);
                    var vnodeMountedHook = !$b7779ef94f774395$export$4d0901d882427199(n2) && n2.props && n2.props.onVnodeMounted;
                    if (vnodeMountedHook) {
                        var scopedVNode = n2;
                        $b7779ef94f774395$export$51ec8e020844a97a(function() {
                            return $b7779ef94f774395$var$invokeVNodeHook(vnodeMountedHook, parentComponent, scopedVNode);
                        }, void 0, parentSuspense);
                    }
                }
            } else {
                var shouldUpdate = $b7779ef94f774395$export$225fd36bef19d8c6(n1, n2, optimized);
                $b7779ef94f774395$var$getVaporInterface(parentComponent, n2).update(n1, n2, shouldUpdate, function() {
                    if (n2.dirs) $b7779ef94f774395$export$91e53aad4f01262(n2, n1, parentComponent, "beforeUpdate");
                }, function() {
                    var vnodeBeforeUpdateHook = n2.props && n2.props.onVnodeBeforeUpdate;
                    if (vnodeBeforeUpdateHook) $b7779ef94f774395$var$invokeVNodeHook(vnodeBeforeUpdateHook, parentComponent, n2, n1);
                    if (n2.ibu) n2.ibu();
                });
                var vnodeUpdatedHook = n2.props && n2.props.onVnodeUpdated;
                if (shouldUpdate && (vnodeUpdatedHook || n2.dirs || n2.iu)) $b7779ef94f774395$export$51ec8e020844a97a(function() {
                    n2.dirs && $b7779ef94f774395$export$91e53aad4f01262(n2, n1, parentComponent, "updated");
                    vnodeUpdatedHook && $b7779ef94f774395$var$invokeVNodeHook(vnodeUpdatedHook, parentComponent, n2, n1);
                    n2.iu && n2.iu();
                }, void 0, parentSuspense);
            }
        } else if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    var mountComponent = function(initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized) {
        var instance = initialVNode.component = $b7779ef94f774395$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($b7779ef94f774395$export$a33216a979d8327a(initialVNode)) instance.ctx.renderer = internals;
        $b7779ef94f774395$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            if (parentSuspense) {
                var hydratedEl = instance.vnode.el;
                parentSuspense.registerDep(instance, function(setupResult) {
                    var vnode = instance.vnode;
                    $b7779ef94f774395$var$handleSetupResult(instance, setupResult, false);
                    if (hydratedEl) vnode.el = hydratedEl;
                    var placeholder = !hydratedEl && instance.subTree.el;
                    setupRenderEffect(instance, vnode, hostParentNode(hydratedEl || instance.subTree.el), hydratedEl ? null : getNextHostNode(instance.subTree), parentSuspense, namespace, optimized);
                    if (placeholder) {
                        vnode.placeholder = null;
                        hostRemove(placeholder);
                    }
                    $b7779ef94f774395$var$updateHOCHostEl(instance, vnode.el);
                });
            }
            if (!initialVNode.el) {
                var placeholder = instance.subTree = $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    var updateComponent = function(n1, n2, optimized) {
        var instance = n2.component = n1.component;
        if ($b7779ef94f774395$export$225fd36bef19d8c6(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                n2.el = n1.el;
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.effect.run();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    var SetupRenderEffect = /*#__PURE__*/ function(ReactiveEffect$1) {
        "use strict";
        (0, $hdIku._)(SetupRenderEffect, ReactiveEffect$1);
        function SetupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) {
            (0, $173N4._)(this, SetupRenderEffect);
            var _this;
            var prevScope = (0, $ftLbb.setCurrentScope)(instance.scope);
            _this = (0, $7qXGD._)(this, SetupRenderEffect);
            _this.instance = instance;
            _this.initialVNode = initialVNode;
            _this.container = container;
            _this.anchor = anchor;
            _this.parentSuspense = parentSuspense;
            _this.namespace = namespace;
            _this.optimized = optimized;
            (0, $ftLbb.setCurrentScope)(prevScope);
            _this.job = instance.job = function() {
                if (_this.dirty) _this.run();
            };
            _this.job.i = instance;
            var e, e1;
            return _this;
        }
        (0, $cFHGC._)(SetupRenderEffect, [
            {
                key: "notify",
                value: function notify() {
                    if (!(this.flags & 256)) {
                        var job = this.job;
                        $b7779ef94f774395$export$fba1a0a20887772f(job, job.i.uid);
                    }
                }
            },
            {
                key: "fn",
                value: function fn() {
                    var _this = this, instance = _this.instance, initialVNode = _this.initialVNode, container = _this.container, anchor = _this.anchor, parentSuspense = _this.parentSuspense, namespace = _this.namespace, optimized = _this.optimized;
                    if (!instance.isMounted) {
                        var vnodeHook;
                        var el = initialVNode.el, props = initialVNode.props;
                        var bm = instance.bm, parent = instance.parent, root = instance.root, type = instance.type;
                        var isAsyncWrapperVNode = $b7779ef94f774395$export$4d0901d882427199(initialVNode);
                        $b7779ef94f774395$var$toggleRecurse(instance, false);
                        if (bm) (0, $6zvdv.invokeArrayFns)(bm);
                        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                        $b7779ef94f774395$var$toggleRecurse(instance, true);
                        if (el && hydrateNode) {
                            var hydrateSubTree = function() {
                                instance.subTree = $b7779ef94f774395$var$renderComponentRoot(instance);
                                hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                            };
                            if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                            else hydrateSubTree();
                        } else {
                            if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                            var subTree = instance.subTree = $b7779ef94f774395$var$renderComponentRoot(instance);
                            patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                            initialVNode.el = subTree.el;
                        }
                        if (instance.m) $b7779ef94f774395$export$51ec8e020844a97a(instance.m, void 0, parentSuspense);
                        if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                            var scopedInitialVNode = initialVNode;
                            $b7779ef94f774395$export$51ec8e020844a97a(function() {
                                return $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode);
                            }, void 0, parentSuspense);
                        }
                        if (initialVNode.shapeFlag & 256 || parent && parent.vnode && $b7779ef94f774395$export$4d0901d882427199(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $b7779ef94f774395$export$51ec8e020844a97a(instance.a, void 0, parentSuspense);
                        instance.isMounted = true;
                        if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$export$a76a9a73068a1a5e(instance);
                        this.initialVNode = this.container = this.anchor = null;
                    } else {
                        var next = instance.next, bu = instance.bu, u = instance.u, parent1 = instance.parent, vnode = instance.vnode;
                        {
                            var nonHydratedAsyncRoot = $b7779ef94f774395$var$locateNonHydratedAsyncRoot(instance);
                            if (nonHydratedAsyncRoot) {
                                if (next) {
                                    next.el = vnode.el;
                                    updateComponentPreRender(instance, next, optimized);
                                }
                                nonHydratedAsyncRoot.asyncDep.then(function() {
                                    $b7779ef94f774395$export$51ec8e020844a97a(function() {
                                        if (!instance.isUnmounted) instance.update();
                                    }, void 0, parentSuspense);
                                });
                                return;
                            }
                        }
                        var originNext = next;
                        var vnodeHook1;
                        $b7779ef94f774395$var$toggleRecurse(instance, false);
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        } else next = vnode;
                        if (bu) (0, $6zvdv.invokeArrayFns)(bu);
                        if (vnodeHook1 = next.props && next.props.onVnodeBeforeUpdate) $b7779ef94f774395$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                        if (next.ibu) next.ibu();
                        $b7779ef94f774395$var$toggleRecurse(instance, true);
                        var nextTree = $b7779ef94f774395$var$renderComponentRoot(instance);
                        var prevTree = instance.subTree;
                        instance.subTree = nextTree;
                        patch(prevTree, nextTree, hostParentNode(prevTree.el), getNextHostNode(prevTree), instance, parentSuspense, namespace);
                        next.el = nextTree.el;
                        if (originNext === null) $b7779ef94f774395$var$updateHOCHostEl(instance, nextTree.el);
                        if (u) $b7779ef94f774395$export$51ec8e020844a97a(u, void 0, parentSuspense);
                        if ((vnodeHook1 = next.props && next.props.onVnodeUpdated) || next.iu) $b7779ef94f774395$export$51ec8e020844a97a(function() {
                            vnodeHook1 && $b7779ef94f774395$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                            next.iu && next.iu();
                        }, void 0, parentSuspense);
                        if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$var$devtoolsComponentUpdated(instance);
                    }
                }
            }
        ]);
        return SetupRenderEffect;
    }((0, $ftLbb.ReactiveEffect));
    var setupRenderEffect = function(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized) {
        var effect = instance.effect = new SetupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
        instance.update = effect.run.bind(effect);
        $b7779ef94f774395$var$toggleRecurse(instance, true);
        effect.run();
    };
    var updateComponentPreRender = function(instance, nextVNode, optimized) {
        nextVNode.component = instance;
        var prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $b7779ef94f774395$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $b7779ef94f774395$var$updateSlots(instance, nextVNode.children, optimized);
        var prevSub = (0, $ftLbb.setActiveSub)();
        $b7779ef94f774395$var$flushPreFlushCbs(instance);
        (0, $ftLbb.setActiveSub)(prevSub);
    };
    var patchChildren = function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds) {
        var optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : false;
        var c1 = n1 && n1.children;
        var prevShapeFlag = n1 ? n1.shapeFlag : 0;
        var c2 = n2.children;
        var patchFlag = n2.patchFlag, shapeFlag = n2.shapeFlag;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    var patchUnkeyedChildren = function(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        c1 = c1 || (0, $6zvdv.EMPTY_ARR);
        c2 = c2 || (0, $6zvdv.EMPTY_ARR);
        var oldLength = c1.length;
        var newLength = c2.length;
        var commonLength = Math.min(oldLength, newLength);
        var i;
        for(i = 0; i < commonLength; i++){
            var nextChild = c2[i] = optimized ? $b7779ef94f774395$var$cloneIfMounted(c2[i]) : $b7779ef94f774395$export$a0e1465ad202d515(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    var patchKeyedChildren = function(c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized) {
        var i = 0;
        var l2 = c2.length;
        var e1 = c1.length - 1;
        var e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            var n1 = c1[i];
            var n2 = c2[i] = optimized ? $b7779ef94f774395$var$cloneIfMounted(c2[i]) : $b7779ef94f774395$export$a0e1465ad202d515(c2[i]);
            if ($b7779ef94f774395$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            var n11 = c1[e1];
            var n21 = c2[e2] = optimized ? $b7779ef94f774395$var$cloneIfMounted(c2[e2]) : $b7779ef94f774395$export$a0e1465ad202d515(c2[e2]);
            if ($b7779ef94f774395$var$isSameVNodeType(n11, n21)) patch(n11, n21, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                var nextPos = e2 + 1;
                var anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $b7779ef94f774395$var$cloneIfMounted(c2[i]) : $b7779ef94f774395$export$a0e1465ad202d515(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            var s1 = i;
            var s2 = i;
            var keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                var nextChild = c2[i] = optimized ? $b7779ef94f774395$var$cloneIfMounted(c2[i]) : $b7779ef94f774395$export$a0e1465ad202d515(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            var j;
            var patched = 0;
            var toBePatched = e2 - s2 + 1;
            var moved = false;
            var maxNewIndexSoFar = 0;
            var newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                var prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                var newIndex = void 0;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $b7779ef94f774395$var$isSameVNodeType(prevChild, c2[j])) {
                    newIndex = j;
                    break;
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            var increasingNewIndexSequence = moved ? (0, $6zvdv.getSequence)(newIndexToOldIndexMap) : (0, $6zvdv.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                var nextIndex = s2 + i;
                var nextChild1 = c2[nextIndex];
                var anchorVNode = c2[nextIndex + 1];
                var anchor1 = nextIndex + 1 < l2 ? anchorVNode.el || $b7779ef94f774395$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild1, container, anchor1, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild1, container, anchor1, 2, parentComponent);
                    else j--;
                }
            }
        }
    };
    var move = function(vnode, container, anchor, moveType, parentComponent) {
        var parentSuspense = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
        var el = vnode.el, type = vnode.type, transition = vnode.transition, children = vnode.children, shapeFlag = vnode.shapeFlag;
        if ($b7779ef94f774395$var$isVaporComponent(type) || type === $b7779ef94f774395$export$c7c4a6890f1c1342) {
            $b7779ef94f774395$var$getVaporInterface(parentComponent, vnode).move(vnode, container, anchor, moveType, parentSuspense);
            return;
        }
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType, parentComponent);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals, parentComponent);
            return;
        }
        if (type === $b7779ef94f774395$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(var i = 0; i < children.length; i++)move(children[i], container, anchor, moveType, parentComponent);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $b7779ef94f774395$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        if (moveType !== 2 && shapeFlag & 1 && transition) {
            if (moveType === 0) $b7779ef94f774395$export$b65fa8a64a2e2d16(el, transition, function() {
                return hostInsert(el, container, anchor);
            }, parentSuspense, true);
            else $b7779ef94f774395$export$6a096a74cfa9e795(el, transition, function() {
                if (vnode.ctx.isUnmounted) hostRemove(el);
                else hostInsert(el, container, anchor);
            }, true, true);
        } else hostInsert(el, container, anchor);
    };
    var unmount = function(vnode, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        var type = vnode.type, props = vnode.props, ref = vnode.ref, children = vnode.children, dynamicChildren = vnode.dynamicChildren, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag, dirs = vnode.dirs, cacheIndex = vnode.cacheIndex, memo = vnode.memo;
        if (patchFlag === -2 || dynamicChildren && dynamicChildren.hasOnce) optimized = false;
        if (ref != null) {
            var prevSub = (0, $ftLbb.setActiveSub)();
            $b7779ef94f774395$export$4bb192c7cacf928f(ref, null, parentSuspense, vnode, true);
            (0, $ftLbb.setActiveSub)(prevSub);
        }
        if (cacheIndex != null && (!vnode.ctx || vnode.ctx === parentComponent)) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            if ($b7779ef94f774395$var$isVaporComponent(vnode.type)) $b7779ef94f774395$var$getVaporInterface(parentComponent, vnode).deactivate(vnode, parentComponent.ctx.getStorageContainer(), parentSuspense);
            else parentComponent.ctx.deactivate(vnode);
            return;
        }
        var shouldInvokeDirs = shapeFlag & 1 && dirs;
        var shouldInvokeVnodeHook = !$b7779ef94f774395$export$4d0901d882427199(vnode);
        var vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) {
            if ($b7779ef94f774395$var$isVaporComponent(type)) {
                if (dirs) $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "beforeUnmount");
                $b7779ef94f774395$var$getVaporInterface(parentComponent, vnode).unmount(vnode, doRemove, parentSuspense);
                if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || dirs) $b7779ef94f774395$export$51ec8e020844a97a(function() {
                    dirs && $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "unmounted");
                    vnodeHook && $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                }, void 0, parentSuspense);
                return;
            } else unmountComponent(vnode.component, parentSuspense, doRemove);
        } else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && !dynamicChildren.hasOnce && (type !== $b7779ef94f774395$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $b7779ef94f774395$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (type === $b7779ef94f774395$export$c7c4a6890f1c1342) {
                $b7779ef94f774395$var$getVaporInterface(parentComponent, vnode).unmount(vnode, doRemove, parentSuspense);
                return;
            }
            if (doRemove) remove(vnode);
        }
        var shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $b7779ef94f774395$export$51ec8e020844a97a(function() {
            vnodeHook && $b7779ef94f774395$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $b7779ef94f774395$export$91e53aad4f01262(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, void 0, parentSuspense);
    };
    var remove = function(vnode) {
        var type = vnode.type, el = vnode.el, anchor = vnode.anchor, transition = vnode.transition;
        if (type === $b7779ef94f774395$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $b7779ef94f774395$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
            return;
        }
        if (transition) $b7779ef94f774395$export$6a096a74cfa9e795(el, transition, function() {
            return hostRemove(el);
        }, !!(vnode.shapeFlag & 1));
        else hostRemove(el);
    };
    var removeFragment = function(cur, end) {
        var next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    var unmountComponent = function(instance, parentSuspense, doRemove) {
        var bum = instance.bum, scope = instance.scope, effect = instance.effect, subTree = instance.subTree, um = instance.um, m = instance.m, a = instance.a;
        $b7779ef94f774395$export$47f10f11906274f2(m);
        $b7779ef94f774395$export$47f10f11906274f2(a);
        if (bum) (0, $6zvdv.invokeArrayFns)(bum);
        scope.stop();
        if (effect) {
            effect.stop();
            unmount(subTree, instance, parentSuspense, doRemove);
        } else if (instance.vnode.el && subTree) {
            subTree.transition = instance.vnode.transition;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $b7779ef94f774395$export$51ec8e020844a97a(um, void 0, parentSuspense);
        $b7779ef94f774395$export$51ec8e020844a97a(function() {
            return instance.isUnmounted = true;
        }, void 0, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $b7779ef94f774395$var$devtoolsComponentRemoved(instance);
    };
    var unmountChildren = function(children, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, start = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
        for(var i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    var getNextHostNode = function(vnode) {
        if (vnode.shapeFlag & 6) {
            if ($b7779ef94f774395$var$isVaporComponent(vnode.type)) return hostNextSibling(vnode.anchor);
            return getNextHostNode(vnode.component.subTree);
        }
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        var el = hostNextSibling(vnode.anchor || vnode.el);
        var teleportEnd = el && el[$b7779ef94f774395$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    var render = function(vnode, container, namespace) {
        var instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        $b7779ef94f774395$export$3ee27bfcb8f44b9d(instance);
    };
    var internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        umt: unmountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    var hydrate;
    var hydrateNode;
    var ref;
    if (createHydrationFns) ref = (0, $f9AOD._)(createHydrationFns(internals), 2), hydrate = ref[0], hydrateNode = ref[1], ref;
    var mountApp = function(app, container, isHydrate, namespace) {
        var vnode = app._ceVNode || $b7779ef94f774395$export$bf5c4cf060303d58(app._component, app._props);
        vnode.appContext = app._context;
        if (namespace === true) namespace = "svg";
        else if (namespace === false) namespace = void 0;
        if (isHydrate && hydrate) hydrate(vnode, container);
        else render(vnode, container, namespace);
        return vnode.component;
    };
    var unmountApp = function(app) {
        render(null, app._container);
    };
    return {
        render: render,
        hydrate: hydrate,
        hydrateNode: hydrateNode,
        internals: internals,
        createApp: $b7779ef94f774395$export$20a32069df128d70(mountApp, unmountApp, $b7779ef94f774395$var$getComponentPublicInstance, render)
    };
}
function $b7779ef94f774395$var$resolveChildrenNamespace(param, currentNamespace) {
    var type = param.type, props = param.props;
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $b7779ef94f774395$var$toggleRecurse(param, allowed) {
    var effect = param.effect, job = param.job, vapor = param.vapor;
    if (!vapor) {
        if (allowed) {
            effect.flags |= 128;
            job.flags |= 2;
        } else {
            effect.flags &= -129;
            job.flags &= -3;
        }
    }
}
function $b7779ef94f774395$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
/**
* #1156
* When a component is HMR-enabled, we need to make sure that all static nodes
* inside a block also inherit the DOM element from the previous tree so that
* HMR updates (which are full updates) can retrieve the element for patching.
*
* #2080
* Inside keyed `template` fragment static children, if a fragment is moved,
* the children will always be moved. Therefore, in order to ensure correct move
* position, el should be inherited from previous nodes.
*/ function $b7779ef94f774395$var$traverseStaticChildren(n1, n2) {
    var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ch1 = n1.children;
    var ch2 = n2.children;
    if ((0, $6zvdv.isArray)(ch1) && (0, $6zvdv.isArray)(ch2)) for(var i = 0; i < ch1.length; i++){
        var c1 = ch1[i];
        var c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $b7779ef94f774395$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $b7779ef94f774395$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $b7779ef94f774395$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $b7779ef94f774395$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $b7779ef94f774395$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $b7779ef94f774395$var$locateNonHydratedAsyncRoot(instance) {
    var subComponent = instance.subTree && instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $b7779ef94f774395$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $b7779ef94f774395$export$47f10f11906274f2(hooks) {
    if (hooks) for(var i = 0; i < hooks.length; i++)hooks[i].flags |= 4;
}
function $b7779ef94f774395$export$b65fa8a64a2e2d16(el, transition, insert, parentSuspense) {
    var force = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if (force && transition.persisted && !el[$b7779ef94f774395$export$6402c150d41fe6bc]) {
        insert();
        return;
    }
    if (force || $b7779ef94f774395$var$needTransition(parentSuspense, transition)) {
        transition.beforeEnter(el);
        insert();
        $b7779ef94f774395$export$51ec8e020844a97a(function() {
            return transition.enter(el);
        }, void 0, parentSuspense);
    } else insert();
}
function $b7779ef94f774395$export$6a096a74cfa9e795(el, transition, remove) {
    var isElement = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, force = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var performRemove = function() {
        remove();
        if (transition && (force || !transition.persisted) && transition.afterLeave) transition.afterLeave();
    };
    if (force || isElement && transition && !transition.persisted) {
        var leave = transition.leave, delayLeave = transition.delayLeave;
        var performLeave = function() {
            var wasLeaving = el._isLeaving || !!el[$b7779ef94f774395$export$6402c150d41fe6bc];
            if (el._isLeaving && force) el[$b7779ef94f774395$export$6402c150d41fe6bc](true);
            if (force && transition.persisted && !wasLeaving) remove();
            else leave(el, performRemove);
        };
        if (delayLeave) delayLeave(el, performRemove, performLeave);
        else performLeave();
    } else performRemove();
}
function $b7779ef94f774395$var$getVaporInterface(instance, vnode) {
    var ctx = instance ? instance.appContext : vnode.appContext;
    var res = ctx && ctx.vapor;
    return res;
}
function $b7779ef94f774395$var$isVaporComponent(type) {
    return type.__vapor;
}
/**
* shared between vdom and vapor
*/ function $b7779ef94f774395$export$3390f5447109b373(vnode, parentComponent) {
    var includeVaporRootIds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var _inheritedScopeIds;
    var inheritedScopeIds = [];
    var currentParent = parentComponent;
    var currentVNode = vnode;
    while(currentParent){
        var subTree = currentParent.subTree;
        if (!subTree) break;
        if (currentVNode === subTree || $b7779ef94f774395$var$isSuspense(subTree.type) && (subTree.ssContent === currentVNode || subTree.ssFallback === currentVNode)) {
            var _inheritedScopeIds1;
            var parentVNode = currentParent.vnode;
            if (parentVNode.scopeId) inheritedScopeIds.push(parentVNode.scopeId);
            if (parentVNode.slotScopeIds) (_inheritedScopeIds1 = inheritedScopeIds).push.apply(_inheritedScopeIds1, (0, $aUGqu._)(parentVNode.slotScopeIds));
            currentVNode = parentVNode;
            currentParent = currentParent.parent;
        } else break;
    }
    var vaporScopeIds = includeVaporRootIds && currentVNode.vaporScopeIds;
    if (vaporScopeIds) (_inheritedScopeIds = inheritedScopeIds).push.apply(_inheritedScopeIds, (0, $aUGqu._)(vaporScopeIds));
    return inheritedScopeIds;
}
function $b7779ef94f774395$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    var instance = anchorVnode.component;
    if (instance) return $b7779ef94f774395$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
//#endregion
//#region packages/runtime-core/src/components/Suspense.ts
var $b7779ef94f774395$var$isSuspense = function(type) {
    return type.__isSuspense;
};
var $b7779ef94f774395$var$suspenseId = 0;
var $b7779ef94f774395$export$74bf444e3cd11ea5 = {
    name: "Suspense",
    __isSuspense: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $b7779ef94f774395$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback && !parentSuspense.isHydrating) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $b7779ef94f774395$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $b7779ef94f774395$var$hydrateSuspense,
    normalize: $b7779ef94f774395$var$normalizeSuspenseChildren
};
function $b7779ef94f774395$var$triggerEvent(vnode, name) {
    var eventListener = vnode.props && vnode.props[name];
    if ((0, $6zvdv.isFunction)(eventListener)) eventListener();
}
function $b7779ef94f774395$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    var patch = rendererInternals.p, createElement = rendererInternals.o.createElement;
    var hiddenContainer = createElement("div");
    var suspense = vnode.suspense = $b7779ef94f774395$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $b7779ef94f774395$var$triggerEvent(vnode, "onPending");
        $b7779ef94f774395$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, namespace, slotScopeIds);
        $b7779ef94f774395$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $b7779ef94f774395$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, param) {
    var patch = param.p, unmount = param.um, createElement = param.o.createElement;
    var suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    var newBranch = n2.ssContent;
    var newFallback = n2.ssFallback;
    var activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, isInFallback = suspense.isInFallback, isHydrating = suspense.isHydrating;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($b7779ef94f774395$var$isSameVNodeType(pendingBranch, newBranch)) {
            suspense.deps++;
            patch(pendingBranch, newBranch, isHydrating ? container : suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            suspense.deps--;
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating && !suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, namespace, slotScopeIds, optimized);
                    $b7779ef94f774395$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $b7779ef94f774395$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            for(var i = 0; i < suspense.effects.length; i++){
                var effect = suspense.effects[i];
                if (effect.flags & 8) $b7779ef94f774395$export$59536a0199721cab(effect);
            }
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else if (!suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, namespace, slotScopeIds, optimized);
                    $b7779ef94f774395$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $b7779ef94f774395$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $b7779ef94f774395$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $b7779ef94f774395$var$setActiveBranch(suspense, newBranch);
    } else {
        $b7779ef94f774395$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $b7779ef94f774395$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            var timeout = suspense.timeout, pendingId = suspense.pendingId;
            if (timeout > 0) setTimeout(function() {
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
var $b7779ef94f774395$var$hasWarned = false;
function $b7779ef94f774395$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals) {
    var isHydrating = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : false;
    /* v8 ignore stop */ var patch = rendererInternals.p, move = rendererInternals.m, unmount = rendererInternals.um, next = rendererInternals.n, parentNode = rendererInternals.o.parentNode;
    var parentSuspenseId;
    var isSuspensible = $b7779ef94f774395$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    var timeout = vnode.props ? (0, $6zvdv.toNumber)(vnode.props.timeout) : void 0;
    var initialAnchor = anchor;
    var suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $b7779ef94f774395$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve: function() {
            var resume = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var _$vnode = suspense.vnode, activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, pendingId = suspense.pendingId, effects = suspense.effects, _$parentComponent = suspense.parentComponent, _$container = suspense.container, isInFallback = suspense.isInFallback;
            var delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                var hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = function() {
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, _$container, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0, _$parentComponent);
                        $b7779ef94f774395$export$59536a0199721cab(effects);
                        if (isInFallback && _$vnode.ssFallback) _$vnode.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === _$container) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, _$parentComponent, suspense, true);
                    if (!delayEnter && isInFallback && _$vnode.ssFallback) $b7779ef94f774395$export$51ec8e020844a97a(function() {
                        return _$vnode.ssFallback.el = null;
                    }, void 0, suspense);
                }
                if (!delayEnter) move(pendingBranch, _$container, anchor, 0, _$parentComponent);
            }
            suspense.isFallbackMountPending = false;
            $b7779ef94f774395$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            var parent = suspense.parent;
            var hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(var i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $b7779ef94f774395$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspenseId = void 0;
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $b7779ef94f774395$var$triggerEvent(_$vnode, "onResolve");
        },
        fallback: function(fallbackVNode) {
            if (!suspense.pendingBranch) return;
            var _$vnode = suspense.vnode, activeBranch = suspense.activeBranch, _$parentComponent = suspense.parentComponent, _$container = suspense.container, _$namespace = suspense.namespace;
            $b7779ef94f774395$var$triggerEvent(_$vnode, "onFallback");
            var _$anchor = next(activeBranch);
            var mountFallback = function() {
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                var latestFallback = suspense.vnode.ssFallback;
                patch(null, latestFallback, _$container, _$anchor, _$parentComponent, null, _$namespace, slotScopeIds, optimized);
                $b7779ef94f774395$var$setActiveBranch(suspense, latestFallback);
            };
            var delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, _$parentComponent, null, true);
            if (!delayEnter) mountFallback();
        },
        move: function(container, anchor, type) {
            suspense.activeBranch && move(suspense.activeBranch, container, anchor, type, parentComponent);
            suspense.container = container;
        },
        next: function() {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep: function(instance, onResolve) {
            var isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            var hydratedEl = instance.vnode && instance.vnode.el;
            instance.asyncDep.catch(function(err) {
                $b7779ef94f774395$export$d3da1ecaf1206c58(err, instance, 0);
            }).then(function(asyncSetupResult) {
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $b7779ef94f774395$export$a5e695a16aa0b6d4(null, void 0);
                if (hydratedEl && !instance.scope.active) {
                    if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
                    return;
                }
                instance.asyncResolved = true;
                onResolve(asyncSetupResult);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount: function(parentSuspense, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense, doRemove);
        }
    };
    return suspense;
}
function $b7779ef94f774395$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    var suspense = vnode.suspense = $b7779ef94f774395$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    var result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $b7779ef94f774395$var$normalizeSuspenseChildren(vnode) {
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    var isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $b7779ef94f774395$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $b7779ef94f774395$var$normalizeSuspenseSlot(children.fallback) : $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$4d299b491347818a);
}
function $b7779ef94f774395$var$normalizeSuspenseSlot(s) {
    var block;
    if ((0, $6zvdv.isFunction)(s)) {
        var trackBlock = $b7779ef94f774395$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $b7779ef94f774395$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $b7779ef94f774395$var$currentBlock;
            $b7779ef94f774395$var$closeBlock();
        }
    }
    if ((0, $6zvdv.isArray)(s)) {
        var singleChild = $b7779ef94f774395$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $b7779ef94f774395$export$a0e1465ad202d515(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter(function(c) {
        return c !== s;
    });
    return s;
}
function $b7779ef94f774395$var$queueEffectWithSuspense(fn, id, suspense) {
    if (suspense && suspense.pendingBranch) {
        var _suspense_effects;
        if ((0, $6zvdv.isArray)(fn)) (_suspense_effects = suspense.effects).push.apply(_suspense_effects, (0, $aUGqu._)(fn));
        else suspense.effects.push(fn);
    } else $b7779ef94f774395$export$59536a0199721cab(fn, id);
}
function $b7779ef94f774395$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    var vnode = suspense.vnode, parentComponent = suspense.parentComponent;
    var el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $b7779ef94f774395$var$updateHOCHostEl(parentComponent, el);
    }
}
function $b7779ef94f774395$var$isVNodeSuspensible(vnode) {
    var suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
//#endregion
//#region packages/runtime-core/src/vnode.ts
var $b7779ef94f774395$export$ffb0004e005737fa = Symbol.for("v-fgt");
var $b7779ef94f774395$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
var $b7779ef94f774395$export$4d299b491347818a = Symbol.for("v-cmt");
var $b7779ef94f774395$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
var $b7779ef94f774395$export$c7c4a6890f1c1342 = Symbol.for("v-vps");
var $b7779ef94f774395$var$blockStack = [];
var $b7779ef94f774395$var$currentBlock = null;
/**
* Open a block.
* This must be called before `createBlock`. It cannot be part of `createBlock`
* because the children of the block are evaluated before `createBlock` itself
* is called. The generated code typically looks like this:
*
* ```js
* function render() {
*   return (openBlock(),createBlock('div', null, [...]))
* }
* ```
* disableTracking is true when creating a v-for fragment block, since a v-for
* fragment always diffs its children.
*
* @private
*/ function $b7779ef94f774395$export$e7eaa45e502fe5cc() {
    var disableTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    $b7779ef94f774395$var$blockStack.push($b7779ef94f774395$var$currentBlock = disableTracking ? null : []);
}
function $b7779ef94f774395$var$closeBlock() {
    $b7779ef94f774395$var$blockStack.pop();
    $b7779ef94f774395$var$currentBlock = $b7779ef94f774395$var$blockStack[$b7779ef94f774395$var$blockStack.length - 1] || null;
}
var $b7779ef94f774395$var$isBlockTreeEnabled = 1;
/**
* Block tracking sometimes needs to be disabled, for example during the
* creation of a tree that needs to be cached by v-once. The compiler generates
* code like this:
*
* ``` js
* _cache[1] || (
*   setBlockTracking(-1, true),
*   _cache[1] = createVNode(...),
*   setBlockTracking(1),
*   _cache[1]
* )
* ```
*
* @private
*/ function $b7779ef94f774395$export$c20bee82f26f1e27(value) {
    var inVOnce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    $b7779ef94f774395$var$isBlockTreeEnabled += value;
    if (value < 0 && $b7779ef94f774395$var$currentBlock && inVOnce) $b7779ef94f774395$var$currentBlock.hasOnce = true;
}
function $b7779ef94f774395$var$setupBlock(vnode) {
    vnode.dynamicChildren = $b7779ef94f774395$var$isBlockTreeEnabled > 0 ? $b7779ef94f774395$var$currentBlock || (0, $6zvdv.EMPTY_ARR) : null;
    $b7779ef94f774395$var$closeBlock();
    if ($b7779ef94f774395$var$isBlockTreeEnabled > 0 && $b7779ef94f774395$var$currentBlock) $b7779ef94f774395$var$currentBlock.push(vnode);
    return vnode;
}
/**
* @private
*/ function $b7779ef94f774395$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $b7779ef94f774395$var$setupBlock($b7779ef94f774395$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
/**
* Create a block root vnode. Takes the same exact arguments as `createVNode`.
* A block root keeps track of dynamic nodes within the block in the
* `dynamicChildren` array.
*
* @private
*/ function $b7779ef94f774395$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $b7779ef94f774395$var$setupBlock($b7779ef94f774395$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $b7779ef94f774395$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $b7779ef94f774395$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
var $b7779ef94f774395$var$vnodeArgsTransformer;
/**
* Internal API for registering an arguments transform for createVNode
* used for creating stubs in the test-utils
* It is *internal* but needs to be exposed for test-utils to pick up proper
* typings
*/ function $b7779ef94f774395$export$83beccd3afeeb809(transformer) {
    $b7779ef94f774395$var$vnodeArgsTransformer = transformer;
}
var $b7779ef94f774395$var$createVNodeWithArgsTransform = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $b7779ef94f774395$var$_createVNode.apply(void 0, (0, $aUGqu._)($b7779ef94f774395$var$vnodeArgsTransformer ? $b7779ef94f774395$var$vnodeArgsTransformer(args, $b7779ef94f774395$var$currentRenderingInstance) : args));
};
var $b7779ef94f774395$var$normalizeKey = function(param) {
    var key = param.key;
    return key != null ? key : null;
};
var $b7779ef94f774395$export$8e5958b67b6795b0 = function(param) {
    var ref = param.ref, ref_key = param.ref_key, ref_for = param.ref_for, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $b7779ef94f774395$var$currentRenderingInstance;
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $6zvdv.isString)(ref) || (0, $ftLbb.isRef)(ref) || (0, $6zvdv.isFunction)(ref) ? {
        i: i,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $b7779ef94f774395$export$42098e0eaa15c48e(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, shapeFlag = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : type === $b7779ef94f774395$export$ffb0004e005737fa ? 0 : 1, isBlockNode = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, needFullChildrenNormalization = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $b7779ef94f774395$var$normalizeKey(props),
        ref: props && $b7779ef94f774395$export$8e5958b67b6795b0(props),
        scopeId: $b7779ef94f774395$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $b7779ef94f774395$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $b7779ef94f774395$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $6zvdv.isString)(children) ? 8 : 16;
    if ($b7779ef94f774395$var$isBlockTreeEnabled > 0 && !isBlockNode && $b7779ef94f774395$var$currentBlock && (vnode.patchFlag > 0 || shapeFlag & 6) && vnode.patchFlag !== 32) $b7779ef94f774395$var$currentBlock.push(vnode);
    return vnode;
}
/**
* dev only
* Whether children would actually render something. Empty text and empty
* arrays are ignored, mirroring the compiler's `node.children.length` check
* for `v-html` / `v-text`.
*/ function $b7779ef94f774395$var$hasContentChildren(children) {
    if ((0, $6zvdv.isString)(children)) return children !== "";
    if ((0, $6zvdv.isArray)(children)) return children.length > 0;
    return false;
}
var $b7779ef94f774395$export$bf5c4cf060303d58 = $b7779ef94f774395$var$_createVNode;
function $b7779ef94f774395$var$_createVNode(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isBlockNode = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (!type || type === $b7779ef94f774395$export$7d1f90a35714b16e) type = $b7779ef94f774395$export$4d299b491347818a;
    if ($b7779ef94f774395$export$3868d13f8734ae81(type)) {
        var cloned = $b7779ef94f774395$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $b7779ef94f774395$var$normalizeChildren(cloned, children);
        if ($b7779ef94f774395$var$isBlockTreeEnabled > 0 && !isBlockNode && $b7779ef94f774395$var$currentBlock) {
            if (cloned.shapeFlag & 6) $b7779ef94f774395$var$currentBlock[$b7779ef94f774395$var$currentBlock.indexOf(type)] = cloned;
            else $b7779ef94f774395$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($b7779ef94f774395$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $b7779ef94f774395$export$1f1be0e0e384d7d2(props);
        var klass = props.class, style = props.style;
        if (klass && !(0, $6zvdv.isString)(klass)) props.class = (0, $6zvdv.normalizeClass)(klass);
        if ((0, $6zvdv.isObject)(style)) {
            if ((0, $ftLbb.isProxy)(style) && !(0, $6zvdv.isArray)(style)) style = (0, $6zvdv.extend)({}, style);
            props.style = (0, $6zvdv.normalizeStyle)(style);
        }
    }
    var shapeFlag = (0, $6zvdv.isString)(type) ? 1 : $b7779ef94f774395$var$isSuspense(type) ? 128 : $b7779ef94f774395$var$isTeleport(type) ? 64 : (0, $6zvdv.isObject)(type) ? 4 : (0, $6zvdv.isFunction)(type) ? 2 : 0;
    return $b7779ef94f774395$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $b7779ef94f774395$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $ftLbb.isProxy)(props) || $b7779ef94f774395$var$isInternalObject(props) ? (0, $6zvdv.extend)({}, props) : props;
}
function $b7779ef94f774395$export$ee4f9e12c0a92a1a(vnode, extraProps) {
    var mergeRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, cloneTransition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = vnode.props, ref = vnode.ref, patchFlag = vnode.patchFlag, children = vnode.children, transition = vnode.transition;
    var mergedProps = extraProps ? $b7779ef94f774395$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    var cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $b7779ef94f774395$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? mergeRef && ref ? (0, $6zvdv.isArray)(ref) ? ref.concat($b7779ef94f774395$export$8e5958b67b6795b0(extraProps)) : [
            ref,
            $b7779ef94f774395$export$8e5958b67b6795b0(extraProps)
        ] : $b7779ef94f774395$export$8e5958b67b6795b0(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        patchFlag: extraProps && vnode.type !== $b7779ef94f774395$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $b7779ef94f774395$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $b7779ef94f774395$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce,
        vi: vnode.vi,
        vs: $b7779ef94f774395$var$cloneVaporSlotMeta(vnode),
        vb: vnode.vb,
        ibu: vnode.ibu,
        iu: vnode.iu,
        cacheIndex: vnode.cacheIndex
    };
    if (transition && cloneTransition) $b7779ef94f774395$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $b7779ef94f774395$var$cloneVaporSlotMeta(vnode) {
    var vaporSlot = vnode.vs;
    if (!vaporSlot) return vaporSlot;
    var cloned = {
        slot: vaporSlot.slot,
        fallback: vaporSlot.fallback,
        outletFallback: vaporSlot.outletFallback
    };
    if (vnode.el) {
        cloned.state = vaporSlot.state;
        cloned.ref = vaporSlot.ref;
        cloned.scope = vaporSlot.scope;
    }
    return cloned;
}
/**
* Dev only, for HMR of hoisted vnodes reused in v-for
* https://github.com/vitejs/vite/issues/2022
*/ function $b7779ef94f774395$var$deepCloneVNode(vnode) {
    var cloned = $b7779ef94f774395$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $6zvdv.isArray)(vnode.children)) cloned.children = vnode.children.map($b7779ef94f774395$var$deepCloneVNode);
    return cloned;
}
/**
* @private
*/ function $b7779ef94f774395$export$22f9b5ffd89dac9() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", flag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$5f1af8db9871e1d6, null, text, flag);
}
/**
* @private
*/ function $b7779ef94f774395$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    var vnode = $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
/**
* @private
*/ function $b7779ef94f774395$export$49553837c7236d3c() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", asBlock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return asBlock ? ($b7779ef94f774395$export$e7eaa45e502fe5cc(), $b7779ef94f774395$export$9f2dfe8048dfb22b($b7779ef94f774395$export$4d299b491347818a, null, text)) : $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$4d299b491347818a, null, text);
}
function $b7779ef94f774395$export$a0e1465ad202d515(child) {
    if (child == null || typeof child === "boolean") return $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$4d299b491347818a);
    else if ((0, $6zvdv.isArray)(child)) return $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$ffb0004e005737fa, null, child.slice());
    else if ($b7779ef94f774395$export$3868d13f8734ae81(child)) return $b7779ef94f774395$var$cloneIfMounted(child);
    else return $b7779ef94f774395$export$bf5c4cf060303d58($b7779ef94f774395$export$5f1af8db9871e1d6, null, String(child));
}
function $b7779ef94f774395$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $b7779ef94f774395$export$ee4f9e12c0a92a1a(child);
}
function $b7779ef94f774395$var$normalizeChildren(vnode, children) {
    var type = 0;
    var shapeFlag = vnode.shapeFlag;
    if (children == null) children = null;
    else if ((0, $6zvdv.isArray)(children)) type = 16;
    else if ((typeof children === "undefined" ? "undefined" : (0, $7E0eS._)(children)) === "object") {
        if (shapeFlag & 65) {
            var slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $b7779ef94f774395$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            var slotFlag = children._;
            if (!slotFlag && !$b7779ef94f774395$var$isInternalObject(children)) children._ctx = $b7779ef94f774395$var$currentRenderingInstance;
            else if (slotFlag === 3 && $b7779ef94f774395$var$currentRenderingInstance) {
                if ($b7779ef94f774395$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $6zvdv.isFunction)(children)) {
        if (shapeFlag & 65) {
            $b7779ef94f774395$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $b7779ef94f774395$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $b7779ef94f774395$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $b7779ef94f774395$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var ret = {};
    for(var i = 0; i < args.length; i++){
        var toMerge = args[i];
        for(var key in toMerge)if (key === "class") {
            if (ret.class !== toMerge.class) ret.class = (0, $6zvdv.normalizeClass)([
                ret.class,
                toMerge.class
            ]);
        } else if (key === "style") ret.style = (0, $6zvdv.normalizeStyle)([
            ret.style,
            toMerge.style
        ]);
        else if ((0, $6zvdv.isOn)(key)) {
            var existing = ret[key];
            var incoming = toMerge[key];
            if (incoming && existing !== incoming && !((0, $6zvdv.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            else if (incoming == null && existing == null && !(0, $6zvdv.isModelListener)(key)) ret[key] = incoming;
        } else if (key !== "") ret[key] = toMerge[key];
    }
    return ret;
}
function $b7779ef94f774395$var$invokeVNodeHook(hook, instance, vnode) {
    var prevVNode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    $b7779ef94f774395$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
//#endregion
//#region packages/runtime-core/src/componentCurrentInstance.ts
/**
* @internal
*/ var $b7779ef94f774395$export$5d0c78f02672825 = null;
/**
* @internal
*/ var $b7779ef94f774395$var$getCurrentGenericInstance = function() {
    return $b7779ef94f774395$export$5d0c78f02672825 || $b7779ef94f774395$var$currentRenderingInstance;
};
var $b7779ef94f774395$export$f13e630aa3915748 = function() {
    return $b7779ef94f774395$export$5d0c78f02672825 && !$b7779ef94f774395$export$5d0c78f02672825.vapor ? $b7779ef94f774395$export$5d0c78f02672825 : $b7779ef94f774395$var$currentRenderingInstance;
};
var $b7779ef94f774395$var$isInSSRComponentSetup = false;
var $b7779ef94f774395$var$setInSSRSetupState;
/**
* @internal
*/ var $b7779ef94f774395$export$a1b5a29a1999a394;
{
    var $b7779ef94f774395$var$g = (0, $6zvdv.getGlobalThis)();
    var $b7779ef94f774395$var$registerGlobalSetter = function(key, setter) {
        var setters;
        if (!(setters = $b7779ef94f774395$var$g[key])) setters = $b7779ef94f774395$var$g[key] = [];
        setters.push(setter);
        return function(v1) {
            if (setters.length > 1) setters.forEach(function(set) {
                return set(v1);
            });
            else setters[0](v1);
        };
    };
    $b7779ef94f774395$export$a1b5a29a1999a394 = $b7779ef94f774395$var$registerGlobalSetter("__VUE_INSTANCE_SETTERS__", function(v1) {
        return $b7779ef94f774395$export$5d0c78f02672825 = v1;
    });
    $b7779ef94f774395$var$setInSSRSetupState = $b7779ef94f774395$var$registerGlobalSetter("__VUE_SSR_SETTERS__", function(v1) {
        return $b7779ef94f774395$var$isInSSRComponentSetup = v1;
    });
}var $b7779ef94f774395$export$a5e695a16aa0b6d4 = function(instance) {
    var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : instance !== null ? instance.scope : void 0;
    try {
        return [
            $b7779ef94f774395$export$5d0c78f02672825,
            (0, $ftLbb.setCurrentScope)(scope)
        ];
    } finally{
        $b7779ef94f774395$export$a1b5a29a1999a394(instance);
    }
};
/**
* Restores a snapshot returned by {@link setCurrentInstance}. Unlike calling
* `setCurrentInstance(...prev)`, an `undefined` saved scope is restored
* verbatim instead of re-triggering the `instance.scope` default.
* @internal
*/ var $b7779ef94f774395$export$95e96a1fb881e3e7 = function(prev) {
    (0, $ftLbb.setCurrentScope)(prev[1]);
    $b7779ef94f774395$export$a1b5a29a1999a394(prev[0]);
};
var $b7779ef94f774395$var$internalOptions = [
    "ce",
    "type",
    "uid"
];
/**
* @internal
*/ var $b7779ef94f774395$export$f94b6c23bf914d02 = function(key) {
    var silent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var instance = $b7779ef94f774395$var$getCurrentGenericInstance();
    if (!instance) return {
        hasInstance: false,
        value: void 0
    };
    if (!$b7779ef94f774395$var$internalOptions.includes(key)) {
        var k;
        return {
            hasInstance: true,
            value: void 0
        };
    }
    return {
        hasInstance: true,
        value: instance[key]
    };
};
//#endregion
//#region packages/runtime-core/src/component.ts
var $b7779ef94f774395$var$emptyAppContext = /*@__PURE__*/ $b7779ef94f774395$var$createAppContext();
var $b7779ef94f774395$var$uid = 0;
/**
* @internal for vapor
*/ function $b7779ef94f774395$export$be5627916a199b29() {
    return $b7779ef94f774395$var$uid++;
}
function $b7779ef94f774395$var$createComponentInstance(vnode, parent, suspense) {
    var type = vnode.type;
    var appContext = (parent ? parent.appContext : vnode.appContext) || $b7779ef94f774395$var$emptyAppContext;
    var instance = {
        uid: $b7779ef94f774395$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        next: null,
        subTree: null,
        effect: null,
        update: null,
        job: null,
        scope: new (0, $ftLbb.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        components: null,
        directives: null,
        propsOptions: $b7779ef94f774395$var$normalizePropsOptions(type, appContext),
        emitsOptions: $b7779ef94f774395$var$normalizeEmitsOptions(type, appContext),
        emit: null,
        emitted: null,
        propsDefaults: null,
        inheritAttrs: type.inheritAttrs,
        ctx: (0, $6zvdv.EMPTY_OBJ),
        data: (0, $6zvdv.EMPTY_OBJ),
        props: (0, $6zvdv.EMPTY_OBJ),
        attrs: (0, $6zvdv.EMPTY_OBJ),
        slots: (0, $6zvdv.EMPTY_OBJ),
        refs: (0, $6zvdv.EMPTY_OBJ),
        setupState: (0, $6zvdv.EMPTY_OBJ),
        setupContext: null,
        suspense: suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $b7779ef94f774395$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
/**
* @internal
*/ function $b7779ef94f774395$export$4fb1f2dc002bb2d3(name, param) {
    var isNativeTag = param.isNativeTag;
    if ((0, $6zvdv.isBuiltInTag)(name) || isNativeTag(name)) $b7779ef94f774395$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $b7779ef94f774395$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
function $b7779ef94f774395$var$setupComponent(instance) {
    var isSSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, optimized = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    isSSR && $b7779ef94f774395$var$setInSSRSetupState(isSSR);
    var _instance_vnode = instance.vnode, props = _instance_vnode.props, children = _instance_vnode.children, vi = _instance_vnode.vi;
    var isStateful = $b7779ef94f774395$var$isStatefulComponent(instance);
    if (vi) vi(instance);
    else {
        $b7779ef94f774395$var$initProps(instance, props, isStateful, isSSR);
        $b7779ef94f774395$var$initSlots(instance, children, optimized || isSSR);
    }
    var setupResult = isStateful ? $b7779ef94f774395$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $b7779ef94f774395$var$setInSSRSetupState(false);
    return setupResult;
}
function $b7779ef94f774395$var$setupStatefulComponent(instance, isSSR) {
    var Component = instance.type;
    instance.accessCache = Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $b7779ef94f774395$var$PublicInstanceProxyHandlers);
    var setup = Component.setup;
    if (setup) {
        var prevSub = (0, $ftLbb.setActiveSub)();
        var setupContext = instance.setupContext = setup.length > 1 ? $b7779ef94f774395$var$createSetupContext(instance) : null;
        var prev = $b7779ef94f774395$export$a5e695a16aa0b6d4(instance);
        var setupResult = $b7779ef94f774395$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        var isAsyncSetup = (0, $6zvdv.isPromise)(setupResult);
        (0, $ftLbb.setActiveSub)(prevSub);
        $b7779ef94f774395$export$95e96a1fb881e3e7(prev);
        if ((isAsyncSetup || instance.sp) && !$b7779ef94f774395$export$4d0901d882427199(instance)) $b7779ef94f774395$export$b9b0eeb564431e5e(instance);
        if (isAsyncSetup) {
            var unsetCurrentInstance = function() {
                $b7779ef94f774395$export$a5e695a16aa0b6d4(null, void 0);
            };
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) return setupResult.then(function(resolvedResult) {
                $b7779ef94f774395$var$setInSSRSetupState(true);
                try {
                    $b7779ef94f774395$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $b7779ef94f774395$var$setInSSRSetupState(false);
                }
            }).catch(function(e) {
                $b7779ef94f774395$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $b7779ef94f774395$var$handleSetupResult(instance, setupResult, isSSR);
    } else $b7779ef94f774395$var$finishComponentSetup(instance, isSSR);
}
function $b7779ef94f774395$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $6zvdv.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $6zvdv.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $ftLbb.proxyRefs)(setupResult);
    }
    $b7779ef94f774395$var$finishComponentSetup(instance, isSSR);
}
var $b7779ef94f774395$var$compile;
var $b7779ef94f774395$var$installWithProxy;
/**
* For runtime-dom to register the compiler.
* Note the exported method uses any to avoid d.ts relying on the compiler types.
*/ function $b7779ef94f774395$export$667bb5a67822b941(_compile) {
    $b7779ef94f774395$var$compile = _compile;
    $b7779ef94f774395$var$installWithProxy = function(i) {
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $b7779ef94f774395$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
var $b7779ef94f774395$export$c93a9c496c5211fa = function() {
    return !$b7779ef94f774395$var$compile;
};
function $b7779ef94f774395$var$finishComponentSetup(instance, isSSR, skipOptions) {
    var Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $b7779ef94f774395$var$compile && !Component.render) {
            var template = Component.template || __VUE_OPTIONS_API__ && $b7779ef94f774395$var$resolveMergedOptions(instance).template;
            if (template) {
                var _instance_appContext_config = instance.appContext.config, isCustomElement = _instance_appContext_config.isCustomElement, compilerOptions = _instance_appContext_config.compilerOptions;
                var delimiters = Component.delimiters, componentCompilerOptions = Component.compilerOptions;
                var finalCompilerOptions = (0, $6zvdv.extend)((0, $6zvdv.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $b7779ef94f774395$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $6zvdv.NOOP);
        if ($b7779ef94f774395$var$installWithProxy) $b7779ef94f774395$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        var prevInstance = $b7779ef94f774395$export$a5e695a16aa0b6d4(instance);
        var prevSub = (0, $ftLbb.setActiveSub)();
        try {
            $b7779ef94f774395$var$applyOptions(instance);
        } finally{
            (0, $ftLbb.setActiveSub)(prevSub);
            $b7779ef94f774395$export$95e96a1fb881e3e7(prevInstance);
        }
    }
}
var $b7779ef94f774395$var$attrsProxyHandlers = {
    get: function(target, key) {
        (0, $ftLbb.track)(target, "get", "");
        return target[key];
    }
};
/**
* Dev-only
*/ function $b7779ef94f774395$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get: function(target, key) {
            (0, $ftLbb.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $b7779ef94f774395$var$createSetupContext(instance) {
    var event, args, exposed;
    return {
        attrs: new Proxy(instance.attrs, $b7779ef94f774395$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: function(exposed) {
            return $b7779ef94f774395$export$9b7f6e342a8cbd38(instance, exposed);
        }
    };
}
/**
* @internal
*/ function $b7779ef94f774395$export$9b7f6e342a8cbd38(instance, exposed) {
    instance.exposed = exposed || {};
}
function $b7779ef94f774395$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $ftLbb.proxyRefs)((0, $ftLbb.markRaw)(instance.exposed)), {
        get: function(target, key) {
            if (key in target) return target[key];
            else {
                var publicPropertiesMap = $b7779ef94f774395$var$getPublicPropertiesMap();
                if (key in publicPropertiesMap) return publicPropertiesMap[key](instance);
            }
        },
        has: function(target, key) {
            var publicPropertiesMap = $b7779ef94f774395$var$getPublicPropertiesMap();
            return key in target || key in publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
var $b7779ef94f774395$var$classifyRE = /(?:^|[-_])\w/g;
var $b7779ef94f774395$var$classify = function(str) {
    return str.replace($b7779ef94f774395$var$classifyRE, function(c) {
        return c.toUpperCase();
    }).replace(/[-_]/g, "");
};
function $b7779ef94f774395$export$26727cfcc4d7e0fc(Component) {
    var includeInferred = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (0, $6zvdv.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $b7779ef94f774395$var$formatComponentName(instance, Component) {
    var isRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var name = $b7779ef94f774395$export$26727cfcc4d7e0fc(Component);
    if (!name && Component.__file) {
        var match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        var inferFromRegistry = function(registry) {
            for(var key in registry)if (registry[key] === Component) return key;
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $b7779ef94f774395$var$classify(name) : isRoot ? "App" : "Anonymous";
}
function $b7779ef94f774395$var$isClassComponent(value) {
    return (0, $6zvdv.isFunction)(value) && "__vccOpts" in value;
}
//#endregion
//#region packages/runtime-core/src/apiComputed.ts
var $b7779ef94f774395$export$2983e091f1a1e8e2 = function(getterOrOptions, debugOptions) {
    return (0, $ftLbb.computed)(getterOrOptions, debugOptions, $b7779ef94f774395$var$isInSSRComponentSetup);
};
//#endregion
//#region packages/runtime-core/src/h.ts
function $b7779ef94f774395$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $b7779ef94f774395$export$c20bee82f26f1e27(-1);
        var l = arguments.length;
        if (l === 2) {
            if ((0, $6zvdv.isObject)(propsOrChildren) && !(0, $6zvdv.isArray)(propsOrChildren)) {
                if ($b7779ef94f774395$export$3868d13f8734ae81(propsOrChildren)) return $b7779ef94f774395$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $b7779ef94f774395$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $b7779ef94f774395$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $b7779ef94f774395$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $b7779ef94f774395$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $b7779ef94f774395$export$c20bee82f26f1e27(1);
    }
}
//#endregion
//#region packages/runtime-core/src/customFormatter.ts
function $b7779ef94f774395$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        var blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $ftLbb.toRaw)(instance.props)));
        if (instance.setupState !== (0, $6zvdv.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $6zvdv.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $ftLbb.toRaw)(instance.data)));
        var computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        var injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $6zvdv.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                }
            ].concat((0, $aUGqu._)(Object.keys(target).map(function(key) {
                return [
                    "div",
                    {},
                    [
                        "span",
                        keywordStyle,
                        key + ": "
                    ],
                    formatValue(target[key], false)
                ];
            })))
        ];
    }
    function formatValue(v1) {
        var asRaw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $6zvdv.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $ftLbb.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        var Comp = instance.type;
        if ((0, $6zvdv.isFunction)(Comp)) return;
        var extracted = {};
        for(var key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        var opts = Comp[type];
        if ((0, $6zvdv.isArray)(opts) && opts.includes(key) || (0, $6zvdv.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some(function(m) {
            return isKeyOfType(m, key, type);
        })) return true;
    }
    function genRefFlag(v1) {
        if ((0, $ftLbb.isShallow)(v1)) return "ShallowRef";
        if (v1.effect) return "ComputedRef";
        return "Ref";
    }
}
//#endregion
//#region packages/runtime-core/src/helpers/withMemo.ts
function $b7779ef94f774395$export$2a6d714a4d738ae(memo, render, cache, index) {
    var cached = cache[index];
    if (cached && $b7779ef94f774395$export$bf525184d622787c(cached, memo)) return cached;
    var ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $b7779ef94f774395$export$bf525184d622787c(cached, memo) {
    var prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(var i = 0; i < prev.length; i++)if ((0, $6zvdv.hasChanged)(prev[i], memo[i])) return false;
    if ($b7779ef94f774395$var$isBlockTreeEnabled > 0 && $b7779ef94f774395$var$currentBlock) $b7779ef94f774395$var$currentBlock.push(cached);
    return true;
}
//#endregion
//#region packages/runtime-core/src/index.ts
var $b7779ef94f774395$export$83d89fbfd8236492 = "3.6.0-rc.9";
var $b7779ef94f774395$export$c106dd0671a0fc2d = (0, $6zvdv.NOOP);
/**
* Runtime error messages. Only exposed in dev or esm builds.
* @internal
*/ var $b7779ef94f774395$export$795e0ad4a0e2ed30 = $b7779ef94f774395$var$ErrorTypeStrings$1;
var $b7779ef94f774395$export$6922d3b3a607469e = $b7779ef94f774395$var$devtools$1;
var $b7779ef94f774395$export$b0c258b32c26c785 = $b7779ef94f774395$var$setDevtoolsHook$1;
/**
* SSR utils for \@vue/server-renderer. Only exposed in ssr-possible builds.
* @internal
*/ var $b7779ef94f774395$export$a9679033567b336d = {
    createComponentInstance: $b7779ef94f774395$var$createComponentInstance,
    setupComponent: $b7779ef94f774395$var$setupComponent,
    renderComponentRoot: $b7779ef94f774395$var$renderComponentRoot,
    setCurrentRenderingInstance: $b7779ef94f774395$export$824c074beef4c41b,
    isVNode: $b7779ef94f774395$export$3868d13f8734ae81,
    normalizeVNode: $b7779ef94f774395$export$a0e1465ad202d515,
    getComponentPublicInstance: $b7779ef94f774395$var$getComponentPublicInstance,
    ensureValidVNode: $b7779ef94f774395$export$9fc41f261330971f,
    pushWarningContext: $b7779ef94f774395$export$eff0ee073d211f48,
    popWarningContext: $b7779ef94f774395$export$1f21d88a9fb0fa16
};
/**
* @internal only exposed in compat builds
*/ var $b7779ef94f774395$export$83cf26e06ea620e1 = null;
/**
* @internal only exposed in compat builds.
*/ var $b7779ef94f774395$export$dc678eddf276286e = null;
var $b7779ef94f774395$export$22072a82865312f6 = null;

});
parcelRegister("ftLbb", function(module, exports) {

$parcel$export(module.exports, "setActiveSub", function () { return $b44e294c25f4d601$export$852d57bcb751cc7a; });
$parcel$export(module.exports, "track", function () { return $b44e294c25f4d601$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $b44e294c25f4d601$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $b44e294c25f4d601$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isShallow", function () { return $b44e294c25f4d601$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "isReadonly", function () { return $b44e294c25f4d601$export$92d09b48637741e7; });
$parcel$export(module.exports, "toReactive", function () { return $b44e294c25f4d601$export$45c769cf449a508c; });
$parcel$export(module.exports, "isReactive", function () { return $b44e294c25f4d601$export$352205f445242f02; });
$parcel$export(module.exports, "toReadonly", function () { return $b44e294c25f4d601$export$4a78e7a2a4fb689f; });
$parcel$export(module.exports, "shallowReadArray", function () { return $b44e294c25f4d601$export$5eb48af14254449e; });
$parcel$export(module.exports, "isProxy", function () { return $b44e294c25f4d601$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "isRef", function () { return $b44e294c25f4d601$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "readonly", function () { return $b44e294c25f4d601$export$6ec456bd5b7b3c51; });
$parcel$export(module.exports, "reactive", function () { return $b44e294c25f4d601$export$90a44edba14e47be; });
$parcel$export(module.exports, "shallowReactive", function () { return $b44e294c25f4d601$export$8d81cefd22d22260; });
$parcel$export(module.exports, "shallowReadonly", function () { return $b44e294c25f4d601$export$7c4b5f2b50f09f6b; });
$parcel$export(module.exports, "markRaw", function () { return $b44e294c25f4d601$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $b44e294c25f4d601$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $b44e294c25f4d601$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "triggerRef", function () { return $b44e294c25f4d601$export$f402f86588575ccc; });
$parcel$export(module.exports, "unref", function () { return $b44e294c25f4d601$export$a239a76781616204; });
$parcel$export(module.exports, "toValue", function () { return $b44e294c25f4d601$export$30bdcc2218aa9458; });
$parcel$export(module.exports, "proxyRefs", function () { return $b44e294c25f4d601$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "customRef", function () { return $b44e294c25f4d601$export$a20c2dd6199824cb; });
$parcel$export(module.exports, "toRefs", function () { return $b44e294c25f4d601$export$2e9533675e5e70e0; });
$parcel$export(module.exports, "toRef", function () { return $b44e294c25f4d601$export$1f60508e4f47b4b7; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $b44e294c25f4d601$export$28352bb4dd362521; });
$parcel$export(module.exports, "effect", function () { return $b44e294c25f4d601$export$dc573d8a6576cdb3; });
$parcel$export(module.exports, "stop", function () { return $b44e294c25f4d601$export$fa6813432f753b0d; });
$parcel$export(module.exports, "onEffectCleanup", function () { return $b44e294c25f4d601$export$92b6a62b33d94031; });
$parcel$export(module.exports, "EffectScope", function () { return $b44e294c25f4d601$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $b44e294c25f4d601$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $b44e294c25f4d601$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "setCurrentScope", function () { return $b44e294c25f4d601$export$7c50eaa430038da7; });
$parcel$export(module.exports, "onScopeDispose", function () { return $b44e294c25f4d601$export$a780418acd4762da; });
$parcel$export(module.exports, "computed", function () { return $b44e294c25f4d601$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "TrackOpTypes", function () { return $b44e294c25f4d601$export$2ac2bd0a56e04551; });
$parcel$export(module.exports, "TriggerOpTypes", function () { return $b44e294c25f4d601$export$1e8941c92696a26; });
$parcel$export(module.exports, "getCurrentWatcher", function () { return $b44e294c25f4d601$export$2532f7acfca7c82d; });
$parcel$export(module.exports, "onWatcherCleanup", function () { return $b44e294c25f4d601$export$8ddeeb083684a9d0; });
$parcel$export(module.exports, "WatcherEffect", function () { return $b44e294c25f4d601$export$c243d5028940e63b; });
$parcel$export(module.exports, "traverse", function () { return $b44e294c25f4d601$export$df3f009e3d155b20; });
$parcel$export(module.exports, "watch", function () { return $b44e294c25f4d601$export$3db5d71bdb2d5499; });
/**
  * @vue/reactivity v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $gXzGB = parcelRequire("gXzGB");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $aUGqu = parcelRequire("aUGqu");

var $6zvdv = parcelRequire("6zvdv");
//#region packages/reactivity/src/debug.ts
var $b44e294c25f4d601$var$triggerEventInfos = [];
function $b44e294c25f4d601$var$onTrack(sub, debugInfo) {
    throw new Error("Internal error: onTrack should be called only in development.");
}
function $b44e294c25f4d601$var$onTrigger(sub) {
    throw new Error("Internal error: onTrigger should be called only in development.");
}
function $b44e294c25f4d601$var$setupOnTrigger(target) {
    var val;
    throw new Error("Internal error: setupOnTrigger should be called only in development.");
}
function $b44e294c25f4d601$var$setupFlagsHandler(target) {
    target._flags = target.flags;
    Object.defineProperty(target, "flags", {
        get: function() {
            return target._flags;
        },
        set: function(value) {
            if (!(target._flags & 48) && !!(value & 48)) $b44e294c25f4d601$var$onTrigger(this);
            target._flags = value;
        }
    });
}
//#endregion
//#region packages/reactivity/src/warning.ts
function $b44e294c25f4d601$var$warn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "[Vue warn] ".concat(msg)
    ].concat((0, $aUGqu._)(args)));
}
//#endregion
//#region packages/reactivity/src/system.ts
var $b44e294c25f4d601$var$notifyBuffer = [];
var $b44e294c25f4d601$var$batchDepth = 0;
var $b44e294c25f4d601$var$activeSub = void 0;
var $b44e294c25f4d601$var$runDepth = 0;
function $b44e294c25f4d601$var$incRunDepth() {
    ++$b44e294c25f4d601$var$runDepth;
}
function $b44e294c25f4d601$var$decRunDepth() {
    --$b44e294c25f4d601$var$runDepth;
}
var $b44e294c25f4d601$var$globalVersion = 0;
var $b44e294c25f4d601$var$notifyIndex = 0;
var $b44e294c25f4d601$var$notifyBufferLength = 0;
function $b44e294c25f4d601$export$852d57bcb751cc7a(sub) {
    try {
        return $b44e294c25f4d601$var$activeSub;
    } finally{
        $b44e294c25f4d601$var$activeSub = sub;
    }
}
function $b44e294c25f4d601$var$startBatch() {
    ++$b44e294c25f4d601$var$batchDepth;
}
function $b44e294c25f4d601$var$endBatch() {
    if (!--$b44e294c25f4d601$var$batchDepth && $b44e294c25f4d601$var$notifyBufferLength) $b44e294c25f4d601$var$flush();
}
function $b44e294c25f4d601$var$link(dep, sub) {
    var prevDep = sub.depsTail;
    if (prevDep !== void 0 && prevDep.dep === dep) return;
    var nextDep = prevDep !== void 0 ? prevDep.nextDep : sub.deps;
    if (nextDep !== void 0 && nextDep.dep === dep) {
        nextDep.version = $b44e294c25f4d601$var$globalVersion;
        sub.depsTail = nextDep;
        return;
    }
    var prevSub = dep.subsTail;
    if (prevSub !== void 0 && prevSub.version === $b44e294c25f4d601$var$globalVersion && prevSub.sub === sub) return;
    var newLink = sub.depsTail = dep.subsTail = {
        version: $b44e294c25f4d601$var$globalVersion,
        dep: dep,
        sub: sub,
        prevDep: prevDep,
        nextDep: nextDep,
        prevSub: prevSub,
        nextSub: void 0
    };
    if (nextDep !== void 0) nextDep.prevDep = newLink;
    if (prevDep !== void 0) prevDep.nextDep = newLink;
    else sub.deps = newLink;
    if (prevSub !== void 0) prevSub.nextSub = newLink;
    else dep.subs = newLink;
}
function $b44e294c25f4d601$var$unlink(link) {
    var sub = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : link.sub;
    var dep = link.dep;
    var prevDep = link.prevDep;
    var nextDep = link.nextDep;
    var nextSub = link.nextSub;
    var prevSub = link.prevSub;
    if (nextDep !== void 0) nextDep.prevDep = prevDep;
    else sub.depsTail = prevDep;
    if (prevDep !== void 0) prevDep.nextDep = nextDep;
    else sub.deps = nextDep;
    if (nextSub !== void 0) nextSub.prevSub = prevSub;
    else dep.subsTail = prevSub;
    if (prevSub !== void 0) prevSub.nextSub = nextSub;
    else if ((dep.subs = nextSub) === void 0) {
        var toRemove = dep.deps;
        if (toRemove !== void 0) {
            do toRemove = $b44e294c25f4d601$var$unlink(toRemove, dep);
            while (toRemove !== void 0);
            dep.flags |= 16;
        }
    }
    return nextDep;
}
function $b44e294c25f4d601$var$propagate(link) {
    var next = link.nextSub;
    var stack;
    top: do {
        var sub = link.sub;
        var flags = sub.flags;
        if (flags & 3) {
            if (!(flags & 60)) {
                sub.flags = flags | 32;
                if ($b44e294c25f4d601$var$runDepth) sub.flags |= 8;
            } else if (!(flags & 12)) flags = 0;
            else if (!(flags & 4)) sub.flags = flags & -9 | 32;
            else if (!(flags & 48) && $b44e294c25f4d601$var$isValidLink(link, sub)) {
                sub.flags = flags | 40;
                flags &= 1;
            } else flags = 0;
            if (flags & 2) $b44e294c25f4d601$var$notifyBuffer[$b44e294c25f4d601$var$notifyBufferLength++] = sub;
            if (flags & 1) {
                var subSubs = sub.subs;
                if (subSubs !== void 0) {
                    link = subSubs;
                    if (subSubs.nextSub !== void 0) {
                        stack = {
                            value: next,
                            prev: stack
                        };
                        next = link.nextSub;
                    }
                    continue;
                }
            }
        }
        if ((link = next) !== void 0) {
            next = link.nextSub;
            continue;
        }
        while(stack !== void 0){
            link = stack.value;
            stack = stack.prev;
            if (link !== void 0) {
                next = link.nextSub;
                continue top;
            }
        }
        break;
    }while (true);
}
function $b44e294c25f4d601$var$startTracking(sub) {
    ++$b44e294c25f4d601$var$globalVersion;
    sub.depsTail = void 0;
    sub.flags = sub.flags & -57 | 4;
    return $b44e294c25f4d601$export$852d57bcb751cc7a(sub);
}
function $b44e294c25f4d601$var$endTracking(sub, prevSub) {
    $b44e294c25f4d601$var$activeSub = prevSub;
    var depsTail = sub.depsTail;
    var toRemove = depsTail !== void 0 ? depsTail.nextDep : sub.deps;
    while(toRemove !== void 0)toRemove = $b44e294c25f4d601$var$unlink(toRemove, sub);
    sub.flags &= -5;
}
function $b44e294c25f4d601$var$flush() {
    while($b44e294c25f4d601$var$notifyIndex < $b44e294c25f4d601$var$notifyBufferLength){
        var effect = $b44e294c25f4d601$var$notifyBuffer[$b44e294c25f4d601$var$notifyIndex];
        $b44e294c25f4d601$var$notifyBuffer[$b44e294c25f4d601$var$notifyIndex++] = void 0;
        effect.notify();
    }
    $b44e294c25f4d601$var$notifyIndex = 0;
    $b44e294c25f4d601$var$notifyBufferLength = 0;
}
function $b44e294c25f4d601$var$checkDirty(link, sub) {
    var stack;
    var checkDepth = 0;
    top: do {
        var dep = link.dep;
        var depFlags = dep.flags;
        var dirty = false;
        if (sub.flags & 16) dirty = true;
        else if ((depFlags & 17) === 17) {
            var subs = dep.subs;
            if (dep.update()) {
                if (subs.nextSub !== void 0) $b44e294c25f4d601$var$shallowPropagate(subs);
                dirty = true;
            }
        } else if ((depFlags & 33) === 33) {
            stack = {
                value: link,
                prev: stack
            };
            link = dep.deps;
            sub = dep;
            ++checkDepth;
            continue;
        }
        if (!dirty && link.nextDep !== void 0) {
            link = link.nextDep;
            continue;
        }
        while(checkDepth){
            --checkDepth;
            link = stack.value;
            stack = stack.prev;
            if (dirty) {
                var subs1 = sub.subs;
                if (sub.update()) {
                    if (subs1.nextSub !== void 0) $b44e294c25f4d601$var$shallowPropagate(subs1);
                    sub = link.sub;
                    continue;
                }
            } else sub.flags &= -33;
            sub = link.sub;
            if (link.nextDep !== void 0) {
                link = link.nextDep;
                continue top;
            }
            dirty = false;
        }
        return dirty && !!sub.flags;
    }while (true);
}
function $b44e294c25f4d601$var$shallowPropagate(link) {
    do {
        var sub = link.sub;
        var nextSub = link.nextSub;
        var subFlags = sub.flags;
        if ((subFlags & 48) === 32) sub.flags = subFlags | 16;
        link = nextSub;
    }while (link !== void 0);
}
function $b44e294c25f4d601$var$isValidLink(checkLink, sub) {
    var link = sub.depsTail;
    while(link !== void 0){
        if (link === checkLink) return true;
        link = link.prevDep;
    }
    return false;
}
//#endregion
//#region packages/reactivity/src/dep.ts
var $b44e294c25f4d601$var$Dep = /*#__PURE__*/ function() {
    "use strict";
    function Dep(map, key) {
        (0, $173N4._)(this, Dep);
        this.map = map;
        this.key = key;
        this._subs = void 0;
        this.subsTail = void 0;
        this.flags = 0;
    }
    (0, $cFHGC._)(Dep, [
        {
            key: "subs",
            get: function get() {
                return this._subs;
            },
            set: function set(value) {
                this._subs = value;
                if (value === void 0) this.map.delete(this.key);
            }
        }
    ]);
    return Dep;
}();
var $b44e294c25f4d601$var$targetMap = /* @__PURE__ */ new WeakMap();
var $b44e294c25f4d601$export$3c41b1a4e06acc14 = Symbol("");
var $b44e294c25f4d601$export$49093fa1cddcb78d = Symbol("");
var $b44e294c25f4d601$export$4f926f0baab682cd = Symbol("");
/**
* Tracks access to a reactive property.
*
* This will check which effect is running at the moment and record it as dep
* which records all effects that depend on the reactive property.
*
* @param target - Object holding the reactive property.
* @param type - Defines the type of access to the reactive property.
* @param key - Identifier of the reactive property to track.
*/ function $b44e294c25f4d601$export$6b2a7d5132615086(target, type, key) {
    if ($b44e294c25f4d601$var$activeSub !== void 0) {
        var depsMap = $b44e294c25f4d601$var$targetMap.get(target);
        if (!depsMap) $b44e294c25f4d601$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        var dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = new $b44e294c25f4d601$var$Dep(depsMap, key));
        $b44e294c25f4d601$var$link(dep, $b44e294c25f4d601$var$activeSub);
    }
}
/**
* Finds all deps associated with the target (or a specific property) and
* triggers the effects stored within.
*
* @param target - The reactive object.
* @param type - Defines the type of the operation that needs to trigger effects.
* @param key - Can be used to target a specific reactive property in the target object.
*/ function $b44e294c25f4d601$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = $b44e294c25f4d601$var$targetMap.get(target);
    if (!depsMap) return;
    var run = function(dep) {
        if (dep !== void 0 && dep.subs !== void 0) {
            $b44e294c25f4d601$var$propagate(dep.subs);
            $b44e294c25f4d601$var$shallowPropagate(dep.subs);
        }
    };
    $b44e294c25f4d601$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        var targetIsArray = (0, $6zvdv.isArray)(target);
        var isArrayIndex = targetIsArray && (0, $6zvdv.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            var newLength = Number(newValue);
            depsMap.forEach(function(dep, key) {
                if (key === "length" || key === $b44e294c25f4d601$export$4f926f0baab682cd || !(0, $6zvdv.isSymbol)(key) && key >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($b44e294c25f4d601$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($b44e294c25f4d601$export$3c41b1a4e06acc14));
                        if ((0, $6zvdv.isMap)(target)) run(depsMap.get($b44e294c25f4d601$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($b44e294c25f4d601$export$3c41b1a4e06acc14));
                        if ((0, $6zvdv.isMap)(target)) run(depsMap.get($b44e294c25f4d601$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $6zvdv.isMap)(target)) run(depsMap.get($b44e294c25f4d601$export$3c41b1a4e06acc14));
            }
        }
    }
    $b44e294c25f4d601$var$endBatch();
}
function $b44e294c25f4d601$var$getDepFromReactive(object, key) {
    var depMap = $b44e294c25f4d601$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
//#endregion
//#region packages/reactivity/src/arrayInstrumentations.ts
/**
* Track array iteration and return:
* - if input is reactive: a cloned raw array with reactive values
* - if input is readonly: a cloned raw array with readonly values, preserving
*   reactivity
* - if input is raw or shallow: the original raw array
*/ function $b44e294c25f4d601$export$1544eab4943788e4(array) {
    var raw = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $b44e294c25f4d601$export$6b2a7d5132615086(raw, "iterate", $b44e294c25f4d601$export$4f926f0baab682cd);
    if (/* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(array)) return raw;
    if (!/* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(array)) return raw.map($b44e294c25f4d601$export$45c769cf449a508c);
    return /* @__PURE__ */ $b44e294c25f4d601$export$352205f445242f02(array) ? raw.map(function(item) {
        return $b44e294c25f4d601$export$4a78e7a2a4fb689f($b44e294c25f4d601$export$45c769cf449a508c(item));
    }) : raw.map($b44e294c25f4d601$export$4a78e7a2a4fb689f);
}
/**
* Track array iteration and return raw array
*/ function $b44e294c25f4d601$export$5eb48af14254449e(arr) {
    $b44e294c25f4d601$export$6b2a7d5132615086(arr = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(arr), "iterate", $b44e294c25f4d601$export$4f926f0baab682cd);
    return arr;
}
function $b44e294c25f4d601$var$toWrapped(target, item) {
    if (/* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(target)) return /* @__PURE__ */ $b44e294c25f4d601$export$352205f445242f02(target) ? $b44e294c25f4d601$export$4a78e7a2a4fb689f($b44e294c25f4d601$export$45c769cf449a508c(item)) : $b44e294c25f4d601$export$4a78e7a2a4fb689f(item);
    return $b44e294c25f4d601$export$45c769cf449a508c(item);
}
var $b44e294c25f4d601$var$_obj;
var $b44e294c25f4d601$var$arrayInstrumentations = ($b44e294c25f4d601$var$_obj = {
    __proto__: null
}, (0, $7Pjls._)($b44e294c25f4d601$var$_obj, Symbol.iterator, function() {
    var _this = this;
    return $b44e294c25f4d601$var$iterator(this, Symbol.iterator, function(item) {
        return $b44e294c25f4d601$var$toWrapped(_this, item);
    });
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "concat", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _reactiveReadArray;
    return (_reactiveReadArray = $b44e294c25f4d601$export$1544eab4943788e4(this)).concat.apply(_reactiveReadArray, (0, $aUGqu._)(args.map(function(x) {
        return (0, $6zvdv.isArray)(x) ? $b44e294c25f4d601$export$1544eab4943788e4(x) : x;
    })));
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "entries", function() {
    var _this = this;
    return $b44e294c25f4d601$var$iterator(this, "entries", function(value) {
        value[1] = $b44e294c25f4d601$var$toWrapped(_this, value[1]);
        return value;
    });
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "every", function(fn, thisArg) {
    return $b44e294c25f4d601$var$apply(this, "every", fn, thisArg, void 0, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "filter", function(fn, thisArg) {
    var _this = this;
    return $b44e294c25f4d601$var$apply(this, "filter", fn, thisArg, function(v) {
        return v.map(function(item) {
            return $b44e294c25f4d601$var$toWrapped(_this, item);
        });
    }, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "find", function(fn, thisArg) {
    var _this = this;
    return $b44e294c25f4d601$var$apply(this, "find", fn, thisArg, function(item) {
        return $b44e294c25f4d601$var$toWrapped(_this, item);
    }, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "findIndex", function(fn, thisArg) {
    return $b44e294c25f4d601$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "findLast", function(fn, thisArg) {
    var _this = this;
    return $b44e294c25f4d601$var$apply(this, "findLast", fn, thisArg, function(item) {
        return $b44e294c25f4d601$var$toWrapped(_this, item);
    }, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "findLastIndex", function(fn, thisArg) {
    return $b44e294c25f4d601$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "forEach", function(fn, thisArg) {
    return $b44e294c25f4d601$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "includes", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $b44e294c25f4d601$var$searchProxy(this, "includes", args);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "indexOf", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $b44e294c25f4d601$var$searchProxy(this, "indexOf", args);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "join", function(separator) {
    return $b44e294c25f4d601$export$1544eab4943788e4(this).join(separator);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "lastIndexOf", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $b44e294c25f4d601$var$searchProxy(this, "lastIndexOf", args);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "map", function(fn, thisArg) {
    return $b44e294c25f4d601$var$apply(this, "map", fn, thisArg, void 0, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "pop", function() {
    return $b44e294c25f4d601$var$noTracking(this, "pop");
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "push", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $b44e294c25f4d601$var$noTracking(this, "push", args);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "reduce", function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return $b44e294c25f4d601$var$reduce(this, "reduce", fn, args);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "reduceRight", function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return $b44e294c25f4d601$var$reduce(this, "reduceRight", fn, args);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "shift", function() {
    return $b44e294c25f4d601$var$noTracking(this, "shift");
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "some", function(fn, thisArg) {
    return $b44e294c25f4d601$var$apply(this, "some", fn, thisArg, void 0, arguments);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "splice", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $b44e294c25f4d601$var$noTracking(this, "splice", args);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "toReversed", function() {
    return $b44e294c25f4d601$export$1544eab4943788e4(this).toReversed();
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "toSorted", function(comparer) {
    return $b44e294c25f4d601$export$1544eab4943788e4(this).toSorted(comparer);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "toSpliced", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _reactiveReadArray;
    return (_reactiveReadArray = $b44e294c25f4d601$export$1544eab4943788e4(this)).toSpliced.apply(_reactiveReadArray, (0, $aUGqu._)(args));
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "unshift", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $b44e294c25f4d601$var$noTracking(this, "unshift", args);
}), (0, $7Pjls._)($b44e294c25f4d601$var$_obj, "values", function() {
    var _this = this;
    return $b44e294c25f4d601$var$iterator(this, "values", function(item) {
        return $b44e294c25f4d601$var$toWrapped(_this, item);
    });
}), $b44e294c25f4d601$var$_obj);
function $b44e294c25f4d601$var$iterator(self, method, wrapValue) {
    var arr = $b44e294c25f4d601$export$5eb48af14254449e(self);
    var iter = arr[method]();
    if (arr !== self && !/* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = function() {
            var result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
var $b44e294c25f4d601$var$arrayProto = Array.prototype;
function $b44e294c25f4d601$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    var arr = $b44e294c25f4d601$export$5eb48af14254449e(self);
    var needsWrap = arr !== self && !/* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(self);
    var methodFn = arr[method];
    if (methodFn !== $b44e294c25f4d601$var$arrayProto[method]) {
        var result = methodFn.apply(self, args);
        return needsWrap ? $b44e294c25f4d601$export$45c769cf449a508c(result) : result;
    }
    var wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function wrappedFn(item, index) {
            return fn.call(this, $b44e294c25f4d601$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function wrappedFn(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    var result1 = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result1) : result1;
}
function $b44e294c25f4d601$var$reduce(self, method, fn, args) {
    var _arr;
    var arr = $b44e294c25f4d601$export$5eb48af14254449e(self);
    var needsWrap = arr !== self && !/* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(self);
    var wrappedFn = fn;
    var wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function wrappedFn(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $b44e294c25f4d601$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $b44e294c25f4d601$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function wrappedFn(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    var result = (_arr = arr)[method].apply(_arr, [
        wrappedFn
    ].concat((0, $aUGqu._)(args)));
    return wrapInitialAccumulator ? $b44e294c25f4d601$var$toWrapped(self, result) : result;
}
function $b44e294c25f4d601$var$searchProxy(self, method, args) {
    var _arr;
    var arr = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(self);
    $b44e294c25f4d601$export$6b2a7d5132615086(arr, "iterate", $b44e294c25f4d601$export$4f926f0baab682cd);
    var res = (_arr = arr)[method].apply(_arr, (0, $aUGqu._)(args));
    if ((res === -1 || res === false) && /* @__PURE__ */ $b44e294c25f4d601$export$5f3ca29d057519b3(args[0])) {
        var _arr1;
        args[0] = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(args[0]);
        return (_arr1 = arr)[method].apply(_arr1, (0, $aUGqu._)(args));
    }
    return res;
}
function $b44e294c25f4d601$var$noTracking(self, method) {
    var args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    $b44e294c25f4d601$var$startBatch();
    var prevSub = $b44e294c25f4d601$export$852d57bcb751cc7a();
    var res = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $b44e294c25f4d601$export$852d57bcb751cc7a(prevSub);
    $b44e294c25f4d601$var$endBatch();
    return res;
}
//#endregion
//#region packages/reactivity/src/baseHandlers.ts
var $b44e294c25f4d601$var$isNonTrackableKeys = /*@__PURE__*/ (0, $6zvdv.makeMap)("__proto__,__v_isRef,__isVue");
var $b44e294c25f4d601$var$builtInSymbols = new Set(/*@__PURE__*/ Object.getOwnPropertyNames(Symbol).filter(function(key) {
    return key !== "arguments" && key !== "caller";
}).map(function(key) {
    return Symbol[key];
}).filter((0, $6zvdv.isSymbol)));
function $b44e294c25f4d601$var$hasOwnProperty(key) {
    if (!(0, $6zvdv.isSymbol)(key)) key = String(key);
    var obj = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(this);
    $b44e294c25f4d601$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
var $b44e294c25f4d601$var$BaseReactiveHandler = /*#__PURE__*/ function() {
    "use strict";
    function BaseReactiveHandler() {
        var _isReadonly = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, _isShallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        (0, $173N4._)(this, BaseReactiveHandler);
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    (0, $cFHGC._)(BaseReactiveHandler, [
        {
            key: "get",
            value: function get(target, key, receiver) {
                if (key === "__v_skip") return target["__v_skip"];
                var isReadonly = this._isReadonly, isShallow = this._isShallow;
                if (key === "__v_isReactive") return !isReadonly;
                else if (key === "__v_isReadonly") return isReadonly;
                else if (key === "__v_isShallow") return isShallow;
                else if (key === "__v_raw") {
                    if (receiver === (isReadonly ? isShallow ? $b44e294c25f4d601$var$shallowReadonlyMap : $b44e294c25f4d601$var$readonlyMap : isShallow ? $b44e294c25f4d601$var$shallowReactiveMap : $b44e294c25f4d601$var$reactiveMap).get(target) || Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
                    return;
                }
                var targetIsArray = (0, $6zvdv.isArray)(target);
                if (!isReadonly) {
                    var fn;
                    if (targetIsArray && (fn = $b44e294c25f4d601$var$arrayInstrumentations[key])) return fn;
                    if (key === "hasOwnProperty") return $b44e294c25f4d601$var$hasOwnProperty;
                }
                var wasRef = /* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(target);
                var res = Reflect.get(target, key, wasRef ? target : receiver);
                if (wasRef && key !== "value") return res;
                if ((0, $6zvdv.isSymbol)(key) ? $b44e294c25f4d601$var$builtInSymbols.has(key) : $b44e294c25f4d601$var$isNonTrackableKeys(key)) return res;
                if (!isReadonly) $b44e294c25f4d601$export$6b2a7d5132615086(target, "get", key);
                if (isShallow) return res;
                if (/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(res)) {
                    var value = targetIsArray && (0, $6zvdv.isIntegerKey)(key) ? res : res.value;
                    return isReadonly && (0, $6zvdv.isObject)(value) ? /* @__PURE__ */ $b44e294c25f4d601$export$6ec456bd5b7b3c51(value) : value;
                }
                if ((0, $6zvdv.isObject)(res)) return isReadonly ? /* @__PURE__ */ $b44e294c25f4d601$export$6ec456bd5b7b3c51(res) : /* @__PURE__ */ $b44e294c25f4d601$export$90a44edba14e47be(res);
                return res;
            }
        }
    ]);
    return BaseReactiveHandler;
}();
var $b44e294c25f4d601$var$MutableReactiveHandler = /*#__PURE__*/ function(BaseReactiveHandler) {
    "use strict";
    (0, $hdIku._)(MutableReactiveHandler, BaseReactiveHandler);
    function MutableReactiveHandler() {
        var isShallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $173N4._)(this, MutableReactiveHandler);
        return (0, $7qXGD._)(this, MutableReactiveHandler, [
            false,
            isShallow
        ]);
    }
    (0, $cFHGC._)(MutableReactiveHandler, [
        {
            key: "set",
            value: function set(target, key, value, receiver) {
                var oldValue = target[key];
                var isArrayWithIntegerKey = (0, $6zvdv.isArray)(target) && (0, $6zvdv.isIntegerKey)(key);
                if (!this._isShallow) {
                    var isOldValueReadonly = /* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(oldValue);
                    if (!/* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(value) && !/* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(value)) {
                        oldValue = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(oldValue);
                        value = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(value);
                    }
                    if (!isArrayWithIntegerKey && /* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(value)) {
                        if (isOldValueReadonly) return true;
                        else {
                            oldValue.value = value;
                            return true;
                        }
                    }
                }
                var hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $6zvdv.hasOwn)(target, key);
                var result = Reflect.set(target, key, value, /* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(target) ? target : receiver);
                if (target === /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(receiver) && result) {
                    if (!hadKey) $b44e294c25f4d601$export$e614dc9140f7ae71(target, "add", key, value);
                    else if ((0, $6zvdv.hasChanged)(value, oldValue)) $b44e294c25f4d601$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
                }
                return result;
            }
        },
        {
            key: "deleteProperty",
            value: function deleteProperty(target, key) {
                var hadKey = (0, $6zvdv.hasOwn)(target, key);
                var oldValue = target[key];
                var result = Reflect.deleteProperty(target, key);
                if (result && hadKey) $b44e294c25f4d601$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
                return result;
            }
        },
        {
            key: "has",
            value: function has(target, key) {
                var result = Reflect.has(target, key);
                if (!(0, $6zvdv.isSymbol)(key) || !$b44e294c25f4d601$var$builtInSymbols.has(key)) $b44e294c25f4d601$export$6b2a7d5132615086(target, "has", key);
                return result;
            }
        },
        {
            key: "ownKeys",
            value: function ownKeys(target) {
                $b44e294c25f4d601$export$6b2a7d5132615086(target, "iterate", (0, $6zvdv.isArray)(target) ? "length" : $b44e294c25f4d601$export$3c41b1a4e06acc14);
                return Reflect.ownKeys(target);
            }
        }
    ]);
    return MutableReactiveHandler;
}($b44e294c25f4d601$var$BaseReactiveHandler);
var $b44e294c25f4d601$var$ReadonlyReactiveHandler = /*#__PURE__*/ function(BaseReactiveHandler) {
    "use strict";
    (0, $hdIku._)(ReadonlyReactiveHandler, BaseReactiveHandler);
    function ReadonlyReactiveHandler() {
        var isShallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $173N4._)(this, ReadonlyReactiveHandler);
        return (0, $7qXGD._)(this, ReadonlyReactiveHandler, [
            true,
            isShallow
        ]);
    }
    (0, $cFHGC._)(ReadonlyReactiveHandler, [
        {
            key: "set",
            value: function set(target, key) {
                return true;
            }
        },
        {
            key: "deleteProperty",
            value: function deleteProperty(target, key) {
                return true;
            }
        }
    ]);
    return ReadonlyReactiveHandler;
}($b44e294c25f4d601$var$BaseReactiveHandler);
var $b44e294c25f4d601$var$mutableHandlers = /*@__PURE__*/ new $b44e294c25f4d601$var$MutableReactiveHandler();
var $b44e294c25f4d601$var$readonlyHandlers = /*@__PURE__*/ new $b44e294c25f4d601$var$ReadonlyReactiveHandler();
var $b44e294c25f4d601$var$shallowReactiveHandlers = /*@__PURE__*/ new $b44e294c25f4d601$var$MutableReactiveHandler(true);
var $b44e294c25f4d601$var$shallowReadonlyHandlers = /*@__PURE__*/ new $b44e294c25f4d601$var$ReadonlyReactiveHandler(true);
//#endregion
//#region packages/reactivity/src/collectionHandlers.ts
var $b44e294c25f4d601$var$toShallow = function(value) {
    return value;
};
var $b44e294c25f4d601$var$getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function $b44e294c25f4d601$var$createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(target);
        var targetIsMap = (0, $6zvdv.isMap)(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $aUGqu._)(args));
        var wrap = isShallow ? $b44e294c25f4d601$var$toShallow : isReadonly ? $b44e294c25f4d601$export$4a78e7a2a4fb689f : $b44e294c25f4d601$export$45c769cf449a508c;
        !isReadonly && $b44e294c25f4d601$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $b44e294c25f4d601$export$49093fa1cddcb78d : $b44e294c25f4d601$export$3c41b1a4e06acc14);
        return (0, $6zvdv.extend)(Object.create(innerIterator), {
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $b44e294c25f4d601$var$createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $b44e294c25f4d601$var$createInstrumentations(readonly, shallow) {
    var instrumentations = {
        get: function(key) {
            var target = this["__v_raw"];
            var rawTarget = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(target);
            var rawKey = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $6zvdv.hasChanged)(key, rawKey)) $b44e294c25f4d601$export$6b2a7d5132615086(rawTarget, "get", key);
                $b44e294c25f4d601$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            var has = $b44e294c25f4d601$var$getProto(rawTarget).has;
            var wrap = shallow ? $b44e294c25f4d601$var$toShallow : readonly ? $b44e294c25f4d601$export$4a78e7a2a4fb689f : $b44e294c25f4d601$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            var target = this["__v_raw"];
            !readonly && $b44e294c25f4d601$export$6b2a7d5132615086(/* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(target), "iterate", $b44e294c25f4d601$export$3c41b1a4e06acc14);
            return target.size;
        },
        has: function(key) {
            var target = this["__v_raw"];
            var rawTarget = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(target);
            var rawKey = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $6zvdv.hasChanged)(key, rawKey)) $b44e294c25f4d601$export$6b2a7d5132615086(rawTarget, "has", key);
                $b44e294c25f4d601$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach: function(callback, thisArg) {
            var observed = this;
            var target = observed["__v_raw"];
            var rawTarget = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(target);
            var wrap = shallow ? $b44e294c25f4d601$var$toShallow : readonly ? $b44e294c25f4d601$export$4a78e7a2a4fb689f : $b44e294c25f4d601$export$45c769cf449a508c;
            !readonly && $b44e294c25f4d601$export$6b2a7d5132615086(rawTarget, "iterate", $b44e294c25f4d601$export$3c41b1a4e06acc14);
            return target.forEach(function(value, key) {
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $6zvdv.extend)(instrumentations, readonly ? {
        add: $b44e294c25f4d601$var$createReadonlyMethod("add"),
        set: $b44e294c25f4d601$var$createReadonlyMethod("set"),
        delete: $b44e294c25f4d601$var$createReadonlyMethod("delete"),
        clear: $b44e294c25f4d601$var$createReadonlyMethod("clear")
    } : {
        add: function(value) {
            var target = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(this);
            var proto = $b44e294c25f4d601$var$getProto(target);
            var rawValue = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(value);
            var valueToAdd = !shallow && !/* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(value) && !/* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(value) ? rawValue : value;
            if (!(proto.has.call(target, valueToAdd) || (0, $6zvdv.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $6zvdv.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue))) {
                target.add(valueToAdd);
                $b44e294c25f4d601$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set: function(key, value) {
            if (!shallow && !/* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(value) && !/* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(value)) value = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(value);
            var target = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(this);
            var _getProto = $b44e294c25f4d601$var$getProto(target), has = _getProto.has, get = _getProto.get;
            var hadKey = has.call(target, key);
            if (!hadKey) {
                key = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            var oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $b44e294c25f4d601$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $6zvdv.hasChanged)(value, oldValue)) $b44e294c25f4d601$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete: function(key) {
            var target = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(this);
            var _getProto = $b44e294c25f4d601$var$getProto(target), has = _getProto.has, get = _getProto.get;
            var hadKey = has.call(target, key);
            if (!hadKey) {
                key = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            var oldValue = get ? get.call(target, key) : void 0;
            var result = target.delete(key);
            if (hadKey) $b44e294c25f4d601$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear: function() {
            var target = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(this);
            var hadItems = target.size !== 0;
            var oldTarget = void 0;
            var result = target.clear();
            if (hadItems) $b44e294c25f4d601$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ].forEach(function(method) {
        instrumentations[method] = $b44e294c25f4d601$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $b44e294c25f4d601$var$createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = $b44e294c25f4d601$var$createInstrumentations(isReadonly, shallow);
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $6zvdv.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $b44e294c25f4d601$var$mutableCollectionHandlers = {
    get: /*@__PURE__*/ $b44e294c25f4d601$var$createInstrumentationGetter(false, false)
};
var $b44e294c25f4d601$var$shallowCollectionHandlers = {
    get: /*@__PURE__*/ $b44e294c25f4d601$var$createInstrumentationGetter(false, true)
};
var $b44e294c25f4d601$var$readonlyCollectionHandlers = {
    get: /*@__PURE__*/ $b44e294c25f4d601$var$createInstrumentationGetter(true, false)
};
var $b44e294c25f4d601$var$shallowReadonlyCollectionHandlers = {
    get: /*@__PURE__*/ $b44e294c25f4d601$var$createInstrumentationGetter(true, true)
};
function $b44e294c25f4d601$var$checkIdentityKeys(target, has, key) {
    var rawKey = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        var type = (0, $6zvdv.toRawType)(target);
        $b44e294c25f4d601$var$warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
//#endregion
//#region packages/reactivity/src/reactive.ts
var $b44e294c25f4d601$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $b44e294c25f4d601$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $b44e294c25f4d601$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $b44e294c25f4d601$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $b44e294c25f4d601$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
/*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(target)) return target;
    return $b44e294c25f4d601$var$createReactiveObject(target, false, $b44e294c25f4d601$var$mutableHandlers, $b44e294c25f4d601$var$mutableCollectionHandlers, $b44e294c25f4d601$var$reactiveMap);
}
/**
* Shallow version of {@link reactive}.
*
* Unlike {@link reactive}, there is no deep conversion: only root-level
* properties are reactive for a shallow reactive object. Property values are
* stored and exposed as-is - this also means properties with ref values will
* not be automatically unwrapped.
*
* @example
* ```js
* const state = shallowReactive({
*   foo: 1,
*   nested: {
*     bar: 2
*   }
* })
*
* // mutating state's own properties is reactive
* state.foo++
*
* // ...but does not convert nested objects
* isReactive(state.nested) // false
*
* // NOT reactive
* state.nested.bar++
* ```
*
* @param target - The source object.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#shallowreactive}
*/ /*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$8d81cefd22d22260(target) {
    return $b44e294c25f4d601$var$createReactiveObject(target, false, $b44e294c25f4d601$var$shallowReactiveHandlers, $b44e294c25f4d601$var$shallowCollectionHandlers, $b44e294c25f4d601$var$shallowReactiveMap);
}
/**
* Takes an object (reactive or plain) or a ref and returns a readonly proxy to
* the original.
*
* A readonly proxy is deep: any nested property accessed will be readonly as
* well. It also has the same ref-unwrapping behavior as {@link reactive},
* except the unwrapped values will also be made readonly.
*
* @example
* ```js
* const original = reactive({ count: 0 })
*
* const copy = readonly(original)
*
* watchEffect(() => {
*   // works for reactivity tracking
*   console.log(copy.count)
* })
*
* // mutating original will trigger watchers relying on the copy
* original.count++
*
* // mutating the copy will fail and result in a warning
* copy.count++ // warning!
* ```
*
* @param target - The source object.
* @see {@link https://vuejs.org/api/reactivity-core.html#readonly}
*/ /*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$6ec456bd5b7b3c51(target) {
    return $b44e294c25f4d601$var$createReactiveObject(target, true, $b44e294c25f4d601$var$readonlyHandlers, $b44e294c25f4d601$var$readonlyCollectionHandlers, $b44e294c25f4d601$var$readonlyMap);
}
/**
* Shallow version of {@link readonly}.
*
* Unlike {@link readonly}, there is no deep conversion: only root-level
* properties are made readonly. Property values are stored and exposed as-is -
* this also means properties with ref values will not be automatically
* unwrapped.
*
* @example
* ```js
* const state = shallowReadonly({
*   foo: 1,
*   nested: {
*     bar: 2
*   }
* })
*
* // mutating state's own properties will fail
* state.foo++
*
* // ...but works on nested objects
* isReadonly(state.nested) // false
*
* // works
* state.nested.bar++
* ```
*
* @param target - The source object.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#shallowreadonly}
*/ /*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$7c4b5f2b50f09f6b(target) {
    return $b44e294c25f4d601$var$createReactiveObject(target, true, $b44e294c25f4d601$var$shallowReadonlyHandlers, $b44e294c25f4d601$var$shallowReadonlyCollectionHandlers, $b44e294c25f4d601$var$shallowReadonlyMap);
}
function $b44e294c25f4d601$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $6zvdv.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var targetType = $b44e294c25f4d601$var$targetTypeMap((0, $6zvdv.toRawType)(target));
    if (targetType === 0) return target;
    var proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
/**
* Checks if an object is a proxy created by {@link reactive} or
* {@link shallowReactive} (or {@link ref} in some cases).
*
* @example
* ```js
* isReactive(reactive({}))            // => true
* isReactive(readonly(reactive({})))  // => true
* isReactive(ref({}).value)           // => true
* isReactive(readonly(ref({})).value) // => true
* isReactive(ref(true))               // => false
* isReactive(shallowRef({}).value)    // => false
* isReactive(shallowReactive({}))     // => true
* ```
*
* @param value - The value to check.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#isreactive}
*/ /*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(value)) return /* @__PURE__ */ $b44e294c25f4d601$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
/**
* Checks whether the passed value is a readonly object. The properties of a
* readonly object can change, but they can't be assigned directly via the
* passed object.
*
* The proxies created by {@link readonly} and {@link shallowReadonly} are
* both considered readonly, as is a computed ref without a set function.
*
* @param value - The value to check.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#isreadonly}
*/ /*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
/*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
/**
* Checks if an object is a proxy created by {@link reactive},
* {@link readonly}, {@link shallowReactive} or {@link shallowReadonly}.
*
* @param value - The value to check.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#isproxy}
*/ /*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
/**
* Returns the raw, original object of a Vue-created proxy.
*
* `toRaw()` can return the original object from proxies created by
* {@link reactive}, {@link readonly}, {@link shallowReactive} or
* {@link shallowReadonly}.
*
* This is an escape hatch that can be used to temporarily read without
* incurring proxy access / tracking overhead or write without triggering
* changes. It is **not** recommended to hold a persistent reference to the
* original object. Use with caution.
*
* @example
* ```js
* const foo = {}
* const reactiveFoo = reactive(foo)
*
* console.log(toRaw(reactiveFoo) === foo) // true
* ```
*
* @param observed - The object for which the "raw" value is requested.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#toraw}
*/ /*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$ab18938b9fc5f28e(observed) {
    var raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(raw) : observed;
}
/**
* Marks an object so that it will never be converted to a proxy. Returns the
* object itself.
*
* @example
* ```js
* const foo = markRaw({})
* console.log(isReactive(reactive(foo))) // false
*
* // also works when nested inside other reactive objects
* const bar = reactive({ foo })
* console.log(isReactive(bar.foo)) // false
* ```
*
* **Warning:** `markRaw()` together with the shallow APIs such as
* {@link shallowReactive} allow you to selectively opt-out of the default
* deep reactive/readonly conversion and embed raw, non-proxied objects in your
* state graph.
*
* @param value - The object to be marked as "raw".
* @see {@link https://vuejs.org/api/reactivity-advanced.html#markraw}
*/ function $b44e294c25f4d601$export$995ab8b13ad7a9d0(value) {
    if (!(0, $6zvdv.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $6zvdv.def)(value, "__v_skip", true);
    return value;
}
/**
* Returns a reactive proxy of the given value (if possible).
*
* If the given value is not an object, the original value itself is returned.
*
* @param value - The value for which a reactive proxy shall be created.
*/ var $b44e294c25f4d601$export$45c769cf449a508c = function(value) {
    return (0, $6zvdv.isObject)(value) ? /* @__PURE__ */ $b44e294c25f4d601$export$90a44edba14e47be(value) : value;
};
/**
* Returns a readonly proxy of the given value (if possible).
*
* If the given value is not an object, the original value itself is returned.
*
* @param value - The value for which a readonly proxy shall be created.
*/ var $b44e294c25f4d601$export$4a78e7a2a4fb689f = function(value) {
    return (0, $6zvdv.isObject)(value) ? /* @__PURE__ */ $b44e294c25f4d601$export$6ec456bd5b7b3c51(value) : value;
};
//#endregion
//#region packages/reactivity/src/ref.ts
/*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
/*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$eff4d24c3ff7876e(value) {
    return $b44e294c25f4d601$var$createRef(value, $b44e294c25f4d601$export$45c769cf449a508c);
}
/*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$9b7bc5fe3b17c8b3(value) {
    return $b44e294c25f4d601$var$createRef(value);
}
function $b44e294c25f4d601$var$createRef(rawValue, wrap) {
    if (/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $b44e294c25f4d601$var$RefImpl(rawValue, wrap);
}
/**
* @internal
*/ var $b44e294c25f4d601$var$RefImpl = /*#__PURE__*/ function() {
    "use strict";
    function RefImpl(value, wrap) {
        (0, $173N4._)(this, RefImpl);
        this.subs = void 0;
        this.subsTail = void 0;
        this.flags = 1;
        this.__v_isRef = true;
        this.__v_isShallow = false;
        this._oldValue = this._rawValue = wrap ? /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(value) : value;
        this._value = wrap ? wrap(value) : value;
        this._wrap = wrap;
        this["__v_isShallow"] = !wrap;
    }
    (0, $cFHGC._)(RefImpl, [
        {
            key: "dep",
            get: function get() {
                return this;
            }
        },
        {
            key: "value",
            get: function get() {
                $b44e294c25f4d601$var$trackRef(this);
                if (this.flags & 16 && this.update()) {
                    var subs = this.subs;
                    if (subs !== void 0) $b44e294c25f4d601$var$shallowPropagate(subs);
                }
                return this._value;
            },
            set: function set(newValue) {
                var oldValue = this._rawValue;
                var useDirectValue = this["__v_isShallow"] || /* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(newValue) || /* @__PURE__ */ $b44e294c25f4d601$export$92d09b48637741e7(newValue);
                newValue = useDirectValue ? newValue : /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(newValue);
                if ((0, $6zvdv.hasChanged)(newValue, oldValue)) {
                    this.flags |= 16;
                    this._rawValue = newValue;
                    this._value = !useDirectValue && this._wrap ? this._wrap(newValue) : newValue;
                    var subs = this.subs;
                    if (subs !== void 0) {
                        $b44e294c25f4d601$var$propagate(subs);
                        if (!$b44e294c25f4d601$var$batchDepth) $b44e294c25f4d601$var$flush();
                    }
                }
            }
        },
        {
            key: "update",
            value: function update() {
                this.flags &= -17;
                return (0, $6zvdv.hasChanged)(this._oldValue, this._oldValue = this._rawValue);
            }
        }
    ]);
    return RefImpl;
}();
/**
* Force trigger effects that depends on a shallow ref. This is typically used
* after making deep mutations to the inner value of a shallow ref.
*
* @example
* ```js
* const shallow = shallowRef({
*   greet: 'Hello, world'
* })
*
* // Logs "Hello, world" once for the first run-through
* watchEffect(() => {
*   console.log(shallow.value.greet)
* })
*
* // This won't trigger the effect because the ref is shallow
* shallow.value.greet = 'Hello, universe'
*
* // Logs "Hello, universe"
* triggerRef(shallow)
* ```
*
* @param ref - The ref whose tied effects shall be executed.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#triggerref}
*/ function $b44e294c25f4d601$export$f402f86588575ccc(ref) {
    var dep = ref.dep;
    if (dep !== void 0 && dep.subs !== void 0) {
        $b44e294c25f4d601$var$propagate(dep.subs);
        $b44e294c25f4d601$var$shallowPropagate(dep.subs);
        if (!$b44e294c25f4d601$var$batchDepth) $b44e294c25f4d601$var$flush();
    }
}
function $b44e294c25f4d601$var$trackRef(dep) {
    if ($b44e294c25f4d601$var$activeSub !== void 0) $b44e294c25f4d601$var$link(dep, $b44e294c25f4d601$var$activeSub);
}
/**
* Returns the inner value if the argument is a ref, otherwise return the
* argument itself. This is a sugar function for
* `val = isRef(val) ? val.value : val`.
*
* @example
* ```js
* function useFoo(x: number | Ref<number>) {
*   const unwrapped = unref(x)
*   // unwrapped is guaranteed to be number now
* }
* ```
*
* @param ref - Ref or plain value to be converted into the plain value.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#unref}
*/ function $b44e294c25f4d601$export$a239a76781616204(ref) {
    return /* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(ref) ? ref.value : ref;
}
/**
* Normalizes values / refs / getters to values.
* This is similar to {@link unref}, except that it also normalizes getters.
* If the argument is a getter, it will be invoked and its return value will
* be returned.
*
* @example
* ```js
* toValue(1) // 1
* toValue(ref(1)) // 1
* toValue(() => 1) // 1
* ```
*
* @param source - A getter, an existing ref, or a non-function value.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#tovalue}
*/ function $b44e294c25f4d601$export$30bdcc2218aa9458(source) {
    return (0, $6zvdv.isFunction)(source) ? source() : $b44e294c25f4d601$export$a239a76781616204(source);
}
var $b44e294c25f4d601$var$shallowUnwrapHandlers = {
    get: function(target, key, receiver) {
        return key === "__v_raw" ? target : $b44e294c25f4d601$export$a239a76781616204(Reflect.get(target, key, receiver));
    },
    set: function(target, key, value, receiver) {
        var oldValue = target[key];
        if (/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
/**
* Returns a proxy for the given object that shallowly unwraps properties that
* are refs. If the object already is reactive, it's returned as-is. If not, a
* new reactive proxy is created.
*
* @param objectWithRefs - Either an already-reactive object or a simple object
* that contains refs.
*/ function $b44e294c25f4d601$export$f353fd1b97db3fa0(objectWithRefs) {
    return /* @__PURE__ */ $b44e294c25f4d601$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $b44e294c25f4d601$var$shallowUnwrapHandlers);
}
var $b44e294c25f4d601$var$CustomRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function CustomRefImpl(factory) {
        var _this = this;
        (0, $173N4._)(this, CustomRefImpl);
        this.subs = void 0;
        this.subsTail = void 0;
        this.flags = 0;
        this["__v_isRef"] = true;
        this._value = void 0;
        var _factory = factory(function() {
            return $b44e294c25f4d601$var$trackRef(_this);
        }, function() {
            return $b44e294c25f4d601$export$f402f86588575ccc(_this);
        }), get = _factory.get, set = _factory.set;
        this._get = get;
        this._set = set;
    }
    (0, $cFHGC._)(CustomRefImpl, [
        {
            key: "dep",
            get: function get() {
                return this;
            }
        },
        {
            key: "value",
            get: function get() {
                return this._value = this._get();
            },
            set: function set(newVal) {
                this._set(newVal);
            }
        }
    ]);
    return CustomRefImpl;
}();
/**
* Creates a customized ref with explicit control over its dependency tracking
* and updates triggering.
*
* @param factory - The function that receives the `track` and `trigger` callbacks.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#customref}
*/ function $b44e294c25f4d601$export$a20c2dd6199824cb(factory) {
    return new $b44e294c25f4d601$var$CustomRefImpl(factory);
}
/**
* Converts a reactive object to a plain object where each property of the
* resulting object is a ref pointing to the corresponding property of the
* original object. Each individual ref is created using {@link toRef}.
*
* @param object - Reactive object to be made into an object of linked refs.
* @see {@link https://vuejs.org/api/reactivity-utilities.html#torefs}
*/ /*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$2e9533675e5e70e0(object) {
    var ret = (0, $6zvdv.isArray)(object) ? new Array(object.length) : {};
    for(var key in object)ret[key] = $b44e294c25f4d601$var$propertyToRef(object, key);
    return ret;
}
var $b44e294c25f4d601$var$ObjectRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ObjectRefImpl(_object, key, _defaultValue) {
        (0, $173N4._)(this, ObjectRefImpl);
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $6zvdv.isSymbol)(key) ? key : String(key);
        this._raw = /* @__PURE__ */ $b44e294c25f4d601$export$ab18938b9fc5f28e(_object);
        var shallow = true;
        var obj = _object;
        if (!(0, $6zvdv.isArray)(_object) || (0, $6zvdv.isSymbol)(this._key) || !(0, $6zvdv.isIntegerKey)(this._key)) do shallow = !/* @__PURE__ */ $b44e294c25f4d601$export$5f3ca29d057519b3(obj) || /* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    (0, $cFHGC._)(ObjectRefImpl, [
        {
            key: "value",
            get: function get() {
                var val = this._object[this._key];
                if (this._shallow) val = $b44e294c25f4d601$export$a239a76781616204(val);
                return this._value = val === void 0 ? this._defaultValue : val;
            },
            set: function set(newVal) {
                if (this._shallow && /* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(this._raw[this._key])) {
                    var nestedRef = this._object[this._key];
                    if (/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(nestedRef)) {
                        nestedRef.value = newVal;
                        return;
                    }
                }
                this._object[this._key] = newVal;
            }
        },
        {
            key: "dep",
            get: function get() {
                return $b44e294c25f4d601$var$getDepFromReactive(this._raw, this._key);
            }
        }
    ]);
    return ObjectRefImpl;
}();
var $b44e294c25f4d601$var$GetterRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function GetterRefImpl(_getter) {
        (0, $173N4._)(this, GetterRefImpl);
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    (0, $cFHGC._)(GetterRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._value = this._getter();
            }
        }
    ]);
    return GetterRefImpl;
}();
/*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $6zvdv.isFunction)(source)) return new $b44e294c25f4d601$var$GetterRefImpl(source);
    else if ((0, $6zvdv.isObject)(source) && arguments.length > 1) return $b44e294c25f4d601$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $b44e294c25f4d601$export$eff4d24c3ff7876e(source);
}
function $b44e294c25f4d601$var$propertyToRef(source, key, defaultValue) {
    return new $b44e294c25f4d601$var$ObjectRefImpl(source, key, defaultValue);
}
//#endregion
//#region packages/reactivity/src/effect.ts
var $b44e294c25f4d601$export$37ee493b2f34ee54 = {
    "ALLOW_RECURSE": 128,
    "128": "ALLOW_RECURSE",
    "PAUSED": 256,
    "256": "PAUSED",
    "STOP": 1024,
    "1024": "STOP"
};
var $b44e294c25f4d601$export$28352bb4dd362521 = /*#__PURE__*/ function() {
    "use strict";
    function ReactiveEffect(fn) {
        (0, $173N4._)(this, ReactiveEffect);
        this.deps = void 0;
        this.depsTail = void 0;
        this.subs = void 0;
        this.subsTail = void 0;
        this.flags = 18;
        this.cleanups = [];
        this.cleanupsLength = 0;
        if (fn !== void 0) this.fn = fn;
        if ($b44e294c25f4d601$var$activeEffectScope) $b44e294c25f4d601$var$link(this, $b44e294c25f4d601$var$activeEffectScope);
    }
    (0, $cFHGC._)(ReactiveEffect, [
        {
            key: "fn",
            value: function fn() {}
        },
        {
            key: "active",
            get: function get() {
                return !(this.flags & 1024);
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.flags |= 256;
            }
        },
        {
            key: "resume",
            value: function resume() {
                if ((this.flags &= -257) & 48) this.notify();
            }
        },
        {
            key: "notify",
            value: function notify() {
                if (!(this.flags & 256) && this.dirty) this.run();
            }
        },
        {
            key: "run",
            value: function run() {
                if (!this.active) return this.fn();
                $b44e294c25f4d601$var$cleanup(this);
                var prevSub = $b44e294c25f4d601$var$startTracking(this);
                $b44e294c25f4d601$var$incRunDepth();
                try {
                    return this.fn();
                } finally{
                    $b44e294c25f4d601$var$decRunDepth();
                    $b44e294c25f4d601$var$endTracking(this, prevSub);
                    var flags = this.flags;
                    if ((flags & 136) === 136) {
                        this.flags = flags & -9;
                        this.notify();
                    }
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (!this.active) return;
                this.flags = 1024;
                var dep = this.deps;
                while(dep !== void 0)dep = $b44e294c25f4d601$var$unlink(dep, this);
                var sub = this.subs;
                if (sub !== void 0) $b44e294c25f4d601$var$unlink(sub);
                $b44e294c25f4d601$var$cleanup(this);
            }
        },
        {
            key: "dirty",
            get: function get() {
                var flags = this.flags;
                if (flags & 16) return true;
                if (flags & 32) {
                    if ($b44e294c25f4d601$var$checkDirty(this.deps, this)) {
                        this.flags = flags | 16;
                        return true;
                    } else this.flags = flags & -33;
                }
                return false;
            }
        }
    ]);
    return ReactiveEffect;
}();
function $b44e294c25f4d601$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $b44e294c25f4d601$export$28352bb4dd362521) fn = fn.effect.fn;
    var e = new $b44e294c25f4d601$export$28352bb4dd362521(fn);
    if (options) {
        var onStop = options.onStop, scheduler = options.scheduler;
        if (onStop) {
            options.onStop = void 0;
            var stop = e.stop.bind(e);
            e.stop = function() {
                stop();
                onStop();
            };
        }
        if (scheduler) {
            options.scheduler = void 0;
            e.notify = function() {
                if (!(e.flags & 256)) scheduler();
            };
        }
        (0, $6zvdv.extend)(e, options);
    }
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    var runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
/**
* Stops the effect associated with the given runner.
*
* @param runner - Association with the effect to stop tracking.
*/ function $b44e294c25f4d601$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
var $b44e294c25f4d601$var$resetTrackingStack = [];
/**
* Temporarily pauses tracking.
*/ function $b44e294c25f4d601$export$938a971395fef855() {
    $b44e294c25f4d601$var$resetTrackingStack.push($b44e294c25f4d601$var$activeSub);
    $b44e294c25f4d601$export$852d57bcb751cc7a();
}
/**
* Re-enables effect tracking (if it was paused).
*/ function $b44e294c25f4d601$export$1f8ffc6fd33b1d16() {
    if (!($b44e294c25f4d601$var$activeSub === void 0)) $b44e294c25f4d601$var$resetTrackingStack.push($b44e294c25f4d601$var$activeSub);
    else {
        $b44e294c25f4d601$var$resetTrackingStack.push(void 0);
        for(var i = $b44e294c25f4d601$var$resetTrackingStack.length - 1; i >= 0; i--)if ($b44e294c25f4d601$var$resetTrackingStack[i] !== void 0) {
            $b44e294c25f4d601$export$852d57bcb751cc7a($b44e294c25f4d601$var$resetTrackingStack[i]);
            break;
        }
    }
}
/**
* Resets the previous global effect tracking state.
*/ function $b44e294c25f4d601$export$c39176b1babaa8b8() {
    if ($b44e294c25f4d601$var$resetTrackingStack.length) $b44e294c25f4d601$export$852d57bcb751cc7a($b44e294c25f4d601$var$resetTrackingStack.pop());
    else $b44e294c25f4d601$export$852d57bcb751cc7a();
}
function $b44e294c25f4d601$var$cleanup(sub) {
    var l = sub.cleanupsLength;
    if (l) {
        for(var i = 0; i < l; i++)sub.cleanups[i]();
        sub.cleanupsLength = 0;
    }
}
/**
* Registers a cleanup function for the current active effect.
* The cleanup function is called right before the next effect run, or when the
* effect is stopped.
*
* Throws a warning if there is no current active effect. The warning can be
* suppressed by passing `true` to the second argument.
*
* @param fn - the cleanup function to be registered
* @param failSilently - if `true`, will not throw warning when called without
* an active effect.
*/ function $b44e294c25f4d601$export$92b6a62b33d94031(fn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if ($b44e294c25f4d601$var$activeSub instanceof $b44e294c25f4d601$export$28352bb4dd362521) $b44e294c25f4d601$var$activeSub.cleanups[$b44e294c25f4d601$var$activeSub.cleanupsLength++] = function() {
        return $b44e294c25f4d601$var$cleanupEffect(fn);
    };
}
function $b44e294c25f4d601$var$cleanupEffect(fn) {
    var prevSub = $b44e294c25f4d601$export$852d57bcb751cc7a();
    try {
        fn();
    } finally{
        $b44e294c25f4d601$export$852d57bcb751cc7a(prevSub);
    }
}
//#endregion
//#region packages/reactivity/src/effectScope.ts
var $b44e294c25f4d601$var$activeEffectScope;
var $b44e294c25f4d601$export$1168ed9dbc71ddbd = /*#__PURE__*/ function() {
    "use strict";
    function EffectScope() {
        var detached = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $173N4._)(this, EffectScope);
        this.deps = void 0;
        this.depsTail = void 0;
        this.subs = void 0;
        this.subsTail = void 0;
        this.flags = 0;
        this.cleanups = [];
        this.cleanupsLength = 0;
        if (!detached && $b44e294c25f4d601$var$activeEffectScope) $b44e294c25f4d601$var$link(this, $b44e294c25f4d601$var$activeEffectScope);
    }
    (0, $cFHGC._)(EffectScope, [
        {
            key: "active",
            get: function get() {
                return !(this.flags & 1024);
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (!(this.flags & 256)) {
                    this.flags |= 256;
                    for(var link = this.deps; link !== void 0; link = link.nextDep){
                        var dep = link.dep;
                        if ("pause" in dep) dep.pause();
                    }
                }
            }
        },
        {
            /**
	* Resumes the effect scope, including all child scopes and effects.
	*/ key: "resume",
            value: function resume() {
                var flags = this.flags;
                if (flags & 256) {
                    this.flags = flags & -257;
                    for(var link = this.deps; link !== void 0; link = link.nextDep){
                        var dep = link.dep;
                        if ("resume" in dep) dep.resume();
                    }
                }
            }
        },
        {
            key: "run",
            value: function run(fn) {
                var prevScope = $b44e294c25f4d601$var$activeEffectScope;
                try {
                    $b44e294c25f4d601$var$activeEffectScope = this;
                    return fn();
                } finally{
                    $b44e294c25f4d601$var$activeEffectScope = prevScope;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (!this.active) return;
                this.flags = 1024;
                this.reset();
                var sub = this.subs;
                if (sub !== void 0) $b44e294c25f4d601$var$unlink(sub);
            }
        },
        {
            /**
	* @internal
	*/ key: "reset",
            value: function reset() {
                var dep = this.deps;
                while(dep !== void 0){
                    var node = dep.dep;
                    if ("stop" in node) {
                        dep = dep.nextDep;
                        node.stop();
                    } else dep = $b44e294c25f4d601$var$unlink(dep, this);
                }
                $b44e294c25f4d601$var$cleanup(this);
            }
        }
    ]);
    return EffectScope;
}();
/**
* Creates an effect scope object which can capture the reactive effects (i.e.
* computed and watchers) created within it so that these effects can be
* disposed together. For detailed use cases of this API, please consult its
* corresponding {@link https://github.com/vuejs/rfcs/blob/master/active-rfcs/0041-reactivity-effect-scope.md | RFC}.
*
* @param detached - Can be used to create a "detached" effect scope.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#effectscope}
*/ function $b44e294c25f4d601$export$7056603ea81600be(detached) {
    return new $b44e294c25f4d601$export$1168ed9dbc71ddbd(detached);
}
/**
* Returns the current active effect scope if there is one.
*
* @see {@link https://vuejs.org/api/reactivity-advanced.html#getcurrentscope}
*/ function $b44e294c25f4d601$export$c7be4b0125a10cba() {
    return $b44e294c25f4d601$var$activeEffectScope;
}
function $b44e294c25f4d601$export$7c50eaa430038da7(scope) {
    try {
        return $b44e294c25f4d601$var$activeEffectScope;
    } finally{
        $b44e294c25f4d601$var$activeEffectScope = scope;
    }
}
/**
* Registers a dispose callback on the current active effect scope. The
* callback will be invoked when the associated effect scope is stopped.
*
* @param fn - The callback function to attach to the scope's cleanup.
* @see {@link https://vuejs.org/api/reactivity-advanced.html#onscopedispose}
*/ function $b44e294c25f4d601$export$a780418acd4762da(fn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if ($b44e294c25f4d601$var$activeEffectScope !== void 0) $b44e294c25f4d601$var$activeEffectScope.cleanups[$b44e294c25f4d601$var$activeEffectScope.cleanupsLength++] = fn;
}
//#endregion
//#region packages/reactivity/src/computed.ts
/**
* @private exported by @vue/reactivity for Vue core use, but not exported from
* the main vue package
*/ var $b44e294c25f4d601$var$ComputedRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ComputedRefImpl(fn, setter) {
        (0, $173N4._)(this, ComputedRefImpl);
        this.fn = fn;
        this.setter = setter;
        this._value = void 0;
        this.subs = void 0;
        this.subsTail = void 0;
        this.deps = void 0;
        this.depsTail = void 0;
        this.flags = 17;
        this.__v_isRef = true;
        this["__v_isReadonly"] = !setter;
    }
    (0, $cFHGC._)(ComputedRefImpl, [
        {
            key: "effect",
            get: function get() {
                return this;
            }
        },
        {
            key: "dep",
            get: function get() {
                return this;
            }
        },
        {
            key: "_dirty",
            get: /**
	* @internal
	* for backwards compat
	*/ function get() {
                var flags = this.flags;
                if (flags & 16) return true;
                if (flags & 32) {
                    if ($b44e294c25f4d601$var$checkDirty(this.deps, this)) {
                        this.flags = flags | 16;
                        return true;
                    } else this.flags = flags & -33;
                }
                return false;
            },
            set: /**
	* @internal
	* for backwards compat
	*/ function set(v) {
                if (v) this.flags |= 16;
                else this.flags &= -49;
            }
        },
        {
            key: "value",
            get: function get() {
                var flags = this.flags;
                if (flags & 16 || flags & 32 && $b44e294c25f4d601$var$checkDirty(this.deps, this)) {
                    if (this.update()) {
                        var subs = this.subs;
                        if (subs !== void 0) $b44e294c25f4d601$var$shallowPropagate(subs);
                    }
                } else if (flags & 32) this.flags = flags & -33;
                if ($b44e294c25f4d601$var$activeSub !== void 0) $b44e294c25f4d601$var$link(this, $b44e294c25f4d601$var$activeSub);
                else if ($b44e294c25f4d601$var$activeEffectScope !== void 0) $b44e294c25f4d601$var$link(this, $b44e294c25f4d601$var$activeEffectScope);
                return this._value;
            },
            set: function set(newValue) {
                if (this.setter) this.setter(newValue);
            }
        },
        {
            key: "update",
            value: function update() {
                var prevSub = $b44e294c25f4d601$var$startTracking(this);
                try {
                    var oldValue = this._value;
                    var newValue = this.fn(oldValue);
                    if ((0, $6zvdv.hasChanged)(oldValue, newValue)) {
                        this._value = newValue;
                        return true;
                    }
                    return false;
                } finally{
                    $b44e294c25f4d601$var$endTracking(this, prevSub);
                }
            }
        }
    ]);
    return ComputedRefImpl;
}();
/*@__NO_SIDE_EFFECTS__*/ function $b44e294c25f4d601$export$2983e091f1a1e8e2(getterOrOptions, debugOptions) {
    var isSSR = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var getter;
    var setter;
    if ((0, $6zvdv.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var cRef = new $b44e294c25f4d601$var$ComputedRefImpl(getter, setter);
    return cRef;
}
//#endregion
//#region packages/reactivity/src/constants.ts
var $b44e294c25f4d601$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
var $b44e294c25f4d601$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
var $b44e294c25f4d601$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
//#endregion
//#region packages/reactivity/src/watch.ts
var $b44e294c25f4d601$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
var $b44e294c25f4d601$var$INITIAL_WATCHER_VALUE = {};
var $b44e294c25f4d601$var$activeWatcher = void 0;
/**
* Returns the current active effect if there is one.
*/ function $b44e294c25f4d601$export$2532f7acfca7c82d() {
    return $b44e294c25f4d601$var$activeWatcher;
}
/**
* Registers a cleanup callback on the current active effect. This
* registered cleanup callback will be invoked right before the
* associated effect re-runs.
*
* @param cleanupFn - The callback function to attach to the effect's cleanup.
* @param failSilently - if `true`, will not throw warning when called without
* an active effect.
* @param owner - The effect that this cleanup function should be attached to.
* By default, the current active effect.
*/ function $b44e294c25f4d601$export$8ddeeb083684a9d0(cleanupFn) {
    var failSilently = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, owner = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $b44e294c25f4d601$var$activeWatcher;
    if (owner) {
        var call = owner.options.call;
        if (call) owner.cleanups[owner.cleanupsLength++] = function() {
            return call(cleanupFn, 4);
        };
        else owner.cleanups[owner.cleanupsLength++] = cleanupFn;
    }
}
var $b44e294c25f4d601$export$c243d5028940e63b = /*#__PURE__*/ function(ReactiveEffect) {
    "use strict";
    (0, $hdIku._)(WatcherEffect, ReactiveEffect);
    function WatcherEffect(source, cb) {
        var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $6zvdv.EMPTY_OBJ);
        (0, $173N4._)(this, WatcherEffect);
        var _this;
        var deep = options.deep, once = options.once, call = options.call, onWarn = options.onWarn;
        var getter;
        var forceTrigger = false;
        var isMultiSource = false;
        if (/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(source)) {
            getter = function() {
                return source.value;
            };
            forceTrigger = /* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(source);
        } else if (/* @__PURE__ */ $b44e294c25f4d601$export$352205f445242f02(source)) {
            getter = function() {
                return $b44e294c25f4d601$var$reactiveGetter(source, deep);
            };
            forceTrigger = true;
        } else if ((0, $6zvdv.isArray)(source)) {
            isMultiSource = true;
            forceTrigger = source.some(function(s) {
                return /* @__PURE__ */ $b44e294c25f4d601$export$352205f445242f02(s) || /* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(s);
            });
            getter = function() {
                return source.map(function(s) {
                    if (/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(s)) return s.value;
                    else if (/* @__PURE__ */ $b44e294c25f4d601$export$352205f445242f02(s)) return $b44e294c25f4d601$var$reactiveGetter(s, deep);
                    else if ((0, $6zvdv.isFunction)(s)) return call ? call(s, 2) : s();
                });
            };
        } else if ((0, $6zvdv.isFunction)(source)) {
            if (cb) getter = call ? function() {
                return call(source, 2);
            } : source;
            else getter = function() {
                if ((0, $gXzGB._)(_this).cleanupsLength) {
                    var prevSub = $b44e294c25f4d601$export$852d57bcb751cc7a();
                    try {
                        $b44e294c25f4d601$var$cleanup((0, $gXzGB._)(_this));
                    } finally{
                        $b44e294c25f4d601$export$852d57bcb751cc7a(prevSub);
                    }
                }
                var currentEffect = $b44e294c25f4d601$var$activeWatcher;
                $b44e294c25f4d601$var$activeWatcher = (0, $gXzGB._)(_this);
                try {
                    return call ? call(source, 3, [
                        (0, $gXzGB._)(_this).boundCleanup
                    ]) : source((0, $gXzGB._)(_this).boundCleanup);
                } finally{
                    $b44e294c25f4d601$var$activeWatcher = currentEffect;
                }
            };
        } else getter = (0, $6zvdv.NOOP);
        if (cb && deep) {
            var baseGetter = getter;
            var depth = deep === true ? Infinity : deep;
            getter = function() {
                return $b44e294c25f4d601$export$df3f009e3d155b20(baseGetter(), depth);
            };
        }
        _this = (0, $7qXGD._)(this, WatcherEffect, [
            getter
        ]);
        _this.cb = cb;
        _this.options = options;
        _this.boundCleanup = function(fn) {
            return $b44e294c25f4d601$export$8ddeeb083684a9d0(fn, false, _this);
        };
        _this.forceTrigger = forceTrigger;
        _this.isMultiSource = isMultiSource;
        if (once && cb) {
            var _cb = cb;
            cb = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var res = _cb.apply(void 0, (0, $aUGqu._)(args));
                _this.stop();
                return res;
            };
        }
        _this.cb = cb;
        _this.oldValue = isMultiSource ? new Array(source.length).fill($b44e294c25f4d601$var$INITIAL_WATCHER_VALUE) : $b44e294c25f4d601$var$INITIAL_WATCHER_VALUE;
        return _this;
    }
    (0, $cFHGC._)(WatcherEffect, [
        {
            key: "run",
            value: function run() {
                var initialRun = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var oldValue = this.oldValue;
                var newValue = this.oldValue = (0, $dWsrg._)((0, $kg0zo._)(WatcherEffect.prototype), "run", this).call(this);
                if (!this.cb) return;
                var _this_options = this.options, immediate = _this_options.immediate, deep = _this_options.deep, call = _this_options.call;
                if (initialRun && !immediate) return;
                if (initialRun || deep || this.forceTrigger || (this.isMultiSource ? newValue.some(function(v, i) {
                    return (0, $6zvdv.hasChanged)(v, oldValue[i]);
                }) : (0, $6zvdv.hasChanged)(newValue, oldValue))) {
                    $b44e294c25f4d601$var$cleanup(this);
                    var currentWatcher = $b44e294c25f4d601$var$activeWatcher;
                    $b44e294c25f4d601$var$activeWatcher = this;
                    try {
                        var args = [
                            newValue,
                            oldValue === $b44e294c25f4d601$var$INITIAL_WATCHER_VALUE ? void 0 : this.isMultiSource && oldValue[0] === $b44e294c25f4d601$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                            this.boundCleanup
                        ];
                        call ? call(this.cb, 3, args) : this.cb.apply(this, (0, $aUGqu._)(args));
                    } finally{
                        $b44e294c25f4d601$var$activeWatcher = currentWatcher;
                    }
                }
            }
        }
    ]);
    return WatcherEffect;
}($b44e294c25f4d601$export$28352bb4dd362521);
function $b44e294c25f4d601$var$reactiveGetter(source, deep) {
    if (deep) return source;
    if (/* @__PURE__ */ $b44e294c25f4d601$export$7f3fe6025abfa26e(source) || deep === false || deep === 0) return $b44e294c25f4d601$export$df3f009e3d155b20(source, 1);
    return $b44e294c25f4d601$export$df3f009e3d155b20(source);
}
function $b44e294c25f4d601$var$warnInvalidSource(s, onWarn) {
    (onWarn || $b44e294c25f4d601$var$warn)("Invalid watch source: ", s, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
}
function $b44e294c25f4d601$export$3db5d71bdb2d5499(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $6zvdv.EMPTY_OBJ);
    var effect = new $b44e294c25f4d601$export$c243d5028940e63b(source, cb, options);
    effect.run(true);
    var stop = effect.stop.bind(effect);
    stop.pause = effect.pause.bind(effect);
    stop.resume = effect.resume.bind(effect);
    stop.stop = stop;
    return stop;
}
function $b44e294c25f4d601$export$df3f009e3d155b20(value) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Infinity, seen = arguments.length > 2 ? arguments[2] : void 0;
    if (depth <= 0 || !(0, $6zvdv.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if (/* @__PURE__ */ $b44e294c25f4d601$export$4f9f5282de18fc69(value)) $b44e294c25f4d601$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $6zvdv.isArray)(value)) for(var i = 0; i < value.length; i++)$b44e294c25f4d601$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $6zvdv.isSet)(value) || (0, $6zvdv.isMap)(value)) value.forEach(function(v) {
        $b44e294c25f4d601$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $6zvdv.isPlainObject)(value)) {
        for(var key in value)$b44e294c25f4d601$export$df3f009e3d155b20(value[key], depth, seen);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.getOwnPropertySymbols(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key1 = _step.value;
                if (Object.prototype.propertyIsEnumerable.call(value, key1)) $b44e294c25f4d601$export$df3f009e3d155b20(value[key1], depth, seen);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return value;
}

});



parcelRegister("51zaq", function(module, exports) {

$parcel$export(module.exports, "setInsertionState", function () { return setInsertionState; });
$parcel$export(module.exports, "createTextNode", function () { return createTextNode; });
$parcel$export(module.exports, "txt", function () { return txt; });
$parcel$export(module.exports, "child", function () { return child; });
$parcel$export(module.exports, "nthChild", function () { return nthChild; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "remove", function () { return remove; });
$parcel$export(module.exports, "withOnce", function () { return withOnce; });
$parcel$export(module.exports, "renderEffect", function () { return renderEffect; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "createInvoker", function () { return createInvoker; });
$parcel$export(module.exports, "onBinding", function () { return onBinding; });
$parcel$export(module.exports, "delegate", function () { return delegate; });
$parcel$export(module.exports, "delegateEvents", function () { return delegateEvents; });
$parcel$export(module.exports, "setDynamicEvents", function () { return setDynamicEvents; });
$parcel$export(module.exports, "withVaporModifiers", function () { return withVaporModifiers; });
$parcel$export(module.exports, "withVaporKeys", function () { return withVaporKeys; });
$parcel$export(module.exports, "setProp", function () { return setProp; });
$parcel$export(module.exports, "setDOMProp", function () { return setDOMProp; });
$parcel$export(module.exports, "setAttr", function () { return setAttr; });
$parcel$export(module.exports, "setClass", function () { return setClass; });
$parcel$export(module.exports, "setClassName", function () { return setClassName; });
$parcel$export(module.exports, "setStyle", function () { return setStyle; });
$parcel$export(module.exports, "setValue", function () { return setValue; });
$parcel$export(module.exports, "setText", function () { return setText; });
$parcel$export(module.exports, "setElementText", function () { return setElementText; });
$parcel$export(module.exports, "setHtml", function () { return setHtml; });
$parcel$export(module.exports, "setDynamicProps", function () { return setDynamicProps; });
$parcel$export(module.exports, "setBlockKey", function () { return setBlockKey; });
$parcel$export(module.exports, "insert", function () { return insert; });
$parcel$export(module.exports, "createSlot", function () { return createSlot; });
$parcel$export(module.exports, "DynamicFragment", function () { return DynamicFragment; });
$parcel$export(module.exports, "isFragment", function () { return isFragment; });
$parcel$export(module.exports, "isVaporComponent", function () { return isVaporComponent; });
$parcel$export(module.exports, "VaporFragment", function () { return VaporFragment; });
$parcel$export(module.exports, "useVaporCssVars", function () { return useVaporCssVars; });
$parcel$export(module.exports, "createComponent", function () { return createComponent; });
$parcel$export(module.exports, "createAssetComponent", function () { return createAssetComponent; });
$parcel$export(module.exports, "createComponentWithFallback", function () { return createComponentWithFallback; });
$parcel$export(module.exports, "createPlainElement", function () { return createPlainElement; });
$parcel$export(module.exports, "createVaporApp", function () { return createVaporApp; });
$parcel$export(module.exports, "createVaporSSRApp", function () { return createVaporSSRApp; });
$parcel$export(module.exports, "defineVaporComponent", function () { return defineVaporComponent; });
$parcel$export(module.exports, "defineVaporAsyncComponent", function () { return defineVaporAsyncComponent; });
$parcel$export(module.exports, "VaporTransition", function () { return VaporTransition; });
$parcel$export(module.exports, "VaporKeepAlive", function () { return VaporKeepAlive; });
$parcel$export(module.exports, "vaporInteropPlugin", function () { return vaporInteropPlugin; });
$parcel$export(module.exports, "VaporTeleport", function () { return VaporTeleport; });
$parcel$export(module.exports, "defineVaporCustomElement", function () { return defineVaporCustomElement; });
$parcel$export(module.exports, "VaporElement", function () { return VaporElement; });
$parcel$export(module.exports, "defineVaporSSRCustomElement", function () { return defineVaporSSRCustomElement; });
$parcel$export(module.exports, "template", function () { return template; });
$parcel$export(module.exports, "createIf", function () { return createIf; });
$parcel$export(module.exports, "createKeyedFragment", function () { return createKeyedFragment; });
$parcel$export(module.exports, "createFor", function () { return createFor; });
$parcel$export(module.exports, "createSelector", function () { return createSelector; });
$parcel$export(module.exports, "createForSlots", function () { return createForSlots; });
$parcel$export(module.exports, "getRestElement", function () { return getRestElement; });
$parcel$export(module.exports, "getDefaultValue", function () { return getDefaultValue; });
$parcel$export(module.exports, "createTemplateRefSetter", function () { return createTemplateRefSetter; });
$parcel$export(module.exports, "setStaticTemplateRef", function () { return setStaticTemplateRef; });
$parcel$export(module.exports, "setTemplateRefBinding", function () { return setTemplateRefBinding; });
$parcel$export(module.exports, "createDynamicComponent", function () { return createDynamicComponent; });
$parcel$export(module.exports, "applyVShow", function () { return applyVShow; });
$parcel$export(module.exports, "applyTextModel", function () { return applyTextModel; });
$parcel$export(module.exports, "applyCheckboxModel", function () { return applyCheckboxModel; });
$parcel$export(module.exports, "applyRadioModel", function () { return applyRadioModel; });
$parcel$export(module.exports, "applySelectModel", function () { return applySelectModel; });
$parcel$export(module.exports, "applyDynamicModel", function () { return applyDynamicModel; });
$parcel$export(module.exports, "withVaporDirectives", function () { return withVaporDirectives; });
$parcel$export(module.exports, "VaporTransitionGroup", function () { return VaporTransitionGroup; });
$parcel$export(module.exports, "extend", function () { return (parcelRequire("6zvdv")).extend; });
/**
  * @vue/runtime-vapor v3.6.0-rc.9
  * (c) 2018-present Yuxi (Evan) You and Vue contributors
  * @license MIT
  **/ 
var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $fKAHx = parcelRequire("fKAHx");
var $ftLbb = parcelRequire("ftLbb");
var $3ewO8 = parcelRequire("3ewO8");
var $ftLbb = parcelRequire("ftLbb");

var $6zvdv = parcelRequire("6zvdv");

var $ftLbb = parcelRequire("ftLbb");
//#region packages/runtime-vapor/src/insertionState.ts
var insertionParent;
var insertionAnchor;
var insertionIndex;
/**
* This function is called before a block type that requires insertion
* (component, slot outlet, if, for) is created.
*
* - `anchor` is a Node: insert before this template `<!>` placeholder during
*   client render; during hydration the located placeholder unit is the
*   block's hydration target.
* - `anchor` is a number: append; the value is the hydration start unit index
*   (the count of preceding logical units), omitted by codegen when 0.
* - `anchor` absent: append with no preceding units.
*/ function setInsertionState(parent, anchor) {
    insertionParent = parent;
    if (typeof anchor === "number") {
        insertionAnchor = void 0;
        insertionIndex = anchor;
    } else {
        insertionAnchor = anchor;
        insertionIndex = void 0;
    }
}
function resetInsertionState() {
    insertionParent = insertionAnchor = insertionIndex = void 0;
}
//#endregion
//#region packages/runtime-vapor/src/dom/node.ts
var SVG_NS = "http://www.w3.org/2000/svg";
var MATHML_NS = "http://www.w3.org/1998/Math/MathML";
/*@__NO_SIDE_EFFECTS__*/ function createElement(tagName, ns) {
    return ns ? document.createElementNS(ns === 1 ? SVG_NS : MATHML_NS, tagName) : document.createElement(tagName);
}
/*@__NO_SIDE_EFFECTS__*/ function createTextNode() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return document.createTextNode(value);
}
/*@__NO_SIDE_EFFECTS__*/ function createComment(data) {
    return document.createComment(data);
}
/*@__NO_SIDE_EFFECTS__*/ function querySelector(selectors) {
    return document.querySelector(selectors);
}
/* @__NO_SIDE_EFFECTS__ */ function parentNode(node) {
    return node.parentNode;
}
/*@__NO_SIDE_EFFECTS__*/ function txt(node) {
    if (isHydrating$1) {
        var n = /* @__PURE__ */ _child(node);
        if (!n) return node.appendChild(/* @__PURE__ */ createTextNode());
        return n;
    }
    return /* @__PURE__ */ _child(node);
}
/*@__NO_SIDE_EFFECTS__*/ function child(node, isText) {
    if (isHydrating$1) {
        var n = locateChildByLogicalIndex(node, 0);
        return isText ? resolveBlankTextTarget(n, node) : n;
    }
    return /* @__PURE__ */ _child(node);
}
/*@__NO_SIDE_EFFECTS__*/ function nthChild(node, i, isText) {
    if (isHydrating$1) {
        var n = locateChildByLogicalIndex(node, i);
        return isText ? resolveBlankTextTarget(n, node) : n;
    }
    return node.childNodes[i];
}
/*@__NO_SIDE_EFFECTS__*/ function next(node, isText) {
    if (isHydrating$1) {
        var result = nextLogicalSibling(node);
        var parent = node.parentNode;
        if (isText) result = resolveBlankTextTarget(result, parent);
        if (parent) updateLastLocatedLogicalChild(parent, node, result, 1);
        return result;
    }
    return /* @__PURE__ */ _next(node);
}
/*@__NO_SIDE_EFFECTS__*/ function _child(node) {
    return node.firstChild;
}
/*@__NO_SIDE_EFFECTS__*/ function _next(node) {
    return node.nextSibling;
}
function locateChildByLogicalIndex(parent, logicalIndex) {
    var child = parent.$llc || skipUntrackedAnchors(parent.firstChild);
    var fromIndex = child && child.$idx || 0;
    if (logicalIndex < fromIndex) {
        child = skipUntrackedAnchors(parent.firstChild);
        fromIndex = 0;
    }
    while(child){
        if (fromIndex === logicalIndex) {
            child.$idx = logicalIndex;
            return parent.$llc = child;
        }
        child = nextLogicalSibling(child);
        fromIndex++;
    }
    return null;
}
function updateLastLocatedLogicalChild(parent, from, to) {
    var logicalIndexOffset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var insertionParent = parent;
    if (insertionParent.$llc === from) {
        if (to) to.$idx = from.$idx + logicalIndexOffset;
        insertionParent.$llc = to;
    }
}
//#endregion
//#region packages/runtime-vapor/src/renderContext.ts
var currentRenderContext = {
    slotOwner: null,
    slotBoundary: null,
    slotScopeIds: null,
    suspense: null
};
function setRenderContext(ctx) {
    var prev = currentRenderContext;
    currentRenderContext = ctx;
    return prev;
}
function withRenderContext(ctx, fn) {
    if (ctx === currentRenderContext) return fn();
    var prev = setRenderContext(ctx);
    try {
        return fn();
    } finally{
        currentRenderContext = prev;
    }
}
function deriveRenderContext(base, slotOwner, slotBoundary, slotScopeIds, suspense) {
    return slotOwner === base.slotOwner && slotBoundary === base.slotBoundary && slotScopeIds === base.slotScopeIds && suspense === base.suspense ? base : {
        slotOwner: slotOwner,
        slotBoundary: slotBoundary,
        slotScopeIds: slotScopeIds,
        suspense: suspense
    };
}
function deriveSlotOwner(base, slotOwner) {
    return deriveRenderContext(base, slotOwner, base.slotBoundary, base.slotScopeIds, base.suspense);
}
function deriveSlotBoundary(base, slotBoundary) {
    return deriveRenderContext(base, base.slotOwner, slotBoundary, base.slotScopeIds, base.suspense);
}
function deriveSlotScopeIds(base, slotScopeIds) {
    return deriveRenderContext(base, base.slotOwner, base.slotBoundary, slotScopeIds, base.suspense);
}
function deriveSuspense(base, suspense) {
    return deriveRenderContext(base, base.slotOwner, base.slotBoundary, base.slotScopeIds, suspense);
}
//#endregion
//#region packages/runtime-vapor/src/dom/scopeIdStamp.ts
function setElementScopeIds(el, scopeIds) {
    for(var i = 0; i < scopeIds.length; i++)el.setAttribute(scopeIds[i], "");
}
function setElementScopeIdsDeep(el, scopeIds) {
    setElementScopeIds(el, scopeIds);
    var child = el.firstElementChild;
    while(child){
        setElementScopeIdsDeep(child, scopeIds);
        child = child.nextElementSibling;
    }
}
/**
* Stamped-variant cache: ids are written once per (template prototype × id
* cell) and clones inherit them via cloneNode. Never stale because scope ids
* are compile-time constants; entries are freed with their cell (WeakMap key).
*/ var stampedTemplates = /* @__PURE__ */ new WeakMap();
function cloneStampedTemplate(prototype, scopeIds) {
    if (prototype.nodeType !== 1) return prototype.cloneNode(true);
    var variants = stampedTemplates.get(prototype);
    if (!variants) stampedTemplates.set(prototype, variants = /* @__PURE__ */ new WeakMap());
    var stamped = variants.get(scopeIds);
    if (!stamped) {
        stamped = prototype.cloneNode(true);
        setElementScopeIdsDeep(stamped, scopeIds);
        variants.set(scopeIds, stamped);
    }
    return stamped.cloneNode(true);
}
//#endregion
//#region packages/runtime-vapor/src/dom/hydration.ts
var START_TAG_RE = /^<([^\s/>]+)/;
var isHydratingEnabled$1 = false;
function setIsHydratingEnabled(value) {
    isHydratingEnabled$1 = value;
}
var currentHydrationNode = null;
var isHydrating$1 = false;
function setIsHydrating(value) {
    if (!isHydratingEnabled$1 && !(0, $fKAHx.isHydrating) && !(0, $fKAHx.isHydratingEnabled)) return false;
    try {
        return isHydrating$1;
    } finally{
        isHydrating$1 = value;
    }
}
var deferredHydrationBoundaryDepth = 0;
function isInDeferredHydrationBoundary() {
    return deferredHydrationBoundaryDepth > 0;
}
function withDeferredHydrationBoundary(fn) {
    deferredHydrationBoundaryDepth++;
    try {
        return fn();
    } finally{
        deferredHydrationBoundaryDepth--;
    }
}
function runWithoutHydration(fn) {
    var prev = setIsHydrating(false);
    try {
        return fn();
    } finally{
        setIsHydrating(prev);
    }
}
var isOptimized$1 = false;
var liveCursors = 0;
var hydrationDepth = 0;
function performHydration(fn, setup, cleanup) {
    if (!isOptimized$1) {
        adoptTemplate = adoptTemplateImpl;
        locateHydrationNode = locateHydrationNodeImpl;
        parseAdoptTarget = parseAdoptTargetImpl;
        Comment.prototype.$fe = void 0;
        Node.prototype.$idx = void 0;
        Node.prototype.$llc = void 0;
        Node.prototype.$vha = 0;
        Node.prototype.$rcn = void 0;
        isOptimized$1 = true;
    }
    var prev = setIsHydrating(true);
    var prevHydrationNode = currentHydrationNode;
    currentHydrationNode = null;
    try {
        setup();
        return fn();
    } finally{
        cleanup();
        currentHydrationNode = prevHydrationNode;
        setIsHydrating(prev);
    }
}
function withHydration(container, fn) {
    var setup = function() {
        return setInsertionState(container);
    };
    var cleanup = function() {
        return resetInsertionState();
    };
    return performHydration(fn, setup, cleanup);
}
function hydrateNode(node, fn) {
    var setup = function() {
        return setCurrentHydrationNode(node);
    };
    var cleanup = function() {};
    return performHydration(fn, setup, cleanup);
}
var adoptTemplate;
var locateHydrationNode;
var parseAdoptTarget;
var isComment = function(node, data) {
    return node.nodeType === 8 && node.data === data;
};
var markerlessHydrationContainer = null;
function setMarkerlessHydrationContainer(container) {
    try {
        return markerlessHydrationContainer;
    } finally{
        markerlessHydrationContainer = container;
        innermostFragmentClaim = null;
    }
}
var transitionChild = 0;
function setTransitionChildPending(pending) {
    try {
        return transitionChild === 1;
    } finally{
        transitionChild = pending ? 1 : 0;
    }
}
function createFragmentClaim() {
    return {
        start: null
    };
}
var innermostFragmentClaim = null;
/**
* Consume the fragment start under the cursor for `claim`, or take over the
* one the enclosing block consumed when nothing was hydrated in between.
*/ function claimFragmentStart(claim) {
    var node = currentHydrationNode;
    if (!node || transitionChild === 2) return;
    if (isComment(node, "[")) {
        claim.start = node;
        setCurrentHydrationNode(node.nextSibling);
    } else {
        var outer = innermostFragmentClaim;
        if (!outer || !outer.start || node !== skipUntrackedAnchors(outer.start.nextSibling)) return;
        claim.start = outer.start;
        outer.start = null;
    }
    if (markerlessHydrationContainer) innermostFragmentClaim = claim;
}
function setCurrentHydrationNode(node) {
    currentHydrationNode = skipUntrackedAnchors(node);
}
function advanceHydrationNode(node) {
    var next = skipUntrackedAnchors(node.nextSibling);
    if (next && currentHydrationNode === next) return;
    while(!next){
        var parent = node.parentNode;
        if (!parent) break;
        node = parent;
        next = skipUntrackedAnchors(node.nextSibling);
    }
    if (currentHydrationNode !== next) currentHydrationNode = next;
}
/**
* Open the block being entered: it is a transition child when the flag was
* armed for its level (element children carry insertion state and are not)
* unless it keeps its markers (component roots); its own content is not.
* Claims registered while it is open are only takeover targets for its
* content.
*/ function openBlockScope(keepsMarkers) {
    transitionChild = transitionChild === 1 && !insertionParent && !keepsMarkers ? 2 : 0;
}
function enterHydrationCursor(claim, keepsMarkers) {
    var cursor = captureHydrationCursor(keepsMarkers);
    locateHydrationNode(claim);
    cursor.start = currentHydrationNode;
    return cursor;
}
/**
* Capture the outer resume cursor and open the block scope without locating
* a start node, for dynamic wrappers whose inner owner locates the local
* start later, after the selected inner path is known. This avoids consuming
* insertion state too early.
*/ function captureHydrationCursor(keepsMarkers) {
    var cursor = {
        start: null,
        resume: insertionParent ? currentHydrationNode : void 0,
        transitionChild: transitionChild,
        innermostFragmentClaim: innermostFragmentClaim
    };
    openBlockScope(keepsMarkers);
    return cursor;
}
function exitHydrationCursor(cursor) {
    if (!cursor) return;
    transitionChild = cursor.transitionChild;
    innermostFragmentClaim = cursor.innermostFragmentClaim;
    if (cursor.resume !== void 0) setCurrentHydrationNode(cursor.resume);
}
/**
* Locate the first non-fragment-comment node and locate the next node
* while handling potential fragments.
*/ function adoptTemplateImpl(node, template) {
    var adoptChildren = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, ns = arguments.length > 3 ? arguments[3] : void 0, target = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : parseAdoptTargetImpl(template);
    if (target.type !== 8) node = target.blank ? resolveBlankTextTarget(node, /* @__PURE__ */ parentNode(node)) : resolveHydrationTarget(node);
    if (!matchesAdoptTarget(node, target)) node = handleMismatch(node, template, adoptChildren, ns);
    advanceHydrationNode(node);
    return node;
}
function nextLogicalSibling(node) {
    return skipUntrackedAnchors(isComment(node, "[") ? locateEndAnchor(node).nextSibling : isComment(node, "teleport start") ? locateEndAnchor(node, "teleport start", "teleport end").nextSibling : node.nextSibling);
}
/** Advance past anchors that occupy no SSR logical position. */ function skipUntrackedAnchors(node) {
    while(node !== null && node.$vha & 2)node = node.nextSibling;
    return node;
}
function locateHydrationNodeImpl(claim) {
    var node;
    if (insertionAnchor) node = insertionAnchor;
    else if (insertionParent) node = locateChildByLogicalIndex(insertionParent, insertionIndex || 0);
    else node = currentHydrationNode;
    resetInsertionState();
    setCurrentHydrationNode(node);
    if (claim) claimFragmentStart(claim);
}
/**
* The end anchor of the SSR fragment starting at `node`, or null when `node`
* is not a fragment start. The candidate-range shape every slot host checks
* before claiming hydrated content.
*/ function locateFragmentEnd(node) {
    return node && isComment(node, "[") ? locateEndAnchor(node) : null;
}
function locateEndAnchor(node) {
    var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "[", close = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "]";
    if (node.$fe) return node.$fe;
    var stack = [
        node
    ];
    while((node = /* @__PURE__ */ _next(node)) && stack.length > 0)if (node.nodeType === 8) {
        if (node.data === open) {
            if (node.$fe) node = node.$fe;
            else stack.push(node);
        } else if (node.data === close) {
            var matchingOpen = stack.pop();
            matchingOpen.$fe = node;
            if (stack.length === 0) return node;
        }
    }
    return null;
}
/**
* The close marker of a claimed range once its content hydrated. The cursor
* normally rests on it, so only a mismatch pays for the walk from `start`.
*/ function locateClaimedEnd(start) {
    var node = currentHydrationNode;
    if (node && isComment(node, "]") && !isClaimedAnchor(node)) return start.$fe = node;
    return locateEndAnchor(start);
}
function handleMismatch(node, template, adoptChildren, ns) {
    warnHydrationNodeMismatch(node, template);
    if (isComment(node, "[")) removeFragmentNodes(node);
    var shouldPreserveAnchor = isClaimedAnchor(node);
    var container = /* @__PURE__ */ parentNode(node);
    var next = shouldPreserveAnchor ? node : /* @__PURE__ */ _next(node);
    if (!shouldPreserveAnchor) remove(node, container);
    if (template[0] !== "<") {
        var newNode = markRecreatedNode(/* @__PURE__ */ createTextNode(template));
        container.insertBefore(newNode, next);
        if (!shouldPreserveAnchor) updateLastLocatedLogicalChild(container, node, newNode);
        return newNode;
    }
    var t = /* @__PURE__ */ createElement("template");
    var newNode1;
    if (ns) {
        var tag = ns === 1 ? "svg" : "math";
        t.innerHTML = "<".concat(tag, ">").concat(template, "</").concat(tag, ">");
        newNode1 = /* @__PURE__ */ _child(/* @__PURE__ */ _child(t.content)).cloneNode(true);
    } else {
        t.innerHTML = template;
        newNode1 = /* @__PURE__ */ _child(t.content).cloneNode(true);
    }
    markRecreatedNode(newNode1);
    if (newNode1.nodeType === 1) {
        var descendants = newNode1.querySelectorAll("*");
        for(var i = 0; i < descendants.length; i++)markRecreatedNode(descendants[i]);
        var slotScopeIds = currentRenderContext.slotScopeIds;
        if (slotScopeIds) setElementScopeIdsDeep(newNode1, slotScopeIds);
    }
    if (adoptChildren && node.nodeType === 1 && !newNode1.firstChild) {
        var child = node.firstChild;
        while(child){
            var nextChild = child.nextSibling;
            newNode1.appendChild(child);
            child = nextChild;
        }
    }
    container.insertBefore(newNode1, next);
    if (!shouldPreserveAnchor) updateLastLocatedLogicalChild(container, node, newNode1);
    return newNode1;
}
function parseAdoptTargetImpl(template) {
    var type;
    var tag = null;
    var tagUpper = null;
    var blank = false;
    if (template[0] !== "<") {
        type = 3;
        blank = template.trim() === "";
    } else if (template[1] === "!") type = 8;
    else {
        type = 1;
        var match = START_TAG_RE.exec(template);
        if (match) {
            tag = match[1].toLowerCase();
            tagUpper = match[1].toUpperCase();
        }
    }
    return {
        type: type,
        tag: tag,
        tagUpper: tagUpper,
        blank: blank
    };
}
/**
* Whether a server-rendered node can be adopted for the given client
* template: the node type must match the template's expected type, and
* element tags must match exactly — a prefix check is not enough
* (e.g. a server `<i>` must not be adopted for a client `<ins>`).
* The uppercase identity compare handles HTML elements without allocating;
* the lowercase fallback covers case-preserving foreign elements (SVG/MathML).
*/ function matchesAdoptTarget(node, target) {
    if (node.nodeType !== target.type) return false;
    if (target.type !== 1) return true;
    return !target.tag || node.tagName === target.tagUpper || node.tagName.toLowerCase() === target.tag;
}
function validateHydrationTarget(node, template) {
    if (!matchesAdoptTarget(node, parseAdoptTargetImpl(template))) warnHydrationNodeMismatch(node, template);
}
function hydrateTextNode(node, expected) {
    if (node.nodeType !== 3) return false;
    var text = node;
    if (text.data === expected) return true;
    var parent = text.parentElement;
    if (parent && !(0, $fKAHx.isMismatchAllowed)(parent, 0)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warnHydrationTextMismatch(text, expected);
        (0, $fKAHx.logMismatchError)();
    }
    text.data = expected;
    return true;
}
function warnHydrationTextMismatch(node, expected) {
    (0, $fKAHx.warn)("Hydration text mismatch in", node.parentNode, "\n  - rendered on server: ".concat(JSON.stringify(node.data), "\n  - expected on client: ").concat(JSON.stringify(expected)));
}
function warnHydrationNodeMismatch(node, expected) {
    if (!(0, $fKAHx.isMismatchAllowed)(node.parentElement, 1)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && (0, $fKAHx.warn)("Hydration node mismatch:\n- rendered on server:", node, node.nodeType === 3 ? "(text)" : isComment(node, "[") ? "(start of fragment)" : "", "\n- expected on client:", expected);
        (0, $fKAHx.logMismatchError)();
    }
}
function removeFragmentNodes(node, endAnchor) {
    var parent = /* @__PURE__ */ parentNode(node);
    if (!parent) return;
    var end = endAnchor || locateEndAnchor(node);
    while(true){
        var next = /* @__PURE__ */ _next(node);
        if (next && next !== end) remove(next, parent);
        else break;
    }
}
function removeHydrationNode(node) {
    var close = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var parent = /* @__PURE__ */ parentNode(node);
    if (!parent) return;
    if (isComment(node, "[")) {
        var end = locateEndAnchor(node);
        removeFragmentNodes(node, end || void 0);
        var endParent = end && /* @__PURE__ */ parentNode(end);
        if (end && end !== close && endParent) remove(end, endParent);
    } else if (isComment(node, "teleport start")) {
        var end1 = locateEndAnchor(node, "teleport start", "teleport end");
        removeFragmentNodes(node, end1 || void 0);
        var endParent1 = end1 && /* @__PURE__ */ parentNode(end1);
        if (end1 && end1 !== close && endParent1) remove(end1, endParent1);
    }
    remove(node, parent);
}
/**
* Removes unclaimed server-rendered nodes and reports a children mismatch.
* Trims `node` alone by default, the rest of `container`'s child list when
* `container` is given, or the logical siblings up to `close` when leaving a
* hydration boundary (which also moves the cursor onto `close`). Range cleanup
* keeps reused hydration anchors in place.
*/ function cleanupHydrationTail(node, container) {
    var close = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (close) {
        var cur = node;
        var hasRemovableNode = false;
        while(cur && cur !== close){
            if (!isClaimedAnchor(cur)) hasRemovableNode = true;
            cur = nextLogicalSibling(cur);
        }
        if (!cur) return;
        if (!hasRemovableNode) {
            setCurrentHydrationNode(close);
            return;
        }
    }
    var mismatchContainer = container || node.parentElement;
    if (mismatchContainer instanceof Element) warnHydrationChildrenMismatch(mismatchContainer);
    if (!container && !close) {
        removeHydrationNode(node);
        return;
    }
    var current = node;
    while(current && current !== close && (!container || current.parentNode === container)){
        var next = nextLogicalSibling(current);
        if (!isClaimedAnchor(current)) removeHydrationNode(current, close);
        current = next;
    }
    if (close) setCurrentHydrationNode(close);
}
/**
* Claim a node as some fragment's insertion anchor standing AT an SSR
* logical position. Claiming a previously untracked anchor promotes it into
* the position stream — a revived deferred branch does this when its runtime
* anchor takes over the logical unit the branch occupies. Use
* `claimUntrackedAnchor` for an anchor that must stay invisible to traversal.
*/ function claimAnchor(node) {
    node.$vha = 1;
    return node;
}
/**
* Claim a node as an anchor that holds no SSR logical position, so hydration
* traversal steps over it and inserting one mid-pass cannot shift the
* positions the server output defines. See `2`.
*/ function claimUntrackedAnchor(node) {
    node.$vha = 3;
    return node;
}
/**
* Whether some fragment owns this node as its insertion anchor, whatever its
* origin. Cleanup and mismatch recovery must leave it in place.
*/ function isClaimedAnchor(node) {
    return !!node && !!(node.$vha & 1);
}
function markRecreatedNode(node) {
    node.$rcn = 1;
    return node;
}
function isRecreatedNode(node) {
    return !!node && node.$rcn === 1;
}
/**
* SSR omits empty text nodes. Block owners consume their opening markers
* before template adoption. Preserve any remaining boundary or sibling while
* seeding the missing text at its logical position.
*/ function resolveBlankTextTarget(node, parent) {
    node = skipUntrackedAnchors(node);
    if (node && node.nodeType === 3) return node;
    var text = /* @__PURE__ */ createTextNode();
    parent.insertBefore(text, node);
    if (node) updateLastLocatedLogicalChild(parent, node, text);
    return text;
}
function resolveHydrationTarget(node) {
    while(true){
        var flags = node.$vha;
        if (flags) {
            if (!(flags & 2)) return node;
        } else if (!(node.nodeType === 8 && (node.data === "[" || node.data === "]" || node.data === "teleport start" || node.data === "teleport end"))) return node;
        var next = node.nextSibling;
        if (!next) return node;
        node = next;
    }
}
function warnHydrationChildrenMismatch(container) {
    if (container && !(0, $fKAHx.isMismatchAllowed)(container, 1)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && (0, $fKAHx.warn)("Hydration children mismatch on", container, "\nServer rendered element contains more child nodes than client nodes.");
        (0, $fKAHx.logMismatchError)();
    }
}
function enterHydrationBoundary(close) {
    return function() {
        return trimHydrationBoundary(close);
    };
}
/** Trim the unclaimed SSR nodes left between the cursor and `close`. */ function trimHydrationBoundary(close) {
    var node = currentHydrationNode;
    if (close && node && node !== close && !(close.compareDocumentPosition(node) & 4)) cleanupHydrationTail(node, void 0, close);
}
//#endregion
//#region packages/runtime-vapor/src/vdomInteropState.ts
var isInteropEnabled = false;
function setInteropEnabled() {
    isInteropEnabled = true;
}
var interopKey = Symbol("interop");
/**
* Carries the live VDOM slots ref on the raw-slots object handed to a vapor
* component mounted from VDOM. Replaces the old overloaded `_` key, which
* elsewhere means SlotFlags (vdom slots) or VaporSlotStability (slot
* functions).
*/ var interopSlotsKey = Symbol("interopSlots");
//#endregion
//#region packages/runtime-vapor/src/componentEmits.ts
/**
* The logic from core isn't too reusable so it's better to duplicate here
*/ function normalizeEmitsOptions(comp) {
    var cached = comp.__emitsOptions;
    if (cached) return cached;
    var raw = comp.emits;
    if (!raw) return null;
    var normalized;
    if ((0, $6zvdv.isArray)(raw)) {
        normalized = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = raw[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                normalized[key] = null;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else normalized = raw;
    return comp.__emitsOptions = normalized;
}
function emit(instance, event) {
    for(var _len = arguments.length, rawArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rawArgs[_key - 2] = arguments[_key];
    }
    var vnode = isInteropEnabled && instance.interopVNode;
    (0, $fKAHx.baseEmit).apply(void 0, [
        instance,
        vnode ? vnode.props || (0, $6zvdv.EMPTY_OBJ) : instance.rawProps || (0, $6zvdv.EMPTY_OBJ),
        vnode ? (0, $fKAHx.defaultPropGetter) : getAttrFromRawProps,
        event
    ].concat((0, $aUGqu._)(rawArgs)));
}
//#endregion
//#region packages/runtime-vapor/src/once.ts
/**
* Whether the code running now belongs to a v-once region: slot content or
* fallback rendered by a `<slot v-once>`, or a compiled v-once directive.
* While set, renderEffect runs its function once instead of creating an
* effect. Every component boundary resets it (Vapor setup, vdom mount), and
* deferred work captures it at creation. Call sites test `inOnce` first so
* the common path pays neither the closure nor the call.
*/ var inOnce = false;
function withOnce(fn) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (inOnce === value) return fn();
    var prev = inOnce;
    try {
        inOnce = value;
        return fn();
    } finally{
        inOnce = prev;
    }
}
//#endregion
//#region packages/runtime-vapor/src/suspense.ts
var isSuspenseEnabled = false;
var currentUnmountSuspense;
function enableSuspense() {
    isSuspenseEnabled = true;
}
function setCurrentUnmountSuspense(suspense) {
    try {
        return currentUnmountSuspense;
    } finally{
        currentUnmountSuspense = suspense;
    }
}
/**
* Establishes `suspense` as the active unmount pass's boundary around `fn`.
* The single entry point for the ambient: unmountComponent and the interop
* vnode unmount re-enter through this when their explicit argument differs
* from the active pass.
*/ function runWithUnmountSuspense(suspense, fn) {
    var prev = setCurrentUnmountSuspense(suspense);
    try {
        return fn();
    } finally{
        setCurrentUnmountSuspense(prev);
    }
}
/**
* The effective boundary for a teardown reached without a parameter channel —
* scope-disposal callbacks and block removal: the active unmount pass's
* boundary when one is set, the caller's fallback otherwise.
*/ function resolveUnmountSuspense(fallback) {
    return currentUnmountSuspense === void 0 ? fallback : currentUnmountSuspense;
}
//#endregion
//#region packages/runtime-vapor/src/renderEffect.ts
var RenderEffect = /*#__PURE__*/ function(ReactiveEffect) {
    "use strict";
    (0, $hdIku._)(RenderEffect, ReactiveEffect);
    function RenderEffect(render) {
        var noLifecycle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        (0, $173N4._)(this, RenderEffect);
        var _this;
        _this = (0, $7qXGD._)(this, RenderEffect, [
            noLifecycle ? render : void 0
        ]);
        _this.render = render;
        var instance = (0, $fKAHx.currentInstance);
        _this.order = instance ? instance.effectCount++ : 0;
        var e, e1;
        _this.i = instance;
        _this.job = void 0;
        _this.flags |= 128;
        return _this;
    }
    (0, $cFHGC._)(RenderEffect, [
        {
            key: "createJob",
            value: function createJob() {
                var _this = this;
                var job = function() {
                    if (!(_this.flags & 256) && _this.dirty) {
                        var deferred = isSuspenseEnabled && _this.i && _this.i.deferredKeepAliveUpdates;
                        if (deferred) {
                            if (isDeferredKeepAliveStateLive(deferred)) {
                                deferred.effects.push(job);
                                return;
                            }
                            settleDeferredKeepAliveUpdates(deferred, job);
                            return;
                        }
                        _this.run();
                    }
                };
                if (this.i) job.i = this.i;
                job.flags |= 2;
                return this.job = job;
            }
        },
        {
            key: "fn",
            value: function fn() {
                var instance = this.i;
                var scope = this.subs ? this.subs.sub : void 0;
                var hasUpdateHooks = instance && (instance.bu || instance.u);
                var prev = (0, $fKAHx.setCurrentInstance)(instance, scope);
                try {
                    if (hasUpdateHooks && instance.isMounted && !instance.isUpdating) {
                        instance.isUpdating = true;
                        try {
                            instance.bu && (0, $6zvdv.invokeArrayFns)(instance.bu);
                            this.render();
                        } catch (err) {
                            instance.isUpdating = false;
                            throw err;
                        }
                        var updateJob = this.updateJob;
                        if (!updateJob) updateJob = this.updateJob = function() {
                            instance.isUpdating = false;
                            instance.u && (0, $6zvdv.invokeArrayFns)(instance.u);
                        };
                        (0, $fKAHx.queuePostRenderEffect)(updateJob, void 0, instance.suspense);
                    } else this.render();
                } finally{
                    (0, $fKAHx.restoreCurrentInstance)(prev);
                }
            }
        },
        {
            key: "notify",
            value: function notify() {
                if (!(this.flags & 256)) (0, $fKAHx.queueJob)(this.job || this.createJob(), this.i ? this.i.uid : void 0, false, this.order);
            }
        }
    ]);
    return RenderEffect;
}((0, $ftLbb.ReactiveEffect));
function renderEffect(fn) {
    var noLifecycle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (inOnce) return fn();
    new RenderEffect(fn, noLifecycle).run();
}
//#endregion
//#region packages/runtime-vapor/src/componentProps.ts
function isolatePropSources(rawProps) {
    var _loop = function(key2) {
        if (key2 === "$") return "continue";
        var source = rawProps[key2];
        if ((0, $6zvdv.isFunction)(source)) {
            var target = committed || (committed = (0, $ftLbb.shallowReactive)({}));
            isolated[key2] = function() {
                return target[key2];
            };
        } else isolated[key2] = source;
    };
    var hasFunctionSource = false;
    for(var key in rawProps)if (key !== "$" && (0, $6zvdv.isFunction)(rawProps[key])) hasFunctionSource = true;
    var dynamicSources = rawProps.$;
    if (dynamicSources && !hasFunctionSource) for(var i = 0; i < dynamicSources.length; i++){
        var source = dynamicSources[i];
        if ((0, $6zvdv.isFunction)(source)) {
            hasFunctionSource = true;
            break;
        } else {
            for(var key1 in source)if ((0, $6zvdv.isFunction)(source[key1])) {
                hasFunctionSource = true;
                break;
            }
            if (hasFunctionSource) break;
        }
    }
    if (!hasFunctionSource) return rawProps;
    var isolated = Object.create(null);
    var committed;
    for(var key2 in rawProps)_loop(key2);
    var committedDynamicSources;
    var previousDynamicSources;
    if (dynamicSources) {
        var _loop1 = function(i1) {
            var source = dynamicSources[i1];
            if ((0, $6zvdv.isFunction)(source)) {
                var target = committedDynamicSources[i1] = (0, $ftLbb.shallowReactive)({});
                previousDynamicSources[i1] = {};
                isolatedDynamicSources[i1] = function() {
                    return target;
                };
            } else {
                var _loop = function(key) {
                    var value = source[key];
                    if ((0, $6zvdv.isFunction)(value)) {
                        if (!target1) target1 = committedDynamicSources[i1] = (0, $ftLbb.shallowReactive)({});
                        var committedSource = target1;
                        isolatedSource[key] = function() {
                            return committedSource[key];
                        };
                    } else isolatedSource[key] = value;
                };
                var isolatedSource = Object.create(null);
                var target1 = void 0;
                for(var key in source)_loop(key);
                isolatedDynamicSources[i1] = target1 ? isolatedSource : source;
            }
        };
        var isolatedDynamicSources = [];
        committedDynamicSources = [];
        previousDynamicSources = [];
        for(var i1 = 0; i1 < dynamicSources.length; i1++)_loop1(i1);
        var symbols = Object.getOwnPropertySymbols(dynamicSources);
        for(var i2 = 0; i2 < symbols.length; i2++)isolatedDynamicSources[symbols[i2]] = dynamicSources[symbols[i2]];
        isolated.$ = isolatedDynamicSources;
    }
    renderEffect(function() {
        if (committed) {
            for(var key in rawProps)if (key !== "$" && (0, $6zvdv.isFunction)(rawProps[key])) committed[key] = resolveSource(rawProps[key]);
        }
        if (dynamicSources) for(var i = 0; i < dynamicSources.length; i++){
            var source = dynamicSources[i];
            var target = committedDynamicSources[i];
            if (!target) continue;
            if ((0, $6zvdv.isFunction)(source)) {
                var next = resolveFunctionSource(source) || (0, $6zvdv.EMPTY_OBJ);
                var previous = previousDynamicSources[i];
                for(var key1 in previous)if (!(0, $6zvdv.hasOwn)(next, key1)) {
                    delete target[key1];
                    delete previous[key1];
                }
                for(var key2 in next)target[key2] = previous[key2] = next[key2];
            } else for(var key3 in source)if ((0, $6zvdv.isFunction)(source[key3])) target[key3] = resolveSource(source[key3]);
        }
    }, true);
    return isolated;
}
function resolveSource(source) {
    return (0, $6zvdv.isFunction)(source) ? resolveFunctionSource(source) : source;
}
function resolveFunctionSource(source) {
    if (source._cache) return source._cache.value;
    var parent = (0, $fKAHx.currentInstance) && (0, $fKAHx.currentInstance).parent;
    if (parent) {
        var prev = (0, $fKAHx.setCurrentInstance)(parent, (0, $ftLbb.getCurrentScope)());
        try {
            source._cache = (0, $ftLbb.computed)(function(oldValue) {
                var prevInner = (0, $fKAHx.setCurrentInstance)(parent);
                try {
                    return stabilizeDynamicSourceValue(oldValue, source());
                } finally{
                    (0, $fKAHx.restoreCurrentInstance)(prevInner);
                }
            });
            (0, $ftLbb.onScopeDispose)(function() {
                return source._cache = void 0;
            });
        } finally{
            (0, $fKAHx.restoreCurrentInstance)(prev);
        }
        return source._cache.value;
    }
    return source();
}
function snapshotRawProps(rawProps) {
    var snapshot = Object.create(null);
    for(var key in rawProps)if (key !== "$") snapshot[key] = freezeValue(key, readSource(rawProps[key]));
    var dynamicSources = rawProps.$;
    if (dynamicSources) {
        var snapshotSources = [];
        for(var i = 0; i < dynamicSources.length; i++){
            var source = dynamicSources[i];
            var isDynamic = (0, $6zvdv.isFunction)(source);
            var resolved = readSource(source) || (0, $6zvdv.EMPTY_OBJ);
            var value = Object.create(null);
            for(var key1 in resolved)value[key1] = freezeValue(key1, isDynamic ? resolved[key1] : readSource(resolved[key1]));
            snapshotSources[i] = value;
        }
        var symbols = Object.getOwnPropertySymbols(dynamicSources);
        for(var i1 = 0; i1 < symbols.length; i1++)snapshotSources[symbols[i1]] = dynamicSources[symbols[i1]];
        snapshot.$ = snapshotSources;
    }
    return snapshot;
}
function readSource(source) {
    return (0, $6zvdv.isFunction)(source) ? source() : source;
}
function freezeValue(key, value) {
    if (key === "class" && value && !(0, $6zvdv.isString)(value)) return (0, $6zvdv.normalizeClass)(value);
    if (key === "style" && (0, $6zvdv.isArray)(value)) return (0, $6zvdv.normalizeStyle)(value);
    return (0, $6zvdv.isFunction)(value) ? function() {
        return value;
    } : value;
}
function stabilizeDynamicSourceValue(oldValue, value) {
    if (!(0, $6zvdv.isPlainObject)(oldValue) || !(0, $6zvdv.isPlainObject)(value)) return value;
    var oldKeys = Object.keys(oldValue);
    var newKeys = Object.keys(value);
    if (oldKeys.length !== newKeys.length) return value;
    for(var i = 0; i < newKeys.length; i++){
        var key = newKeys[i];
        if (!(0, $6zvdv.hasOwn)(oldValue, key) || !Object.is(oldValue[key], value[key])) return value;
    }
    return oldValue;
}
function getPropsProxyHandlers(comp) {
    if (comp.__propsHandlers) return comp.__propsHandlers;
    var propsOptions = normalizePropsOptions(comp)[0];
    var emitsOptions = normalizeEmitsOptions(comp);
    var isProp = propsOptions ? function(key) {
        return (0, $6zvdv.isString)(key) && (0, $6zvdv.hasOwn)(propsOptions, (0, $6zvdv.camelize)(key));
    } : (0, $6zvdv.NO);
    var isAttr = propsOptions || emitsOptions ? function(key) {
        return (0, $6zvdv.isString)(key) && key !== "$" && !(0, $6zvdv.isReservedProp)(key) && !isProp(key) && !(0, $fKAHx.isEmitListener)(emitsOptions, key);
    } : function(key) {
        return (0, $6zvdv.isString)(key) && !(0, $6zvdv.isReservedProp)(key);
    };
    var normalizeRawProp = function(key, value) {
        if (!value) return value;
        if (key === "class" && !(0, $6zvdv.isString)(value)) return (0, $6zvdv.normalizeClass)(value);
        if (key === "style" && (0, $6zvdv.isObject)(value)) return (0, $6zvdv.normalizeStyle)(value);
        return value;
    };
    var getProp = function(instance, key) {
        if (key === "__v_isReactive" || key === "__v_isShallow") return true;
        if (!isProp(key)) return;
        var rawProps = instance.rawProps;
        var dynamicSources = rawProps.$;
        if (dynamicSources && (0, $6zvdv.isOn)(key)) {
            var handlers = {};
            var matchedKey;
            for(var i = -1; i < dynamicSources.length; i++){
                var source = i < 0 ? rawProps : dynamicSources[i];
                var isDynamic = (0, $6zvdv.isFunction)(source);
                var resolved = isDynamic ? resolveFunctionSource(source) : source;
                for(var rawKey in resolved)if ((0, $6zvdv.camelize)(rawKey) === key) {
                    if (!(0, $6zvdv.hasOwn)(handlers, rawKey)) matchedKey = rawKey;
                    var value = isDynamic ? resolved[rawKey] : resolveSource(resolved[rawKey]);
                    handlers[rawKey] = mergeEventHandlers(handlers[rawKey], value);
                }
            }
            return (0, $fKAHx.resolvePropValue)(propsOptions, key, matchedKey === void 0 ? void 0 : handlers[matchedKey], instance, resolveDefault, matchedKey === void 0);
        }
        var merged = dynamicSources && (key === "class" || key === "style") ? [] : void 0;
        if (dynamicSources) {
            var i1 = dynamicSources.length;
            var source1, isDynamic1, rawKey1;
            while(i1--){
                source1 = dynamicSources[i1];
                isDynamic1 = (0, $6zvdv.isFunction)(source1);
                source1 = isDynamic1 ? resolveFunctionSource(source1) : source1;
                for(rawKey1 in source1)if ((0, $6zvdv.camelize)(rawKey1) === key) {
                    var value1 = isDynamic1 ? source1[rawKey1] : resolveSource(source1[rawKey1]);
                    if (merged) merged.push(value1);
                    else return (0, $fKAHx.resolvePropValue)(propsOptions, key, normalizeRawProp(key, value1), instance, resolveDefault);
                }
            }
        }
        for(var rawKey2 in rawProps)if ((0, $6zvdv.camelize)(rawKey2) === key) {
            var value2 = resolveSource(rawProps[rawKey2]);
            if (merged) merged.push(value2);
            else return (0, $fKAHx.resolvePropValue)(propsOptions, key, normalizeRawProp(key, value2), instance, resolveDefault);
        }
        var hasMerged = !!(merged && merged.length);
        var value3;
        if (hasMerged) {
            if (merged.length === 1) value3 = merged[0];
            else if (key === "class") {
                for(var i2 = merged.length - 1; i2 >= 0; i2--)if (value3 !== merged[i2]) value3 = (0, $6zvdv.normalizeClass)([
                    value3,
                    merged[i2]
                ]);
            } else value3 = merged.reverse();
        }
        return (0, $fKAHx.resolvePropValue)(propsOptions, key, normalizeRawProp(key, value3), instance, resolveDefault, !hasMerged);
    };
    var propsHandlers = propsOptions ? {
        get: getProp,
        has: function(_, key) {
            return isProp(key);
        },
        ownKeys: function() {
            return Object.keys(propsOptions);
        },
        getOwnPropertyDescriptor: function(target, key) {
            if (isProp(key)) return {
                configurable: true,
                enumerable: true,
                get: function() {
                    return getProp(target, key);
                }
            };
        }
    } : null;
    var getAttr = function(target, key) {
        if ((0, $6zvdv.isString)(key) && !(0, $6zvdv.isReservedProp)(key) && !isProp(key) && !(0, $fKAHx.isEmitListener)(emitsOptions, key)) return getAttrFromRawProps(target, key);
    };
    var hasAttr = function(target, key) {
        if (isAttr(key)) return hasAttrFromRawProps(target, key);
        else return false;
    };
    var getAttrKeys = function(target) {
        return getKeysFromRawProps(target.rawProps).filter(isAttr);
    };
    var attrsHandlers = {
        get: function(target, key) {
            return getAttr(target.rawProps, key);
        },
        has: function(target, key) {
            return hasAttr(target.rawProps, key);
        },
        ownKeys: getAttrKeys,
        getOwnPropertyDescriptor: function(target, key) {
            if ((0, $6zvdv.isString)(key) && hasAttr(target.rawProps, key)) return {
                configurable: true,
                enumerable: true,
                get: function() {
                    return getAttr(target.rawProps, key);
                }
            };
        }
    };
    return comp.__propsHandlers = [
        propsHandlers,
        attrsHandlers
    ];
}
function getAttrFromRawProps(rawProps, key) {
    if (key === "$") return;
    var dynamicSources = rawProps.$;
    var isEvent = dynamicSources && (0, $6zvdv.isString)(key) && (0, $6zvdv.isOn)(key);
    var merged = key === "class" || key === "style" || isEvent ? [] : void 0;
    if (dynamicSources) {
        var i = dynamicSources.length;
        var source, isDynamic;
        while(i--){
            source = dynamicSources[i];
            isDynamic = (0, $6zvdv.isFunction)(source);
            source = isDynamic ? resolveFunctionSource(source) : source;
            if (source && (0, $6zvdv.hasOwn)(source, key)) {
                var value = isDynamic ? source[key] : resolveSource(source[key]);
                if (merged) merged.push(value);
                else return value;
            }
        }
    }
    if ((0, $6zvdv.hasOwn)(rawProps, key)) {
        var value1 = resolveSource(rawProps[key]);
        if (merged) merged.push(value1);
        else return value1;
    }
    if (merged && merged.length) {
        merged.reverse();
        return isEvent ? merged.reduce(mergeEventHandlers) : merged;
    }
}
function mergeEventHandlers(existing, incoming) {
    if (!existing) return incoming;
    return incoming && existing !== incoming && !((0, $6zvdv.isArray)(existing) && existing.includes(incoming)) ? [].concat(existing, incoming) : existing;
}
function hasAttrFromRawProps(rawProps, key) {
    if (key === "$") return false;
    var dynamicSources = rawProps.$;
    if (dynamicSources) {
        var i = dynamicSources.length;
        while(i--){
            var source = resolveSource(dynamicSources[i]);
            if (source && (0, $6zvdv.hasOwn)(source, key)) return true;
        }
    }
    return (0, $6zvdv.hasOwn)(rawProps, key);
}
function getKeysFromRawProps(rawProps) {
    var keys = [];
    for(var key in rawProps)if (key !== "$") keys.push(key);
    var dynamicSources = rawProps.$;
    if (dynamicSources) {
        var i = dynamicSources.length;
        var source;
        while(i--){
            source = (0, $6zvdv.isFunction)(dynamicSources[i]) ? resolveFunctionSource(dynamicSources[i]) : dynamicSources[i];
            for(var key1 in source)keys.push(key1);
        }
    }
    return Array.from(new Set(keys));
}
function normalizePropsOptions(comp) {
    var cached = comp.__propsOptions;
    if (cached) return cached;
    var raw = comp.props;
    if (!raw) return 0, $6zvdv.EMPTY_ARR;
    var normalized = {};
    var needCastKeys = [];
    (0, $fKAHx.baseNormalizePropsOptions)(raw, normalized, needCastKeys);
    return comp.__propsOptions = [
        normalized,
        needCastKeys
    ];
}
function resolveDefault(factory, instance) {
    var prev = (0, $fKAHx.setCurrentInstance)(instance);
    var res = factory.call(null, instance.props);
    (0, $fKAHx.restoreCurrentInstance)(prev);
    return res;
}
function hasFallthroughAttrs(comp, rawProps) {
    if (rawProps) {
        if (rawProps.$) return true;
        var propsOptions = comp.props ? normalizePropsOptions(comp)[0] : null;
        for(var key in rawProps)if (!propsOptions || !(0, $6zvdv.hasOwn)(propsOptions, (0, $6zvdv.camelize)(key))) return true;
    }
    return false;
}
/**
* dev only
*/ function setupPropsValidation(instance) {
    var warningContext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : instance;
    var rawProps = instance.rawProps;
    if (!rawProps) return;
    renderEffect(function() {
        (0, $fKAHx.pushWarningContext)(warningContext);
        (0, $fKAHx.validateProps)(resolveDynamicProps(rawProps), instance.props, normalizePropsOptions(instance.type)[0]);
        (0, $fKAHx.popWarningContext)();
    }, true);
}
function resolveDynamicProps(props) {
    var mergedRawProps = {};
    for(var key in props)if (key !== "$") mergedRawProps[key] = resolveSource(props[key]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (props.$) try {
        for(var _iterator = props.$[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var source = _step.value;
            var isDynamic = (0, $6zvdv.isFunction)(source);
            var resolved = isDynamic ? resolveFunctionSource(source) : source;
            for(var key1 in resolved){
                var value = isDynamic ? resolved[key1] : resolveSource(source[key1]);
                if (key1 === "class" || key1 === "style") {
                    var existing = mergedRawProps[key1];
                    mergedRawProps[key1] = (0, $6zvdv.isArray)(existing) ? (0, $aUGqu._)(existing).concat([
                        value
                    ]) : [
                        existing,
                        value
                    ];
                } else if ((0, $6zvdv.isOn)(key1)) mergedRawProps[key1] = mergeEventHandlers(mergedRawProps[key1], value);
                else mergedRawProps[key1] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedRawProps;
}
function propsSetDevTrap(_, key) {
    (0, $fKAHx.warn)("Attempt to mutate prop ".concat(JSON.stringify(key), " failed. Props are readonly."));
    return true;
}
function propsDeleteDevTrap(_, key) {
    (0, $fKAHx.warn)("Attempt to delete prop ".concat(JSON.stringify(key), " failed. Props are readonly."));
    return true;
}
var rawPropsProxyHandlers = {
    get: getAttrFromRawProps,
    has: hasAttrFromRawProps,
    ownKeys: getKeysFromRawProps,
    getOwnPropertyDescriptor: function(target, key) {
        if (hasAttrFromRawProps(target, key)) return {
            configurable: true,
            enumerable: true,
            get: function() {
                return getAttrFromRawProps(target, key);
            }
        };
    }
};
//#endregion
//#region packages/runtime-vapor/src/dom/event.ts
function addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
    return function() {
        return el.removeEventListener(event, handler, options);
    };
}
function on(el, event, handler, options) {
    if ((0, $6zvdv.isArray)(handler)) handler.forEach(function(fn) {
        return on(el, event, fn, options);
    });
    else {
        if (!handler) return;
        el.addEventListener(event, createInvoker(handler), options);
    }
}
function onBinding(el, event, handler, options) {
    if ((0, $6zvdv.isArray)(handler)) {
        handler.forEach(function(fn) {
            return onBinding(el, event, fn, options);
        });
        return;
    }
    if (!handler) return;
    if (options && options.once) {
        var firedKey = "$evtonce_".concat(options.capture ? 1 : 0, "_").concat(event);
        if (el[firedKey]) return;
        var invoker = handler;
        handler = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            el[firedKey] = true;
            return invoker.apply(void 0, (0, $aUGqu._)(args));
        };
    }
    var cleanup = addEventListener(el, event, createInvoker(handler), options);
    (0, $ftLbb.onEffectCleanup)(cleanup);
}
function delegate(el, event, handler) {
    var key = "$evt".concat(event);
    var existing = el[key];
    var invoker = createInvoker(handler);
    if (existing) {
        if ((0, $6zvdv.isArray)(existing)) existing.push(invoker);
        else el[key] = [
            existing,
            invoker
        ];
    } else el[key] = invoker;
}
/**
* Event delegation borrowed from solid
*/ var delegatedEvents = /*@__PURE__*/ Object.create(null);
var delegateEvents = function() {
    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
        names[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            if (!delegatedEvents[name]) {
                delegatedEvents[name] = true;
                document.addEventListener(name, delegatedEventHandler);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var delegatedEventHandler = function(e) {
    var node = e.composedPath && e.composedPath()[0] || e.target;
    if (e.target !== node) Object.defineProperty(e, "target", {
        configurable: true,
        value: node
    });
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get: function() {
            return node || document;
        }
    });
    while(node !== null){
        var handlers = node["$evt".concat(e.type)];
        if (handlers) {
            if ((0, $6zvdv.isArray)(handlers)) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var handler = _step.value;
                        if (!node.disabled) {
                            handler(e);
                            if (e.cancelBubble) return;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else if (!node.disabled) {
                handlers(e);
                if (e.cancelBubble) return;
            }
        }
        node = node.host && node.host !== node && node.host instanceof Node ? node.host : node.parentNode;
    }
};
function setDynamicEvents(el, events) {
    for(var name in events){
        var _parseEventName = (0, $f9AOD._)((0, $3ewO8.parseEventName)("on:".concat(name)), 2), event = _parseEventName[0], options = _parseEventName[1];
        onBinding(el, event, events[name], options);
    }
}
function withVaporModifiers(fn, modifiers) {
    return createInvoker(typeof fn === "function" ? (0, $3ewO8.withModifiers)(fn, modifiers) : fn);
}
function withVaporKeys(fn, modifiers) {
    return createInvoker(typeof fn === "function" ? (0, $3ewO8.withKeys)(fn, modifiers) : fn);
}
function createInvoker(handler) {
    var i = (0, $fKAHx.currentInstance);
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $fKAHx.callWithAsyncErrorHandling)(handler, i, 5, args);
    };
}
//#endregion
//#region packages/runtime-vapor/src/transition.ts
var applyTransitionHooks;
var applyTransitionLeaveHooks;
var deferBranchUpdateDuringLeave;
var removeBranchWithLeave;
var isTransitionEnabled = false;
function registerTransitionHooks(applyHooks, applyLeaveHooks, deferBranchUpdate, removeBranch) {
    isTransitionEnabled = true;
    applyTransitionHooks = applyHooks;
    applyTransitionLeaveHooks = applyLeaveHooks;
    deferBranchUpdateDuringLeave = deferBranchUpdate;
    removeBranchWithLeave = removeBranch;
}
var displayName = "VaporTransition";
function isVaporTransition(component) {
    return component.displayName === displayName;
}
//#endregion
//#region packages/runtime-vapor/src/dom/prop.ts
var shouldSkipFallthroughKey = function(el, key) {
    var instance = (0, $fKAHx.currentInstance);
    return !isApplyingFallthroughProps && el.$root && instance.hasFallthrough && instance.type.inheritAttrs !== false && key in instance.attrs && !isDeclaredModelListener(instance, key) && (!shouldUseFunctionalFallthrough(instance.type) || (0, $fKAHx.isFunctionalFallthroughKey)(key));
};
function setProp(el, key, value) {
    if (key in el) setDOMProp(el, key, value);
    else setAttr(el, key, value);
}
function setAttr(el, key, value) {
    var isSVG = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (shouldSkipFallthroughKey(el, key)) return;
    if (key === "true-value") el._trueValue = value;
    else if (key === "false-value") el._falseValue = value;
    if (isHydrating$1 && !isRecreatedNode(el)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && attributeHasMismatch(el, key, value);
        el["$".concat(key)] = value;
        return;
    }
    if (value !== el["$".concat(key)]) {
        el["$".concat(key)] = value;
        if (isSVG && key.startsWith("xlink:")) {
            if (value != null) el.setAttributeNS((0, $3ewO8.xlinkNS), key, value);
            else el.removeAttributeNS((0, $3ewO8.xlinkNS), key.slice(6, key.length));
        } else {
            var isBoolean = (0, $6zvdv.isSpecialBooleanAttr)(key);
            if (value == null || isBoolean && !(0, $6zvdv.includeBooleanAttr)(value)) el.removeAttribute(key);
            else el.setAttribute(key, isBoolean ? "" : (0, $6zvdv.isSymbol)(value) ? String(value) : value);
        }
    }
}
function setDOMProp(el, key, value) {
    var forceHydrate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, attrName = arguments.length > 4 ? arguments[4] : void 0;
    if (shouldSkipFallthroughKey(el, key)) return;
    if (isHydrating$1 && !isRecreatedNode(el)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && attributeHasMismatch(el, key, value);
        if (!forceHydrate && !shouldForceHydrate(el, key)) return;
    }
    var cacheKey = "$p$".concat(key);
    if (value === el[cacheKey] && cacheKey in el) return;
    el[cacheKey] = value;
    var needRemove = false;
    if (value === "" || value == null) {
        var type = (0, $7E0eS._)(el[key]);
        if (type === "boolean") value = (0, $6zvdv.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function setClass(el, value) {
    var isSVG = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isNormalized = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (el.$clsFlags !== void 0) el.$clsFlags = void 0;
    if (el.$root) setClassIncremental(el, value, isNormalized);
    else {
        if (!isNormalized) value = (0, $6zvdv.normalizeClass)(value);
        if (isHydrating$1 && !isRecreatedNode(el)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && classHasMismatch(el, value, false);
            el.$cls = value;
            return;
        }
        if (value !== el.$cls) {
            el.$cls = value;
            if (isTransitionEnabled) (0, $3ewO8.patchClass)(el, value, isSVG);
            else if (isSVG) el.setAttribute("class", value);
            else el.className = value;
        }
    }
}
function setClassName(el, flags, cls) {
    var prefix = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", suffix = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "";
    if (flags === el.$clsFlags) return;
    var value = prefix;
    if ((0, $6zvdv.isString)(cls)) {
        if (flags & 1) value += cls;
    } else for(var i = 0, bit = 1; i < cls.length; i++, bit <<= 1)if (flags & bit) value += cls[i];
    if (!prefix && value.charCodeAt(0) === 32) value = value.slice(1);
    if (suffix) value = value ? "".concat(value, " ").concat(suffix) : suffix;
    if (el.$root || isHydrating$1) setClass(el, value, false, true);
    else {
        el.$cls = value;
        if (isTransitionEnabled) (0, $3ewO8.patchClass)(el, value, false);
        else el.className = value;
    }
    el.$clsFlags = flags;
}
function setClassIncremental(el, value) {
    var isNormalized = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cacheKey = "$clsi".concat(isApplyingFallthroughProps ? "$" : "");
    var normalizedValue = isNormalized ? value : (0, $6zvdv.normalizeClass)(value);
    if (isHydrating$1 && !isRecreatedNode(el)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && classHasMismatch(el, normalizedValue, true);
        el[cacheKey] = normalizedValue;
        return;
    }
    var prev = el[cacheKey];
    if ((value = el[cacheKey] = normalizedValue) !== prev) {
        var _el_classList;
        var nextList = value.split(/\s+/);
        if (value) (_el_classList = el.classList).add.apply(_el_classList, (0, $aUGqu._)(nextList));
        if (prev) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = prev.split(/\s+/)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cls = _step.value;
                    if (!nextList.includes(cls)) el.classList.remove(cls);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }
}
function shouldDeferCheckStyleMismatch(el) {
    return hasCssVarsInOwnerChain((0, $fKAHx.currentInstance)) || hasCssVars(el.style);
}
function hasCssVarsInOwnerChain(instance) {
    while(instance){
        if (instance.getCssVars) return true;
        instance = instance.parent;
    }
    return false;
}
function hasCssVars(style) {
    for(var i = 0; i < style.length; i++)if (style.item(i).startsWith("--")) return true;
    return false;
}
function checkHydrationStyleMismatch(el, value, normalizedValue, isIncremental) {
    if (shouldDeferCheckStyleMismatch(el)) {
        var instance = (0, $fKAHx.currentInstance);
        (0, $fKAHx.queuePostFlushCb)(function() {
            styleHasMismatch(el, value, normalizedValue, isIncremental, instance);
        });
    } else styleHasMismatch(el, value, normalizedValue, isIncremental);
}
function setStyle(el, value) {
    if (el.$root) setStyleIncremental(el, value);
    else {
        var normalizedValue = (0, $6zvdv.normalizeStyle)(value);
        if (isHydrating$1 && !isRecreatedNode(el)) {
            if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) checkHydrationStyleMismatch(el, value, normalizedValue, false);
            el.$sty = normalizedValue;
            hydrateVShowDisplay(el, normalizedValue);
            return;
        }
        (0, $3ewO8.patchStyle)(el, el.$sty, el.$sty = normalizedValue);
    }
}
function setStyleIncremental(el, value) {
    var cacheKey = "$styi".concat(isApplyingFallthroughProps ? "$" : "");
    var normalizedValue = (0, $6zvdv.isString)(value) ? (0, $6zvdv.parseStringStyle)(value) : (0, $6zvdv.normalizeStyle)(value);
    if (isHydrating$1 && !isRecreatedNode(el)) {
        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) checkHydrationStyleMismatch(el, value, normalizedValue, true);
        el[cacheKey] = normalizedValue;
        hydrateVShowDisplay(el, normalizedValue);
        return;
    }
    (0, $3ewO8.patchStyle)(el, el[cacheKey], el[cacheKey] = normalizedValue);
}
function hydrateVShowDisplay(el, style) {
    if ((0, $3ewO8.vShowOriginalDisplay) in el) {
        var display = (0, $6zvdv.isString)(style) ? (0, $6zvdv.parseStringStyle)(style).display : style && style.display;
        if ((0, $6zvdv.isArray)(display)) display = display[display.length - 1];
        el[0, $3ewO8.vShowOriginalDisplay] = display == null ? "" : String(display);
    }
}
function setValue(el, value) {
    var forceHydrate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (shouldSkipFallthroughKey(el, "value")) return;
    el._value = value;
    if (isHydrating$1 && !isRecreatedNode(el)) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && attributeHasMismatch(el, "value", (0, $6zvdv.isString)(value) ? getClientText(el, value) : value);
        if (!forceHydrate && !shouldForceHydrate(el, "value")) return;
    }
    var oldValue = el.tagName === "OPTION" ? el.getAttribute("value") : el.value;
    var newValue = value == null ? "" : value;
    if (oldValue !== newValue) el.value = newValue;
    if (value == null) el.removeAttribute("value");
    else el.setAttribute("value", (0, $6zvdv.isSymbol)(newValue) ? String(newValue) : newValue);
}
/**
* Only called on text nodes!
* Compiler should also ensure value passed here is already converted by
* `toDisplayString`
*/ function setText(el, value) {
    if (isHydrating$1 && !isRecreatedNode(el) && !isRecreatedNode(el.parentNode)) {
        var clientText = getClientText(el.parentNode, value);
        if (el.nodeValue == clientText) {
            el.$txt = clientText;
            return;
        }
        var parent = el.parentElement;
        if (parent && !(0, $fKAHx.isMismatchAllowed)(parent, 0)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warnHydrationTextMismatch(el, value);
            (0, $fKAHx.logMismatchError)();
        }
    }
    if (el.$txt !== value) el.nodeValue = el.$txt = value;
}
/**
* Used by setDynamicProps and `textContent` bindings, so need to guard with
* `toDisplayString`
*/ function setElementText(el, value) {
    value = (0, $6zvdv.toDisplayString)(value);
    if (isHydrating$1 && !isRecreatedNode(el)) {
        var clientText = getClientText(el, value);
        if (el.textContent === clientText) {
            el.$txt = clientText;
            return;
        }
        if (!(0, $fKAHx.isMismatchAllowed)(el, 0)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && (0, $fKAHx.warn)("Hydration text content mismatch on", el, "\n  - rendered on server: ".concat(el.textContent, "\n  - expected on client: ").concat(clientText));
            (0, $fKAHx.logMismatchError)();
        }
    }
    if (el.$txt !== value) el.textContent = el.$txt = value;
}
function setHtml(el, value) {
    value = value == null ? "" : (0, $3ewO8.unsafeToTrustedHTML)(value);
    if (isHydrating$1 && !isRecreatedNode(el)) {
        el.$html = value;
        return;
    }
    if (el.$html !== value) el.innerHTML = el.$html = value;
}
function setDynamicProps(el, args, isSVG) {
    patchDynamicProps(el, args.length > 1 ? (0, $fKAHx.mergeProps).apply(void 0, (0, $aUGqu._)(args)) : args[0] || (0, $6zvdv.EMPTY_OBJ), isSVG);
}
function patchDynamicProps(el, props, isSVG) {
    var cacheKey = "$dprops".concat(isApplyingFallthroughProps ? "$" : "");
    var prevProps = el[cacheKey];
    var nextProps = Object.create(null);
    if (prevProps) {
        for(var key in prevProps)if (!(key in props)) setDynamicProp(el, key, null, isSVG);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(props)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key1 = _step.value;
            if ((0, $6zvdv.isReservedProp)(key1)) continue;
            var value = props[key1];
            nextProps[key1] = value;
            if (prevProps && key1 in prevProps && !(0, $6zvdv.isOn)(key1) && (value == null || (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) !== "object") && Object.is(prevProps[key1], value)) continue;
            setDynamicProp(el, key1, value, isSVG);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    el[cacheKey] = nextProps;
}
/**
* @internal
*/ function setDynamicProp(el, key, value) {
    var isSVG = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var forceHydrate = false;
    if (key === "class") setClass(el, value, isSVG);
    else if (key === "style") setStyle(el, value);
    else if ((0, $6zvdv.isOn)(key)) {
        if (shouldSkipFallthroughKey(el, key)) return;
        var _parseEventName = (0, $f9AOD._)((0, $3ewO8.parseEventName)(key), 2), event = _parseEventName[0], options = _parseEventName[1];
        onBinding(el, event, value, options);
    } else if ((forceHydrate = key[0] === ".") ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : (0, $3ewO8.shouldSetAsProp)(el, key, value, isSVG)) {
        if (key === "innerHTML") setHtml(el, value);
        else if (key === "textContent") setElementText(el, value);
        else if (key === "value" && (0, $6zvdv.canSetValueDirectly)(el.tagName)) setValue(el, value, forceHydrate);
        else setDOMProp(el, key, value, forceHydrate);
    } else if (el._isVueCE && ((0, $3ewO8.shouldSetAsPropForVueCE)(el, key) || el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $6zvdv.isString)(value)))) setDOMProp(el, (0, $6zvdv.camelize)(key), value, forceHydrate, key);
    else setAttr(el, key, value, isSVG);
    return value;
}
var isOptimized = false;
/**
* Optimize property lookup for cache properties on Element and Text nodes
*/ function optimizePropertyLookup() {
    if (isOptimized) return;
    isOptimized = true;
    var proto = Element.prototype;
    proto.$transition = void 0;
    proto.$key = void 0;
    proto.$evtclick = void 0;
    proto.$root = false;
    proto.$clsFlags = void 0;
    proto.$html = proto.$cls = proto.$sty = "";
    Text.prototype.$txt = void 0;
}
function classHasMismatch(el, expected, isIncremental) {
    var actual = el.getAttribute("class");
    var actualClassSet = (0, $fKAHx.toClassSet)(actual || "");
    var expectedClassSet = (0, $fKAHx.toClassSet)(expected);
    var hasMismatch = false;
    if (isIncremental) {
        if (expected) hasMismatch = Array.from(expectedClassSet).some(function(cls) {
            return !actualClassSet.has(cls);
        });
    } else hasMismatch = !(0, $fKAHx.isSetEqual)(actualClassSet, expectedClassSet);
    if (hasMismatch) {
        if ((0, $fKAHx.warnPropMismatch)(el, "class", 2, actual, expected)) {
            (0, $fKAHx.logMismatchError)();
            return true;
        }
    }
    return false;
}
function styleHasMismatch(el, value, normalizedValue, isIncremental) {
    var instance = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, $fKAHx.currentInstance);
    var actual = el.getAttribute("style");
    var actualStyleMap = (0, $fKAHx.toStyleMap)(actual || "");
    var expected = (0, $6zvdv.isString)(value) ? value : (0, $6zvdv.stringifyStyle)(normalizedValue);
    var expectedStyleMap = (0, $fKAHx.toStyleMap)(expected);
    if (el[0, $3ewO8.vShowHidden]) expectedStyleMap.set("display", "none");
    if (instance) resolveCssVars(instance, el, expectedStyleMap);
    var hasMismatch = false;
    if (isIncremental) {
        if (expected) hasMismatch = Array.from(expectedStyleMap.entries()).some(function(param) {
            var _param = (0, $f9AOD._)(param, 2), key = _param[0], val = _param[1];
            return actualStyleMap.get(key) !== val;
        });
    } else hasMismatch = !(0, $fKAHx.isMapEqual)(actualStyleMap, expectedStyleMap);
    if (hasMismatch) {
        if ((0, $fKAHx.warnPropMismatch)(el, "style", 3, actual, expected)) {
            (0, $fKAHx.logMismatchError)();
            return true;
        }
    }
    return false;
}
/**
* dev only
*/ function resolveCssVars(instance, block, expectedMap) {
    if (!instance.isMounted) return;
    var rootBlocks = normalizeBlock(instance);
    if (instance.getCssVars && normalizeBlock(block).every(function(b) {
        return rootBlocks.includes(b);
    })) {
        var cssVars = instance.getCssVars();
        for(var key in cssVars){
            var value = (0, $6zvdv.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set("--".concat((0, $6zvdv.getEscapedCssVarName)(key, false)), value);
        }
    }
    if (normalizeBlock(block).every(function(b) {
        return rootBlocks.includes(b);
    }) && instance.parent) resolveCssVars(instance.parent, instance.block, expectedMap);
}
function attributeHasMismatch(el, key, value) {
    if ((0, $fKAHx.isValidHtmlOrSvgAttribute)(el, key)) {
        var _getAttributeMismatch = (0, $fKAHx.getAttributeMismatch)(el, key, value), actual = _getAttributeMismatch.actual, expected = _getAttributeMismatch.expected;
        if (actual !== expected) {
            if ((0, $fKAHx.warnPropMismatch)(el, key, 4, actual, expected)) {
                (0, $fKAHx.logMismatchError)();
                return true;
            }
        }
    }
    return false;
}
function getClientText(el, value) {
    if (value[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) value = value.slice(1);
    return value;
}
function shouldForceHydrate(el, key) {
    var tagName = el.tagName;
    return (tagName === "INPUT" || tagName === "OPTION") && (key.endsWith("value") || key === "indeterminate") || tagName.includes("-");
}
//#endregion
//#region packages/runtime-vapor/src/asyncComponentState.ts
var isAsyncComponentEnabled = false;
function enableAsyncComponent() {
    isAsyncComponentEnabled = true;
}
//#endregion
//#region packages/runtime-vapor/src/slotBoundary.ts
function withSlotBoundary(boundary, fn) {
    return withRenderContext(deriveSlotBoundary(currentRenderContext, boundary), fn);
}
function trackSlotBoundaryDirtying(fragment, onInvalid) {
    var boundary = currentRenderContext.slotBoundary;
    if (!boundary) return;
    if (onInvalid) registerContentInvalid(boundary, onInvalid, fragment);
    var prevValid;
    (fragment.bu || (fragment.bu = [])).push(function() {
        prevValid = isValidSlot(fragment);
    });
    (fragment.u || (fragment.u = [])).push(function() {
        if (isValidSlot(fragment) !== prevValid) boundary.markDirty();
    });
}
function registerContentInvalid(boundary, onInvalid, fragment) {
    var callbacks = boundary.onContentInvalid || (boundary.onContentInvalid = []);
    callbacks.push(onInvalid);
    var unregister = function() {
        var index = callbacks.indexOf(onInvalid);
        if (index > -1) callbacks.splice(index, 1);
    };
    (fragment.bum || (fragment.bum = [])).push(unregister);
}
function hasSlotFallback(boundary) {
    while(boundary){
        if (boundary.getFallback()) return true;
        boundary = boundary.parent;
    }
    return false;
}
//#endregion
//#region packages/runtime-vapor/src/helpers/setKey.ts
function setBlockKey(block, key) {
    var frag = block;
    frag.$key = key;
    if (isInteropEnabled && frag.setKey) frag.setKey(key);
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/typeof.js
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/defineProperty.js
function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
//#endregion
//#region \0@oxc-project+runtime@0.146.0/helpers/esm/objectSpread2.js
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
//#endregion
//#region packages/runtime-vapor/src/slotFragment.ts
function renderSlotFallback(boundary, scope) {
    var _loop = function() {
        var current = boundary;
        var localFallback = current.getFallback();
        if (localFallback) {
            var selected = false;
            var onContentInvalid = [];
            var renderFallback = scopeIds ? function() {
                return renderWithSlotScopeIds(scopeIds, localFallback);
            } : localFallback;
            var content = current.run(function() {
                return withSlotBoundary(_objectSpread2(_objectSpread2({}, current), {}, {
                    getFallback: function() {
                        return void 0;
                    },
                    onContentInvalid: onContentInvalid,
                    markDirty: function(force) {
                        return current.markDirty(!!force || !selected && hasSlotFallback(current.parent));
                    }
                }), renderFallback);
            }, scope);
            if (isValidSlot(content)) {
                selected = true;
                return {
                    v: {
                        block: content,
                        onContentInvalid: onContentInvalid
                    }
                };
            }
            result = {
                block: content,
                onContentInvalid: onContentInvalid
            };
        }
        boundary = current.parent;
    };
    var result;
    var scopeIds = boundary && boundary.getScopeIds ? boundary.getScopeIds() : null;
    while(boundary){
        var _ret = _loop();
        if ((0, $7E0eS._)(_ret) === "object") return _ret.v;
    }
    return result;
}
function beforeExpose(state, block) {
    var bm = state.bm;
    if (bm) for(var i = 0; i < bm.length; i++)bm[i](block);
}
/**
* The winning exposed branch for a slot host: the committed fallback while one
* is active, the resolved content otherwise. Every host's `syncNodes` points
* its exposed nodes here.
*/ function resolveExposedSlotNodes(state) {
    return state.activeFallback || state.getContent();
}
function markSlotResolutionDirty(state) {
    var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (state.isDisposed()) return;
    if (state.isReconciling || state.isBusy()) {
        state.pendingRecheck = true;
        state.pendingRecheckForce = state.pendingRecheckForce || force;
        return;
    }
    recheckSlotResolution(state, force);
}
function invalidateExposedSlotContent(state) {
    var callbacks = state.activeFallback ? state.activeFallbackInvalidCallbacks : state.boundary.onContentInvalid;
    if (callbacks) for(var i = 0; i < callbacks.length; i++)callbacks[i]();
}
function clearSlotFallback(state) {
    var parentNode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : state.getParentNode();
    if (state.fallbackScope) {
        state.fallbackScope.stop();
        state.fallbackScope = void 0;
    }
    var fallback = state.activeFallback;
    if (fallback) {
        remove(fallback, state.fallbackInserted ? parentNode || void 0 : void 0);
        state.activeFallback = null;
        state.fallbackInserted = false;
    }
    state.activeFallbackInvalidCallbacks = void 0;
}
function leaveSlotFallback(state, hooks, afterLeave) {
    var fallback = state.activeFallback;
    if (!fallback || !applyTransitionLeaveHooks(fallback, hooks, afterLeave)) return false;
    clearSlotFallback(state);
    return true;
}
function renderFallbackInScope(state) {
    var scope = new (0, $ftLbb.EffectScope)(true);
    var renderedFallback;
    try {
        renderedFallback = renderSlotFallback(state.boundary, scope);
    } catch (err) {
        scope.stop();
        throw err;
    }
    if (!renderedFallback) {
        scope.stop();
        return;
    }
    return {
        block: renderedFallback.block,
        onContentInvalid: renderedFallback.onContentInvalid,
        scope: scope
    };
}
function insertActiveSlotFallback(state, moveType) {
    var fallback = state.activeFallback;
    if (isHydrating$1 || !fallback || !isValidSlot(fallback)) return;
    var parentNode = state.getParentNode();
    if (!parentNode) return;
    if (moveType === void 0) insert(fallback, parentNode, state.getAnchor());
    else move(fallback, parentNode, state.getAnchor(), moveType);
    state.fallbackInserted = true;
}
function commitSlotFallback(state, block, scope, onContentInvalid, detachContent) {
    state.activeFallback = block;
    state.activeFallbackInvalidCallbacks = onContentInvalid;
    state.fallbackScope = scope;
    state.fallbackInserted = isHydrating$1;
    if (isTransitionEnabled) {
        if (state.$transition) {
            if (!(0, $6zvdv.isArray)(block)) setBlockKey(block, "_fb");
            state.$transition = applyTransitionHooks(block, state.$transition, ownerFragment(state));
        }
    }
    if (detachContent && !isHydrating$1) {
        var parentNode = state.getParentNode();
        var contentInvalidCallbacks = state.boundary.onContentInvalid;
        if (contentInvalidCallbacks) for(var i = 0; i < contentInvalidCallbacks.length; i++)contentInvalidCallbacks[i]();
        if (parentNode) removeAttachedNodes$1(state.getContent(), parentNode, false);
    }
    beforeExpose(state, block);
    insertActiveSlotFallback(state);
}
function ownerFragment(state) {
    var frag = state;
    return frag.__vf ? frag : void 0;
}
function renderAndCommitSlotFallback(state, hadFallback) {
    var result = renderFallbackInScope(state);
    clearSlotFallback(state);
    if (result) commitSlotFallback(state, result.block, result.scope, result.onContentInvalid, !hadFallback);
}
function disposeSlotResolution(state, parentNode) {
    clearSlotFallback(state, parentNode || null);
    state.pendingRecheck = false;
    state.pendingRecheckForce = false;
    state.lastNodesValid = void 0;
}
function recheckSlotResolution(state) {
    var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (state.isReconciling) {
        state.pendingRecheck = true;
        state.pendingRecheckForce = state.pendingRecheckForce || force;
        return;
    }
    var nextForce = force || state.pendingRecheckForce;
    do {
        state.pendingRecheck = false;
        state.pendingRecheckForce = false;
        state.isReconciling = true;
        try {
            recheckSlotResolutionNow(state, nextForce);
        } finally{
            state.isReconciling = false;
        }
        if (!state.pendingRecheck) return;
        nextForce = state.pendingRecheckForce;
    }while (true);
}
function recheckSlotResolutionNow(state, force) {
    var _state$lastNodesValid;
    var fallback = state.activeFallback;
    var fallbackValid = fallback ? isValidSlot(fallback) : false;
    var contentValid = state.isContentValid();
    var exposedValid = fallback ? fallbackValid : contentValid;
    var prevNodesValid = (_state$lastNodesValid = state.lastNodesValid) !== null && _state$lastNodesValid !== void 0 ? _state$lastNodesValid : exposedValid;
    if (!force && contentValid && !fallback && prevNodesValid) {
        state.syncNodes();
        state.lastNodesValid = true;
        return;
    }
    if (contentValid) {
        var content = state.getContent();
        var hadFallback = !!fallback;
        clearSlotFallback(state);
        if (hadFallback) {
            beforeExpose(state, content);
            if (!isHydrating$1) {
                var parentNode = state.getParentNode();
                if (parentNode) insert(content, parentNode, state.getAnchor());
            }
        }
    } else if (fallback) {
        if (prevNodesValid) {
            if (!fallbackValid && hasSlotFallback(state.boundary.parent)) renderAndCommitSlotFallback(state, true);
            else if (force && fallbackValid) renderAndCommitSlotFallback(state, true);
        } else if (fallbackValid) insertActiveSlotFallback(state);
        else if (force) renderAndCommitSlotFallback(state, true);
    } else renderAndCommitSlotFallback(state, false);
    var nextFallback = state.activeFallback;
    var nextNodesValid = contentValid && !nextFallback ? true : nextFallback ? nextFallback === fallback ? fallbackValid : isValidSlot(nextFallback) : state.isContentValid();
    state.syncNodes();
    state.lastNodesValid = nextNodesValid;
    if (prevNodesValid !== nextNodesValid) state.notifyExposedValidityChange();
}
//#endregion
//#region packages/runtime-vapor/src/dom/hydrateFragment.ts
var SlotHydrationSession = /*#__PURE__*/ function() {
    "use strict";
    function SlotHydrationSession(claim, parent, pending) {
        (0, $173N4._)(this, SlotHydrationSession);
        this.claim = claim;
        this.parent = parent;
        this.pending = pending;
        this.deferred = null;
    }
    (0, $cFHGC._)(SlotHydrationSession, [
        {
            key: "endAnchor",
            get: /**
	* The boundary's SSR close marker while it owns its range, else the
	* inherited one. Derived on read: the content's first block may take the
	* range over mid-content (see `FragmentClaim`).
	*/ function get() {
                return this.ownEndAnchor || (this.parent ? this.parent.endAnchor : null);
            }
        },
        {
            key: "ownEndAnchor",
            get: /** The close marker of the range this boundary itself owns, if any. */ function get() {
                return locateFragmentEnd(this.claim.start);
            }
        },
        {
            /** Trim the range's unclaimed tail; a range the content took over has none. */ key: "exitBoundary",
            value: function exitBoundary() {
                var close = this.ownEndAnchor;
                if (close) trimHydrationBoundary(close);
            }
        },
        {
            /** Record a claim in the ledger; false = no pending window, act now. */ key: "defer",
            value: function defer(anchor) {
                if (!this.pending) return false;
                (this.deferred || (this.deferred = [])).push(anchor);
                return true;
            }
        },
        {
            /**
	* Settle ledger entries. `from > 0` (only ever passed for an invalid
	* inner segment) rolls back just that segment's tail of the ledger.
	*/ key: "settle",
            value: function settle(contentValid) {
                var from = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var deferred = this.deferred;
                if (!deferred) return;
                var batch = from ? deferred.splice(from) : deferred;
                if (!from) this.deferred = null;
                for(var i = 0; i < batch.length; i++)if (contentValid) batch[i].onContent();
                else batch[i].onFallback();
            }
        },
        {
            /**
	* Open a pending window. The returned `finish` is idempotent and applies
	* the settlement rules above; on invalid content it also rewinds the
	* cursor to `start` so fallback hydrates the range content walked over.
	*/ key: "beginSegment",
            value: function beginSegment(start) {
                var _this = this;
                var prevPending = this.pending;
                var watermark = this.deferred ? this.deferred.length : 0;
                this.pending = true;
                var active = true;
                return function(contentValid) {
                    if (!active) return;
                    active = false;
                    _this.settle(contentValid, !contentValid && prevPending ? watermark : 0);
                    _this.pending = prevPending;
                    if (!contentValid) setCurrentHydrationNode(start);
                };
            }
        },
        {
            /**
	* Unconditional variant for a child boundary that settled: the parent's
	* ledger settles as content even if the parent itself was not pending —
	* it may hold entries adopted from an earlier undecided child.
	*/ key: "settleAsContent",
            value: function settleAsContent() {
                this.settle(true);
                this.pending = false;
            }
        },
        {
            /** Boundary ended still undecided: its ledger becomes the parent's. */ key: "adoptInto",
            value: function adoptInto(parent) {
                if (this.deferred) {
                    var _instance;
                    (_instance = parent.deferred || (parent.deferred = [])).push.apply(_instance, (0, $aUGqu._)(this.deferred));
                    this.deferred = null;
                }
            }
        }
    ]);
    return SlotHydrationSession;
}();
var currentSlotHydrationSession = null;
function getCurrentSlotEndAnchor() {
    return currentSlotHydrationSession ? currentSlotHydrationSession.endAnchor : null;
}
/** Locate this boundary's SSR range and consume its opening marker. */ function enterSlotBoundaryRange(pending) {
    var claim = createFragmentClaim();
    locateHydrationNode(claim);
    return new SlotHydrationSession(claim, currentSlotHydrationSession, pending);
}
function withHydratingSlotBoundary(fn) {
    var session = enterSlotBoundaryRange(false);
    var prevSession = currentSlotHydrationSession;
    currentSlotHydrationSession = session;
    try {
        return fn();
    } finally{
        currentSlotHydrationSession = prevSession;
        session.exitBoundary();
    }
}
/**
* A boundary that starts undecided (forwarded interop slots): if `fn`
* completes without settling, the range stays unclaimed — the ledger is
* adopted by the parent boundary and the cursor rewinds. If it settles,
* the parent's own pending window settles as content along with it.
*/ function withPendingHydratingSlotBoundary(fn) {
    var parentSession = currentSlotHydrationSession;
    var contentStart = currentHydrationNode;
    var session = enterSlotBoundaryRange(true);
    currentSlotHydrationSession = session;
    var completed = false;
    try {
        var result = fn();
        completed = true;
        return result;
    } finally{
        currentSlotHydrationSession = parentSession;
        if (!completed) session.exitBoundary();
        else if (session.pending) {
            session.adoptInto(parentSession);
            setCurrentHydrationNode(contentStart);
        } else {
            session.exitBoundary();
            parentSession.settleAsContent();
        }
    }
}
function queuePendingSlotContentAnchor(anchor) {
    var session = currentSlotHydrationSession;
    return !!session && session.defer(anchor);
}
/**
* Builds the attach step of a deferred shared-fallback decision. Once the
* winning side is known, resolve the reference node, then either claim the
* candidate SSR range's end anchor (when this host won one) or insert the
* runtime anchor, and move the host's nodes into place. The claim itself
* stays host-specific: which anchor fields it publishes and whether the
* hydration cursor must advance differ per host.
*/ function createDeferredSlotAttach(contentStart, slotEnd, runtimeAnchor, candidate, claimCandidate, getNodes, onAttached) {
    return function() {
        var insertionAnchor = resolveDeferredInsertionAnchor(candidate, contentStart, slotEnd);
        var parent = insertionAnchor && insertionAnchor.parentNode;
        if (!parent) return;
        var anchor;
        if (candidate) anchor = claimCandidate(candidate);
        else {
            insertUntrackedAnchor(parent, insertionAnchor, runtimeAnchor);
            anchor = runtimeAnchor;
        }
        if (onAttached) onAttached(parent);
        move(getNodes(), parent, anchor);
    };
}
/**
* Claims the SSR fragment close marker directly preceding a receiver slot's
* end anchor. Slot content hydrating inside the receiver does not own that
* marker, but boundary cleanup can run before deferred anchors are inserted,
* so it must be marked as claimed up front.
*/ function claimPrecedingFragmentClose(slotEnd) {
    var previous = slotEnd && slotEnd.previousSibling;
    if (previous && isComment(previous, "]")) claimAnchor(previous);
}
/**
* The reference node a deferred slot anchor attaches before: the candidate
* range's end when one exists, otherwise the (still-attached) content start,
* otherwise the receiver slot's end anchor.
*/ function resolveDeferredInsertionAnchor(candidate, contentStart, slotEnd) {
    return candidate || (contentStart && contentStart.parentNode ? contentStart : slotEnd);
}
function startPendingSlotContent(start) {
    var session = currentSlotHydrationSession;
    if (!session) return function() {};
    return session.beginSegment(start);
}
/**
* Wraps startPendingSlotContent's one-shot protocol: the decision must be
* resolved exactly once, and an abandoned render (throw) must resolve it as
* content so the enclosing slot hydration session can continue. Inactive
* guards (`shouldDefer` false) are inert.
*/ var INERT_PENDING_SLOT_CONTENT = {
    finish: (0, $6zvdv.NOOP),
    settle: (0, $6zvdv.NOOP)
};
function startPendingSlotContentGuard(shouldDefer, start) {
    if (!shouldDefer) return INERT_PENDING_SLOT_CONTENT;
    var finish = startPendingSlotContent(start);
    var resolve = function(contentValid) {
        if (finish) {
            finish(contentValid);
            finish = null;
        }
    };
    return {
        finish: resolve,
        settle: function() {
            return resolve(true);
        }
    };
}
function resolvePendingSlotContent() {
    var session = currentSlotHydrationSession;
    if (session && session.pending) session.settleAsContent();
}
function isPendingSlotContent() {
    var session = currentSlotHydrationSession;
    return !!(session && session.pending);
}
/**
* Insert an anchor at a position resolved during the hydration pass. Untracked
* anchors hold no SSR logical position, so traversal steps over them and the
* insert can happen right away. `nextNode` may already have been trimmed by
* boundary cleanup, in which case the anchor is appended instead.
*/ function insertUntrackedAnchor(parentNode$1, nextNode, anchor) {
    parentNode$1.insertBefore(anchor, nextNode && /* @__PURE__ */ parentNode(nextNode) === parentNode$1 ? nextNode : null);
}
/**
* Whether `node` can serve as `frag`'s anchor. Beyond the SSR candidates
* (`<!---->` and a fragment close), dev builds also accept a runtime anchor
* this fragment kind already created: those carry the fragment's debug label
* as their comment data, where prod uses unlabeled text nodes.
*/ function isReusableAnchorCandidate(node, frag) {
    return !!node && (isComment(node, "") || isComment(node, "]") || false);
}
function reuseOrCreateAfterAnchor(node, resetNodes) {
    var parent = /* @__PURE__ */ parentNode(node);
    return isClaimedAnchor(node) && parent ? {
        kind: "create",
        parent: parent,
        next: node.nextSibling,
        resetNodes: resetNodes
    } : {
        kind: "reuse",
        node: node,
        resetNodes: resetNodes
    };
}
function prepareDeferredHydrationAnchor(frag, hasRender) {
    var isRevivingDeferredBranch = isInDeferredHydrationBoundary() && hasRender && !(frag.__vf & 4) && !isValidBlock(frag.nodes);
    var reusingDeferredAnchor = isRevivingDeferredBranch && !!frag.anchor && !!frag.anchor.parentNode;
    if (isRevivingDeferredBranch) {
        var slotEndAnchor = null;
        var anchor = frag.anchor || (currentHydrationNode === (slotEndAnchor = getCurrentSlotEndAnchor()) ? slotEndAnchor : null);
        if (anchor) setCurrentHydrationNode(claimAnchor(anchor));
    }
    return reusingDeferredAnchor;
}
/** Rule 1: the enclosing slot has not decided content vs fallback yet. */ function planPendingSlotDecision(frag, isEmpty) {
    if (isPendingSlotContent() && (isEmpty || !isValidBlock(frag.nodes))) {
        var slotEnd = getCurrentSlotEndAnchor();
        var node = currentHydrationNode || slotEnd;
        if (node) {
            var parent = /* @__PURE__ */ parentNode(node);
            if (parent) return {
                kind: "pending",
                parent: parent,
                slotEnd: slotEnd
            };
        }
    }
}
/** Rule 2: adopt the anchor createPlainElement injected for native children. */ function planReuseInjectedAnchor(frag) {
    if (frag.__vf & 512 && isClaimedAnchor(currentHydrationNode) && /* @__PURE__ */ parentNode(currentHydrationNode)) return {
        kind: "reuse",
        node: currentHydrationNode
    };
}
/** Rule 3: the fragment owns an SSR range; its close marker is the anchor. */ function planReuseOwnClose(frag) {
    var close = frag.__vf & 4 ? currentSlotHydrationSession && currentSlotHydrationSession.ownEndAnchor : frag.hydrationClaim && frag.hydrationClaim.start ? locateClaimedEnd(frag.hydrationClaim.start) : null;
    if (close) return reuseOrCreateAfterAnchor(close);
}
/** Rule 4: the client rendered nothing and owns no range. */ function planEmptyBranch(frag) {
    var flags = frag.__vf;
    if (isReusableAnchorCandidate(currentHydrationNode, frag)) return reuseOrCreateAfterAnchor(currentHydrationNode);
    if (!(flags & 512) && currentHydrationNode && isComment(currentHydrationNode, "teleport anchor")) {
        var parentNode$2 = /* @__PURE__ */ parentNode(currentHydrationNode);
        if (parentNode$2) return {
            kind: "create",
            parent: parentNode$2,
            next: currentHydrationNode,
            mark: currentHydrationNode
        };
    }
    if (!(flags & 4) && currentHydrationNode && !isComment(currentHydrationNode, "]")) {
        var parentNode$3 = /* @__PURE__ */ parentNode(currentHydrationNode);
        if (flags & 512 && parentNode$3) return {
            kind: "create-cleanup",
            parent: parentNode$3,
            next: null,
            cleanupStart: currentHydrationNode,
            cleanupUntil: null,
            cleanupContainer: parentNode$3
        };
        if (parentNode$3) {
            var anchor = nextLogicalSibling(currentHydrationNode);
            if (isReusableAnchorCandidate(anchor, frag) && /* @__PURE__ */ parentNode(anchor)) return reuseOrCreateAfterAnchor(anchor, true);
            return planTrimFromCursor(parentNode$3, anchor);
        }
    }
}
/** Trim the unclaimed SSR range at the cursor, then create a fresh anchor. */ function planTrimFromCursor(parent, next) {
    return {
        kind: "create-cleanup",
        parent: parent,
        next: next,
        cleanupStart: currentHydrationNode,
        cleanupUntil: next
    };
}
/** Rule 5: the block is a bare runtime comment from earlier in this pass. */ function planRestartFromRuntimeComment(frag) {
    if (isValidBlock(frag.nodes) || !(frag.nodes instanceof Comment)) return;
    if (isReusableAnchorCandidate(frag.nodes, frag) && /* @__PURE__ */ parentNode(frag.nodes)) return reuseOrCreateAfterAnchor(frag.nodes, true);
    if (!/* @__PURE__ */ parentNode(frag.nodes) && currentHydrationNode) {
        var parentNode$4 = /* @__PURE__ */ parentNode(currentHydrationNode);
        if (parentNode$4) return planTrimFromCursor(parentNode$4, nextLogicalSibling(currentHydrationNode));
    }
}
/** Rule 6: derive the anchor position from the hydrated block itself. */ function planFromBlockBoundary(frag) {
    var node = findBlockBoundary(frag.nodes);
    return {
        kind: "create",
        parent: node.parentNode,
        next: node.nextNode
    };
}
function resolveDynamicAnchor(frag, isEmpty) {
    return planPendingSlotDecision(frag, isEmpty) || planReuseInjectedAnchor(frag) || planReuseOwnClose(frag) || (isEmpty ? planEmptyBranch(frag) : void 0) || planRestartFromRuntimeComment(frag) || planFromBlockBoundary(frag);
}
function executeAnchorPlan(frag, plan) {
    var advanceAfterRestore = null;
    var exitHydrationBoundary;
    var createRuntimeAnchor = function() {
        var _frag$anchorLabel;
        return frag.anchor = claimUntrackedAnchor(/* @__PURE__ */ createTextNode());
    };
    try {
        switch(plan.kind){
            case "reuse":
                if (plan.resetNodes) frag.nodes = EMPTY_BLOCK;
                frag.anchor = claimAnchor(plan.node);
                if (currentHydrationNode === frag.anchor) advanceHydrationNode(frag.anchor);
                else {
                    exitHydrationBoundary = enterHydrationBoundary(frag.anchor);
                    advanceAfterRestore = frag.anchor;
                }
                break;
            case "pending":
                {
                    var slotEnd = plan.slotEnd;
                    queuePendingSlotContentAnchor({
                        onContent: function() {
                            var node = currentHydrationNode;
                            var nodeParent = node && /* @__PURE__ */ parentNode(node);
                            if (node && nodeParent === plan.parent && isReusableAnchorCandidate(node, frag)) {
                                if (isClaimedAnchor(node)) {
                                    var nextNode = node.nextSibling;
                                    advanceHydrationNode(node);
                                    nodeParent.insertBefore(createRuntimeAnchor(), nextNode);
                                } else {
                                    frag.anchor = claimAnchor(node);
                                    advanceHydrationNode(node);
                                }
                                return;
                            }
                            insertUntrackedAnchor(plan.parent, node && nodeParent === plan.parent ? node : slotEnd, createRuntimeAnchor());
                        },
                        onFallback: function() {
                            createRuntimeAnchor();
                        }
                    });
                    break;
                }
            case "create":
                if (plan.resetNodes) frag.nodes = EMPTY_BLOCK;
                if (plan.mark) claimAnchor(plan.mark);
                insertUntrackedAnchor(plan.parent, plan.next, createRuntimeAnchor());
                break;
            case "create-cleanup":
                {
                    frag.nodes = EMPTY_BLOCK;
                    var cleanupParent = /* @__PURE__ */ parentNode(plan.cleanupStart);
                    if (cleanupParent) updateLastLocatedLogicalChild(cleanupParent, plan.cleanupStart, plan.cleanupUntil, 1);
                    if (plan.cleanupUntil) exitHydrationBoundary = enterHydrationBoundary(plan.cleanupUntil);
                    else {
                        cleanupHydrationTail(plan.cleanupStart, plan.cleanupContainer);
                        setCurrentHydrationNode(null);
                    }
                    insertUntrackedAnchor(plan.parent, plan.next, createRuntimeAnchor());
                    break;
                }
        }
    } finally{
        exitHydrationBoundary && exitHydrationBoundary();
        if (advanceAfterRestore && currentHydrationNode === advanceAfterRestore) advanceHydrationNode(advanceAfterRestore);
    }
}
function hydrateDynamicFragmentAnchor(frag) {
    var isEmpty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    executeAnchorPlan(frag, resolveDynamicAnchor(frag, isEmpty));
}
function updateHydratingSlotContent(frag, render, key) {
    var contentStart = currentHydrationNode;
    var pending = startPendingSlotContentGuard(frag.sharedFallback || hasSlotFallback(frag.boundary), contentStart);
    try {
        frag.updateContent(render, key);
        var contentValid = isValidSlot(frag.getContent());
        pending.finish(contentValid);
        return {
            contentStart: contentStart,
            contentValid: contentValid
        };
    } finally{
        pending.settle();
    }
}
/** The hydrating half of `SlotFragment.updateSlot`: content, then anchor. */ function hydrateSlotFragmentContent(frag, render, hasLocalFallback, key, shouldForce) {
    if (frag.sharedFallback || frag.inheritFallback && !hasLocalFallback) {
        var claim = createFragmentClaim();
        locateHydrationNode(claim);
        var _updateHydratingSlotContent = updateHydratingSlotContent(frag, render, key), contentStart = _updateHydratingSlotContent.contentStart, contentValid = _updateHydratingSlotContent.contentValid;
        var end = locateFragmentEnd(claim.start);
        var exposedValid = contentValid;
        if (frag.sharedFallback) {
            recheckSlotResolution(frag, shouldForce || frag.pendingRecheckForce);
            exposedValid = isValidSlot(frag.nodes);
        } else {
            frag.syncNodes();
            frag.lastNodesValid = contentValid;
        }
        if (exposedValid) {
            if (end) {
                frag.anchor = claimAnchor(end);
                advanceHydrationNode(end);
            } else hydrateDynamicFragmentAnchor(frag, !isValidBlock(frag.nodes));
        } else if (frag.sharedFallback) {
            var _frag$anchorLabel2;
            var slotEnd = getCurrentSlotEndAnchor();
            var candidate = end && end !== slotEnd ? end : null;
            if (candidate) advanceHydrationNode(candidate);
            var anchor = claimUntrackedAnchor(/* @__PURE__ */ createTextNode());
            frag.anchor = anchor;
            claimPrecedingFragmentClose(slotEnd);
            var attachContent = createDeferredSlotAttach(contentStart, slotEnd, anchor, candidate, function(candidate) {
                return frag.anchor = claimAnchor(candidate);
            }, function() {
                return frag.nodes;
            });
            if (!queuePendingSlotContentAnchor({
                onContent: attachContent,
                onFallback: function() {}
            })) {
                if (candidate) claimAnchor(candidate);
                (0, $fKAHx.queuePostFlushCb)(attachContent);
            }
        } else {
            var _frag$anchorLabel3;
            var anchor1 = frag.anchor = claimUntrackedAnchor(/* @__PURE__ */ createTextNode());
            var slotEnd1 = getCurrentSlotEndAnchor();
            var parent = slotEnd1 && slotEnd1.parentNode;
            if (parent) {
                claimPrecedingFragmentClose(slotEnd1);
                (0, $fKAHx.queuePostFlushCb)(function() {
                    if (slotEnd1.parentNode === parent) parent.insertBefore(anchor1, slotEnd1);
                });
            }
        }
    } else withHydratingSlotBoundary(function() {
        updateHydratingSlotContent(frag, render, key);
        recheckSlotResolution(frag, shouldForce || frag.pendingRecheckForce);
        hydrateDynamicFragmentAnchor(frag, !isValidBlock(frag.nodes));
    });
}
//#endregion
//#region packages/runtime-vapor/src/componentSlots.ts
var rawSlotsOwnerMap = /* @__PURE__ */ new WeakMap();
var rawSlotWrappersCache = /* @__PURE__ */ new WeakMap();
function normalizeRawSlots(rawSlots) {
    if (!rawSlots) return rawSlots;
    var normalized = (0, $6zvdv.isFunction)(rawSlots) ? {
        default: rawSlots
    } : rawSlots;
    if (!rawSlotsOwnerMap.has(normalized)) rawSlotsOwnerMap.set(normalized, getScopeOwner());
    return normalized;
}
/**
* Freeze the slot set of a v-once component: dynamic sources resolve once,
* in `resolveSlot` precedence, into plain entries. The slot functions stay
* live; the child re-runs them on its own updates.
*/ function snapshotRawSlots(rawSlots) {
    var dynamicSources = rawSlots.$;
    if (!dynamicSources) return rawSlots;
    var snapshot = {};
    for(var key in rawSlots)if (key !== "$") snapshot[key] = rawSlots[key];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var source = _step.value;
            if ((0, $6zvdv.isFunction)(source)) {
                var slot = withSlotOwner(rawSlots, function() {
                    return source();
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if ((0, $6zvdv.isArray)(slot)) try {
                    for(var _iterator = slot[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step1.value;
                        snapshot[String(s.name)] = s.fn;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else if (slot) snapshot[String(slot.name)] = slot.fn;
            } else for(var key in source)snapshot[key] = source[key];
        };
        for(var _iterator = dynamicSources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = Object.getOwnPropertySymbols(rawSlots)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var symbol = _step1.value;
            snapshot[symbol] = rawSlots[symbol];
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    rawSlotsOwnerMap.set(snapshot, rawSlotsOwnerMap.get(rawSlots) || null);
    return snapshot;
}
function withSlotOwner(slots, fn) {
    var owner = rawSlotsOwnerMap.get(slots);
    if (owner === void 0) return fn();
    return withRenderContext(deriveSlotOwner(currentRenderContext, owner), fn);
}
function getOwnedSlot(slots, key, slot) {
    if (!rawSlotsOwnerMap.has(slots)) return slot;
    var wrappers = rawSlotWrappersCache.get(slots);
    if (!wrappers) rawSlotWrappersCache.set(slots, wrappers = /* @__PURE__ */ new Map());
    var cached = wrappers.get(key);
    if (cached && cached.slot === slot) return cached.wrapped;
    var wrapped = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return withSlotOwner(slots, function() {
            return slot.apply(void 0, (0, $aUGqu._)(args));
        });
    };
    wrapped._ = slot._;
    wrappers.set(key, {
        slot: slot,
        wrapped: wrapped
    });
    return wrapped;
}
var dynamicSlotsProxyHandlers = {
    get: getSlot,
    has: function(target, key) {
        return !!getSlot(target, key);
    },
    getOwnPropertyDescriptor: function(target, key) {
        var slot = getSlot(target, key);
        if (slot) return {
            configurable: true,
            enumerable: true,
            value: slot
        };
    },
    ownKeys: function(target) {
        var keys = new Set(Object.keys(target).filter(function(k) {
            return k !== "$";
        }));
        var dynamicSources = target.$;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (dynamicSources) try {
            var _loop = function() {
                var source = _step.value;
                if ((0, $6zvdv.isFunction)(source)) {
                    var slot = withSlotOwner(target, function() {
                        return resolveFunctionSource(source);
                    });
                    if (slot) {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if ((0, $6zvdv.isArray)(slot)) try {
                            for(var _iterator = slot[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                var s = _step1.value;
                                keys.add(String(s.name));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        else keys.add(String(slot.name));
                    }
                } else try {
                    for(var _iterator1 = Object.keys(source)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var key = _step2.value;
                        keys.add(key);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
            for(var _iterator = dynamicSources[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true)_loop();
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return (0, $aUGqu._)(keys);
    },
    set: (0, $6zvdv.NO),
    deleteProperty: (0, $6zvdv.NO)
};
function getSlot(target, key) {
    var slot = resolveSlot(target, key);
    if (slot) return getOwnedSlot(target, key, (0, $6zvdv.isFunction)(slot) ? slot : slot.fn);
}
function resolveSlot(target, key) {
    if (key === "$") return;
    var dynamicSources = target.$;
    if (dynamicSources) {
        var i = dynamicSources.length;
        var source;
        while(i--){
            source = dynamicSources[i];
            if ((0, $6zvdv.isFunction)(source)) {
                var slot = withSlotOwner(target, function() {
                    return resolveFunctionSource(source);
                });
                if (slot) {
                    if ((0, $6zvdv.isArray)(slot)) {
                        for(var j = slot.length - 1; j >= 0; j--)if (String(slot[j].name) === key) return slot[j];
                    } else if (String(slot.name) === key) return slot;
                }
            } else if ((0, $6zvdv.hasOwn)(source, key)) return source[key];
        }
    }
    if ((0, $6zvdv.hasOwn)(target, key)) return target[key];
}
/**
* Get the effective slot instance for accessing rawSlots and scopeId.
* Prefers the slot owner (if inside a slot), falls back to currentInstance.
*/ function getScopeOwner() {
    return currentRenderContext.slotOwner || (0, $fKAHx.currentInstance);
}
function createSlot() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "default", rawProps = arguments.length > 1 ? arguments[1] : void 0, fallback = arguments.length > 2 ? arguments[2] : void 0, flags = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var _insertionParent = insertionParent;
    var _insertionAnchor = insertionAnchor;
    if (!isHydrating$1) resetInsertionState();
    var hydrationCursor = null;
    var instance = getScopeOwner();
    var rawSlots = instance.rawSlots;
    var scopeId = !(flags & 1) && instance.type.__scopeId;
    var outerSlotScopeIds = currentRenderContext.slotScopeIds;
    var slotScopeIds = scopeId ? outerSlotScopeIds ? (0, $aUGqu._)(outerSlotScopeIds).concat([
        "".concat(scopeId, "-s")
    ]) : [
        "".concat(scopeId, "-s")
    ] : outerSlotScopeIds;
    var once = !!(flags & 2);
    var slotProps = rawProps ? new Proxy(once ? snapshotRawProps(rawProps) : rawProps, rawPropsProxyHandlers) : (0, $6zvdv.EMPTY_OBJ);
    var fragment;
    var isCustomElementSlot = false;
    var interopSlotsSource = isInteropEnabled && rawSlots[interopSlotsKey];
    if (interopSlotsSource) {
        if (isHydrating$1) hydrationCursor = enterHydrationCursor();
        fragment = withRenderContext(deriveSlotScopeIds(currentRenderContext, slotScopeIds), function() {
            return instance.appContext.vdom.slot(interopSlotsSource, name, slotProps, instance, {
                fallback: fallback,
                flags: flags,
                adoptAnchor: _insertionAnchor
            });
        });
    } else {
        if (once && fallback) {
            var originalFallback = fallback;
            fallback = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return withOnce(function() {
                    return originalFallback.apply(void 0, (0, $aUGqu._)(args));
                });
            };
        }
        if (isHydrating$1) hydrationCursor = captureHydrationCursor();
        var ce = instance.ce || isAsyncComponentEnabled && instance.parent && (0, $fKAHx.isAsyncWrapper)(instance.parent) && instance.parent.ce;
        isCustomElementSlot = !!(ce && ce._hasShadowRoot());
        var slotFragment = !isCustomElementSlot && shouldUseSlotFragment(rawSlots, name, fallback, flags) ? new SlotFragment(flags, _insertionAnchor) : void 0;
        var dynamicFragment;
        if (slotFragment) {
            slotFragment.ctx = deriveSlotScopeIds(slotFragment.ctx, slotScopeIds);
            fragment = slotFragment;
        } else {
            dynamicFragment = new DynamicFragment(132, void 0, false, false, void 0, _insertionAnchor);
            var ctx = dynamicFragment.ctx;
            dynamicFragment.ctx = deriveRenderContext(ctx, ctx.slotOwner, null, slotScopeIds, ctx.suspense);
            fragment = dynamicFragment;
        }
        var isDynamicName = (0, $6zvdv.isFunction)(name);
        var renderSlot = function() {
            if (isCustomElementSlot) {
                var el = /* @__PURE__ */ createElement("slot");
                if (slotScopeIds) setElementScopeIds(el, slotScopeIds);
                var setSlotProps = function() {
                    var slotName = (0, $6zvdv.isFunction)(name) ? name() : name;
                    setDynamicProps(el, [
                        slotProps,
                        slotName !== "default" ? {
                            name: slotName
                        } : {}
                    ]);
                };
                if (once) setSlotProps();
                else renderEffect(setSlotProps);
                if (fallback) {
                    var fallbackFn = fallback;
                    withRenderContext(dynamicFragment.ctx, function() {
                        var block = fallbackFn();
                        insert(block, el);
                        registerNestedVDOMCleanup(block);
                    });
                }
                fragment.nodes = el;
                return;
            }
            var slotName = (0, $6zvdv.isFunction)(name) ? name() : name;
            var resolvedSlot = resolveSlot(rawSlots, slotName);
            var slot = resolvedSlot ? getOwnedSlot(rawSlots, slotName, (0, $6zvdv.isFunction)(resolvedSlot) ? resolvedSlot : resolvedSlot.fn) : void 0;
            var render = slot ? getBoundSlot(slot) : void 0;
            var key = resolvedSlot && !(0, $6zvdv.isFunction)(resolvedSlot) && (0, $6zvdv.hasOwn)(resolvedSlot, "key") ? resolvedSlot.key : render || fallback;
            if (slotFragment) slotFragment.updateSlot(render, fallback, key);
            else if (isHydrating$1) withHydratingSlotBoundary(function() {
                return dynamicFragment.update(render || fallback, key);
            });
            else dynamicFragment.update(render || fallback, key);
        };
        var cachedSlot;
        var cachedBoundSlot;
        var getBoundSlot = function(slot) {
            if (slot !== cachedSlot) {
                cachedSlot = slot;
                cachedBoundSlot = function() {
                    return renderWithSlotScopeIds(slotScopeIds, function() {
                        return once ? withOnce(function() {
                            return slot(slotProps);
                        }) : slot(slotProps);
                    });
                };
            }
            return cachedBoundSlot;
        };
        if (!once && !isCustomElementSlot && (isDynamicName || rawSlots.$)) renderEffect(renderSlot);
        else renderSlot();
    }
    if (isHydrating$1 && isInteropEnabled && isInteropFragment(fragment)) fragment.hydrate();
    finishBlockCreation(fragment, fragment.anchor, hydrationCursor, _insertionParent, _insertionAnchor, isCustomElementSlot);
    return fragment;
}
function shouldUseSlotFragment(rawSlots, name, fallback, flags) {
    if (currentRenderContext.slotBoundary && (0, $6zvdv.isForwardedSlot)(flags)) return true;
    if (!fallback) return false;
    if (rawSlots === (0, $6zvdv.EMPTY_OBJ)) return false;
    if ((0, $6zvdv.isFunction)(name) || rawSlots.$) return true;
    var slot = resolveSlot(rawSlots, name);
    if (!slot) return false;
    return ((0, $6zvdv.isFunction)(slot) ? slot : slot.fn)._ === 1;
}
//#endregion
//#region packages/runtime-vapor/src/scopeId.ts
/**
* Catch-up for slot content DOM created outside the ambient window (eager
* template clones, hand-built elements). Shallow on purpose: element subtrees
* can contain mounted component internals, so descendants are left to the
* creation-time ambient. Interop fragments derive their ids through the vdom
* patch context and are skipped.
*/ function stampSlotContent(block, scopeIds) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (block instanceof Element) {
        for(var i = 0; i < scopeIds.length; i++)if (!block.hasAttribute(scopeIds[i])) block.setAttribute(scopeIds[i], "");
    } else if ((0, $6zvdv.isArray)(block)) try {
        for(var _iterator = block[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var b = _step.value;
            stampSlotContent(b, scopeIds);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (isFragment(block) && !(isInteropEnabled && isInteropFragment(block))) stampSlotContent(block.nodes, scopeIds);
}
function renderWithSlotScopeIds(scopeIds, render) {
    var block = withRenderContext(deriveSlotScopeIds(currentRenderContext, scopeIds), render);
    if (scopeIds && !isHydrating$1) stampSlotContent(block, scopeIds);
    return block;
}
function getCurrentScopeId() {
    var scopeOwner = getScopeOwner();
    return scopeOwner ? scopeOwner.type.__scopeId : void 0;
}
function registerScopeIdOwner(instance, frag) {
    var owners = frag.scopeIdOwners || (frag.scopeIdOwners = []);
    if (!owners.includes(instance)) owners.push(instance);
}
function resolveScopeIdRoot(instance, onComponent) {
    return getRootElement(instance.block, {
        onDynamicFragment: function(frag) {
            return registerScopeIdOwner(instance, frag);
        },
        onComponent: onComponent,
        excludeSlotOutlets: true
    });
}
function applyScopeIdOwners(owners) {
    for(var i = 0; i < owners.length; i++)applyRootScopeIds(owners[i]);
}
var publishInteropScopeIds = null;
function setPublishInteropScopeIds(fn) {
    publishInteropScopeIds = fn;
}
function pushOwnRootScopeIds(instance, ids) {
    var _instance;
    var scopeId = instance.scopeId, slotScopeIds = instance.slotScopeIds;
    if (scopeId) (ids || (ids = [])).push(scopeId);
    if (slotScopeIds) (_instance = ids || (ids = [])).push.apply(_instance, (0, $aUGqu._)(slotScopeIds));
    return ids;
}
function hasOwnRootScopeIds(instance) {
    return !!(instance.parent && (instance.scopeId || instance.slotScopeIds));
}
/**
* The instance's root-only ids, climbing the effective-root chain so the
* innermost owner's collection carries every ancestor's contribution.
* Assigned parent blocks ground the climb: a null parent block means an
* in-setup mount, where the mounting component is never the root.
*/ function collectRootScopeIds(instance) {
    var ids = pushOwnRootScopeIds(instance, null);
    var current = instance;
    while(current.parent && isVaporComponent(current.parent) && isRootChainChild(current.parent, current)){
        current = current.parent;
        ids = pushOwnRootScopeIds(current, ids);
    }
    return ids;
}
function isRootChainChild(parent, child) {
    return parent.block === child || !!parent.block && getRootChainComponent(parent.block) === child;
}
/**
* Resolves the effective root, registers owners along the chain, and applies
* the instance's root-only ids: element roots are stamped, vnode-backed roots
* are published for core to apply at its own mount. When the chain crosses a
* nested component with its own root ids, the outer owner delegates — the
* innermost owner's collect climbs every ancestor, so one pre-insert
* application preserves both custom element connectedCallback timing and
* VDOM's innermost-first attribute order.
*/ function applyRootScopeIds(instance) {
    var delegated = false;
    var root = resolveScopeIdRoot(instance, function(nested) {
        if (hasOwnRootScopeIds(nested)) delegated = true;
    });
    if (delegated) return;
    var scopeIds = collectRootScopeIds(instance);
    if (!scopeIds) return;
    if (root) setElementScopeIds(root, scopeIds);
    if (isInteropEnabled && publishInteropScopeIds) publishInteropScopeIds(instance.block, scopeIds);
}
function applyComponentScopeIds(instance) {
    if (!hasOwnRootScopeIds(instance)) return;
    applyRootScopeIds(instance);
}
/**
* Hydration counterpart of applyComponentScopeIds: hydrated roots already
* carry SSR scope attrs, so the walk only registers dynamic root tracking,
* publishes interop carriers, and stamps mismatch-recreated roots
* (client-built DOM without SSR attrs).
*/ function hydrateComponentScopeIds(instance) {
    if (!hasOwnRootScopeIds(instance)) return;
    var root = resolveScopeIdRoot(instance);
    var stampRoot = root && isRecreatedNode(root) ? root : void 0;
    var publish = isInteropEnabled && publishInteropScopeIds;
    if (!stampRoot && !publish) return;
    var scopeIds = collectRootScopeIds(instance);
    if (!scopeIds) return;
    if (stampRoot) setElementScopeIds(stampRoot, scopeIds);
    if (publish) publish(instance.block, scopeIds);
}
//#endregion
//#region packages/runtime-vapor/src/keepAlive.ts
var isKeepAliveEnabled = false;
var currentCacheKey;
function enableKeepAlive() {
    isKeepAliveEnabled = true;
}
function withKeepAliveEnabled(value) {
    enableKeepAlive();
    return value;
}
function getKeepAliveContext(instance) {
    var owner = instance;
    while(isAsyncComponentEnabled && owner && owner.vapor && (0, $fKAHx.isAsyncWrapper)(owner))owner = owner.parent;
    return owner && owner.vapor && (0, $fKAHx.isKeepAlive)(owner) ? owner.ctx : null;
}
function withCurrentCacheKey(key, fn) {
    if (key === void 0) return fn();
    var prev = currentCacheKey;
    currentCacheKey = key;
    try {
        return fn();
    } finally{
        currentCacheKey = prev;
    }
}
//#endregion
//#region packages/runtime-vapor/src/fragment.ts
var VaporFragment = function VaporFragment(nodes) {
    "use strict";
    var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    (0, $173N4._)(this, VaporFragment);
    this.nodes = nodes;
    this.__vf = flags;
};
var RenderContextFragment = /*#__PURE__*/ function(VaporFragment) {
    "use strict";
    (0, $hdIku._)(RenderContextFragment, VaporFragment);
    function RenderContextFragment(nodes) {
        var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        (0, $173N4._)(this, RenderContextFragment);
        var _this;
        _this = (0, $7qXGD._)(this, RenderContextFragment, [
            nodes,
            flags
        ]);
        _this.renderInstance = (0, $fKAHx.currentInstance);
        _this.ctx = currentRenderContext;
        if (isKeepAliveEnabled) _this.keepAliveCtx = getKeepAliveContext((0, $fKAHx.currentInstance));
        return _this;
    }
    (0, $cFHGC._)(RenderContextFragment, [
        {
            key: "slotBoundary",
            get: function get() {
                return this.ctx.slotBoundary;
            }
        },
        {
            key: "slotScopeIds",
            get: function get() {
                return this.ctx.slotScopeIds;
            }
        },
        {
            key: "runWithRenderCtx",
            value: function runWithRenderCtx1(fn, scope) {
                return runWithRenderCtx(this, fn, scope);
            }
        }
    ]);
    return RenderContextFragment;
}(VaporFragment);
function runWithRenderCtx(fragment, fn, scope) {
    if (scope === void 0 && (0, $fKAHx.currentInstance) === fragment.renderInstance) return withRenderContext(fragment.ctx, fn);
    var prevInstance = (0, $fKAHx.setCurrentInstance)(fragment.renderInstance, scope);
    try {
        return withRenderContext(fragment.ctx, fn);
    } finally{
        (0, $fKAHx.restoreCurrentInstance)(prevInstance);
    }
}
/**
* The one construction point for a slot host's boundary context, shared by
* SlotFragment and both vdom-interop slot hosts. `run` and `getScopeIds`
* always come from the host fragment's render seam; `parent`, `getFallback`
* and `markDirty` stay host-specific (ownership caps, fallback sources and
* dirty batching differ per host).
*/ function createSlotBoundary(fragment, parent, getFallback, markDirty, onContentInvalid) {
    return {
        parent: parent,
        getFallback: getFallback,
        run: function(fn, scope) {
            return runWithRenderCtx(fragment, fn, scope);
        },
        getScopeIds: function() {
            return fragment.slotScopeIds;
        },
        markDirty: markDirty,
        onContentInvalid: onContentInvalid
    };
}
var ForFragment = /*#__PURE__*/ function(VaporFragment) {
    "use strict";
    (0, $hdIku._)(ForFragment, VaporFragment);
    function ForFragment(nodes, trackSlotBoundary, onInvalid) {
        (0, $173N4._)(this, ForFragment);
        var _this;
        _this = (0, $7qXGD._)(this, ForFragment, [
            nodes,
            8
        ]);
        if (trackSlotBoundary) trackSlotBoundaryDirtying(_this, onInvalid);
        return _this;
    }
    (0, $cFHGC._)(ForFragment, [
        {
            key: "onReset",
            value: function onReset(fn) {
                (this.resetListeners || (this.resetListeners = [])).push(fn);
            }
        }
    ]);
    return ForFragment;
}(VaporFragment);
var ForBlock = /*#__PURE__*/ function(VaporFragment) {
    "use strict";
    (0, $hdIku._)(ForBlock, VaporFragment);
    function ForBlock(nodes, scope, item, key, index, renderKey) {
        (0, $173N4._)(this, ForBlock);
        var _this;
        _this = (0, $7qXGD._)(this, ForBlock, [
            nodes,
            16
        ]);
        _this.scope = scope;
        _this.itemRef = item;
        _this.keyRef = key;
        _this.indexRef = index;
        _this.key = renderKey;
        return _this;
    }
    return ForBlock;
}(VaporFragment);
var DynamicFragment = /*#__PURE__*/ function(RenderContextFragment) {
    "use strict";
    (0, $hdIku._)(DynamicFragment, RenderContextFragment);
    function DynamicFragment() {
        var flags = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, anchorLabel = arguments.length > 1 ? arguments[1] : void 0, keyed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, trackSlotBoundary = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, onInvalid = arguments.length > 4 ? arguments[4] : void 0, adoptAnchor = arguments.length > 5 ? arguments[5] : void 0;
        (0, $173N4._)(this, DynamicFragment);
        var _this;
        _this = (0, $7qXGD._)(this, DynamicFragment, [
            EMPTY_BLOCK,
            2 | flags
        ]);
        _this.everUpdated = false;
        if (keyed) _this.keyed = true;
        if (!isHydrating$1) _this.anchor = resolveFragmentAnchor(adoptAnchor, anchorLabel);
        if (trackSlotBoundary) trackSlotBoundaryDirtying(_this, onInvalid);
        return _this;
    }
    (0, $cFHGC._)(DynamicFragment, [
        {
            key: "autoHydrate",
            get: function get() {
                return true;
            }
        },
        {
            key: "update",
            value: function update(render) {
                var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : render, noScope = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, branchKey = arguments.length > 3 ? arguments[3] : void 0;
                var everUpdated = this.everUpdated;
                this.everUpdated = true;
                if (key === this.current) {
                    if (isHydrating$1 && this.autoHydrate) hydrateDynamicFragmentAnchor(this, true);
                    return;
                }
                var transition = isTransitionEnabled ? this.$transition : void 0;
                var prevKey = this.current;
                var wasMounted = prevKey !== void 0;
                this.current = key;
                var prevSub = (0, $ftLbb.setActiveSub)();
                var reusingDeferredAnchor = false;
                try {
                    var parent = !isHydrating$1 ? this.getBranchParent() : null;
                    var isUpdate = wasMounted || everUpdated && !!parent;
                    if (isUpdate) {
                        var bu = this.bu;
                        if (bu) for(var i = 0; i < bu.length; i++)bu[i]();
                    }
                    if (transition && deferBranchUpdateDuringLeave(this, render, key, noScope, branchKey)) return;
                    var removePrevious;
                    if (wasMounted) {
                        var scope = this.scope;
                        var previous = this.nodes;
                        var removeBranch = function() {
                            return remove(previous, parent || void 0);
                        };
                        var deferRemoval = false;
                        if (scope) {
                            if (this.keepAliveCtx) deferRemoval = this.keepAliveCtx.prepareBranchRemoval(this, scope, prevKey);
                            else scope.stop();
                        }
                        if (transition && removeBranchWithLeave(this, transition, parent, render, key, noScope, branchKey)) return;
                        if (deferRemoval) removePrevious = removeBranch;
                        else removeBranch();
                    }
                    reusingDeferredAnchor = isHydrating$1 ? prepareDeferredHydrationAnchor(this, !!render) : false;
                    this.renderBranch(render, transition, parent, key, noScope, isUpdate, removePrevious, branchKey);
                } finally{
                    (0, $ftLbb.setActiveSub)(prevSub);
                }
                if (isHydrating$1 && this.autoHydrate && !reusingDeferredAnchor) hydrateDynamicFragmentAnchor(this, render == null);
            }
        },
        {
            key: "getBranchParent",
            value: function getBranchParent() {
                return this.anchor.parentNode;
            }
        },
        {
            key: "renderBranch",
            value: function renderBranch(render, transition, parent, key, noScope, notifyUpdated, removePrevious, branchKey) {
                var _this = this;
                this.branchKey = this.keyed ? key : branchKey;
                if (render) {
                    var keepAliveCtx = isKeepAliveEnabled ? this.keepAliveCtx : null;
                    var useScope = !noScope || !!this.fallthrough;
                    if (keepAliveCtx) keepAliveCtx.runBranchRender(this, function() {
                        return _this.renderNodes(render, useScope, parent, transition);
                    }, useScope, removePrevious);
                    else {
                        this.scope = useScope ? new (0, $ftLbb.EffectScope)() : void 0;
                        this.renderNodes(render, useScope, parent, transition);
                    }
                    if (this.scopeIdOwners) applyScopeIdOwners(this.scopeIdOwners);
                    if (parent) {
                        insert(this.nodes, parent, this.anchor);
                        if (removePrevious && keepAliveCtx) keepAliveCtx.cacheBlock(this);
                    }
                } else {
                    this.scope = void 0;
                    this.nodes = EMPTY_BLOCK;
                    if (removePrevious) removePrevious();
                }
                var u = this.u;
                if (notifyUpdated && u) for(var i = 0; i < u.length; i++)u[i](this.nodes);
            }
        },
        {
            key: "renderNodes",
            value: function renderNodes(render, useScope, parent, transition) {
                var _this = this;
                try {
                    this.nodes = this.runWithRenderCtx(function() {
                        var nodes = (useScope ? _this.scope.run(render) : render()) || EMPTY_BLOCK;
                        if (parent && _this.fallthrough) _this.fallthrough(nodes);
                        var bm = _this.bm;
                        if (bm) for(var i = 0; i < bm.length; i++)bm[i](nodes);
                        return nodes;
                    });
                } finally{
                    if (isTransitionEnabled && transition) this.$transition = applyTransitionHooks(this.nodes, transition, this);
                }
            }
        }
    ]);
    return DynamicFragment;
}(RenderContextFragment);
var SlotFragment = /*#__PURE__*/ function(DynamicFragment) {
    "use strict";
    (0, $hdIku._)(SlotFragment, DynamicFragment);
    function SlotFragment() {
        var flags = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, adoptAnchor = arguments.length > 1 ? arguments[1] : void 0;
        (0, $173N4._)(this, SlotFragment);
        var _this;
        _this = (0, $7qXGD._)(this, SlotFragment, [
            1156,
            void 0,
            false,
            false,
            void 0,
            adoptAnchor
        ]);
        _this.disposed = false;
        _this.activeFallback = null;
        _this.fallbackInserted = false;
        _this.pendingRecheck = false;
        _this.pendingRecheckForce = false;
        _this.isReconciling = false;
        _this.content = EMPTY_BLOCK;
        _this.isUpdating = false;
        (0, $ftLbb.onScopeDispose)(function() {
            _this.disposed = true;
            if (_this.fallbackScope) _this.fallbackScope.stop();
        }, true);
        _this.sharedFallback = !!(flags & 8);
        _this.inheritFallback = (0, $6zvdv.slotInheritsFallback)(flags);
        _this.notifyParentBoundary = (0, $6zvdv.slotNotifiesBoundary)(flags);
        if (_this.sharedFallback) {
            if (_this.slotBoundary) registerContentInvalid(_this.slotBoundary, function() {
                invalidateExposedSlotContent(_this);
                var anchor = _this.anchor;
                var parent = anchor.parentNode;
                if (parent) {
                    removeAttachedNodes$1(_this.content, parent);
                    if (_this.activeFallback) removeAttachedNodes$1(_this.activeFallback, parent);
                    removeNode(anchor, parent);
                }
            }, _this);
        }
        return _this;
    }
    (0, $cFHGC._)(SlotFragment, [
        {
            key: "autoHydrate",
            get: function get() {
                return false;
            }
        },
        {
            key: "renderBranch",
            value: function renderBranch(render, transition, parent, key, noScope, notifyUpdated, removePrevious, branchKey) {
                (0, $dWsrg._)((0, $kg0zo._)(SlotFragment.prototype), "renderBranch", this).call(this, render, transition, parent, key, noScope, notifyUpdated, removePrevious, branchKey);
                if (!this.isUpdating) {
                    this.content = this.nodes;
                    recheckSlotResolution(this, false);
                }
            }
        },
        {
            key: "boundary",
            get: function get() {
                var _this = this;
                return this.ownBoundary || (this.ownBoundary = createSlotBoundary(this, this.inheritFallback ? this.slotBoundary : null, function() {
                    return _this.localFallback;
                }, function(force) {
                    return markSlotResolutionDirty(_this, force);
                }));
            }
        },
        {
            key: "insert",
            value: function insert1(parent, anchor, parentSuspense) {
                this.disposed = false;
                insert(this.nodes, parent, anchor, parentSuspense);
                if (this.activeFallback === this.nodes) this.fallbackInserted = true;
            }
        },
        {
            key: "move",
            value: function move1(parent, anchor, moveType, parentComponent, parentSuspense) {
                move(this.nodes, parent, anchor, moveType, parentComponent, parentSuspense);
                if (this.activeFallback === this.nodes) this.fallbackInserted = true;
            }
        },
        {
            key: "remove",
            value: function remove1(parent) {
                this.disposed = true;
                if (this.fallbackScope) this.fallbackScope.stop();
                var nodes = this.nodes;
                remove(nodes, parent);
                if (this.activeFallback === nodes) {
                    this.activeFallback = null;
                    this.fallbackInserted = false;
                }
                this.clearContentInvalid();
                disposeSlotResolution(this, parent);
            }
        },
        {
            key: "clearContentInvalid",
            value: function clearContentInvalid() {
                var callbacks = this.ownBoundary && this.ownBoundary.onContentInvalid;
                if (callbacks) callbacks.length = 0;
            }
        },
        {
            key: "getBranchParent",
            value: function getBranchParent() {
                return this.activeFallback ? null : (0, $dWsrg._)((0, $kg0zo._)(SlotFragment.prototype), "getBranchParent", this).call(this);
            }
        },
        {
            key: "updateContent",
            value: function updateContent(render, key) {
                if (key !== this.current) this.clearContentInvalid();
                this.nodes = this.content;
                this.update(render, key);
                this.content = this.nodes;
            }
        },
        {
            key: "updateSlot",
            value: function updateSlot(render, fallback) {
                var key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : render || fallback;
                var prevLocalFallback = this.localFallback;
                this.localFallback = fallback;
                var boundary = this.boundary;
                var contentCtx = this.contentCtx || (this.contentCtx = deriveSlotBoundary(this.ctx, boundary));
                var slotRender = render ? function() {
                    return withRenderContext(contentCtx, render);
                } : function() {
                    return EMPTY_BLOCK;
                };
                this.isUpdating = true;
                this.pendingRecheck = false;
                try {
                    var shouldForce = prevLocalFallback !== fallback;
                    if (isHydrating$1) hydrateSlotFragmentContent(this, slotRender, !!fallback, key, shouldForce);
                    else {
                        this.updateContent(slotRender, key);
                        recheckSlotResolution(this, shouldForce || this.pendingRecheckForce);
                    }
                } finally{
                    this.pendingRecheck = false;
                    this.pendingRecheckForce = false;
                    this.isUpdating = false;
                }
            }
        },
        {
            key: "getContent",
            value: function getContent() {
                return this.content;
            }
        },
        {
            key: "getParentNode",
            value: function getParentNode() {
                return this.anchor ? this.anchor.parentNode : null;
            }
        },
        {
            key: "getAnchor",
            value: function getAnchor() {
                return this.anchor || null;
            }
        },
        {
            key: "isBusy",
            value: function isBusy() {
                return this.isUpdating;
            }
        },
        {
            key: "isDisposed",
            value: function isDisposed() {
                return this.disposed;
            }
        },
        {
            key: "isContentValid",
            value: function isContentValid() {
                return isValidSlot(this.content);
            }
        },
        {
            key: "syncNodes",
            value: function syncNodes() {
                this.nodes = resolveExposedSlotNodes(this);
            }
        },
        {
            key: "notifyExposedValidityChange",
            value: function notifyExposedValidityChange() {
                if (this.notifyParentBoundary && this.slotBoundary) this.slotBoundary.markDirty();
            }
        }
    ]);
    return SlotFragment;
}(DynamicFragment);
/**
* Adopt the template `<!>` placeholder passed through the insertion state as
* the fragment anchor instead of creating (and later inserting) a runtime
* anchor. Restricted to comments: adopting any other node would remove user
* DOM on removeFragment. Callers detect adoption by identity: the returned
* node is the adopted anchor iff it equals the passed one.
*/ function resolveFragmentAnchor(adopt, anchorLabel) {
    if (adopt && adopt.nodeType === 8) return claimUntrackedAnchor(adopt);
    return claimUntrackedAnchor(/* @__PURE__ */ createTextNode());
}
/**
* Whether a fragment adopted the captured insertion anchor — the template
* `<!>` placeholder — as its own, which means it rendered in place and the
* creator must skip its trailing insert. Unrelated to hydration's
* `isClaimedAnchor` / `skipUntrackedAnchors`, which are about anchor nodes
* marked during a hydration pass.
*
* The insertion anchor must be checked non-null: append inserts capture no
* anchor, and fragments without a client anchor (vdom interop slots, any
* fragment during hydration) would otherwise compare undefined === undefined
* and falsely skip their only insertion.
*/ function isAdoptedPlaceholder(fragmentAnchor, insertionAnchor) {
    return !!insertionAnchor && fragmentAnchor === insertionAnchor;
}
/**
* Shared tail for every block-creating API (`createIf`, `createFor`,
* `createKeyedFragment`, `createDynamicComponent`, slot outlets): the block is
* built, now hand it over to the scope that asked for it.
*
* Client render: insert it at the captured insertion point, unless it adopted
* that point's `<!>` placeholder as its own anchor and therefore already
* rendered in place. Hydration: there is nothing to insert — the block adopted
* server nodes where they already stood — so hand back the cursor instead.
*
* Site-specific hydration work (claiming a leftover `<!---->`, advancing past
* an anchor, running an interop fragment's `hydrate()`) belongs *before* this
* call, guarded by `isHydrating`; keeping it out of here avoids allocating a
* callback on the client-render path, which never needs one.
*/ function finishBlockCreation(block, anchor, cursor, insertionParent, insertionAnchor, force) {
    if (isHydrating$1) exitHydrationCursor(cursor);
    else if (insertionParent && (force || !isAdoptedPlaceholder(anchor, insertionAnchor))) insert(block, insertionParent, insertionAnchor);
    if (insertionParent) registerNestedVDOMCleanup(block);
}
function isFragment(val) {
    return !!(val && val.__vf);
}
function isInteropFragment(val) {
    return !!(val && val.__vf & 64);
}
function isSlotOutletFragment(val) {
    return !!(val && val.__vf & 128);
}
function isDynamicFragment(val) {
    return !!(val && val.__vf & 2);
}
/**
* The key a fragment hands to its branch root as default: a declared key
* (static key on a dynamic component) or the current branch key (keyed
* fragment, dynamic component `:key`, v-if branch index).
*/ function getFragmentKey(frag) {
    var _frag$$key;
    return (_frag$$key = frag.$key) !== null && _frag$$key !== void 0 ? _frag$$key : frag.branchKey;
}
function isForFragment(val) {
    return !!(val && val.__vf & 8);
}
function isForBlock(val) {
    return !!(val && val.__vf & 16);
}
function isVaporSlotOutlet(val) {
    return !!(val && val.__vf & 4);
}
function isSlotResolver(val) {
    return !!(val && val.__vf & 1024);
}
//#endregion
//#region packages/runtime-vapor/src/teleport.ts
var isTeleportEnabled = false;
function enableTeleport(value) {
    isTeleportEnabled = true;
    return value;
}
function isVaporTeleport(value) {
    return !!(value && value.__isTeleport && value.__vapor);
}
function isTeleportFragment(value) {
    return !!(value && value.__vf & 32);
}
//#endregion
//#region packages/runtime-vapor/src/block.ts
var EMPTY_BLOCK = (0, $6zvdv.EMPTY_ARR);
function isBlock(val) {
    return val instanceof Node || (0, $6zvdv.isArray)(val) || isVaporComponent(val) || isFragment(val);
}
function isValidBlock(block) {
    var componentAsValid = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!block) return false;
    else if (block instanceof Node) return !(block instanceof Comment) && !isClaimedAnchor(block);
    else if (isVaporComponent(block)) return componentAsValid || isValidBlock(block.block, componentAsValid);
    else if ((0, $6zvdv.isArray)(block)) return block.length > 0 && block.some(function(block) {
        return isValidBlock(block, componentAsValid);
    });
    else {
        if (isInteropEnabled && block.isBlockValid) return block.isBlockValid(componentAsValid);
        return isValidBlock(block.nodes, componentAsValid);
    }
}
function isValidSlot(block) {
    return isValidBlock(block, true);
}
function insert(block, parent) {
    var anchor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, parentSuspense = arguments.length > 3 ? arguments[3] : void 0;
    if (block instanceof Node) {
        insertNode(block, parent, anchor, parentSuspense);
        return;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (isVaporComponent(block)) {
        if (block.isMounted && !block.isDeactivated) insert(block.block, parent, anchor, parentSuspense);
        else mountComponent(block, parent, anchor);
    } else if ((0, $6zvdv.isArray)(block)) try {
        for(var _iterator = block[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var b = _step.value;
            insert(b, parent, anchor, parentSuspense);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else insertFragment(block, parent, anchor, parentSuspense);
}
function insertNode(block, parent) {
    var anchor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, parentSuspense = arguments.length > 3 ? arguments[3] : void 0;
    if (!isHydrating$1) {
        var transition = isTransitionEnabled && block instanceof Element ? block.$transition : void 0;
        if (transition) {
            var insert = function() {
                return parent.insertBefore(block, anchor);
            };
            if (isVShowMountEnter(block, transition)) {
                transition.beforeEnter(block);
                insert();
                (0, $fKAHx.queuePostRenderEffect)(function() {
                    return transition.enter(block);
                }, void 0, parentSuspense);
            } else (0, $fKAHx.performTransitionEnter)(block, transition, insert, parentSuspense);
        } else if (block !== anchor) parent.insertBefore(block, anchor);
    }
}
function isVShowMountEnter(el, transition) {
    return transition.persisted && !!el.$vshow && !el[0, $3ewO8.vShowHidden];
}
function insertFragment(block, parent) {
    var anchor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, parentSuspense = arguments.length > 3 ? arguments[3] : void 0;
    var blockAnchor = block.anchor;
    if (blockAnchor) {
        insertNode(blockAnchor, parent, anchor, parentSuspense);
        anchor = blockAnchor;
    }
    if (block.insert) block.insert(parent, anchor, parentSuspense, block.$transition);
    else insert(block.nodes, parent, anchor, parentSuspense);
}
function move(block, parent) {
    var anchor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, moveType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, parentComponent = arguments.length > 4 ? arguments[4] : void 0, parentSuspense = arguments.length > 5 ? arguments[5] : void 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (block instanceof Node) {
        if (isTransitionEnabled && block instanceof Element && block.$transition && moveType !== 2) {
            if (moveType === 0) (0, $fKAHx.performTransitionEnter)(block, block.$transition, function() {
                return parent.insertBefore(block, anchor);
            }, parentSuspense, true);
            else (0, $fKAHx.performTransitionLeave)(block, block.$transition, function() {
                if (moveType === 1 && parentComponent && parentComponent.isUnmounted) block.remove();
                else parent.insertBefore(block, anchor);
            }, true, true);
        } else parent.insertBefore(block, anchor);
    } else if (isVaporComponent(block)) {
        if (block.isMounted) move(block.block, parent, anchor, moveType, parentComponent, parentSuspense);
        else mountComponent(block, parent, anchor);
    } else if ((0, $6zvdv.isArray)(block)) try {
        for(var _iterator = block[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var b = _step.value;
            move(b, parent, anchor, moveType, parentComponent, parentSuspense);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else {
        if (block.anchor) {
            move(block.anchor, parent, anchor, moveType, parentComponent, parentSuspense);
            anchor = block.anchor;
        }
        if (block.move) block.move(parent, anchor, moveType, parentComponent, parentSuspense, block.$transition);
        else move(block.nodes, parent, anchor, moveType, parentComponent, parentSuspense);
    }
}
function remove(block, parent) {
    if (block instanceof Node) removeNode(block, parent);
    else if (isVaporComponent(block)) unmountComponent(block, parent, isSuspenseEnabled && isInteropEnabled ? resolveUnmountSuspense(block.suspense) : block.suspense);
    else if ((0, $6zvdv.isArray)(block)) for(var i = 0; i < block.length; i++)remove(block[i], parent);
    else removeFragment(block, parent);
}
function removeAttachedNodes$1(block, parent) {
    var removeAnchors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (block instanceof Node) {
        if (block.parentNode === parent) removeNode(block, parent);
    } else if (isVaporComponent(block)) {
        if (block.block) removeAttachedNodes$1(block.block, parent, removeAnchors);
    } else if ((0, $6zvdv.isArray)(block)) for(var i = 0; i < block.length; i++)removeAttachedNodes$1(block[i], parent, removeAnchors);
    else {
        removeAttachedNodes$1(block.nodes, parent, removeAnchors);
        var anchor = block.anchor;
        if (removeAnchors && anchor && anchor.parentNode === parent) removeNode(anchor, parent);
    }
}
function removeNode(block, parent) {
    if (isTransitionEnabled && block.$transition && block instanceof Element) (0, $fKAHx.performTransitionLeave)(block, block.$transition, function() {
        return parent && block.parentNode === parent && parent.removeChild(block);
    });
    else parent && parent.removeChild(block);
}
function removeFragment(block, parent) {
    var bum = block.bum;
    if (bum) for(var i = 0; i < bum.length; i++)bum[i]();
    if (block.remove) block.remove(parent, block.$transition);
    else remove(block.nodes, parent);
    if (block.anchor) removeNode(block.anchor, parent);
    if (block.scope) block.scope.stop();
}
/**
* Block removal doesn't descend into elements, so it never reaches a block
* mounted into one. Unmount the vdom components in its tree synchronously when
* its owner scope is disposed, as vdom does for an element's children.
*/ function registerNestedVDOMCleanup(block) {
    if (isInteropEnabled && !(block instanceof Node)) (0, $ftLbb.onScopeDispose)(function() {
        return unmountVDOM(block);
    }, true);
}
/**
* Unmounts the vdom components in a block tree whose DOM goes away without
* block removal.
*/ function unmountVDOM(block) {
    if (!block || block instanceof Node) return;
    if (isVaporComponent(block)) unmountVDOM(block.block);
    else if ((0, $6zvdv.isArray)(block)) for(var i = 0; i < block.length; i++)unmountVDOM(block[i]);
    else if (isInteropFragment(block)) block.remove();
    else unmountVDOM(block.nodes);
}
/**
* dev / test only
*/ function normalizeBlock(block) {
    var child;
    throw new Error("normalizeBlock should not be used in production code paths");
}
/**
* First node of a block as it appears in its own container, or `undefined`
* when the block has no node there: an empty array of blocks, or a block
* whose content lives elsewhere (a teleport target) and has no marker left.
*/ function getBlockFirstNode(block) {
    if (block instanceof Node) return block;
    else if ((0, $6zvdv.isArray)(block)) {
        for(var i = 0; i < block.length; i++){
            var anchor = getBlockFirstNode(block[i]);
            if (anchor) return anchor;
        }
        return;
    } else if (isVaporComponent(block)) return getBlockFirstNode(getComponentPhysicalBlock(block));
    else {
        if (isTeleportEnabled && isTeleportFragment(block)) {
            var marker = block.placeholder || block.anchor;
            if (marker) return marker;
        }
        var nodes = block.nodes;
        if (isValidBlock(nodes)) return getBlockFirstNode(nodes);
        var node = getBlockFirstNode(nodes);
        var anchor1 = block.anchor;
        return node && (!anchor1 || node.parentNode === anchor1.parentNode) ? node : anchor1;
    }
}
function findBlockBoundary(block) {
    var boundaryBlock = isVaporComponent(block) ? getComponentPhysicalBlock(block) : block;
    var lastChild = findLastChild(boundaryBlock);
    var parentNode = lastChild.parentNode, nextNode = lastChild.nextSibling;
    if (nextNode && isComment(nextNode, "]") && isFragmentBlock(boundaryBlock) && !isComment(lastChild, "]") && !(lastChild.nodeType === 3 && !lastChild.data)) nextNode = nextNode.nextSibling;
    return {
        parentNode: parentNode,
        nextNode: nextNode
    };
}
function findLastChild(node) {
    if (node && node instanceof Node) return node;
    else if ((0, $6zvdv.isArray)(node)) return findLastChild(node[node.length - 1]);
    else if (isVaporComponent(node)) return findLastChild(getComponentPhysicalBlock(node));
    else {
        if (node.anchor) return node.anchor;
        return findLastChild(node.nodes);
    }
}
function getComponentPhysicalBlock(instance) {
    return isSuspenseEnabled && instance.pendingBlock || instance.block;
}
function isFragmentBlock(block) {
    if ((0, $6zvdv.isArray)(block)) return true;
    else if (isVaporComponent(block)) return isFragmentBlock(getComponentPhysicalBlock(block));
    else if (isFragment(block)) return isFragmentBlock(block.nodes);
    return false;
}
//#endregion
//#region packages/runtime-vapor/src/helpers/useCssVars.ts
/**
* Css vars are root-inherited state: the owner writes its root chain before
* insertion, containers on that chain write the content they produce later
* (`bm` hooks; `u` for vdom-owned interop content), and teleports are written
* directly as outlets since their content leaves the chain.
*/ function useVaporCssVars(getter) {
    var instance = (0, $fKAHx.currentInstance);
    var vars = (0, $6zvdv.EMPTY_OBJ);
    var apply = instance.applyCssVars = function(nodes) {
        if (!isHydrating$1) setVarsOnBlock(nodes, vars);
        registerCssVarApply(nodes, apply);
    };
    var watchVars = function() {
        return (0, $fKAHx.watch)(function() {
            vars = (0, $6zvdv.extend)({}, getter());
            if (instance.ce) (0, $3ewO8.setVarsOnNode)(instance.ce, vars);
            else setVarsOnBlock(instance.block, vars);
            var outlets = instance.cssVarOutlets;
            if (outlets) for(var i = 0; i < outlets.length; i++)setVarsOnBlock(outlets[i].nodes, vars);
        }, (0, $6zvdv.NOOP), {
            flush: "post"
        });
    };
    (0, $fKAHx.onBeforeMount)(function() {
        if (!instance.ce) registerCssVarApply(instance.block, apply);
    });
    if (isHydrating$1) (0, $fKAHx.onMounted)(watchVars);
    else (0, $fKAHx.onBeforeMount)(watchVars);
}
function setVarsOnBlock(block, vars) {
    if (block instanceof Node) (0, $3ewO8.setVarsOnNode)(block, vars);
    else if ((0, $6zvdv.isArray)(block)) for(var i = 0; i < block.length; i++)setVarsOnBlock(block[i], vars);
    else if (isVaporComponent(block)) setVarsOnBlock(block.block, vars);
    else if (isFragment(block) && !(isTeleportEnabled && isTeleportFragment(block))) setVarsOnBlock(block.nodes, vars);
}
function registerCssVarApply(block, apply) {
    if ((0, $6zvdv.isArray)(block)) for(var i = 0; i < block.length; i++)registerCssVarApply(block[i], apply);
    else if (isVaporComponent(block)) {
        if (block.block) registerCssVarApply(block.block, apply);
        else (block.bm || (block.bm = [])).push(function() {
            return apply(block.block);
        });
    } else if (isFragment(block) && !(isTeleportEnabled && isTeleportFragment(block))) {
        var hooks = isInteropEnabled && isInteropFragment(block) ? block.u || (block.u = []) : isDynamicFragment(block) || isForFragment(block) ? block.bm || (block.bm = []) : void 0;
        if (hooks && !hooks.includes(apply)) hooks.push(apply);
        registerCssVarApply(block.nodes, apply);
    }
}
function registerCssVarOutlet(owner, frag) {
    (owner.cssVarOutlets || (owner.cssVarOutlets = [])).push(frag);
    (0, $ftLbb.onScopeDispose)(function() {
        return (0, $6zvdv.remove)(owner.cssVarOutlets, frag);
    }, true);
}
function applyComponentCssVars(instance) {
    var current = instance;
    while(current && current.vapor){
        var owner = current;
        if (owner.applyCssVars && !owner.ce) owner.applyCssVars(owner.block);
        current = current.parent;
    }
}
//#endregion
//#region packages/runtime-vapor/src/hmr.ts
function hmrRerender(instance) {
    if (!instance.type.render) {
        var parent = instance.parent;
        if (parent && parent.vapor) return parent.hmrRerender();
        if (!parent && !instance.ce) return instance.hmrReload(instance.type);
    }
    var _findBlockBoundary = findBlockBoundary(instance.block), parentNode = _findBlockBoundary.parentNode, anchor = _findBlockBoundary.nextNode;
    var parent1 = parentNode;
    if (instance.renderScope) instance.renderScope.stop();
    remove(instance.block, parent1);
    var prev = (0, $fKAHx.setCurrentInstance)(instance);
    (0, $fKAHx.pushWarningContext)(instance);
    try {
        withRenderContext(deriveSlotScopeIds(currentRenderContext, null), function() {
            runDevRender(instance);
            applyComponentFallthrough(instance);
        });
    } finally{
        (0, $fKAHx.popWarningContext)();
        (0, $fKAHx.restoreCurrentInstance)(prev);
    }
    applyComponentScopeIds(instance);
    applyComponentCssVars(instance);
    insert(instance.block, parent1, anchor);
}
function hmrReload(instance, newComp) {
    var parentInstance = instance.parent;
    if (parentInstance) {
        parentInstance.hmrRerender();
        return;
    }
    var _findBlockBoundary = findBlockBoundary(instance.block), parentNode = _findBlockBoundary.parentNode, anchor = _findBlockBoundary.nextNode;
    var parent = parentNode;
    unmountComponent(instance, parent);
    var prev = (0, $fKAHx.setCurrentInstance)(parentInstance);
    var newInstance;
    try {
        newInstance = createComponent(newComp, instance.rawProps, instance.rawSlots, instance.isSingleRoot, void 0, instance.appContext);
    } finally{
        (0, $fKAHx.restoreCurrentInstance)(prev);
    }
    mountComponent(newInstance, parent, anchor);
    var app = instance.appContext.app;
    if (app && app._instance === instance) app._instance = newInstance;
}
//#endregion
//#region packages/runtime-vapor/src/component.ts
function useVdomInterop(component, appContext) {
    return !!appContext.vdom && !component.__vapor;
}
function resolveFallthroughOwner(isSingleRoot) {
    var instance = (0, $fKAHx.currentInstance);
    if ((isSingleRoot || isTransitionEnabled && instance && isVaporTransition(instance.type)) && isVaporComponent(instance) && instance.type.inheritAttrs !== false && instance.hasFallthrough) return instance;
}
function createComponent(component, rawProps, rawSlots, isSingleRoot, once) {
    var appContext = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $fKAHx.currentInstance) && (0, $fKAHx.currentInstance).appContext || emptyContext, managedMount = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, ce = arguments.length > 7 ? arguments[7] : void 0;
    var wasInOnce = inOnce;
    if (wasInOnce && !managedMount) once = true;
    var _insertionParent = insertionParent;
    var _insertionAnchor = insertionAnchor;
    var hydration = null;
    var pendingAsyncHydration = false;
    if (isHydrating$1) hydration = enterComponentHydration(component);
    else resetInsertionState();
    var prevCtx = currentRenderContext;
    try {
        if (isSuspenseEnabled && !prevCtx.suspense && (0, $fKAHx.currentInstance) && (0, $fKAHx.currentInstance).suspense) setRenderContext(deriveSuspense(prevCtx, (0, $fKAHx.currentInstance).suspense));
        var owner = resolveFallthroughOwner(isSingleRoot);
        if (owner) {
            var source = function() {
                return resolveFallthroughAttrs(owner);
            };
            if (rawProps && rawProps !== (0, $6zvdv.EMPTY_OBJ)) {
                var sources = rawProps.$;
                rawProps = (0, $6zvdv.extend)({}, rawProps, {
                    $: sources ? sources.concat(source) : [
                        source
                    ]
                });
            } else rawProps = {
                $: [
                    source
                ]
            };
        }
        var keepAliveCtx = null;
        if (isKeepAliveEnabled && (0, $fKAHx.currentInstance) && (0, $fKAHx.currentInstance).vapor && (0, $fKAHx.isKeepAlive)((0, $fKAHx.currentInstance))) {
            var ctx = (0, $fKAHx.currentInstance).ctx;
            keepAliveCtx = ctx;
            var cached = ctx.getCachedComponent(component);
            if (cached) {
                var scope = (0, $ftLbb.getCurrentScope)();
                if (isVaporComponent(cached) && cached.unmountScope !== scope) {
                    cached.unmountScope = scope;
                    registerUnmount(cached);
                }
                return cached;
            }
        }
        var asyncBoundary = false;
        if (isAsyncComponentEnabled && !isHydrating$1) {
            var resolved = component.__asyncResolved;
            if (resolved && !(isInteropEnabled && useVdomInterop(resolved, appContext))) {
                component = resolved;
                asyncBoundary = true;
            }
        }
        if (isTeleportEnabled && isVaporTeleport(component)) {
            var frag = component.process(rawProps, normalizeRawSlots(rawSlots), _insertionAnchor);
            if (_insertionParent) {
                (0, $ftLbb.onScopeDispose)(function() {
                    return frag.disposeTarget();
                }, true);
                registerNestedVDOMCleanup(frag);
            } else (0, $ftLbb.onScopeDispose)(function() {
                return frag.scheduleTargetDispose();
            }, true);
            if (!isHydrating$1) {
                if (_insertionParent) insert(frag, _insertionParent, _insertionAnchor, currentRenderContext.suspense);
            } else frag.hydrate();
            return frag;
        }
        var inputScope;
        if (keepAliveCtx && !once && (rawProps || rawSlots && rawSlots.$)) {
            var scope1 = new (0, $ftLbb.EffectScope)(true);
            var isolated = false;
            scope1.run(function() {
                if (rawProps) {
                    var next = keepAliveCtx.isolatePropSources(rawProps);
                    isolated = next !== rawProps;
                    rawProps = next;
                }
                if (rawSlots && rawSlots.$) {
                    var next1 = keepAliveCtx.isolateSlotSources(rawSlots);
                    isolated = isolated || next1 !== rawSlots;
                    rawSlots = next1;
                }
            });
            if (isolated) inputScope = scope1;
        }
        if (isInteropEnabled && useVdomInterop(component, appContext)) {
            var frag1 = appContext.vdom.mount(component, (0, $fKAHx.currentInstance), rawProps, normalizeRawSlots(rawSlots), once);
            if (inputScope) frag1.inputScope = inputScope;
            if (_insertionParent) registerNestedVDOMCleanup(frag1);
            if (!isHydrating$1) {
                if (_insertionParent) insert(frag1, _insertionParent, _insertionAnchor, currentRenderContext.suspense);
            } else frag1.hydrate();
            return frag1;
        }
        var instance = new VaporComponentInstance(component, rawProps, rawSlots, appContext, once, ce);
        if (inputScope) instance.inputScope = inputScope;
        if (asyncBoundary) (0, $fKAHx.markAsyncBoundary)(instance);
        if (isKeepAliveEnabled && !(isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(instance))) {
            keepAliveCtx || (keepAliveCtx = getKeepAliveContext((0, $fKAHx.currentInstance)));
            if (keepAliveCtx) keepAliveCtx.processShapeFlag(instance);
        }
        var outerCtx = currentRenderContext;
        setRenderContext(deriveRenderContext(outerCtx, null, outerCtx.slotBoundary, null, outerCtx.suspense));
        var hasWarningContext = false;
        var hasInitMeasure = false;
        if (isHydrating$1 && isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(instance) && component.__asyncHydrate) {
            var setup = function() {
                return setupComponent(instance, component);
            };
            component.__asyncHydrate(currentHydrationNode, instance, wasInOnce ? function() {
                return withOnce(setup, false);
            } : setup);
        } else {
            if (wasInOnce) withOnce(function() {
                return setupComponent(instance, component);
            }, false);
            else setupComponent(instance, component);
            if (isHydrating$1 && isSuspenseEnabled && instance.suspense && instance.asyncDep) {
                var pendingBlock = [];
                var claim = hydration.claim, cursor = hydration.cursor;
                var node = claim && claim.start || cursor.start;
                var hydrationNext = nextLogicalSibling(node);
                do {
                    pendingBlock.push(node);
                    node = node.nextSibling;
                }while (node !== hydrationNext);
                instance.pendingBlock = pendingBlock.length === 1 ? pendingBlock[0] : pendingBlock;
                advanceHydrationNode(pendingBlock[pendingBlock.length - 1]);
                pendingAsyncHydration = true;
            }
        }
        if (keepAliveCtx) instance.unmountScope = (0, $ftLbb.getCurrentScope)();
        registerUnmount(instance);
        if (_insertionParent) registerNestedVDOMCleanup(instance);
        if (!managedMount && (_insertionParent || isHydrating$1)) mountComponent(instance, _insertionParent, _insertionAnchor);
        return instance;
    } finally{
        setRenderContext(prevCtx);
        if (hydration) exitComponentHydration(hydration, !pendingAsyncHydration);
    }
}
/**
* Open a component's SSR range: locate its start and claim its markers.
* Shared by creation and by the deferred render of an async setup, which
* re-enters the range once setup has settled.
*/ function enterComponentHydration(component) {
    resolvePendingSlotContent();
    var claim = component.__multiRoot ? createFragmentClaim() : void 0;
    var cursor = enterHydrationCursor(claim, true);
    var close = claim && claim.start ? locateEndAnchor(claim.start) : null;
    if (close) claimAnchor(close);
    return {
        claim: claim,
        cursor: cursor,
        close: close
    };
}
/**
* Hand the cursor back; with `finalizeBoundary` the unclaimed tail of the
* range is trimmed first and the cursor moves past the close marker.
*/ function exitComponentHydration(param, finalizeBoundary) {
    var close = param.close, cursor = param.cursor;
    if (finalizeBoundary) {
        trimHydrationBoundary(close);
        if (close && currentHydrationNode === close) advanceHydrationNode(close);
    }
    exitHydrationCursor(cursor);
}
function setupComponent(instance, component) {
    var prevInstance = (0, $fKAHx.setCurrentInstance)(instance);
    var prevSub = (0, $ftLbb.setActiveSub)();
    var setupFn = (0, $6zvdv.isFunction)(component) ? component : component.setup;
    var setupResult = setupFn ? (0, $fKAHx.callWithErrorHandling)(setupFn, instance, 0, [
        instance.props,
        instance
    ]) || (0, $6zvdv.EMPTY_OBJ) : (0, $6zvdv.EMPTY_OBJ);
    var isAsyncSetup = (0, $6zvdv.isPromise)(setupResult);
    if ((isAsyncSetup || instance.sp) && !(isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(instance))) (0, $fKAHx.markAsyncBoundary)(instance);
    if (isAsyncSetup) {
        instance.asyncDep = setupResult;
        var _getComponentName;
    } else handleSetupResult(setupResult, component, instance);
    (0, $ftLbb.setActiveSub)(prevSub);
    (0, $fKAHx.restoreCurrentInstance)(prevInstance);
}
var isApplyingFallthroughProps = false;
function shouldUseFunctionalFallthrough(component) {
    return (0, $6zvdv.isFunction)(component) && !component.props && !(isTransitionEnabled && isVaporTransition(component));
}
/**
* The single source of truth for the attrs a component may fall through to
* its effective root — used both for the root element render effect and for
* forwarding into a root component's props. Functional components without
* declared props only pass class / style / event listeners; v-model
* listeners with a corresponding declared prop never fall through (the
* component handles the v-model itself — #1543, #1643, #1989). Never
* returns undefined so consumers can always diff away stale keys.
*/ function resolveFallthroughAttrs(instance) {
    var attrs = shouldUseFunctionalFallthrough(instance.type) ? (0, $fKAHx.getFunctionalFallthrough)(instance.attrs) || (0, $6zvdv.EMPTY_OBJ) : instance.attrs;
    var propsOptions = normalizePropsOptions(instance.type)[0];
    if (propsOptions) {
        for(var key in attrs)if ((0, $6zvdv.isModelListener)(key)) return (0, $fKAHx.filterModelListeners)(attrs, propsOptions);
    }
    return attrs;
}
function isDeclaredModelListener(instance, key) {
    if (!(0, $6zvdv.isModelListener)(key)) return false;
    var propsOptions = normalizePropsOptions(instance.type)[0];
    return !!propsOptions && key.slice(9) in propsOptions;
}
function applyFallthroughProps(el, attrs) {
    isApplyingFallthroughProps = true;
    try {
        patchDynamicProps(el, attrs);
    } finally{
        isApplyingFallthroughProps = false;
    }
}
/**
* dev only
*/ function createDevSetupStateProxy(setupState) {
    return new Proxy(setupState, {
        get: function(target, key, receiver) {
            if ((0, $6zvdv.isString)(key) && !key.startsWith("__v") && !(0, $6zvdv.hasOwn)((0, $ftLbb.toRaw)(setupState), key)) (0, $fKAHx.warn)("Property ".concat(JSON.stringify(key), " was accessed during render but is not defined on instance."));
            return Reflect.get(target, key, receiver);
        }
    });
}
function callRender(render, instance, setupState) {
    return (0, $fKAHx.callWithErrorHandling)(render, instance, 1, [
        setupState,
        instance.props,
        instance.emit,
        instance.attrs,
        instance.slots
    ]);
}
/**
* dev only
* Runs devRender with everything it creates owned by a fresh per-render
* scope, so HMR rerender can tear down one generation by stopping the
* scope - including components nested inside elements, which the block
* graph cannot reach.
*/ function runDevRender(instance) {
    instance.accessedAttrs = instance.props === instance.attrs;
    (instance.renderScope = new (0, $ftLbb.EffectScope)()).run(function() {
        return devRender(instance);
    });
}
/**
* dev only
*/ function devRender(instance) {
    var prev = (0, $fKAHx.setCurrentRenderingInstance)(instance);
    try {
        instance.block = (instance.type.render ? callRender(instance.type.render, instance, instance.setupState) : (0, $fKAHx.callWithErrorHandling)((0, $6zvdv.isFunction)(instance.type) ? instance.type : instance.type.setup, instance, 0, [
            instance.props,
            {
                slots: instance.slots,
                attrs: instance.attrs,
                emit: instance.emit,
                expose: instance.expose
            }
        ])) || [];
    } finally{
        (0, $fKAHx.setCurrentRenderingInstance)(prev);
    }
}
var emptyContext = {
    app: null,
    config: {},
    provides: /*@__PURE__*/ Object.create(null)
};
var VaporComponentInstance = /*#__PURE__*/ function() {
    "use strict";
    function VaporComponentInstance(comp, rawProps, rawSlots, appContext, once, ce) {
        (0, $173N4._)(this, VaporComponentInstance);
        this.effectCount = 0;
        this.vapor = true;
        this.uid = (0, $fKAHx.nextUid)();
        this.type = comp;
        this.parent = (0, $fKAHx.currentInstance);
        if (0, $fKAHx.currentInstance) {
            this.root = (0, $fKAHx.currentInstance).root;
            this.appContext = (0, $fKAHx.currentInstance).appContext;
            this.provides = (0, $fKAHx.currentInstance).provides;
            this.ids = (0, $fKAHx.currentInstance).ids;
        } else {
            this.root = this;
            this.appContext = appContext || emptyContext;
            this.provides = Object.create(this.appContext.provides);
            this.ids = [
                "",
                0,
                0
            ];
        }
        this.block = null;
        this.scope = new (0, $ftLbb.EffectScope)(true);
        this.emit = emit.bind(null, this);
        this.expose = (0, $fKAHx.expose).bind(null, this);
        this.refs = (0, $6zvdv.EMPTY_OBJ);
        this.emitted = this.exposed = this.exposeProxy = this.propsDefaults = null;
        this.suspense = null;
        this.suspenseId = 0;
        if (isSuspenseEnabled) {
            var suspense = this.suspense = currentRenderContext.suspense;
            this.suspenseId = suspense ? suspense.pendingId : 0;
        }
        this.asyncDep = null;
        this.asyncResolved = false;
        this.isMounted = this.isUnmounted = this.isUpdating = this.isDeactivated = false;
        this.rawProps = once && rawProps ? snapshotRawProps(rawProps) : rawProps || (0, $6zvdv.EMPTY_OBJ);
        this.hasFallthrough = !!ce || hasFallthroughAttrs(comp, this.rawProps);
        if (rawProps || comp.props) {
            var _getPropsProxyHandlers = (0, $f9AOD._)(getPropsProxyHandlers(comp), 2), propsHandlers = _getPropsProxyHandlers[0], attrsHandlers = _getPropsProxyHandlers[1];
            this.attrs = new Proxy(this, attrsHandlers);
            this.props = comp.props ? new Proxy(this, propsHandlers) : (0, $6zvdv.isFunction)(comp) ? this.attrs : (0, $6zvdv.EMPTY_OBJ);
        } else this.props = this.attrs = (0, $6zvdv.EMPTY_OBJ);
        var normalizedRawSlots = normalizeRawSlots(rawSlots);
        if (once && normalizedRawSlots) normalizedRawSlots = snapshotRawSlots(normalizedRawSlots);
        this.rawSlots = normalizedRawSlots || (0, $6zvdv.EMPTY_OBJ);
        this.slots = normalizedRawSlots ? new Proxy(normalizedRawSlots, dynamicSlotsProxyHandlers) : (0, $6zvdv.EMPTY_OBJ);
        this.scopeId = getCurrentScopeId();
        this.slotScopeIds = currentRenderContext.slotScopeIds;
        if (ce) ce(this);
        var target, key, receiver;
    }
    (0, $cFHGC._)(VaporComponentInstance, [
        {
            /**
	* Expose `getKeysFromRawProps` on the instance so it can be used in code
	* paths where it's needed, e.g. `useModel`
	*/ key: "rawKeys",
            value: function rawKeys() {
                var vnode = isInteropEnabled && this.interopVNode;
                return vnode ? Object.keys(vnode.props || (0, $6zvdv.EMPTY_OBJ)) : getKeysFromRawProps(this.rawProps);
            }
        }
    ]);
    return VaporComponentInstance;
}();
function isVaporComponent(value) {
    return value instanceof VaporComponentInstance;
}
/**
* Resolve an asset component by name before passing it to the fallback helper;
* a string passed directly to `createComponentWithFallback` is plain element
* fallback, not a component name.
*/ function createAssetComponent(name, rawProps, rawSlots, isSingleRoot, once, maybeSelfReference, ns, appContext) {
    return createComponentWithFallback((0, $fKAHx.resolveComponent)(name, maybeSelfReference), rawProps, rawSlots, isSingleRoot, once, ns, appContext);
}
/**
* Used when a component cannot be resolved at compile time
* and needs rely on runtime resolution - where it might fallback to a plain
* element if the resolution fails.
*/ function createComponentWithFallback(comp, rawProps, rawSlots, isSingleRoot, once, ns, appContext) {
    if (comp === (0, $fKAHx.NULL_DYNAMIC_COMPONENT)) {
        if (isHydrating$1 && currentHydrationNode) {
            if (isReusableNullComponentAnchor(currentHydrationNode)) {
                var node = currentHydrationNode;
                if (isComment(node, "")) advanceHydrationNode(node);
                return node;
            }
            var nextAnchor = nextLogicalSibling(currentHydrationNode);
            if (nextAnchor && isReusableNullComponentAnchor(nextAnchor)) return nextAnchor;
        }
        return /* @__PURE__ */ createTextNode("");
    }
    if (!(0, $6zvdv.isString)(comp)) return createComponent(comp, rawProps, rawSlots, isSingleRoot, once, appContext);
    return createPlainElement(comp, rawProps, rawSlots, isSingleRoot, once, ns);
}
function isReusableNullComponentAnchor(node) {
    return isComment(node, "") || false;
}
function createPlainElement(comp, rawProps, rawSlots, isSingleRoot, once, ns) {
    rawSlots = normalizeRawSlots(rawSlots);
    var _insertionParent = insertionParent;
    var _insertionAnchor = insertionAnchor;
    var hydrationCursor = null;
    if (isHydrating$1) {
        resolvePendingSlotContent();
        hydrationCursor = enterHydrationCursor();
    } else resetInsertionState();
    var defaultSlot = rawSlots && getSlot(rawSlots, "default");
    var hasDynamicSlots = !!rawSlots && !!rawSlots.$;
    var adoptHydrationChildren = !!defaultSlot;
    var hydrationTemplate = hasDynamicSlots && !defaultSlot ? "<".concat(comp, "><!></").concat(comp, ">") : "<".concat(comp, "/>");
    var el = isHydrating$1 ? adoptTemplate(currentHydrationNode, hydrationTemplate, adoptHydrationChildren, ns) : /* @__PURE__ */ createElement(comp, ns);
    el.$root = isSingleRoot;
    if (!isHydrating$1 || isRecreatedNode(el)) {
        var scopeId = getCurrentScopeId();
        if (scopeId) el.setAttribute(scopeId, "");
        var slotScopeIds = currentRenderContext.slotScopeIds;
        if (slotScopeIds) setElementScopeIds(el, slotScopeIds);
    }
    if (rawProps) {
        var isSVG = ns === 1;
        var setFn = function() {
            return patchDynamicProps(el, resolveDynamicProps(rawProps), isSVG);
        };
        if (once) setFn();
        else renderEffect(setFn);
    }
    if (rawSlots) {
        var nextNode = null;
        if (isHydrating$1) {
            nextNode = nextLogicalSibling(el);
            var child = el.firstChild;
            if (rawSlots.$ && !child) child = el.appendChild(claimAnchor(/* @__PURE__ */ createTextNode()));
            setCurrentHydrationNode(child);
        }
        if (rawSlots.$) {
            var frag = new DynamicFragment(512, void 0);
            if (isHydrating$1) locateHydrationNode();
            renderEffect(function() {
                return frag.update(getSlot(rawSlots, "default"));
            });
            if (!isHydrating$1) insert(frag, el);
            registerNestedVDOMCleanup(frag);
        } else {
            var slot = getSlot(rawSlots, "default");
            if (slot) {
                var block = slot();
                if (!isHydrating$1) insert(block, el);
                registerNestedVDOMCleanup(block);
            }
        }
        if (isHydrating$1) setCurrentHydrationNode(nextNode);
    }
    finishBlockCreation(el, void 0, hydrationCursor, _insertionParent, _insertionAnchor);
    return el;
}
function mountComponent(instance, parent, anchor) {
    if (isSuspenseEnabled && instance.suspense && instance.asyncDep && !instance.asyncResolved) {
        if (instance.asyncDepRegistered) {
            if (instance.pendingBlock) insert(instance.pendingBlock, parent, anchor);
            else if (instance.block) insert(instance.block, parent, anchor);
            if (isKeepAliveEnabled && instance.shapeFlag & 512) instance.isDeactivated = false;
            return;
        }
        var suspense = instance.suspense;
        var deferred = isKeepAliveEnabled && deferKeepAliveRenderEffects(instance);
        var hydrating = isHydrating$1;
        if (!hydrating) {
            instance.block = /* @__PURE__ */ createComment("");
            insert(instance.block, parent, anchor);
        }
        instance.asyncDepRegistered = true;
        var component = instance.type;
        var asyncSetupFinished = false;
        var finishAsyncSetup = function(setupResult) {
            if (asyncSetupFinished) return;
            asyncSetupFinished = true;
            instance.asyncResolved = true;
            var handleResult = function() {
                var prevInstance = (0, $fKAHx.setCurrentInstance)(instance);
                var prevSub = (0, $ftLbb.setActiveSub)();
                try {
                    handleSetupResult(setupResult, component, instance);
                } finally{
                    (0, $ftLbb.setActiveSub)(prevSub);
                    (0, $fKAHx.restoreCurrentInstance)(prevInstance);
                }
            };
            try {
                var pendingBlock = hydrating ? instance.pendingBlock : instance.block;
                var _findBlockBoundary = findBlockBoundary(pendingBlock), parentNode = _findBlockBoundary.parentNode, nextNode = _findBlockBoundary.nextNode;
                var renderAndMount = function() {
                    handleResult();
                    mountComponent(instance, parentNode, nextNode);
                };
                if (hydrating) hydrateNode(getBlockFirstNode(pendingBlock), function() {
                    var hydration = enterComponentHydration(component);
                    try {
                        withDeferredHydrationBoundary(renderAndMount);
                    } finally{
                        exitComponentHydration(hydration, true);
                    }
                });
                else {
                    renderAndMount();
                    remove(pendingBlock, parentNode);
                }
            } finally{
                if (hydrating) instance.pendingBlock = void 0;
            }
        };
        suspense.registerDep(instance, function(setupResult) {
            if (deferred) {
                if (deferred.pendingRoot === instance) deferred.pendingRoot = void 0;
                if (!deferred.flushQueued) {
                    deferred.flushQueued = true;
                    (0, $fKAHx.queuePostRenderEffect)(deferred.flushJob, void 0, deferred.suspense);
                }
            }
            finishAsyncSetup(setupResult);
        });
        if (deferred) {
            var state = deferred;
            instance.asyncDep.catch((0, $6zvdv.NOOP)).then(function(setupResult) {
                if (asyncSetupFinished) return;
                if (!instance.isUnmounted && !suspense.isUnmounted && !suspense.pendingBranch) finishAsyncSetup(setupResult);
                if (!state.flushQueued && state.pendingRoot === instance) settleDeferredKeepAliveUpdates(state);
            });
        }
        return;
    }
    if (isKeepAliveEnabled && instance.shapeFlag & 512 && instance.isMounted) {
        instance.parent.ctx.activate(instance, parent, anchor);
        return;
    }
    var root = instance.root, type = instance.type;
    if (root && root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
    if (instance.bm) (0, $6zvdv.invokeArrayFns)(instance.bm);
    if (!isHydrating$1) {
        applyComponentScopeIds(instance);
        insert(instance.block, parent, anchor, instance.suspense);
    } else hydrateComponentScopeIds(instance);
    if (instance.m) (0, $fKAHx.queuePostRenderEffect)(instance.m, void 0, instance.suspense);
    if (isKeepAliveEnabled && instance.shapeFlag & 256 && instance.a) (0, $fKAHx.queuePostRenderEffect)(instance.a, void 0, instance.suspense);
    instance.isMounted = true;
}
function registerUnmount(instance) {
    var scope = instance.unmountScope;
    (0, $ftLbb.onScopeDispose)(function() {
        if (scope && instance.unmountScope === scope) instance.unmountScope = void 0;
        unmountComponent(instance, void 0, isInteropEnabled ? resolveUnmountSuspense(instance.suspense) : instance.suspense);
    }, true);
}
function unmountComponent(instance, parentNode) {
    var parentSuspense = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : instance.suspense;
    if (isSuspenseEnabled && isInteropEnabled && currentUnmountSuspense !== parentSuspense) {
        runWithUnmountSuspense(parentSuspense, function() {
            return unmountComponent(instance, parentNode, parentSuspense);
        });
        return;
    }
    if (isKeepAliveEnabled && instance.shapeFlag & 256 && instance.parent && instance.parent.vapor && instance.parent.ctx) {
        if (parentNode) instance.parent.ctx.deactivate(instance, parentSuspense);
        return;
    }
    var pendingAsyncSetup = !!instance.asyncDep && !instance.asyncResolved;
    if (!instance.isUnmounted) {
        var hasLifecycle = instance.isMounted || pendingAsyncSetup;
        if (hasLifecycle) {
            (0, $fKAHx.invalidateMount)(instance.m);
            (0, $fKAHx.invalidateMount)(instance.a);
            if (instance.bum) (0, $6zvdv.invokeArrayFns)(instance.bum);
        }
        if (isKeepAliveEnabled) {
            var inputScope = instance.inputScope;
            if (inputScope) inputScope.stop();
        }
        instance.scope.stop();
        if (hasLifecycle && instance.um) (0, $fKAHx.queuePostRenderEffect)(instance.um, void 0, parentSuspense);
        instance.isUnmounted = true;
    }
    if (isSuspenseEnabled && pendingAsyncSetup) {
        if (instance.pendingBlock) {
            if (parentNode) {
                var pendingBlock = instance.pendingBlock;
                var _findBlockBoundary = findBlockBoundary(pendingBlock), blockParent = _findBlockBoundary.parentNode;
                if (blockParent) remove(pendingBlock, blockParent);
                instance.pendingBlock = void 0;
            }
        } else if (instance.block instanceof Comment) {
            var blockParent1 = instance.block.parentNode;
            if (blockParent1) remove(instance.block, blockParent1);
        }
    } else if (parentNode) {
        if (instance.block) remove(instance.block, parentNode);
    }
}
function getExposed(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $ftLbb.markRaw)(instance.exposed), {
        get: function(target, key) {
            return (0, $ftLbb.unref)(target[key]);
        },
        set: function(target, key, value, receiver) {
            var oldValue = target[key];
            if ((0, $ftLbb.isRef)(oldValue) && !(0, $ftLbb.isRef)(value)) {
                oldValue.value = value;
                return true;
            }
            return Reflect.set(target, key, value, receiver);
        }
    }));
}
function getRootElement(block, visitor) {
    if (block instanceof Element) return block;
    if (isVaporComponent(block)) {
        if (visitor) {
            if (visitor.onComponent && visitor.onComponent(block)) return;
            if (visitor.stopAtComponent) return;
        }
        return getRootElement(block.block, visitor);
    }
    if (isFragment(block) && !(isTeleportEnabled && isTeleportFragment(block))) {
        if (visitor) {
            if (visitor.excludeSlotOutlets && isSlotOutletFragment(block)) return;
            if (isDynamicFragment(block) && visitor.onDynamicFragment && visitor.onDynamicFragment(block)) return;
            if (isInteropEnabled && visitor.onInteropFragment && isInteropFragment(block) && visitor.onInteropFragment(block)) return;
        }
        return getRootElement(block.nodes, visitor);
    }
    if ((0, $6zvdv.isArray)(block)) {
        var single = singleRootOf(block);
        return single === void 0 ? void 0 : getRootElement(single, visitor);
    }
}
function singleRootOf(nodes) {
    var single;
    var hasComment = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var b = _step.value;
            if (b instanceof Comment) {
                hasComment = true;
                continue;
            }
            if (single !== void 0) return;
            single = b;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return hasComment ? single : void 0;
}
/**
* Descends the same effective-root rules as getRootElement but stops at the
* first component instead of resolving an element. Used to verify `child`
* sits on `parent`'s root chain when the chain passes through fragments
* (where `parent.block === child` cannot see the link).
*/ function getRootChainComponent(block) {
    while(true){
        if (isVaporComponent(block)) return block;
        if (isFragment(block) && !(isTeleportEnabled && isTeleportFragment(block))) {
            if (isSlotOutletFragment(block)) return;
            block = block.nodes;
            continue;
        }
        if ((0, $6zvdv.isArray)(block)) {
            var single = singleRootOf(block);
            if (single === void 0) return;
            block = single;
            continue;
        }
        return;
    }
}
function handleSetupResult(setupResult, component, instance) {
    if (isBlock(setupResult)) instance.block = setupResult;
    else if ((0, $6zvdv.isFunction)(setupResult) && instance.asyncDep) instance.block = (0, $fKAHx.callWithErrorHandling)(setupResult, instance, 1) || [];
    else if ((0, $6zvdv.isFunction)(component)) instance.block = [];
    else if (!component.render) instance.block = [];
    else {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.block = callRender(component.render, instance, setupResult) || [];
    }
    applyComponentFallthrough(instance);
}
function applyComponentFallthrough(instance) {
    if (instance.hasFallthrough && instance.type.inheritAttrs !== false) applyFallthroughAttrs(instance.block, instance, void 0);
}
function applyFallthroughAttrs(block, instance, scope) {
    var state = new FallthroughResolveState(scope);
    var root = resolveFallthroughRoot(block, state);
    var fragments = state.fragments, innermost = state.innermost, hasSlotOutlet = state.hasSlotOutlet;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (fragments) try {
        for(var _iterator = fragments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var frag = _step.value;
            registerDynamicFragmentFallthroughAttrs(frag, instance);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (root && !hasSlotOutlet) {
        var ownerScope = scope;
        if (innermost) ownerScope = innermost.scope || (innermost.scope = state.parentScope ? state.parentScope.run(function() {
            return new (0, $ftLbb.EffectScope)();
        }) : new (0, $ftLbb.EffectScope)());
        var applyEffect = function() {
            return renderEffect(function() {
                return applyFallthroughProps(root, resolveFallthroughAttrs(instance));
            });
        };
        ownerScope ? ownerScope.run(applyEffect) : applyEffect();
    }
}
var FallthroughResolveState = /*#__PURE__*/ function() {
    "use strict";
    function FallthroughResolveState(parentScope) {
        (0, $173N4._)(this, FallthroughResolveState);
        this.stopAtComponent = true;
        this.parentScope = parentScope;
    }
    (0, $cFHGC._)(FallthroughResolveState, [
        {
            key: "onDynamicFragment",
            value: function onDynamicFragment(frag) {
                if (frag.__vf & 4) {
                    this.hasSlotOutlet = true;
                    return true;
                }
                (this.fragments || (this.fragments = [])).push(frag);
                if (this.innermost && this.innermost.scope) this.parentScope = this.innermost.scope;
                this.innermost = frag;
            }
        }
    ]);
    return FallthroughResolveState;
}();
function resolveFallthroughRoot(block, state) {
    var root = getRootElement(block, state);
    var innermost = state.innermost;
    var child;
    return root;
}
function containsTeleportFragment(block) {
    if (isTeleportFragment(block)) return true;
    if ((0, $6zvdv.isArray)(block)) return block.some(function(child) {
        return !(child instanceof Comment) && containsTeleportFragment(child);
    });
    return isFragment(block) && containsTeleportFragment(block.nodes);
}
function registerDynamicFragmentFallthroughAttrs(frag, instance) {
    if (frag.fallthrough) return;
    frag.fallthrough = function(nodes) {
        return applyFallthroughAttrs(nodes, instance, frag.scope);
    };
}
/**
* A deferred state stays live while its async root is pending or its flush is
* queued for the same Suspense generation. The flush is requeued if that
* generation is discarded, so `flushQueued` cannot strand buffered updates.
*/ function isDeferredKeepAliveStateLive(state) {
    var suspense = state.suspense;
    if (suspense.isUnmounted || state.pendingId !== suspense.pendingId) return false;
    if (state.flushQueued) return true;
    var root = state.pendingRoot;
    return !!root && !root.isUnmounted;
}
function settleDeferredKeepAliveUpdates(state, currentJob) {
    var effects = state.effects, owners = state.owners;
    state.effects = [];
    state.owners = [];
    state.pendingRoot = void 0;
    for(var i = 0; i < owners.length; i++)if (owners[i].deferredKeepAliveUpdates === state) owners[i].deferredKeepAliveUpdates = void 0;
    if (currentJob && !effects.includes(currentJob)) effects.push(currentJob);
    if (effects.length > 1) effects.sort(function(a, b) {
        return a.order - b.order;
    });
    for(var i1 = 0; i1 < effects.length; i1++){
        var job = effects[i1];
        (0, $fKAHx.callWithErrorHandling)(job, job.i, job.i ? 15 : 14);
    }
}
function deferKeepAliveRenderEffects(instance) {
    var suspense = instance.suspense;
    var owners = [];
    var keepAlive;
    if (isHydrating$1) {
        var owner = instance.parent;
        if (owner && owner.vapor && (0, $fKAHx.isKeepAlive)(owner) && owner.suspense === suspense) {
            keepAlive = owner;
            owners.push(keepAlive);
        }
    } else {
        var child = instance;
        var owner1 = instance.parent;
        while(owner1 && owner1.vapor && owner1.suspense === suspense){
            var vaporOwner = owner1;
            var root = vaporOwner.block;
            while(isDynamicFragment(root) && !(root.__vf & 4))root = root.nodes;
            if (root !== child) return;
            owners.push(vaporOwner);
            if ((0, $fKAHx.isKeepAlive)(owner1)) keepAlive = vaporOwner;
            child = vaporOwner;
            owner1 = vaporOwner.parent;
        }
    }
    if (!keepAlive) return;
    var deferred = keepAlive.deferredKeepAliveUpdates;
    if (!deferred || deferred.suspense !== suspense || deferred.pendingId !== instance.suspenseId) {
        var flushJob = function() {
            state.flushQueued = false;
            if (keepAlive.deferredKeepAliveUpdates !== state || state.pendingRoot) return;
            settleDeferredKeepAliveUpdates(state);
        };
        flushJob.flags = 8;
        var state = {
            effects: [],
            owners: [],
            suspense: suspense,
            pendingId: instance.suspenseId,
            pendingRoot: instance,
            flushQueued: false,
            flushJob: flushJob
        };
        deferred = state;
    } else deferred.pendingRoot = instance;
    for(var i = 0; i < owners.length; i++){
        var owner2 = owners[i];
        if (owner2.deferredKeepAliveUpdates !== deferred) {
            owner2.deferredKeepAliveUpdates = deferred;
            deferred.owners.push(owner2);
        }
    }
    return deferred;
}
//#endregion
//#region packages/runtime-vapor/src/apiCreateApp.ts
var _createApp;
var rootInstances = /* @__PURE__ */ new WeakMap();
var mountApp = function(app, container) {
    optimizePropertyLookup();
    if (container.nodeType === 1) container.textContent = "";
    var instance = app._ceComponent || createComponent(app._component, app._props, null, false, false, app._context);
    mountComponent(instance, container);
    (0, $fKAHx.flushOnAppMount)();
    rootInstances.set(app, instance);
    return instance;
};
var _hydrateApp;
var hydrateApp = function(app, container) {
    if (!container.hasChildNodes()) {
        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && (0, $fKAHx.warn)("Attempting to hydrate existing markup but container is empty. Performing full mount instead.");
        return mountApp(app, container);
    }
    optimizePropertyLookup();
    var instance;
    withHydration(container, function() {
        instance = app._ceComponent || createComponent(app._component, app._props, null, false, false, app._context, true);
        mountComponent(instance, container);
        (0, $fKAHx.flushOnAppMount)();
    });
    rootInstances.set(app, instance);
    return instance;
};
var unmountApp = function(app) {
    var instance = rootInstances.get(app);
    unmountComponent(instance, app._container);
    (0, $fKAHx.flushOnAppMount)(instance);
    rootInstances.delete(app);
};
function prepareApp() {
    (0, $fKAHx.initFeatureFlags)();
    var target = (0, $6zvdv.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) (0, $fKAHx.setDevtoolsHook)(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
}
function postPrepareApp(app) {
    app.vapor = true;
    var mount = app.mount;
    app.mount = function(container) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        container = (0, $3ewO8.normalizeContainer)(container);
        if (!container) return;
        var proxy = mount.apply(void 0, [
            container
        ].concat((0, $aUGqu._)(args)));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
}
var createVaporApp = function(comp, props) {
    prepareApp();
    if (!_createApp) _createApp = (0, $fKAHx.createAppAPI)(mountApp, unmountApp, getExposed);
    var app = _createApp(comp, props);
    postPrepareApp(app);
    return app;
};
var createVaporSSRApp = function(comp, props) {
    setIsHydratingEnabled(true);
    prepareApp();
    if (!_hydrateApp) _hydrateApp = (0, $fKAHx.createAppAPI)(hydrateApp, unmountApp, getExposed);
    var app = _hydrateApp(comp, props);
    postPrepareApp(app);
    return app;
};
//#endregion
//#region packages/runtime-vapor/src/apiDefineComponent.ts
/*@__NO_SIDE_EFFECTS__*/ function defineVaporComponent(comp, extraOptions) {
    if ((0, $6zvdv.isFunction)(comp)) return /*@__PURE__*/ function() {
        return (0, $6zvdv.extend)({
            name: comp.name
        }, extraOptions, {
            setup: comp,
            __vapor: true
        });
    }();
    comp.__vapor = true;
    return comp;
}
//#endregion
//#region packages/runtime-vapor/src/apiDefineAsyncComponent.ts
function defineVaporAsyncComponent(source) {
    enableAsyncComponent();
    var _createAsyncComponentContext = (0, $fKAHx.createAsyncComponentContext)(source), load = _createAsyncComponentContext.load, getResolvedComp = _createAsyncComponentContext.getResolvedComp, setPendingRequest = _createAsyncComponentContext.setPendingRequest, _createAsyncComponentContext_source = _createAsyncComponentContext.source, loadingComponent = _createAsyncComponentContext_source.loadingComponent, errorComponent = _createAsyncComponentContext_source.errorComponent, delay = _createAsyncComponentContext_source.delay, hydrateStrategy = _createAsyncComponentContext_source.hydrate, timeout = _createAsyncComponentContext_source.timeout, _createAsyncComponentContext_source_suspensible = _createAsyncComponentContext_source.suspensible, suspensible = _createAsyncComponentContext_source_suspensible === void 0 ? true : _createAsyncComponentContext_source_suspensible;
    return /* @__PURE__ */ defineVaporComponent({
        name: "VaporAsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate: function(el, instance, hydrate) {
            if (!isHydrating$1) return;
            var endAnchor = isComment(el, "[") ? locateEndAnchor(el) : null;
            var nodes;
            if (endAnchor) {
                var end = /* @__PURE__ */ _next(endAnchor);
                var range = nodes = [
                    el
                ];
                var cur = el;
                while(true){
                    var n = /* @__PURE__ */ _next(cur);
                    if (n && n !== end) range.push(cur = n);
                    else break;
                }
            } else nodes = el;
            var prev = (0, $fKAHx.setCurrentInstance)(instance);
            try {
                var frag = new DynamicFragment(0, void 0);
                frag.nodes = nodes;
                instance.block = frag;
            } finally{
                (0, $fKAHx.restoreCurrentInstance)(prev);
            }
            instance.isMounted = true;
            setCurrentHydrationNode(nextLogicalSibling(el));
            (0, $fKAHx.performAsyncHydrate)(el, instance, function() {
                return hydrateNode(el, function() {
                    return withDeferredHydrationBoundary(hydrate);
                });
            }, getResolvedComp, load, hydrateStrategy, false);
        },
        get __asyncResolved () {
            return getResolvedComp();
        },
        setup: function() {
            var instance = (0, $fKAHx.currentInstance);
            (0, $fKAHx.markAsyncBoundary)(instance);
            var placeholder = instance.block;
            var frag;
            if (isHydrating$1 && isDynamicFragment(placeholder)) {
                frag = placeholder;
                frag.nodes = EMPTY_BLOCK;
                locateHydrationNode();
            } else {
                frag = new DynamicFragment(0, void 0);
                if (isHydrating$1) locateHydrationNode();
            }
            var resolvedComp = getResolvedComp();
            if (resolvedComp) {
                frag.update(function() {
                    return createInnerComp(resolvedComp, instance);
                });
                if (frag === placeholder) {
                    var u = frag.u;
                    if (u) u.forEach(function(hook) {
                        return hook(frag.nodes);
                    });
                }
                return frag;
            }
            var onError = function(err) {
                setPendingRequest(null);
                (0, $fKAHx.handleError)(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense) {
                var renderBranch = function(render) {
                    if (!instance.isUnmounted) instance.scope.run(function() {
                        return frag.update(render);
                    });
                };
                return load().then(function() {
                    resolvedComp = getResolvedComp();
                    if (resolvedComp) renderBranch(function() {
                        return createInnerComp(resolvedComp, instance);
                    });
                    return frag;
                }).catch(function(err) {
                    onError(err);
                    if (errorComponent) renderBranch(function() {
                        return createErrorComp(errorComponent, instance, function() {
                            return err;
                        });
                    });
                    return frag;
                });
            }
            var _useAsyncComponentState = (0, $fKAHx.useAsyncComponentState)(delay, timeout, onError, instance), loaded = _useAsyncComponentState.loaded, error = _useAsyncComponentState.error, delayed = _useAsyncComponentState.delayed;
            load().then(function() {
                if (instance.isUnmounted) return;
                loaded.value = true;
            }).catch(function(err) {
                if (instance.isUnmounted) {
                    setPendingRequest(null);
                    return;
                }
                onError(err);
                error.value = err;
            });
            renderEffect(function() {
                resolvedComp = getResolvedComp();
                var render;
                var key;
                if (loaded.value && resolvedComp) {
                    render = function() {
                        return createInnerComp(resolvedComp, instance);
                    };
                    key = 1;
                } else if (error.value && errorComponent) {
                    render = function() {
                        return createErrorComp(errorComponent, instance, function() {
                            return error.value;
                        });
                    };
                    key = 2;
                } else if (loadingComponent && !delayed.value) {
                    render = function() {
                        return createInnerComp(loadingComponent, instance);
                    };
                    key = 3;
                }
                frag.update(render, key);
                if (isKeepAliveEnabled && frag.keepAliveCtx) frag.keepAliveCtx.cacheBlock();
            });
            return frag;
        }
    });
}
/**
* The block an async wrapper has settled on, or undefined while it is
* unresolved or (under deferred hydration) resolved but not set up yet.
* Consumers reading through the wrapper treat undefined as unresolved.
*/ function getAsyncWrapperInner(instance) {
    var frag = instance.block;
    if (isDynamicFragment(frag) && frag.current !== void 0 && instance.type.__asyncResolved) return frag.nodes;
}
function createErrorComp(comp, parent, getError) {
    return createInnerComp(comp, parent, {
        error: getError
    }, {});
}
function createInnerComp(comp, parent) {
    var rawProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : parent.rawProps, rawSlots = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : parent.rawSlots;
    var prevInstance = (0, $fKAHx.setCurrentInstance)(parent);
    try {
        return createComponent(comp, rawProps, rawSlots, void 0, void 0, parent.appContext);
    } finally{
        (0, $fKAHx.restoreCurrentInstance)(prevInstance);
    }
}
//#endregion
//#region packages/runtime-vapor/src/components/Transition.ts
var registered = false;
var ensureTransitionHooksRegistered = function() {
    if (!registered) {
        registered = true;
        registerTransitionHooks(applyTransitionHooksImpl, applyTransitionLeaveHooksImpl, deferBranchUpdateDuringLeaveImpl, removeBranchWithLeaveImpl);
    }
};
var hydrateTransitionImpl = function(suspense) {
    if (!currentHydrationNode || !(0, $fKAHx.isTemplateNode)(currentHydrationNode)) return;
    var templateNode = currentHydrationNode;
    var content = templateNode.content, parentNode = templateNode.parentNode;
    var firstChild = content.firstChild;
    if (firstChild) {
        var transitionEl;
        for(var node = firstChild; node; node = node.nextSibling)if (node instanceof Element) {
            transitionEl = node;
            break;
        }
        parentNode.insertBefore(content, templateNode);
        parentNode.removeChild(templateNode);
        updateLastLocatedLogicalChild(parentNode, templateNode, firstChild);
        setCurrentHydrationNode(firstChild);
        if (transitionEl instanceof HTMLElement || transitionEl instanceof SVGElement) {
            var originalDisplay = transitionEl.style.display;
            transitionEl.style.display = "none";
            return function(hooks) {
                hooks.beforeEnter(transitionEl);
                transitionEl.style.display = originalDisplay;
                (0, $fKAHx.queuePostRenderEffect)(function() {
                    return hooks.enter(transitionEl);
                }, void 0, suspense);
            };
        }
    }
};
var decorate$1 = function(t) {
    t.displayName = displayName;
    t.props = (0, $3ewO8.TransitionPropsValidators);
    t.__vapor = true;
    return t;
};
var VaporTransition = /*@__PURE__*/ decorate$1(function(props, param) {
    var slots = param.slots, expose = param.expose;
    expose();
    ensureTransitionHooksRegistered();
    var instance = (0, $fKAHx.currentInstance);
    var performAppear = isHydrating$1 ? hydrateTransitionImpl(instance.suspense) : void 0;
    var state = (0, $fKAHx.useTransitionState)();
    var mode = props.mode;
    var resolvedProps = (0, $ftLbb.computed)(function() {
        return (0, $3ewO8.resolveTransitionProps)(props);
    });
    var propsProxy = new Proxy({}, {
        get: function(_, key) {
            return resolvedProps.value[key];
        }
    });
    var shouldPerformAppear = !!props.appear && !!performAppear;
    if (instance.rawSlots.$) {
        var frag = new DynamicFragment(0, void 0);
        if (isHydrating$1) locateHydrationNode();
        state.root = frag;
        var isMounted = false;
        renderEffect(function() {
            if (!frag.$transition) frag.$transition = resolveTransitionHooks(frag, propsProxy, state, instance);
            else frag.$transition.mode = resolvedProps.value.mode;
            var prevNodes = frag.nodes;
            frag.update(slots.default);
            if (isMounted && frag.nodes === prevNodes && !state.isLeaving) frag.$transition = applyTransitionHooksImpl(frag.nodes, frag.$transition);
            if (!isMounted && shouldPerformAppear) performAppear(frag.$transition);
            isMounted = true;
        });
        return frag;
    }
    var children = slots.default && slots.default() || [];
    state.root = children;
    var appliedHooks = {
        __vapor: true,
        state: state,
        props: propsProxy,
        instance: instance
    };
    var isMounted1 = false;
    renderEffect(function() {
        appliedHooks = applyTransitionHooksImpl(children, appliedHooks);
        if (!isMounted1) {
            isMounted1 = true;
            if (shouldPerformAppear) performAppear(appliedHooks);
        }
    });
    return children;
});
var transitionTypeMap = /* @__PURE__ */ new WeakMap();
function getTransitionType(block) {
    var type = transitionTypeMap.get(block);
    if (type !== void 0) return type;
    if (block instanceof Element) return block.localName;
    if (isInteropEnabled && isFragment(block) && block.getTransitionType) {
        var type1 = block.getTransitionType();
        if (type1 !== void 0) return type1;
    }
    return block;
}
function setTransitionType(block, type) {
    transitionTypeMap.set(block, type);
}
function getLeavingNodesForType(state, block) {
    var leavingNodes = state.leavingNodes;
    var type = getTransitionType(block);
    var nodes = leavingNodes.get(type);
    if (!nodes) {
        nodes = Object.create(null);
        leavingNodes.set(type, nodes);
    }
    return nodes;
}
function getLeaveElement(block) {
    var el = getTransitionElement(block);
    if (el) return el;
    if (isFragment(block) && !(0, $6zvdv.isArray)(block.nodes) && (block.nodes instanceof Element || isFragment(block.nodes))) return getLeaveElement(block.nodes);
}
var transitionKeys = /* @__PURE__ */ new WeakMap();
function getTransitionKey(block) {
    return transitionKeys.get(block);
}
function setTransitionKey(block, key) {
    transitionKeys.set(block, key);
}
var getTransitionHooksContext = function(block, state) {
    var key = String(getTransitionKey(block));
    var leavingNodes = getLeavingNodesForType(state, block);
    return {
        isLeaving: function() {
            return leavingNodes[key] === block;
        },
        setLeavingNodeCache: function() {
            leavingNodes[key] = block;
        },
        unsetLeavingNodeCache: function() {
            if (leavingNodes[key] === block) delete leavingNodes[key];
        },
        earlyRemove: function() {
            var leavingNode = leavingNodes[key];
            if (leavingNode && getTransitionKey(leavingNode) === getTransitionKey(block)) {
                var el = getLeaveElement(leavingNode);
                if (el && el[0, $fKAHx.leaveCbKey]) el[0, $fKAHx.leaveCbKey]();
            }
        }
    };
};
function resolveTransitionHooks(block, props, state, instance) {
    var context = getTransitionHooksContext(block, state);
    var hooks = (0, $fKAHx.baseResolveTransitionHooks)(context, props, state, instance);
    hooks.__vapor = true;
    hooks.persisted = hooks.persisted || !!state.persisted;
    hooks.state = state;
    hooks.props = props;
    hooks.instance = instance;
    return hooks;
}
function applyTransitionHooksImpl(block, hooks, owner) {
    if ((0, $6zvdv.isArray)(block)) {
        block = block.filter(function(b) {
            return !(b instanceof Comment);
        });
        if (block.length === 1) block = block[0];
        else if (block.length === 0) return hooks;
    }
    if (hooks.applyGroup && (isForFragment(block) || isVaporSlotOutlet(block) || isVaporComponent(block) && isVaporSlotOutlet(block.block))) {
        hooks.applyGroup(block, hooks.props, hooks.state, hooks.instance);
        return hooks;
    }
    var fragments = [];
    var child = resolveTransitionBlock(block, function(fragment) {
        return fragments.push(fragment);
    }, owner);
    if (!child) {
        fragments.forEach(function(f) {
            return f.$transition = hooks;
        });
        return hooks;
    }
    var props = hooks.props, instance = hooks.instance, state = hooks.state, delayedLeave = hooks.delayedLeave;
    state.persisted = isPersistedRoot(state.root);
    var resolvedHooks = resolveTransitionHooks(child, props, state, instance);
    resolvedHooks.delayedLeave = delayedLeave;
    child.$transition = resolvedHooks;
    fragments.forEach(function(f) {
        return f.$transition = resolvedHooks;
    });
    return resolvedHooks;
}
function isPersistedRoot(block) {
    while(block){
        if (block.$vshow) return true;
        if (isVaporComponent(block)) {
            if (isVaporTransition(block.type)) return false;
            block = isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(block) ? getAsyncWrapperInner(block) : block.block;
        } else if ((0, $6zvdv.isArray)(block)) block = block.find(function(b) {
            return !(b instanceof Comment);
        });
        else if (isFragment(block) && (isVaporSlotOutlet(block) || !(isDynamicFragment(block) || isForFragment(block)))) block = block.nodes;
        else return false;
    }
    return false;
}
function applyTransitionLeaveHooksImpl(block, enterHooks, afterLeaveCb) {
    var leavingBlock = findTransitionBlock(block);
    if (!leavingBlock) return false;
    var props = enterHooks.props, state = enterHooks.state, instance = enterHooks.instance;
    var leavingHooks = resolveTransitionHooks(leavingBlock, props, state, instance);
    leavingBlock.$transition = leavingHooks;
    var mode = props.mode;
    if (mode === "out-in") {
        state.isLeaving = true;
        leavingHooks.afterLeave = function() {
            state.isLeaving = false;
            afterLeaveCb();
            leavingBlock.$transition = void 0;
            delete leavingHooks.afterLeave;
        };
    } else if (mode === "in-out") leavingHooks.delayLeave = function(block, earlyRemove, delayedLeave) {
        var leavingNodes = getLeavingNodesForType(state, leavingBlock);
        var leavingKey = String(getTransitionKey(leavingBlock));
        leavingNodes[leavingKey] = leavingBlock;
        var delayedLeaveCb = function() {
            delayedLeave();
            leavingBlock.$transition = void 0;
            if (enterHooks.delayedLeave === delayedLeaveCb) delete enterHooks.delayedLeave;
        };
        block[0, $fKAHx.leaveCbKey] = function() {
            earlyRemove();
            block[0, $fKAHx.leaveCbKey] = void 0;
            leavingBlock.$transition = void 0;
            if (leavingNodes[leavingKey] === leavingBlock) delete leavingNodes[leavingKey];
            if (enterHooks.delayedLeave === delayedLeaveCb) delete enterHooks.delayedLeave;
        };
        enterHooks.delayedLeave = delayedLeaveCb;
    };
    return true;
}
function deferBranchUpdateDuringLeaveImpl(frag, render, key, noScope, branchKey) {
    if (!frag.$transition.state.isLeaving) return false;
    var pending = frag.pending;
    if (pending) {
        pending.render = render;
        pending.key = key;
        pending.noScope = noScope;
        pending.branchKey = branchKey;
    } else frag.pending = {
        render: render,
        key: key,
        noScope: noScope,
        branchKey: branchKey
    };
    return true;
}
function removeBranchWithLeaveImpl(frag, transition, parent, render, key, noScope, branchKey) {
    var mode = transition.mode;
    if (mode && !transition.persisted && (mode !== "in-out" || render) && (mode !== "out-in" || isValidBlock(frag.nodes))) {
        var instance = (0, $fKAHx.currentInstance);
        applyTransitionLeaveHooksImpl(frag.nodes, transition, function() {
            if (transition.state.isUnmounting) return;
            var prevInstance = (0, $fKAHx.setCurrentInstance)(instance);
            try {
                var pending = frag.pending;
                if (pending) {
                    frag.pending = void 0;
                    frag.renderBranch(pending.render, transition, parent, pending.key, pending.noScope, true, void 0, pending.branchKey);
                } else frag.renderBranch(render, transition, parent, key, noScope, true, void 0, branchKey);
            } finally{
                (0, $fKAHx.restoreCurrentInstance)(prevInstance);
            }
        });
        if (mode === "out-in") {
            parent && remove(frag.nodes, parent);
            return true;
        }
    }
    return false;
}
var ROOT_KEY_CONTEXT = {
    key: void 0
};
var keyContexts = /* @__PURE__ */ new WeakMap();
var KEY_CONTEXT_OWNER = 34;
function transitionTypeOf(block) {
    return isAsyncComponentEnabled && block.type.__asyncResolved || block.type;
}
function withDefaultKey(ctx, key) {
    return ctx.type || key == null ? ctx : {
        key: key
    };
}
function isUnresolvedAsyncWrapper(block) {
    return isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(block) && getAsyncWrapperInner(block) === void 0;
}
function enterComponentKeyContext(ctx, block) {
    var unresolved = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : isUnresolvedAsyncWrapper(block);
    var _block$$key;
    if (ctx.type) return ctx;
    return unresolved ? withDefaultKey(ctx, block.$key) : {
        key: (_block$$key = block.$key) !== null && _block$$key !== void 0 ? _block$$key : ctx.key,
        type: transitionTypeOf(block)
    };
}
function enterFragmentKeyContext(frag, ctx) {
    var key = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : getFragmentKey(frag);
    if (frag.__vf & KEY_CONTEXT_OWNER) keyContexts.set(frag, ctx);
    return withDefaultKey(ctx, key);
}
function resolveChildIdentity(child, ctx) {
    var _child$$key;
    transitionKeys.set(child, ctx.type ? ctx.key : (_child$$key = child.$key) !== null && _child$$key !== void 0 ? _child$$key : ctx.key);
    if (ctx.type) setTransitionType(child, ctx.type);
}
/**
* Resolve the transition child of `block` together with its identity.
* `owner` is the fragment whose content `block` is.
*/ function resolveTransitionBlock(block, onFragment, owner) {
    var ctx = owner ? withDefaultKey(keyContexts.get(owner) || ROOT_KEY_CONTEXT, getFragmentKey(owner)) : ROOT_KEY_CONTEXT;
    var children = [];
    collectTransitionBlocks$1(block, onFragment, children, ctx);
    return children[0];
}
/** Locate the transition child of `block` without touching its identity. */ function findTransitionBlock(block) {
    var children = [];
    collectTransitionBlocks$1(block, void 0, children, void 0);
    return children[0];
}
function collectTransitionBlocks$1(block, onFragment, children, ctx) {
    if (block instanceof Node) {
        if (block instanceof Element) {
            children.push(block);
            if (ctx) resolveChildIdentity(block, ctx);
        }
    } else if (isVaporComponent(block)) collectComponentTransitionBlocks(block, onFragment, children, ctx);
    else if ((0, $6zvdv.isArray)(block)) collectArrayTransitionBlocks(block, onFragment, children, ctx);
    else if (isFragment(block)) collectFragmentTransitionBlocks(block, onFragment, children, ctx);
}
function collectComponentTransitionBlocks(block, onFragment, children, ctx) {
    if (isKeepAliveEnabled && (0, $fKAHx.isKeepAlive)(block)) {
        collectTransitionBlocks$1(block.block, onFragment, children, ctx);
        return;
    }
    var async = isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(block);
    var inner = async ? getAsyncWrapperInner(block) : void 0;
    if (ctx) ctx = enterComponentKeyContext(ctx, block, async && inner === void 0);
    if (async) {
        if (inner === void 0) {
            if (isFragment(block.block)) {
                if (onFragment) onFragment(block.block);
                if (ctx) keyContexts.set(block.block, ctx);
            }
            return;
        }
        collectTransitionBlocks$1(inner, onFragment, children, ctx);
        return;
    }
    if (isVaporTransition(block.type)) return;
    collectTransitionBlocks$1(block.block, onFragment, children, ctx);
}
function collectArrayTransitionBlocks(block, onFragment, children, ctx) {
    var hasFound = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = block[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var c = _step.value;
            if (c instanceof Comment) continue;
            var nested = [];
            collectTransitionBlocks$1(c, onFragment, nested, ctx);
            if (nested.length) children.push(nested[0]);
            hasFound = true;
            break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function collectFragmentTransitionBlocks(block, onFragment, children, ctx) {
    if (isInteropEnabled && block.hasVDOMContent && block.hasVDOMContent()) {
        children.push(block);
        if (ctx) {
            resolveChildIdentity(block, ctx);
            if (!ctx.type) {
                var type = block.getTransitionType();
                if (type !== void 0) setTransitionType(block, type);
            }
        }
        return;
    }
    if (onFragment) onFragment(block);
    collectTransitionBlocks$1(block.nodes, onFragment, children, ctx && enterFragmentKeyContext(block, ctx));
}
function setTransitionHooks$1(block, hooks) {
    if (isVaporComponent(block)) {
        block = findTransitionBlock(block.block);
        if (!block) return;
    }
    block.$transition = hooks;
}
function isValidTransitionBlock(block) {
    return block instanceof Element || !!(isInteropEnabled && isFragment(block) && block.hasVDOMContent && block.hasVDOMContent());
}
function getTransitionElement(block) {
    if (block instanceof Element) return block;
    if (isInteropEnabled && isFragment(block) && block.getTransitionElement) return block.getTransitionElement();
}
//#endregion
//#region packages/runtime-vapor/src/refCleanup.ts
/**
* Stores ref cleanup functions keyed by the element/component they are set on.
* Shared between apiTemplateRef.ts (writes) and KeepAlive deactivate (reads).
*/ var refCleanups = /* @__PURE__ */ new WeakMap();
function invalidatePendingRef(el) {
    var c = refCleanups.get(el);
    if (c && c.job) {
        c.job.flags = c.job.flags | 4;
        c.job = void 0;
    }
}
/**
* Synchronously clear the ref for an element being deactivated by KeepAlive.
* In VDOM core, refs are cleared during unmount before the deactivation check.
* Since Vapor's KeepAlive retains scopes (skipping onScopeDispose), we need
* this explicit sync cleanup path.
*/ function unsetRef(el) {
    invalidatePendingRef(el);
    var c = refCleanups.get(el);
    if (c) c.fn();
}
var VaporKeepAlive = /*@__PURE__*/ withKeepAliveEnabled(/* @__PURE__ */ defineVaporComponent({
    name: "VaporKeepAlive",
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup: function(props, param) {
        var slots = param.slots, expose = param.expose;
        var exposed;
        expose(exposed);
        if (!slots.default) return;
        var keepAliveInstance = (0, $fKAHx.currentInstance);
        var cache = /* @__PURE__ */ new Map();
        var keys = /* @__PURE__ */ new Set();
        var storageContainer = /* @__PURE__ */ createElement("div");
        var keptAliveScopes = /* @__PURE__ */ new Map();
        var resolveCacheKeyFromBlock = function(block, interop, branchKey) {
            var _ref3, _$key;
            if (interop && isInteropEnabled) {
                var _ref, _ref2, _frag$$key;
                var frag = block;
                return (_ref = (_ref2 = (_frag$$key = frag.$key) !== null && _frag$$key !== void 0 ? _frag$$key : frag.vnode.key) !== null && _ref2 !== void 0 ? _ref2 : branchKey) !== null && _ref !== void 0 ? _ref : frag.vnode.type;
            }
            return (_ref3 = (_$key = block.$key) !== null && _$key !== void 0 ? _$key : branchKey) !== null && _ref3 !== void 0 ? _ref3 : block.type;
        };
        var current;
        var rootFragment;
        if (__VUE_PROD_DEVTOOLS__) {
            keepAliveInstance.__v_cache = cache;
            keepAliveInstance.__v_keptAliveScopes = keptAliveScopes;
        }
        var addCacheKey = function(key) {
            var max = props.max;
            keys.add(key);
            if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
        };
        var innerCacheBlock = function(key, block, isCurrent) {
            if (cache.has(key)) {
                if (isCurrent) {
                    keys.delete(key);
                    keys.add(key);
                }
            } else addCacheKey(key);
            cache.set(key, block);
            if (isCurrent) current = block;
        };
        var cacheBlock = function() {
            var block = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : keepAliveInstance.block;
            if (isDynamicFragment(block)) {
                var transition = block.$transition;
                if (transition && transition.mode === "out-in" && transition.state.isLeaving) return;
            }
            var _getInnerBlock = (0, $f9AOD._)(getInnerBlock(block), 3), innerBlock = _getInnerBlock[0], interop = _getInnerBlock[1], branchKey = _getInnerBlock[2];
            if (!innerBlock) return;
            var cacheKey = resolveCacheKeyFromBlock(innerBlock, interop, branchKey);
            if (!shouldCache(innerBlock, props, interop)) {
                if (cache.has(cacheKey)) pruneCacheEntry(cacheKey);
                return;
            }
            setShapeFlag(innerBlock, interop, cache.has(cacheKey));
            var _getCurrentBlockState = getCurrentBlockState(), currentBlock = _getCurrentBlockState.currentBlock, currentKey = _getCurrentBlockState.currentKey;
            innerCacheBlock(cacheKey, innerBlock, currentBlock === innerBlock || currentKey === cacheKey);
        };
        var processShapeFlag = function(block) {
            var requireKeptAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            var _getInnerBlock = (0, $f9AOD._)(getInnerBlock(block), 3), innerBlock = _getInnerBlock[0], interop = _getInnerBlock[1], branchKey = _getInnerBlock[2];
            if (!innerBlock || requireKeptAlive && !isKeptAlive(innerBlock, interop) || !shouldCache(innerBlock, props, interop)) return false;
            var cacheKey = resolveCacheKeyFromBlock(innerBlock, interop, branchKey);
            setShapeFlag(innerBlock, interop, cache.has(cacheKey));
            return cacheKey;
        };
        var pruneCache = function(filter) {
            cache.forEach(function(cached, key) {
                var instance = getInstanceFromCache(cached);
                if (!instance) return;
                var name = (0, $fKAHx.getComponentName)((0, $fKAHx.isAsyncWrapper)(instance) ? instance.type.__asyncResolved || {} : instance.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        };
        var deleteScope = function(key) {
            var scope = keptAliveScopes.get(key);
            if (scope) {
                keptAliveScopes.delete(key);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keptAliveScopes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $f9AOD._)(_step.value, 2), k = _step_value[0], s = _step_value[1];
                        if (s === scope) {
                            keptAliveScopes.delete(k);
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return scope;
        };
        var cacheScope = function(cacheKey, scopeLookupKey, scope) {
            var prevScope = keptAliveScopes.get(cacheKey);
            if (prevScope && prevScope !== scope) {
                var staleScope = deleteScope(cacheKey);
                if (staleScope) staleScope.stop();
            }
            keptAliveScopes.set(cacheKey, scope);
            if (scopeLookupKey !== cacheKey) keptAliveScopes.set(scopeLookupKey, scope);
        };
        var pruneCacheEntry = function(key) {
            var cached = cache.get(key);
            if (cached && (!current || cached !== current)) {
                unsetShapeFlag(cached);
                var parentNode = findBlockBoundary(cached).parentNode;
                if (parentNode) remove(cached, parentNode);
            } else if (current) unsetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
            var scope = deleteScope(key);
            if (scope) scope.stop();
        };
        (0, $fKAHx.watch)(function() {
            return [
                props.include,
                props.exclude
            ];
        }, function(param) {
            var _param = (0, $f9AOD._)(param, 2), include = _param[0], exclude = _param[1];
            include && pruneCache(function(name) {
                return (0, $fKAHx.matches)(include, name);
            });
            exclude && pruneCache(function(name) {
                return !(0, $fKAHx.matches)(exclude, name);
            });
            cacheBlock();
        }, {
            flush: "post",
            deep: true
        });
        (0, $fKAHx.onMounted)(cacheBlock);
        (0, $fKAHx.onUpdated)(cacheBlock);
        var getCurrentBlockState = function() {
            var block = keepAliveInstance.block;
            var _getInnerBlock = (0, $f9AOD._)(getInnerBlock(block), 3), currentBlock = _getInnerBlock[0], interop = _getInnerBlock[1], branchKey = _getInnerBlock[2];
            return {
                currentBlock: currentBlock,
                interop: interop,
                currentKey: currentBlock && resolveCacheKeyFromBlock(currentBlock, interop, branchKey)
            };
        };
        (0, $fKAHx.onBeforeUnmount)(function() {
            var _getCurrentBlockState = getCurrentBlockState(), currentBlock = _getCurrentBlockState.currentBlock, interop = _getCurrentBlockState.interop, currentKey = _getCurrentBlockState.currentKey;
            var deactivateCached = function(cached) {
                unsetShapeFlag(cached);
                var instance = getInstanceFromCache(cached);
                if (instance) {
                    var da = instance.da;
                    da && (0, $fKAHx.queuePostRenderEffect)(da, void 0, keepAliveInstance.suspense);
                }
            };
            var matched = false;
            cache.forEach(function(cached, key) {
                if (currentKey === key) {
                    matched = true;
                    deactivateCached(cached);
                    return;
                }
                unsetShapeFlag(cached);
                var parentNode = findBlockBoundary(cached).parentNode;
                remove(cached, parentNode || void 0);
            });
            if (!matched && currentBlock && isKeptAlive(currentBlock, interop)) deactivateCached(currentBlock);
            keptAliveScopes.forEach(function(scope) {
                return scope.stop();
            });
            keptAliveScopes.clear();
        });
        var keepAliveCtx = {
            isolatePropSources: isolatePropSources,
            isolateSlotSources: isolateSlotSources,
            getStorageContainer: function() {
                return storageContainer;
            },
            getCachedComponent: function(comp, key) {
                if (isInteropEnabled && (0, $fKAHx.isVNode)(comp)) {
                    var _ref4, _comp$key;
                    return cache.get((_ref4 = (_comp$key = comp.key) !== null && _comp$key !== void 0 ? _comp$key : currentCacheKey) !== null && _ref4 !== void 0 ? _ref4 : comp.type);
                }
                var branchKey = key !== null && key !== void 0 ? key : currentCacheKey;
                return branchKey != null ? cache.get(branchKey) : cache.get(comp) || cache.get(comp.__asyncResolved);
            },
            activate: function(instance, parentNode, anchor, parentSuspense) {
                current = instance;
                activate$1(instance, parentNode, anchor, parentSuspense);
            },
            deactivate: function(instance, parentSuspense) {
                current = void 0;
                deactivate$1(instance, storageContainer, parentSuspense);
            },
            prepareBranchRemoval: function(frag, scope, prevKey) {
                if (frag !== rootFragment) {
                    scope.stop();
                    return false;
                }
                var fragKey = getFragmentKey(frag);
                var cacheKey = withCurrentCacheKey(fragKey, function() {
                    return processShapeFlag(frag.nodes, true);
                });
                if (cacheKey === false) {
                    scope.stop();
                    return false;
                }
                scope.pause();
                cacheScope(cacheKey, fragKey !== null && fragKey !== void 0 ? fragKey : prevKey, scope);
                return true;
            },
            runBranchRender: function(frag, fn, useScope, removePrevious) {
                var fragKey = getFragmentKey(frag);
                var cachedScope = useScope ? deleteScope(fragKey !== null && fragKey !== void 0 ? fragKey : frag.current) : void 0;
                frag.scope = useScope ? cachedScope || new (0, $ftLbb.EffectScope)() : void 0;
                if (cachedScope) cachedScope.resume();
                var incomingCacheKey = false;
                var run = function() {
                    try {
                        fn();
                    } finally{
                        incomingCacheKey = processShapeFlag(frag.nodes);
                    }
                };
                try {
                    withCurrentCacheKey(fragKey, run);
                    if (removePrevious && incomingCacheKey !== false && !cache.has(incomingCacheKey)) addCacheKey(incomingCacheKey);
                } finally{
                    if (removePrevious) removePrevious();
                }
            },
            processShapeFlag: processShapeFlag,
            cacheBlock: cacheBlock
        };
        if (isInteropEnabled) keepAliveCtx.clearCurrent = function(block) {
            if (current === block) current = void 0;
        };
        keepAliveInstance.ctx = keepAliveCtx;
        var children = slots.default();
        rootFragment = registerDynamicFragmentHooks(children, keepAliveCtx);
        if ((0, $6zvdv.isArray)(children)) {
            children = children.filter(function(child) {
                return !(child instanceof Comment);
            });
            if (children.length === 1) rootFragment = registerDynamicFragmentHooks(children[0], keepAliveCtx);
            if (children.length > 1) return children;
        }
        return children;
    }
}));
function registerDynamicFragmentHooks(block, keepAliveCtx) {
    if (!isDynamicFragment(block)) return;
    (block.u || (block.u = [])).unshift(function() {
        if (block.$transition && block.$transition.mode === "out-in") keepAliveCtx.cacheBlock(block);
    });
    return block;
}
var shouldCache = function(block, props) {
    var interop = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var isAsync = (0, $fKAHx.isAsyncWrapper)(interop ? block.vnode : block);
    var type = interop && isInteropEnabled ? block.vnode.type : block.type;
    if (isAsync && !type.__asyncResolved) return !props.include;
    var include = props.include, exclude = props.exclude;
    var name = (0, $fKAHx.getComponentName)(isAsync ? type.__asyncResolved : type);
    return !(include && (!name || !(0, $fKAHx.matches)(include, name)) || exclude && name && (0, $fKAHx.matches)(exclude, name));
};
function setShapeFlag(block, interop, cached) {
    if (interop && isInteropEnabled) {
        if (cached) block.vnode.shapeFlag |= 512;
        block.vnode.shapeFlag |= 256;
    } else {
        if (cached) block.shapeFlag |= 512;
        block.shapeFlag |= 256;
    }
}
var unsetShapeFlag = function(cached) {
    if (isVaporComponent(cached)) {
        (0, $fKAHx.resetShapeFlag)(cached);
        if (isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(cached)) {
            var _getInnerBlock = (0, $f9AOD._)(getInnerBlock(cached.block), 1), inner = _getInnerBlock[0];
            if (inner && isVaporComponent(inner)) (0, $fKAHx.resetShapeFlag)(inner);
        }
    } else if (isInteropEnabled) {
        var vnode = cached.vnode;
        (0, $fKAHx.resetShapeFlag)(vnode);
        if (isVaporComponent(vnode.component)) unsetShapeFlag(vnode.component);
    }
};
function isKeptAlive(cached, interop) {
    if (interop && isInteropEnabled && isInteropFragment(cached)) return !!(cached.vnode.shapeFlag & 256);
    return !!(cached.shapeFlag & 256);
}
function getInnerBlock(block) {
    var branchKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : currentCacheKey;
    if (isVaporComponent(block)) return [
        block,
        false,
        branchKey
    ];
    else if (isInteropEnabled && isInteropFragment(block)) return [
        block,
        true,
        branchKey
    ];
    else if (isFragment(block)) {
        var _getFragmentKey;
        return getInnerBlock(block.nodes, (_getFragmentKey = getFragmentKey(block)) !== null && _getFragmentKey !== void 0 ? _getFragmentKey : branchKey);
    }
    return [
        void 0,
        false,
        branchKey
    ];
}
function getInstanceFromCache(cached) {
    if (isVaporComponent(cached)) return cached;
    if (isInteropEnabled) return cached.vnode.component;
}
function activate$1(instance, parentNode, anchor) {
    var parentSuspense = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : instance.suspense;
    var inputScope = instance.inputScope;
    if (inputScope) inputScope.resume();
    move(instance, parentNode, anchor, 0, instance, parentSuspense);
    (0, $fKAHx.queuePostRenderEffect)(function() {
        instance.isDeactivated = false;
        if (instance.a) (0, $6zvdv.invokeArrayFns)(instance.a);
    }, void 0, parentSuspense);
    if (__VUE_PROD_DEVTOOLS__) (0, $fKAHx.devtoolsComponentAdded)(instance);
}
function deactivate$1(instance, container) {
    var parentSuspense = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : instance.suspense;
    var inputScope = instance.inputScope;
    if (inputScope) inputScope.pause();
    unsetRef(instance);
    (0, $fKAHx.invalidateMount)(instance.m);
    (0, $fKAHx.invalidateMount)(instance.a);
    move(instance, container, null, 1, instance, parentSuspense);
    (0, $fKAHx.queuePostRenderEffect)(function() {
        if (instance.da) (0, $6zvdv.invokeArrayFns)(instance.da);
        instance.isDeactivated = true;
    }, void 0, parentSuspense);
    if (__VUE_PROD_DEVTOOLS__) (0, $fKAHx.devtoolsComponentAdded)(instance);
}
function isolateSlotSources(rawSlots) {
    var _loop = function(i) {
        var source = dynamicSources[i];
        if ((0, $6zvdv.isFunction)(source)) {
            hasFunctionSource = true;
            isolatedSources[i] = function() {
                return committedSources[i];
            };
        }
    };
    var dynamicSources = rawSlots.$;
    var isolatedSources = dynamicSources.slice();
    var committedSources = (0, $ftLbb.shallowReactive)([]);
    var hasFunctionSource = false;
    for(var i = 0; i < dynamicSources.length; i++)_loop(i);
    if (!hasFunctionSource) return rawSlots;
    var isolated = _objectSpread2(_objectSpread2({}, rawSlots), {}, {
        $: isolatedSources
    });
    renderEffect(function() {
        for(var i = 0; i < dynamicSources.length; i++){
            var source = dynamicSources[i];
            if ((0, $6zvdv.isFunction)(source)) committedSources[i] = resolveFunctionSource(source);
        }
    }, true);
    return isolated;
}
//#endregion
//#region packages/runtime-vapor/src/vdomInterop.ts
var EMPTY_VNODES = (0, $6zvdv.EMPTY_ARR);
function getRawTransitionChild(vnode) {
    if (!vnode) return;
    var children = (0, $fKAHx.getTransitionRawChildren)([
        vnode
    ]);
    return children.length === 1 ? children[0] : void 0;
}
function isVaporTransitionHooks(hooks) {
    return !!hooks && hooks.__vapor === true;
}
function getVaporInstance(vnode) {
    return vnode.component;
}
function prepareInteropSlotTransition(frag, vnode, forwarded, previous, resumeAfterLeave, delayedLeaveSource) {
    var transition = frag.$transition;
    var instance = frag.renderInstance;
    if (transition && !isVaporTransitionHooks(transition)) {
        (0, $fKAHx.setTransitionHooks)(vnode, transition);
        return;
    }
    if (transition && transition.applyGroup) return;
    if (!transition && !(forwarded && instance && isVaporTransition(instance.type))) return;
    var branch = (0, $fKAHx.resolveTransitionChild)([
        vnode
    ], true);
    if (!transition) return branch;
    return (0, $fKAHx.prepareTransitionSwitch)(previous, branch, transition.props, transition.state, transition.instance, resumeAfterLeave, delayedLeaveSource || transition) || (0, $fKAHx.createCommentVNode)();
}
function getInteropTransitionType(vnode) {
    var child = getRawTransitionChild(vnode);
    return child && child.type;
}
function vnodeKeyOf(vnode) {
    var _vnode$key;
    return (_vnode$key = vnode.key) !== null && _vnode$key !== void 0 ? _vnode$key : void 0;
}
function getVNodeKey(vnode) {
    var child = getRawTransitionChild(vnode);
    return child && vnodeKeyOf(child);
}
function getInteropTransitionElement(vnode) {
    if (!vnode) return;
    var component = vnode.component;
    if (isVaporComponent(component)) {
        var block = component.block && findTransitionBlock(component.block);
        return block && getTransitionElement(block);
    }
    if (component) return getInteropTransitionElement(component.subTree);
    if (vnode.el instanceof Element) return vnode.el;
    if (vnode.type === (0, $fKAHx.Fragment)) {
        var child = getRawTransitionChild(vnode);
        if (child) return getInteropTransitionElement(child);
    } else if (vnode.shapeFlag & 64 && (0, $6zvdv.isArray)(vnode.children)) {
        var child1 = (0, $fKAHx.resolveTransitionChild)(vnode.children);
        if (child1) return getInteropTransitionElement(child1);
    }
}
function filterReservedProps(props) {
    var filtered = {};
    for(var key in props)if (!(0, $6zvdv.isReservedProp)(key)) filtered[key] = props[key];
    return filtered;
}
var vaporInteropImpl = {
    applyCssVars: function(vnode, vars) {
        setVarsOnBlock(getVaporInstance(vnode).block, vars);
    },
    mount: function(vnode, container, anchor, parentComponent, parentSuspense, onBeforeMount, onVnodeBeforeMount) {
        var selfAnchor = vnode.anchor = /* @__PURE__ */ createTextNode();
        vnode.el = selfAnchor;
        container.insertBefore(selfAnchor, anchor);
        var prev = (0, $fKAHx.currentInstance);
        (0, $fKAHx.simpleSetCurrentInstance)(parentComponent);
        var propsRef = (0, $ftLbb.shallowRef)(filterReservedProps(vnode.props));
        var slotsRef = (0, $ftLbb.shallowRef)(normalizeInteropSlots(vnode.children));
        var rawSlots = createInteropRawSlots(slotsRef);
        var prevCtx = currentRenderContext;
        if (isSuspenseEnabled && parentSuspense) setRenderContext(deriveSuspense(prevCtx, parentSuspense));
        var dynamicPropSource = [
            function() {
                return propsRef.value;
            }
        ];
        dynamicPropSource[interopKey] = true;
        var instance = vnode.component = createComponent(vnode.type, {
            $: dynamicPropSource
        }, rawSlots, void 0, void 0, parentComponent ? parentComponent.appContext : vnode.appContext, true);
        instance.rawPropsRef = propsRef;
        instance.rawSlotsRef = slotsRef;
        var vnodeHookState = ensureVNodeHookState(instance, vnode);
        setInteropComponentScopeIds(instance, vnode);
        if (parentComponent && (0, $fKAHx.isKeepAlive)(parentComponent)) {
            enableKeepAlive();
            instance.shapeFlag = vnode.shapeFlag;
        }
        if (vnode.transition) {
            ensureTransitionHooksRegistered();
            (instance.bm || (instance.bm = [])).push(function() {
                var transition = vnodeHookState.vnode.transition;
                if (transition) setTransitionHooks$1(instance, transition);
            });
        }
        setRenderContext(prevCtx);
        var rootEl = resolveInteropRootEl(instance);
        if (rootEl) vnode.el = rootEl;
        onVnodeBeforeMount && onVnodeBeforeMount();
        if (vnode.dirs) {
            if (rootEl) onBeforeMount && onBeforeMount();
            else vnode.dirs = null;
        }
        mountComponent(instance, container, selfAnchor);
        (0, $fKAHx.simpleSetCurrentInstance)(prev);
        return instance;
    },
    update: function(n1, n2, shouldUpdate, onBeforeUpdate, onVnodeBeforeUpdate) {
        n2.component = n1.component;
        n2.el = n1.el;
        n2.anchor = n1.anchor;
        var instance = getVaporInstance(n2);
        var vnodeHookState = ensureVNodeHookState(instance, n2);
        if (shouldUpdate) {
            var rootEl = getRootElement(instance);
            if (rootEl) n2.el = rootEl;
            onVnodeBeforeUpdate && onVnodeBeforeUpdate();
            if (n2.dirs) {
                if (rootEl) onBeforeUpdate && onBeforeUpdate();
                else n2.dirs = null;
            }
            vnodeHookState.pendingVNodeUpdate = n2;
            if (n2.transition && instance.block) {
                ensureTransitionHooksRegistered();
                setTransitionHooks$1(instance, n2.transition);
            }
            instance.rawPropsRef.value = filterReservedProps(n2.props);
            instance.rawSlotsRef.value = normalizeInteropSlots(n2.children);
            (0, $fKAHx.queuePostFlushCb)(function() {
                syncVNodeEl(n2, instance);
                if (vnodeHookState.pendingVNodeUpdate === n2 && !instance.isUpdating) vnodeHookState.pendingVNodeUpdate = null;
            });
        }
    },
    unmount: function(vnode, doRemove, parentSuspense) {
        if (isSuspenseEnabled && currentUnmountSuspense !== parentSuspense) {
            runWithUnmountSuspense(parentSuspense, function() {
                return vaporInteropImpl.unmount(vnode, doRemove, parentSuspense);
            });
            return;
        }
        var container = doRemove ? vnode.anchor.parentNode : void 0;
        var instance = getVaporInstance(vnode);
        var slotStartAnchor = null;
        if (instance) {
            var anchor = vnode.anchor;
            if (instance.block) {
                unmountComponent(instance, container, parentSuspense);
                if (!doRemove) {
                    var blockContainer = needsHostParentForRemove(instance.block) ? anchor && anchor.parentNode : void 0;
                    remove(instance.block, blockContainer);
                }
            } else {
                unmountComponent(instance, container, parentSuspense);
                if (!doRemove) instance.pendingBlock = void 0;
            }
        } else if (vnode.vb) {
            var anchor1 = vnode.anchor;
            if (vnode.el && vnode.el !== anchor1 && isComment(vnode.el, "[")) slotStartAnchor = vnode.el;
            var blockContainer1 = container || (needsHostParentForRemove(vnode.vb) ? anchor1 && anchor1.parentNode : void 0);
            stopVaporSlotScope(vnode);
            remove(vnode.vb, blockContainer1);
        }
        if (doRemove) {
            if (slotStartAnchor) {
                var parent = slotStartAnchor.parentNode;
                if (parent) remove(slotStartAnchor, parent);
            }
            var anchor2 = vnode.anchor;
            var parent1 = anchor2.parentNode;
            if (parent1) remove(anchor2, parent1);
        }
    },
    /**
	* vapor slot in vdom
	*/ slot: function(n1, n2, container, anchor, parentComponent, parentSuspense, slotScopeIds) {
        if (!n1) {
            var slotBlock = renderVaporSlot(n2, parentComponent, parentSuspense, slotScopeIds);
            var selfAnchor = (isFragment(slotBlock) ? slotBlock.anchor : void 0) || /* @__PURE__ */ createTextNode();
            insert(n2.el = n2.anchor = selfAnchor, container, anchor);
            insert(n2.vb = slotBlock, container, selfAnchor, parentSuspense);
        } else if (!n1.vs || !n2.vs || !n1.vs.slot || !n2.vs.slot || n2.vs.slot !== n1.vs.slot) {
            var selfAnchor1 = n1.anchor;
            var parent = selfAnchor1.parentNode;
            var nextSibling = selfAnchor1.nextSibling;
            var rangeStartAnchor = n1.el && n1.el !== selfAnchor1 && isComment(n1.el, "[") ? n1.el : void 0;
            var oldBlockOwnsAnchor = isFragment(n1.vb) && n1.vb.anchor === selfAnchor1;
            stopVaporSlotScope(n1);
            remove(n1.vb, parent);
            var slotBlock1 = renderVaporSlot(n2, parentComponent, parentSuspense, slotScopeIds);
            var newAnchor = isFragment(slotBlock1) ? slotBlock1.anchor : void 0;
            var insertAnchor = nextSibling;
            if (newAnchor) {
                if (!oldBlockOwnsAnchor) remove(selfAnchor1, parent);
            } else if (oldBlockOwnsAnchor) newAnchor = /* @__PURE__ */ createTextNode();
            else {
                newAnchor = selfAnchor1;
                insertAnchor = selfAnchor1;
            }
            insert(n2.anchor = newAnchor, parent, insertAnchor);
            n2.el = rangeStartAnchor || newAnchor;
            insert(n2.vb = slotBlock1, parent, newAnchor, parentSuspense);
        } else {
            var vs1 = n1.vs;
            var vs2 = n2.vs;
            n2.el = n1.el;
            n2.anchor = n1.anchor;
            n2.vb = n1.vb;
            (vs2.ref = vs1.ref).value = n2.props;
            vs2.scope = vs1.scope;
            syncInteropVaporSlotState(n1, n2);
        }
    },
    move: function(vnode, container, anchor, moveType, parentSuspense) {
        var block = vnode.vb || vnode.component;
        var pendingRangeOwnsFragmentStart = isVaporComponent(block) && !!block.pendingBlock;
        if (vnode.el && vnode.el !== vnode.anchor && isComment(vnode.el, "[") && !pendingRangeOwnsFragmentStart) move(vnode.el, container, anchor, moveType, void 0, parentSuspense);
        move(block, container, anchor, moveType, void 0, parentSuspense);
        move(vnode.anchor, container, anchor, moveType, void 0, parentSuspense);
    },
    hydrate: function(vnode, node, container, anchor, parentComponent, parentSuspense, onBeforeMount, onVnodeBeforeMount) {
        var _this = this;
        if (!isHydrating$1 && !(0, $fKAHx.isHydrating) && !(0, $fKAHx.isHydratingEnabled)) return node;
        var instance;
        hydrateNode(node, function() {
            instance = _this.mount(vnode, container, anchor, parentComponent, parentSuspense, onBeforeMount, onVnodeBeforeMount);
        });
        if (instance && instance.asyncDep && !instance.asyncResolved) vnode.el = node;
        return anchor;
    },
    hydrateSlot: function(vnode, node, parentComponent, parentSuspense, slotScopeIds) {
        if (!isHydrating$1 && !(0, $fKAHx.isHydrating) && !(0, $fKAHx.isHydratingEnabled)) return node;
        var container = /* @__PURE__ */ parentNode(node);
        var createdAnchor = false;
        var resumeNode = null;
        hydrateNode(node, function() {
            vnode.vb = renderVaporSlot(vnode, parentComponent, parentSuspense, slotScopeIds);
            var fragmentAnchor = isFragment(vnode.vb) && vnode.vb.anchor;
            var anchor = fragmentAnchor || currentHydrationNode;
            var wrapped = isComment(node, "[") && isComment(anchor, "]");
            if (!fragmentAnchor && !wrapped) {
                createdAnchor = true;
                resumeNode = anchor && /* @__PURE__ */ parentNode(anchor) === container ? anchor : null;
                anchor = /* @__PURE__ */ createTextNode();
                container.insertBefore(anchor, resumeNode);
            }
            if (isComment(node, "[") && isComment(anchor, "]")) {
                vnode.el = node;
                vnode.anchor = anchor;
            } else vnode.anchor = vnode.el = anchor;
        });
        if (createdAnchor) return resumeNode;
        return isComment(node, "[") ? vnode.anchor.nextSibling : vnode.anchor;
    },
    setTransitionHooks: function(component, hooks) {
        ensureTransitionHooksRegistered();
        setTransitionHooks$1(component, hooks);
    },
    activate: function(vnode, container, anchor, parentComponent, parentSuspense) {
        var cached = parentComponent.ctx.getCachedComponent(vnode);
        vnode.el = cached.el;
        vnode.component = cached.component;
        vnode.anchor = cached.anchor;
        var instance = getVaporInstance(vnode);
        var vnodeHookState = ensureVNodeHookState(instance, vnode);
        var rootEl = getRootElement(instance);
        if (rootEl) vnode.el = rootEl;
        if (vnode.dirs && !rootEl) vnode.dirs = null;
        if ((0, $fKAHx.shouldUpdateComponent)(cached, vnode)) {
            vnodeHookState.pendingVNodeUpdate = vnode;
            instance.rawPropsRef.value = filterReservedProps(vnode.props);
            instance.rawSlotsRef.value = normalizeInteropSlots(vnode.children);
            var vnodeBeforeUpdateHook = vnode.props && vnode.props.onVnodeBeforeUpdate;
            if (vnodeBeforeUpdateHook) (0, $fKAHx.callWithAsyncErrorHandling)(vnodeBeforeUpdateHook, parentComponent, 7, [
                vnode,
                cached
            ]);
            if (vnode.ibu) vnode.ibu();
            if (vnode.dirs) (0, $fKAHx.invokeDirectiveHook)(vnode, cached, parentComponent, "beforeUpdate");
            (0, $fKAHx.queuePostFlushCb)(function() {
                syncVNodeEl(vnode, instance);
                if (vnodeHookState.pendingVNodeUpdate === vnode && !instance.isUpdating) vnodeHookState.pendingVNodeUpdate = null;
            });
            (0, $fKAHx.queuePostRenderEffect)(function() {
                if (vnode.dirs) (0, $fKAHx.invokeDirectiveHook)(vnode, cached, parentComponent, "updated");
                var vnodeUpdatedHook = vnode.props && vnode.props.onVnodeUpdated;
                if (vnodeUpdatedHook) (0, $fKAHx.callWithAsyncErrorHandling)(vnodeUpdatedHook, parentComponent, 7, [
                    vnode,
                    cached
                ]);
                if (vnode.iu) vnode.iu();
            }, void 0, parentSuspense);
        }
        activate$1(instance, container, anchor, parentSuspense);
        insert(vnode.anchor, container, anchor);
        var vnodeMountedHook = vnode.props && vnode.props.onVnodeMounted;
        if (vnodeMountedHook) (0, $fKAHx.queuePostRenderEffect)(function() {
            (0, $fKAHx.callWithAsyncErrorHandling)(vnodeMountedHook, parentComponent, 7, [
                vnode
            ]);
        }, void 0, parentSuspense);
    },
    deactivate: function(vnode, container, parentSuspense) {
        var instance = getVaporInstance(vnode);
        deactivate$1(instance, container, parentSuspense);
        insert(vnode.anchor, container);
        (0, $fKAHx.queuePostRenderEffect)(function() {
            var vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
            if (vnodeHook) (0, $fKAHx.callWithAsyncErrorHandling)(vnodeHook, instance.parent, 7, [
                vnode
            ]);
        }, void 0, parentSuspense);
    }
};
var vaporSlotPropsProxyHandler = {
    get: function(target, key) {
        return target.value[key];
    },
    has: function(target, key) {
        return key in target.value;
    },
    ownKeys: function(target) {
        return Reflect.ownKeys(target.value);
    },
    getOwnPropertyDescriptor: function(target, key) {
        if (key in target.value) return {
            enumerable: true,
            configurable: true
        };
    }
};
var vaporSlotWrappersCache = /* @__PURE__ */ new WeakMap();
var vaporSlotsProxyHandler = {
    get: function(target, key) {
        var slot = (0, $6zvdv.isString)(key) && !isInternalSlotKey(key) ? getSlot(target, key) : target[key];
        if ((0, $6zvdv.isFunction)(slot)) {
            slot[0, $fKAHx.rawVaporSlotKey] = slot;
            var wrappers = vaporSlotWrappersCache.get(target);
            if (!wrappers) vaporSlotWrappersCache.set(target, wrappers = /* @__PURE__ */ new Map());
            var cached = wrappers.get(key);
            if (cached && cached.slot === slot) return cached.wrapped;
            var wrapped = function(props) {
                return [
                    (0, $fKAHx.renderSlot)((0, $7Pjls._)({}, key, slot), key, props)
                ];
            };
            wrapped[0, $fKAHx.rawVaporSlotKey] = slot;
            wrapped._n = true;
            wrappers.set(key, {
                slot: slot,
                wrapped: wrapped
            });
            return wrapped;
        }
        return slot;
    },
    ownKeys: function(target) {
        return Array.from(dynamicSlotsProxyHandlers.ownKeys(target)).filter(function(key) {
            return (0, $6zvdv.isString)(key) && !isInternalSlotKey(key);
        });
    },
    getOwnPropertyDescriptor: function(target, key) {
        if (!(0, $6zvdv.isString)(key) || isInternalSlotKey(key)) return;
        return dynamicSlotsProxyHandlers.getOwnPropertyDescriptor(target, key);
    }
};
var vdomHydrateNode;
function resolveVNodeRange(vnode) {
    var type = vnode.type, shapeFlag = vnode.shapeFlag, el = vnode.el, anchor = vnode.anchor;
    if (shapeFlag & 64 && el && anchor && anchor !== el) return [
        el,
        anchor
    ];
    if ((type === (0, $fKAHx.Static) || type === (0, $fKAHx.Fragment)) && anchor) return el && anchor !== el ? [
        el,
        anchor
    ] : [
        anchor,
        anchor
    ];
    if (shapeFlag & 6) {
        var subTree = vnode.component && vnode.component.subTree;
        if (subTree) return resolveVNodeRange(subTree);
    }
}
function resolveVNodeNodes(vnode) {
    if (vnode.component && isVaporComponent(vnode.component)) {
        var block = vnode.component.block;
        if (block) {
            var anchor = vnode.anchor;
            if (anchor) return [
                block,
                anchor
            ];
            return block;
        }
    }
    if (vnode.type === (0, $fKAHx.VaporSlot) && vnode.vb) {
        var el = vnode.el, anchor1 = vnode.anchor, vb = vnode.vb;
        if (!anchor1) return vb;
        return el && el !== anchor1 && isComment(el, "[") ? [
            el,
            vb,
            anchor1
        ] : [
            vb,
            anchor1
        ];
    }
    var vnodeRange = resolveVNodeRange(vnode);
    if (vnodeRange) {
        var nodeRange = [];
        var n = vnodeRange[0];
        while(n){
            nodeRange.push(n);
            if (n === vnodeRange[1]) break;
            n = n.nextSibling;
        }
        return nodeRange;
    }
    if (vnode.shapeFlag & 6) {
        var subTree = vnode.component && vnode.component.subTree;
        if (subTree) return resolveVNodeNodes(subTree);
    }
    return vnode.el;
}
function removeAttachedNodes(block, parent) {
    if (block instanceof Node) {
        if (block.parentNode === parent) remove(block, parent);
    } else if ((0, $6zvdv.isArray)(block)) for(var i = 0; i < block.length; i++)removeAttachedNodes(block[i], parent);
}
function trackFragmentVNodeUpdates(frag, vnode, syncNodes) {
    vnode.ibu = function() {
        if (frag.bu) frag.bu.forEach(function(hook) {
            return hook();
        });
    };
    vnode.iu = function() {
        syncNodes();
        if (frag.u) frag.u.forEach(function(hook) {
            return hook(frag.nodes);
        });
    };
}
/**
* Shared content cell for interop fragments. Hosts write the subset they
* own — do not read a field the host does not maintain (`valid` stays false
* where validity is derived live from the nodes; `nodes` stays EMPTY_BLOCK
* where the fragment's own `nodes` is the snapshot).
*
* `resolved` implements the optimistic-validity rule every interop fragment
* shares: nodes stay unresolved until the first sync (on insert / after
* patch), and validity reports true until then to keep a host boundary from
* mounting its fallback before the content exists. This keeps the common
* (valid) case free — an empty result is corrected later when the resolve
* path notifies the boundary to recheck; starting invalid would instead
* mount-then-teardown the fallback on every interop mount. Hydration starts
* resolved (SSR nodes exist).
*/ var InteropContentState = function InteropContentState() {
    "use strict";
    (0, $173N4._)(this, InteropContentState);
    this.nodes = EMPTY_BLOCK;
    this.valid = false;
    this.resolved = isHydrating$1;
};
function createVNodeFragment(vnode) {
    var frag = createInteropFragment(EMPTY_BLOCK, vnode);
    frag.$key = vnodeKeyOf(vnode);
    var content = new InteropContentState();
    var syncNodes = function() {
        frag.nodes = resolveVNodeNodes(frag.vnode);
        content.resolved = true;
    };
    frag.isBlockValid = function(componentAsValid) {
        return content.resolved ? isValidBlock(frag.nodes, componentAsValid) : true;
    };
    trackFragmentVNodeUpdates(frag, vnode, syncNodes);
    return {
        frag: frag,
        syncNodes: syncNodes
    };
}
/**
* Mount a vnode as a dynamic component branch (`<component :is="vnode">`
* in a vapor template). The KeepAlive lookup, fallthrough and hydration of
* the vnode live here so the dynamic component only sees a block.
*/ function mountDynamicVNode(internals, vnode, parentComponent, isSingleRoot) {
    if (parentComponent && (0, $fKAHx.isKeepAlive)(parentComponent)) {
        var cached = parentComponent.ctx.getCachedComponent(vnode.type, vnode.key);
        if (cached) return cached;
    }
    var owner = resolveFallthroughOwner(isSingleRoot);
    var frag = mountVNode(internals, vnode, parentComponent, owner && function() {
        return resolveFallthroughAttrs(owner);
    });
    if (isHydrating$1) {
        locateHydrationNode(shouldConsumeFragmentStart(vnode) ? createFragmentClaim() : void 0);
        frag.hydrate();
    }
    return frag;
}
function shouldConsumeFragmentStart(vnode) {
    if (vnode.type === (0, $fKAHx.Fragment)) return false;
    if (vnode.shapeFlag & 6) {
        var type = vnode.type;
        return !!type.__vapor && !type.__multiRoot;
    }
    return true;
}
/**
* Mount VNode in vapor
*/ function mountVNode(internals, vnode, parentComponent, getFallthroughAttrs) {
    var suspense = currentRenderContext.suspense || parentComponent && parentComponent.suspense;
    var baseVNode = vnode;
    if (getFallthroughAttrs) vnode = (0, $fKAHx.cloneVNode)(baseVNode, getFallthroughAttrs());
    var _createVNodeFragment = createVNodeFragment(vnode), frag = _createVNodeFragment.frag, syncNodes = _createVNodeFragment.syncNodes;
    var isMounted = false;
    var mountedParentNode;
    var mountedAnchor = null;
    var namespace;
    var isUnmounted = false;
    var unmount = function(parentNode, transition) {
        if (isUnmounted) {
            if (parentNode) {
                removeAttachedNodes(resolveVNodeNodes(vnode), parentNode);
                if (vnode.anchor && vnode.anchor.parentNode === parentNode) remove(vnode.anchor, parentNode);
            }
            return;
        }
        if (transition) (0, $fKAHx.setTransitionHooks)(vnode, transition);
        var parentSuspense = resolveUnmountSuspense(suspense);
        if (vnode.shapeFlag & 256) {
            var keepAliveCtx = parentComponent.ctx;
            keepAliveCtx.clearCurrent(frag);
            var storageContainer = keepAliveCtx.getStorageContainer();
            if (vnode.type.__vapor) {
                deactivate$1(vnode.component, storageContainer, parentSuspense);
                insert(vnode.anchor, storageContainer);
            } else (0, $fKAHx.deactivate)(vnode, storageContainer, internals, parentComponent, parentSuspense);
        } else {
            isUnmounted = true;
            internals.um(vnode, parentComponent, parentSuspense, !!parentNode);
        }
        if (vnode.anchor && parentNode && vnode.anchor.parentNode === parentNode) remove(vnode.anchor, parentNode);
    };
    frag.hydrate = function() {
        if (!isHydrating$1) return;
        hydrateVNode(vnode, parentComponent, frag.slotScopeIds);
        isMounted = true;
        syncNodes();
    };
    var place = function(parentNode, anchor, parentSuspense, transition) {
        var moveType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2;
        if (isHydrating$1) return;
        if (parentSuspense !== void 0) suspense = parentSuspense;
        var operationSuspense = suspense;
        if (vnode.shapeFlag & 512) {
            if (vnode.type.__vapor) {
                activate$1(vnode.component, parentNode, anchor, operationSuspense);
                insert(vnode.anchor, parentNode, anchor);
            } else (0, $fKAHx.activate)(vnode, parentNode, anchor, internals, parentComponent, operationSuspense, void 0, false);
            return;
        } else {
            var prev = (0, $fKAHx.currentInstance);
            (0, $fKAHx.simpleSetCurrentInstance)(parentComponent);
            if (!isMounted) {
                if (transition) (0, $fKAHx.setTransitionHooks)(vnode, transition);
                namespace = (0, $fKAHx.getContainerType)(parentNode);
                internals.p(null, vnode, parentNode, anchor, parentComponent, operationSuspense, namespace, frag.slotScopeIds);
                isMounted = true;
            } else {
                if (transition && moveType !== 2) (0, $fKAHx.setTransitionHooks)(vnode, transition);
                internals.m(vnode, parentNode, anchor, moveType, parentComponent, operationSuspense);
            }
            (0, $fKAHx.simpleSetCurrentInstance)(prev);
            mountedParentNode = parentNode;
            mountedAnchor = anchor;
        }
        syncNodes();
        if (isMounted && frag.u) frag.u.forEach(function(hook) {
            return hook(frag.nodes);
        });
    };
    frag.insert = function(parentNode, anchor, parentSuspense, transition) {
        return place(parentNode, anchor, parentSuspense, transition);
    };
    frag.move = function(parentNode, anchor, moveType, _parentComponent, parentSuspense, transition) {
        return place(parentNode, anchor, parentSuspense, transition, moveType);
    };
    if (getFallthroughAttrs) {
        var applied = false;
        renderEffect(function() {
            var next = (0, $fKAHx.cloneVNode)(baseVNode, getFallthroughAttrs());
            if (!applied) {
                applied = true;
                return;
            }
            if (!isMounted || !mountedParentNode) return;
            var previous = vnode;
            vnode = next;
            trackFragmentVNodeUpdates(frag, vnode, syncNodes);
            frag.vnode = vnode;
            frag.$key = vnodeKeyOf(vnode);
            var prevInstance = (0, $fKAHx.currentInstance);
            (0, $fKAHx.simpleSetCurrentInstance)(parentComponent);
            internals.p(previous, vnode, mountedParentNode, mountedAnchor, parentComponent, suspense, namespace, frag.slotScopeIds);
            (0, $fKAHx.simpleSetCurrentInstance)(prevInstance);
            syncNodes();
        });
    }
    frag.remove = unmount;
    return frag;
}
/**
* Mount vdom component in vapor
*/ function createVDOMComponent(internals, component, parentComponent, rawProps, rawSlots, once) {
    var suspense = currentRenderContext.suspense || parentComponent && parentComponent.suspense;
    var useBridge = shouldUseRendererBridge(component);
    var comp = useBridge ? ensureRendererBridge(component) : component;
    var vnode = (0, $fKAHx.createVNode)(comp, rawProps && (0, $6zvdv.extend)({}, new Proxy(rawProps, rawPropsProxyHandlers)));
    var _createVNodeFragment = createVNodeFragment(vnode), frag = _createVNodeFragment.frag, syncNodes = _createVNodeFragment.syncNodes;
    var keepAliveCtx = isKeepAliveEnabled ? getKeepAliveContext(parentComponent) : null;
    if (keepAliveCtx) {
        keepAliveCtx.processShapeFlag(frag);
        if (component.__asyncLoader) {
            var disposed = false;
            (0, $ftLbb.onScopeDispose)(function() {
                return disposed = true;
            });
            component.__asyncLoader().then(function() {
                if (!disposed) keepAliveCtx.cacheBlock(frag);
            }).catch((0, $6zvdv.NOOP));
        }
    }
    if (!once && component.__asyncLoader && rawSlots && rawSlots.$) renderEffect(function() {
        dynamicSlotsProxyHandlers.ownKeys(rawSlots);
        var instance = vnode.component;
        if (instance && instance.isMounted) instance.update();
    }, true);
    vnode.vi = function(instance) {
        var wrapper = new VaporComponentInstance(useBridge ? comp : {
            props: instance.propsOptions[0],
            __propsOptions: instance.propsOptions
        }, rawProps, rawSlots, parentComponent ? parentComponent.appContext : void 0, once);
        var attrs = (0, $fKAHx.createInternalObject)();
        var isFilteredAttr = function(key) {
            return typeof key === "string" && ((0, $6zvdv.isReservedProp)(key) || (0, $fKAHx.isEmitListener)(instance.emitsOptions, key));
        };
        instance.attrs = new Proxy(attrs, {
            get: function(_, key) {
                if (isFilteredAttr(key)) return;
                return wrapper.attrs[key];
            },
            has: function(_, key) {
                return !isFilteredAttr(key) && key in wrapper.attrs;
            },
            ownKeys: function() {
                return Reflect.ownKeys(wrapper.attrs).filter(function(key) {
                    return !isFilteredAttr(key);
                });
            },
            getOwnPropertyDescriptor: function(_, key) {
                if (!isFilteredAttr(key) && key in wrapper.attrs) return {
                    enumerable: true,
                    configurable: true
                };
            }
        });
        instance.props = vnode.shapeFlag & 2 && !comp.props ? instance.attrs : (0, $ftLbb.shallowReactive)(wrapper.props);
        instance.slots = wrapper.rawSlots === (0, $6zvdv.EMPTY_OBJ) ? (0, $6zvdv.EMPTY_OBJ) : new Proxy(wrapper.rawSlots, vaporSlotsProxyHandler);
        if (component.__asyncLoader && instance.slots !== (0, $6zvdv.EMPTY_OBJ)) {
            vnode.children = instance.slots;
            vnode.shapeFlag |= 32;
        }
    };
    var rawRef = null;
    var isMounted = false;
    var isUnmounted = false;
    var isDomRemoved = false;
    var removeDom = function(parentNode) {
        if (!parentNode || isDomRemoved) return;
        removeAttachedNodes(resolveVNodeNodes(vnode), parentNode);
        isDomRemoved = true;
    };
    var unmount = function(parentNode, transition) {
        if (isUnmounted) {
            if (!transition) removeDom(parentNode);
            return;
        }
        if (rawRef) (0, $fKAHx.setRef)(rawRef, null, null, vnode, true);
        if (transition) (0, $fKAHx.setTransitionHooks)(vnode, transition);
        var parentSuspense = resolveUnmountSuspense(suspense);
        if (vnode.shapeFlag & 256) {
            if (frag.inputScope) frag.inputScope.pause();
            keepAliveCtx.clearCurrent(frag);
            (0, $fKAHx.deactivate)(vnode, keepAliveCtx.getStorageContainer(), internals, parentComponent, parentSuspense);
            return;
        }
        isUnmounted = true;
        isMounted = false;
        if (isKeepAliveEnabled && frag.inputScope) frag.inputScope.stop();
        internals.um(vnode, parentComponent, parentSuspense, !!parentNode);
        if (!transition) removeDom(parentNode);
    };
    frag.hydrate = function() {
        if (!isHydrating$1) return;
        hydrateVNode(vnode, parentComponent, frag.slotScopeIds);
        isMounted = true;
        syncNodes();
    };
    vnode.scopeId = getCurrentScopeId() || null;
    vnode.slotScopeIds = currentRenderContext.slotScopeIds;
    var place = function(parentNode, anchor, parentSuspense, transition) {
        var moveType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2;
        if (isHydrating$1) return;
        if (parentSuspense !== void 0) suspense = parentSuspense;
        var operationSuspense = suspense;
        if (vnode.shapeFlag & 512) {
            if (frag.inputScope) frag.inputScope.resume();
            (0, $fKAHx.activate)(vnode, parentNode, anchor, internals, parentComponent, operationSuspense, void 0, false);
        } else {
            var prev = (0, $fKAHx.currentInstance);
            (0, $fKAHx.simpleSetCurrentInstance)(parentComponent);
            if (!isMounted) {
                if (transition) (0, $fKAHx.setTransitionHooks)(vnode, transition);
                internals.mt(vnode, parentNode, anchor, parentComponent, operationSuspense, (0, $fKAHx.getContainerType)(parentNode), false);
                if (rawRef) (0, $fKAHx.setRef)(rawRef, null, operationSuspense, vnode);
                isMounted = true;
            } else {
                if (transition && moveType !== 2) (0, $fKAHx.setTransitionHooks)(vnode, transition);
                internals.m(vnode, parentNode, anchor, moveType, parentComponent, operationSuspense);
            }
            (0, $fKAHx.simpleSetCurrentInstance)(prev);
        }
        syncNodes();
        if (isMounted && frag.u) frag.u.forEach(function(hook) {
            return hook(frag.nodes);
        });
    };
    frag.insert = function(parentNode, anchor, parentSuspense, transition) {
        return place(parentNode, anchor, parentSuspense, transition);
    };
    frag.move = function(parentNode, anchor, moveType, _parentComponent, parentSuspense, transition) {
        return place(parentNode, anchor, parentSuspense, transition, moveType);
    };
    frag.remove = unmount;
    frag.setRef = function(instance, ref, refFor, refKey) {
        var oldRawRef = rawRef;
        rawRef = (0, $fKAHx.normalizeRef)({
            ref: ref,
            ref_for: refFor,
            ref_key: refKey
        }, instance);
        if (isMounted) {
            if (rawRef) (0, $fKAHx.setRef)(rawRef, oldRawRef, suspense, vnode);
            else if (oldRawRef) (0, $fKAHx.setRef)(oldRawRef, null, null, vnode, true);
        }
    };
    return frag;
}
var rendererBridgeCache = /* @__PURE__ */ new WeakMap();
/**
* Teleport/Suspense are renderer primitives (`__isTeleport` / `__isSuspense`),
* not regular components with their own render pipeline.
*
* We wrap them with a tiny functional bridge so they can pass through the
* interop component mount path while preserving built-in vnode semantics.
*/ function shouldUseRendererBridge(component) {
    return !!(component.__isTeleport || component.__isSuspense);
}
function ensureRendererBridge(component) {
    var bridge = rendererBridgeCache.get(component);
    if (!bridge) rendererBridgeCache.set(component, bridge = function(props, param) {
        var slots = param.slots;
        return (0, $fKAHx.createVNode)(component, props, slots);
    });
    return bridge;
}
function hasValidVNodeContent(vnode) {
    return !!(0, $fKAHx.ensureValidVNode)(vnode.type === (0, $fKAHx.Fragment) && (0, $6zvdv.isArray)(vnode.children) ? vnode.children : [
        vnode
    ]);
}
function isSlotOutletOnlyVNode(vnode) {
    if (vnode.type === (0, $fKAHx.VaporSlot)) return true;
    return vnode.type === (0, $fKAHx.Fragment) && (0, $6zvdv.isArray)(vnode.children) && vnode.children.every(function(child) {
        return (0, $fKAHx.isVNode)(child) && isSlotOutletOnlyVNode(child);
    });
}
function hydrateForwardedEmptySlotFragment(vnode, parentComponent, contentValid) {
    if (vnode.type !== (0, $fKAHx.Fragment) || !(0, $6zvdv.isArray)(vnode.children)) return false;
    var children = vnode.children;
    var inheritedEmptySlotEndAnchor = isComment(currentHydrationNode, "]") && isComment(currentHydrationNode.previousSibling, "[") ? currentHydrationNode : null;
    var slotEndAnchor = getCurrentSlotEndAnchor() || inheritedEmptySlotEndAnchor;
    var slotStartAnchor = slotEndAnchor && slotEndAnchor.previousSibling;
    if (!contentValid && currentHydrationNode === slotEndAnchor && slotStartAnchor && isComment(slotStartAnchor, "[")) {
        vnode.el = slotStartAnchor;
        vnode.anchor = slotEndAnchor;
        advanceHydrationNode(slotEndAnchor);
        return true;
    }
    var isEmptyFragmentStart = isComment(currentHydrationNode, "[");
    var hasSlotOutletChildren = children.length > 0;
    var slotOutletOnlyChildren = children.every(function(child) {
        return (0, $fKAHx.isVNode)(child) && isSlotOutletOnlyVNode(child);
    });
    if (!isEmptyFragmentStart || !contentValid || !hasSlotOutletChildren || !slotOutletOnlyChildren) return false;
    var fragmentStartAnchor = currentHydrationNode;
    var fragmentEndAnchor = locateEndAnchor(fragmentStartAnchor);
    if (!fragmentEndAnchor || fragmentStartAnchor.nextSibling !== fragmentEndAnchor) return false;
    vnode.el = fragmentStartAnchor;
    withHydratingSlotBoundary(function() {
        children.forEach(function(child) {
            hydrateVNode(child, parentComponent);
        });
    });
    vnode.anchor = fragmentEndAnchor;
    if (currentHydrationNode === fragmentEndAnchor) advanceHydrationNode(fragmentEndAnchor);
    return true;
}
function trackSlotVNodeUpdatesWithRefresh(vnode, refresh, beforeUpdate) {
    var track = function(node) {
        if (beforeUpdate) node.ibu = beforeUpdate;
        node.iu = refresh;
        if (node.type === (0, $fKAHx.Fragment) && (0, $6zvdv.isArray)(node.children)) node.children.forEach(function(child) {
            if ((0, $fKAHx.isVNode)(child)) track(child);
        });
    };
    track(vnode);
}
/**
* Construction point for the interop hosts' resolution state — the shared
* bookkeeping fields plus the host-specific hooks. (SlotFragment, the third
* host, implements SlotResolutionState directly as a class.)
*/ function createSlotResolutionState(boundary, hooks) {
    return (0, $6zvdv.extend)({
        boundary: boundary,
        activeFallback: null,
        fallbackInserted: false,
        pendingRecheck: false,
        pendingRecheckForce: false,
        isReconciling: false
    }, hooks);
}
/**
* Exposes `$transition` through the outlet fragment so BaseTransition state
* stays on the fragment; hooks inherited from VDOM BaseTransition are
* filtered out on read because they belong to its own state machine.
* Enumerable + configurable to match an object-literal accessor pair.
*/ function installInteropTransitionAccessor(state, frag) {
    Object.defineProperty(state, "$transition", {
        enumerable: true,
        configurable: true,
        get: function() {
            var transition = frag.$transition;
            return transition && isVaporTransitionHooks(transition) ? transition : void 0;
        },
        set: function(transition) {
            frag.$transition = transition;
        }
    });
}
function renderVDOMSlot(internals, slotsRef, name, props, parentComponent) {
    var options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, $6zvdv.EMPTY_OBJ);
    var fallback = options.fallback, _options_flags = options.flags, flags = _options_flags === void 0 ? 0 : _options_flags, adoptAnchor = options.adoptAnchor;
    var once = !!(flags & 2);
    var sharedFallback = !!(flags & 8);
    var forwarded = (0, $6zvdv.isForwardedSlot)(flags);
    var inheritFallback = (0, $6zvdv.slotInheritsFallback)(flags);
    var notifiesBoundary = (0, $6zvdv.slotNotifiesBoundary)(flags);
    var suspense = currentRenderContext.suspense || parentComponent.suspense;
    var frag = createInteropFragment(EMPTY_BLOCK, null, 128);
    var slotBoundary = frag.slotBoundary;
    var content = new InteropContentState();
    var scope = (0, $ftLbb.effectScope)();
    var localFallback;
    var rendered = null;
    var isMounted = false;
    var currentParentNode = null;
    var slotNamespace;
    var currentAnchor = null;
    var sharedContentStorage;
    var disposed = false;
    var pendingInOutVNode;
    var pendingOutIn;
    var isContentUpdateRecheck = false;
    var slotResolutionState;
    frag.isBlockValid = function(componentAsValid) {
        if (!content.resolved) return true;
        return slotResolutionState.activeFallback ? isValidBlock(slotResolutionState.activeFallback, componentAsValid) : content.valid;
    };
    var boundary = createSlotBoundary(frag, inheritFallback ? slotBoundary : null, function() {
        return localFallback;
    }, function(force) {
        return markSlotResolutionDirty(slotResolutionState, force);
    }, [
        cleanupInvalidContent
    ]);
    var contentBoundary = forwarded || fallback ? boundary : null;
    slotResolutionState = createSlotResolutionState(boundary, {
        getContent: function() {
            return content.nodes;
        },
        getParentNode: function() {
            return currentParentNode;
        },
        getAnchor: function() {
            return currentAnchor;
        },
        isBusy: function() {
            return false;
        },
        isDisposed: function() {
            return disposed;
        },
        isContentValid: function() {
            return content.valid;
        },
        syncNodes: function() {
            frag.nodes = resolveExposedSlotNodes(slotResolutionState);
        },
        notifyExposedValidityChange: function() {
            if (notifiesBoundary && !isContentUpdateRecheck && slotBoundary) slotBoundary.markDirty();
        }
    });
    installInteropTransitionAccessor(slotResolutionState, frag);
    if (sharedFallback && slotBoundary) registerContentInvalid(slotBoundary, parkSharedContent, frag);
    if (notifiesBoundary) trackSlotBoundaryDirtying(frag, sharedFallback ? void 0 : cleanupInvalidContent);
    localFallback = fallback ? once ? function() {
        return withOnce(function() {
            return fallback(internals, parentComponent);
        });
    } : function() {
        return fallback(internals, parentComponent);
    } : void 0;
    var place = function(parentNode, anchor, parentSuspense, moveType) {
        if (isHydrating$1) return;
        if (parentSuspense !== void 0) suspense = parentSuspense;
        if (localFallback && !inheritFallback && !frag.anchor) {
            frag.anchor = resolveFragmentAnchor(adoptAnchor, void 0);
            if (frag.anchor !== adoptAnchor) parentNode.insertBefore(frag.anchor, anchor);
            anchor = frag.anchor;
        }
        var sharedContentParked = !!sharedContentStorage;
        currentParentNode = parentNode;
        currentAnchor = anchor;
        if (!isMounted) {
            slotNamespace = (0, $fKAHx.getContainerType)(parentNode);
            scope.run(render);
            isMounted = true;
        } else {
            if (sharedContentParked) {
                insert(frag.nodes, parentNode, anchor, suspense);
                sharedContentStorage = void 0;
                if (slotResolutionState.activeFallback) slotResolutionState.fallbackInserted = true;
            } else if ((0, $fKAHx.isVNode)(rendered)) internals.m(rendered, parentNode, anchor, moveType === void 0 ? 2 : moveType, parentComponent, suspense);
            else if (rendered) {
                if (moveType === void 0) insert(rendered, parentNode, anchor, suspense);
                else move(rendered, parentNode, anchor, moveType, void 0, suspense);
            }
            if (!sharedContentParked) insertActiveSlotFallback(slotResolutionState, moveType);
        }
        notifyUpdated();
    };
    frag.insert = function(parentNode, anchor, parentSuspense) {
        return place(parentNode, anchor, parentSuspense);
    };
    frag.move = function(parentNode, anchor, moveType, _parentComponent, parentSuspense) {
        return place(parentNode, anchor, parentSuspense, moveType);
    };
    frag.remove = function(parentNode) {
        var storage = sharedContentStorage;
        if (parentNode && !storage) currentParentNode = parentNode;
        scope.stop();
        disposed = true;
        var leavingElement = pendingOutIn && pendingOutIn.leavingElement;
        pendingOutIn = void 0;
        var leave = leavingElement && leavingElement[0, $fKAHx.leaveCbKey];
        if (leave) leave(true);
        if (rendered) removeRenderedContent(rendered, storage || parentNode);
        disposeSlotResolution(slotResolutionState, storage || parentNode);
        if (storage) {
            var anchor = frag.anchor;
            if (anchor && anchor.parentNode === storage) frag.anchor = void 0;
            sharedContentStorage = void 0;
        }
    };
    frag.hydrate = function() {
        if (!isHydrating$1) return;
        var hydrationParent = currentHydrationNode && currentHydrationNode.parentNode;
        scope.run(render);
        if (!currentParentNode) {
            currentAnchor = getCurrentSlotEndAnchor() || currentHydrationNode;
            currentParentNode = currentAnchor.parentNode;
        }
        slotNamespace = (0, $fKAHx.getContainerType)(hydrationParent || currentParentNode);
        if (content.valid && localFallback && !inheritFallback && !frag.anchor) {
            var outletAnchor = claimUntrackedAnchor(/* @__PURE__ */ createTextNode());
            insertUntrackedAnchor(currentParentNode, currentAnchor, outletAnchor);
            frag.anchor = currentAnchor = outletAnchor;
        }
        isMounted = true;
    };
    return frag;
    function cleanupInvalidContent() {
        var pending = pendingInOutVNode;
        if (pending) {
            pendingInOutVNode = void 0;
            var transition = slotResolutionState.$transition;
            var fallback = slotResolutionState.activeFallback;
            if (transition) (0, $fKAHx.prepareTransitionLeave)(pending, fallback && isValidSlot(fallback) ? transition : void 0, transition.props, transition.state, transition.instance, (0, $6zvdv.NOOP));
            internals.um(pending, parentComponent, resolveUnmountSuspense(suspense), true);
            return;
        }
        if (currentParentNode) removeAttachedNodes(content.nodes, currentParentNode);
    }
    function parkSharedContent() {
        if (!currentParentNode || sharedContentStorage) return;
        invalidateExposedSlotContent(slotResolutionState);
        var storage = document.createDocumentFragment();
        var anchor = frag.anchor;
        if (!anchor || anchor.parentNode !== currentParentNode) anchor = /* @__PURE__ */ createTextNode();
        storage.appendChild(anchor);
        insert(frag.nodes, storage, anchor, suspense);
        sharedContentStorage = storage;
        currentParentNode = storage;
        currentAnchor = anchor;
    }
    function notifyUpdated() {
        syncInteropRoot(parentComponent);
        if (isMounted && frag.u) frag.u.forEach(function(hook) {
            return hook(frag.nodes);
        });
    }
    function notifyBeforeUpdate() {
        if (isMounted && frag.bu) frag.bu.forEach(function(hook) {
            return hook();
        });
    }
    function recheckAfterContentUpdate() {
        var forceResolutionRecheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        isContentUpdateRecheck = true;
        try {
            recheckSlotResolution(slotResolutionState, forceResolutionRecheck);
        } finally{
            isContentUpdateRecheck = false;
        }
    }
    function finishContentUpdate() {
        var forceResolutionRecheck = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        recheckAfterContentUpdate(forceResolutionRecheck);
        notifyUpdated();
    }
    function patchSlotVNode(previous, next, slotScopeIds, valid) {
        setVNode(next);
        var refreshSlotVNode = function() {
            var prevValid = content.valid;
            var prevOutput = frag.nodes;
            setRendered(next);
            recheckAfterContentUpdate();
            if (content.valid !== prevValid || !isSameResolvedOutput(prevOutput, frag.nodes)) notifyUpdated();
        };
        trackSlotVNodeUpdatesWithRefresh(next, refreshSlotVNode, notifyBeforeUpdate);
        internals.p(previous, next, currentParentNode, currentAnchor, parentComponent, suspense, slotNamespace, concatInteropScopeIds(frag.slotScopeIds, slotScopeIds));
        setRendered(next, valid);
        finishContentUpdate();
    }
    function removeRenderedContent(renderedContent, parentNode) {
        var contentDetached = !!slotResolutionState.activeFallback;
        if ((0, $fKAHx.isVNode)(renderedContent)) internals.um(renderedContent, parentComponent, resolveUnmountSuspense(suspense), !contentDetached && !!parentNode);
        else remove(renderedContent, contentDetached ? void 0 : parentNode);
    }
    function resumeOutIn() {
        (0, $fKAHx.queuePostFlushCb)(function() {
            var pending = pendingOutIn;
            pendingOutIn = void 0;
            if (!pending || disposed || !currentParentNode) return;
            var pendingContent = pending.content;
            if ((0, $fKAHx.isVNode)(pendingContent)) {
                var nextVNode = prepareInteropSlotTransition(frag, pendingContent, forwarded, void 0, (0, $6zvdv.NOOP)) || pendingContent;
                patchSlotVNode(pending.placeholder, nextVNode, pendingContent.slotScopeIds, pending.contentValid);
            } else {
                setVNode(null);
                if (pending.placeholder) removeRenderedContent(pending.placeholder, currentParentNode);
                if (pendingContent) insert(pendingContent, currentParentNode, currentAnchor, suspense);
                setRendered(pendingContent || null, pending.contentValid);
                finishContentUpdate();
            }
        });
    }
    function render() {
        var prev = (0, $fKAHx.currentInstance);
        (0, $fKAHx.simpleSetCurrentInstance)(frag.renderInstance);
        try {
            once ? renderContent() : renderEffect(renderContent);
        } finally{
            (0, $fKAHx.simpleSetCurrentInstance)(prev);
        }
    }
    function renderContent() {
        notifyBeforeUpdate();
        withRenderContext(frag.ctx, function() {
            return withSlotBoundary(contentBoundary, function() {
                var _resolveSlotContent = resolveSlotContent(), slotContent = _resolveSlotContent.content, slotContentValid = _resolveSlotContent.valid;
                if (isHydrating$1) {
                    hydrateContent(slotContent, slotContentValid);
                    return;
                }
                if (pendingOutIn) {
                    pendingOutIn.content = slotContent;
                    pendingOutIn.contentValid = slotContentValid;
                    return;
                }
                if ((0, $fKAHx.isVNode)(slotContent)) {
                    applyVNodeContent(slotContent, slotContentValid);
                    return;
                }
                if (slotContent) {
                    applyBlockContent(slotContent, slotContentValid);
                    return;
                }
                applyEmptyContent();
            });
        });
    }
    function resolveSlotContent() {
        var slotContent;
        var slotContentValid = false;
        if (slotsRef.value) {
            var renderContent = function() {
                return (0, $fKAHx.renderSlot)(slotsRef.value, (0, $6zvdv.isFunction)(name) ? name() : name, props);
            };
            slotContent = once ? withOnce(renderContent) : renderContent();
            if ((0, $fKAHx.isVNode)(slotContent)) {
                if (slotContent.type === (0, $fKAHx.Fragment)) {
                    var children = slotContent.children;
                    (0, $fKAHx.ensureVaporSlotFallback)(children, localFallback);
                    slotContentValid = hasValidVNodeContent(slotContent);
                } else slotContentValid = true;
            } else if (slotContent) slotContentValid = isValidSlot(slotContent);
        }
        return {
            content: slotContent,
            valid: slotContentValid
        };
    }
    function applyVNodeContent(slotContent, slotContentValid) {
        var prevRendered = rendered;
        var transition = slotResolutionState.$transition;
        var mode = transition && transition.props.mode;
        var delayedLeaveSource;
        if (slotResolutionState.activeFallback && !slotContentValid) {
            applyEmptyContent();
            return;
        }
        if (slotResolutionState.activeFallback && slotContentValid && transition) {
            if (mode === "out-in") {
                var fallback = slotResolutionState.activeFallback;
                var leavingBlock = fallback && findTransitionBlock(fallback);
                pendingOutIn = {
                    content: slotContent,
                    placeholder: null,
                    contentValid: true,
                    leavingElement: leavingBlock && getTransitionElement(leavingBlock)
                };
                if (leaveSlotFallback(slotResolutionState, transition, resumeOutIn)) return;
                pendingOutIn = void 0;
            } else if (mode === "in-out") {
                var enterHooks = (0, $6zvdv.extend)({}, transition);
                delete enterHooks.delayedLeave;
                leaveSlotFallback(slotResolutionState, enterHooks, (0, $6zvdv.NOOP));
                delayedLeaveSource = enterHooks;
            }
        }
        var prevIsVNode = (0, $fKAHx.isVNode)(prevRendered);
        var prevVNode = prevIsVNode && (!slotResolutionState.activeFallback || content.valid) ? prevRendered : null;
        if (prevVNode && !slotContentValid && transition && hasSlotFallback(boundary)) {
            if (mode === "out-in") {
                var placeholder = prepareInteropSlotTransition(frag, slotContent, forwarded, void 0, (0, $6zvdv.NOOP)) || (0, $fKAHx.createCommentVNode)();
                if ((0, $fKAHx.prepareTransitionLeave)(prevVNode, void 0, transition.props, transition.state, transition.instance, resumeOutIn)) {
                    suspendForOutIn(prevVNode, placeholder, slotContent, false);
                    return;
                }
            } else if (mode === "in-out") {
                pendingInOutVNode = prevVNode;
                setVNode(null);
                setRendered(null);
                finishContentUpdate();
                return;
            }
        }
        var transitionChild = prepareInteropSlotTransition(frag, slotContent, forwarded, prevVNode || void 0, resumeOutIn, delayedLeaveSource);
        var nextVNode = transitionChild || slotContent;
        if (prevVNode && transitionChild && transition && transition.state.isLeaving) {
            suspendForOutIn(prevVNode, nextVNode, slotContent, slotContentValid);
            return;
        }
        if (prevRendered && !prevIsVNode) removeRenderedContent(prevRendered, currentParentNode);
        patchSlotVNode(prevVNode, nextVNode, slotContent.slotScopeIds, slotContentValid);
    }
    function applyBlockContent(slotContent, slotContentValid) {
        setVNode(null);
        var prevRendered = rendered;
        if (prevRendered) removeRenderedContent(prevRendered, currentParentNode);
        insert(slotContent, currentParentNode, currentAnchor, suspense);
        setRendered(slotContent, slotContentValid);
        finishContentUpdate();
    }
    function applyEmptyContent() {
        if (rendered) removeRenderedContent(rendered, currentParentNode);
        setVNode(null);
        setRendered(null);
        finishContentUpdate();
    }
    function setVNode(vnode) {
        frag.vnode = vnode;
        frag.$key = vnode ? getVNodeKey(vnode) : void 0;
    }
    /** Commit rendered output, deriving the content nodes and validity. */ function setRendered(renderedContent, knownValid) {
        rendered = renderedContent;
        if ((0, $fKAHx.isVNode)(renderedContent)) {
            content.nodes = resolveVNodeNodes(renderedContent);
            content.valid = knownValid === void 0 ? hasValidVNodeContent(renderedContent) : knownValid;
        } else if (renderedContent) {
            content.nodes = renderedContent;
            content.valid = knownValid === void 0 ? isValidSlot(renderedContent) : knownValid;
        } else {
            content.nodes = EMPTY_BLOCK;
            content.valid = false;
        }
        content.resolved = true;
    }
    function suspendForOutIn(prevVNode, placeholder, slotContent, contentValid) {
        pendingOutIn = {
            content: slotContent,
            placeholder: placeholder,
            contentValid: contentValid,
            leavingElement: getInteropTransitionElement(prevVNode)
        };
        setVNode(placeholder);
        rendered = placeholder;
        internals.p(prevVNode, placeholder, currentParentNode, currentAnchor, parentComponent, suspense, slotNamespace, null);
    }
    /**
	* One-shot hydration claimer: adopts the SSR-rendered slot range —
	* content, a local-fallback candidate range, or a deferred shared-fallback
	* decision — instead of mounting. Runs only on the first render pass under
	* an active hydration cursor; later passes take the CSR paths above.
	*/ function hydrateContent(slotContent, slotContentValid) {
        if (!isHydrating$1) return;
        if (slotContentValid && isPendingSlotContent()) resolvePendingSlotContent();
        var contentStart = currentHydrationNode;
        var contentEnd = locateFragmentEnd(contentStart);
        var slotEnd = getCurrentSlotEndAnchor();
        var candidateEnd = contentEnd && contentEnd !== slotEnd ? contentEnd : null;
        var deferSharedContent = sharedFallback && !slotContentValid && isPendingSlotContent();
        var localFallbackOwnsRange = !!(!inheritFallback && !slotContentValid && !deferSharedContent && localFallback && candidateEnd);
        var hydratedContent = !deferSharedContent && slotContent && (slotContentValid || !hasSlotFallback(boundary)) ? slotContent : void 0;
        if ((0, $fKAHx.isVNode)(hydratedContent)) {
            var hydrationVNode = prepareInteropSlotTransition(frag, hydratedContent, forwarded, void 0, (0, $6zvdv.NOOP)) || hydratedContent;
            setVNode(hydrationVNode);
            var refreshSlotVNode = function() {
                frag.nodes = resolveVNodeNodes(hydrationVNode);
                notifyUpdated();
            };
            trackSlotVNodeUpdatesWithRefresh(hydrationVNode, refreshSlotVNode, notifyBeforeUpdate);
            var hydrationParent = /* @__PURE__ */ parentNode(currentHydrationNode);
            if (!hydrateForwardedEmptySlotFragment(hydrationVNode, parentComponent, slotContentValid)) hydrateVNode(hydrationVNode, parentComponent, concatInteropScopeIds(frag.slotScopeIds, hydrationVNode === hydratedContent ? null : hydratedContent.slotScopeIds));
            currentParentNode = hydrationParent;
            currentAnchor = internals.n(hydrationVNode);
            setRendered(hydrationVNode, slotContentValid);
        } else if (hydratedContent) {
            setVNode(null);
            setRendered(hydratedContent, slotContentValid);
        } else {
            setVNode(null);
            setRendered(null);
        }
        if (deferSharedContent && localFallback && candidateEnd) withPendingHydratingSlotBoundary(function() {
            return finishContentUpdate(true);
        });
        else if (localFallbackOwnsRange) {
            withHydratingSlotBoundary(function() {
                return finishContentUpdate(true);
            });
            frag.anchor = currentAnchor = claimAnchor(candidateEnd);
            currentParentNode = candidateEnd.parentNode;
            advanceHydrationNode(candidateEnd);
        } else finishContentUpdate(true);
        var exposedValid = isValidSlot(frag.nodes);
        if (deferSharedContent && exposedValid && candidateEnd) {
            frag.anchor = currentAnchor = claimAnchor(candidateEnd);
            currentParentNode = candidateEnd.parentNode;
        }
        if (sharedFallback && exposedValid && candidateEnd && currentHydrationNode === candidateEnd) advanceHydrationNode(candidateEnd);
        else if (deferSharedContent && !exposedValid) {
            if (candidateEnd && currentHydrationNode === candidateEnd) advanceHydrationNode(candidateEnd);
            var anchor = claimUntrackedAnchor(/* @__PURE__ */ createTextNode());
            var detachedParent = document.createDocumentFragment();
            detachedParent.appendChild(anchor);
            currentParentNode = detachedParent;
            currentAnchor = anchor;
            claimPrecedingFragmentClose(slotEnd);
            var attachAnchor = createDeferredSlotAttach(contentStart, slotEnd, anchor, candidateEnd, function(candidate) {
                frag.anchor = currentAnchor = claimAnchor(candidate);
                if (currentHydrationNode === contentStart) advanceHydrationNode(candidate);
                return currentAnchor;
            }, function() {
                return frag.nodes;
            }, function(parent) {
                currentParentNode = parent;
            });
            if (!queuePendingSlotContentAnchor({
                onContent: function() {
                    attachAnchor();
                    if (!candidateEnd) (0, $fKAHx.queuePostFlushCb)(function() {
                        if (!disposed) frag.anchor = anchor;
                    });
                },
                onFallback: function() {
                    frag.anchor = anchor;
                }
            })) (0, $fKAHx.queuePostFlushCb)(function() {
                attachAnchor();
                if (!disposed && !candidateEnd) frag.anchor = anchor;
            });
        }
    }
}
function needsHostParentForRemove(block) {
    if (isVaporComponent(block)) return (0, $fKAHx.isKeepAlive)(block) || needsHostParentForRemove(block.block);
    if ((0, $6zvdv.isArray)(block)) return block.some(needsHostParentForRemove);
    if (isFragment(block)) return needsHostParentForRemove(block.nodes);
    return false;
}
var vaporInteropPlugin = function(app) {
    enableSuspense();
    setInteropEnabled();
    setPublishInteropScopeIds(publishVaporScopeIds);
    app._context.vapor = vaporInteropImpl;
    var internals = (0, $3ewO8.ensureRenderer)().internals;
    app._context.vdom = {
        mount: createVDOMComponent.bind(null, internals),
        slot: renderVDOMSlot.bind(null, internals),
        mountVNode: mountDynamicVNode.bind(null, internals)
    };
    var mount = app.mount;
    app.mount = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        optimizePropertyLookup();
        return mount.apply(void 0, (0, $aUGqu._)(args));
    };
};
function hydrateVNode(vnode, parentComponent) {
    var slotScopeIds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var node = currentHydrationNode;
    if (!vdomHydrateNode) vdomHydrateNode = (0, $3ewO8.ensureHydrationRenderer)().hydrateNode;
    var nextNode = vdomHydrateNode(node, vnode, parentComponent, null, slotScopeIds, false);
    if (nextNode) setCurrentHydrationNode(nextNode);
    else advanceHydrationNode(node);
}
function createFallback(fallback, parentComponent, isVNodeFallback) {
    var internals = (0, $3ewO8.ensureRenderer)().internals;
    return function() {
        if (isVNodeFallback()) {
            var frag = createVNodeChildrenFragment(internals, function() {
                var children = fallback();
                return children == null ? EMPTY_VNODES : normalizeInteropSlotValue(children);
            }, parentComponent);
            if (isHydrating$1 && frag.hydrate) frag.hydrate();
            return frag;
        }
        return fallback();
    };
}
var renderEmptyVNodes = function() {
    return EMPTY_VNODES;
};
function resolveInteropVaporSlotState(vnode) {
    var slot = vnode.vs;
    var state = slot.state;
    if (!state) {
        state = {
            localFallback: (0, $ftLbb.shallowRef)(slot.fallback),
            outletFallback: (0, $ftLbb.shallowRef)(slot.outletFallback)
        };
        slot.state = state;
    }
    return state;
}
function syncInteropVaporSlotState(n1, n2) {
    var prevState = n1.vs.state;
    if (!prevState) return;
    n2.vs.state = prevState;
    prevState.localFallback.value = n2.vs.fallback;
    prevState.outletFallback.value = n2.vs.outletFallback;
}
function trackInteropFallbackChanges(scope, state, onChange) {
    if (!scope) return;
    var trackedLocalFallback;
    var trackedOutletFallback;
    var initialized = false;
    scope.run(function() {
        renderEffect(function() {
            var nextLocalFallback = state.localFallback.value;
            var nextOutletFallback = state.outletFallback.value;
            if (!initialized) {
                trackedLocalFallback = nextLocalFallback;
                trackedOutletFallback = nextOutletFallback;
                initialized = true;
                return;
            }
            if (trackedLocalFallback === nextLocalFallback && trackedOutletFallback === nextOutletFallback) return;
            trackedLocalFallback = nextLocalFallback;
            trackedOutletFallback = nextOutletFallback;
            onChange();
        }, true);
    });
}
function renderVaporSlot(vnode, parentComponent, parentSuspense, contextSlotScopeIds) {
    var prev = (0, $fKAHx.currentInstance);
    var prevCtx = currentRenderContext;
    (0, $fKAHx.simpleSetCurrentInstance)(parentComponent);
    if (isSuspenseEnabled && parentSuspense) setRenderContext(deriveSuspense(prevCtx, parentSuspense));
    try {
        if (!vnode.vs || !vnode.vs.slot) return EMPTY_BLOCK;
        var slotState = resolveInteropVaporSlotState(vnode);
        var frag = createInteropFragment(EMPTY_BLOCK, null, 128);
        frag.ctx = deriveSlotScopeIds(frag.ctx, getInteropVaporSlotScopeIds(vnode, parentComponent, contextSlotScopeIds));
        var content = new InteropContentState();
        frag.isBlockValid = function(componentAsValid) {
            return content.resolved ? isValidBlock(frag.nodes, componentAsValid) : true;
        };
        var slotBoundary = frag.slotBoundary;
        var isResolvingContent = false;
        var localFallback;
        var outletFallback;
        var currentParentNode = null;
        var currentAnchor = null;
        var disposed = false;
        var slotResolutionState;
        var ownedSlotFragment;
        var ownedSlotFragmentDirtyQueued = false;
        var ownedSlotFragmentDirtyForce = false;
        var onContentInvalid = [
            function() {
                if (currentParentNode) removeAttachedNodes(content.nodes, currentParentNode);
            }
        ];
        var markInteropSlotResolutionDirty = function(force) {
            var target = ownedSlotFragment;
            if (!target) {
                markSlotResolutionDirty(slotResolutionState, force);
                return;
            }
            ownedSlotFragmentDirtyForce = ownedSlotFragmentDirtyForce || !!force;
            if (ownedSlotFragmentDirtyQueued) return;
            ownedSlotFragmentDirtyQueued = true;
            (0, $fKAHx.queuePostFlushCb)(function() {
                ownedSlotFragmentDirtyQueued = false;
                var _$force = ownedSlotFragmentDirtyForce;
                ownedSlotFragmentDirtyForce = false;
                markSlotResolutionDirty(target, _$force);
            });
        };
        var localFallbackBoundary = createSlotBoundary(frag, createSlotBoundary(frag, slotBoundary, function() {
            return slotState.outletFallback.value ? outletFallback : void 0;
        }, markInteropSlotResolutionDirty), function() {
            return slotState.localFallback.value ? localFallback : void 0;
        }, markInteropSlotResolutionDirty, onContentInvalid);
        slotResolutionState = createSlotResolutionState(localFallbackBoundary, {
            getContent: function() {
                return content.nodes;
            },
            getParentNode: function() {
                return currentParentNode;
            },
            getAnchor: function() {
                return currentAnchor;
            },
            isBusy: function() {
                return isResolvingContent;
            },
            isDisposed: function() {
                return disposed;
            },
            isContentValid: function() {
                return isValidSlot(content.nodes);
            },
            syncNodes: function() {
                frag.nodes = resolveExposedSlotNodes(slotResolutionState);
                content.resolved = true;
            },
            notifyExposedValidityChange: function() {
                if (slotBoundary) slotBoundary.markDirty();
            }
        });
        var takePendingRecheck = function() {
            var force = slotResolutionState.pendingRecheckForce;
            slotResolutionState.pendingRecheck = false;
            slotResolutionState.pendingRecheckForce = false;
            return force;
        };
        var dispose = function(parentNode) {
            if (disposed) return;
            if (parentNode) currentParentNode = parentNode;
            disposed = true;
            disposeSlotResolution(slotResolutionState, parentNode);
            currentParentNode = null;
            currentAnchor = null;
        };
        try {
            localFallback = createFallback(function() {
                return (slotState.localFallback.value || renderEmptyVNodes)();
            }, parentComponent, function() {
                return !!slotState.localFallback.value && !!slotState.localFallback.value[0, $fKAHx.vdomSlotFallbackKey];
            });
            outletFallback = createFallback(function() {
                return (slotState.outletFallback.value || renderEmptyVNodes)();
            }, parentComponent, function() {
                return !!slotState.outletFallback.value && !!slotState.outletFallback.value[0, $fKAHx.vdomSlotFallbackKey];
            });
            var hasInteropFallback = !!slotState.localFallback.value || !!slotState.outletFallback.value;
            slotResolutionState.pendingRecheck = false;
            slotResolutionState.pendingRecheckForce = false;
            var pending = INERT_PENDING_SLOT_CONTENT;
            var finalizeResolvedContent = function(resolvedContent) {
                if (hasInteropFallback && isSlotResolver(resolvedContent)) {
                    pending.finish(true);
                    return resolvedContent;
                }
                content.nodes = resolvedContent || EMPTY_BLOCK;
                pending.finish(isValidSlot(content.nodes));
                recheckSlotResolution(slotResolutionState, takePendingRecheck());
                return resolvedContent;
            };
            var resolvedContent;
            isResolvingContent = true;
            try {
                if (isHydrating$1) resolvedContent = withHydratingSlotBoundary(function() {
                    pending = startPendingSlotContentGuard(hasSlotFallback(localFallbackBoundary), currentHydrationNode);
                    try {
                        return finalizeResolvedContent(withRenderContext(frag.ctx, function() {
                            var renderSlot = function() {
                                return withSlotBoundary(localFallbackBoundary, function() {
                                    return invokeVaporSlot(vnode);
                                });
                            };
                            return renderSlot();
                        }));
                    } finally{
                        pending.settle();
                    }
                });
                else resolvedContent = finalizeResolvedContent(withRenderContext(frag.ctx, function() {
                    return withSlotBoundary(localFallbackBoundary, function() {
                        return invokeVaporSlot(vnode);
                    });
                }));
            } finally{
                isResolvingContent = false;
            }
            if (hasInteropFallback && isSlotResolver(resolvedContent)) {
                ownedSlotFragment = resolvedContent;
                trackInteropFallbackChanges(vnode.vs.scope, slotState, function() {
                    return markInteropSlotResolutionDirty();
                });
                dispose();
                return resolvedContent;
            }
            slotResolutionState.pendingRecheck = false;
            slotResolutionState.pendingRecheckForce = false;
            frag.insert = function(parentNode, anchor, parentSuspense) {
                currentParentNode = parentNode;
                currentAnchor = anchor;
                if (slotResolutionState.activeFallback) insertActiveSlotFallback(slotResolutionState);
                else insert(frag.nodes, parentNode, anchor, parentSuspense);
            };
            frag.move = function(parentNode, anchor, moveType, parentComponent, parentSuspense) {
                currentParentNode = parentNode;
                currentAnchor = anchor;
                if (slotResolutionState.activeFallback) insertActiveSlotFallback(slotResolutionState, moveType);
                else move(frag.nodes, parentNode, anchor, moveType, parentComponent, parentSuspense);
            };
            frag.remove = function(parentNode) {
                if (!slotResolutionState.activeFallback) remove(frag.nodes, parentNode);
                dispose(parentNode);
            };
            trackInteropFallbackChanges(vnode.vs.scope, slotState, function() {
                recheckSlotResolution(slotResolutionState, true);
            });
            if (isHydrating$1 && currentHydrationNode) {
                currentAnchor = currentHydrationNode;
                currentParentNode = currentAnchor.parentNode;
            }
            return frag;
        } catch (e) {
            dispose(currentParentNode || void 0);
            stopVaporSlotScope(vnode);
            throw e;
        }
    } finally{
        setRenderContext(prevCtx);
        (0, $fKAHx.simpleSetCurrentInstance)(prev);
    }
}
function stopVaporSlotScope(vnode) {
    if (vnode.vs && vnode.vs.scope) {
        vnode.vs.scope.stop();
        vnode.vs.scope = void 0;
    }
}
/**
* Slot functions can create renderEffects while evaluating their block.
* Those effects live in this dedicated scope so slot re-mount/unmount can
* dispose them immediately instead of waiting for the parent component.
*/ function invokeVaporSlot(vnode) {
    var propsRef = vnode.vs.ref = (0, $ftLbb.shallowRef)(vnode.props);
    var scope = (0, $ftLbb.effectScope)();
    vnode.vs.scope = scope;
    try {
        var run = function() {
            return vnode.vs.slot(new Proxy(propsRef, vaporSlotPropsProxyHandler));
        };
        return inOnce ? withOnce(function() {
            return scope.run(run);
        }, false) : scope.run(run);
    } catch (e) {
        vnode.vs.scope = void 0;
        scope.stop();
        throw e;
    }
}
function resolveInteropRootEl(instance) {
    return getRootElement(instance, {
        onDynamicFragment: function(frag) {
            return registerInteropRootSync(instance, frag);
        }
    });
}
function syncVNodeEl(vnode, instance) {
    var rootEl = resolveInteropRootEl(instance);
    if (rootEl) vnode.el = rootEl;
    else {
        vnode.el = vnode.anchor;
        vnode.dirs = null;
    }
}
function syncInteropRoot(instance) {
    var state = vnodeHookStateMap.get(instance);
    if (!state) return;
    syncVNodeEl(state.vnode, instance);
}
var vnodeHookStateMap = /* @__PURE__ */ new WeakMap();
function ensureVNodeHookState(instance, vnode) {
    instance.interopVNode = vnode;
    var state = vnodeHookStateMap.get(instance);
    if (!state) {
        state = {
            vnode: vnode,
            pendingVNodeUpdate: null
        };
        vnodeHookStateMap.set(instance, state);
        (instance.bu || (instance.bu = [])).push(function() {
            if (state.pendingVNodeUpdate) return;
            var vnodeHook = state.vnode.props && state.vnode.props.onVnodeBeforeUpdate;
            if (vnodeHook) (0, $fKAHx.callWithAsyncErrorHandling)(vnodeHook, instance.parent, 7, [
                state.vnode,
                state.vnode
            ]);
            if (state.vnode.ibu) state.vnode.ibu();
        });
        (instance.u || (instance.u = [])).unshift(function() {
            return syncInteropRoot(instance);
        });
        instance.u.push(function() {
            if (state.pendingVNodeUpdate) {
                state.pendingVNodeUpdate = null;
                return;
            }
            var vnodeHook = state.vnode.props && state.vnode.props.onVnodeUpdated;
            if (vnodeHook) (0, $fKAHx.callWithAsyncErrorHandling)(vnodeHook, instance.parent, 7, [
                state.vnode,
                state.vnode
            ]);
            if (state.vnode.iu) state.vnode.iu();
        });
    } else state.vnode = vnode;
    return state;
}
function createVNodeChildrenFragment(internals, render, parentComponent) {
    var suspense = currentRenderContext.suspense || parentComponent && parentComponent.suspense;
    var frag = createInteropFragment();
    var content = new InteropContentState();
    frag.isBlockValid = function() {
        return content.resolved ? content.valid : true;
    };
    var currentVNode = null;
    var currentChildren = EMPTY_VNODES;
    var currentParentNode = null;
    var childrenNamespace;
    var currentAnchor = null;
    var isMounted = false;
    var isRenderEffectStarted = false;
    var scope = (0, $ftLbb.effectScope)();
    var cleanupInvalidContent = function() {
        if (currentParentNode) removeAttachedNodes(frag.nodes, currentParentNode);
    };
    if (frag.slotBoundary) registerContentInvalid(frag.slotBoundary, cleanupInvalidContent, frag);
    var syncResolvedNodes = function() {
        var children = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : currentChildren;
        var prevValid = content.resolved ? content.valid : true;
        content.valid = !!(0, $fKAHx.ensureValidVNode)(children);
        if (children.length === 0) frag.nodes = EMPTY_BLOCK;
        else if (children.length === 1) frag.nodes = resolveVNodeNodes(children[0]);
        else frag.nodes = children.map(resolveVNodeNodes);
        content.resolved = true;
        return prevValid !== content.valid;
    };
    var syncResolvedNodesAndCleanup = function() {
        var children = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : currentChildren;
        var validityChanged = syncResolvedNodes(children);
        if (!content.valid && frag.slotBoundary) {
            cleanupInvalidContent();
            currentVNode = null;
            currentChildren = EMPTY_VNODES;
        }
        return validityChanged;
    };
    var notifyUpdated = function() {
        var validityChanged = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (validityChanged && frag.slotBoundary) frag.slotBoundary.markDirty();
        if (isMounted && frag.u) frag.u.forEach(function(hook) {
            return hook(frag.nodes);
        });
    };
    var notifyBeforeUpdate = function() {
        if (isMounted && frag.bu) frag.bu.forEach(function(hook) {
            return hook();
        });
    };
    var renderContent = function() {
        var prev = (0, $fKAHx.currentInstance);
        (0, $fKAHx.simpleSetCurrentInstance)(parentComponent);
        try {
            renderEffect(function() {
                withRenderContext(frag.ctx, function() {
                    var nextChildren = render();
                    notifyBeforeUpdate();
                    if (isHydrating$1) {
                        nextChildren.forEach(function(vnode) {
                            return hydrateVNode(vnode, parentComponent, frag.slotScopeIds);
                        });
                        currentChildren = nextChildren;
                        currentVNode = (0, $fKAHx.createVNode)((0, $fKAHx.Fragment), null, nextChildren);
                        currentParentNode = currentHydrationNode.parentNode;
                        childrenNamespace = (0, $fKAHx.getContainerType)(currentParentNode);
                        currentAnchor = currentHydrationNode;
                        if (frag.slotBoundary && currentAnchor && isClaimedAnchor(currentAnchor) && currentAnchor !== getCurrentSlotEndAnchor() && currentAnchor.nextSibling) currentAnchor = currentAnchor.nextSibling;
                    } else if (!isMounted) {
                        currentChildren = nextChildren;
                        currentVNode = (0, $fKAHx.createVNode)((0, $fKAHx.Fragment), null, nextChildren);
                        var wasResolved = content.resolved;
                        var validityChanged = syncResolvedNodes(nextChildren);
                        if (wasResolved) notifyUpdated(validityChanged);
                        return;
                    } else if (!currentVNode) {
                        currentChildren = nextChildren;
                        currentVNode = (0, $fKAHx.createVNode)((0, $fKAHx.Fragment), null, nextChildren);
                        trackSlotVNodeUpdatesWithRefresh(currentVNode, function() {
                            notifyUpdated(syncResolvedNodesAndCleanup(nextChildren));
                        }, notifyBeforeUpdate);
                        if (nextChildren.length) internals.mc(nextChildren, currentParentNode, currentAnchor, parentComponent, suspense, childrenNamespace, frag.slotScopeIds, false);
                    } else {
                        var nextVNode = (0, $fKAHx.createVNode)((0, $fKAHx.Fragment), null, nextChildren);
                        trackSlotVNodeUpdatesWithRefresh(nextVNode, function() {
                            notifyUpdated(syncResolvedNodesAndCleanup(nextChildren));
                        }, notifyBeforeUpdate);
                        internals.pc(currentVNode, nextVNode, currentParentNode, currentAnchor, parentComponent, suspense, childrenNamespace, frag.slotScopeIds, false);
                        currentChildren = nextChildren;
                        currentVNode = nextVNode;
                    }
                    var validityChanged1 = syncResolvedNodesAndCleanup();
                    if (isHydrating$1) {
                        if (isMounted && frag.u) frag.u.forEach(function(hook) {
                            return hook(frag.nodes);
                        });
                    } else notifyUpdated(validityChanged1);
                });
            });
        } finally{
            (0, $fKAHx.simpleSetCurrentInstance)(prev);
        }
    };
    var startRenderEffect = function() {
        if (isRenderEffectStarted) return;
        isRenderEffectStarted = true;
        scope.run(renderContent);
    };
    if (!isHydrating$1) startRenderEffect();
    var place = function(parentNode, anchor, parentSuspense) {
        var moveType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2;
        if (isHydrating$1) return;
        if (parentSuspense !== void 0) suspense = parentSuspense;
        currentParentNode = parentNode;
        currentAnchor = anchor;
        if (!isMounted) {
            childrenNamespace = (0, $fKAHx.getContainerType)(parentNode);
            startRenderEffect();
            if (currentVNode) trackSlotVNodeUpdatesWithRefresh(currentVNode, function() {
                notifyUpdated(syncResolvedNodesAndCleanup(currentChildren));
            }, notifyBeforeUpdate);
            if (currentChildren.length) internals.mc(currentChildren, currentParentNode, currentAnchor, parentComponent, suspense, childrenNamespace, frag.slotScopeIds, false);
            syncResolvedNodes();
            isMounted = true;
        } else currentChildren.forEach(function(vnode) {
            internals.m(vnode, parentNode, anchor, moveType, parentComponent, suspense);
        });
    };
    frag.insert = function(parentNode, anchor, parentSuspense) {
        return place(parentNode, anchor, parentSuspense);
    };
    frag.move = function(parentNode, anchor, moveType, _parentComponent, parentSuspense) {
        return place(parentNode, anchor, parentSuspense, moveType);
    };
    frag.remove = function(parentNode) {
        scope.stop();
        var parentSuspense = resolveUnmountSuspense(suspense);
        currentChildren.forEach(function(vnode) {
            internals.um(vnode, parentComponent, parentSuspense, !!parentNode);
        });
    };
    frag.hydrate = function() {
        if (!isHydrating$1) return;
        startRenderEffect();
        isMounted = true;
    };
    return frag;
}
function isSameResolvedOutput(prev, next) {
    return prev === next || (0, $6zvdv.isArray)(prev) && (0, $6zvdv.isArray)(next) && prev.length === next.length && prev.every(function(node, index) {
        return node === next[index];
    });
}
function normalizeInteropSlots(rawSlots) {
    var _loop = function(key) {
        if (isInternalSlotKey(key)) return "continue";
        var slot = rawSlots[key];
        if ((0, $6zvdv.isFunction)(slot)) normalized[key] = slot[0, $fKAHx.rawVaporSlotKey] || slot._n ? slot : normalizeInteropSlot(slot, rawSlots._ctx);
        else if (slot != null) normalized[key] = function() {
            return normalizeInteropSlotValue(slot);
        };
    };
    if (rawSlots == null) return 0, $6zvdv.EMPTY_OBJ;
    if (!(0, $6zvdv.isObject)(rawSlots) || (0, $6zvdv.isArray)(rawSlots) || (0, $fKAHx.isVNode)(rawSlots)) return normalizeInteropDefaultSlot(rawSlots);
    var normalized = (0, $fKAHx.createInternalObject)();
    for(var key in rawSlots)_loop(key);
    [
        "_",
        "_ctx",
        "$stable"
    ].forEach(function(key) {
        var descriptor = Object.getOwnPropertyDescriptor(rawSlots, key);
        if (descriptor) Object.defineProperty(normalized, key, descriptor);
    });
    return normalized;
}
var interopSlotCache = /* @__PURE__ */ new WeakMap();
function normalizeInteropSlot(rawSlot, ctx) {
    var cache = interopSlotCache.get(rawSlot);
    if (!cache) interopSlotCache.set(rawSlot, cache = {});
    if (ctx) {
        var ctxCache = cache.ctx;
        if (!ctxCache) cache.ctx = ctxCache = /* @__PURE__ */ new WeakMap();
        var cached = ctxCache.get(ctx);
        if (cached) return cached;
        var normalized = createNormalizedInteropSlot(rawSlot, ctx);
        ctxCache.set(ctx, normalized);
        return normalized;
    }
    if (cache.noCtx) return cache.noCtx;
    return cache.noCtx = createNormalizedInteropSlot(rawSlot, ctx);
}
function createNormalizedInteropSlot(rawSlot, ctx) {
    var normalized = (0, $fKAHx.withCtx)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return normalizeInteropSlotValue(rawSlot.apply(void 0, (0, $aUGqu._)(args)));
    }, ctx);
    normalized._c = false;
    return normalized;
}
function normalizeInteropDefaultSlot(value) {
    var normalized = (0, $fKAHx.createInternalObject)();
    var normalizedValue = normalizeInteropSlotValue(value);
    normalized.default = function() {
        return normalizedValue;
    };
    return normalized;
}
function normalizeInteropSlotValue(value) {
    return (0, $6zvdv.isArray)(value) ? value.map(function(child) {
        return (0, $fKAHx.normalizeVNode)(child);
    }) : [
        (0, $fKAHx.normalizeVNode)(value)
    ];
}
var isInternalSlotKey = function(key) {
    return key === "_" || key === "_ctx" || key === "$stable" || key === "$";
};
var interopSlotsSourceHandlers = {
    get: function(target, key) {
        var slots = target.value;
        return slots && slots[key];
    },
    has: function(target, key) {
        var slots = target.value;
        return !!slots && key in slots;
    },
    ownKeys: function(target) {
        var slots = target.value;
        return slots ? Object.keys(slots).filter(function(key) {
            return !isInternalSlotKey(key);
        }) : (0, $6zvdv.EMPTY_ARR);
    },
    getOwnPropertyDescriptor: function(target, key) {
        var slots = target.value;
        var descriptor = slots && Object.getOwnPropertyDescriptor(slots, key);
        if (descriptor && descriptor.enumerable && !isInternalSlotKey(key)) return {
            enumerable: true,
            configurable: true,
            value: descriptor.value
        };
    }
};
function createInteropRawSlots(slotsRef) {
    return (0, $7Pjls._)({
        $: [
            new Proxy(slotsRef, interopSlotsSourceHandlers)
        ]
    }, interopSlotsKey, slotsRef);
}
var interopRootSyncFragmentMap = /* @__PURE__ */ new WeakMap();
function registerInteropRootSync(instance, frag) {
    if (interopRootSyncFragmentMap.get(frag) === instance) return;
    interopRootSyncFragmentMap.set(frag, instance);
    (frag.u || (frag.u = [])).push(function() {
        return syncInteropRoot(instance);
    });
}
/**
* Stores the vnode-derived root-only ids on the instance. Metadata only:
* mountComponent and dynamic branch renders apply them pre-insert to roots
* that mount afterwards; kept roots keep their mount-time ids (VDOM parity).
*/ function setInteropComponentScopeIds(instance, vnode) {
    instance.scopeId = vnode.scopeId;
    var inherited = (0, $fKAHx.getInheritedScopeIds)(vnode, instance.parent);
    instance.slotScopeIds = concatInteropScopeIds(vnode.slotScopeIds, inherited.length ? inherited : null);
}
function concatInteropScopeIds(base, own) {
    return base ? own && own.length && own !== base ? base.concat(own) : base : own || null;
}
/**
* Publishes root-only ids onto the interop vnode backing a vapor component's
* effective root, for core to apply at its own pre-insertion mount. A nested
* component crossed during the descent re-collects canonically — its climb
* carries every ancestor's contribution — superseding the caller's subset.
*/ function publishVaporScopeIds(block, scopeIds) {
    var currentScopeIds = scopeIds;
    getRootElement(block, {
        onComponent: function(instance) {
            currentScopeIds = collectRootScopeIds(instance) || [];
        },
        onInteropFragment: function(frag) {
            if (frag.vnode) {
                setVNodeVaporScopeIds(frag.vnode, currentScopeIds);
                return true;
            }
        },
        excludeSlotOutlets: true
    });
}
function setVNodeVaporScopeIds(vnode, scopeIds) {
    vnode.vaporScopeIds = scopeIds;
    if (vnode.ssContent) setVNodeVaporScopeIds(vnode.ssContent, scopeIds);
    if (vnode.ssFallback) setVNodeVaporScopeIds(vnode.ssFallback, scopeIds);
}
function getInteropVaporSlotScopeIds(vnode, parentComponent, contextSlotScopeIds) {
    var inherited = (0, $fKAHx.getInheritedScopeIds)(vnode, parentComponent, false);
    return concatInteropScopeIds(concatInteropScopeIds(contextSlotScopeIds, vnode.slotScopeIds), inherited.length ? inherited : null);
}
function interopHasVDOMContent() {
    return !!this.vnode;
}
function interopSetKey(key) {
    if (this.vnode) this.vnode.key = key;
}
function interopGetTransitionType() {
    return this.vnode ? getInteropTransitionType(this.vnode) : void 0;
}
function interopGetTransitionElement() {
    return this.vnode ? getInteropTransitionElement(this.vnode) : void 0;
}
function createInteropFragment() {
    var nodes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_BLOCK, vnode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, extraFlags = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var frag = new RenderContextFragment(nodes, 64 | extraFlags);
    frag.vnode = vnode;
    frag.hasVDOMContent = interopHasVDOMContent;
    frag.setKey = interopSetKey;
    frag.getTransitionType = interopGetTransitionType;
    frag.getTransitionElement = interopGetTransitionElement;
    return frag;
}
//#endregion
//#region packages/runtime-vapor/src/components/Teleport.ts
var VaporTeleportImpl = {
    name: "VaporTeleport",
    __isTeleport: true,
    __vapor: true,
    process: function(props, slots, adoptAnchor) {
        return new TeleportFragment(props, slots, adoptAnchor);
    }
};
var TeleportFragment = /*#__PURE__*/ function(RenderContextFragment) {
    "use strict";
    (0, $hdIku._)(TeleportFragment, RenderContextFragment);
    function TeleportFragment(props, slots, adoptAnchor) {
        (0, $173N4._)(this, TeleportFragment);
        var _this;
        _this = (0, $7qXGD._)(this, TeleportFragment, [
            [],
            32
        ]);
        _this.childrenInitialized = false;
        _this.childrenScope = (0, $ftLbb.getCurrentScope)();
        _this.mountState = {
            location: 0
        };
        _this.dispose = function() {
            var scope = _this.scope;
            if (scope) {
                _this.scope = void 0;
                scope.stop();
            }
            var mountState = _this.mountState;
            if (_this.nodes && mountState.location === 1) {
                remove(_this.nodes, mountState.container);
                _this.nodes = [];
            }
            _this.disposeTarget();
            _this.mountState = {
                location: 0
            };
        };
        _this.hydrate = function() {
            if (!isHydrating$1) return;
            var target = _this.target = (0, $fKAHx.resolveTeleportTarget)(_this.resolvedProps, querySelector);
            var disabled = (0, $fKAHx.isTeleportDisabled)(_this.resolvedProps);
            _this.placeholder = currentHydrationNode;
            if (target) {
                var targetNode = target._lpa || target.firstChild;
                if (disabled) _this.hydrateDisabledTeleport(target, targetNode);
                else {
                    _this.anchor = claimAnchor(locateTeleportEndAnchor(currentHydrationNode.nextSibling));
                    _this.hydrateTargetAnchors(target, targetNode);
                    _this.mountState = {
                        location: 2,
                        container: target,
                        anchor: _this.targetAnchor || null
                    };
                    if (targetNode) setCurrentHydrationNode(targetNode.nextSibling);
                    if (!_this.targetAnchor) _this.mountChildren(target);
                    else _this.initChildren();
                }
            } else if (disabled) _this.hydrateDisabledTeleport(null, null);
            else _this.anchor = claimAnchor(locateTeleportEndAnchor(currentHydrationNode.nextSibling));
            advanceHydrationNode(_this.anchor);
        };
        _this.rawSlots = slots;
        _this.anchor = isHydrating$1 ? void 0 : resolveFragmentAnchor(adoptAnchor, "teleport end");
        var propsProxy = new Proxy(props, rawPropsProxyHandlers);
        renderEffect(function() {
            var prevTo = _this.resolvedProps && _this.resolvedProps.to;
            var wasDisabled = _this.isDisabled;
            _this.resolvedProps = (0, $6zvdv.extend)({}, propsProxy);
            _this.isDisabled = (0, $fKAHx.isTeleportDisabled)(_this.resolvedProps);
            if (wasDisabled !== _this.isDisabled || !_this.isDisabled && prevTo !== _this.resolvedProps.to) _this.handlePropsUpdate();
        });
        return _this;
    }
    (0, $cFHGC._)(TeleportFragment, [
        {
            key: "parent",
            get: function get() {
                return this.anchor ? /* @__PURE__ */ parentNode(this.anchor) : null;
            }
        },
        {
            key: "scopeOwner",
            get: function get() {
                return this.ctx.slotOwner || this.renderInstance;
            }
        },
        {
            key: "initChildren",
            value: function initChildren() {
                var _this = this;
                var instance = this.renderInstance;
                var prevInstance = (0, $fKAHx.setCurrentInstance)(instance, this.childrenScope);
                var prevUpdating = instance ? instance.isUpdating : false;
                if (instance) instance.isUpdating = true;
                try {
                    this.childrenInitialized = true;
                    renderEffect(function() {
                        return withRenderContext(_this.ctx, function() {
                            var prevScope = _this.scope;
                            if (prevScope) prevScope.stop();
                            var scope = _this.scope = new (0, $ftLbb.EffectScope)();
                            _this.handleChildrenUpdate(scope.run(function() {
                                return _this.rawSlots && _this.rawSlots.default ? _this.rawSlots.default() : [];
                            }) || []);
                        });
                    });
                    var owner = this.scopeOwner;
                    if (owner && owner.applyCssVars) registerCssVarOutlet(owner, this);
                    this.bindChildren(this.nodes);
                } finally{
                    if (instance) instance.isUpdating = prevUpdating;
                    (0, $fKAHx.restoreCurrentInstance)(prevInstance);
                }
            }
        },
        {
            key: "ensureChildrenInitialized",
            value: function ensureChildrenInitialized() {
                if (!this.childrenInitialized) this.initChildren();
            }
        },
        {
            key: "bindChildren",
            value: function bindChildren(block) {
                var owner = this.scopeOwner;
                if (owner && owner.applyCssVars) owner.applyCssVars(block);
            }
        },
        {
            key: "handleChildrenUpdate",
            value: function handleChildrenUpdate(children) {
                var mountState = this.mountState;
                if (isHydrating$1 || !this.parent || mountState.location === 0) {
                    this.nodes = children;
                    return;
                }
                remove(this.nodes, mountState.container);
                this.nodes = children;
                this.bindChildren(children);
                insert(children, mountState.container, mountState.anchor);
            }
        },
        {
            key: "mount",
            value: function mount(parent, anchor, location) {
                if (isTransitionEnabled && this.$transition && this.mountState.location === 0) applyTransitionHooks(this.nodes, this.$transition, this);
                if (this.mountState.location !== 0) move(this.nodes, parent, anchor, 2);
                else insert(this.nodes, parent, anchor);
                this.mountState = {
                    location: location,
                    container: parent,
                    anchor: anchor
                };
            }
        },
        {
            key: "prepareTargetAnchors",
            value: function prepareTargetAnchors(target) {
                if (!this.targetAnchor || /* @__PURE__ */ parentNode(this.targetAnchor) !== target) {
                    if (this.targetStart) remove(this.targetStart, /* @__PURE__ */ parentNode(this.targetStart));
                    if (this.targetAnchor) remove(this.targetAnchor, /* @__PURE__ */ parentNode(this.targetAnchor));
                    insert(this.targetStart = /* @__PURE__ */ createTextNode(""), target);
                    insert(this.targetAnchor = /* @__PURE__ */ createTextNode(""), target);
                }
            }
        },
        {
            key: "prepareTarget",
            value: function prepareTarget() {
                var target = this.target = (0, $fKAHx.resolveTeleportTarget)(this.resolvedProps, querySelector);
                if (target) this.prepareTargetAnchors(target);
                return target;
            }
        },
        {
            key: "queueTargetUpdate",
            value: function queueTargetUpdate() {
                var _this = this;
                if (!this.mountToTargetJob || this.mountToTargetJob.flags & 4) this.mountToTargetJob = function() {
                    _this.mountToTargetJob = void 0;
                    if (!_this.anchor) return;
                    if (_this.isDisabled) {
                        if (!_this.targetAnchor) _this.prepareTarget();
                    } else _this.mountToTarget();
                };
                (0, $fKAHx.queuePostRenderEffect)(this.mountToTargetJob, void 0, this.parentSuspense !== void 0 ? this.parentSuspense : isSuspenseEnabled && this.ctx.suspense || null);
            }
        },
        {
            key: "mountToTarget",
            value: function mountToTarget() {
                var target = this.prepareTarget();
                if (target) {
                    this.ensureChildrenInitialized();
                    this.mount(target, this.targetAnchor, 2);
                    this.cancelMountToTarget();
                }
            }
        },
        {
            key: "handlePropsUpdate",
            value: function handlePropsUpdate() {
                if (!this.parent || isHydrating$1) return;
                if (this.isDisabled) {
                    this.ensureChildrenInitialized();
                    this.mount(this.parent, this.anchor, 1);
                    if (!this.targetAnchor) {
                        if ((0, $fKAHx.isTeleportDeferred)(this.resolvedProps) || !this.parent.isConnected) this.queueTargetUpdate();
                        else this.prepareTarget();
                    }
                } else if ((0, $fKAHx.isTeleportDeferred)(this.resolvedProps) || !this.parent.isConnected) this.queueTargetUpdate();
                else this.mountToTarget();
            }
        },
        {
            key: "insert",
            value: function insert1(container, anchor, parentSuspense) {
                if (isHydrating$1) return;
                if (parentSuspense !== void 0) this.parentSuspense = parentSuspense;
                var wasMountedInTarget = this.mountState.location === 2;
                if (!this.placeholder) this.placeholder = /* @__PURE__ */ createTextNode();
                insert(this.placeholder, container, anchor);
                insert(this.anchor, container, anchor);
                if (!wasMountedInTarget) this.handlePropsUpdate();
            }
        },
        {
            key: "move",
            value: function move(container, anchor, _moveType, _parentComponent, parentSuspense) {
                this.insert(container, anchor, parentSuspense);
            }
        },
        {
            key: "cancelMountToTarget",
            value: function cancelMountToTarget() {
                if (this.mountToTargetJob) {
                    this.mountToTargetJob.flags |= 4;
                    this.mountToTargetJob = void 0;
                }
            }
        },
        {
            key: "disposeTarget",
            value: function disposeTarget() {
                this.cancelMountToTarget();
                var mountState = this.mountState;
                if (this.nodes && mountState.location === 2) {
                    var targetParent = this.targetStart && /* @__PURE__ */ parentNode(this.targetStart) || this.targetAnchor && /* @__PURE__ */ parentNode(this.targetAnchor) || void 0;
                    remove(this.nodes, targetParent);
                    this.nodes = [];
                    this.mountState = {
                        location: 0
                    };
                }
                if (this.targetStart) {
                    remove(this.targetStart, /* @__PURE__ */ parentNode(this.targetStart));
                    this.targetStart = void 0;
                }
                if (this.targetAnchor) {
                    remove(this.targetAnchor, /* @__PURE__ */ parentNode(this.targetAnchor));
                    this.targetAnchor = void 0;
                }
                this.target = void 0;
            }
        },
        {
            key: "scheduleTargetDispose",
            value: function scheduleTargetDispose() {
                var _this = this;
                this.cancelMountToTarget();
                (0, $fKAHx.queuePostFlushCb)(function() {
                    return _this.disposeTarget();
                });
            }
        },
        {
            key: "remove",
            value: function remove1() {
                this.dispose();
                if (this.anchor) {
                    remove(this.anchor, /* @__PURE__ */ parentNode(this.anchor));
                    this.anchor = void 0;
                }
                if (this.placeholder) {
                    remove(this.placeholder, /* @__PURE__ */ parentNode(this.placeholder));
                    this.placeholder = void 0;
                }
            }
        },
        {
            key: "hydrateTargetAnchors",
            value: function hydrateTargetAnchors(target, targetNode) {
                if (!isHydrating$1) return;
                var targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") this.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            this.targetAnchor = claimAnchor(targetAnchor);
                            target._lpa = this.targetAnchor.nextSibling;
                            break;
                        }
                    }
                    targetAnchor = targetAnchor.nextSibling;
                }
            }
        },
        {
            key: "hydrateDisabledTeleport",
            value: function hydrateDisabledTeleport(target, targetNode) {
                if (!isHydrating$1) return;
                var nextNode = this.placeholder.nextSibling;
                setCurrentHydrationNode(nextNode);
                this.anchor = claimAnchor(locateTeleportEndAnchor(nextNode));
                this.mountState = {
                    location: 1,
                    container: /* @__PURE__ */ parentNode(this.anchor),
                    anchor: this.anchor
                };
                if (target) this.hydrateTargetAnchors(target, targetNode);
                else {
                    this.targetStart = targetNode;
                    this.targetAnchor = targetNode && targetNode.nextSibling;
                }
                this.initChildren();
            }
        },
        {
            key: "mountChildren",
            value: function mountChildren(target) {
                if (!isHydrating$1) return;
                target.appendChild(this.targetStart = /* @__PURE__ */ createTextNode(""));
                target.appendChild(this.targetAnchor = claimAnchor(/* @__PURE__ */ createTextNode("")));
                this.mountState = {
                    location: 2,
                    container: target,
                    anchor: this.targetAnchor
                };
                if (!(0, $fKAHx.isMismatchAllowed)(target, 1)) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) (0, $fKAHx.warn)("Hydration children mismatch on", target, "\nServer rendered element contains fewer child nodes than client nodes.");
                    (0, $fKAHx.logMismatchError)();
                }
                runWithoutHydration(this.initChildren.bind(this));
            }
        }
    ]);
    return TeleportFragment;
}(RenderContextFragment);
var VaporTeleport = /*@__PURE__*/ enableTeleport(VaporTeleportImpl);
function locateTeleportEndAnchor() {
    var node = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : currentHydrationNode;
    var depth = 0;
    while(node){
        if (isComment(node, "teleport start")) depth++;
        else if (isComment(node, "teleport end")) {
            if (depth === 0) return node;
            else depth--;
        }
        node = node.nextSibling;
    }
    return null;
}
//#endregion
//#region packages/runtime-vapor/src/apiDefineCustomElement.ts
var vaporCustomElementHydrates = /* @__PURE__ */ new WeakMap();
/*@__NO_SIDE_EFFECTS__*/ function defineVaporCustomElement(options, extraOptions, _createApp, _hydrate) {
    var Comp = /* @__PURE__ */ defineVaporComponent(options, extraOptions);
    if ((0, $6zvdv.isPlainObject)(Comp)) Comp = (0, $6zvdv.extend)({}, Comp, extraOptions);
    var VaporCustomElement = /*#__PURE__*/ function(VaporElement) {
        "use strict";
        (0, $hdIku._)(VaporCustomElement, VaporElement);
        function VaporCustomElement(initialProps) {
            (0, $173N4._)(this, VaporCustomElement);
            return (0, $7qXGD._)(this, VaporCustomElement, [
                Comp,
                initialProps,
                _createApp
            ]);
        }
        return VaporCustomElement;
    }(VaporElement);
    VaporCustomElement.def = Comp;
    if (_hydrate) vaporCustomElementHydrates.set(VaporCustomElement, _hydrate);
    return VaporCustomElement;
}
var defineVaporSSRCustomElement = function(options, extraOptions) {
    return /* @__PURE__ */ defineVaporCustomElement(options, extraOptions, createVaporSSRApp, withHydration);
};
var VaporElement = /*#__PURE__*/ function(VueElementBase) {
    "use strict";
    (0, $hdIku._)(VaporElement, VueElementBase);
    function VaporElement(def) {
        var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, createAppFn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : createVaporApp;
        (0, $173N4._)(this, VaporElement);
        return (0, $7qXGD._)(this, VaporElement, [
            def,
            (0, $ftLbb.shallowReactive)(props),
            createAppFn
        ]);
    }
    (0, $cFHGC._)(VaporElement, [
        {
            key: "_needsHydration",
            value: function _needsHydration() {
                var hydrate = vaporCustomElementHydrates.get(this.constructor);
                if (this.shadowRoot && hydrate) return true;
                return false;
            }
        },
        {
            key: "_mount",
            value: function _mount(def) {
                if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VaporElement";
                this._app = this._createApp(this._def);
                this._inheritParentContext();
                if (this._def.configureApp) this._def.configureApp(this._app);
                var hydrate = vaporCustomElementHydrates.get(this.constructor);
                if (this.shadowRoot && hydrate) hydrate(this._root, this._createComponent.bind(this));
                else this._createComponent();
                this._app.mount(this._root);
            }
        },
        {
            key: "_update",
            value: function _update() {}
        },
        {
            key: "_unmount",
            value: function _unmount() {
                if (this._app) this._app.unmount();
                if (this._instance && this._instance.ce) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        },
        {
            key: "_createComponent",
            value: function _createComponent() {
                var _this = this;
                var ce = function(instance) {
                    _this._app._ceComponent = _this._instance = instance;
                    _this._processInstance();
                };
                createComponent(this._def, this._props, this.shadowRoot ? void 0 : this._createSlots(), void 0, void 0, this._app._context, false, ce);
            }
        },
        {
            /**
	* Only called when shadowRoot is false. The light DOM children parsed on
	* connect become static slots, so `<slot/>` outlets render them in place
	* through the normal slot pipeline instead of a native outlet that has to
	* be replaced after mount.
	*/ key: "_createSlots",
            value: function _createSlots() {
                var _loop = function(name) {
                    var nodes = parsed[name];
                    if (scopeId) {
                        var id = scopeId + "-s";
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var n = _step.value;
                                if (n.nodeType === 1) {
                                    n.setAttribute(id, "");
                                    var walker = document.createTreeWalker(n, 1);
                                    var child = void 0;
                                    while(child = walker.nextNode())child.setAttribute(id, "");
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    (slots || (slots = {}))[name] = function() {
                        return nodes;
                    };
                };
                var parsed = this._slots;
                if (!parsed) return;
                var scopeId = this._def.__scopeId;
                var slots;
                for(var name in parsed)_loop(name);
                return slots;
            }
        }
    ]);
    return VaporElement;
}((0, $3ewO8.VueElementBase));
//#endregion
//#region packages/runtime-vapor/src/dom/template.ts
var t;
function cloneTemplate(n) {
    var scopeIds = currentRenderContext.slotScopeIds;
    return scopeIds ? cloneStampedTemplate(n, scopeIds) : n.cloneNode(true);
}
/*@__NO_SIDE_EFFECTS__*/ function template(html) {
    var flags = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ns = arguments.length > 2 ? arguments[2] : void 0;
    var root = !!(flags & 1);
    var isStatic = !!(flags & 2);
    var node;
    var adoptTarget;
    return function() {
        if (isHydrating$1) {
            if (!(html[0] === "<" && html[1] === "!")) resolvePendingSlotContent();
            var adopted = null;
            if (isStatic && !isComment(currentHydrationNode, "")) {
                adopted = resolveHydrationTarget(currentHydrationNode);
                if (html !== "") {
                    if (html[0] !== "<") {
                        if (!hydrateTextNode(adopted, html) && __VUE_PROD_HYDRATION_MISMATCH_DETAILS__) validateHydrationTarget(adopted, html);
                    } else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) validateHydrationTarget(adopted, html);
                }
                if (!node) node = adopted.cloneNode(true);
                advanceHydrationNode(adopted);
            } else adopted = adoptTemplate(currentHydrationNode, html, false, ns, adoptTarget || (adoptTarget = parseAdoptTarget(html)));
            if (root) adopted.$root = true;
            return adopted;
        }
        if (node) {
            var ret = cloneTemplate(node);
            if (root) ret.$root = true;
            return ret;
        }
        if (html[0] !== "<") return /* @__PURE__ */ createTextNode(html);
        t = t || document.createElement("template");
        if (ns) {
            var tag = ns === 1 ? "svg" : "math";
            t.innerHTML = "<".concat(tag, ">").concat(html, "</").concat(tag, ">");
            node = /* @__PURE__ */ _child(/* @__PURE__ */ _child(t.content));
        } else {
            t.innerHTML = html;
            node = /* @__PURE__ */ _child(t.content);
        }
        var ret1 = cloneTemplate(node);
        if (root) ret1.$root = true;
        return ret1;
    };
}
//#endregion
//#region packages/runtime-vapor/src/apiCreateIf.ts
function createIf(condition, b1, b2) {
    var flags = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var _insertionParent = insertionParent;
    var _insertionAnchor = insertionAnchor;
    if (!isHydrating$1) resetInsertionState();
    var hydrationCursor = null;
    var branchShape;
    var anchor;
    var frag;
    if (flags & 16) {
        var ok = condition();
        var claim;
        if (isHydrating$1) {
            branchShape = decodeIfShape(flags, ok);
            claim = branchShape === 2 ? createFragmentClaim() : void 0;
            hydrationCursor = enterHydrationCursor(claim);
        }
        frag = ok ? b1() : b2 ? b2() : [
            claimUntrackedAnchor(/* @__PURE__ */ createTextNode())
        ];
        if (isHydrating$1 && claim && claim.start) advanceHydrationNode(locateEndAnchor(claim.start));
    } else {
        var index = flags >> 8;
        var keyed = index > 0;
        var keyBase = keyed ? (index - 1) * 2 : 0;
        var trackSlotBoundary = !!(flags & 128);
        var dynamicFragment = new DynamicFragment(256, void 0, keyed, trackSlotBoundary, trackSlotBoundary ? function() {
            var anchor = dynamicFragment.anchor;
            var parent = anchor.parentNode;
            if (parent) removeNode(anchor, parent);
        } : void 0, _insertionAnchor);
        anchor = dynamicFragment.anchor;
        frag = dynamicFragment;
        renderEffect(function() {
            var ok = condition();
            if (isHydrating$1) {
                branchShape = decodeIfShape(flags, ok);
                dynamicFragment.hydrationClaim = branchShape === 2 ? createFragmentClaim() : void 0;
                hydrationCursor = enterHydrationCursor(dynamicFragment.hydrationClaim);
            }
            dynamicFragment.update(ok ? b1 : b2, keyed ? keyBase + (ok ? 0 : 1) : void 0, isNoScopeBranch(flags, ok));
        });
    }
    if (isHydrating$1 && branchShape === 0 && hydrationCursor) {
        var start = hydrationCursor.start;
        if (start && currentHydrationNode === start && isComment(start, "")) advanceHydrationNode(start);
    }
    finishBlockCreation(frag, anchor, hydrationCursor, _insertionParent, _insertionAnchor);
    return frag;
}
function decodeIfShape(shape, ok) {
    return shape >> (ok ? 0 : 2) & 3;
}
function isNoScopeBranch(flags, ok) {
    return !!(flags & (ok ? 32 : 64));
}
//#endregion
//#region packages/runtime-vapor/src/apiCreateFragment.ts
/**
* Create a dynamic fragment keyed by a reactive value for Vapor transitions.
* The fragment is re-rendered when the key changes to trigger enter/leave
* animations.
*
* Example:
* <VaporTransition>
*   <h1 :key="count">{{ count }}</h1>
* </VaporTransition>
*/ function createKeyedFragment(key, render) {
    var trackSlotBoundary = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _insertionParent = insertionParent;
    var _insertionAnchor = insertionAnchor;
    if (!isHydrating$1) resetInsertionState();
    var hydrationCursor = isHydrating$1 ? captureHydrationCursor() : null;
    var frag = new DynamicFragment(0, void 0, true, trackSlotBoundary, trackSlotBoundary ? function() {
        var parent = frag.anchor.parentNode;
        if (parent) removeNode(frag.anchor, parent);
    } : void 0, _insertionAnchor);
    if (isHydrating$1) locateHydrationNode();
    renderEffect(function() {
        return frag.update(render, key());
    });
    finishBlockCreation(frag, frag.anchor, hydrationCursor, _insertionParent, _insertionAnchor);
    return frag;
}
//#endregion
//#region packages/runtime-vapor/src/apiCreateFor.ts
var createFor = function(src, renderItem, getKey) {
    var flags = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var _insertionParent = insertionParent;
    var _insertionAnchor = insertionAnchor;
    var _insertionIndex = insertionIndex;
    var hydrationCursor = null;
    var hydrationClaim;
    if (isHydrating$1) {
        hydrationClaim = createFragmentClaim();
        hydrationCursor = enterHydrationCursor(hydrationClaim);
    } else resetInsertionState();
    var isMounted = false;
    var oldBlocks = [];
    var newBlocks;
    var newKeys;
    var parent;
    var parentAnchor;
    var pendingHydrationAnchor = false;
    if (!isHydrating$1) {
        parentAnchor = resolveFragmentAnchor(_insertionAnchor, "for");
        if (parentAnchor === _insertionAnchor) parent = parentAnchor.parentNode;
    }
    var trackSlotBoundary = !!(flags & 32);
    var frag = new ForFragment(oldBlocks, trackSlotBoundary, trackSlotBoundary ? function() {
        var parent = parentAnchor.parentNode;
        if (parent) removeNode(parentAnchor, parent);
    } : void 0);
    var instance = (0, $fKAHx.currentInstance);
    var isComponent = !!(flags & 2);
    var canUseFastRemove = !!(flags & 1) && !isComponent;
    var isSingleNode = !!(flags & 8);
    var isFragment = !!(flags & 16);
    var wrappedRows = !!(flags & 64);
    var ctx = currentRenderContext;
    (0, $ftLbb.onScopeDispose)(function() {
        stopBlockScopes(oldBlocks);
        if (newBlocks && newBlocks !== oldBlocks) stopBlockScopes(newBlocks);
        oldBlocks = [];
        newBlocks = [];
    }, true);
    var renderList = function() {
        var source = normalizeSource(src());
        var sourceKeys = source.keys;
        var newLength = source.values.length;
        var oldLength = oldBlocks.length;
        newBlocks = new Array(newLength);
        newKeys = void 0;
        if (getKey) {
            newKeys = new Array(newLength);
            for(var i = 0; i < newLength; i++){
                var value = getItemValue(source, i);
                newKeys[i] = sourceKeys ? getKey(value, sourceKeys[i], i) : getKey(value, i, void 0);
            }
        }
        var prevSub = (0, $ftLbb.setActiveSub)();
        var wasMounted = isMounted;
        if (wasMounted && frag.bu) for(var i1 = 0; i1 < frag.bu.length; i1++)frag.bu[i1]();
        if (!wasMounted) {
            isMounted = true;
            if (isHydrating$1) hydrateList(source, newLength);
            else mountAll(source, newLength);
        } else {
            parent = parentAnchor.parentNode;
            if (!oldLength) mountAll(source, newLength);
            else if (!newLength) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (frag.resetListeners) try {
                    for(var _iterator = frag.resetListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var fn = _step.value;
                        fn();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var doRemove = !canUseFastRemove;
                for(var i2 = 0; i2 < oldLength; i2++)unmount(oldBlocks[i2], doRemove);
                if (canUseFastRemove) {
                    parent.textContent = "";
                    parent.appendChild(parentAnchor);
                }
            } else if (!getKey) {
                var commonLength = Math.min(newLength, oldLength);
                for(var i3 = 0; i3 < commonLength; i3++)updateAt(newBlocks[i3] = oldBlocks[i3], source, i3);
                for(var i4 = oldLength; i4 < newLength; i4++)mount(source, i4, parentAnchor);
                for(var i5 = newLength; i5 < oldLength; i5++)unmount(oldBlocks[i5]);
            } else {
                var commonLength1 = Math.min(oldLength, newLength);
                var endOffset = 0;
                while(endOffset < commonLength1){
                    var index = newLength - endOffset - 1;
                    var key = newKeys[index];
                    var existingBlock = oldBlocks[oldLength - endOffset - 1];
                    if (existingBlock.key !== key) break;
                    updateAt(existingBlock, source, index);
                    newBlocks[index] = existingBlock;
                    endOffset++;
                }
                var e1 = commonLength1 - endOffset;
                var e2 = oldLength - endOffset;
                var e3 = newLength - endOffset;
                var queuedIndices = [];
                var oldKeyIndexMap = /* @__PURE__ */ new Map();
                for(var i6 = 0; i6 < e1; i6++){
                    var currentKey = newKeys[i6];
                    var oldBlock = oldBlocks[i6];
                    if (oldBlock.key === currentKey) updateAt(newBlocks[i6] = oldBlock, source, i6);
                    else {
                        queuedIndices.push(i6);
                        oldKeyIndexMap.set(oldBlock.key, i6);
                    }
                }
                for(var i7 = e1; i7 < e2; i7++)oldKeyIndexMap.set(oldBlocks[i7].key, i7);
                for(var i8 = e1; i8 < e3; i8++)queuedIndices.push(i8);
                var queuedLength = queuedIndices.length;
                var sources = (0, $6zvdv.EMPTY_ARR);
                var mountCounter = 0;
                if (oldKeyIndexMap.size === 0) mountCounter = queuedLength;
                else {
                    sources = new Array(queuedLength);
                    for(var q = queuedLength - 1; q >= 0; q--){
                        var index1 = queuedIndices[q];
                        var key1 = newKeys[index1];
                        var oldIndex = oldKeyIndexMap.get(key1);
                        if (oldIndex !== void 0) {
                            oldKeyIndexMap.delete(key1);
                            var reusedBlock = newBlocks[index1] = oldBlocks[oldIndex];
                            updateAt(reusedBlock, source, index1);
                            sources[q] = oldIndex + 1;
                        } else {
                            sources[q] = 0;
                            mountCounter++;
                        }
                    }
                }
                var useFastRemove = mountCounter === newLength;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (useFastRemove && frag.resetListeners) try {
                    for(var _iterator1 = frag.resetListeners[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var fn1 = _step1.value;
                        fn1();
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                if (oldKeyIndexMap.size) try {
                    for(var _iterator2 = oldKeyIndexMap.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var leftoverIndex = _step2.value;
                        unmount(oldBlocks[leftoverIndex], !(useFastRemove && canUseFastRemove));
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
                if (useFastRemove && canUseFastRemove) {
                    parent.textContent = "";
                    parent.appendChild(parentAnchor);
                }
                var sequence;
                var hasReuse = mountCounter !== queuedLength;
                if (hasReuse) {
                    sequence = planMoves(queuedIndices, sources, e2, e3);
                    queuedLength = queuedIndices.length;
                }
                var allKept = hasReuse && sequence === void 0;
                var sequenceEnd = sequence ? sequence.length - 1 : -1;
                var scanFrom = newLength;
                var cachedAnchor;
                for(var q1 = queuedLength - 1; q1 >= 0; q1--){
                    var index2 = queuedIndices[q1];
                    var isKept = allKept && sources[q1] !== 0;
                    if (sequenceEnd >= 0 && sequence[sequenceEnd] === q1) {
                        sequenceEnd--;
                        isKept = sources[q1] !== 0;
                    }
                    if (isKept) continue;
                    var anchorNode = void 0;
                    for(var i9 = index2 + 1; i9 < scanFrom; i9++){
                        var node = getBlockFirstNode(newBlocks[i9].nodes);
                        if (node && node.parentNode === parent) {
                            anchorNode = node;
                            break;
                        }
                    }
                    if (anchorNode === void 0) {
                        if (cachedAnchor === void 0) cachedAnchor = parentAnchor;
                        anchorNode = cachedAnchor;
                    }
                    scanFrom = index2 + 1;
                    cachedAnchor = anchorNode;
                    var block = newBlocks[index2];
                    if (block !== void 0) move(block.nodes, parent, anchorNode, 2);
                    else mount(source, index2, anchorNode);
                }
            }
        }
        oldBlocks = newBlocks;
        frag.nodes = parentAnchor ? [
            newBlocks,
            parentAnchor
        ] : [
            newBlocks
        ];
        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
        if (wasMounted && frag.u) try {
            for(var _iterator3 = frag.u[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                var fn2 = _step3.value;
                fn2(frag.nodes);
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                }
            } finally{
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }
        (0, $ftLbb.setActiveSub)(prevSub);
    };
    var needKey = renderItem.length > 1;
    var needIndex = renderItem.length > 2;
    var insertForBlock = isSingleNode ? function(block, anchor) {
        return insertNode(block.nodes, parent, anchor);
    } : isFragment ? function(block, anchor) {
        return insertFragment(block.nodes, parent, anchor);
    } : function(block, anchor) {
        return insert(block.nodes, parent, anchor);
    };
    var removeForBlock = isSingleNode ? function(block) {
        return removeNode(block.nodes, parent);
    } : isFragment ? function(block) {
        return removeFragment(block.nodes, parent);
    } : function(block) {
        return remove(block.nodes, parent);
    };
    var mount = function(source, idx, anchor) {
        var keys = source.keys;
        var itemRef = (0, $ftLbb.shallowRef)(getItemValue(source, idx));
        var keyRef = needKey ? (0, $ftLbb.shallowRef)(keys ? keys[idx] : idx) : void 0;
        var indexRef = needIndex ? (0, $ftLbb.shallowRef)(keys ? idx : void 0) : void 0;
        var nodes;
        var scope = new (0, $ftLbb.EffectScope)(true);
        var prevScope = (0, $ftLbb.setCurrentScope)(scope);
        var ok = false;
        try {
            nodes = renderItem(itemRef, keyRef, indexRef);
            ok = true;
        } finally{
            (0, $ftLbb.setCurrentScope)(prevScope);
            if (!ok) scope.stop();
        }
        var block = newBlocks[idx] = new ForBlock(nodes, scope, itemRef, keyRef, indexRef, newKeys ? newKeys[idx] : void 0);
        if (isTransitionEnabled && frag.$transition) {
            var hooks = frag.$transition;
            if (hooks.applyGroup) hooks.applyGroup(block, hooks.props, hooks.state, hooks.instance);
            else applyTransitionHooks(block.nodes, hooks);
        }
        var bm = frag.bm;
        if (bm) for(var i = 0; i < bm.length; i++)bm[i](block.nodes);
        if (parent) insertForBlock(block, anchor);
        return block;
    };
    var mountAll = function(source, newLength) {
        for(var i = 0; i < newLength; i++)mount(source, i, parentAnchor);
    };
    var updateAt = function(block, source, idx) {
        var keys = source.keys;
        update(block, getItemValue(source, idx), keys ? keys[idx] : idx, keys ? idx : void 0);
    };
    function hydrateList(source, newLength) {
        var hydrationStart = currentHydrationNode;
        var claim = hydrationClaim;
        var exitHydrationBoundary;
        var slotEndAnchor = getCurrentSlotEndAnchor();
        var slotFallbackRange = isPendingSlotContent() && slotEndAnchor;
        var reuseBoundaryClose = function(close) {
            parentAnchor = claimAnchor(close);
            exitHydrationBoundary = enterHydrationBoundary(parentAnchor);
        };
        try {
            for(var i = 0; i < newLength; i++){
                var node = currentHydrationNode;
                var nextNode = null;
                if (isComment(node, "]")) nextNode = claimAnchor(node);
                else if (wrappedRows && isComment(node, "[")) {
                    nextNode = nextLogicalSibling(node);
                    setCurrentHydrationNode(node.nextSibling);
                }
                mount(source, i, parentAnchor);
                if (nextNode) setCurrentHydrationNode(nextNode);
            }
            if (claim.start) {
                reuseBoundaryClose(locateClaimedEnd(claim.start));
                if (_insertionParent) {
                    var idx = _insertionAnchor ? _insertionAnchor.$idx : _insertionIndex || 0;
                    if (idx !== void 0) {
                        parentAnchor.$idx = idx;
                        _insertionParent.$llc = parentAnchor;
                    }
                }
            } else if (slotFallbackRange && !isValidSlot(newBlocks)) {
                var anchor = currentHydrationNode !== hydrationStart ? currentHydrationNode : hydrationStart !== slotEndAnchor ? hydrationStart.nextSibling : slotEndAnchor;
                parentAnchor = claimUntrackedAnchor(/* @__PURE__ */ createTextNode());
                var hydrationAnchor = parentAnchor;
                pendingHydrationAnchor = true;
                if (currentHydrationNode === hydrationStart || currentHydrationNode === slotEndAnchor) setCurrentHydrationNode(hydrationStart);
                var attachAnchor = function() {
                    var parentNode = anchor.parentNode;
                    if (parentNode) parentNode.insertBefore(hydrationAnchor, anchor);
                };
                if (!queuePendingSlotContentAnchor({
                    onContent: function() {
                        return (0, $fKAHx.queuePostFlushCb)(attachAnchor);
                    },
                    onFallback: function() {}
                })) (0, $fKAHx.queuePostFlushCb)(attachAnchor);
            } else if (markerlessHydrationContainer) {
                var afterRows = currentHydrationNode;
                if (!newLength && afterRows && isComment(afterRows, "")) parentAnchor = claimAnchor(afterRows);
                else {
                    parentAnchor = claimAnchor(/* @__PURE__ */ createTextNode());
                    markerlessHydrationContainer.insertBefore(parentAnchor, afterRows && afterRows.parentNode === markerlessHydrationContainer ? afterRows : null);
                    pendingHydrationAnchor = true;
                }
            } else {
                var close = currentHydrationNode;
                reuseBoundaryClose(close);
            }
        } finally{
            exitHydrationBoundary && exitHydrationBoundary();
        }
    }
    var update = function(param, newItem, newKey, newIndex) {
        var itemRef = param.itemRef, keyRef = param.keyRef, indexRef = param.indexRef;
        if (newItem !== itemRef.value) itemRef.value = newItem;
        if (keyRef && newKey !== void 0 && newKey !== keyRef.value) keyRef.value = newKey;
        if (indexRef && newIndex !== indexRef.value) indexRef.value = newIndex;
    };
    var unmount = function(block) {
        var doRemove = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (!isComponent) block.scope.stop();
        if (doRemove) removeForBlock(block);
        else if (isInteropEnabled) unmountVDOM(block);
        if (isComponent) block.scope.stop();
    };
    if (flags & 4) renderList();
    else renderEffect(function() {
        if (!isMounted) return renderList();
        withRenderContext(ctx, renderList);
    });
    if (isHydrating$1 && !pendingHydrationAnchor && currentHydrationNode === parentAnchor) advanceHydrationNode(parentAnchor);
    finishBlockCreation(frag, parentAnchor, hydrationCursor, _insertionParent, _insertionAnchor);
    return frag;
};
/**
* Builds a key-indexed selector that activates only the opers registered with
* the key matching the current source value. Compared to letting each item
* subscribe directly, this keeps re-renders on source change O(2) instead of
* O(N) (only previous and new active item re-run).
*
* Selector cleanup follows the current scope. Per-item teardown is auto-wired
* via `onScopeDispose` so callers (typically v-for item scopes) don't need
* explicit deregistration. For bulk-reset hot paths, attach the selector to
* the v-for via `frag.onReset(selector.reset)` to skip the per-item Map ops.
*/ function createSelector(source) {
    var operMap = /* @__PURE__ */ new Map();
    var activeKey = source();
    var activeOpers;
    var pendingKey = activeKey;
    var pending = false;
    var generation = 0;
    (0, $ftLbb.watch)(source, function(newValue) {
        pendingKey = newValue;
        if (pending) return;
        pending = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (activeOpers !== void 0) try {
            for(var _iterator = activeOpers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var oper = _step.value;
                oper();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        (0, $fKAHx.queuePostFlushCb)(function() {
            pending = false;
            activeKey = pendingKey;
            activeOpers = operMap.get(activeKey);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (activeOpers !== void 0) try {
                for(var _iterator = activeOpers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var oper = _step.value;
                    oper();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    });
    var register = function(key, oper) {
        oper();
        var opers = operMap.get(key);
        if (opers !== void 0) opers.push(oper);
        else {
            opers = [
                oper
            ];
            operMap.set(key, opers);
            if (key === activeKey) activeOpers = opers;
        }
        var myGen = generation;
        (0, $ftLbb.onScopeDispose)(function() {
            if (myGen !== generation) return;
            var list = operMap.get(key);
            if (list === void 0) return;
            if (list.length === 1) {
                operMap.delete(key);
                if (key === activeKey) activeOpers = void 0;
            } else {
                var idx = list.indexOf(oper);
                if (idx !== -1) list.splice(idx, 1);
            }
        }, true);
    };
    register.reset = function() {
        operMap.clear();
        activeOpers = void 0;
        generation++;
    };
    return register;
}
/**
* Decides which reused blocks may stay where they are: the longest increasing
* subsequence of their old indices is already in relative order, so only the
* blocks outside it need a DOM move. Returns that subsequence as indices into
* `sources`, or `undefined` when no reused block has to move at all.
*
* Two planners, picked by how dense the change is across the range it touches:
*
* - dense (the queued indices cover at least half of the range they span):
*   pull the in-place matches in that range into the plan too and run an
*   unbounded LIS, which is move-count minimal like vdom's. The range is at
*   most `2 * queuedIndices.length` wide here, so this stays O(queued).
* - sparse (a couple of rows moved across an otherwise untouched list, e.g. a
*   far swap): keep the in-place matches pinned, which costs nothing but
*   bounds each segment's LIS by its stationary neighbours. Not minimal in
*   general, but it never walks the untouched majority.
*
* Both arrays are expanded in place on the dense path.
*/ function planMoves(queuedIndices, sources, e2, e3) {
    var queuedLength = queuedIndices.length;
    var denseLength = e3 - queuedIndices[0];
    var isDense = queuedLength * 2 >= denseLength;
    var moved = false;
    var maxSource = 0;
    if (isDense) {
        var read = queuedLength - 1;
        queuedIndices.length = sources.length = denseLength;
        for(var write = denseLength - 1, index = e3 - 1; write >= 0; write--, index--){
            if (read >= 0 && queuedIndices[read] === index) sources[write] = sources[read--];
            else sources[write] = index + 1;
            queuedIndices[write] = index;
        }
        queuedLength = denseLength;
        for(var q = 0; q < queuedLength; q++){
            var value = sources[q];
            if (value !== 0) {
                if (value < maxSource) moved = true;
                else maxSource = value;
            }
        }
    } else {
        var seg = 0;
        while(seg < queuedLength){
            var segEnd = seg;
            while(segEnd + 1 < queuedLength && queuedIndices[segEnd + 1] === queuedIndices[segEnd] + 1)segEnd++;
            var lowerBound = queuedIndices[seg] - 1;
            var nextIndex = queuedIndices[segEnd] + 1;
            var upperBound = nextIndex < e3 ? nextIndex : e2;
            for(var q1 = seg; q1 <= segEnd; q1++){
                var value1 = sources[q1];
                var oldIndex = value1 - 1;
                if (oldIndex <= lowerBound || oldIndex >= upperBound) sources[q1] = 0;
                else if (value1 < maxSource) moved = true;
                else maxSource = value1;
            }
            seg = segEnd + 1;
        }
    }
    return moved ? (0, $6zvdv.getSequence)(sources) : void 0;
}
function stopBlockScopes(blocks) {
    for(var i = 0; i < blocks.length; i++){
        var block = blocks[i];
        if (block) {
            var scope = block.scope;
            if (scope) scope.stop();
        }
    }
}
function isSameMapKey(a, b) {
    return Object.is(a, b) || a === 0 && b === 0;
}
function createForSlots(rawSource, renderSlot, getName, getKey) {
    var oldRecords = [];
    var needKey = renderSlot.length > 1;
    var needIndex = renderSlot.length > 2;
    var update = function(record, param) {
        var _param = (0, $f9AOD._)(param, 3), item = _param[0], key = _param[1], index = _param[2];
        if (!Object.is(record.itemRef.value, item)) record.itemRef.value = item;
        if (record.keyRef && !Object.is(record.keyRef.value, key)) record.keyRef.value = key;
        if (record.indexRef && !Object.is(record.indexRef.value, index)) record.indexRef.value = index;
    };
    return function() {
        var source = normalizeSource(rawSource());
        var sourceLength = source.values.length;
        var names = new Array(sourceLength);
        var identities = getKey ? new Array(sourceLength) : names;
        var items = new Array(sourceLength);
        var sameResolution = sourceLength === oldRecords.length;
        for(var i = 0; i < sourceLength; i++){
            var item = items[i] = getItem(source, i);
            var name = names[i] = String(getName.apply(void 0, (0, $aUGqu._)(item)));
            var identity = identities[i] = getKey ? getKey.apply(void 0, (0, $aUGqu._)(item)) : name;
            if (sameResolution && (!isSameMapKey(oldRecords[i].rawIdentity, identity) || oldRecords[i].name !== name)) sameResolution = false;
        }
        if (sameResolution) {
            var prevSub = (0, $ftLbb.setActiveSub)();
            for(var i1 = sourceLength - 1; i1 >= 0; i1--)update(oldRecords[i1], items[i1]);
            (0, $ftLbb.setActiveSub)(prevSub);
            return oldRecords;
        }
        var oldByIdentity = /* @__PURE__ */ new Map();
        for(var i2 = 0; i2 < oldRecords.length; i2++)oldByIdentity.set(oldRecords[i2].rawIdentity, oldRecords[i2]);
        var records = new Array(sourceLength);
        var prevSub1 = (0, $ftLbb.setActiveSub)();
        for(var i3 = sourceLength - 1; i3 >= 0; i3--){
            var slotItem = items[i3];
            var rawIdentity = identities[i3];
            var record = oldByIdentity.get(rawIdentity);
            if (record) {
                oldByIdentity.delete(rawIdentity);
                update(record, slotItem);
                record.name = names[i3];
            } else {
                var _slotItem = (0, $f9AOD._)(slotItem, 3), item1 = _slotItem[0], key = _slotItem[1], index = _slotItem[2];
                var itemRef = (0, $ftLbb.shallowRef)(item1);
                var keyRef = needKey ? (0, $ftLbb.shallowRef)(key) : void 0;
                var indexRef = needIndex ? (0, $ftLbb.shallowRef)(index) : void 0;
                record = {
                    rawIdentity: rawIdentity,
                    itemRef: itemRef,
                    keyRef: keyRef,
                    indexRef: indexRef,
                    name: names[i3],
                    fn: renderSlot(itemRef, keyRef, indexRef),
                    key: itemRef
                };
            }
            records[i3] = record;
        }
        (0, $ftLbb.setActiveSub)(prevSub1);
        oldRecords = records;
        return records;
    };
}
function normalizeSource(source) {
    var values = source;
    var needsWrap = false;
    var isReadonlySource = false;
    var keys;
    if ((0, $6zvdv.isArray)(source)) {
        if ((0, $ftLbb.isReactive)(source)) {
            needsWrap = !(0, $ftLbb.isShallow)(source);
            values = (0, $ftLbb.shallowReadArray)(source);
            isReadonlySource = (0, $ftLbb.isReadonly)(source);
        }
    } else if ((0, $6zvdv.isString)(source)) values = source.split("");
    else if (typeof source === "number") {
        values = new Array(source);
        for(var i = 0; i < source; i++)values[i] = i + 1;
    } else if ((0, $6zvdv.isObject)(source)) {
        if (source[Symbol.iterator]) values = Array.from(source);
        else {
            keys = Object.keys(source);
            values = new Array(keys.length);
            for(var i1 = 0, l = keys.length; i1 < l; i1++)values[i1] = source[keys[i1]];
        }
    } else values = [];
    return {
        values: values,
        needsWrap: needsWrap,
        isReadonlySource: isReadonlySource,
        keys: keys
    };
}
function getItemValue(param, idx) {
    var values = param.values, needsWrap = param.needsWrap, isReadonlySource = param.isReadonlySource;
    return needsWrap ? isReadonlySource ? (0, $ftLbb.toReadonly)((0, $ftLbb.toReactive)(values[idx])) : (0, $ftLbb.toReactive)(values[idx]) : values[idx];
}
function getItem(source, idx) {
    var value = getItemValue(source, idx);
    if (source.keys) return [
        value,
        source.keys[idx],
        idx
    ];
    else return [
        value,
        idx,
        void 0
    ];
}
function getRestElement(val, keys) {
    var res = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(val)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!keys.includes(key)) res[key] = val[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return res;
}
function getDefaultValue(val, getDefaultVal) {
    return val === void 0 ? getDefaultVal() : val;
}
//#endregion
//#region packages/runtime-vapor/src/apiTemplateRef.ts
function getTemplateRefUpdateFragment(el) {
    if (isDynamicFragment(el)) return el;
    if (isAsyncComponentEnabled && isVaporComponent(el) && (0, $fKAHx.isAsyncWrapper)(el)) return el.block;
}
/**
* Async/dynamic component targets swap their inner block on update, so the ref
* has to be re-applied after the fragment settles. Registration is idempotent
* per (el, owner) pair: `getTemplateRefUpdateFragment` reads the async
* wrapper's mutable `block`, so the resolved fragment is compared by identity
* rather than with a "registered once" flag.
*/ function registerFragmentRefUpdate(el, registeredFrag, reapply) {
    var frag = getTemplateRefUpdateFragment(el);
    if (frag && registeredFrag !== frag) {
        (frag.u || (frag.u = [])).push(function() {
            if (isVaporComponent(el) && el.isDeactivated) return;
            reapply();
        });
        return frag;
    }
    return registeredFrag;
}
function ensureCleanup(el) {
    var cleanupRef = refCleanups.get(el);
    if (!cleanupRef) {
        refCleanups.set(el, cleanupRef = {
            fn: (0, $6zvdv.NOOP)
        });
        (0, $ftLbb.onScopeDispose)(function() {
            invalidatePendingRef(el);
            cleanupRef.fn();
            refCleanups.delete(el);
        });
    }
    return cleanupRef;
}
function createTemplateRefSetter() {
    var instance = getScopeOwner();
    var stateMap = /* @__PURE__ */ new WeakMap();
    return function(el, ref, refFor, refKey) {
        var state = stateMap.get(el);
        if (!state) stateMap.set(el, state = {
            ref: ref,
            suspense: currentRenderContext.suspense
        });
        setTemplateRefWithState(instance, el, state, ref, refFor, refKey);
    };
}
function setTemplateRefWithState(instance, el, state, ref, refFor, refKey) {
    state.ref = ref;
    state.refFor = refFor;
    state.refKey = refKey;
    state.registeredFrag = registerFragmentRefUpdate(el, state.registeredFrag, function() {
        setRef$1(instance, state.suspense, el, state.ref, state.oldRef, state.refFor, state.refKey, state.oldRefKey);
        state.oldRef = state.ref;
        state.oldRefKey = state.ref != null ? state.refKey : void 0;
    });
    setRef$1(instance, state.suspense, el, ref, state.oldRef, refFor, refKey, state.oldRefKey);
    state.oldRef = ref;
    state.oldRefKey = ref != null ? refKey : void 0;
}
/**
* Static refs never change value, so they need no old-ref tracking and no
* per-element state - only the fragment re-apply hook shared with the
* stateful path.
*/ function setStaticTemplateRef(el, ref, refFor, refKey) {
    var instance = getScopeOwner();
    var suspense = currentRenderContext.suspense;
    setRef$1(instance, suspense, el, ref, void 0, refFor, refKey);
    registerFragmentRefUpdate(el, void 0, function() {
        setRef$1(instance, suspense, el, ref, ref, refFor, refKey);
    });
}
function setTemplateRefBinding(el, getter, refFor, refKey) {
    var instance = getScopeOwner();
    var state;
    renderEffect(function() {
        var ref = getter();
        if (!state) state = {
            ref: ref,
            suspense: currentRenderContext.suspense
        };
        setTemplateRefWithState(instance, el, state, ref, refFor, refKey);
    });
}
/**
* Function for handling a template ref
*/ function setRef$1(instance, suspense, el, ref, oldRef) {
    var refFor = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, refKey = arguments.length > 6 ? arguments[6] : void 0, oldRefKey = arguments.length > 7 ? arguments[7] : void 0;
    if (!instance || instance.isUnmounted) return;
    var setupState = null;
    var refValue = getRefValue(el);
    if (isInteropEnabled) {
        var target = isFragment(el) && el.setRef ? el : refValue && isFragment(refValue) && refValue.setRef ? refValue : null;
        if (target) {
            target.setRef(instance, ref, refFor, refKey);
            return;
        }
    }
    var refs = instance.refs === (0, $6zvdv.EMPTY_OBJ) ? instance.refs = {} : instance.refs;
    var canSetSetupRef = (0, $6zvdv.NO);
    var canSetRef = function(ref, key) {
        if (key && (0, $fKAHx.isTemplateRefKey)(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        invalidatePendingRef(el);
        if ((0, $6zvdv.isString)(oldRef)) refs[oldRef] = null;
        else if ((0, $ftLbb.isRef)(oldRef)) {
            if (canSetRef(oldRef, oldRefKey)) oldRef.value = null;
            if (oldRefKey) refs[oldRefKey] = null;
        } else if ((0, $6zvdv.isFunction)(oldRef) && isDynamicFragment(el)) (0, $fKAHx.callWithErrorHandling)(oldRef, instance, 12, [
            null,
            refs
        ]);
    } else if (oldRef != null && isDynamicFragment(el)) {
        if ((0, $6zvdv.isFunction)(oldRef)) (0, $fKAHx.callWithErrorHandling)(oldRef, instance, 12, [
            null,
            refs
        ]);
        else if (refFor) unsetRef(el);
    }
    if (ref == null) return;
    if ((0, $6zvdv.isFunction)(ref)) {
        var invokeRefSetter = function(value) {
            (0, $fKAHx.callWithErrorHandling)(ref, instance, 12, [
                value,
                refs
            ]);
        };
        invokeRefSetter(refValue);
        ensureCleanup(el).fn = function() {
            return invokeRefSetter(null);
        };
    } else {
        var _isString = (0, $6zvdv.isString)(ref);
        var _isRef = (0, $ftLbb.isRef)(ref);
        var existing;
        if (_isString || _isRef) {
            var doSet = function() {
                if (refFor) {
                    if (refValue == null) return;
                    existing = _isString ? (0, refs[ref]) : canSetRef(ref) || !refKey ? ref.value : refs[refKey];
                    if (!(0, $6zvdv.isArray)(existing)) {
                        existing = [
                            refValue
                        ];
                        if (_isString) refs[ref] = existing;
                        else {
                            if (canSetRef(ref, refKey)) ref.value = existing;
                            if (refKey) refs[refKey] = existing;
                        }
                    } else if (!existing.includes(refValue)) existing.push(refValue);
                } else if (_isString) refs[ref] = refValue;
                else if (_isRef) {
                    if (canSetRef(ref, refKey)) ref.value = refValue;
                    if (refKey) refs[refKey] = refValue;
                }
            };
            var cleanup = ensureCleanup(el);
            cleanup.fn = function() {
                if (refFor) {
                    if ((0, $6zvdv.isArray)(existing)) (0, $6zvdv.remove)(existing, refValue);
                } else if (_isString) refs[ref] = null;
                else if (_isRef) {
                    if (canSetRef(ref, refKey)) ref.value = null;
                    if (refKey) refs[refKey] = null;
                }
            };
            invalidatePendingRef(el);
            if (refValue != null) {
                var job = function() {
                    doSet();
                    if (cleanup.job === job) cleanup.job = void 0;
                };
                cleanup.job = job;
                (0, $fKAHx.queuePostRenderEffect)(job, -1, suspense);
            } else doSet();
        }
    }
}
var getRefValue = function(el) {
    if (isVaporComponent(el)) {
        if (isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(el)) {
            var inner = getAsyncWrapperInner(el);
            if (inner === void 0) return null;
            return getRefValue(inner);
        }
        return getExposed(el) || el;
    } else if (isTeleportEnabled && isTeleportFragment(el)) return null;
    else if (isDynamicFragment(el)) {
        if ((0, $6zvdv.isArray)(el.nodes)) return null;
        return getRefValue(el.nodes);
    }
    return el;
};
//#endregion
//#region packages/runtime-vapor/src/apiCreateDynamicComponent.ts
function createDynamicComponent(getter, rawProps, rawSlots) {
    var flags = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, key = arguments.length > 4 ? arguments[4] : void 0;
    var isSingleRoot = !!(flags & 1);
    var once = !!(flags & 2);
    var slotRoot = !!(flags & 4);
    var ns = flags & 8 ? 1 : flags & 16 ? 2 : void 0;
    var _insertionParent = insertionParent;
    var _insertionAnchor = insertionAnchor;
    if (!isHydrating$1) resetInsertionState();
    var normalizedRawSlots = normalizeRawSlots(rawSlots);
    var scopeOwner = getScopeOwner();
    var render = function(value, resolved, appContext) {
        if (isBlock(value)) return value;
        if (isInteropEnabled && appContext.vdom && (0, $fKAHx.isVNode)(value)) return appContext.vdom.mountVNode(value, (0, $fKAHx.currentInstance), isSingleRoot);
        return createComponentWithFallback(resolved, rawProps, normalizedRawSlots, isSingleRoot, once, ns, appContext);
    };
    if (once) {
        var hydrationCursor = isHydrating$1 ? enterHydrationCursor() : null;
        var value = getter();
        var appContext = getAppContext();
        var block = render(value, resolveValue(value, appContext, scopeOwner), appContext);
        finishBlockCreation(block, void 0, hydrationCursor, _insertionParent, _insertionAnchor);
        return block;
    }
    var hydrationCursor1 = isHydrating$1 ? captureHydrationCursor() : null;
    var frag = new DynamicFragment(0, void 0, false, slotRoot, slotRoot ? function() {
        var nodes = frag.nodes;
        if (nodes instanceof Node) {
            var parent = nodes.parentNode;
            if (parent) removeNode(nodes, parent);
        }
        var anchorParent = frag.anchor.parentNode;
        if (anchorParent) removeNode(frag.anchor, anchorParent);
    } : void 0, _insertionAnchor);
    if (isHydrating$1) locateHydrationNode();
    var lastKey;
    var lastResolved;
    var branchToken;
    renderEffect(function() {
        var value = getter();
        var userKey = key ? key() : void 0;
        var appContext = getAppContext();
        var resolved = resolveValue(value, appContext, scopeOwner);
        if (resolved === (0, $fKAHx.NULL_DYNAMIC_COMPONENT)) {
            frag.update(void 0, resolved);
            return;
        }
        var branchKey = resolved;
        if (key) {
            if (userKey !== lastKey || resolved !== lastResolved) {
                lastKey = userKey;
                lastResolved = resolved;
                branchToken = {};
            }
            branchKey = branchToken;
        }
        if (branchKey === frag.current && !isHydrating$1) return;
        frag.update(function() {
            return render(value, resolved, appContext);
        }, branchKey, false, userKey);
    });
    finishBlockCreation(frag, frag.anchor, hydrationCursor1, _insertionParent, _insertionAnchor);
    return frag;
}
function getAppContext() {
    return (0, $fKAHx.currentInstance) && (0, $fKAHx.currentInstance).appContext || emptyContext;
}
function resolveValue(value, appContext, scopeOwner) {
    if (isBlock(value) || isInteropEnabled && appContext.vdom && (0, $fKAHx.isVNode)(value)) return value;
    var resolved = withScopeOwner(scopeOwner, function() {
        return (0, $fKAHx.resolveDynamicComponent)(value);
    });
    var type = typeof resolved === "undefined" ? "undefined" : (0, $7E0eS._)(resolved);
    if (!resolved || type !== "string" && type !== "object" && type !== "function" && type !== "symbol") return 0, $fKAHx.NULL_DYNAMIC_COMPONENT;
    return resolved;
}
function withScopeOwner(owner, fn) {
    var prev = (0, $fKAHx.setCurrentRenderingInstance)(owner);
    try {
        return fn();
    } finally{
        (0, $fKAHx.setCurrentRenderingInstance)(prev);
    }
}
//#endregion
//#region packages/runtime-vapor/src/directives/vShow.ts
/**
* v-show is root-inherited state: it lands on the effective root element of
* `target`, and any producer on the root chain (dynamic fragment branch,
* interop subtree, pending async setup) can replace that root later. `apply`
* resolves the root through the shared chain walker and registers itself on
* every producer it passes, so a replacement root re-enters `apply` and
* registers the producers inside it in turn.
*/ function applyVShow(target, source) {
    var value;
    var transition;
    var unresolved = false;
    var slotRoot = false;
    var visitor = {
        onComponent: function(instance) {
            if (isSuspenseEnabled && instance.asyncDep && !instance.asyncResolved) {
                if (!instance.$vshow) (instance.bm || (instance.bm = [])).push(function() {
                    return apply(instance.block);
                });
                unresolved = true;
                mark(instance);
                return true;
            }
            mark(instance);
        },
        onDynamicFragment: function(frag) {
            if (isSlotOutletFragment(frag)) return slotRoot = true;
            mark(frag);
            register(frag.bm || (frag.bm = []), apply);
        }
    };
    if (isInteropEnabled) visitor.onInteropFragment = function(frag) {
        if (isSlotOutletFragment(frag)) return slotRoot = true;
        mark(frag);
        if (isTransitionEnabled && frag.$transition) transition = frag.$transition;
        register(frag.u || (frag.u = []), apply);
        if (!isValidBlock(frag.nodes)) unresolved = true;
    };
    var apply = function(nodes) {
        transition = void 0;
        unresolved = slotRoot = false;
        var root = getRootElement(nodes, visitor);
        if (root) setDisplay(root, value, transition);
    };
    renderEffect(function() {
        value = source();
        apply(target);
    });
}
function mark(block) {
    block.$vshow = true;
}
function register(hooks, hook) {
    if (!hooks.includes(hook)) hooks.push(hook);
}
function setDisplay(el, value, transition) {
    var hidden = !value;
    if (!((0, $3ewO8.vShowOriginalDisplay) in el)) {
        mark(el);
        el[0, $3ewO8.vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        el[0, $3ewO8.vShowHidden] = hidden;
        writeDisplay(el, value);
        return;
    }
    if (el[0, $3ewO8.vShowHidden] === hidden) return;
    el[0, $3ewO8.vShowHidden] = hidden;
    var $transition = isTransitionEnabled ? el.$transition || transition : void 0;
    if ($transition) {
        var prevSub = (0, $ftLbb.setActiveSub)();
        try {
            if (value) {
                $transition.beforeEnter(el);
                el.style.display = el[0, $3ewO8.vShowOriginalDisplay];
                $transition.enter(el);
            } else if (el.isConnected) $transition.leave(el, function() {
                el.style.display = "none";
            });
            else el.style.display = "none";
        } finally{
            (0, $ftLbb.setActiveSub)(prevSub);
        }
    } else writeDisplay(el, value);
}
function writeDisplay(el, value) {
    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && isHydrating$1) {
        var hidden = el.style.display === "none";
        if (!value === hidden) return;
        var expected = value ? el[0, $3ewO8.vShowOriginalDisplay] : "none";
        if ((0, $fKAHx.warnPropMismatch)(el, "style", 3, "display: ".concat(el.style.display), expected ? "display: ".concat(expected) : false)) (0, $fKAHx.logMismatchError)();
    }
    el.style.display = value ? el[0, $3ewO8.vShowOriginalDisplay] : "none";
}
//#endregion
//#region packages/runtime-vapor/src/directives/vModel.ts
function ensureMounted(cb) {
    if ((0, $fKAHx.currentInstance).isMounted) cb();
    else (0, $fKAHx.onMounted)(inOnce ? function() {
        return withOnce(cb);
    } : cb);
}
var applyTextModel = function(el, get, set) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, trim = _ref.trim, number = _ref.number, lazy = _ref.lazy;
    (0, $3ewO8.vModelTextInit)(el, trim, number, lazy, set);
    ensureMounted(function() {
        var value;
        renderEffect(function() {
            (0, $3ewO8.vModelTextUpdate)(el, value, value = get(), trim, number, lazy);
        });
    });
};
var applyCheckboxModel = function(el, get, set) {
    (0, $3ewO8.vModelCheckboxInit)(el, set);
    ensureMounted(function() {
        var value;
        renderEffect(function() {
            (0, $3ewO8.vModelCheckboxUpdate)(el, value, (0, $ftLbb.traverse)(value = get()));
        });
    });
};
var applyRadioModel = function(el, get, set) {
    el.addEventListener("change", function() {
        return set((0, $3ewO8.vModelGetValue)(el));
    });
    ensureMounted(function() {
        var value;
        renderEffect(function() {
            if (value !== (value = get())) el.checked = (0, $6zvdv.looseEqual)(value, (0, $3ewO8.vModelGetValue)(el));
        });
    });
};
var applySelectModel = function(el, get, set, modifiers) {
    (0, $3ewO8.vModelSelectInit)(el, get(), modifiers && modifiers.number, set);
    ensureMounted(function() {
        renderEffect(function() {
            return (0, $3ewO8.vModelSetSelected)(el, (0, $ftLbb.traverse)(get()));
        });
    });
};
var applyDynamicModel = function(el, get, set, modifiers) {
    var apply = applyTextModel;
    if (el.tagName === "SELECT") apply = applySelectModel;
    else if (el.tagName === "TEXTAREA") apply = applyTextModel;
    else if (el.type === "checkbox") apply = applyCheckboxModel;
    else if (el.type === "radio") apply = applyRadioModel;
    apply(el, get, set, modifiers);
};
//#endregion
//#region packages/runtime-vapor/src/directives/custom.ts
function withVaporDirectives(node, dirs) {
    if (node instanceof Element) {
        applyDirectivesToElement(node, dirs, (0, $fKAHx.currentInstance));
        return;
    }
    var instance = (0, $fKAHx.currentInstance);
    var once = inOnce;
    var currentElement = null;
    var directiveScope;
    var disposed = false;
    var pending = false;
    var pendingSetups;
    var visitor = {
        onDynamicFragment: track,
        onComponent: function(block) {
            if (isSuspenseEnabled && block.asyncDep && !block.asyncResolved) {
                pending = true;
                if (!(pendingSetups || (pendingSetups = /* @__PURE__ */ new WeakSet())).has(block)) {
                    pendingSetups.add(block);
                    (0, $fKAHx.onBeforeMount)(applyDirectives, block);
                }
                return true;
            }
            if (isAsyncComponentEnabled && (0, $fKAHx.isAsyncWrapper)(block)) {
                var inner = block.block;
                if (isFragment(inner) && inner.nodes === EMPTY_BLOCK) pending = true;
            }
        },
        excludeSlotOutlets: true
    };
    if (isInteropEnabled) visitor.onInteropFragment = function(frag) {
        if (frag.nodes === EMPTY_BLOCK) pending = true;
        track(frag);
    };
    function stopDirectiveScope() {
        if (directiveScope) {
            directiveScope.stop();
            directiveScope = void 0;
        }
    }
    function track(frag) {
        var u = frag.u || (frag.u = []);
        if (u.includes(applyDirectives)) return;
        u.push(applyDirectives);
        if (isDynamicFragment(frag)) (frag.bu || (frag.bu = [])).push(function() {
            if (currentElement && getRootElement(frag.nodes) === currentElement) {
                currentElement = null;
                stopDirectiveScope();
            }
        });
    }
    function applyDirectives() {
        if (disposed) return;
        pending = false;
        var element = getRootElement(node, visitor);
        if (!element && pending) {
            if (currentElement !== null) {
                currentElement = null;
                stopDirectiveScope();
            }
            return;
        }
        if (element === currentElement) return;
        currentElement = element;
        stopDirectiveScope();
        if (!element) return;
        directiveScope = new (0, $ftLbb.EffectScope)(true);
        var prev = (0, $fKAHx.setCurrentInstance)(instance, directiveScope);
        try {
            if (once) withOnce(function() {
                return applyDirectivesToElement(element, dirs, instance);
            });
            else applyDirectivesToElement(element, dirs, instance);
        } finally{
            (0, $fKAHx.restoreCurrentInstance)(prev);
        }
    }
    (0, $ftLbb.onScopeDispose)(function() {
        disposed = true;
        stopDirectiveScope();
    }, true);
    applyDirectives();
}
function applyDirectivesToElement(element, dirs, instance) {
    var hookCounts = null;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $f9AOD._)(_step.value, 4), dir = _step_value[0], value = _step_value[1], argument = _step_value[2], modifiers = _step_value[3];
            if (dir) {
                if (!(0, $6zvdv.isFunction)(dir)) return "continue";
                var ret = (0, $fKAHx.callWithErrorHandling)(dir, instance, 8, [
                    element,
                    value,
                    argument,
                    modifiers
                ]);
                if (ret) (0, $ftLbb.onScopeDispose)(function() {
                    return (0, $fKAHx.callWithErrorHandling)(ret, instance, 8);
                });
            }
        };
        for(var _iterator = dirs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var lifecycleHookNames = {};
function countLifecycleHooks(instance) {
    var counts = [];
    for(var key in lifecycleHookNames){
        var hooks = instance[key];
        counts.push(hooks ? hooks.length : 0);
    }
    return counts;
}
function warnLifecycleHooks(instance, before) {
    var i = 0;
    for(var key in lifecycleHookNames){
        var hooks = instance[key];
        if (hooks && hooks.length > before[i]) (0, $fKAHx.warn)("".concat(lifecycleHookNames[key], "() was called inside a custom directive. Lifecycle hooks are not supported in Vapor directives: they attach to the component, not the element. Use watchPostEffect() for work that needs the element in the DOM, and return a cleanup function for teardown."));
        i++;
    }
}
//#endregion
//#region packages/runtime-vapor/src/components/TransitionGroup.ts
var positionMap = /* @__PURE__ */ new WeakMap();
var newPositionMap = /* @__PURE__ */ new WeakMap();
var trackedTransitionGroupOwners = /* @__PURE__ */ new WeakSet();
var decorate = function(t) {
    delete t.props.mode;
    return t;
};
var VaporTransitionGroup = /*@__PURE__*/ decorate(/* @__PURE__ */ defineVaporComponent({
    name: "VaporTransitionGroup",
    props: /*@__PURE__*/ (0, $6zvdv.extend)({}, (0, $3ewO8.TransitionPropsValidators), {
        tag: String,
        moveClass: String
    }),
    setup: function(props, param) {
        var slots = param.slots, expose = param.expose;
        expose();
        if (!isTransitionEnabled) registerTransitionHooks(applyTransitionHooksImpl, function() {
            return false;
        }, function() {
            return false;
        }, function() {
            return false;
        });
        var instance = (0, $fKAHx.currentInstance);
        var state = (0, $fKAHx.useTransitionState)();
        var cssTransitionProps;
        var propsProxy = new Proxy({}, {
            get: function(_, key) {
                return cssTransitionProps[key];
            }
        });
        var prevChildren = [];
        var isUpdatePending = false;
        var isUpdatedPending = false;
        var slottedBlock = [];
        var beforeUpdate = function() {
            if (isUpdatePending) return;
            isUpdatePending = true;
            prevChildren = [];
            var children = resolveTransitionBlocks(slottedBlock, void 0, void 0, true);
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var el = isValidTransitionBlock(child) && child.$transition ? getTransitionElement(child) : void 0;
                if (el && !el[0, $3ewO8.vShowHidden]) {
                    prevChildren.push(child);
                    positionMap.set(child, el.getBoundingClientRect());
                }
            }
        };
        var flushUpdated = function() {
            isUpdatedPending = false;
            if (!isUpdatePending) return;
            isUpdatePending = false;
            if (!prevChildren.length) return;
            var moveClass = props.moveClass || "".concat(props.name || "v", "-move");
            var firstChild = getFirstConnectedChild(prevChildren);
            if (!!!(firstChild && (0, $3ewO8.hasCSSTransform)(firstChild, firstChild.parentNode, moveClass))) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach(function(child) {
                var el = getTransitionElement(child);
                if (el) (0, $3ewO8.callPendingCbs)(el);
            });
            prevChildren.forEach(recordPosition);
            var movedChildren = prevChildren.filter(applyTranslation);
            (0, $3ewO8.forceReflow)(firstChild);
            movedChildren.forEach(function(c) {
                return (0, $3ewO8.handleMovedChildren)(getTransitionElement(c), moveClass);
            });
            prevChildren = [];
        };
        var updated = function() {
            if (!isUpdatePending || isUpdatedPending) return;
            isUpdatedPending = true;
            (0, $fKAHx.queuePostRenderEffect)(flushUpdated, void 0, instance.suspense);
        };
        (0, $fKAHx.onBeforeUpdate)(beforeUpdate);
        (0, $fKAHx.onUpdated)(updated);
        var updateHooks = {
            beforeUpdate: beforeUpdate,
            updated: updated
        };
        if (isHydrating$1) locateHydrationNode();
        var tag = props.tag;
        var isMounted = false;
        renderEffect(function() {
            cssTransitionProps = (0, $3ewO8.resolveTransitionProps)(props);
            if (isMounted) applyGroupTransitionHooks(slottedBlock, propsProxy, state, instance, updateHooks);
        }, true);
        var createContainer = function() {
            return tag ? isHydrating$1 ? adoptTemplate(currentHydrationNode, "<".concat(tag, "/>")) : /* @__PURE__ */ createElement(tag) : void 0;
        };
        var renderChildren = function(slot, container) {
            var run = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(render) {
                return render();
            };
            var nextNode = null;
            var prevMarkerlessContainer = null;
            var prevTransitionChildPending = false;
            if (isHydrating$1 && container) {
                prevMarkerlessContainer = setMarkerlessHydrationContainer(container);
                prevTransitionChildPending = setTransitionChildPending(true);
                nextNode = nextLogicalSibling(container);
                setCurrentHydrationNode(container.firstChild || container);
            }
            var transitionBlocks = [];
            try {
                run(function() {
                    var block = slot && slot() || [];
                    transitionBlocks = applyGroupTransitionHooks(block, propsProxy, state, instance, updateHooks);
                    slottedBlock = block;
                    if (container) {
                        if (!isHydrating$1) insert(block, container);
                        registerNestedVDOMCleanup(block);
                        return container;
                    }
                    return block;
                });
                if (isHydrating$1 && container && currentHydrationNode && currentHydrationNode.parentNode === container && !transitionBlocks.some(function(child) {
                    return child === currentHydrationNode;
                })) cleanupHydrationTail(currentHydrationNode, container);
            } finally{
                if (isHydrating$1 && container) {
                    setMarkerlessHydrationContainer(prevMarkerlessContainer);
                    setTransitionChildPending(prevTransitionChildPending);
                    setCurrentHydrationNode(nextNode);
                }
            }
            isMounted = true;
        };
        if (!instance.rawSlots.$) {
            var container = createContainer();
            renderChildren(slots.default, container);
            return container || slottedBlock;
        }
        var frag = new DynamicFragment(0, void 0);
        var currentSlot;
        renderEffect(function() {
            var slot = slots.default;
            if (isMounted && slot === currentSlot) return;
            renderChildren(slot, createContainer(), function(render) {
                return frag.update(render);
            });
            currentSlot = slot;
        });
        return frag;
    }
}));
function resolveTransitionBlocks(block, onFragment, onUpdateOwner) {
    var collectOnly = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var children = [];
    if (collectOnly) {
        collectTransitionBlocks(block, children, onFragment, onUpdateOwner);
        return children;
    }
    var keys = /* @__PURE__ */ new Map();
    collectTransitionBlocks(block, children, onFragment, onUpdateOwner, keys, ROOT_KEY_CONTEXT);
    for(var i = 0; i < children.length; i++)setTransitionKey(children[i], keys.get(children[i]));
    return children;
}
function collectTransitionBlocks(block, children, onFragment, onUpdateOwner, keys, ctx) {
    if (block instanceof Node) {
        if (block instanceof Element) {
            children.push(block);
            if (keys) keys.set(block, block.$key);
        }
    } else if (isVaporComponent(block)) {
        var isRootSlot = block.block && isVaporSlotOutlet(block.block);
        if (onUpdateOwner && !isRootSlot) onUpdateOwner(block);
        var start = children.length;
        collectTransitionBlocks(block.block, children, onFragment, isRootSlot ? onUpdateOwner : void 0, keys, ctx && (isRootSlot ? withDefaultKey(ctx, block.$key) : enterComponentKeyContext(ctx, block)));
        if (keys) {
            if (!isRootSlot) {
                var t = transitionTypeOf(block);
                for(var i = start; i < children.length; i++)setTransitionType(children[i], t);
            }
            resolveOwnerKey(children, start, block.$key, keys, !isRootSlot);
        }
    } else if ((0, $6zvdv.isArray)(block)) for(var i1 = 0; i1 < block.length; i1++)collectTransitionBlocks(block[i1], children, onFragment, onUpdateOwner, keys, ctx);
    else if (isFragment(block)) {
        var isItem = isForBlock(block);
        if (!isItem) {
            if (onFragment) onFragment(block);
            if (onUpdateOwner) onUpdateOwner(block);
        }
        if (isInteropEnabled && block.hasVDOMContent && block.hasVDOMContent()) {
            children.push(block);
            if (keys) keys.set(block, block.$key);
        } else {
            var key = isItem ? block.key : getFragmentKey(block);
            var start1 = children.length;
            collectTransitionBlocks(block.nodes, children, onFragment, onUpdateOwner, keys, ctx && enterFragmentKeyContext(block, ctx, key));
            if (!keys) return;
            if (!isItem) resolveOwnerKey(children, start1, key, keys, false);
            else if (key != null) {
                if (children.length - start1 === 1) keys.set(children[start1], key);
                else for(var i2 = start1; i2 < children.length; i2++)keys.set(children[i2], "".concat(key, ":").concat(i2 - start1));
            }
        }
    }
}
function resolveOwnerKey(children, start, key, keys, final) {
    if (children.length - start === 1) {
        var child = children[start];
        if (final || keys.get(child) == null) keys.set(child, key);
        return;
    }
    if (key == null) return;
    for(var i = start; i < children.length; i++){
        var child1 = children[i];
        var inner = keys.get(child1);
        keys.set(child1, String(key) + String(inner != null ? inner : i - start));
    }
}
function applyGroupTransitionHooks(block, props, state, instance, updateHooks) {
    var fragments = [];
    var children = resolveTransitionBlocks(block, function(frag) {
        return fragments.push(frag);
    }, function(owner) {
        return trackTransitionGroupUpdate(owner, instance, updateHooks);
    });
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if (isValidTransitionBlock(child)) {
            if (getTransitionKey(child) != null) child.$transition = resolveTransitionHooks(child, props, state, instance);
        }
    }
    fragments.forEach(function(frag) {
        var hooks = resolveTransitionHooks(frag, props, state, instance);
        hooks.applyGroup = function(block, props, state, instance) {
            return applyGroupTransitionHooks(block, props, state, instance, updateHooks);
        };
        frag.$transition = hooks;
    });
    return children;
}
function trackTransitionGroupUpdate(owner, instance, updateHooks) {
    if (trackedTransitionGroupOwners.has(owner)) return;
    if (isFragment(owner)) {
        trackedTransitionGroupOwners.add(owner);
        (owner.bu || (owner.bu = [])).push(updateHooks.beforeUpdate);
        (owner.u || (owner.u = [])).push(updateHooks.updated);
        return;
    }
    if (!hasDynamicPropsSource(owner.rawProps)) return;
    trackedTransitionGroupOwners.add(owner);
    var prevGroup = (0, $fKAHx.setCurrentInstance)(instance, owner.scope);
    try {
        renderEffect(function() {
            var prev = (0, $fKAHx.setCurrentInstance)(owner, owner.scope);
            try {
                resolveDynamicProps(owner.rawProps);
            } finally{
                (0, $fKAHx.restoreCurrentInstance)(prev);
            }
        });
    } finally{
        (0, $fKAHx.restoreCurrentInstance)(prevGroup);
    }
}
function hasDynamicPropsSource(props) {
    if (props.$) return true;
    for(var key in props)if (key !== "$" && (0, $6zvdv.isFunction)(props[key])) return true;
    return false;
}
function recordPosition(c) {
    var el = getTransitionElement(c);
    if (el) newPositionMap.set(c, el.getBoundingClientRect());
}
function applyTranslation(c) {
    var el = getTransitionElement(c);
    if (el && (0, $3ewO8.baseApplyTranslation)(positionMap.get(c), newPositionMap.get(c), el)) return c;
}
function getFirstConnectedChild(children) {
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        var el = getTransitionElement(child);
        if (el && el.isConnected) return el;
    }
}

});


parcelRegister("h2kUE", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });

var $7E0eS = parcelRequire("7E0eS");
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function ownKeys(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if ((typeof key === "undefined" ? "undefined" : (0, $7E0eS._)(key)) === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $7E0eS._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i)) ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return (typeof context === "undefined" ? "undefined" : (0, $7E0eS._)(context)) == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var _$mthd = initMthd;
        if (!isAction(_$mthd)) _$mthd = _createAction(_$mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            _$mthd = _$mthd.bind(this);
            _$mthd.isMobxAction = true;
        }
        return _$mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    var computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        var options = _extends({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        return new ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        var adm = asObservableObject(this)[$mobx];
        var target = this;
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) adm.values_["delete"](key);
        ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys : adm.lazyComputedKeys_ = new Map()).set(key, function() {
            return createComputedValue(target, adm);
        });
    });
    return function() {
        var adm = this[$mobx];
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) {
            var _computedValues;
            var computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        var adm = asObservableObject(target)[$mobx];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, function() {
            var _ann$options_$enhance, _ann$options_;
            return new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        });
        return adm;
    }
    return {
        get: function get() {
            var _this$$mobx;
            var adm = (_this$$mobx = this[$mobx]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set: function set(value) {
            var _this$$mobx2;
            var adm = (_this$$mobx2 = this[$mobx]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init: function init(value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if ((typeof v === "undefined" ? "undefined" : (0, $7E0eS._)(v)) === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && (0, $7E0eS._)(Symbol.dispose) === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
var FlowCancellationError = /*#__PURE__*/ function(_Error) {
    function FlowCancellationError() {
        var _this;
        _this = _Error.call(this, "FLOW_CANCELLED") || this;
        Object.setPrototypeOf(_this, (this instanceof FlowCancellationError ? this.constructor : void 0).prototype);
        _this.name = "FlowCancellationError";
        return _this;
    }
    _inheritsLoose(FlowCancellationError, _Error);
    var _proto = FlowCancellationError.prototype;
    _proto.toString = function toString() {
        return "Error: " + this.message;
    };
    return FlowCancellationError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    var adm = value[$mobx];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            var adm = value[$mobx];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || (typeof source === "undefined" ? "undefined" : (0, $7E0eS._)(source)) !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && (typeof arg1 === "undefined" ? "undefined" : (0, $7E0eS._)(arg1)) === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if ((typeof name === "undefined" ? "undefined" : (0, $7E0eS._)(name)) === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.getOrInsert = function getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    };
    _proto.getOrInsertComputed = function getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        var observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    };
    _proto.materializeLazyComputed_ = function materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        var factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_["delete"](key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        var computed = factory();
        this.values_.set(key, computed);
        return computed;
    };
    _proto.materializeLazyObservable_ = function materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        var factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_["delete"](key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = undefined;
        var observable = factory();
        this.values_.set(key, observable);
        return observable;
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        var observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if ((typeof thing === "undefined" ? "undefined" : (0, $7E0eS._)(thing)) === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            var _ref, _adm$values_$get;
            if (!property) return die(26);
            var adm = thing[$mobx];
            var _observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a === "undefined" ? "undefined" : (0, $7E0eS._)(a);
    if (type !== "function" && type !== "object" && (typeof b === "undefined" ? "undefined" : (0, $7E0eS._)(b)) != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if ((typeof a === "undefined" ? "undefined" : (0, $7E0eS._)(a)) != "object" || (typeof b === "undefined" ? "undefined" : (0, $7E0eS._)(b)) != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _global$Iterator;
// safely get iterator prototype if available
var global$1 = /*#__PURE__*/ getGlobal();
var maybeIteratorPrototype = ((_global$Iterator = global$1.Iterator) == null ? void 0 : _global$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : (0, $7E0eS._)(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("2LnxQ", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $20323c11eee2dc3e$export$b3890eb0ae9dca99; });

var $aUGqu = parcelRequire("aUGqu");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
var $20323c11eee2dc3e$var$_hoisted_1 = {
    id: "nav",
    class: "flex flex-wrap justify-center gap-x-2 gap-y-1"
};
var $20323c11eee2dc3e$var$_hoisted_2 = {
    class: "rich-text mx-auto w-full max-w-6xl px-4 pb-12"
};
function $20323c11eee2dc3e$export$b3890eb0ae9dca99(_ctx, _cache) {
    var _component_router_link = (0, $fKAHx.resolveComponent)("router-link");
    var _component_router_view = (0, $fKAHx.resolveComponent)("router-view");
    return (0, $fKAHx.openBlock)(), (0, $fKAHx.createElementBlock)((0, $fKAHx.Fragment), null, [
        (0, $fKAHx.createElementVNode)("div", $20323c11eee2dc3e$var$_hoisted_1, [
            (0, $fKAHx.createVNode)(_component_router_link, {
                to: "/"
            }, {
                default: (0, $fKAHx.withCtx)(function() {
                    return (0, $aUGqu._)(_cache[0] || (_cache[0] = [
                        (0, $fKAHx.createTextVNode)("Home", -1)
                    ]));
                }),
                _: 1
            }),
            _cache[6] || (_cache[6] = (0, $fKAHx.createTextVNode)(" | ", -1)),
            (0, $fKAHx.createVNode)(_component_router_link, {
                to: "/decorator/class"
            }, {
                default: (0, $fKAHx.withCtx)(function() {
                    return (0, $aUGqu._)(_cache[1] || (_cache[1] = [
                        (0, $fKAHx.createTextVNode)("Decorator (class)", -1)
                    ]));
                }),
                _: 1
            }),
            _cache[7] || (_cache[7] = (0, $fKAHx.createTextVNode)(" | ", -1)),
            (0, $fKAHx.createVNode)(_component_router_link, {
                to: "/decorator/function"
            }, {
                default: (0, $fKAHx.withCtx)(function() {
                    return (0, $aUGqu._)(_cache[2] || (_cache[2] = [
                        (0, $fKAHx.createTextVNode)("Decorator (function)", -1)
                    ]));
                }),
                _: 1
            }),
            _cache[8] || (_cache[8] = (0, $fKAHx.createTextVNode)(" | ", -1)),
            (0, $fKAHx.createVNode)(_component_router_link, {
                to: "/component"
            }, {
                default: (0, $fKAHx.withCtx)(function() {
                    return (0, $aUGqu._)(_cache[3] || (_cache[3] = [
                        (0, $fKAHx.createTextVNode)("Component", -1)
                    ]));
                }),
                _: 1
            }),
            _cache[9] || (_cache[9] = (0, $fKAHx.createTextVNode)(" | ", -1)),
            (0, $fKAHx.createVNode)(_component_router_link, {
                to: "/chart"
            }, {
                default: (0, $fKAHx.withCtx)(function() {
                    return (0, $aUGqu._)(_cache[4] || (_cache[4] = [
                        (0, $fKAHx.createTextVNode)("Chart", -1)
                    ]));
                }),
                _: 1
            }),
            _cache[10] || (_cache[10] = (0, $fKAHx.createTextVNode)(" | ", -1)),
            (0, $fKAHx.createVNode)(_component_router_link, {
                to: "/about"
            }, {
                default: (0, $fKAHx.withCtx)(function() {
                    return (0, $aUGqu._)(_cache[5] || (_cache[5] = [
                        (0, $fKAHx.createTextVNode)("About", -1)
                    ]));
                }),
                _: 1
            })
        ]),
        (0, $fKAHx.createElementVNode)("main", $20323c11eee2dc3e$var$_hoisted_2, [
            (0, $fKAHx.createVNode)(_component_router_view)
        ])
    ], 64);
}

});

parcelRegister("b6j9v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $814f1c81ef0a2b7a$export$2e2bcd8739ae039; });
var $814f1c81ef0a2b7a$var$NOOP = function() {};
var $814f1c81ef0a2b7a$export$2e2bcd8739ae039 = function(script) {};

});

parcelRegister("1SdK7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $15d57e9fad4077d2$export$71511d61b312f219; });

var $2Ysl1 = parcelRequire("2Ysl1");

var $kg0zo = parcelRequire("kg0zo");

var $PC69E = parcelRequire("PC69E");

var $fyVjP = parcelRequire("fyVjP");
function $15d57e9fad4077d2$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $15d57e9fad4077d2$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $PC69E._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $2Ysl1._)(Class, arguments, (0, $kg0zo._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $fyVjP._)(Wrapper, Class);
    };
    return $15d57e9fad4077d2$export$71511d61b312f219(Class);
}

});
parcelRegister("2Ysl1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $22a72ab9392d6183$export$71511d61b312f219; });

var $euUQR = parcelRequire("euUQR");

var $fyVjP = parcelRequire("fyVjP");
function $22a72ab9392d6183$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $euUQR._)()) $22a72ab9392d6183$export$71511d61b312f219 = Reflect.construct;
    else $22a72ab9392d6183$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $fyVjP._)(instance, Class.prototype);
        return instance;
    };
    return $22a72ab9392d6183$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("PC69E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09b2510eb3fb01bb$export$71511d61b312f219; });
function $09b2510eb3fb01bb$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});


parcelRegister("9iKK3", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $6c5a0d6caccac2f9$export$a143d493d941bafc; }, function (v) { return $6c5a0d6caccac2f9$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $6c5a0d6caccac2f9$export$f99ded8fe4b79145; }, function (v) { return $6c5a0d6caccac2f9$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 
var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $hdIku = parcelRequire("hdIku");

var $7E0eS = parcelRequire("7E0eS");
var $6c5a0d6caccac2f9$export$a143d493d941bafc;
var $6c5a0d6caccac2f9$export$e4cf37d7f6fb9e0a;
var $6c5a0d6caccac2f9$export$f99ded8fe4b79145;
var $6c5a0d6caccac2f9$export$599f31c3813fae4d;
'use strict';

var $cOFqU = parcelRequire("cOFqU");

var $lqFFf = parcelRequire("lqFFf");
var $6c5a0d6caccac2f9$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$6c5a0d6caccac2f9$export$a143d493d941bafc = $6c5a0d6caccac2f9$var$Buffer;
$6c5a0d6caccac2f9$export$e4cf37d7f6fb9e0a = $6c5a0d6caccac2f9$var$SlowBuffer;
$6c5a0d6caccac2f9$export$f99ded8fe4b79145 = 50;
var $6c5a0d6caccac2f9$var$K_MAX_LENGTH = 0x7fffffff;
$6c5a0d6caccac2f9$export$599f31c3813fae4d = $6c5a0d6caccac2f9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $6c5a0d6caccac2f9$var$Buffer.TYPED_ARRAY_SUPPORT = $6c5a0d6caccac2f9$var$typedArraySupport();
if (!$6c5a0d6caccac2f9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $6c5a0d6caccac2f9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($6c5a0d6caccac2f9$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function get() {
        if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($6c5a0d6caccac2f9$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function get() {
        if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $6c5a0d6caccac2f9$var$createBuffer(length) {
    if (length > $6c5a0d6caccac2f9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $6c5a0d6caccac2f9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $6c5a0d6caccac2f9$var$allocUnsafe(arg);
    }
    return $6c5a0d6caccac2f9$var$from(arg, encodingOrOffset, length);
}
$6c5a0d6caccac2f9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $6c5a0d6caccac2f9$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $6c5a0d6caccac2f9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $6c5a0d6caccac2f9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)));
    if ($6c5a0d6caccac2f9$var$isInstance(value, ArrayBuffer) || value && $6c5a0d6caccac2f9$var$isInstance(value.buffer, ArrayBuffer)) return $6c5a0d6caccac2f9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($6c5a0d6caccac2f9$var$isInstance(value, SharedArrayBuffer) || value && $6c5a0d6caccac2f9$var$isInstance(value.buffer, SharedArrayBuffer))) return $6c5a0d6caccac2f9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $6c5a0d6caccac2f9$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $6c5a0d6caccac2f9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $6c5a0d6caccac2f9$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $6c5a0d6caccac2f9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $6c5a0d6caccac2f9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($6c5a0d6caccac2f9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($6c5a0d6caccac2f9$var$Buffer, Uint8Array);
function $6c5a0d6caccac2f9$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $6c5a0d6caccac2f9$var$alloc(size, fill, encoding) {
    $6c5a0d6caccac2f9$var$assertSize(size);
    if (size <= 0) return $6c5a0d6caccac2f9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $6c5a0d6caccac2f9$var$createBuffer(size).fill(fill, encoding) : $6c5a0d6caccac2f9$var$createBuffer(size).fill(fill);
    return $6c5a0d6caccac2f9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $6c5a0d6caccac2f9$var$Buffer.alloc = function(size, fill, encoding) {
    return $6c5a0d6caccac2f9$var$alloc(size, fill, encoding);
};
function $6c5a0d6caccac2f9$var$allocUnsafe(size) {
    $6c5a0d6caccac2f9$var$assertSize(size);
    return $6c5a0d6caccac2f9$var$createBuffer(size < 0 ? 0 : $6c5a0d6caccac2f9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $6c5a0d6caccac2f9$var$Buffer.allocUnsafe = function(size) {
    return $6c5a0d6caccac2f9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $6c5a0d6caccac2f9$var$Buffer.allocUnsafeSlow = function(size) {
    return $6c5a0d6caccac2f9$var$allocUnsafe(size);
};
function $6c5a0d6caccac2f9$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$6c5a0d6caccac2f9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $6c5a0d6caccac2f9$var$byteLength(string, encoding) | 0;
    var buf = $6c5a0d6caccac2f9$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $6c5a0d6caccac2f9$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $6c5a0d6caccac2f9$var$checked(array.length) | 0;
    var buf = $6c5a0d6caccac2f9$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $6c5a0d6caccac2f9$var$fromArrayView(arrayView) {
    if ($6c5a0d6caccac2f9$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $6c5a0d6caccac2f9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $6c5a0d6caccac2f9$var$fromArrayLike(arrayView);
}
function $6c5a0d6caccac2f9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return buf;
}
function $6c5a0d6caccac2f9$var$fromObject(obj) {
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(obj)) {
        var len = $6c5a0d6caccac2f9$var$checked(obj.length) | 0;
        var buf = $6c5a0d6caccac2f9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $6c5a0d6caccac2f9$var$numberIsNaN(obj.length)) return $6c5a0d6caccac2f9$var$createBuffer(0);
        return $6c5a0d6caccac2f9$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $6c5a0d6caccac2f9$var$fromArrayLike(obj.data);
}
function $6c5a0d6caccac2f9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $6c5a0d6caccac2f9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $6c5a0d6caccac2f9$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $6c5a0d6caccac2f9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $6c5a0d6caccac2f9$var$Buffer.alloc(+length);
}
$6c5a0d6caccac2f9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $6c5a0d6caccac2f9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$6c5a0d6caccac2f9$var$Buffer.compare = function compare(a, b) {
    if ($6c5a0d6caccac2f9$var$isInstance(a, Uint8Array)) a = $6c5a0d6caccac2f9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($6c5a0d6caccac2f9$var$isInstance(b, Uint8Array)) b = $6c5a0d6caccac2f9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(a) || !$6c5a0d6caccac2f9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$6c5a0d6caccac2f9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$6c5a0d6caccac2f9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $6c5a0d6caccac2f9$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $6c5a0d6caccac2f9$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($6c5a0d6caccac2f9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) buf = $6c5a0d6caccac2f9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $6c5a0d6caccac2f9$var$byteLength(string, encoding) {
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $6c5a0d6caccac2f9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $7E0eS._)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $6c5a0d6caccac2f9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $6c5a0d6caccac2f9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$6c5a0d6caccac2f9$var$Buffer.byteLength = $6c5a0d6caccac2f9$var$byteLength;
function $6c5a0d6caccac2f9$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $6c5a0d6caccac2f9$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8Slice(this, start, end);
        case 'ascii':
            return $6c5a0d6caccac2f9$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $6c5a0d6caccac2f9$var$latin1Slice(this, start, end);
        case 'base64':
            return $6c5a0d6caccac2f9$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6c5a0d6caccac2f9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$6c5a0d6caccac2f9$var$Buffer.prototype._isBuffer = true;
function $6c5a0d6caccac2f9$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$6c5a0d6caccac2f9$var$swap(this, i, i + 1);
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $6c5a0d6caccac2f9$var$swap(this, i, i + 3);
        $6c5a0d6caccac2f9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $6c5a0d6caccac2f9$var$swap(this, i, i + 7);
        $6c5a0d6caccac2f9$var$swap(this, i + 1, i + 6);
        $6c5a0d6caccac2f9$var$swap(this, i + 2, i + 5);
        $6c5a0d6caccac2f9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $6c5a0d6caccac2f9$var$utf8Slice(this, 0, length);
    return $6c5a0d6caccac2f9$var$slowToString.apply(this, arguments);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toLocaleString = $6c5a0d6caccac2f9$var$Buffer.prototype.toString;
$6c5a0d6caccac2f9$var$Buffer.prototype.equals = function equals(b) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $6c5a0d6caccac2f9$var$Buffer.compare(this, b) === 0;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $6c5a0d6caccac2f9$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($6c5a0d6caccac2f9$var$customInspectSymbol) $6c5a0d6caccac2f9$var$Buffer.prototype[$6c5a0d6caccac2f9$var$customInspectSymbol] = $6c5a0d6caccac2f9$var$Buffer.prototype.inspect;
$6c5a0d6caccac2f9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($6c5a0d6caccac2f9$var$isInstance(target, Uint8Array)) target = $6c5a0d6caccac2f9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $7E0eS._)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $6c5a0d6caccac2f9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($6c5a0d6caccac2f9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $6c5a0d6caccac2f9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($6c5a0d6caccac2f9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $6c5a0d6caccac2f9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $6c5a0d6caccac2f9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $6c5a0d6caccac2f9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $6c5a0d6caccac2f9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $6c5a0d6caccac2f9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $6c5a0d6caccac2f9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($6c5a0d6caccac2f9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $6c5a0d6caccac2f9$var$utf8Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$asciiWrite(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$asciiToBytes(string), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$base64Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$base64ToBytes(string), buf, offset, length);
}
function $6c5a0d6caccac2f9$var$ucs2Write(buf, string, offset, length) {
    return $6c5a0d6caccac2f9$var$blitBuffer($6c5a0d6caccac2f9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$6c5a0d6caccac2f9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $6c5a0d6caccac2f9$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $6c5a0d6caccac2f9$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $6c5a0d6caccac2f9$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $6c5a0d6caccac2f9$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $6c5a0d6caccac2f9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$6c5a0d6caccac2f9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $6c5a0d6caccac2f9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $cOFqU.fromByteArray(buf);
    else return $cOFqU.fromByteArray(buf.slice(start, end));
}
function $6c5a0d6caccac2f9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $6c5a0d6caccac2f9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $6c5a0d6caccac2f9$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $6c5a0d6caccac2f9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $6c5a0d6caccac2f9$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $6c5a0d6caccac2f9$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $6c5a0d6caccac2f9$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $6c5a0d6caccac2f9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $6c5a0d6caccac2f9$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $6c5a0d6caccac2f9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $6c5a0d6caccac2f9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$6c5a0d6caccac2f9$var$Buffer.prototype.readUintLE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUintBE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint8 = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint16LE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint16BE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint32LE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readUint32BE = $6c5a0d6caccac2f9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigUInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigUInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readBigInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$6c5a0d6caccac2f9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return $lqFFf.read(this, offset, true, 23, 4);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 4, this.length);
    return $lqFFf.read(this, offset, false, 23, 4);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 8, this.length);
    return $lqFFf.read(this, offset, true, 52, 8);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkOffset(offset, 8, this.length);
    return $lqFFf.read(this, offset, false, 52, 8);
};
function $6c5a0d6caccac2f9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUintLE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUintBE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint8 = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint16LE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint16BE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint32LE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeUint32BE = $6c5a0d6caccac2f9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $6c5a0d6caccac2f9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $6c5a0d6caccac2f9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigUInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigUInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $6c5a0d6caccac2f9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigInt64LE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$6c5a0d6caccac2f9$var$Buffer.prototype.writeBigInt64BE = $6c5a0d6caccac2f9$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $6c5a0d6caccac2f9$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $6c5a0d6caccac2f9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $lqFFf.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeFloat(this, value, offset, true, noAssert);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeFloat(this, value, offset, false, noAssert);
};
function $6c5a0d6caccac2f9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $6c5a0d6caccac2f9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $lqFFf.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$6c5a0d6caccac2f9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeDouble(this, value, offset, true, noAssert);
};
$6c5a0d6caccac2f9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $6c5a0d6caccac2f9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$6c5a0d6caccac2f9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$6c5a0d6caccac2f9$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$6c5a0d6caccac2f9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$6c5a0d6caccac2f9$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $6c5a0d6caccac2f9$var$Buffer.isBuffer(val) ? val : $6c5a0d6caccac2f9$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $6c5a0d6caccac2f9$var$errors = {};
function $6c5a0d6caccac2f9$var$E(sym, getMessage, Base) {
    $6c5a0d6caccac2f9$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $hdIku._)(NodeError, Base);
        function NodeError() {
            (0, $173N4._)(this, NodeError);
            var _this;
            _this = (0, $7qXGD._)(this, NodeError);
            Object.defineProperty(_this, 'message', {
                value: getMessage.apply(_this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $cFHGC._)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, 'code', {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$6c5a0d6caccac2f9$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$6c5a0d6caccac2f9$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $7E0eS._)(actual));
}, TypeError);
$6c5a0d6caccac2f9$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $6c5a0d6caccac2f9$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $7E0eS._)(input)) === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $6c5a0d6caccac2f9$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $6c5a0d6caccac2f9$var$addNumericalSeparator(val) {
    var res = '';
    var i = val.length;
    var start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $6c5a0d6caccac2f9$var$checkBounds(buf, offset, byteLength) {
    $6c5a0d6caccac2f9$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $6c5a0d6caccac2f9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $6c5a0d6caccac2f9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $7E0eS._)(min)) === 'bigint' ? 'n' : '';
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $6c5a0d6caccac2f9$var$checkBounds(buf, offset, byteLength);
}
function $6c5a0d6caccac2f9$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $6c5a0d6caccac2f9$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $6c5a0d6caccac2f9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $6c5a0d6caccac2f9$var$validateNumber(value, type);
        throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $6c5a0d6caccac2f9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $6c5a0d6caccac2f9$var$errors.ERR_OUT_OF_RANGE(type || 'offset', ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $6c5a0d6caccac2f9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $6c5a0d6caccac2f9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($6c5a0d6caccac2f9$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $6c5a0d6caccac2f9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $6c5a0d6caccac2f9$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $6c5a0d6caccac2f9$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $6c5a0d6caccac2f9$var$base64ToBytes(str) {
    return $cOFqU.toByteArray($6c5a0d6caccac2f9$var$base64clean(str));
}
function $6c5a0d6caccac2f9$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $6c5a0d6caccac2f9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $6c5a0d6caccac2f9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $6c5a0d6caccac2f9$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $6c5a0d6caccac2f9$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $6c5a0d6caccac2f9$var$BufferBigIntNotDefined : fn;
}
function $6c5a0d6caccac2f9$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("cOFqU", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $954a4b447490bcaa$export$d622b2ad8d90c771; }, function (v) { return $954a4b447490bcaa$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $954a4b447490bcaa$export$6100ba28696e12de; }, function (v) { return $954a4b447490bcaa$export$6100ba28696e12de = v; });
var $954a4b447490bcaa$export$a48f0734ac7c2329;
var $954a4b447490bcaa$export$d622b2ad8d90c771;
var $954a4b447490bcaa$export$6100ba28696e12de;
'use strict';
$954a4b447490bcaa$export$a48f0734ac7c2329 = $954a4b447490bcaa$var$byteLength;
$954a4b447490bcaa$export$d622b2ad8d90c771 = $954a4b447490bcaa$var$toByteArray;
$954a4b447490bcaa$export$6100ba28696e12de = $954a4b447490bcaa$var$fromByteArray;
var $954a4b447490bcaa$var$lookup = [];
var $954a4b447490bcaa$var$revLookup = [];
var $954a4b447490bcaa$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $954a4b447490bcaa$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $954a4b447490bcaa$var$i = 0, $954a4b447490bcaa$var$len = $954a4b447490bcaa$var$code.length; $954a4b447490bcaa$var$i < $954a4b447490bcaa$var$len; ++$954a4b447490bcaa$var$i){
    $954a4b447490bcaa$var$lookup[$954a4b447490bcaa$var$i] = $954a4b447490bcaa$var$code[$954a4b447490bcaa$var$i];
    $954a4b447490bcaa$var$revLookup[$954a4b447490bcaa$var$code.charCodeAt($954a4b447490bcaa$var$i)] = $954a4b447490bcaa$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$954a4b447490bcaa$var$revLookup['-'.charCodeAt(0)] = 62;
$954a4b447490bcaa$var$revLookup['_'.charCodeAt(0)] = 63;
function $954a4b447490bcaa$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $954a4b447490bcaa$var$byteLength(b64) {
    var lens = $954a4b447490bcaa$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $954a4b447490bcaa$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $954a4b447490bcaa$var$toByteArray(b64) {
    var tmp;
    var lens = $954a4b447490bcaa$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $954a4b447490bcaa$var$Arr($954a4b447490bcaa$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 18 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 2 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i)] << 10 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $954a4b447490bcaa$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $954a4b447490bcaa$var$tripletToBase64(num) {
    return $954a4b447490bcaa$var$lookup[num >> 18 & 0x3F] + $954a4b447490bcaa$var$lookup[num >> 12 & 0x3F] + $954a4b447490bcaa$var$lookup[num >> 6 & 0x3F] + $954a4b447490bcaa$var$lookup[num & 0x3F];
}
function $954a4b447490bcaa$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($954a4b447490bcaa$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $954a4b447490bcaa$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($954a4b447490bcaa$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($954a4b447490bcaa$var$lookup[tmp >> 2] + $954a4b447490bcaa$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($954a4b447490bcaa$var$lookup[tmp >> 10] + $954a4b447490bcaa$var$lookup[tmp >> 4 & 0x3F] + $954a4b447490bcaa$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("lqFFf", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $f99c5859a5f73a56$export$aafa59e2e03f2942; }, function (v) { return $f99c5859a5f73a56$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $f99c5859a5f73a56$export$68d8715fc104d294; }, function (v) { return $f99c5859a5f73a56$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $f99c5859a5f73a56$export$aafa59e2e03f2942;
var $f99c5859a5f73a56$export$68d8715fc104d294;
$f99c5859a5f73a56$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$f99c5859a5f73a56$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("65S8r", function(module, exports) {
$parcel$export(module.exports, "observer", function () { return (parcelRequire("as4kI")).observer; });
$parcel$export(module.exports, "reaction", function () { return (parcelRequire("as4kI")).reaction; });
parcelRequire("kx3EX");
parcelRequire("as4kI");

});
parcelRegister("kx3EX", function(module, exports) {

$parcel$export(module.exports, "ProxyMap", function () { return $ef29ba74889bb3b6$export$5bcdd9ec8525d86e; });

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $gtaQ6 = parcelRequire("gtaQ6");
var $ef29ba74889bb3b6$var$_a;
var $ef29ba74889bb3b6$var$uniqueKey = (0, $gtaQ6.uniqueID)();
var $ef29ba74889bb3b6$export$5bcdd9ec8525d86e = /*#__PURE__*/ function() {
    "use strict";
    function ProxyMap() {
        (0, $173N4._)(this, ProxyMap);
        Object.defineProperty(this, $ef29ba74889bb3b6$var$_a, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'ProxyMap'
        });
    }
    (0, $cFHGC._)(ProxyMap, [
        {
            key: "set",
            value: function set(key, value) {
                key[$ef29ba74889bb3b6$var$uniqueKey] = value;
                return this;
            }
        },
        {
            key: "get",
            value: function get(key) {
                return key[$ef29ba74889bb3b6$var$uniqueKey];
            }
        },
        {
            key: "has",
            value: function has(key) {
                return $ef29ba74889bb3b6$var$uniqueKey in key;
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                return delete key[$ef29ba74889bb3b6$var$uniqueKey];
            }
        }
    ]);
    return ProxyMap;
}();
$ef29ba74889bb3b6$var$_a = Symbol.toStringTag;

});

parcelRegister("as4kI", function(module, exports) {

$parcel$export(module.exports, "reaction", function () { return $79bfe15e7f092eb3$export$7203b476385689ae; });
$parcel$export(module.exports, "observer", function () { return $79bfe15e7f092eb3$export$b6ae1bc530f4c149; });

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $4O9q3 = parcelRequire("4O9q3");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
parcelRequire("jBjHf");
var $8uJ7j = parcelRequire("8uJ7j");

var $h2kUE = parcelRequire("h2kUE");

var $2sMtU = parcelRequire("2sMtU");

var $kx3EX = parcelRequire("kx3EX");
var $79bfe15e7f092eb3$var$reactionMap = new (0, $kx3EX.ProxyMap)();
var $79bfe15e7f092eb3$export$7203b476385689ae = function(expression) {
    return function(effect, param) {
        var addInitializer = param.addInitializer;
        return addInitializer(function() {
            var reactions = $79bfe15e7f092eb3$var$reactionMap.get(this) || [];
            reactions.push({
                expression: expression,
                effect: effect
            });
            $79bfe15e7f092eb3$var$reactionMap.set(this, reactions);
        });
    };
};
var $79bfe15e7f092eb3$var$wrapClass = function(Component) {
    var ObserverComponent = /*#__PURE__*/ function(Component) {
        "use strict";
        (0, $hdIku._)(ObserverComponent, Component);
        function ObserverComponent() {
            (0, $173N4._)(this, ObserverComponent);
            var _this;
            _this = (0, $7qXGD._)(this, ObserverComponent, arguments);
            Object.defineProperty(_this, "disposers", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            return _this;
        }
        (0, $cFHGC._)(ObserverComponent, [
            {
                key: "mounted",
                value: function mounted() {
                    var _this = this;
                    var _a, _b;
                    this.disposers = (_a = $79bfe15e7f092eb3$var$reactionMap.get(this)) === null || _a === void 0 ? void 0 : _a.map(function(param) {
                        var expression = param.expression, effect = param.effect;
                        return (0, $h2kUE.reaction)(function(reaction) {
                            return expression(_this, reaction);
                        }, effect.bind(_this));
                    });
                    (_b = (0, $dWsrg._)((0, $kg0zo._)(ObserverComponent.prototype), "mounted", this)) === null || _b === void 0 || _b.call(this);
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this = this;
                    return (0, $4O9q3.jsx)((0, $2sMtU.Observer), {
                        children: function() {
                            var _a;
                            return (_a = (0, $dWsrg._)((0, $kg0zo._)(ObserverComponent.prototype), "render", _this)) === null || _a === void 0 ? void 0 : _a.call(_this);
                        }
                    });
                }
            },
            {
                key: "unmounted",
                value: function unmounted() {
                    var _a;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = (this.disposers || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var disposer = _step.value;
                            disposer();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this.disposers = [];
                    (_a = (0, $dWsrg._)((0, $kg0zo._)(ObserverComponent.prototype), "unmounted", this)) === null || _a === void 0 || _a.call(this);
                }
            }
        ]);
        return ObserverComponent;
    }(Component);
    return ObserverComponent;
};
function $79bfe15e7f092eb3$export$b6ae1bc530f4c149(component) {
    if (typeof component === 'function') {
        var prototype = component.prototype;
        if (prototype instanceof (0, $8uJ7j.Base) || typeof (prototype === null || prototype === void 0 ? void 0 : prototype.render) === 'function') return $79bfe15e7f092eb3$var$wrapClass(component);
    }
    var FunctionComponent = component;
    return (0, $fKAHx.defineComponent)({
        setup: function(props, context) {
            return function() {
                return (0, $4O9q3.jsx)((0, $2sMtU.Observer), {
                    children: function() {
                        return FunctionComponent(Object.assign(Object.assign({}, props), context.attrs), context);
                    }
                });
            };
        }
    });
}

});
parcelRegister("4O9q3", function(module, exports) {

$parcel$export(module.exports, "jsx", function () { return $cdf48cd808492c88$export$34b9dba7ce09269b; });
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
function $cdf48cd808492c88$export$34b9dba7ce09269b(type, props, key) {
    var children = props.children;
    delete props.children;
    if (arguments.length > 2) props.key = key;
    return (0, $fKAHx.h)(type, props, children);
}

});

parcelRegister("jBjHf", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return (parcelRequire("fTAJe")).ComponentBase; });
$parcel$export(module.exports, "Watch", function () { return (parcelRequire("bqO9D")).decorator; });
$parcel$export(module.exports, "Prop", function () { return (parcelRequire("hbwBq")).decorator; });
$parcel$export(module.exports, "TSX", function () { return (parcelRequire("1oPot")).TSX; });
$parcel$export(module.exports, "Vue", function () { return (parcelRequire("8uJ7j")).Base; });
$parcel$export(module.exports, "toNative", function () { return (parcelRequire("fTAJe")).toNative; });

var $fTAJe = parcelRequire("fTAJe");

var $4kvDR = parcelRequire("4kvDR");

var $5tKlc = parcelRequire("5tKlc");

var $bqO9D = parcelRequire("bqO9D");

var $hbwBq = parcelRequire("hbwBq");

var $7aIJh = parcelRequire("7aIJh");

var $ksQts = parcelRequire("ksQts");

var $5B52k = parcelRequire("5B52k");

var $lorU1 = parcelRequire("lorU1");

var $gY8sK = parcelRequire("gY8sK");

var $6Dpbe = parcelRequire("6Dpbe");

var $UltEa = parcelRequire("UltEa");

var $bRFSV = parcelRequire("bRFSV");

var $1oPot = parcelRequire("1oPot");

var $8uJ7j = parcelRequire("8uJ7j");
parcelRequire("bvzkw");

});
parcelRegister("fTAJe", function(module, exports) {

$parcel$export(module.exports, "ComponentBase", function () { return $b9287b94001ac883$export$425c3e0a21b857e8; });
$parcel$export(module.exports, "toNative", function () { return $b9287b94001ac883$export$b5ba361dca0a2be9; });

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");

var $aBA3c = parcelRequire("aBA3c");

var $bDXoP = parcelRequire("bDXoP");

var $4kvDR = parcelRequire("4kvDR");

var $b7Bvd = parcelRequire("b7Bvd");

var $eA5VX = parcelRequire("eA5VX");

var $6Dpbe = parcelRequire("6Dpbe");

var $5tKlc = parcelRequire("5tKlc");

var $bqO9D = parcelRequire("bqO9D");

var $hbwBq = parcelRequire("hbwBq");

var $ksQts = parcelRequire("ksQts");

var $7aIJh = parcelRequire("7aIJh");

var $5B52k = parcelRequire("5B52k");

var $lorU1 = parcelRequire("lorU1");

var $f5Em7 = parcelRequire("f5Em7");
function $b9287b94001ac883$var$componentOptionFactory(cons, extend) {
    var optionBuilder = {};
    (0, $4kvDR.build)(cons, optionBuilder);
    (0, $lorU1.build)(cons, optionBuilder);
    (0, $b7Bvd.build)(cons, optionBuilder); //after VModel
    (0, $bqO9D.build)(cons, optionBuilder);
    (0, $hbwBq.build)(cons, optionBuilder);
    (0, $ksQts.build)(cons, optionBuilder);
    (0, $5B52k.build)(cons, optionBuilder);
    (0, $5tKlc.build)(cons, optionBuilder); //after Computed
    (0, $f5Em7.build)(cons, optionBuilder);
    (0, $6Dpbe.build)(cons, optionBuilder); //the last one
    var raw = Object.assign(Object.assign({
        name: cons.name,
        setup: optionBuilder.setup,
        data: function() {
            var _a;
            delete optionBuilder.data;
            (0, $eA5VX.build)(cons, optionBuilder);
            return (_a = optionBuilder.data) !== null && _a !== void 0 ? _a : {};
        },
        methods: optionBuilder.methods,
        computed: optionBuilder.computed,
        watch: optionBuilder.watch,
        props: optionBuilder.props,
        inject: optionBuilder.inject,
        provide: function() {
            var _a;
            (0, $7aIJh.build)(cons, optionBuilder, this);
            return (_a = optionBuilder.provide) !== null && _a !== void 0 ? _a : {};
        }
    }, optionBuilder.hooks), {
        extends: extend
    });
    return raw;
}
function $b9287b94001ac883$var$buildComponent(cons, arg, extend) {
    var _a, _b;
    var option = $b9287b94001ac883$var$componentOptionFactory(cons, extend);
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    Object.keys(arg).reduce(function(option, name) {
        if ([
            'options',
            'modifier',
            'methods',
            'emits',
            'setup',
            'provide'
        ].includes(name)) return option;
        option[name] = arg[name];
        return option;
    }, option);
    //apply event emits
    var emits = Array.from(slot.obtainMap('emits').keys());
    if (Array.isArray(arg.emits)) emits = Array.from(new Set((0, $aUGqu._)(emits).concat((0, $aUGqu._)(arg.emits))));
    option.emits = emits;
    //merge methods
    if ('object' === (0, $7E0eS._)(arg.methods) && !Array.isArray(arg.methods) && arg.methods !== null) {
        (_a = option.methods) !== null && _a !== void 0 ? _a : option.methods = {};
        Object.assign(option.methods, arg.methods);
    }
    //merge setup function
    if (!option.setup) option.setup = arg.setup;
    else {
        var oldSetup = option.setup;
        var newSetup = (_b = arg.setup) !== null && _b !== void 0 ? _b : function newSetup() {
            return {};
        };
        var setup = function setup(props, ctx) {
            var newRet = newSetup(props, ctx);
            var oldRet = oldSetup(props, ctx);
            if (oldRet instanceof Promise || newRet instanceof Promise) return Promise.all([
                newRet,
                oldRet
            ]).then(function(arr) {
                return Object.assign({}, arr[0], arr[1]);
            });
            else return Object.assign({}, newRet, oldRet);
        };
        option.setup = setup;
    }
    //merge provide function
    var oldProvider = (0, $bDXoP.getProviderFunction)(option.provide);
    var newProvider = (0, $bDXoP.getProviderFunction)(arg.provide);
    option.provide = function() {
        return Object.assign({}, oldProvider.call(this), newProvider.call(this));
    };
    //custom decorator
    var map = slot.getMap('customDecorator');
    if (map && map.size > 0) map.forEach(function(v) {
        v.forEach(function(ite) {
            return ite.creator.apply({}, [
                option,
                ite.key
            ]);
        });
    });
    //shallow merge options
    if (arg.options) Object.assign(option, arg.options);
    //apply modifier
    if (arg.modifier) arg.modifier(option);
    return (0, $fKAHx.defineComponent)(option);
}
function $b9287b94001ac883$var$build(cons, option) {
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    slot.inComponent = true;
    var superSlot = (0, $bDXoP.getSuperSlot)(cons.prototype);
    if (superSlot) {
        if (!superSlot.inComponent) throw 'Class should be decorated by Component or ComponentBase: ' + slot.master;
        if (superSlot.cachedVueComponent === null) throw 'Component decorator 1';
    }
    var component = $b9287b94001ac883$var$buildComponent(cons, option, superSlot === null ? undefined : superSlot.cachedVueComponent);
    component.__vfdConstructor = cons;
    slot.cachedVueComponent = component;
    cons.__vccOpts = component;
}
var $b9287b94001ac883$export$425c3e0a21b857e8 = (0, $bDXoP.optionNullableClassDecorator)(function(cons, option) {
    $b9287b94001ac883$var$build(cons, option !== null && option !== void 0 ? option : {});
});
function $b9287b94001ac883$export$b5ba361dca0a2be9(cons) {
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    if (!slot.inComponent) throw 'to native 1';
    var cached = slot.cachedVueComponent;
    if (!cached) throw 'to native 2';
    return cached;
}

});
parcelRegister("aBA3c", function(module, exports) {

$parcel$export(module.exports, "getSlot", function () { return $7b8952fde93b7541$export$f81520ef48fbe118; });
$parcel$export(module.exports, "obtainSlot", function () { return $7b8952fde93b7541$export$55fad84da1c41cea; });

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");
parcelRequire("gw2v0");
var $dElRN = parcelRequire("dElRN");
var $7b8952fde93b7541$var$SlotSymbol = Symbol('vue-facing-decorator-slot');
var $7b8952fde93b7541$export$8c6ed5c666ac1360 = /*#__PURE__*/ function() {
    "use strict";
    function Slot(master) {
        (0, $173N4._)(this, Slot);
        Object.defineProperty(this, "master", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "names", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "inComponent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "cachedVueComponent", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.master = master;
    }
    (0, $cFHGC._)(Slot, [
        {
            key: "obtainMap",
            value: function obtainMap(name) {
                var map = this.getMap(name);
                if (!map) {
                    map = new Map();
                    this.names.set(name, map);
                }
                return map;
            }
        },
        {
            key: "getMap",
            value: function getMap(name) {
                var map = this.names.get(name);
                return map;
            }
        }
    ]);
    return Slot;
}();
var $7b8952fde93b7541$var$metadata = new (0, $dElRN.Metadata)($7b8952fde93b7541$var$SlotSymbol);
function $7b8952fde93b7541$export$43c296757b81c771(obj, defaultSlot) {
    if ($7b8952fde93b7541$export$f81520ef48fbe118(obj)) throw '';
    if (defaultSlot) defaultSlot.master = obj;
    var slot = defaultSlot !== null && defaultSlot !== void 0 ? defaultSlot : new $7b8952fde93b7541$export$8c6ed5c666ac1360(obj);
    $7b8952fde93b7541$var$metadata.create(obj, slot);
    return slot;
}
function $7b8952fde93b7541$export$f81520ef48fbe118(obj) {
    return $7b8952fde93b7541$var$metadata.getOwn(obj);
}
function $7b8952fde93b7541$export$55fad84da1c41cea(obj, defaultSlot) {
    var slot = $7b8952fde93b7541$export$f81520ef48fbe118(obj);
    if (slot) return slot;
    return $7b8952fde93b7541$export$43c296757b81c771(obj, defaultSlot);
}

});
parcelRegister("gw2v0", function(module, exports) {

$parcel$export(module.exports, "Metadata", function () { return (parcelRequire("dElRN")).Metadata; });

var $dElRN = parcelRequire("dElRN");

});
parcelRegister("dElRN", function(module, exports) {

$parcel$export(module.exports, "Metadata", function () { return $9efff914638dc6d1$export$e7adebdc1ebd2fed; });

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $bHJoZ = parcelRequire("bHJoZ");
var $9efff914638dc6d1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9efff914638dc6d1$var$_Metadata_instances, $9efff914638dc6d1$var$_Metadata_travel;
var $9efff914638dc6d1$export$e7adebdc1ebd2fed = /*#__PURE__*/ function() {
    "use strict";
    function Metadata() {
        var symbol = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Symbol('faple-metadata');
        (0, $173N4._)(this, Metadata);
        $9efff914638dc6d1$var$_Metadata_instances.add(this);
        this.symbol = symbol;
    }
    (0, $cFHGC._)(Metadata, [
        {
            /**
     * Create metadata in the target.
     * @param target Target.
     * @param data   Init metadata.
     */ key: "create",
            value: function create(target, data) {
                if (Object.getOwnPropertyDescriptor(target, this.symbol)) (0, $bHJoZ.error)('Target had metadata');
                Object.defineProperty(target, this.symbol, {
                    enumerable: false,
                    configurable: false,
                    writable: false,
                    value: data
                });
            }
        },
        {
            /**
     * Get own metadata.
     * @param target Target.
     * @returns Metadata data or undefined.
     */ key: "getOwn",
            value: function getOwn(target) {
                var des = Object.getOwnPropertyDescriptor(target, this.symbol);
                if (!des) return undefined;
                return des.value;
            }
        },
        {
            /**
    * Get metadata in prototype chain.
    * @param target Target.
    * @returns Metadata data or undefined.
    */ key: "get",
            value: function get(target) {
                var data = undefined;
                $9efff914638dc6d1$var$__classPrivateFieldGet(this, $9efff914638dc6d1$var$_Metadata_instances, "m", $9efff914638dc6d1$var$_Metadata_travel).call(this, target, function(target, _data) {
                    data = _data;
                    return false;
                });
                return data;
            }
        },
        {
            /**
     * Get metadata array in prototype chain.
     * @param target Target.
     * @returns Metadata array to acient.
     */ key: "getAll",
            value: function getAll(target) {
                var data = [];
                $9efff914638dc6d1$var$__classPrivateFieldGet(this, $9efff914638dc6d1$var$_Metadata_instances, "m", $9efff914638dc6d1$var$_Metadata_travel).call(this, target, function(target, _data) {
                    data.push(_data);
                    return true;
                });
                return data;
            }
        },
        {
            /**
     * Set value in the own mdatadata.
     * Implement by `obtainOwn`.
     * @param target Target.
     * @param key Key.
     * @param value value.
     */ key: "setValueOwn",
            value: function setValueOwn(target, key, value) {
                var _data = this.getOwn(target);
                if (!_data) (0, $bHJoZ.error)('Target has not metadata');
                _data[key] = value;
            }
        },
        {
            /**
    * Set value in the recent mdatadata in prototype chain.
    * Implement by `obtain`.
    * @param target Target.
    * @param key Key.
    * @param value value.
    */ key: "setValue",
            value: function setValue(target, key, value) {
                var _data = this.get(target);
                if (!_data) (0, $bHJoZ.error)('Target has not metadata');
                _data[key] = value;
            }
        },
        {
            /**
     * Get value in the own metadata.
     * @param target Target.
     * @param key Key.
     * @returns
     */ key: "getValueOwn",
            value: function getValueOwn(target, key) {
                var data = this.getOwn(target);
                if (data === undefined) (0, $bHJoZ.error)('Target has not metadata');
                return data[key];
            }
        },
        {
            /**
    * Get value in the recent mdatadata WHICH HAS THE KEY in prototype chain.
    * @param target Target.
    * @param key Key.
    */ key: "getValue",
            value: function getValue(target, key) {
                var foundMetadata = false;
                var value = undefined;
                $9efff914638dc6d1$var$__classPrivateFieldGet(this, $9efff914638dc6d1$var$_Metadata_instances, "m", $9efff914638dc6d1$var$_Metadata_travel).call(this, target, function(target, _data) {
                    foundMetadata = true;
                    if (!(key in _data) || _data[key] === undefined) return true;
                    value = _data[key];
                    return false;
                });
                if (!foundMetadata) (0, $bHJoZ.error)('Target has not metadata');
                return value;
            }
        }
    ]);
    return Metadata;
}();
$9efff914638dc6d1$var$_Metadata_instances = new WeakSet(), $9efff914638dc6d1$var$_Metadata_travel = function _Metadata_travel(target, traveler) {
    var t = target;
    do {
        var data = this.getOwn(t);
        if (data !== undefined) {
            if (!traveler(target, data)) break;
        }
        t = Object.getPrototypeOf(t);
    }while (t !== null);
};

});
parcelRegister("bHJoZ", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $8856edbdee7bb7b6$export$a3bc9b8ed74fc; });
function $8856edbdee7bb7b6$export$a3bc9b8ed74fc(str) {
    throw "facing-metadata: ".concat(str);
}

});




parcelRegister("bDXoP", function(module, exports) {

$parcel$export(module.exports, "toComponentReverse", function () { return $87a169b30304e866$export$24e76474a56d46af; });
$parcel$export(module.exports, "getSuperSlot", function () { return $87a169b30304e866$export$f5ff6a15189e0f60; });
$parcel$export(module.exports, "filterNames", function () { return $87a169b30304e866$export$899efafbba5f734f; });
$parcel$export(module.exports, "getValidOwnPropertyNames", function () { return $87a169b30304e866$export$f901187bd6d808f9; });
$parcel$export(module.exports, "getProviderFunction", function () { return $87a169b30304e866$export$4f6969ad550ef58b; });
$parcel$export(module.exports, "optionNullableMemberDecorator", function () { return $87a169b30304e866$export$d77d8c1a0bc3ba75; });
$parcel$export(module.exports, "optionNullableClassDecorator", function () { return $87a169b30304e866$export$3be4012fea40d4cb; });

var $ifVvN = parcelRequire("ifVvN");

var $8uJ7j = parcelRequire("8uJ7j");

var $aBA3c = parcelRequire("aBA3c");
function $87a169b30304e866$export$dd5385caa81b6660(proto) {
    var p = Object.getPrototypeOf(proto);
    if (!(p instanceof (0, $8uJ7j.Base))) return null;
    return p;
}
function $87a169b30304e866$export$24e76474a56d46af(proto) {
    var arr = [];
    var curr = proto;
    do {
        arr.unshift(curr);
        curr = $87a169b30304e866$export$dd5385caa81b6660(curr);
    }while (curr !== null && !(0, $aBA3c.getSlot)(curr));
    return arr;
}
function $87a169b30304e866$export$f5ff6a15189e0f60(proto) {
    var curr = $87a169b30304e866$export$dd5385caa81b6660(proto);
    while(curr !== null){
        var slot = (0, $aBA3c.getSlot)(curr);
        if (slot) return slot;
        curr = $87a169b30304e866$export$dd5385caa81b6660(curr);
    }
    return null;
}
function $87a169b30304e866$export$899efafbba5f734f(names, slot, mapNames) {
    return names.filter(function(name) {
        var currSlot = slot;
        while(currSlot != null){
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = currSlot.names.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var mapName = _step.value;
                    if (mapName === 'customDecorator') {
                        var map = currSlot.obtainMap('customDecorator');
                        if (map.has(name)) {
                            if (map.get(name).every(function(ite) {
                                return !ite.preserve;
                            })) return false;
                        }
                    }
                    if (mapNames && mapNames.includes(mapName)) continue;
                    var map1 = currSlot.names.get(mapName);
                    if (map1.has(name)) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            currSlot = $87a169b30304e866$export$f5ff6a15189e0f60(currSlot.master);
        }
        return true;
    });
}
function $87a169b30304e866$export$f901187bd6d808f9(obj, filter) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    return Object.keys(descriptors).filter(function(name) {
        return filter(descriptors[name], name);
    });
}
function $87a169b30304e866$export$4f6969ad550ef58b(provide) {
    if (typeof provide === 'function') return provide;
    return function() {
        return provide || {};
    };
}
function $87a169b30304e866$export$d77d8c1a0bc3ba75(handler) {
    function decorator(optionOrProtoOrValue, nameOrCtx) {
        if (nameOrCtx) {
            var protoOrValue = optionOrProtoOrValue;
            (0, $ifVvN.compatibleMemberDecorator)(function(proto, name) {
                handler(proto, name);
            })(protoOrValue, nameOrCtx);
        } else {
            var option = optionOrProtoOrValue;
            return (0, $ifVvN.compatibleMemberDecorator)(function(proto, name) {
                handler(proto, name, option);
            });
        }
    }
    return decorator;
}
function $87a169b30304e866$export$3be4012fea40d4cb(handler) {
    function decorator(optionOrCons, ctx) {
        if (typeof optionOrCons === 'function') {
            var cons = optionOrCons;
            (0, $ifVvN.compatibleClassDecorator)(function(cons) {
                handler(cons);
            })(cons, ctx);
        } else {
            var option = optionOrCons;
            return (0, $ifVvN.compatibleClassDecorator)(function(cons) {
                handler(cons, option);
            });
        }
    }
    return decorator;
}

});
parcelRegister("ifVvN", function(module, exports) {

$parcel$export(module.exports, "compatibleClassDecorator", function () { return $d4a63d5b7ce899c9$export$312d0557e589bc8a; });
$parcel$export(module.exports, "compatibleMemberDecorator", function () { return $d4a63d5b7ce899c9$export$49d57d4a4f7496b6; });

var $7E0eS = parcelRequire("7E0eS");

var $aBA3c = parcelRequire("aBA3c");
var $d4a63d5b7ce899c9$export$569d6cae07c10a88 = {};
function $d4a63d5b7ce899c9$export$312d0557e589bc8a(deco) {
    return function(cons, ctx) {
        var _a;
        if (ctx) {
            if (ctx.kind !== 'class') throw 'deco stage 3 class';
            var proto = (_a = $d4a63d5b7ce899c9$export$569d6cae07c10a88.fakePrototype) !== null && _a !== void 0 ? _a : $d4a63d5b7ce899c9$export$569d6cae07c10a88.fakePrototype = {};
            var slot = (0, $aBA3c.obtainSlot)(proto);
            delete $d4a63d5b7ce899c9$export$569d6cae07c10a88.fakePrototype;
            (0, $aBA3c.obtainSlot)(cons.prototype, slot);
            var ret = deco(cons);
            return ret;
        } else return deco(cons);
    };
}
function $d4a63d5b7ce899c9$export$49d57d4a4f7496b6(deco) {
    return function(protoOrValue, nameOrCtx) {
        var _a;
        if ((typeof nameOrCtx === "undefined" ? "undefined" : (0, $7E0eS._)(nameOrCtx)) === 'object') {
            var ctx = nameOrCtx;
            var value = protoOrValue;
            var proto = (_a = $d4a63d5b7ce899c9$export$569d6cae07c10a88.fakePrototype) !== null && _a !== void 0 ? _a : $d4a63d5b7ce899c9$export$569d6cae07c10a88.fakePrototype = {};
            proto[ctx.name] = value;
            return deco(proto, ctx.name);
        } else {
            var name = nameOrCtx;
            var proto1 = protoOrValue;
            return deco(proto1, name);
        }
    };
}

});

parcelRegister("8uJ7j", function(module, exports) {

$parcel$export(module.exports, "Base", function () { return $62f41f592464924f$export$ef88aa0d34c34520; });

var $173N4 = parcelRequire("173N4");
var $62f41f592464924f$export$ef88aa0d34c34520 = function Base() {
    "use strict";
    (0, $173N4._)(this, Base);
};

});


parcelRegister("4kvDR", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $32719316386eca6f$export$3f8fe6489e95757d; });

var $ifVvN = parcelRequire("ifVvN");

var $aBA3c = parcelRequire("aBA3c");
function $32719316386eca6f$export$46bdae34a7208737(setupFunction) {
    return (0, $ifVvN.compatibleMemberDecorator)(function(proto, name) {
        var slot = (0, $aBA3c.obtainSlot)(proto);
        var map = slot.obtainMap('setup');
        map.set(name, {
            setupFunction: setupFunction
        });
    });
}
var $32719316386eca6f$var$isPromise = function(v) {
    return v instanceof Promise;
};
function $32719316386eca6f$export$3f8fe6489e95757d(cons, optionBuilder) {
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var map = slot.getMap('setup');
    if (!map || map.size === 0) return;
    var setup = function setup(props, ctx) {
        var setupData = {};
        var promises = null;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var name = _step.value;
                var setupState = map.get(name).setupFunction(props, ctx);
                if ($32719316386eca6f$var$isPromise(setupState)) {
                    promises !== null && promises !== void 0 ? promises : promises = [];
                    promises.push(setupState.then(function(v) {
                        setupData[name] = v;
                    }));
                } else setupData[name] = setupState;
            };
            for(var _iterator = map.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (Array.isArray(promises)) return Promise.all(promises).then(function() {
            return setupData;
        });
        else return setupData;
    };
    optionBuilder.setup = setup;
}

});

parcelRegister("b7Bvd", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $818d705d9de6ed70$export$3f8fe6489e95757d; });

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
function $818d705d9de6ed70$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.computed) !== null && _a !== void 0 ? _a : optionBuilder.computed = {};
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var map = slot.obtainMap('computed');
    var vanillaMap = slot.obtainMap('vanilla');
    var protoArr = (0, $bDXoP.toComponentReverse)(cons.prototype);
    protoArr.forEach(function(proto) {
        (0, $bDXoP.getValidOwnPropertyNames)(proto, function(des, name) {
            return (typeof des.get === 'function' || typeof des.set === 'function') && !vanillaMap.has(name);
        }).forEach(function(name) {
            map.set(name, true);
            var des = Object.getOwnPropertyDescriptor(proto, name);
            optionBuilder.computed[name] = {
                get: typeof des.get === 'function' ? des.get : undefined,
                set: typeof des.set === 'function' ? des.set : undefined
            };
        });
    });
}

});

parcelRegister("eA5VX", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $a9d907d4c77d4d6b$export$3f8fe6489e95757d; });

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
function $a9d907d4c77d4d6b$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.data) !== null && _a !== void 0 ? _a : optionBuilder.data = {};
    var sample = new cons();
    var names = (0, $bDXoP.getValidOwnPropertyNames)(sample, function(des, name) {
        var _a, _b;
        return !!des.enumerable && !((_a = optionBuilder.methods) === null || _a === void 0 ? void 0 : _a[name]) && !((_b = optionBuilder.props) === null || _b === void 0 ? void 0 : _b[name]);
    });
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    //include these names:
    //provide, user may access field directly
    //customDecorator
    names = (0, $bDXoP.filterNames)(names, slot, [
        'provide',
        'customDecorator'
    ]);
    Object.assign(optionBuilder.data, names.reduce(function(pv, cv) {
        pv[cv] = sample[cv];
        return pv;
    }, {}));
}

});

parcelRegister("6Dpbe", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $4d49ead3b388ed84$export$3f8fe6489e95757d; });

var $aUGqu = parcelRequire("aUGqu");

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
var $4d49ead3b388ed84$export$fd75dcd53aced7c6 = [
    "beforeCreate",
    "created",
    "beforeMount",
    "mounted",
    "beforeUpdate",
    "updated",
    "activated",
    "deactivated",
    "beforeDestroy",
    "beforeUnmount",
    "destroyed",
    "unmounted",
    "renderTracked",
    "renderTriggered",
    "errorCaptured",
    "serverPrefetch",
    "render"
];
var $4d49ead3b388ed84$export$46bdae34a7208737 = (0, $bDXoP.optionNullableMemberDecorator)(function(proto, name) {
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var map = slot.obtainMap('hooks');
    map.set(name, null);
});
function $4d49ead3b388ed84$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a, _b, _c;
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var protoArr = (0, $bDXoP.toComponentReverse)(cons.prototype);
    var map = slot.obtainMap('hooks');
    (_a = optionBuilder.hooks) !== null && _a !== void 0 ? _a : optionBuilder.hooks = {};
    (_b = optionBuilder.methods) !== null && _b !== void 0 ? _b : optionBuilder.methods = {};
    var HookFunctions = {};
    var MethodFunctions = {};
    protoArr.forEach(function(proto) {
        var names = (0, $bDXoP.getValidOwnPropertyNames)(proto, function(des, name) {
            return typeof des.value === 'function' && name !== 'constructor';
        });
        //include these names:
        //watch, user may call watch method directly
        //hooks, user may call hook method directly
        //emits, user may have a method name which is same as one of event names
        //provide, user may access field directly
        //customDecorator
        names = (0, $bDXoP.filterNames)(names, slot, [
            'watch',
            'hooks',
            'emits',
            'provide',
            'customDecorator'
        ]);
        names.forEach(function(name) {
            if ($4d49ead3b388ed84$export$fd75dcd53aced7c6.includes(name) || map.has(name)) HookFunctions[name] = proto[name];
            else MethodFunctions[name] = proto[name];
        });
    });
    Object.assign(optionBuilder.methods, MethodFunctions);
    var beforeCreateCallbacks = (0, $aUGqu._)((_c = optionBuilder.beforeCreateCallbacks) !== null && _c !== void 0 ? _c : []);
    if (beforeCreateCallbacks && beforeCreateCallbacks.length > 0) {
        var oldBeforeCreateCallback = HookFunctions['beforeCreate'];
        HookFunctions['beforeCreate'] = function() {
            var _this = this, _arguments = arguments;
            beforeCreateCallbacks.forEach(function(callback) {
                return callback.apply(_this, _arguments);
            });
            if (oldBeforeCreateCallback) oldBeforeCreateCallback.apply(this, arguments);
        };
    }
    Object.assign(optionBuilder.hooks, HookFunctions);
}

});

parcelRegister("5tKlc", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $3fd39b8bbfa76c35$export$3f8fe6489e95757d; });

var $la79R = parcelRequire("la79R");

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
var $3fd39b8bbfa76c35$export$46bdae34a7208737 = (0, $bDXoP.optionNullableMemberDecorator)(function(proto, name, key) {
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var map = slot.obtainMap('ref');
    map.set(name, typeof key === 'undefined' ? null : key);
});
function $3fd39b8bbfa76c35$export$3f8fe6489e95757d(cons, optionBuilder) {
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var names = slot.getMap('ref');
    if (!names || names.size === 0) return;
    (0, $la79R.applyAccessors)(optionBuilder, function(ctx) {
        var data = new Map;
        names.forEach(function(value, name) {
            var refKey = value === null ? name : value;
            data.set(name, {
                get: function get() {
                    return ctx.$refs[refKey];
                },
                set: undefined
            });
        });
        return data;
    });
}

});
parcelRegister("la79R", function(module, exports) {

$parcel$export(module.exports, "applyAccessors", function () { return $f6801594b01bd145$export$f5db7f88babe0e97; });
function $f6801594b01bd145$export$f5db7f88babe0e97(optionBuilder, dataFunc) {
    var _a;
    (_a = optionBuilder.beforeCreateCallbacks) !== null && _a !== void 0 ? _a : optionBuilder.beforeCreateCallbacks = [];
    optionBuilder.beforeCreateCallbacks.push(function() {
        var ctx = this;
        var data = dataFunc(ctx);
        data.forEach(function(v, n) {
            Object.defineProperty(ctx, n, v);
        });
    });
}

});


parcelRegister("bqO9D", function(module, exports) {

$parcel$export(module.exports, "decorator", function () { return $8529070cc063bd98$export$46bdae34a7208737; });
$parcel$export(module.exports, "build", function () { return $8529070cc063bd98$export$3f8fe6489e95757d; });

var $aBA3c = parcelRequire("aBA3c");

var $ifVvN = parcelRequire("ifVvN");
function $8529070cc063bd98$export$46bdae34a7208737(key, option) {
    return (0, $ifVvN.compatibleMemberDecorator)(function(proto, name) {
        var slot = (0, $aBA3c.obtainSlot)(proto);
        var map = slot.obtainMap('watch');
        var opt = Object.assign({}, option !== null && option !== void 0 ? option : {}, {
            key: key,
            handler: proto[name]
        });
        if (map.has(name)) {
            var t = map.get(name);
            if (Array.isArray(t)) t.push(opt);
            else map.set(name, [
                t,
                opt
            ]);
        } else map.set(name, opt);
    });
}
function $8529070cc063bd98$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.watch) !== null && _a !== void 0 ? _a : optionBuilder.watch = {};
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var names = slot.getMap('watch');
    if (!names || names.size === 0) return;
    names.forEach(function(value, _name) {
        var values = Array.isArray(value) ? value : [
            value
        ];
        values.forEach(function(v) {
            if (!optionBuilder.watch[v.key]) optionBuilder.watch[v.key] = v;
            else {
                var t = optionBuilder.watch[v.key];
                if (Array.isArray(t)) t.push(v);
                else optionBuilder.watch[v.key] = [
                    t,
                    v
                ];
            }
        });
    });
}

});

parcelRegister("hbwBq", function(module, exports) {

$parcel$export(module.exports, "decorator", function () { return $c82cc0fa458ed94e$export$46bdae34a7208737; });
$parcel$export(module.exports, "build", function () { return $c82cc0fa458ed94e$export$3f8fe6489e95757d; });

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
var $c82cc0fa458ed94e$export$46bdae34a7208737 = (0, $bDXoP.optionNullableMemberDecorator)(function(proto, name, option) {
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var map = slot.obtainMap('props');
    var opt = Object.assign({}, option !== null && option !== void 0 ? option : {});
    map.set(name, opt);
});
function $c82cc0fa458ed94e$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.props) !== null && _a !== void 0 ? _a : optionBuilder.props = {};
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var names = slot.getMap('props');
    if (!names || names.size === 0) return;
    names.forEach(function(value, name) {
        optionBuilder.props[name] = value;
    });
}

});

parcelRegister("ksQts", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $ee5f20738e144c4f$export$3f8fe6489e95757d; });

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
var $ee5f20738e144c4f$export$46bdae34a7208737 = (0, $bDXoP.optionNullableMemberDecorator)(function(proto, name, option) {
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var map = slot.obtainMap('inject');
    var opt = Object.assign({}, option !== null && option !== void 0 ? option : {});
    map.set(name, opt);
});
function $ee5f20738e144c4f$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.inject) !== null && _a !== void 0 ? _a : optionBuilder.inject = {};
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var names = slot.getMap('inject');
    if (!names || names.size === 0) return;
    names.forEach(function(value, name) {
        optionBuilder.inject[name] = value;
    });
}

});

parcelRegister("7aIJh", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $0158f86afcf23a9b$export$3f8fe6489e95757d; });
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
var $0158f86afcf23a9b$export$46bdae34a7208737 = (0, $bDXoP.optionNullableMemberDecorator)(function(proto, name, key) {
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var map = slot.obtainMap('provide');
    map.set(name, typeof key === 'undefined' ? null : key);
});
function $0158f86afcf23a9b$export$3f8fe6489e95757d(cons, optionBuilder, vueInstance) {
    var _a;
    (_a = optionBuilder.provide) !== null && _a !== void 0 ? _a : optionBuilder.provide = {};
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var names = slot.obtainMap('provide');
    if (!names) return null;
    names.forEach(function(value, name) {
        var key = value === null ? name : value;
        optionBuilder.provide[key] = (0, $fKAHx.computed)(function() {
            return vueInstance[name];
        });
    });
}

});

parcelRegister("5B52k", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $41345098e10552a1$export$3f8fe6489e95757d; });

var $13u2V = parcelRequire("13u2V");

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
var $41345098e10552a1$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $41345098e10552a1$export$46bdae34a7208737 = (0, $bDXoP.optionNullableMemberDecorator)(function(proto, name, key) {
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var map = slot.obtainMap('emit');
    map.set(name, typeof key === 'undefined' ? null : key);
});
function $41345098e10552a1$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.methods) !== null && _a !== void 0 ? _a : optionBuilder.methods = {};
    var proto = cons.prototype;
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var names = slot.getMap('emit');
    if (!names || names.size === 0) return;
    var emits = slot.obtainMap('emits');
    names.forEach(function(value, key) {
        var eventName = value === null ? key : value;
        emits.set(eventName, true);
        optionBuilder.methods[key] = function() {
            return $41345098e10552a1$var$__awaiter(this, arguments, void 0, function() {
                var ret, proRet;
                var _arguments = arguments;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            ret = proto[key].apply(this, _arguments);
                            if (!(ret instanceof Promise)) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                ret
                            ];
                        case 1:
                            proRet = _state.sent();
                            this.$emit(eventName, proRet);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            if (ret === undefined) this.$emit(eventName);
                            else this.$emit(eventName, ret);
                            _state.label = 3;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
        };
    });
}

});

parcelRegister("lorU1", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $f9317bbe5ab64ee3$export$3f8fe6489e95757d; });

var $bDXoP = parcelRequire("bDXoP");

var $hbwBq = parcelRequire("hbwBq");

var $aBA3c = parcelRequire("aBA3c");
var $f9317bbe5ab64ee3$export$46bdae34a7208737 = (0, $bDXoP.optionNullableMemberDecorator)(function(proto, name, option) {
    var _a;
    option !== null && option !== void 0 ? option : option = {};
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var vmodelName = 'modelValue';
    var propsConfig = Object.assign({}, option);
    if (propsConfig) {
        vmodelName = (_a = propsConfig.name) !== null && _a !== void 0 ? _a : vmodelName;
        delete propsConfig.name;
    }
    (0, $hbwBq.decorator)(propsConfig)(proto, vmodelName);
    var map = slot.obtainMap('v-model');
    map.set(name, option);
});
function $f9317bbe5ab64ee3$export$3f8fe6489e95757d(cons, optionBuilder) {
    var _a;
    (_a = optionBuilder.computed) !== null && _a !== void 0 ? _a : optionBuilder.computed = {};
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var names = slot.getMap('v-model');
    if (!names || names.size === 0) return;
    var emits = slot.obtainMap('emits');
    names.forEach(function(value, name) {
        var _a;
        var vmodelName = (_a = value && value.name) !== null && _a !== void 0 ? _a : 'modelValue';
        var eventName = "update:".concat(vmodelName);
        optionBuilder.computed[name] = {
            get: function get() {
                return this[vmodelName];
            },
            set: function set(val) {
                this.$emit(eventName, val);
            }
        };
        emits.set(eventName, true);
    });
}

});

parcelRegister("f5Em7", function(module, exports) {

$parcel$export(module.exports, "build", function () { return $afc6a070e48615ee$export$3f8fe6489e95757d; });

var $la79R = parcelRequire("la79R");

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
function $afc6a070e48615ee$export$3f8fe6489e95757d(cons, optionBuilder) {
    var slot = (0, $aBA3c.obtainSlot)(cons.prototype);
    var vanillaMap = slot.getMap('vanilla');
    if (!vanillaMap || vanillaMap.size === 0) return;
    var protoArr = (0, $bDXoP.toComponentReverse)(cons.prototype);
    var map = new Map;
    (0, $la79R.applyAccessors)(optionBuilder, function(ctx) {
        protoArr.forEach(function(proto) {
            var deses = Object.getOwnPropertyDescriptors(proto);
            for(var name in deses){
                var des = deses[name];
                if (des && vanillaMap.has(name)) {
                    if (typeof des.get === 'function' || typeof des.set === 'function') map.set(name, {
                        set: typeof des.set === 'function' ? des.set.bind(ctx) : undefined,
                        get: typeof des.get === 'function' ? des.get.bind(ctx) : undefined
                    });
                }
            }
        });
        return map;
    });
}

});


parcelRegister("gY8sK", function(module, exports) {

var $bDXoP = parcelRequire("bDXoP");

var $aBA3c = parcelRequire("aBA3c");
var $c5a8d079740f4dd4$export$46bdae34a7208737 = (0, $bDXoP.optionNullableMemberDecorator)(function(proto, name) {
    var slot = (0, $aBA3c.obtainSlot)(proto);
    var map = slot.obtainMap('vanilla');
    map.set(name, true);
});

});

parcelRegister("UltEa", function(module, exports) {

var $aBA3c = parcelRequire("aBA3c");

var $ifVvN = parcelRequire("ifVvN");
function $0a95e3ff4fe8f1df$export$13d893143ac665a6(creator, opt) {
    return (0, $ifVvN.compatibleMemberDecorator)(function(proto, key) {
        var slot = (0, $aBA3c.obtainSlot)(proto);
        var map = slot.obtainMap('customDecorator');
        if (!map.has(key)) map.set(key, []);
        var arr = map.get(key);
        arr.push({
            key: key,
            creator: creator,
            preserve: !!(opt === null || opt === void 0 ? void 0 : opt.preserve)
        });
    });
}

});

parcelRegister("bRFSV", function(module, exports) {

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $hdIku = parcelRequire("hdIku");

var $fTAJe = parcelRequire("fTAJe");

var $aBA3c = parcelRequire("aBA3c");

var $8uJ7j = parcelRequire("8uJ7j");
function $8a35226f91653ba7$export$7d6c3ba1e86fd7aa() {
    for(var _len = arguments.length, conses = new Array(_len), _key = 0; _key < _len; _key++){
        conses[_key] = arguments[_key];
    }
    var MixinsClass = /*#__PURE__*/ function(Vue) {
        "use strict";
        (0, $hdIku._)(MixinsClass, Vue);
        function MixinsClass() {
            (0, $173N4._)(this, MixinsClass);
            return (0, $7qXGD._)(this, MixinsClass, arguments);
        }
        return MixinsClass;
    }((0, $8uJ7j.Base));
    (0, $fTAJe.ComponentBase)({
        mixins: conses.map(function(cons) {
            return (0, $aBA3c.obtainSlot)(cons.prototype).cachedVueComponent;
        })
    })(MixinsClass);
    return MixinsClass;
}

});

parcelRegister("1oPot", function(module, exports) {

$parcel$export(module.exports, "TSX", function () { return $104fe61213598fc6$export$94b8be0c52501862; });
function $104fe61213598fc6$export$94b8be0c52501862() {
    return function(cons) {
        return cons;
    };
}

});

parcelRegister("bvzkw", function(module, exports) {

});


parcelRegister("2sMtU", function(module, exports) {

$parcel$export(module.exports, "Observer", function () { return $ec89f63e09d7dee4$export$c1cbdee04e18ea8b; });
// src/index.ts

var $ji3LS = parcelRequire("ji3LS");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
var $ftLbb = parcelRequire("ftLbb");

var $h2kUE = parcelRequire("h2kUE");
var $ec89f63e09d7dee4$export$c1cbdee04e18ea8b = (0, $fKAHx.defineComponent)({
    data: function() {
        return {
            key: 0,
            dispose: function() {}
        };
    },
    mounted: function() {
        var _this = this;
        this.dispose = (0, $h2kUE.reaction)(function() {
            var _this_$slots_default, _this_$slots;
            return (_this_$slots_default = (_this_$slots = _this.$slots).default) === null || _this_$slots_default === void 0 ? void 0 : _this_$slots_default.call(_this_$slots);
        }, function() {
            _this.forceUpdate();
        }, {
            requiresObservable: true
        });
    },
    unmounted: function() {
        this.dispose();
    },
    methods: {
        forceUpdate: function() {
            this.key++;
        }
    },
    render: function() {
        return (0, $fKAHx.h)(this.$slots.default, {
            mobxVueKey: this.key
        });
    }
});
function $ec89f63e09d7dee4$export$aa207039f277c5f(initializer, annotations) {
    var localObservable = (0, $ftLbb.shallowRef)((0, $h2kUE.observable)(initializer(), annotations, {
        autoBind: true,
        deep: true
    }));
    var dispose = (0, $h2kUE.reaction)(function() {
        return (0, $h2kUE.toJS)(localObservable.value);
    }, function() {
        (0, $ftLbb.triggerRef)(localObservable);
    }, {
        fireImmediately: false,
        delay: 0
    });
    (0, $ji3LS.tryOnScopeDispose)(function() {
        dispose();
    });
    return (0, $ftLbb.readonly)(localObservable);
}
// src/index.ts
var $ec89f63e09d7dee4$export$901cf72dabf2112a = {
    install: function(app) {
        app.component("Observer", $ec89f63e09d7dee4$export$c1cbdee04e18ea8b);
    }
};
var $ec89f63e09d7dee4$export$2e2bcd8739ae039 = $ec89f63e09d7dee4$export$901cf72dabf2112a;

});
parcelRegister("ji3LS", function(module, exports) {

$parcel$export(module.exports, "tryOnScopeDispose", function () { return $f16e5b30169320d8$export$c3d49ae4e58d3d9d; });

var $3gP77 = parcelRequire("3gP77");

var $7Pjls = parcelRequire("7Pjls");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $13u2V = parcelRequire("13u2V");
parcelRequire("gbYVB");
var $fKAHx = parcelRequire("fKAHx");
var $ftLbb = parcelRequire("ftLbb");
var $gbYVB = parcelRequire("gbYVB");
function $f16e5b30169320d8$export$c92323792c35f5f1(fn, options) {
    var _a;
    var result = (0, $ftLbb.shallowRef)();
    (0, $fKAHx.watchEffect)(function() {
        result.value = fn();
    }, (0, $6fpqi._)((0, $1XAnY._)({}, options), {
        flush: (_a = options == null ? void 0 : options.flush) != null ? _a : "sync"
    }));
    return (0, $ftLbb.readonly)(result);
}
function $f16e5b30169320d8$export$220dfb31330e2956(source, fn) {
    var v = void 0;
    var track;
    var trigger;
    var dirty = (0, $ftLbb.ref)(true);
    var update = function() {
        dirty.value = true;
        trigger();
    };
    (0, $fKAHx.watch)(source, update, {
        flush: "sync"
    });
    var get = typeof fn === "function" ? fn : fn.get;
    var set = typeof fn === "function" ? void 0 : fn.set;
    var result = (0, $ftLbb.customRef)(function(_track, _trigger) {
        track = _track;
        trigger = _trigger;
        return {
            get: function() {
                if (dirty.value) {
                    v = get();
                    dirty.value = false;
                }
                track();
                return v;
            },
            set: function(v2) {
                set == null || set(v2);
            }
        };
    });
    if (Object.isExtensible(result)) result.trigger = update;
    return result;
}
function $f16e5b30169320d8$export$c3d49ae4e58d3d9d(fn) {
    if ((0, $ftLbb.getCurrentScope)()) {
        (0, $ftLbb.onScopeDispose)(fn);
        return true;
    }
    return false;
}
function $f16e5b30169320d8$export$c8b3b0996d763ee() {
    var fns = /* @__PURE__ */ new Set();
    var off = function(fn) {
        fns.delete(fn);
    };
    var on = function(fn) {
        fns.add(fn);
        var offFn = function() {
            return off(fn);
        };
        $f16e5b30169320d8$export$c3d49ae4e58d3d9d(offFn);
        return {
            off: offFn
        };
    };
    var trigger = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Promise.all(Array.from(fns).map(function(fn) {
            return fn.apply(void 0, (0, $aUGqu._)(args));
        }));
    };
    return {
        on: on,
        off: off,
        trigger: trigger
    };
}
function $f16e5b30169320d8$export$aa9aac23b3959ee1(stateFactory) {
    var initialized = false;
    var state;
    var scope = (0, $ftLbb.effectScope)(true);
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (!initialized) {
            state = scope.run(function() {
                return stateFactory.apply(void 0, (0, $aUGqu._)(args));
            });
            initialized = true;
        }
        return state;
    };
}
var $f16e5b30169320d8$var$localProvidedStateMap = /* @__PURE__ */ new WeakMap();
var $f16e5b30169320d8$export$a797c3886d31ed0 = function(key, value) {
    var _a;
    var instance = (_a = (0, $fKAHx.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("provideLocal must be called in setup");
    if (!$f16e5b30169320d8$var$localProvidedStateMap.has(instance)) $f16e5b30169320d8$var$localProvidedStateMap.set(instance, /* @__PURE__ */ Object.create(null));
    var localProvidedState = $f16e5b30169320d8$var$localProvidedStateMap.get(instance);
    localProvidedState[key] = value;
    (0, $fKAHx.provide)(key, value);
};
var $f16e5b30169320d8$export$89897216f9bf9933 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _a;
    var key = args[0];
    var instance = (_a = (0, $fKAHx.getCurrentInstance)()) == null ? void 0 : _a.proxy;
    if (instance == null) throw new Error("injectLocal must be called in setup");
    if ($f16e5b30169320d8$var$localProvidedStateMap.has(instance) && key in $f16e5b30169320d8$var$localProvidedStateMap.get(instance)) return $f16e5b30169320d8$var$localProvidedStateMap.get(instance)[key];
    return (0, $fKAHx.inject).apply(void 0, (0, $aUGqu._)(args));
};
function $f16e5b30169320d8$export$91b9c7550061230e(composable, options) {
    var key = (options == null ? void 0 : options.injectionKey) || Symbol("InjectionState");
    var useProvidingState = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var state = composable.apply(void 0, (0, $aUGqu._)(args));
        $f16e5b30169320d8$export$a797c3886d31ed0(key, state);
        return state;
    };
    var useInjectedState = function() {
        return $f16e5b30169320d8$export$89897216f9bf9933(key);
    };
    return [
        useProvidingState,
        useInjectedState
    ];
}
function $f16e5b30169320d8$export$9e8d4b001a1bb310(composable) {
    var subscribers = 0;
    var state;
    var scope;
    var dispose = function() {
        subscribers -= 1;
        if (scope && subscribers <= 0) {
            scope.stop();
            state = void 0;
            scope = void 0;
        }
    };
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        subscribers += 1;
        if (!state) {
            scope = (0, $ftLbb.effectScope)(true);
            state = scope.run(function() {
                return composable.apply(void 0, (0, $aUGqu._)(args));
            });
        }
        $f16e5b30169320d8$export$c3d49ae4e58d3d9d(dispose);
        return state;
    };
}
function $f16e5b30169320d8$export$ecda8b07a1b5deab(ref, extend) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_enumerable = _ref.enumerable, enumerable = _ref_enumerable === void 0 ? false : _ref_enumerable, _ref_unwrap = _ref.unwrap, unwrap = _ref_unwrap === void 0 ? true : _ref_unwrap;
    if (!(0, $gbYVB.isVue3) && !(0, $fKAHx.version).startsWith("2.7.")) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $f9AOD._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (key === "value") return "continue";
            if ((0, $ftLbb.isRef)(value) && unwrap) Object.defineProperty(ref, key, {
                get: function() {
                    return value.value;
                },
                set: function(v) {
                    value.value = v;
                },
                enumerable: enumerable
            });
            else Object.defineProperty(ref, key, {
                value: value,
                enumerable: enumerable
            });
        };
        for(var _iterator = Object.entries(extend)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return ref;
}
function $f16e5b30169320d8$export$3988ae62b71be9a3(obj, key) {
    if (key == null) return (0, $ftLbb.unref)(obj);
    return (0, $ftLbb.unref)(obj)[key];
}
function $f16e5b30169320d8$export$4e62c701997796c1(v) {
    return (0, $ftLbb.unref)(v) != null;
}
function $f16e5b30169320d8$export$d50fdd10db75504e(obj, arr) {
    if (typeof Symbol !== "undefined") {
        var clone = (0, $1XAnY._)({}, obj);
        Object.defineProperty(clone, Symbol.iterator, {
            enumerable: false,
            value: function() {
                var index = 0;
                return {
                    next: function() {
                        return {
                            value: arr[index++],
                            done: index > arr.length
                        };
                    }
                };
            }
        });
        return clone;
    } else return Object.assign((0, $aUGqu._)(arr), obj);
}
function $f16e5b30169320d8$export$30bdcc2218aa9458(r) {
    return typeof r === "function" ? r() : (0, $ftLbb.unref)(r);
}
var $f16e5b30169320d8$export$13fbab860e8afb41 = $f16e5b30169320d8$export$30bdcc2218aa9458;
function $f16e5b30169320d8$export$4ba03523724ba2d7(fn, options) {
    var unrefFn = (options == null ? void 0 : options.computedGetter) === false ? (0, $ftLbb.unref) : $f16e5b30169320d8$export$30bdcc2218aa9458;
    return function() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $fKAHx.computed)(function() {
            return fn.apply(_this, args.map(function(i) {
                return unrefFn(i);
            }));
        });
    };
}
function $f16e5b30169320d8$export$1ff2e29423610e60(obj) {
    var optionsOrKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var keys = [];
    var options;
    if (Array.isArray(optionsOrKeys)) keys = optionsOrKeys;
    else {
        var _keys, _keys1;
        options = optionsOrKeys;
        var _optionsOrKeys_includeOwnProperties = optionsOrKeys.includeOwnProperties, includeOwnProperties = _optionsOrKeys_includeOwnProperties === void 0 ? true : _optionsOrKeys_includeOwnProperties;
        (_keys = keys).push.apply(_keys, (0, $aUGqu._)(Object.keys(obj)));
        if (includeOwnProperties) (_keys1 = keys).push.apply(_keys1, (0, $aUGqu._)(Object.getOwnPropertyNames(obj)));
    }
    return Object.fromEntries(keys.map(function(key) {
        var value = obj[key];
        return [
            key,
            typeof value === "function" ? $f16e5b30169320d8$export$4ba03523724ba2d7(value.bind(obj), options) : value
        ];
    }));
}
function $f16e5b30169320d8$export$45c769cf449a508c(objectRef) {
    if (!(0, $ftLbb.isRef)(objectRef)) return (0, $ftLbb.reactive)(objectRef);
    var proxy = new Proxy({}, {
        get: function(_, p, receiver) {
            return (0, $ftLbb.unref)(Reflect.get(objectRef.value, p, receiver));
        },
        set: function(_, p, value) {
            if ((0, $ftLbb.isRef)(objectRef.value[p]) && !(0, $ftLbb.isRef)(value)) objectRef.value[p].value = value;
            else objectRef.value[p] = value;
            return true;
        },
        deleteProperty: function(_, p) {
            return Reflect.deleteProperty(objectRef.value, p);
        },
        has: function(_, p) {
            return Reflect.has(objectRef.value, p);
        },
        ownKeys: function() {
            return Object.keys(objectRef.value);
        },
        getOwnPropertyDescriptor: function() {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
    return (0, $ftLbb.reactive)(proxy);
}
function $f16e5b30169320d8$export$35298289c11958e1(fn) {
    return $f16e5b30169320d8$export$45c769cf449a508c((0, $fKAHx.computed)(fn));
}
function $f16e5b30169320d8$export$797deb43a681bdd1(obj) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    var flatKeys = keys.flat();
    var predicate = flatKeys[0];
    return $f16e5b30169320d8$export$35298289c11958e1(function() {
        return typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $ftLbb.toRefs)(obj)).filter(function(param) {
            var _param = (0, $f9AOD._)(param, 2), k = _param[0], v = _param[1];
            return !predicate($f16e5b30169320d8$export$30bdcc2218aa9458(v), k);
        })) : Object.fromEntries(Object.entries((0, $ftLbb.toRefs)(obj)).filter(function(e) {
            return !flatKeys.includes(e[0]);
        }));
    });
}
var $f16e5b30169320d8$export$7383f122bf48ec30 = typeof window !== "undefined" && typeof document !== "undefined";
var $f16e5b30169320d8$export$3c901a5f01941a06 = typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
var $f16e5b30169320d8$export$7b816c9b8ecf71b4 = function(val) {
    return typeof val !== "undefined";
};
var $f16e5b30169320d8$export$aedb69ff3e31596c = function(val) {
    return val != null;
};
var $f16e5b30169320d8$export$a7a9523472993e97 = function(condition) {
    for(var _len = arguments.length, infos = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        infos[_key - 1] = arguments[_key];
    }
    var _console;
    if (!condition) (_console = console).warn.apply(_console, (0, $aUGqu._)(infos));
};
var $f16e5b30169320d8$var$toString = Object.prototype.toString;
var $f16e5b30169320d8$export$a6cdc56e425d0d0a = function(val) {
    return $f16e5b30169320d8$var$toString.call(val) === "[object Object]";
};
var $f16e5b30169320d8$export$461939dd4422153 = function() {
    return Date.now();
};
var $f16e5b30169320d8$export$fc00ee57782020aa = function() {
    return +Date.now();
};
var $f16e5b30169320d8$export$7d15b64cf5a3a4c4 = function(n, min, max) {
    return Math.min(max, Math.max(min, n));
};
var $f16e5b30169320d8$export$8793edee2d425525 = function() {};
var $f16e5b30169320d8$export$bb0a9c36cf454ea0 = function(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
var $f16e5b30169320d8$export$b5a638e9b3fff9f3 = function(val, key) {
    return Object.prototype.hasOwnProperty.call(val, key);
};
var $f16e5b30169320d8$export$fedb369cb70207f1 = /* @__PURE__ */ $f16e5b30169320d8$var$getIsIOS();
function $f16e5b30169320d8$var$getIsIOS() {
    var _a, _b;
    return $f16e5b30169320d8$export$7383f122bf48ec30 && ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function $f16e5b30169320d8$export$a1f1cf91007f23bf(filter, fn) {
    function wrapper() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return new Promise(function(resolve, reject) {
            Promise.resolve(filter(function() {
                return fn.apply(_this, args);
            }, {
                fn: fn,
                thisArg: _this,
                args: args
            })).then(resolve).catch(reject);
        });
    }
    return wrapper;
}
var $f16e5b30169320d8$export$8cc0e33a27868391 = function(invoke) {
    return invoke();
};
function $f16e5b30169320d8$export$fca2c450ae03b38e(ms) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var timer;
    var maxTimer;
    var lastRejector = $f16e5b30169320d8$export$8793edee2d425525;
    var _clearTimeout = function(timer2) {
        clearTimeout(timer2);
        lastRejector();
        lastRejector = $f16e5b30169320d8$export$8793edee2d425525;
    };
    var filter = function(invoke) {
        var duration = $f16e5b30169320d8$export$30bdcc2218aa9458(ms);
        var maxDuration = $f16e5b30169320d8$export$30bdcc2218aa9458(options.maxWait);
        if (timer) _clearTimeout(timer);
        if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
            if (maxTimer) {
                _clearTimeout(maxTimer);
                maxTimer = null;
            }
            return Promise.resolve(invoke());
        }
        return new Promise(function(resolve, reject) {
            lastRejector = options.rejectOnCancel ? reject : resolve;
            if (maxDuration && !maxTimer) maxTimer = setTimeout(function() {
                if (timer) _clearTimeout(timer);
                maxTimer = null;
                resolve(invoke());
            }, maxDuration);
            timer = setTimeout(function() {
                if (maxTimer) _clearTimeout(maxTimer);
                maxTimer = null;
                resolve(invoke());
            }, duration);
        });
    };
    return filter;
}
function $f16e5b30169320d8$export$cd62e9dbf204fd92(ms) {
    var trailing = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, leading = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, rejectOnCancel = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var lastExec = 0;
    var timer;
    var isLeading = true;
    var lastRejector = $f16e5b30169320d8$export$8793edee2d425525;
    var lastValue;
    var clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = void 0;
            lastRejector();
            lastRejector = $f16e5b30169320d8$export$8793edee2d425525;
        }
    };
    var filter = function(_invoke) {
        var duration = $f16e5b30169320d8$export$30bdcc2218aa9458(ms);
        var elapsed = Date.now() - lastExec;
        var invoke = function() {
            return lastValue = _invoke();
        };
        clear();
        if (duration <= 0) {
            lastExec = Date.now();
            return invoke();
        }
        if (elapsed > duration && (leading || !isLeading)) {
            lastExec = Date.now();
            invoke();
        } else if (trailing) lastValue = new Promise(function(resolve, reject) {
            lastRejector = rejectOnCancel ? reject : resolve;
            timer = setTimeout(function() {
                lastExec = Date.now();
                isLeading = true;
                resolve(invoke());
                clear();
            }, Math.max(0, duration - elapsed));
        });
        if (!leading && !timer) timer = setTimeout(function() {
            return isLeading = true;
        }, duration);
        isLeading = false;
        return lastValue;
    };
    return filter;
}
function $f16e5b30169320d8$export$8d46ce8e0ead9c2b() {
    var extendFilter = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $f16e5b30169320d8$export$8cc0e33a27868391;
    var isActive = (0, $ftLbb.ref)(true);
    function pause() {
        isActive.value = false;
    }
    function resume() {
        isActive.value = true;
    }
    var eventFilter = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (isActive.value) extendFilter.apply(void 0, (0, $aUGqu._)(args));
    };
    return {
        isActive: (0, $ftLbb.readonly)(isActive),
        pause: pause,
        resume: resume,
        eventFilter: eventFilter
    };
}
var $f16e5b30169320d8$export$2161f27fc78b6ab2 = {
    mounted: (0, $gbYVB.isVue3) ? "mounted" : "inserted",
    updated: (0, $gbYVB.isVue3) ? "updated" : "componentUpdated",
    unmounted: (0, $gbYVB.isVue3) ? "unmounted" : "unbind"
};
function $f16e5b30169320d8$var$cacheStringFunction(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
var $f16e5b30169320d8$var$hyphenateRE = /\B([A-Z])/g;
var $f16e5b30169320d8$export$6e6a0a3676c4b8bb = $f16e5b30169320d8$var$cacheStringFunction(function(str) {
    return str.replace($f16e5b30169320d8$var$hyphenateRE, "-$1").toLowerCase();
});
var $f16e5b30169320d8$var$camelizeRE = /-(\w)/g;
var $f16e5b30169320d8$export$161d051f5dd25de7 = $f16e5b30169320d8$var$cacheStringFunction(function(str) {
    return str.replace($f16e5b30169320d8$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
function $f16e5b30169320d8$export$69e8b3daf72c74b7(ms) {
    var throwOnTimeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, reason = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Timeout";
    return new Promise(function(resolve, reject) {
        if (throwOnTimeout) setTimeout(function() {
            return reject(reason);
        }, ms);
        else setTimeout(resolve, ms);
    });
}
function $f16e5b30169320d8$export$f0954fd7d5368655(arg) {
    return arg;
}
function $f16e5b30169320d8$export$7a0c7c93e8e22bce(fn) {
    var _promise;
    function wrapper() {
        if (!_promise) _promise = fn();
        return _promise;
    }
    wrapper.reset = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _prev;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _prev = _promise;
                        _promise = void 0;
                        if (!_prev) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            _prev
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    return wrapper;
}
function $f16e5b30169320d8$export$468cda29b159ee5d(fn) {
    return fn();
}
function $f16e5b30169320d8$export$d138bf93e1dfa23f(obj) {
    for(var _len = arguments.length, props = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        props[_key - 1] = arguments[_key];
    }
    return props.some(function(k) {
        return k in obj;
    });
}
function $f16e5b30169320d8$export$f5c97f6a04b90212(target, delta) {
    var _a;
    if (typeof target === "number") return target + delta;
    var value = ((_a = target.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : _a[0]) || "";
    var unit = target.slice(value.length);
    var result = Number.parseFloat(value) + delta;
    if (Number.isNaN(result)) return target;
    return result + unit;
}
function $f16e5b30169320d8$export$5f2d71bd504be1ec(obj, keys) {
    var omitUndefined = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return keys.reduce(function(n, k) {
        if (k in obj) {
            if (!omitUndefined || obj[k] !== void 0) n[k] = obj[k];
        }
        return n;
    }, {});
}
function $f16e5b30169320d8$export$3320623908f24e40(obj, keys) {
    var omitUndefined = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
        return (!omitUndefined || value !== void 0) && !keys.includes(key);
    }));
}
function $f16e5b30169320d8$export$6a29ade99f81ec8a(obj) {
    return Object.entries(obj);
}
function $f16e5b30169320d8$export$5c967efe8efb656c(target) {
    return target || (0, $fKAHx.getCurrentInstance)();
}
function $f16e5b30169320d8$export$1f60508e4f47b4b7() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (args.length !== 1) return (0, $ftLbb.toRef).apply(void 0, (0, $aUGqu._)(args));
    var r = args[0];
    return typeof r === "function" ? (0, $ftLbb.readonly)((0, $ftLbb.customRef)(function() {
        return {
            get: r,
            set: $f16e5b30169320d8$export$8793edee2d425525
        };
    })) : (0, $ftLbb.ref)(r);
}
var $f16e5b30169320d8$export$fb2b8a41d9966b32 = $f16e5b30169320d8$export$1f60508e4f47b4b7;
function $f16e5b30169320d8$export$afd74972d99a820f(obj) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    var flatKeys = keys.flat();
    var predicate = flatKeys[0];
    return $f16e5b30169320d8$export$35298289c11958e1(function() {
        return typeof predicate === "function" ? Object.fromEntries(Object.entries((0, $ftLbb.toRefs)(obj)).filter(function(param) {
            var _param = (0, $f9AOD._)(param, 2), k = _param[0], v = _param[1];
            return predicate($f16e5b30169320d8$export$30bdcc2218aa9458(v), k);
        })) : Object.fromEntries(flatKeys.map(function(k) {
            return [
                k,
                $f16e5b30169320d8$export$1f60508e4f47b4b7(obj, k)
            ];
        }));
    });
}
function $f16e5b30169320d8$export$c1f1e286df6cc58f(defaultValue) {
    var afterMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e4;
    return (0, $ftLbb.customRef)(function(track, trigger) {
        var value = $f16e5b30169320d8$export$30bdcc2218aa9458(defaultValue);
        var timer;
        var resetAfter = function() {
            return setTimeout(function() {
                value = $f16e5b30169320d8$export$30bdcc2218aa9458(defaultValue);
                trigger();
            }, $f16e5b30169320d8$export$30bdcc2218aa9458(afterMs));
        };
        $f16e5b30169320d8$export$c3d49ae4e58d3d9d(function() {
            clearTimeout(timer);
        });
        return {
            get: function() {
                track();
                return value;
            },
            set: function(newValue) {
                value = newValue;
                trigger();
                clearTimeout(timer);
                timer = resetAfter();
            }
        };
    });
}
function $f16e5b30169320d8$export$ddf8f1aa96b8ea88(fn) {
    var ms = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return $f16e5b30169320d8$export$a1f1cf91007f23bf($f16e5b30169320d8$export$fca2c450ae03b38e(ms, options), fn);
}
function $f16e5b30169320d8$export$179967fbe3ecb41a(value) {
    var ms = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var debounced = (0, $ftLbb.ref)(value.value);
    var updater = $f16e5b30169320d8$export$ddf8f1aa96b8ea88(function() {
        debounced.value = value.value;
    }, ms, options);
    (0, $fKAHx.watch)(value, function() {
        return updater();
    });
    return debounced;
}
function $f16e5b30169320d8$export$52a73c0b6dcfe111(source, defaultValue) {
    return (0, $fKAHx.computed)({
        get: function() {
            var _a;
            return (_a = source.value) != null ? _a : defaultValue;
        },
        set: function(value) {
            source.value = value;
        }
    });
}
function $f16e5b30169320d8$export$8ed85856108010bc(fn) {
    var ms = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, trailing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, leading = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, rejectOnCancel = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return $f16e5b30169320d8$export$a1f1cf91007f23bf($f16e5b30169320d8$export$cd62e9dbf204fd92(ms, trailing, leading, rejectOnCancel), fn);
}
function $f16e5b30169320d8$export$4d1d638ad6b48495(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 200, trailing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, leading = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    if (delay <= 0) return value;
    var throttled = (0, $ftLbb.ref)(value.value);
    var updater = $f16e5b30169320d8$export$8ed85856108010bc(function() {
        throttled.value = value.value;
    }, delay, trailing, leading);
    (0, $fKAHx.watch)(value, function() {
        return updater();
    });
    return throttled;
}
function $f16e5b30169320d8$export$4b7f2010e13474b2(initial) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var source = initial;
    var track;
    var trigger;
    var ref = (0, $ftLbb.customRef)(function(_track, _trigger) {
        track = _track;
        trigger = _trigger;
        return {
            get: function() {
                return get();
            },
            set: function(v) {
                set(v);
            }
        };
    });
    function get() {
        var tracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (tracking) track();
        return source;
    }
    function set(value) {
        var triggering = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _a, _b;
        if (value === source) return;
        var old = source;
        if (((_a = options.onBeforeChange) == null ? void 0 : _a.call(options, value, old)) === false) return;
        source = value;
        (_b = options.onChanged) == null || _b.call(options, value, old);
        if (triggering) trigger();
    }
    var untrackedGet = function() {
        return get(false);
    };
    var silentSet = function(v) {
        return set(v, false);
    };
    var peek = function() {
        return get(false);
    };
    var lay = function(v) {
        return set(v, false);
    };
    return $f16e5b30169320d8$export$ecda8b07a1b5deab(ref, {
        get: get,
        set: set,
        untrackedGet: untrackedGet,
        silentSet: silentSet,
        peek: peek,
        lay: lay
    }, {
        enumerable: true
    });
}
var $f16e5b30169320d8$export$6b6db3af7a80e2d2 = $f16e5b30169320d8$export$4b7f2010e13474b2;
function $f16e5b30169320d8$export$adaa4cf7ef1b65be() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (args.length === 2) {
        var _args = (0, $f9AOD._)(args, 2), ref = _args[0], value = _args[1];
        ref.value = value;
    }
    if (args.length === 3) {
        if (0, $gbYVB.isVue2) (0, $gbYVB.set).apply(void 0, (0, $aUGqu._)(args));
        else {
            var _args1 = (0, $f9AOD._)(args, 3), target = _args1[0], key = _args1[1], value1 = _args1[2];
            target[key] = value1;
        }
    }
}
function $f16e5b30169320d8$export$3955c00bb6715986(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_eventFilter = options.eventFilter, eventFilter = _options_eventFilter === void 0 ? $f16e5b30169320d8$export$8cc0e33a27868391 : _options_eventFilter, watchOptions = (0, $6acIq._)(options, [
        "eventFilter"
    ]);
    return (0, $fKAHx.watch)(source, $f16e5b30169320d8$export$a1f1cf91007f23bf(eventFilter, cb), watchOptions);
}
function $f16e5b30169320d8$export$37fdf671f882195e(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var filter = options.eventFilter, watchOptions = (0, $6acIq._)(options, [
        "eventFilter"
    ]);
    var _pausableFilter = $f16e5b30169320d8$export$8d46ce8e0ead9c2b(filter), eventFilter = _pausableFilter.eventFilter, pause = _pausableFilter.pause, resume = _pausableFilter.resume, isActive = _pausableFilter.isActive;
    var stop = $f16e5b30169320d8$export$3955c00bb6715986(source, cb, (0, $6fpqi._)((0, $1XAnY._)({}, watchOptions), {
        eventFilter: eventFilter
    }));
    return {
        stop: stop,
        pause: pause,
        resume: resume,
        isActive: isActive
    };
}
function $f16e5b30169320d8$export$d43743c1df800be0(left, right) {
    for(var _len = arguments.length, _tmp = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        _tmp[_key - 2] = arguments[_key];
    }
    var _tmp1 = (0, $f9AOD._)(_tmp, 1), options = _tmp1[0];
    var _ref = options || {}, _ref_flush = _ref.flush, flush = _ref_flush === void 0 ? "sync" : _ref_flush, _ref_deep = _ref.deep, deep = _ref_deep === void 0 ? false : _ref_deep, _ref_immediate = _ref.immediate, immediate = _ref_immediate === void 0 ? true : _ref_immediate, _ref_direction = _ref.direction, direction = _ref_direction === void 0 ? "both" : _ref_direction, _ref_transform = _ref.transform, transform = _ref_transform === void 0 ? {} : _ref_transform;
    var watchers = [];
    var transformLTR = "ltr" in transform && transform.ltr || function(v) {
        return v;
    };
    var transformRTL = "rtl" in transform && transform.rtl || function(v) {
        return v;
    };
    if (direction === "both" || direction === "ltr") watchers.push($f16e5b30169320d8$export$37fdf671f882195e(left, function(newValue) {
        watchers.forEach(function(w) {
            return w.pause();
        });
        right.value = transformLTR(newValue);
        watchers.forEach(function(w) {
            return w.resume();
        });
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    if (direction === "both" || direction === "rtl") watchers.push($f16e5b30169320d8$export$37fdf671f882195e(right, function(newValue) {
        watchers.forEach(function(w) {
            return w.pause();
        });
        left.value = transformRTL(newValue);
        watchers.forEach(function(w) {
            return w.resume();
        });
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    }));
    var stop = function() {
        watchers.forEach(function(w) {
            return w.stop();
        });
    };
    return stop;
}
function $f16e5b30169320d8$export$16a582ae8a437df6(source, targets) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_flush = options.flush, flush = _options_flush === void 0 ? "sync" : _options_flush, _options_deep = options.deep, deep = _options_deep === void 0 ? false : _options_deep, _options_immediate = options.immediate, immediate = _options_immediate === void 0 ? true : _options_immediate;
    if (!Array.isArray(targets)) targets = [
        targets
    ];
    return (0, $fKAHx.watch)(source, function(newValue) {
        return targets.forEach(function(target) {
            return target.value = newValue;
        });
    }, {
        flush: flush,
        deep: deep,
        immediate: immediate
    });
}
function $f16e5b30169320d8$export$2e9533675e5e70e0(objectRef) {
    var _loop = function(key) {
        result[key] = (0, $ftLbb.customRef)(function() {
            return {
                get: function() {
                    return objectRef.value[key];
                },
                set: function(v) {
                    var _a;
                    var replaceRef = (_a = $f16e5b30169320d8$export$30bdcc2218aa9458(options.replaceRef)) != null ? _a : true;
                    if (replaceRef) {
                        if (Array.isArray(objectRef.value)) {
                            var copy = (0, $aUGqu._)(objectRef.value);
                            copy[key] = v;
                            objectRef.value = copy;
                        } else {
                            var newObject = (0, $6fpqi._)((0, $1XAnY._)({}, objectRef.value), (0, $7Pjls._)({}, key, v));
                            Object.setPrototypeOf(newObject, Object.getPrototypeOf(objectRef.value));
                            objectRef.value = newObject;
                        }
                    } else objectRef.value[key] = v;
                }
            };
        });
    };
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!(0, $ftLbb.isRef)(objectRef)) return (0, $ftLbb.toRefs)(objectRef);
    var result = Array.isArray(objectRef.value) ? Array.from({
        length: objectRef.value.length
    }) : {};
    for(var key in objectRef.value)_loop(key);
    return result;
}
function $f16e5b30169320d8$export$25180f6b7105226e(fn) {
    var sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, target = arguments.length > 2 ? arguments[2] : void 0;
    var instance = $f16e5b30169320d8$export$5c967efe8efb656c(target);
    if (instance) (0, $fKAHx.onBeforeMount)(fn, target);
    else if (sync) fn();
    else (0, $fKAHx.nextTick)(fn);
}
function $f16e5b30169320d8$export$7b037ce8d7969c15(fn, target) {
    var instance = $f16e5b30169320d8$export$5c967efe8efb656c(target);
    if (instance) (0, $fKAHx.onBeforeUnmount)(fn, target);
}
function $f16e5b30169320d8$export$cf1be5b643f0827(fn) {
    var sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, target = arguments.length > 2 ? arguments[2] : void 0;
    var instance = $f16e5b30169320d8$export$5c967efe8efb656c();
    if (instance) (0, $fKAHx.onMounted)(fn, target);
    else if (sync) fn();
    else (0, $fKAHx.nextTick)(fn);
}
function $f16e5b30169320d8$export$9fa6e59ca833c930(fn, target) {
    var instance = $f16e5b30169320d8$export$5c967efe8efb656c(target);
    if (instance) (0, $fKAHx.onUnmounted)(fn, target);
}
function $f16e5b30169320d8$var$createUntil(r) {
    var isNot = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    function toMatch(condition) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_flush = _ref.flush, flush = _ref_flush === void 0 ? "sync" : _ref_flush, _ref_deep = _ref.deep, deep = _ref_deep === void 0 ? false : _ref_deep, timeout = _ref.timeout, throwOnTimeout = _ref.throwOnTimeout;
        var stop = null;
        var watcher = new Promise(function(resolve) {
            stop = (0, $fKAHx.watch)(r, function(v) {
                if (condition(v) !== isNot) {
                    stop == null || stop();
                    resolve(v);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        var promises = [
            watcher
        ];
        if (timeout != null) promises.push($f16e5b30169320d8$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(function() {
            return $f16e5b30169320d8$export$30bdcc2218aa9458(r);
        }).finally(function() {
            return stop == null ? void 0 : stop();
        }));
        return Promise.race(promises);
    }
    function toBe(value, options) {
        if (!(0, $ftLbb.isRef)(value)) return toMatch(function(v) {
            return v === value;
        }, options);
        var _ref = options != null ? options : {}, _ref_flush = _ref.flush, flush = _ref_flush === void 0 ? "sync" : _ref_flush, _ref_deep = _ref.deep, deep = _ref_deep === void 0 ? false : _ref_deep, timeout = _ref.timeout, throwOnTimeout = _ref.throwOnTimeout;
        var stop = null;
        var watcher = new Promise(function(resolve) {
            stop = (0, $fKAHx.watch)([
                r,
                value
            ], function(param) {
                var _param = (0, $f9AOD._)(param, 2), v1 = _param[0], v2 = _param[1];
                if (isNot !== (v1 === v2)) {
                    stop == null || stop();
                    resolve(v1);
                }
            }, {
                flush: flush,
                deep: deep,
                immediate: true
            });
        });
        var promises = [
            watcher
        ];
        if (timeout != null) promises.push($f16e5b30169320d8$export$69e8b3daf72c74b7(timeout, throwOnTimeout).then(function() {
            return $f16e5b30169320d8$export$30bdcc2218aa9458(r);
        }).finally(function() {
            stop == null || stop();
            return $f16e5b30169320d8$export$30bdcc2218aa9458(r);
        }));
        return Promise.race(promises);
    }
    function toBeTruthy(options) {
        return toMatch(function(v) {
            return Boolean(v);
        }, options);
    }
    function toBeNull(options) {
        return toBe(null, options);
    }
    function toBeUndefined(options) {
        return toBe(void 0, options);
    }
    function toBeNaN(options) {
        return toMatch(Number.isNaN, options);
    }
    function toContains(value, options) {
        return toMatch(function(v) {
            var array = Array.from(v);
            return array.includes(value) || array.includes($f16e5b30169320d8$export$30bdcc2218aa9458(value));
        }, options);
    }
    function changed(options) {
        return changedTimes(1, options);
    }
    function changedTimes() {
        var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1, options = arguments.length > 1 ? arguments[1] : void 0;
        var count = -1;
        return toMatch(function() {
            count += 1;
            return count >= n;
        }, options);
    }
    if (Array.isArray($f16e5b30169320d8$export$30bdcc2218aa9458(r))) {
        var instance = {
            toMatch: toMatch,
            toContains: toContains,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $f16e5b30169320d8$var$createUntil(r, !isNot);
            }
        };
        return instance;
    } else {
        var instance1 = {
            toMatch: toMatch,
            toBe: toBe,
            toBeTruthy: toBeTruthy,
            toBeNull: toBeNull,
            toBeNaN: toBeNaN,
            toBeUndefined: toBeUndefined,
            changed: changed,
            changedTimes: changedTimes,
            get not () {
                return $f16e5b30169320d8$var$createUntil(r, !isNot);
            }
        };
        return instance1;
    }
}
function $f16e5b30169320d8$export$a40009bd2c363351(r) {
    return $f16e5b30169320d8$var$createUntil(r);
}
function $f16e5b30169320d8$var$defaultComparator(value, othVal) {
    return value === othVal;
}
function $f16e5b30169320d8$export$34602ebc410e389c() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _a;
    var list = args[0];
    var values = args[1];
    var compareFn = (_a = args[2]) != null ? _a : $f16e5b30169320d8$var$defaultComparator;
    if (typeof compareFn === "string") {
        var key = compareFn;
        compareFn = function(value, othVal) {
            return value[key] === othVal[key];
        };
    }
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(list).filter(function(x) {
            return $f16e5b30169320d8$export$30bdcc2218aa9458(values).findIndex(function(y) {
                return compareFn(x, y);
            }) === -1;
        });
    });
}
function $f16e5b30169320d8$export$1e5a400faddb345f(list, fn) {
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(list).every(function(element, index, array) {
            return fn($f16e5b30169320d8$export$30bdcc2218aa9458(element), index, array);
        });
    });
}
function $f16e5b30169320d8$export$d62e4083f0a2d244(list, fn) {
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(list).map(function(i) {
            return $f16e5b30169320d8$export$30bdcc2218aa9458(i);
        }).filter(fn);
    });
}
function $f16e5b30169320d8$export$ace4ef07c63f605e(list, fn) {
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458($f16e5b30169320d8$export$30bdcc2218aa9458(list).find(function(element, index, array) {
            return fn($f16e5b30169320d8$export$30bdcc2218aa9458(element), index, array);
        }));
    });
}
function $f16e5b30169320d8$export$3ec066cdb63e2970(list, fn) {
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(list).findIndex(function(element, index, array) {
            return fn($f16e5b30169320d8$export$30bdcc2218aa9458(element), index, array);
        });
    });
}
function $f16e5b30169320d8$var$findLast(arr, cb) {
    var index = arr.length;
    while(index-- > 0){
        if (cb(arr[index], index, arr)) return arr[index];
    }
    return void 0;
}
function $f16e5b30169320d8$export$b59cd47693a134f7(list, fn) {
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(!Array.prototype.findLast ? $f16e5b30169320d8$var$findLast($f16e5b30169320d8$export$30bdcc2218aa9458(list), function(element, index, array) {
            return fn($f16e5b30169320d8$export$30bdcc2218aa9458(element), index, array);
        }) : $f16e5b30169320d8$export$30bdcc2218aa9458(list).findLast(function(element, index, array) {
            return fn($f16e5b30169320d8$export$30bdcc2218aa9458(element), index, array);
        }));
    });
}
function $f16e5b30169320d8$var$isArrayIncludesOptions(obj) {
    return $f16e5b30169320d8$export$a6cdc56e425d0d0a(obj) && $f16e5b30169320d8$export$d138bf93e1dfa23f(obj, "formIndex", "comparator");
}
function $f16e5b30169320d8$export$34f006a38543d952() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _a;
    var list = args[0];
    var value = args[1];
    var comparator = args[2];
    var formIndex = 0;
    if ($f16e5b30169320d8$var$isArrayIncludesOptions(comparator)) {
        formIndex = (_a = comparator.fromIndex) != null ? _a : 0;
        comparator = comparator.comparator;
    }
    if (typeof comparator === "string") {
        var key = comparator;
        comparator = function(element, value2) {
            return element[key] === $f16e5b30169320d8$export$30bdcc2218aa9458(value2);
        };
    }
    comparator = comparator != null ? comparator : function(element, value2) {
        return element === $f16e5b30169320d8$export$30bdcc2218aa9458(value2);
    };
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(list).slice(formIndex).some(function(element, index, array) {
            return comparator($f16e5b30169320d8$export$30bdcc2218aa9458(element), $f16e5b30169320d8$export$30bdcc2218aa9458(value), index, $f16e5b30169320d8$export$30bdcc2218aa9458(array));
        });
    });
}
function $f16e5b30169320d8$export$4a02928bbff39848(list, separator) {
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(list).map(function(i) {
            return $f16e5b30169320d8$export$30bdcc2218aa9458(i);
        }).join($f16e5b30169320d8$export$30bdcc2218aa9458(separator));
    });
}
function $f16e5b30169320d8$export$8cc4758f083c4ffe(list, fn) {
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(list).map(function(i) {
            return $f16e5b30169320d8$export$30bdcc2218aa9458(i);
        }).map(fn);
    });
}
function $f16e5b30169320d8$export$2a4c0ee40e3400de(list, reducer) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        args[_key - 2] = arguments[_key];
    }
    var reduceCallback = function(sum, value, index) {
        return reducer($f16e5b30169320d8$export$30bdcc2218aa9458(sum), $f16e5b30169320d8$export$30bdcc2218aa9458(value), index);
    };
    return (0, $fKAHx.computed)(function() {
        var resolved = $f16e5b30169320d8$export$30bdcc2218aa9458(list);
        return args.length ? resolved.reduce(reduceCallback, $f16e5b30169320d8$export$30bdcc2218aa9458(args[0])) : resolved.reduce(reduceCallback);
    });
}
function $f16e5b30169320d8$export$53834b0e1a20e7a3(list, fn) {
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(list).some(function(element, index, array) {
            return fn($f16e5b30169320d8$export$30bdcc2218aa9458(element), index, array);
        });
    });
}
function $f16e5b30169320d8$var$uniq(array) {
    return Array.from(new Set(array));
}
function $f16e5b30169320d8$var$uniqueElementsBy(array, fn) {
    return array.reduce(function(acc, v) {
        if (!acc.some(function(x) {
            return fn(v, x, array);
        })) acc.push(v);
        return acc;
    }, []);
}
function $f16e5b30169320d8$export$1b97ec936c2f7d03(list, compareFn) {
    return (0, $fKAHx.computed)(function() {
        var resolvedList = $f16e5b30169320d8$export$30bdcc2218aa9458(list).map(function(element) {
            return $f16e5b30169320d8$export$30bdcc2218aa9458(element);
        });
        return compareFn ? $f16e5b30169320d8$var$uniqueElementsBy(resolvedList, compareFn) : $f16e5b30169320d8$var$uniq(resolvedList);
    });
}
function $f16e5b30169320d8$export$70c4067197c60e2d() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _initialValue = (0, $ftLbb.unref)(initialValue);
    var count = (0, $ftLbb.ref)(initialValue);
    var _options_max = options.max, max = _options_max === void 0 ? Number.POSITIVE_INFINITY : _options_max, _options_min = options.min, min = _options_min === void 0 ? Number.NEGATIVE_INFINITY : _options_min;
    var inc = function() {
        var delta = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        return count.value = Math.min(max, count.value + delta);
    };
    var dec = function() {
        var delta = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        return count.value = Math.max(min, count.value - delta);
    };
    var get = function() {
        return count.value;
    };
    var set = function(val) {
        return count.value = Math.max(min, Math.min(max, val));
    };
    var reset = function() {
        var val = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _initialValue;
        _initialValue = val;
        return set(val);
    };
    return {
        count: count,
        inc: inc,
        dec: dec,
        get: get,
        set: set,
        reset: reset
    };
}
var $f16e5b30169320d8$var$REGEX_PARSE = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/;
var $f16e5b30169320d8$var$REGEX_FORMAT = /[YMDHhms]o|\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a{1,2}|A{1,2}|m{1,2}|s{1,2}|Z{1,2}|SSS/g;
function $f16e5b30169320d8$var$defaultMeridiem(hours, minutes, isLowercase, hasPeriod) {
    var m = hours < 12 ? "AM" : "PM";
    if (hasPeriod) m = m.split("").reduce(function(acc, curr) {
        return acc += "".concat(curr, ".");
    }, "");
    return isLowercase ? m.toLowerCase() : m;
}
function $f16e5b30169320d8$var$formatOrdinal(num) {
    var suffixes = [
        "th",
        "st",
        "nd",
        "rd"
    ];
    var v = num % 100;
    return num + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
function $f16e5b30169320d8$export$3ae94a2503e890a1(date, formatStr) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _a;
    var years = date.getFullYear();
    var month = date.getMonth();
    var days = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    var milliseconds = date.getMilliseconds();
    var day = date.getDay();
    var meridiem = (_a = options.customMeridiem) != null ? _a : $f16e5b30169320d8$var$defaultMeridiem;
    var matches = {
        Yo: function() {
            return $f16e5b30169320d8$var$formatOrdinal(years);
        },
        YY: function() {
            return String(years).slice(-2);
        },
        YYYY: function() {
            return years;
        },
        M: function() {
            return month + 1;
        },
        Mo: function() {
            return $f16e5b30169320d8$var$formatOrdinal(month + 1);
        },
        MM: function() {
            return "".concat(month + 1).padStart(2, "0");
        },
        MMM: function() {
            return date.toLocaleDateString(options.locales, {
                month: "short"
            });
        },
        MMMM: function() {
            return date.toLocaleDateString(options.locales, {
                month: "long"
            });
        },
        D: function() {
            return String(days);
        },
        Do: function() {
            return $f16e5b30169320d8$var$formatOrdinal(days);
        },
        DD: function() {
            return "".concat(days).padStart(2, "0");
        },
        H: function() {
            return String(hours);
        },
        Ho: function() {
            return $f16e5b30169320d8$var$formatOrdinal(hours);
        },
        HH: function() {
            return "".concat(hours).padStart(2, "0");
        },
        h: function() {
            return "".concat(hours % 12 || 12).padStart(1, "0");
        },
        ho: function() {
            return $f16e5b30169320d8$var$formatOrdinal(hours % 12 || 12);
        },
        hh: function() {
            return "".concat(hours % 12 || 12).padStart(2, "0");
        },
        m: function() {
            return String(minutes);
        },
        mo: function() {
            return $f16e5b30169320d8$var$formatOrdinal(minutes);
        },
        mm: function() {
            return "".concat(minutes).padStart(2, "0");
        },
        s: function() {
            return String(seconds);
        },
        so: function() {
            return $f16e5b30169320d8$var$formatOrdinal(seconds);
        },
        ss: function() {
            return "".concat(seconds).padStart(2, "0");
        },
        SSS: function() {
            return "".concat(milliseconds).padStart(3, "0");
        },
        d: function() {
            return day;
        },
        dd: function() {
            return date.toLocaleDateString(options.locales, {
                weekday: "narrow"
            });
        },
        ddd: function() {
            return date.toLocaleDateString(options.locales, {
                weekday: "short"
            });
        },
        dddd: function() {
            return date.toLocaleDateString(options.locales, {
                weekday: "long"
            });
        },
        A: function() {
            return meridiem(hours, minutes);
        },
        AA: function() {
            return meridiem(hours, minutes, false, true);
        },
        a: function() {
            return meridiem(hours, minutes, true);
        },
        aa: function() {
            return meridiem(hours, minutes, true, true);
        }
    };
    return formatStr.replace($f16e5b30169320d8$var$REGEX_FORMAT, function(match, $1) {
        var _a2, _b;
        return (_b = $1 != null ? $1 : (_a2 = matches[match]) == null ? void 0 : _a2.call(matches)) != null ? _b : match;
    });
}
function $f16e5b30169320d8$export$fcc71269590ba0a8(date) {
    if (date === null) return new Date(Number.NaN);
    if (date === void 0) return /* @__PURE__ */ new Date();
    if (date instanceof Date) return new Date(date);
    if (typeof date === "string" && !/Z$/i.test(date)) {
        var d = date.match($f16e5b30169320d8$var$REGEX_PARSE);
        if (d) {
            var m = d[2] - 1 || 0;
            var ms = (d[7] || "0").substring(0, 3);
            return new Date(d[1], m, d[3] || 1, d[4] || 0, d[5] || 0, d[6] || 0, ms);
        }
    }
    return new Date(date);
}
function $f16e5b30169320d8$export$6d181172004bc6fc(date) {
    var formatStr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "HH:mm:ss", options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return (0, $fKAHx.computed)(function() {
        return $f16e5b30169320d8$export$3ae94a2503e890a1($f16e5b30169320d8$export$fcc71269590ba0a8($f16e5b30169320d8$export$30bdcc2218aa9458(date)), $f16e5b30169320d8$export$30bdcc2218aa9458(formatStr), options);
    });
}
function $f16e5b30169320d8$export$35ee30a05e4f2223(cb) {
    var interval = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e3, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_immediate = options.immediate, immediate = _options_immediate === void 0 ? true : _options_immediate, _options_immediateCallback = options.immediateCallback, immediateCallback = _options_immediateCallback === void 0 ? false : _options_immediateCallback;
    var timer = null;
    var isActive = (0, $ftLbb.ref)(false);
    function clean() {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    }
    function pause() {
        isActive.value = false;
        clean();
    }
    function resume() {
        var intervalValue = $f16e5b30169320d8$export$30bdcc2218aa9458(interval);
        if (intervalValue <= 0) return;
        isActive.value = true;
        if (immediateCallback) cb();
        clean();
        timer = setInterval(cb, intervalValue);
    }
    if (immediate && $f16e5b30169320d8$export$7383f122bf48ec30) resume();
    if ((0, $ftLbb.isRef)(interval) || typeof interval === "function") {
        var stopWatch = (0, $fKAHx.watch)(interval, function() {
            if (isActive.value && $f16e5b30169320d8$export$7383f122bf48ec30) resume();
        });
        $f16e5b30169320d8$export$c3d49ae4e58d3d9d(stopWatch);
    }
    $f16e5b30169320d8$export$c3d49ae4e58d3d9d(pause);
    return {
        isActive: isActive,
        pause: pause,
        resume: resume
    };
}
function $f16e5b30169320d8$export$f4b266cd2aae9cb1() {
    var interval = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1e3, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var tmp = options.controls, exposeControls = tmp === void 0 ? false : tmp, _options_immediate = options.immediate, immediate = _options_immediate === void 0 ? true : _options_immediate, callback = options.callback;
    var counter = (0, $ftLbb.ref)(0);
    var update = function() {
        return counter.value += 1;
    };
    var reset = function() {
        counter.value = 0;
    };
    var controls = $f16e5b30169320d8$export$35ee30a05e4f2223(callback ? function() {
        update();
        callback(counter.value);
    } : update, interval, {
        immediate: immediate
    });
    if (exposeControls) return (0, $1XAnY._)({
        counter: counter,
        reset: reset
    }, controls);
    else return counter;
}
function $f16e5b30169320d8$export$de385d6f89d6db3c(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _a;
    var ms = (0, $ftLbb.ref)((_a = options.initialValue) != null ? _a : null);
    (0, $fKAHx.watch)(source, function() {
        return ms.value = $f16e5b30169320d8$export$fc00ee57782020aa();
    }, options);
    return ms;
}
function $f16e5b30169320d8$export$14705c14c13d528a(cb, interval) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_immediate = options.immediate, immediate = _options_immediate === void 0 ? true : _options_immediate;
    var isPending = (0, $ftLbb.ref)(false);
    var timer = null;
    function clear() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }
    function stop() {
        isPending.value = false;
        clear();
    }
    function start() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clear();
        isPending.value = true;
        timer = setTimeout(function() {
            isPending.value = false;
            timer = null;
            cb.apply(void 0, (0, $aUGqu._)(args));
        }, $f16e5b30169320d8$export$30bdcc2218aa9458(interval));
    }
    if (immediate) {
        isPending.value = true;
        if ($f16e5b30169320d8$export$7383f122bf48ec30) start();
    }
    $f16e5b30169320d8$export$c3d49ae4e58d3d9d(stop);
    return {
        isPending: (0, $ftLbb.readonly)(isPending),
        start: start,
        stop: stop
    };
}
function $f16e5b30169320d8$export$d8e6abf214c9ec0f() {
    var interval = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1e3, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var tmp = options.controls, exposeControls = tmp === void 0 ? false : tmp, callback = options.callback;
    var controls = $f16e5b30169320d8$export$14705c14c13d528a(callback != null ? callback : $f16e5b30169320d8$export$8793edee2d425525, interval, options);
    var ready = (0, $fKAHx.computed)(function() {
        return !controls.isPending.value;
    });
    if (exposeControls) return (0, $1XAnY._)({
        ready: ready
    }, controls);
    else return ready;
}
function $f16e5b30169320d8$export$1ee6bb1f922f50b3(value) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_method = options.method, method = _options_method === void 0 ? "parseFloat" : _options_method, radix = options.radix, nanToZero = options.nanToZero;
    return (0, $fKAHx.computed)(function() {
        var resolved = $f16e5b30169320d8$export$30bdcc2218aa9458(value);
        if (typeof resolved === "string") resolved = Number[method](resolved, radix);
        if (nanToZero && Number.isNaN(resolved)) resolved = 0;
        return resolved;
    });
}
function $f16e5b30169320d8$export$8906942fea47e698(value) {
    return (0, $fKAHx.computed)(function() {
        return "".concat($f16e5b30169320d8$export$30bdcc2218aa9458(value));
    });
}
function $f16e5b30169320d8$export$cbe85ee05b554577() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_truthyValue = options.truthyValue, truthyValue = _options_truthyValue === void 0 ? true : _options_truthyValue, _options_falsyValue = options.falsyValue, falsyValue = _options_falsyValue === void 0 ? false : _options_falsyValue;
    var valueIsRef = (0, $ftLbb.isRef)(initialValue);
    var _value = (0, $ftLbb.ref)(initialValue);
    function toggle(value) {
        if (arguments.length) {
            _value.value = value;
            return _value.value;
        } else {
            var truthy = $f16e5b30169320d8$export$30bdcc2218aa9458(truthyValue);
            _value.value = _value.value === truthy ? $f16e5b30169320d8$export$30bdcc2218aa9458(falsyValue) : truthy;
            return _value.value;
        }
    }
    if (valueIsRef) return toggle;
    else return [
        _value,
        toggle
    ];
}
function $f16e5b30169320d8$export$8ebd2befe4deaa6b(source, cb, options) {
    var oldList = (options == null ? void 0 : options.immediate) ? [] : (0, $aUGqu._)(source instanceof Function ? source() : Array.isArray(source) ? source : $f16e5b30169320d8$export$30bdcc2218aa9458(source));
    return (0, $fKAHx.watch)(source, function(newList, _, onCleanup) {
        var oldListRemains = Array.from({
            length: oldList.length
        });
        var added = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var obj = _step.value;
                var found = false;
                for(var i = 0; i < oldList.length; i++)if (!oldListRemains[i] && obj === oldList[i]) {
                    oldListRemains[i] = true;
                    found = true;
                    break;
                }
                if (!found) added.push(obj);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var removed = oldList.filter(function(_2, i) {
            return !oldListRemains[i];
        });
        cb(newList, oldList, added, removed, onCleanup);
        oldList = (0, $aUGqu._)(newList);
    }, options);
}
function $f16e5b30169320d8$export$a121c3bc1a97f0b4(source, cb, options) {
    var count = options.count, watchOptions = (0, $6acIq._)(options, [
        "count"
    ]);
    var current = (0, $ftLbb.ref)(0);
    var stop = $f16e5b30169320d8$export$3955c00bb6715986(source, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        current.value += 1;
        if (current.value >= $f16e5b30169320d8$export$30bdcc2218aa9458(count)) (0, $fKAHx.nextTick)(function() {
            return stop();
        });
        cb.apply(void 0, (0, $aUGqu._)(args));
    }, watchOptions);
    return {
        count: current,
        stop: stop
    };
}
function $f16e5b30169320d8$export$578b5d9cbe132cee(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_debounce = options.debounce, debounce = _options_debounce === void 0 ? 0 : _options_debounce, maxWait = options.maxWait, watchOptions = (0, $6acIq._)(options, [
        "debounce",
        "maxWait"
    ]);
    return $f16e5b30169320d8$export$3955c00bb6715986(source, cb, (0, $6fpqi._)((0, $1XAnY._)({}, watchOptions), {
        eventFilter: $f16e5b30169320d8$export$fca2c450ae03b38e(debounce, {
            maxWait: maxWait
        })
    }));
}
function $f16e5b30169320d8$export$79f242cf85fb93a(source, cb, options) {
    return (0, $fKAHx.watch)(source, cb, (0, $6fpqi._)((0, $1XAnY._)({}, options), {
        deep: true
    }));
}
function $f16e5b30169320d8$export$63ac06655f58d92a(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_eventFilter = options.eventFilter, eventFilter = _options_eventFilter === void 0 ? $f16e5b30169320d8$export$8cc0e33a27868391 : _options_eventFilter, watchOptions = (0, $6acIq._)(options, [
        "eventFilter"
    ]);
    var filteredCb = $f16e5b30169320d8$export$a1f1cf91007f23bf(eventFilter, cb);
    var ignoreUpdates;
    var ignorePrevAsyncUpdates;
    var stop;
    if (watchOptions.flush === "sync") {
        var ignore = (0, $ftLbb.ref)(false);
        ignorePrevAsyncUpdates = function() {};
        ignoreUpdates = function(updater) {
            ignore.value = true;
            updater();
            ignore.value = false;
        };
        stop = (0, $fKAHx.watch)(source, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (!ignore.value) filteredCb.apply(void 0, (0, $aUGqu._)(args));
        }, watchOptions);
    } else {
        var disposables = [];
        var ignoreCounter = (0, $ftLbb.ref)(0);
        var syncCounter = (0, $ftLbb.ref)(0);
        ignorePrevAsyncUpdates = function() {
            ignoreCounter.value = syncCounter.value;
        };
        disposables.push((0, $fKAHx.watch)(source, function() {
            syncCounter.value++;
        }, (0, $6fpqi._)((0, $1XAnY._)({}, watchOptions), {
            flush: "sync"
        })));
        ignoreUpdates = function(updater) {
            var syncCounterPrev = syncCounter.value;
            updater();
            ignoreCounter.value += syncCounter.value - syncCounterPrev;
        };
        disposables.push((0, $fKAHx.watch)(source, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var ignore = ignoreCounter.value > 0 && ignoreCounter.value === syncCounter.value;
            ignoreCounter.value = 0;
            syncCounter.value = 0;
            if (ignore) return;
            filteredCb.apply(void 0, (0, $aUGqu._)(args));
        }, watchOptions));
        stop = function() {
            disposables.forEach(function(fn) {
                return fn();
            });
        };
    }
    return {
        stop: stop,
        ignoreUpdates: ignoreUpdates,
        ignorePrevAsyncUpdates: ignorePrevAsyncUpdates
    };
}
function $f16e5b30169320d8$export$d9aec7ec4e8a1634(source, cb, options) {
    return (0, $fKAHx.watch)(source, cb, (0, $6fpqi._)((0, $1XAnY._)({}, options), {
        immediate: true
    }));
}
function $f16e5b30169320d8$export$95d4a8ca30b80ae0(source, cb, options) {
    var stop = (0, $fKAHx.watch)(source, function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $fKAHx.nextTick)(function() {
            return stop();
        });
        return cb.apply(void 0, (0, $aUGqu._)(args));
    }, options);
    return stop;
}
function $f16e5b30169320d8$export$2768dce732d5eb3(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_throttle = options.throttle, throttle = _options_throttle === void 0 ? 0 : _options_throttle, _options_trailing = options.trailing, trailing = _options_trailing === void 0 ? true : _options_trailing, _options_leading = options.leading, leading = _options_leading === void 0 ? true : _options_leading, watchOptions = (0, $6acIq._)(options, [
        "throttle",
        "trailing",
        "leading"
    ]);
    return $f16e5b30169320d8$export$3955c00bb6715986(source, cb, (0, $6fpqi._)((0, $1XAnY._)({}, watchOptions), {
        eventFilter: $f16e5b30169320d8$export$cd62e9dbf204fd92(throttle, trailing, leading)
    }));
}
function $f16e5b30169320d8$export$b75c094d1092c205(source, cb) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var cleanupFn;
    function onEffect() {
        if (!cleanupFn) return;
        var fn = cleanupFn;
        cleanupFn = void 0;
        fn();
    }
    function onCleanup(callback) {
        cleanupFn = callback;
    }
    var _cb = function(value, oldValue) {
        onEffect();
        return cb(value, oldValue, onCleanup);
    };
    var res = $f16e5b30169320d8$export$63ac06655f58d92a(source, _cb, options);
    var ignoreUpdates = res.ignoreUpdates;
    var trigger = function() {
        var res2;
        ignoreUpdates(function() {
            res2 = _cb($f16e5b30169320d8$var$getWatchSources(source), $f16e5b30169320d8$var$getOldValue(source));
        });
        return res2;
    };
    return (0, $6fpqi._)((0, $1XAnY._)({}, res), {
        trigger: trigger
    });
}
function $f16e5b30169320d8$var$getWatchSources(sources) {
    if ((0, $ftLbb.isReactive)(sources)) return sources;
    if (Array.isArray(sources)) return sources.map(function(item) {
        return $f16e5b30169320d8$export$30bdcc2218aa9458(item);
    });
    return $f16e5b30169320d8$export$30bdcc2218aa9458(sources);
}
function $f16e5b30169320d8$var$getOldValue(source) {
    return Array.isArray(source) ? source.map(function() {
        return void 0;
    }) : void 0;
}
function $f16e5b30169320d8$export$909eba9696cc3445(source, cb, options) {
    return (0, $fKAHx.watch)(source, function(v, ov, onInvalidate) {
        if (v) cb(v, ov, onInvalidate);
    }, options);
}

});
parcelRegister("gbYVB", function(module, exports) {

$parcel$export(module.exports, "isVue2", function () { return $8fc6c5513cdafa34$export$1da84e343e81ceb9; });
$parcel$export(module.exports, "isVue3", function () { return $8fc6c5513cdafa34$export$34b222e3d4733e48; });
$parcel$export(module.exports, "set", function () { return $8fc6c5513cdafa34$export$adaa4cf7ef1b65be; });

var $63vlS = parcelRequire("63vlS");
var $8fc6c5513cdafa34$export$1da84e343e81ceb9 = false;
var $8fc6c5513cdafa34$export$34b222e3d4733e48 = true;
var $8fc6c5513cdafa34$export$a8cb34872e7d8b79 = undefined;
function $8fc6c5513cdafa34$export$4b3e715f166fdd78() {}
function $8fc6c5513cdafa34$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $8fc6c5513cdafa34$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}
$parcel$exportWildcard(module.exports, $63vlS);

});





parcelRegister("1A3mN", function(module, exports) {

$parcel$export(module.exports, "buttonVariants", function () { return $047efee5919475fa$export$dca1ee5a936bb312; });
$parcel$export(module.exports, "Button", function () { return (parcelRequire("fy1oX")).default; });

var $c0b4S = parcelRequire("c0b4S");

var $fy1oX = parcelRequire("fy1oX");
var $047efee5919475fa$export$dca1ee5a936bb312 = (0, $c0b4S.cva)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline"
        },
        size: {
            "default": "h-10 px-4 py-2",
            "sm": "h-9 rounded-md px-3",
            "lg": "h-11 rounded-md px-8",
            "icon": "h-10 w-10",
            "icon-sm": "size-9",
            "icon-lg": "size-11"
        }
    },
    defaultVariants: {
        variant: "default",
        size: "default"
    }
});

});
parcelRegister("c0b4S", function(module, exports) {

$parcel$export(module.exports, "cva", function () { return $178dae989dce269d$export$87dc52566e90b739; });
/**
 * Copyright 2022 Joe Bell. All rights reserved.
 *
 * This file is licensed to you under the Apache License, Version 2.0
 * (the "License"); you may not use this file except in compliance with the
 * License. You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR REPRESENTATIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */ 
var $1XAnY = parcelRequire("1XAnY");

var $6acIq = parcelRequire("6acIq");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");

var $5craf = parcelRequire("5craf");
var $178dae989dce269d$var$falsyToString = function(value) {
    return typeof value === "boolean" ? "".concat(value) : value === 0 ? "0" : value;
};
var $178dae989dce269d$export$a274e22fb40f762e = (0, $5craf.clsx);
var $178dae989dce269d$export$87dc52566e90b739 = function(base, config) {
    return function(props) {
        var _config_compoundVariants;
        if ((config === null || config === void 0 ? void 0 : config.variants) == null) return $178dae989dce269d$export$a274e22fb40f762e(base, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
        var variants = config.variants, defaultVariants = config.defaultVariants;
        var getVariantClassNames = Object.keys(variants).map(function(variant) {
            var variantProp = props === null || props === void 0 ? void 0 : props[variant];
            var defaultVariantProp = defaultVariants === null || defaultVariants === void 0 ? void 0 : defaultVariants[variant];
            if (variantProp === null) return null;
            var variantKey = $178dae989dce269d$var$falsyToString(variantProp) || $178dae989dce269d$var$falsyToString(defaultVariantProp);
            return variants[variant][variantKey];
        });
        var propsWithoutUndefined = props && Object.entries(props).reduce(function(acc, param) {
            var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
            if (value === undefined) return acc;
            acc[key] = value;
            return acc;
        }, {});
        var getCompoundVariantClassNames = config === null || config === void 0 ? void 0 : (_config_compoundVariants = config.compoundVariants) === null || _config_compoundVariants === void 0 ? void 0 : _config_compoundVariants.reduce(function(acc, param) {
            var cvClass = param.class, cvClassName = param.className, compoundVariantOptions = (0, $6acIq._)(param, [
                "class",
                "className"
            ]);
            return Object.entries(compoundVariantOptions).every(function(param) {
                var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
                return Array.isArray(value) ? value.includes((0, $1XAnY._)({}, defaultVariants, propsWithoutUndefined)[key]) : (0, $1XAnY._)({}, defaultVariants, propsWithoutUndefined)[key] === value;
            }) ? (0, $aUGqu._)(acc).concat([
                cvClass,
                cvClassName
            ]) : acc;
        }, []);
        return $178dae989dce269d$export$a274e22fb40f762e(base, getVariantClassNames, getCompoundVariantClassNames, props === null || props === void 0 ? void 0 : props.class, props === null || props === void 0 ? void 0 : props.className);
    };
};

});
parcelRegister("5craf", function(module, exports) {

$parcel$export(module.exports, "clsx", function () { return $51b1b578e3b8ff34$export$4f5d2d50c9deca37; });

var $7E0eS = parcelRequire("7E0eS");
function $51b1b578e3b8ff34$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == (typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e))) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $51b1b578e3b8ff34$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $51b1b578e3b8ff34$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $51b1b578e3b8ff34$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $51b1b578e3b8ff34$export$2e2bcd8739ae039 = $51b1b578e3b8ff34$export$4f5d2d50c9deca37;

});


parcelRegister("fy1oX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b51b1e49bb27a822$export$2e2bcd8739ae039; });
var $b51b1e49bb27a822$var$script;



var $b51b1e49bb27a822$var$initialize = function() {
    $b51b1e49bb27a822$var$script = (parcelRequire("cSV9S"));
    if ($b51b1e49bb27a822$var$script.__esModule) $b51b1e49bb27a822$var$script = $b51b1e49bb27a822$var$script.default;
    $b51b1e49bb27a822$var$script.render = (parcelRequire("7xMzb")).render;
    (parcelRequire("2d7qy")).default($b51b1e49bb27a822$var$script);
    $b51b1e49bb27a822$var$script.__scopeId = 'data-v-782b48';
    $b51b1e49bb27a822$var$script.__file = "Button.vue";
};
$b51b1e49bb27a822$var$initialize();
var $b51b1e49bb27a822$export$2e2bcd8739ae039 = $b51b1e49bb27a822$var$script;

});
parcelRegister("cSV9S", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e96509d8ed123512$export$2e2bcd8739ae039; });
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");

var $b5TCB = parcelRequire("b5TCB");

var $7jFPZ = parcelRequire("7jFPZ");

var $1A3mN = parcelRequire("1A3mN");
var $e96509d8ed123512$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $fKAHx.defineComponent)({
    __name: 'Button',
    props: {
        variant: {},
        size: {},
        class: {
            type: [
                Boolean,
                null,
                String,
                Object,
                Array
            ]
        },
        asChild: {
            type: Boolean
        },
        as: {
            default: "button"
        }
    },
    setup: function(__props, param) {
        var __expose = param.expose;
        __expose();
        var props = __props;
        var __returned__ = {
            props: props,
            get Primitive () {
                return 0, $b5TCB.Primitive;
            },
            get cn () {
                return 0, $7jFPZ.cn;
            },
            get buttonVariants () {
                return 0, $1A3mN.buttonVariants;
            }
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("b5TCB", function(module, exports) {

$parcel$export(module.exports, "Primitive", function () { return $813b4ea1fc29dffc$export$250ffa63cdc0d034; });

var $e3kJY = parcelRequire("e3kJY");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
//#region src/Primitive/Primitive.ts
var $813b4ea1fc29dffc$var$SELF_CLOSING_TAGS = [
    "area",
    "img",
    "input"
];
var $813b4ea1fc29dffc$export$250ffa63cdc0d034 = /*#__PURE__*/ (0, $fKAHx.defineComponent)({
    name: "Primitive",
    inheritAttrs: false,
    props: {
        asChild: {
            type: Boolean,
            default: false
        },
        as: {
            type: [
                String,
                Object
            ],
            default: "div"
        }
    },
    setup: function(props, param) {
        var attrs = param.attrs, slots = param.slots;
        var asTag = props.asChild ? "template" : props.as;
        if (typeof asTag === "string" && $813b4ea1fc29dffc$var$SELF_CLOSING_TAGS.includes(asTag)) return function() {
            return (0, $fKAHx.h)(asTag, attrs);
        };
        if (asTag !== "template") return function() {
            return (0, $fKAHx.h)(props.as, attrs, {
                default: slots.default
            });
        };
        return function() {
            return (0, $fKAHx.h)((0, $e3kJY.Slot), attrs, {
                default: slots.default
            });
        };
    }
});

});
parcelRegister("e3kJY", function(module, exports) {

$parcel$export(module.exports, "Slot", function () { return $a3b16f27e3cf52b0$export$8c6ed5c666ac1360; });

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $fVzbL = parcelRequire("fVzbL");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
//#region src/Primitive/Slot.ts
var $a3b16f27e3cf52b0$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $fKAHx.defineComponent)({
    name: "PrimitiveSlot",
    inheritAttrs: false,
    setup: function(_, param) {
        var attrs = param.attrs, slots = param.slots;
        return function() {
            var _firstNonCommentChildren_props;
            if (!slots.default) return null;
            var children = (0, $fVzbL.renderSlotFragments)(slots.default());
            var firstNonCommentChildrenIndex = children.findIndex(function(child) {
                return child.type !== (0, $fKAHx.Comment);
            });
            if (firstNonCommentChildrenIndex === -1) return children;
            var firstNonCommentChildren = children[firstNonCommentChildrenIndex];
            (_firstNonCommentChildren_props = firstNonCommentChildren.props) === null || _firstNonCommentChildren_props === void 0 ? true : delete _firstNonCommentChildren_props.ref;
            var mergedProps = firstNonCommentChildren.props ? (0, $fKAHx.mergeProps)(attrs, firstNonCommentChildren.props) : attrs;
            var cloned = (0, $fKAHx.cloneVNode)((0, $6fpqi._)((0, $1XAnY._)({}, firstNonCommentChildren), {
                props: {}
            }), mergedProps);
            if (children.length === 1) return cloned;
            children[firstNonCommentChildrenIndex] = cloned;
            return children;
        };
    }
});

});
parcelRegister("fVzbL", function(module, exports) {

$parcel$export(module.exports, "renderSlotFragments", function () { return $b987799ccf39c4ad$export$e3200b1318e9d1; });
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
//#region src/shared/renderSlotFragments.ts
function $b987799ccf39c4ad$export$e3200b1318e9d1(children) {
    if (!children) return [];
    return children.flatMap(function(child) {
        if (child.type === (0, $fKAHx.Fragment)) return $b987799ccf39c4ad$export$e3200b1318e9d1(child.children);
        return [
            child
        ];
    });
}

});



parcelRegister("7jFPZ", function(module, exports) {

$parcel$export(module.exports, "cn", function () { return $52adff6184762aab$export$1343a74baacb0543; });

var $5craf = parcelRequire("5craf");

var $hvILH = parcelRequire("hvILH");
var $52adff6184762aab$export$1343a74baacb0543 = function() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0, $hvILH.twMerge)((0, $5craf.clsx)(inputs));
};

});
parcelRegister("hvILH", function(module, exports) {

$parcel$export(module.exports, "twMerge", function () { return $f1e8fdbbd7d56f0d$export$b4660bb6000dfbc9; });
/**
 * Concatenates two arrays faster than the array spread operator.
 */ 
var $1XAnY = parcelRequire("1XAnY");

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");
var $f1e8fdbbd7d56f0d$var$concatArrays = function(array1, array2) {
    // Pre-allocate for better V8 optimization
    var combinedArray = new Array(array1.length + array2.length);
    for(var i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(var i1 = 0; i1 < array2.length; i1++)combinedArray[array1.length + i1] = array2[i1];
    return combinedArray;
};
// Factory function ensures consistent object shapes
var $f1e8fdbbd7d56f0d$var$createClassValidatorObject = function(classGroupId, validator) {
    return {
        classGroupId: classGroupId,
        validator: validator
    };
};
// Factory ensures consistent ClassPartObject shape
var $f1e8fdbbd7d56f0d$var$createClassPartObject = function() {
    var nextPart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Map(), validators = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, classGroupId = arguments.length > 2 ? arguments[2] : void 0;
    return {
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    };
};
var $f1e8fdbbd7d56f0d$var$CLASS_PART_SEPARATOR = '-';
var $f1e8fdbbd7d56f0d$var$EMPTY_CONFLICTS = [];
// I use two dots here because one dot is used as prefix for class groups in plugins
var $f1e8fdbbd7d56f0d$var$ARBITRARY_PROPERTY_PREFIX = 'arbitrary..';
var $f1e8fdbbd7d56f0d$var$createClassGroupUtils = function(config) {
    var classMap = $f1e8fdbbd7d56f0d$var$createClassMap(config);
    var conflictingClassGroups = config.conflictingClassGroups, conflictingClassGroupModifiers = config.conflictingClassGroupModifiers;
    var getClassGroupId = function(className) {
        if (className.startsWith('[') && className.endsWith(']')) return $f1e8fdbbd7d56f0d$var$getGroupIdForArbitraryProperty(className);
        var classParts = className.split($f1e8fdbbd7d56f0d$var$CLASS_PART_SEPARATOR);
        // Classes like `-inset-1` produce an empty string as first classPart. We assume that classes for negative values are used correctly and skip it.
        var startIndex = classParts[0] === '' && classParts.length > 1 ? 1 : 0;
        return $f1e8fdbbd7d56f0d$var$getGroupRecursive(classParts, startIndex, classMap);
    };
    var getConflictingClassGroupIds = function(classGroupId, hasPostfixModifier) {
        if (hasPostfixModifier) {
            var modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            var baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) // Merge base conflicts with modifier conflicts
                return $f1e8fdbbd7d56f0d$var$concatArrays(baseConflicts, modifierConflicts);
                // Only modifier conflicts
                return modifierConflicts;
            }
            // Fall back to without postfix if no modifier conflicts
            return baseConflicts || $f1e8fdbbd7d56f0d$var$EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || $f1e8fdbbd7d56f0d$var$EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
var $f1e8fdbbd7d56f0d$var$getGroupRecursive = function(classParts, startIndex, classPartObject) {
    var classPathsLength = classParts.length - startIndex;
    if (classPathsLength === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[startIndex];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        var result = $f1e8fdbbd7d56f0d$var$getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    var validators = classPartObject.validators;
    if (validators === null) return undefined;
    // Build classRest string efficiently by joining from startIndex onwards
    var classRest = startIndex === 0 ? classParts.join($f1e8fdbbd7d56f0d$var$CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join($f1e8fdbbd7d56f0d$var$CLASS_PART_SEPARATOR);
    var validatorsLength = validators.length;
    for(var i = 0; i < validatorsLength; i++){
        var validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
    return undefined;
};
/**
 * Get the class group ID for an arbitrary property.
 *
 * @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
 */ var $f1e8fdbbd7d56f0d$var$getGroupIdForArbitraryProperty = function(className) {
    return className.slice(1, -1).indexOf(':') === -1 ? undefined : function() {
        var content = className.slice(1, -1);
        var colonIndex = content.indexOf(':');
        var property = content.slice(0, colonIndex);
        return property ? $f1e8fdbbd7d56f0d$var$ARBITRARY_PROPERTY_PREFIX + property : undefined;
    }();
};
/**
 * Exported for testing only
 */ var $f1e8fdbbd7d56f0d$var$createClassMap = function(config) {
    var theme = config.theme, classGroups = config.classGroups;
    return $f1e8fdbbd7d56f0d$var$processClassGroups(classGroups, theme);
};
// Split into separate functions to maintain monomorphic call sites
var $f1e8fdbbd7d56f0d$var$processClassGroups = function(classGroups, theme) {
    var classMap = $f1e8fdbbd7d56f0d$var$createClassPartObject();
    for(var classGroupId in classGroups){
        var group = classGroups[classGroupId];
        $f1e8fdbbd7d56f0d$var$processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
var $f1e8fdbbd7d56f0d$var$processClassesRecursively = function(classGroup, classPartObject, classGroupId, theme) {
    var len = classGroup.length;
    for(var i = 0; i < len; i++){
        var classDefinition = classGroup[i];
        $f1e8fdbbd7d56f0d$var$processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
// Split into separate functions for each type to maintain monomorphic call sites
var $f1e8fdbbd7d56f0d$var$processClassDefinition = function(classDefinition, classPartObject, classGroupId, theme) {
    if (typeof classDefinition === 'string') {
        $f1e8fdbbd7d56f0d$var$processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === 'function') {
        $f1e8fdbbd7d56f0d$var$processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    $f1e8fdbbd7d56f0d$var$processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
var $f1e8fdbbd7d56f0d$var$processStringDefinition = function(classDefinition, classPartObject, classGroupId) {
    var classPartObjectToEdit = classDefinition === '' ? classPartObject : $f1e8fdbbd7d56f0d$var$getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
var $f1e8fdbbd7d56f0d$var$processFunctionDefinition = function(classDefinition, classPartObject, classGroupId, theme) {
    if ($f1e8fdbbd7d56f0d$var$isThemeGetter(classDefinition)) {
        $f1e8fdbbd7d56f0d$var$processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push($f1e8fdbbd7d56f0d$var$createClassValidatorObject(classGroupId, classDefinition));
};
var $f1e8fdbbd7d56f0d$var$processObjectDefinition = function(classDefinition, classPartObject, classGroupId, theme) {
    var entries = Object.entries(classDefinition);
    var len = entries.length;
    for(var i = 0; i < len; i++){
        var _entries_i = (0, $f9AOD._)(entries[i], 2), key = _entries_i[0], value = _entries_i[1];
        $f1e8fdbbd7d56f0d$var$processClassesRecursively(value, $f1e8fdbbd7d56f0d$var$getPart(classPartObject, key), classGroupId, theme);
    }
};
var $f1e8fdbbd7d56f0d$var$getPart = function(classPartObject, path) {
    var current = classPartObject;
    var parts = path.split($f1e8fdbbd7d56f0d$var$CLASS_PART_SEPARATOR);
    var len = parts.length;
    for(var i = 0; i < len; i++){
        var part = parts[i];
        var next = current.nextPart.get(part);
        if (!next) {
            next = $f1e8fdbbd7d56f0d$var$createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
// Type guard maintains monomorphic check
var $f1e8fdbbd7d56f0d$var$isThemeGetter = function(func) {
    return 'isThemeGetter' in func && func.isThemeGetter === true;
};
// LRU cache implementation using plain objects for simplicity
var $f1e8fdbbd7d56f0d$var$createLruCache = function(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function() {
            return undefined;
        },
        set: function() {}
    };
    var cacheSize = 0;
    var cache = Object.create(null);
    var previousCache = Object.create(null);
    var update = function(key, value) {
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get: function(key) {
            var value = cache[key];
            if (value !== undefined) return value;
            if ((value = previousCache[key]) !== undefined) {
                update(key, value);
                return value;
            }
        },
        set: function(key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
var $f1e8fdbbd7d56f0d$var$IMPORTANT_MODIFIER = '!';
var $f1e8fdbbd7d56f0d$var$MODIFIER_SEPARATOR = ':';
var $f1e8fdbbd7d56f0d$var$EMPTY_MODIFIERS = [];
// Pre-allocated result object shape for consistency
var $f1e8fdbbd7d56f0d$var$createResultObject = function(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal) {
    return {
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    };
};
var $f1e8fdbbd7d56f0d$var$createParseClassName = function(config) {
    var prefix = config.prefix, experimentalParseClassName = config.experimentalParseClassName;
    /**
   * Parse class name into parts.
   *
   * Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
   * @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
   */ var parseClassName = function(className) {
        // Use simple array with push for better performance
        var modifiers = [];
        var bracketDepth = 0;
        var parenDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        var len = className.length;
        for(var index = 0; index < len; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === $f1e8fdbbd7d56f0d$var$MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === '/') {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === '[') bracketDepth++;
            else if (currentCharacter === ']') bracketDepth--;
            else if (currentCharacter === '(') parenDepth++;
            else if (currentCharacter === ')') parenDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        // Inline important modifier check
        var baseClassName = baseClassNameWithImportantModifier;
        var hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith($f1e8fdbbd7d56f0d$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (/**
     * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
     * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
     */ baseClassNameWithImportantModifier.startsWith($f1e8fdbbd7d56f0d$var$IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : undefined;
        return $f1e8fdbbd7d56f0d$var$createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        var fullPrefix = prefix + $f1e8fdbbd7d56f0d$var$MODIFIER_SEPARATOR;
        var parseClassNameOriginal = parseClassName;
        parseClassName = function(className) {
            return className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : $f1e8fdbbd7d56f0d$var$createResultObject($f1e8fdbbd7d56f0d$var$EMPTY_MODIFIERS, false, className, undefined, true);
        };
    }
    if (experimentalParseClassName) {
        var parseClassNameOriginal1 = parseClassName;
        parseClassName = function(className) {
            return experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal1
            });
        };
    }
    return parseClassName;
};
/**
 * Sorts modifiers according to following schema:
 * - Predefined modifiers are sorted alphabetically
 * - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
 */ var $f1e8fdbbd7d56f0d$var$createSortModifiers = function(config) {
    // Pre-compute weights for all known modifiers for O(1) comparison
    var modifierWeights = new Map();
    // Assign weights to sensitive modifiers (highest priority, but preserve order)
    config.orderSensitiveModifiers.forEach(function(mod, index) {
        modifierWeights.set(mod, 1000000 + index); // High weights for sensitive mods
    });
    return function(modifiers) {
        var result = [];
        var currentSegment = [];
        // Process modifiers in one pass
        for(var i = 0; i < modifiers.length; i++){
            var modifier = modifiers[i];
            // Check if modifier is sensitive (starts with '[' or in orderSensitiveModifiers)
            var isArbitrary = modifier[0] === '[';
            var isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                // Sort and flush current segment alphabetically
                if (currentSegment.length > 0) {
                    var _result;
                    currentSegment.sort();
                    (_result = result).push.apply(_result, (0, $aUGqu._)(currentSegment));
                    currentSegment = [];
                }
                result.push(modifier);
            } else // Regular modifier - add to current segment for batch sorting
            currentSegment.push(modifier);
        }
        // Sort and add any remaining segment items
        if (currentSegment.length > 0) {
            var _result1;
            currentSegment.sort();
            (_result1 = result).push.apply(_result1, (0, $aUGqu._)(currentSegment));
        }
        return result;
    };
};
var $f1e8fdbbd7d56f0d$var$createConfigUtils = function(config) {
    return (0, $1XAnY._)({
        cache: $f1e8fdbbd7d56f0d$var$createLruCache(config.cacheSize),
        parseClassName: $f1e8fdbbd7d56f0d$var$createParseClassName(config),
        sortModifiers: $f1e8fdbbd7d56f0d$var$createSortModifiers(config),
        postfixLookupClassGroupIds: $f1e8fdbbd7d56f0d$var$createPostfixLookupClassGroupIds(config)
    }, $f1e8fdbbd7d56f0d$var$createClassGroupUtils(config));
};
var $f1e8fdbbd7d56f0d$var$createPostfixLookupClassGroupIds = function(config) {
    var lookup = Object.create(null);
    var classGroupIds = config.postfixLookupClassGroups;
    if (classGroupIds) for(var i = 0; i < classGroupIds.length; i++)lookup[classGroupIds[i]] = true;
    return lookup;
};
var $f1e8fdbbd7d56f0d$var$SPLIT_CLASSES_REGEX = /\s+/;
var $f1e8fdbbd7d56f0d$var$mergeClassList = function(classList, configUtils) {
    var parseClassName = configUtils.parseClassName, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds, sortModifiers = configUtils.sortModifiers, postfixLookupClassGroupIds = configUtils.postfixLookupClassGroupIds;
    /**
   * Set of classGroupIds in following format:
   * `{importantModifier}{variantModifiers}{classGroupId}`
   * @example 'float'
   * @example 'hover:focus:bg-color'
   * @example 'md:!pr'
   */ var classGroupsInConflict = [];
    var classNames = classList.trim().split($f1e8fdbbd7d56f0d$var$SPLIT_CLASSES_REGEX);
    var result = '';
    for(var index = classNames.length - 1; index >= 0; index -= 1){
        var originalClassName = classNames[index];
        var _parseClassName = parseClassName(originalClassName), isExternal = _parseClassName.isExternal, modifiers = _parseClassName.modifiers, hasImportantModifier = _parseClassName.hasImportantModifier, baseClassName = _parseClassName.baseClassName, maybePostfixModifierPosition = _parseClassName.maybePostfixModifierPosition;
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? ' ' + result : result);
            continue;
        }
        var hasPostfixModifier = !!maybePostfixModifierPosition;
        var classGroupId = void 0;
        if (hasPostfixModifier) {
            var baseClassNameWithoutPostfix = baseClassName.substring(0, maybePostfixModifierPosition);
            classGroupId = getClassGroupId(baseClassNameWithoutPostfix);
            var classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : undefined;
            if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
                classGroupId = classGroupIdWithPostfix;
                hasPostfixModifier = false;
            }
        } else classGroupId = getClassGroupId(baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                // Not a Tailwind class
                result = originalClassName + (result.length > 0 ? ' ' + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        // Fast path: skip sorting for empty or single modifier
        var variantModifier = modifiers.length === 0 ? '' : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(':');
        var modifierId = hasImportantModifier ? variantModifier + $f1e8fdbbd7d56f0d$var$IMPORTANT_MODIFIER : variantModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        var conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(var i = 0; i < conflictGroups.length; ++i){
            var group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        // Tailwind class not in conflict
        result = originalClassName + (result.length > 0 ? ' ' + result : result);
    }
    return result;
};
/**
 * The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
 *
 * Specifically:
 * - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
 * - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
 *
 * Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
 */ var $f1e8fdbbd7d56f0d$export$a8bbfb445e1f163f = function() {
    for(var _len = arguments.length, classLists = new Array(_len), _key = 0; _key < _len; _key++){
        classLists[_key] = arguments[_key];
    }
    var index = 0;
    var argument;
    var resolvedValue;
    var string = '';
    while(index < classLists.length){
        if (argument = classLists[index++]) {
            if (resolvedValue = $f1e8fdbbd7d56f0d$var$toValue(argument)) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
var $f1e8fdbbd7d56f0d$var$toValue = function(mix) {
    // Fast path for strings
    if (typeof mix === 'string') return mix;
    var resolvedValue;
    var string = '';
    for(var k = 0; k < mix.length; k++){
        if (mix[k]) {
            if (resolvedValue = $f1e8fdbbd7d56f0d$var$toValue(mix[k])) {
                string && (string += ' ');
                string += resolvedValue;
            }
        }
    }
    return string;
};
var $f1e8fdbbd7d56f0d$export$ea2d4fba4d1bd27f = function(createConfigFirst) {
    for(var _len = arguments.length, createConfigRest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        createConfigRest[_key - 1] = arguments[_key];
    }
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall;
    var initTailwindMerge = function(classList) {
        var config = createConfigRest.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, createConfigFirst());
        configUtils = $f1e8fdbbd7d56f0d$var$createConfigUtils(config);
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    var tailwindMerge = function(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = $f1e8fdbbd7d56f0d$var$mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return functionToCall($f1e8fdbbd7d56f0d$export$a8bbfb445e1f163f.apply(void 0, (0, $aUGqu._)(args)));
    };
};
var $f1e8fdbbd7d56f0d$var$fallbackThemeArr = [];
var $f1e8fdbbd7d56f0d$export$e176af7b8eefe933 = function(key) {
    var themeGetter = function(theme) {
        return theme[key] || $f1e8fdbbd7d56f0d$var$fallbackThemeArr;
    };
    themeGetter.isThemeGetter = true;
    themeGetter.themeKey = key;
    return themeGetter;
};
var $f1e8fdbbd7d56f0d$var$arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
var $f1e8fdbbd7d56f0d$var$arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
var $f1e8fdbbd7d56f0d$var$fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
var $f1e8fdbbd7d56f0d$var$tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var $f1e8fdbbd7d56f0d$var$lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var $f1e8fdbbd7d56f0d$var$colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix|color|light-dark)\(.+\)$/;
// Shadow always begins with x and y offset separated by underscore optionally prepended by inset
var $f1e8fdbbd7d56f0d$var$shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
var $f1e8fdbbd7d56f0d$var$imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
var $f1e8fdbbd7d56f0d$var$isFraction = function(value) {
    return $f1e8fdbbd7d56f0d$var$fractionRegex.test(value);
};
var $f1e8fdbbd7d56f0d$var$isNumber = function(value) {
    return !!value && !Number.isNaN(Number(value));
};
var $f1e8fdbbd7d56f0d$var$isInteger = function(value) {
    return !!value && Number.isInteger(Number(value));
};
var $f1e8fdbbd7d56f0d$var$isPercent = function(value) {
    return value.endsWith('%') && $f1e8fdbbd7d56f0d$var$isNumber(value.slice(0, -1));
};
var $f1e8fdbbd7d56f0d$var$isTshirtSize = function(value) {
    return $f1e8fdbbd7d56f0d$var$tshirtUnitRegex.test(value);
};
var $f1e8fdbbd7d56f0d$var$isAny = function() {
    return true;
};
var $f1e8fdbbd7d56f0d$var$isLengthOnly = function(value) {
    return(// `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    $f1e8fdbbd7d56f0d$var$lengthUnitRegex.test(value) && !$f1e8fdbbd7d56f0d$var$colorFunctionRegex.test(value));
};
var $f1e8fdbbd7d56f0d$var$isNever = function() {
    return false;
};
var $f1e8fdbbd7d56f0d$var$isShadow = function(value) {
    return $f1e8fdbbd7d56f0d$var$shadowRegex.test(value);
};
var $f1e8fdbbd7d56f0d$var$isImage = function(value) {
    return $f1e8fdbbd7d56f0d$var$imageRegex.test(value);
};
var $f1e8fdbbd7d56f0d$var$isAnyNonArbitrary = function(value) {
    return !$f1e8fdbbd7d56f0d$var$isArbitraryValue(value) && !$f1e8fdbbd7d56f0d$var$isArbitraryVariable(value);
};
var $f1e8fdbbd7d56f0d$var$isNamedContainerQuery = function(value) {
    return value.startsWith('@container') && (value[10] === '/' && value[11] !== undefined || value[11] === 's' && value[16] !== undefined && value.startsWith('-size/', 10) || value[11] === 'n' && value[18] !== undefined && value.startsWith('-normal/', 10));
};
var $f1e8fdbbd7d56f0d$var$isArbitrarySize = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryValue(value, $f1e8fdbbd7d56f0d$var$isLabelSize, $f1e8fdbbd7d56f0d$var$isNever);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryValue = function(value) {
    return $f1e8fdbbd7d56f0d$var$arbitraryValueRegex.test(value);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryLength = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryValue(value, $f1e8fdbbd7d56f0d$var$isLabelLength, $f1e8fdbbd7d56f0d$var$isLengthOnly);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryNumber = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryValue(value, $f1e8fdbbd7d56f0d$var$isLabelNumber, $f1e8fdbbd7d56f0d$var$isNumber);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryWeight = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryValue(value, $f1e8fdbbd7d56f0d$var$isLabelWeight, $f1e8fdbbd7d56f0d$var$isAny);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryFamilyName = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryValue(value, $f1e8fdbbd7d56f0d$var$isLabelFamilyName, $f1e8fdbbd7d56f0d$var$isNever);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryPosition = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryValue(value, $f1e8fdbbd7d56f0d$var$isLabelPosition, $f1e8fdbbd7d56f0d$var$isNever);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryImage = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryValue(value, $f1e8fdbbd7d56f0d$var$isLabelImage, $f1e8fdbbd7d56f0d$var$isImage);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryShadow = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryValue(value, $f1e8fdbbd7d56f0d$var$isLabelShadow, $f1e8fdbbd7d56f0d$var$isShadow);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryVariable = function(value) {
    return $f1e8fdbbd7d56f0d$var$arbitraryVariableRegex.test(value);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryVariableLength = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryVariable(value, $f1e8fdbbd7d56f0d$var$isLabelLength);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryVariableFamilyName = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryVariable(value, $f1e8fdbbd7d56f0d$var$isLabelFamilyName);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryVariablePosition = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryVariable(value, $f1e8fdbbd7d56f0d$var$isLabelPosition);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryVariableSize = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryVariable(value, $f1e8fdbbd7d56f0d$var$isLabelSize);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryVariableImage = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryVariable(value, $f1e8fdbbd7d56f0d$var$isLabelImage);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryVariableShadow = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryVariable(value, $f1e8fdbbd7d56f0d$var$isLabelShadow, true);
};
var $f1e8fdbbd7d56f0d$var$isArbitraryVariableWeight = function(value) {
    return $f1e8fdbbd7d56f0d$var$getIsArbitraryVariable(value, $f1e8fdbbd7d56f0d$var$isLabelWeight, true);
};
// Helpers
var $f1e8fdbbd7d56f0d$var$getIsArbitraryValue = function(value, testLabel, testValue) {
    var result = $f1e8fdbbd7d56f0d$var$arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
var $f1e8fdbbd7d56f0d$var$getIsArbitraryVariable = function(value, testLabel) {
    var shouldMatchNoLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var result = $f1e8fdbbd7d56f0d$var$arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
// Labels
var $f1e8fdbbd7d56f0d$var$isLabelPosition = function(label) {
    return label === 'position' || label === 'percentage';
};
var $f1e8fdbbd7d56f0d$var$isLabelImage = function(label) {
    return label === 'image' || label === 'url';
};
var $f1e8fdbbd7d56f0d$var$isLabelSize = function(label) {
    return label === 'length' || label === 'size' || label === 'bg-size';
};
var $f1e8fdbbd7d56f0d$var$isLabelLength = function(label) {
    return label === 'length';
};
var $f1e8fdbbd7d56f0d$var$isLabelNumber = function(label) {
    return label === 'number';
};
var $f1e8fdbbd7d56f0d$var$isLabelFamilyName = function(label) {
    return label === 'family-name';
};
var $f1e8fdbbd7d56f0d$var$isLabelWeight = function(label) {
    return label === 'number' || label === 'weight';
};
var $f1e8fdbbd7d56f0d$var$isLabelShadow = function(label) {
    return label === 'shadow';
};
var $f1e8fdbbd7d56f0d$export$6f98703d2f5d4276 = /*#__PURE__*/ Object.defineProperty({
    __proto__: null,
    isAny: $f1e8fdbbd7d56f0d$var$isAny,
    isAnyNonArbitrary: $f1e8fdbbd7d56f0d$var$isAnyNonArbitrary,
    isArbitraryFamilyName: $f1e8fdbbd7d56f0d$var$isArbitraryFamilyName,
    isArbitraryImage: $f1e8fdbbd7d56f0d$var$isArbitraryImage,
    isArbitraryLength: $f1e8fdbbd7d56f0d$var$isArbitraryLength,
    isArbitraryNumber: $f1e8fdbbd7d56f0d$var$isArbitraryNumber,
    isArbitraryPosition: $f1e8fdbbd7d56f0d$var$isArbitraryPosition,
    isArbitraryShadow: $f1e8fdbbd7d56f0d$var$isArbitraryShadow,
    isArbitrarySize: $f1e8fdbbd7d56f0d$var$isArbitrarySize,
    isArbitraryValue: $f1e8fdbbd7d56f0d$var$isArbitraryValue,
    isArbitraryVariable: $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
    isArbitraryVariableFamilyName: $f1e8fdbbd7d56f0d$var$isArbitraryVariableFamilyName,
    isArbitraryVariableImage: $f1e8fdbbd7d56f0d$var$isArbitraryVariableImage,
    isArbitraryVariableLength: $f1e8fdbbd7d56f0d$var$isArbitraryVariableLength,
    isArbitraryVariablePosition: $f1e8fdbbd7d56f0d$var$isArbitraryVariablePosition,
    isArbitraryVariableShadow: $f1e8fdbbd7d56f0d$var$isArbitraryVariableShadow,
    isArbitraryVariableSize: $f1e8fdbbd7d56f0d$var$isArbitraryVariableSize,
    isArbitraryVariableWeight: $f1e8fdbbd7d56f0d$var$isArbitraryVariableWeight,
    isArbitraryWeight: $f1e8fdbbd7d56f0d$var$isArbitraryWeight,
    isFraction: $f1e8fdbbd7d56f0d$var$isFraction,
    isInteger: $f1e8fdbbd7d56f0d$var$isInteger,
    isNamedContainerQuery: $f1e8fdbbd7d56f0d$var$isNamedContainerQuery,
    isNumber: $f1e8fdbbd7d56f0d$var$isNumber,
    isPercent: $f1e8fdbbd7d56f0d$var$isPercent,
    isTshirtSize: $f1e8fdbbd7d56f0d$var$isTshirtSize
}, Symbol.toStringTag, {
    value: 'Module'
});
var $f1e8fdbbd7d56f0d$export$ed30944e0fe6ae5c = function() {
    /**
   * Theme getters for theme variable namespaces
   * @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
   */ /***/ var themeColor = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('color');
    var themeFont = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('font');
    var themeText = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('text');
    var themeFontWeight = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('font-weight');
    var themeTracking = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('tracking');
    var themeLeading = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('leading');
    var themeBreakpoint = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('breakpoint');
    var themeContainer = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('container');
    var themeSpacing = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('spacing');
    var themeRadius = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('radius');
    var themeShadow = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('shadow');
    var themeInsetShadow = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('inset-shadow');
    var themeTextShadow = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('text-shadow');
    var themeDropShadow = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('drop-shadow');
    var themeBlur = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('blur');
    var themePerspective = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('perspective');
    var themeAspect = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('aspect');
    var themeEase = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('ease');
    var themeAnimate = $f1e8fdbbd7d56f0d$export$e176af7b8eefe933('animate');
    /**
   * Helpers to avoid repeating the same scales
   *
   * We use functions that create a new array every time they're called instead of static arrays.
   * This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
   */ /***/ var scaleBreak = function() {
        return [
            'auto',
            'avoid',
            'all',
            'avoid-page',
            'page',
            'left',
            'right',
            'column'
        ];
    };
    var scalePosition = function() {
        return [
            'center',
            'top',
            'bottom',
            'left',
            'right',
            'top-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-top',
            'top-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-top',
            'bottom-right',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'right-bottom',
            'bottom-left',
            // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
            'left-bottom'
        ];
    };
    var scalePositionWithArbitrary = function() {
        return (0, $aUGqu._)(scalePosition()).concat([
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ]);
    };
    var scaleOverflow = function() {
        return [
            'auto',
            'hidden',
            'clip',
            'visible',
            'scroll'
        ];
    };
    var scaleOverscroll = function() {
        return [
            'auto',
            'contain',
            'none'
        ];
    };
    var scaleUnambiguousSpacing = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue,
            themeSpacing
        ];
    };
    var scaleInset = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isFraction,
            'full',
            'auto'
        ].concat((0, $aUGqu._)(scaleUnambiguousSpacing()));
    };
    var scaleGridTemplateColsRows = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isInteger,
            'none',
            'subgrid',
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleGridColRowStartAndEnd = function() {
        return [
            'auto',
            {
                span: [
                    'full',
                    $f1e8fdbbd7d56f0d$var$isInteger,
                    $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                    $f1e8fdbbd7d56f0d$var$isArbitraryValue
                ]
            },
            $f1e8fdbbd7d56f0d$var$isInteger,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleGridColRowStartOrEnd = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isInteger,
            'auto',
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleGridAutoColsRows = function() {
        return [
            'auto',
            'min',
            'max',
            'fr',
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleAlignPrimaryAxis = function() {
        return [
            'start',
            'end',
            'center',
            'between',
            'around',
            'evenly',
            'stretch',
            'baseline',
            'center-safe',
            'end-safe'
        ];
    };
    var scaleAlignSecondaryAxis = function() {
        return [
            'start',
            'end',
            'center',
            'stretch',
            'center-safe',
            'end-safe'
        ];
    };
    var scaleMargin = function() {
        return [
            'auto'
        ].concat((0, $aUGqu._)(scaleUnambiguousSpacing()));
    };
    var scaleSizing = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isFraction,
            'auto',
            'full',
            'dvw',
            'dvh',
            'lvw',
            'lvh',
            'svw',
            'svh',
            'min',
            'max',
            'fit'
        ].concat((0, $aUGqu._)(scaleUnambiguousSpacing()));
    };
    var scaleSizingInline = function() {
        return [
            themeContainer,
            $f1e8fdbbd7d56f0d$var$isFraction,
            'screen',
            'full',
            'dvw',
            'lvw',
            'svw',
            'min',
            'max',
            'fit'
        ].concat((0, $aUGqu._)(scaleUnambiguousSpacing()));
    };
    var scaleSizingBlock = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isFraction,
            'screen',
            'full',
            'lh',
            'dvh',
            'lvh',
            'svh',
            'min',
            'max',
            'fit'
        ].concat((0, $aUGqu._)(scaleUnambiguousSpacing()));
    };
    var scaleColor = function() {
        return [
            themeColor,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleBgPosition = function() {
        return (0, $aUGqu._)(scalePosition()).concat([
            $f1e8fdbbd7d56f0d$var$isArbitraryVariablePosition,
            $f1e8fdbbd7d56f0d$var$isArbitraryPosition,
            {
                position: [
                    $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                    $f1e8fdbbd7d56f0d$var$isArbitraryValue
                ]
            }
        ]);
    };
    var scaleBgRepeat = function() {
        return [
            'no-repeat',
            {
                repeat: [
                    '',
                    'x',
                    'y',
                    'space',
                    'round'
                ]
            }
        ];
    };
    var scaleBgSize = function() {
        return [
            'auto',
            'cover',
            'contain',
            $f1e8fdbbd7d56f0d$var$isArbitraryVariableSize,
            $f1e8fdbbd7d56f0d$var$isArbitrarySize,
            {
                size: [
                    $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                    $f1e8fdbbd7d56f0d$var$isArbitraryValue
                ]
            }
        ];
    };
    var scaleGradientStopPosition = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isPercent,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariableLength,
            $f1e8fdbbd7d56f0d$var$isArbitraryLength
        ];
    };
    var scaleRadius = function() {
        return [
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            'full',
            themeRadius,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleBorderWidth = function() {
        return [
            '',
            $f1e8fdbbd7d56f0d$var$isNumber,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariableLength,
            $f1e8fdbbd7d56f0d$var$isArbitraryLength
        ];
    };
    var scaleLineStyle = function() {
        return [
            'solid',
            'dashed',
            'dotted',
            'double'
        ];
    };
    var scaleBlendMode = function() {
        return [
            'normal',
            'multiply',
            'screen',
            'overlay',
            'darken',
            'lighten',
            'color-dodge',
            'color-burn',
            'hard-light',
            'soft-light',
            'difference',
            'exclusion',
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
    };
    var scaleMaskImagePosition = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isNumber,
            $f1e8fdbbd7d56f0d$var$isPercent,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariablePosition,
            $f1e8fdbbd7d56f0d$var$isArbitraryPosition
        ];
    };
    var scaleBlur = function() {
        return [
            // Deprecated since Tailwind CSS v4.0.0
            '',
            'none',
            themeBlur,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleRotate = function() {
        return [
            'none',
            $f1e8fdbbd7d56f0d$var$isNumber,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleScale = function() {
        return [
            'none',
            $f1e8fdbbd7d56f0d$var$isNumber,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleSkew = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isNumber,
            $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
            $f1e8fdbbd7d56f0d$var$isArbitraryValue
        ];
    };
    var scaleTranslate = function() {
        return [
            $f1e8fdbbd7d56f0d$var$isFraction,
            'full'
        ].concat((0, $aUGqu._)(scaleUnambiguousSpacing()));
    };
    return {
        cacheSize: 500,
        theme: {
            animate: [
                'spin',
                'ping',
                'pulse',
                'bounce'
            ],
            aspect: [
                'video'
            ],
            blur: [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            breakpoint: [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            color: [
                $f1e8fdbbd7d56f0d$var$isAny
            ],
            container: [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            'drop-shadow': [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            ease: [
                'in',
                'out',
                'in-out'
            ],
            font: [
                $f1e8fdbbd7d56f0d$var$isAnyNonArbitrary
            ],
            'font-weight': [
                'thin',
                'extralight',
                'light',
                'normal',
                'medium',
                'semibold',
                'bold',
                'extrabold',
                'black'
            ],
            'inset-shadow': [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            leading: [
                'none',
                'tight',
                'snug',
                'normal',
                'relaxed',
                'loose'
            ],
            perspective: [
                'dramatic',
                'near',
                'normal',
                'midrange',
                'distant',
                'none'
            ],
            radius: [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            shadow: [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            spacing: [
                'px',
                $f1e8fdbbd7d56f0d$var$isNumber
            ],
            text: [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            'text-shadow': [
                $f1e8fdbbd7d56f0d$var$isTshirtSize
            ],
            tracking: [
                'tighter',
                'tight',
                'normal',
                'wide',
                'wider',
                'widest'
            ]
        },
        classGroups: {
            // --------------
            // --- Layout ---
            // --------------
            /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */ aspect: [
                {
                    aspect: [
                        'auto',
                        'square',
                        $f1e8fdbbd7d56f0d$var$isFraction,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */ container: [
                'container'
            ],
            /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */ 'container-type': [
                {
                    '@container': [
                        '',
                        'normal',
                        'size',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */ 'container-named': [
                $f1e8fdbbd7d56f0d$var$isNamedContainerQuery
            ],
            /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */ columns: [
                {
                    columns: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        'auto',
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */ 'break-after': [
                {
                    'break-after': scaleBreak()
                }
            ],
            /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */ 'break-before': [
                {
                    'break-before': scaleBreak()
                }
            ],
            /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */ 'break-inside': [
                {
                    'break-inside': [
                        'auto',
                        'avoid',
                        'avoid-page',
                        'avoid-column'
                    ]
                }
            ],
            /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */ 'box-decoration': [
                {
                    'box-decoration': [
                        'slice',
                        'clone'
                    ]
                }
            ],
            /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */ box: [
                {
                    box: [
                        'border',
                        'content'
                    ]
                }
            ],
            /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */ display: [
                'block',
                'inline-block',
                'inline',
                'flex',
                'inline-flex',
                'table',
                'inline-table',
                'table-caption',
                'table-cell',
                'table-column',
                'table-column-group',
                'table-footer-group',
                'table-header-group',
                'table-row-group',
                'table-row',
                'flow-root',
                'grid',
                'inline-grid',
                'contents',
                'list-item',
                'hidden'
            ],
            /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */ sr: [
                'sr-only',
                'not-sr-only'
            ],
            /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */ float: [
                {
                    float: [
                        'right',
                        'left',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */ clear: [
                {
                    clear: [
                        'left',
                        'right',
                        'both',
                        'none',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */ isolation: [
                'isolate',
                'isolation-auto'
            ],
            /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */ 'object-fit': [
                {
                    object: [
                        'contain',
                        'cover',
                        'fill',
                        'none',
                        'scale-down'
                    ]
                }
            ],
            /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */ 'object-position': [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-x': [
                {
                    'overflow-x': scaleOverflow()
                }
            ],
            /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */ 'overflow-y': [
                {
                    'overflow-y': scaleOverflow()
                }
            ],
            /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-x': [
                {
                    'overscroll-x': scaleOverscroll()
                }
            ],
            /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */ 'overscroll-y': [
                {
                    'overscroll-y': scaleOverscroll()
                }
            ],
            /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */ position: [
                'static',
                'fixed',
                'absolute',
                'relative',
                'sticky'
            ],
            /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-x': [
                {
                    'inset-x': scaleInset()
                }
            ],
            /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-y': [
                {
                    'inset-y': scaleInset()
                }
            ],
            /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */ start: [
                {
                    'inset-s': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ start: scaleInset()
                }
            ],
            /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */ end: [
                {
                    'inset-e': scaleInset(),
                    /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */ end: scaleInset()
                }
            ],
            /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-bs': [
                {
                    'inset-bs': scaleInset()
                }
            ],
            /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ 'inset-be': [
                {
                    'inset-be': scaleInset()
                }
            ],
            /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */ visibility: [
                'visible',
                'invisible',
                'collapse'
            ],
            /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */ z: [
                {
                    z: [
                        $f1e8fdbbd7d56f0d$var$isInteger,
                        'auto',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------------
            // --- Flexbox and Grid ---
            // ------------------------
            /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */ basis: [
                {
                    basis: [
                        $f1e8fdbbd7d56f0d$var$isFraction,
                        'full',
                        'auto',
                        themeContainer
                    ].concat((0, $aUGqu._)(scaleUnambiguousSpacing()))
                }
            ],
            /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */ 'flex-direction': [
                {
                    flex: [
                        'row',
                        'row-reverse',
                        'col',
                        'col-reverse'
                    ]
                }
            ],
            /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */ 'flex-wrap': [
                {
                    flex: [
                        'nowrap',
                        'wrap',
                        'wrap-reverse'
                    ]
                }
            ],
            /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */ flex: [
                {
                    flex: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isFraction,
                        'auto',
                        'initial',
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */ grow: [
                {
                    grow: [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */ shrink: [
                {
                    shrink: [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */ order: [
                {
                    order: [
                        $f1e8fdbbd7d56f0d$var$isInteger,
                        'first',
                        'last',
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */ 'grid-cols': [
                {
                    'grid-cols': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start-end': [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-start': [
                {
                    'col-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */ 'col-end': [
                {
                    'col-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */ 'grid-rows': [
                {
                    'grid-rows': scaleGridTemplateColsRows()
                }
            ],
            /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start-end': [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-start': [
                {
                    'row-start': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */ 'row-end': [
                {
                    'row-end': scaleGridColRowStartOrEnd()
                }
            ],
            /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */ 'grid-flow': [
                {
                    'grid-flow': [
                        'row',
                        'col',
                        'dense',
                        'row-dense',
                        'col-dense'
                    ]
                }
            ],
            /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */ 'auto-cols': [
                {
                    'auto-cols': scaleGridAutoColsRows()
                }
            ],
            /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */ 'auto-rows': [
                {
                    'auto-rows': scaleGridAutoColsRows()
                }
            ],
            /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-x': [
                {
                    'gap-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */ 'gap-y': [
                {
                    'gap-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */ 'justify-content': [
                {
                    justify: (0, $aUGqu._)(scaleAlignPrimaryAxis()).concat([
                        'normal'
                    ])
                }
            ],
            /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */ 'justify-items': [
                {
                    'justify-items': (0, $aUGqu._)(scaleAlignSecondaryAxis()).concat([
                        'normal'
                    ])
                }
            ],
            /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */ 'justify-self': [
                {
                    'justify-self': [
                        'auto'
                    ].concat((0, $aUGqu._)(scaleAlignSecondaryAxis()))
                }
            ],
            /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */ 'align-content': [
                {
                    content: [
                        'normal'
                    ].concat((0, $aUGqu._)(scaleAlignPrimaryAxis()))
                }
            ],
            /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */ 'align-items': [
                {
                    items: (0, $aUGqu._)(scaleAlignSecondaryAxis()).concat([
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ])
                }
            ],
            /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */ 'align-self': [
                {
                    self: [
                        'auto'
                    ].concat((0, $aUGqu._)(scaleAlignSecondaryAxis()), [
                        {
                            baseline: [
                                '',
                                'last'
                            ]
                        }
                    ])
                }
            ],
            /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */ 'place-content': [
                {
                    'place-content': scaleAlignPrimaryAxis()
                }
            ],
            /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */ 'place-items': [
                {
                    'place-items': (0, $aUGqu._)(scaleAlignSecondaryAxis()).concat([
                        'baseline'
                    ])
                }
            ],
            /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */ 'place-self': [
                {
                    'place-self': [
                        'auto'
                    ].concat((0, $aUGqu._)(scaleAlignSecondaryAxis()))
                }
            ],
            // Spacing
            /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x': [
                {
                    'space-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-x-reverse': [
                'space-x-reverse'
            ],
            /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y': [
                {
                    'space-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */ 'space-y-reverse': [
                'space-y-reverse'
            ],
            // --------------
            // --- Sizing ---
            // --------------
            /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
       * Inline Size
       * @see https://tailwindcss.com/docs/inline-size
       */ 'inline-size': [
                {
                    inline: [
                        'auto'
                    ].concat((0, $aUGqu._)(scaleSizingInline()))
                }
            ],
            /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-inline-size
       */ 'min-inline-size': [
                {
                    'min-inline': [
                        'auto'
                    ].concat((0, $aUGqu._)(scaleSizingInline()))
                }
            ],
            /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-inline-size
       */ 'max-inline-size': [
                {
                    'max-inline': [
                        'none'
                    ].concat((0, $aUGqu._)(scaleSizingInline()))
                }
            ],
            /**
       * Block Size
       * @see https://tailwindcss.com/docs/block-size
       */ 'block-size': [
                {
                    block: [
                        'auto'
                    ].concat((0, $aUGqu._)(scaleSizingBlock()))
                }
            ],
            /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-block-size
       */ 'min-block-size': [
                {
                    'min-block': [
                        'auto'
                    ].concat((0, $aUGqu._)(scaleSizingBlock()))
                }
            ],
            /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-block-size
       */ 'max-block-size': [
                {
                    'max-block': [
                        'none'
                    ].concat((0, $aUGqu._)(scaleSizingBlock()))
                }
            ],
            /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */ w: [
                {
                    w: [
                        themeContainer,
                        'screen'
                    ].concat((0, $aUGqu._)(scaleSizing()))
                }
            ],
            /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */ 'min-w': [
                {
                    'min-w': [
                        themeContainer,
                        'screen',
                        /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'none'
                    ].concat((0, $aUGqu._)(scaleSizing()))
                }
            ],
            /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */ 'max-w': [
                {
                    'max-w': [
                        themeContainer,
                        'screen',
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ 'prose',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ {
                            screen: [
                                themeBreakpoint
                            ]
                        }
                    ].concat((0, $aUGqu._)(scaleSizing()))
                }
            ],
            /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */ h: [
                {
                    h: [
                        'screen',
                        'lh'
                    ].concat((0, $aUGqu._)(scaleSizing()))
                }
            ],
            /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */ 'min-h': [
                {
                    'min-h': [
                        'screen',
                        'lh',
                        'none'
                    ].concat((0, $aUGqu._)(scaleSizing()))
                }
            ],
            /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */ 'max-h': [
                {
                    'max-h': [
                        'screen',
                        'lh',
                        'none'
                    ].concat((0, $aUGqu._)(scaleSizing()))
                }
            ],
            // ------------------
            // --- Typography ---
            // ------------------
            /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */ 'font-size': [
                {
                    text: [
                        'base',
                        themeText,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableLength,
                        $f1e8fdbbd7d56f0d$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */ 'font-smoothing': [
                'antialiased',
                'subpixel-antialiased'
            ],
            /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */ 'font-style': [
                'italic',
                'not-italic'
            ],
            /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */ 'font-weight': [
                {
                    font: [
                        themeFontWeight,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableWeight,
                        $f1e8fdbbd7d56f0d$var$isArbitraryWeight
                    ]
                }
            ],
            /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */ 'font-stretch': [
                {
                    'font-stretch': [
                        'ultra-condensed',
                        'extra-condensed',
                        'condensed',
                        'semi-condensed',
                        'normal',
                        'semi-expanded',
                        'expanded',
                        'extra-expanded',
                        'ultra-expanded',
                        $f1e8fdbbd7d56f0d$var$isPercent,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */ 'font-family': [
                {
                    font: [
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableFamilyName,
                        $f1e8fdbbd7d56f0d$var$isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */ 'font-features': [
                {
                    'font-features': [
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-normal': [
                'normal-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-ordinal': [
                'ordinal'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-slashed-zero': [
                'slashed-zero'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-figure': [
                'lining-nums',
                'oldstyle-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-spacing': [
                'proportional-nums',
                'tabular-nums'
            ],
            /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */ 'fvn-fraction': [
                'diagonal-fractions',
                'stacked-fractions'
            ],
            /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */ tracking: [
                {
                    tracking: [
                        themeTracking,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */ 'line-clamp': [
                {
                    'line-clamp': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */ leading: [
                {
                    leading: [
                        'none',
                        /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */ themeLeading
                    ].concat((0, $aUGqu._)(scaleUnambiguousSpacing()))
                }
            ],
            /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */ 'list-image': [
                {
                    'list-image': [
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */ 'list-style-position': [
                {
                    list: [
                        'inside',
                        'outside'
                    ]
                }
            ],
            /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */ 'list-style-type': [
                {
                    list: [
                        'disc',
                        'decimal',
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */ 'text-alignment': [
                {
                    text: [
                        'left',
                        'center',
                        'right',
                        'justify',
                        'start',
                        'end'
                    ]
                }
            ],
            /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */ 'placeholder-color': [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */ 'text-color': [
                {
                    text: scaleColor()
                }
            ],
            /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */ 'text-decoration': [
                'underline',
                'overline',
                'line-through',
                'no-underline'
            ],
            /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */ 'text-decoration-style': [
                {
                    decoration: (0, $aUGqu._)(scaleLineStyle()).concat([
                        'wavy'
                    ])
                }
            ],
            /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */ 'text-decoration-thickness': [
                {
                    decoration: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        'from-font',
                        'auto',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */ 'text-decoration-color': [
                {
                    decoration: scaleColor()
                }
            ],
            /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */ 'underline-offset': [
                {
                    'underline-offset': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        'auto',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */ 'text-transform': [
                'uppercase',
                'lowercase',
                'capitalize',
                'normal-case'
            ],
            /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */ 'text-overflow': [
                'truncate',
                'text-ellipsis',
                'text-clip'
            ],
            /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */ 'text-wrap': [
                {
                    text: [
                        'wrap',
                        'nowrap',
                        'balance',
                        'pretty'
                    ]
                }
            ],
            /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */ 'tab-size': [
                {
                    tab: [
                        $f1e8fdbbd7d56f0d$var$isInteger,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */ 'vertical-align': [
                {
                    align: [
                        'baseline',
                        'top',
                        'middle',
                        'bottom',
                        'text-top',
                        'text-bottom',
                        'sub',
                        'super',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */ whitespace: [
                {
                    whitespace: [
                        'normal',
                        'nowrap',
                        'pre',
                        'pre-line',
                        'pre-wrap',
                        'break-spaces'
                    ]
                }
            ],
            /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */ break: [
                {
                    break: [
                        'normal',
                        'words',
                        'all',
                        'keep'
                    ]
                }
            ],
            /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */ wrap: [
                {
                    wrap: [
                        'break-word',
                        'anywhere',
                        'normal'
                    ]
                }
            ],
            /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */ hyphens: [
                {
                    hyphens: [
                        'none',
                        'manual',
                        'auto'
                    ]
                }
            ],
            /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */ content: [
                {
                    content: [
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            // -------------------
            // --- Backgrounds ---
            // -------------------
            /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */ 'bg-attachment': [
                {
                    bg: [
                        'fixed',
                        'local',
                        'scroll'
                    ]
                }
            ],
            /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */ 'bg-clip': [
                {
                    'bg-clip': [
                        'border',
                        'padding',
                        'content',
                        'text'
                    ]
                }
            ],
            /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */ 'bg-origin': [
                {
                    'bg-origin': [
                        'border',
                        'padding',
                        'content'
                    ]
                }
            ],
            /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */ 'bg-position': [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */ 'bg-repeat': [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */ 'bg-size': [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */ 'bg-image': [
                {
                    bg: [
                        'none',
                        {
                            linear: [
                                {
                                    to: [
                                        't',
                                        'tr',
                                        'r',
                                        'br',
                                        'b',
                                        'bl',
                                        'l',
                                        'tl'
                                    ]
                                },
                                $f1e8fdbbd7d56f0d$var$isInteger,
                                $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                                $f1e8fdbbd7d56f0d$var$isArbitraryValue
                            ],
                            radial: [
                                '',
                                $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                                $f1e8fdbbd7d56f0d$var$isArbitraryValue
                            ],
                            conic: [
                                '',
                                $f1e8fdbbd7d56f0d$var$isInteger,
                                $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                                $f1e8fdbbd7d56f0d$var$isArbitraryValue
                            ]
                        },
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableImage,
                        $f1e8fdbbd7d56f0d$var$isArbitraryImage
                    ]
                }
            ],
            /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */ 'bg-color': [
                {
                    bg: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from-pos': [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via-pos': [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to-pos': [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-from': [
                {
                    from: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-via': [
                {
                    via: scaleColor()
                }
            ],
            /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */ 'gradient-to': [
                {
                    to: scaleColor()
                }
            ],
            // ---------------
            // --- Borders ---
            // ---------------
            /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-s': [
                {
                    'rounded-s': scaleRadius()
                }
            ],
            /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-e': [
                {
                    'rounded-e': scaleRadius()
                }
            ],
            /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-t': [
                {
                    'rounded-t': scaleRadius()
                }
            ],
            /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-r': [
                {
                    'rounded-r': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-b': [
                {
                    'rounded-b': scaleRadius()
                }
            ],
            /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-l': [
                {
                    'rounded-l': scaleRadius()
                }
            ],
            /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ss': [
                {
                    'rounded-ss': scaleRadius()
                }
            ],
            /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-se': [
                {
                    'rounded-se': scaleRadius()
                }
            ],
            /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-ee': [
                {
                    'rounded-ee': scaleRadius()
                }
            ],
            /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-es': [
                {
                    'rounded-es': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tl': [
                {
                    'rounded-tl': scaleRadius()
                }
            ],
            /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-tr': [
                {
                    'rounded-tr': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-br': [
                {
                    'rounded-br': scaleRadius()
                }
            ],
            /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */ 'rounded-bl': [
                {
                    'rounded-bl': scaleRadius()
                }
            ],
            /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w': [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-x': [
                {
                    'border-x': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-y': [
                {
                    'border-y': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-s': [
                {
                    'border-s': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-e': [
                {
                    'border-e': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-bs': [
                {
                    'border-bs': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-be': [
                {
                    'border-be': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-t': [
                {
                    'border-t': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-r': [
                {
                    'border-r': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-b': [
                {
                    'border-b': scaleBorderWidth()
                }
            ],
            /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */ 'border-w-l': [
                {
                    'border-l': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x': [
                {
                    'divide-x': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-x-reverse': [
                'divide-x-reverse'
            ],
            /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y': [
                {
                    'divide-y': scaleBorderWidth()
                }
            ],
            /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */ 'divide-y-reverse': [
                'divide-y-reverse'
            ],
            /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */ 'border-style': [
                {
                    border: (0, $aUGqu._)(scaleLineStyle()).concat([
                        'hidden',
                        'none'
                    ])
                }
            ],
            /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */ 'divide-style': [
                {
                    divide: (0, $aUGqu._)(scaleLineStyle()).concat([
                        'hidden',
                        'none'
                    ])
                }
            ],
            /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color': [
                {
                    border: scaleColor()
                }
            ],
            /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-x': [
                {
                    'border-x': scaleColor()
                }
            ],
            /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-y': [
                {
                    'border-y': scaleColor()
                }
            ],
            /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-s': [
                {
                    'border-s': scaleColor()
                }
            ],
            /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-e': [
                {
                    'border-e': scaleColor()
                }
            ],
            /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-bs': [
                {
                    'border-bs': scaleColor()
                }
            ],
            /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-be': [
                {
                    'border-be': scaleColor()
                }
            ],
            /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-t': [
                {
                    'border-t': scaleColor()
                }
            ],
            /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-r': [
                {
                    'border-r': scaleColor()
                }
            ],
            /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-b': [
                {
                    'border-b': scaleColor()
                }
            ],
            /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */ 'border-color-l': [
                {
                    'border-l': scaleColor()
                }
            ],
            /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */ 'divide-color': [
                {
                    divide: scaleColor()
                }
            ],
            /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */ 'outline-style': [
                {
                    outline: (0, $aUGqu._)(scaleLineStyle()).concat([
                        'none',
                        'hidden'
                    ])
                }
            ],
            /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */ 'outline-offset': [
                {
                    'outline-offset': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */ 'outline-w': [
                {
                    outline: [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableLength,
                        $f1e8fdbbd7d56f0d$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */ 'outline-color': [
                {
                    outline: scaleColor()
                }
            ],
            // ---------------
            // --- Effects ---
            // ---------------
            /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */ shadow: [
                {
                    shadow: [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        // Deprecated since Tailwind CSS v4.0.0
                        'inner',
                        'none',
                        themeShadow,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableShadow,
                        $f1e8fdbbd7d56f0d$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */ 'shadow-color': [
                {
                    shadow: scaleColor()
                }
            ],
            /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */ 'inset-shadow': [
                {
                    'inset-shadow': [
                        'none',
                        themeInsetShadow,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableShadow,
                        $f1e8fdbbd7d56f0d$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */ 'inset-shadow-color': [
                {
                    'inset-shadow': scaleColor()
                }
            ],
            /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */ 'ring-w': [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-w-inset': [
                'ring-inset'
            ],
            /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */ 'ring-color': [
                {
                    ring: scaleColor()
                }
            ],
            /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-w': [
                {
                    'ring-offset': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryLength
                    ]
                }
            ],
            /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */ 'ring-offset-color': [
                {
                    'ring-offset': scaleColor()
                }
            ],
            /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */ 'inset-ring-w': [
                {
                    'inset-ring': scaleBorderWidth()
                }
            ],
            /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */ 'inset-ring-color': [
                {
                    'inset-ring': scaleColor()
                }
            ],
            /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */ 'text-shadow': [
                {
                    'text-shadow': [
                        'none',
                        themeTextShadow,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableShadow,
                        $f1e8fdbbd7d56f0d$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */ 'text-shadow-color': [
                {
                    'text-shadow': scaleColor()
                }
            ],
            /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */ opacity: [
                {
                    opacity: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */ 'mix-blend': [
                {
                    'mix-blend': (0, $aUGqu._)(scaleBlendMode()).concat([
                        'plus-darker',
                        'plus-lighter'
                    ])
                }
            ],
            /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */ 'bg-blend': [
                {
                    'bg-blend': scaleBlendMode()
                }
            ],
            /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */ 'mask-clip': [
                {
                    'mask-clip': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                },
                'mask-no-clip'
            ],
            /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */ 'mask-composite': [
                {
                    mask: [
                        'add',
                        'subtract',
                        'intersect',
                        'exclude'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image-linear-pos': [
                {
                    'mask-linear': [
                        $f1e8fdbbd7d56f0d$var$isNumber
                    ]
                }
            ],
            'mask-image-linear-from-pos': [
                {
                    'mask-linear-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-to-pos': [
                {
                    'mask-linear-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-linear-from-color': [
                {
                    'mask-linear-from': scaleColor()
                }
            ],
            'mask-image-linear-to-color': [
                {
                    'mask-linear-to': scaleColor()
                }
            ],
            'mask-image-t-from-pos': [
                {
                    'mask-t-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-to-pos': [
                {
                    'mask-t-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-t-from-color': [
                {
                    'mask-t-from': scaleColor()
                }
            ],
            'mask-image-t-to-color': [
                {
                    'mask-t-to': scaleColor()
                }
            ],
            'mask-image-r-from-pos': [
                {
                    'mask-r-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-to-pos': [
                {
                    'mask-r-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-r-from-color': [
                {
                    'mask-r-from': scaleColor()
                }
            ],
            'mask-image-r-to-color': [
                {
                    'mask-r-to': scaleColor()
                }
            ],
            'mask-image-b-from-pos': [
                {
                    'mask-b-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-to-pos': [
                {
                    'mask-b-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-b-from-color': [
                {
                    'mask-b-from': scaleColor()
                }
            ],
            'mask-image-b-to-color': [
                {
                    'mask-b-to': scaleColor()
                }
            ],
            'mask-image-l-from-pos': [
                {
                    'mask-l-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-to-pos': [
                {
                    'mask-l-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-l-from-color': [
                {
                    'mask-l-from': scaleColor()
                }
            ],
            'mask-image-l-to-color': [
                {
                    'mask-l-to': scaleColor()
                }
            ],
            'mask-image-x-from-pos': [
                {
                    'mask-x-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-to-pos': [
                {
                    'mask-x-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-x-from-color': [
                {
                    'mask-x-from': scaleColor()
                }
            ],
            'mask-image-x-to-color': [
                {
                    'mask-x-to': scaleColor()
                }
            ],
            'mask-image-y-from-pos': [
                {
                    'mask-y-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-to-pos': [
                {
                    'mask-y-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-y-from-color': [
                {
                    'mask-y-from': scaleColor()
                }
            ],
            'mask-image-y-to-color': [
                {
                    'mask-y-to': scaleColor()
                }
            ],
            'mask-image-radial': [
                {
                    'mask-radial': [
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            'mask-image-radial-from-pos': [
                {
                    'mask-radial-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-to-pos': [
                {
                    'mask-radial-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-radial-from-color': [
                {
                    'mask-radial-from': scaleColor()
                }
            ],
            'mask-image-radial-to-color': [
                {
                    'mask-radial-to': scaleColor()
                }
            ],
            'mask-image-radial-shape': [
                {
                    'mask-radial': [
                        'circle',
                        'ellipse'
                    ]
                }
            ],
            'mask-image-radial-size': [
                {
                    'mask-radial': [
                        {
                            closest: [
                                'side',
                                'corner'
                            ],
                            farthest: [
                                'side',
                                'corner'
                            ]
                        }
                    ]
                }
            ],
            'mask-image-radial-pos': [
                {
                    'mask-radial-at': scalePosition()
                }
            ],
            'mask-image-conic-pos': [
                {
                    'mask-conic': [
                        $f1e8fdbbd7d56f0d$var$isNumber
                    ]
                }
            ],
            'mask-image-conic-from-pos': [
                {
                    'mask-conic-from': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-to-pos': [
                {
                    'mask-conic-to': scaleMaskImagePosition()
                }
            ],
            'mask-image-conic-from-color': [
                {
                    'mask-conic-from': scaleColor()
                }
            ],
            'mask-image-conic-to-color': [
                {
                    'mask-conic-to': scaleColor()
                }
            ],
            /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */ 'mask-mode': [
                {
                    mask: [
                        'alpha',
                        'luminance',
                        'match'
                    ]
                }
            ],
            /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */ 'mask-origin': [
                {
                    'mask-origin': [
                        'border',
                        'padding',
                        'content',
                        'fill',
                        'stroke',
                        'view'
                    ]
                }
            ],
            /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */ 'mask-position': [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */ 'mask-repeat': [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */ 'mask-size': [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */ 'mask-type': [
                {
                    'mask-type': [
                        'alpha',
                        'luminance'
                    ]
                }
            ],
            /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */ 'mask-image': [
                {
                    mask: [
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------
            // --- Filters ---
            // ---------------
            /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */ filter: [
                {
                    filter: [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */ brightness: [
                {
                    brightness: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */ contrast: [
                {
                    contrast: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */ 'drop-shadow': [
                {
                    'drop-shadow': [
                        // Deprecated since Tailwind CSS v4.0.0
                        '',
                        'none',
                        themeDropShadow,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableShadow,
                        $f1e8fdbbd7d56f0d$var$isArbitraryShadow
                    ]
                }
            ],
            /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */ 'drop-shadow-color': [
                {
                    'drop-shadow': scaleColor()
                }
            ],
            /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */ grayscale: [
                {
                    grayscale: [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */ 'hue-rotate': [
                {
                    'hue-rotate': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */ invert: [
                {
                    invert: [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */ saturate: [
                {
                    saturate: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */ sepia: [
                {
                    sepia: [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */ 'backdrop-filter': [
                {
                    'backdrop-filter': [
                        // Deprecated since Tailwind CSS v3.0.0
                        '',
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */ 'backdrop-blur': [
                {
                    'backdrop-blur': scaleBlur()
                }
            ],
            /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */ 'backdrop-brightness': [
                {
                    'backdrop-brightness': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */ 'backdrop-contrast': [
                {
                    'backdrop-contrast': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */ 'backdrop-grayscale': [
                {
                    'backdrop-grayscale': [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */ 'backdrop-hue-rotate': [
                {
                    'backdrop-hue-rotate': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */ 'backdrop-invert': [
                {
                    'backdrop-invert': [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */ 'backdrop-opacity': [
                {
                    'backdrop-opacity': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */ 'backdrop-saturate': [
                {
                    'backdrop-saturate': [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */ 'backdrop-sepia': [
                {
                    'backdrop-sepia': [
                        '',
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            // --------------
            // --- Tables ---
            // --------------
            /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */ 'border-collapse': [
                {
                    border: [
                        'collapse',
                        'separate'
                    ]
                }
            ],
            /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing': [
                {
                    'border-spacing': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-x': [
                {
                    'border-spacing-x': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */ 'border-spacing-y': [
                {
                    'border-spacing-y': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */ 'table-layout': [
                {
                    table: [
                        'auto',
                        'fixed'
                    ]
                }
            ],
            /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */ caption: [
                {
                    caption: [
                        'top',
                        'bottom'
                    ]
                }
            ],
            // ---------------------------------
            // --- Transitions and Animation ---
            // ---------------------------------
            /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */ transition: [
                {
                    transition: [
                        '',
                        'all',
                        'colors',
                        'opacity',
                        'shadow',
                        'transform',
                        'none',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */ 'transition-behavior': [
                {
                    transition: [
                        'normal',
                        'discrete'
                    ]
                }
            ],
            /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */ duration: [
                {
                    duration: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        'initial',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */ ease: [
                {
                    ease: [
                        'linear',
                        'initial',
                        themeEase,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */ delay: [
                {
                    delay: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */ animate: [
                {
                    animate: [
                        'none',
                        themeAnimate,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            // ------------------
            // --- Transforms ---
            // ------------------
            /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */ backface: [
                {
                    backface: [
                        'hidden',
                        'visible'
                    ]
                }
            ],
            /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */ perspective: [
                {
                    perspective: [
                        themePerspective,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */ 'perspective-origin': [
                {
                    'perspective-origin': scalePositionWithArbitrary()
                }
            ],
            /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-x': [
                {
                    'rotate-x': scaleRotate()
                }
            ],
            /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-y': [
                {
                    'rotate-y': scaleRotate()
                }
            ],
            /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */ 'rotate-z': [
                {
                    'rotate-z': scaleRotate()
                }
            ],
            /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-x': [
                {
                    'scale-x': scaleScale()
                }
            ],
            /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-y': [
                {
                    'scale-y': scaleScale()
                }
            ],
            /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-z': [
                {
                    'scale-z': scaleScale()
                }
            ],
            /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */ 'scale-3d': [
                'scale-3d'
            ],
            /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-x': [
                {
                    'skew-x': scaleSkew()
                }
            ],
            /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */ 'skew-y': [
                {
                    'skew-y': scaleSkew()
                }
            ],
            /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */ transform: [
                {
                    transform: [
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue,
                        '',
                        'none',
                        'gpu',
                        'cpu'
                    ]
                }
            ],
            /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */ 'transform-origin': [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */ 'transform-style': [
                {
                    transform: [
                        '3d',
                        'flat'
                    ]
                }
            ],
            /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-x': [
                {
                    'translate-x': scaleTranslate()
                }
            ],
            /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-y': [
                {
                    'translate-y': scaleTranslate()
                }
            ],
            /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-z': [
                {
                    'translate-z': scaleTranslate()
                }
            ],
            /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */ 'translate-none': [
                'translate-none'
            ],
            /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */ zoom: [
                {
                    zoom: [
                        $f1e8fdbbd7d56f0d$var$isInteger,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            // ---------------------
            // --- Interactivity ---
            // ---------------------
            /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */ appearance: [
                {
                    appearance: [
                        'none',
                        'auto'
                    ]
                }
            ],
            /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */ 'caret-color': [
                {
                    caret: scaleColor()
                }
            ],
            /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */ 'color-scheme': [
                {
                    scheme: [
                        'normal',
                        'dark',
                        'light',
                        'light-dark',
                        'only-dark',
                        'only-light'
                    ]
                }
            ],
            /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */ cursor: [
                {
                    cursor: [
                        'auto',
                        'default',
                        'pointer',
                        'wait',
                        'text',
                        'move',
                        'help',
                        'not-allowed',
                        'none',
                        'context-menu',
                        'progress',
                        'cell',
                        'crosshair',
                        'vertical-text',
                        'alias',
                        'copy',
                        'no-drop',
                        'grab',
                        'grabbing',
                        'all-scroll',
                        'col-resize',
                        'row-resize',
                        'n-resize',
                        'e-resize',
                        's-resize',
                        'w-resize',
                        'ne-resize',
                        'nw-resize',
                        'se-resize',
                        'sw-resize',
                        'ew-resize',
                        'ns-resize',
                        'nesw-resize',
                        'nwse-resize',
                        'zoom-in',
                        'zoom-out',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */ 'field-sizing': [
                {
                    'field-sizing': [
                        'fixed',
                        'content'
                    ]
                }
            ],
            /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */ 'pointer-events': [
                {
                    'pointer-events': [
                        'auto',
                        'none'
                    ]
                }
            ],
            /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */ resize: [
                {
                    resize: [
                        'none',
                        '',
                        'y',
                        'x'
                    ]
                }
            ],
            /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */ 'scroll-behavior': [
                {
                    scroll: [
                        'auto',
                        'smooth'
                    ]
                }
            ],
            /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-thumb-color': [
                {
                    'scrollbar-thumb': scaleColor()
                }
            ],
            /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */ 'scrollbar-track-color': [
                {
                    'scrollbar-track': scaleColor()
                }
            ],
            /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */ 'scrollbar-gutter': [
                {
                    'scrollbar-gutter': [
                        'auto',
                        'stable',
                        'both'
                    ]
                }
            ],
            /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */ 'scrollbar-w': [
                {
                    scrollbar: [
                        'auto',
                        'thin',
                        'none'
                    ]
                }
            ],
            /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-m': [
                {
                    'scroll-m': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mx': [
                {
                    'scroll-mx': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-my': [
                {
                    'scroll-my': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ms': [
                {
                    'scroll-ms': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-me': [
                {
                    'scroll-me': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbs': [
                {
                    'scroll-mbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mbe': [
                {
                    'scroll-mbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mt': [
                {
                    'scroll-mt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mr': [
                {
                    'scroll-mr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-mb': [
                {
                    'scroll-mb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */ 'scroll-ml': [
                {
                    'scroll-ml': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-p': [
                {
                    'scroll-p': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-px': [
                {
                    'scroll-px': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-py': [
                {
                    'scroll-py': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-ps': [
                {
                    'scroll-ps': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pe': [
                {
                    'scroll-pe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbs': [
                {
                    'scroll-pbs': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pbe': [
                {
                    'scroll-pbe': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pt': [
                {
                    'scroll-pt': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pr': [
                {
                    'scroll-pr': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pb': [
                {
                    'scroll-pb': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */ 'scroll-pl': [
                {
                    'scroll-pl': scaleUnambiguousSpacing()
                }
            ],
            /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */ 'snap-align': [
                {
                    snap: [
                        'start',
                        'end',
                        'center',
                        'align-none'
                    ]
                }
            ],
            /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */ 'snap-stop': [
                {
                    snap: [
                        'normal',
                        'always'
                    ]
                }
            ],
            /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-type': [
                {
                    snap: [
                        'none',
                        'x',
                        'y',
                        'both'
                    ]
                }
            ],
            /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */ 'snap-strictness': [
                {
                    snap: [
                        'mandatory',
                        'proximity'
                    ]
                }
            ],
            /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */ touch: [
                {
                    touch: [
                        'auto',
                        'none',
                        'manipulation'
                    ]
                }
            ],
            /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-x': [
                {
                    'touch-pan': [
                        'x',
                        'left',
                        'right'
                    ]
                }
            ],
            /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-y': [
                {
                    'touch-pan': [
                        'y',
                        'up',
                        'down'
                    ]
                }
            ],
            /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */ 'touch-pz': [
                'touch-pinch-zoom'
            ],
            /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */ select: [
                {
                    select: [
                        'none',
                        'text',
                        'all',
                        'auto'
                    ]
                }
            ],
            /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */ 'will-change': [
                {
                    'will-change': [
                        'auto',
                        'scroll',
                        'contents',
                        'transform',
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariable,
                        $f1e8fdbbd7d56f0d$var$isArbitraryValue
                    ]
                }
            ],
            // -----------
            // --- SVG ---
            // -----------
            /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */ fill: [
                {
                    fill: [
                        'none'
                    ].concat((0, $aUGqu._)(scaleColor()))
                }
            ],
            /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */ 'stroke-w': [
                {
                    stroke: [
                        $f1e8fdbbd7d56f0d$var$isNumber,
                        $f1e8fdbbd7d56f0d$var$isArbitraryVariableLength,
                        $f1e8fdbbd7d56f0d$var$isArbitraryLength,
                        $f1e8fdbbd7d56f0d$var$isArbitraryNumber
                    ]
                }
            ],
            /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */ stroke: [
                {
                    stroke: [
                        'none'
                    ].concat((0, $aUGqu._)(scaleColor()))
                }
            ],
            // ---------------------
            // --- Accessibility ---
            // ---------------------
            /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */ 'forced-color-adjust': [
                {
                    'forced-color-adjust': [
                        'auto',
                        'none'
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            'container-named': [
                'container-type'
            ],
            overflow: [
                'overflow-x',
                'overflow-y'
            ],
            overscroll: [
                'overscroll-x',
                'overscroll-y'
            ],
            inset: [
                'inset-x',
                'inset-y',
                'inset-bs',
                'inset-be',
                'start',
                'end',
                'top',
                'right',
                'bottom',
                'left'
            ],
            'inset-x': [
                'start',
                'end',
                'right',
                'left'
            ],
            'inset-y': [
                'inset-bs',
                'inset-be',
                'top',
                'bottom'
            ],
            flex: [
                'basis',
                'grow',
                'shrink'
            ],
            gap: [
                'gap-x',
                'gap-y'
            ],
            p: [
                'px',
                'py',
                'ps',
                'pe',
                'pbs',
                'pbe',
                'pt',
                'pr',
                'pb',
                'pl'
            ],
            px: [
                'ps',
                'pe',
                'pr',
                'pl'
            ],
            py: [
                'pbs',
                'pbe',
                'pt',
                'pb'
            ],
            m: [
                'mx',
                'my',
                'ms',
                'me',
                'mbs',
                'mbe',
                'mt',
                'mr',
                'mb',
                'ml'
            ],
            mx: [
                'ms',
                'me',
                'mr',
                'ml'
            ],
            my: [
                'mbs',
                'mbe',
                'mt',
                'mb'
            ],
            size: [
                'w',
                'h'
            ],
            'font-size': [
                'leading'
            ],
            'fvn-normal': [
                'fvn-ordinal',
                'fvn-slashed-zero',
                'fvn-figure',
                'fvn-spacing',
                'fvn-fraction'
            ],
            'fvn-ordinal': [
                'fvn-normal'
            ],
            'fvn-slashed-zero': [
                'fvn-normal'
            ],
            'fvn-figure': [
                'fvn-normal'
            ],
            'fvn-spacing': [
                'fvn-normal'
            ],
            'fvn-fraction': [
                'fvn-normal'
            ],
            'line-clamp': [
                'display',
                'overflow'
            ],
            rounded: [
                'rounded-s',
                'rounded-e',
                'rounded-t',
                'rounded-r',
                'rounded-b',
                'rounded-l',
                'rounded-ss',
                'rounded-se',
                'rounded-ee',
                'rounded-es',
                'rounded-tl',
                'rounded-tr',
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-s': [
                'rounded-ss',
                'rounded-es'
            ],
            'rounded-e': [
                'rounded-se',
                'rounded-ee'
            ],
            'rounded-t': [
                'rounded-tl',
                'rounded-tr'
            ],
            'rounded-r': [
                'rounded-tr',
                'rounded-br'
            ],
            'rounded-b': [
                'rounded-br',
                'rounded-bl'
            ],
            'rounded-l': [
                'rounded-tl',
                'rounded-bl'
            ],
            'border-spacing': [
                'border-spacing-x',
                'border-spacing-y'
            ],
            'border-w': [
                'border-w-x',
                'border-w-y',
                'border-w-s',
                'border-w-e',
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-r',
                'border-w-b',
                'border-w-l'
            ],
            'border-w-x': [
                'border-w-s',
                'border-w-e',
                'border-w-r',
                'border-w-l'
            ],
            'border-w-y': [
                'border-w-bs',
                'border-w-be',
                'border-w-t',
                'border-w-b'
            ],
            'border-color': [
                'border-color-x',
                'border-color-y',
                'border-color-s',
                'border-color-e',
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-r',
                'border-color-b',
                'border-color-l'
            ],
            'border-color-x': [
                'border-color-s',
                'border-color-e',
                'border-color-r',
                'border-color-l'
            ],
            'border-color-y': [
                'border-color-bs',
                'border-color-be',
                'border-color-t',
                'border-color-b'
            ],
            translate: [
                'translate-x',
                'translate-y',
                'translate-none'
            ],
            'translate-none': [
                'translate',
                'translate-x',
                'translate-y',
                'translate-z'
            ],
            'scroll-m': [
                'scroll-mx',
                'scroll-my',
                'scroll-ms',
                'scroll-me',
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mr',
                'scroll-mb',
                'scroll-ml'
            ],
            'scroll-mx': [
                'scroll-ms',
                'scroll-me',
                'scroll-mr',
                'scroll-ml'
            ],
            'scroll-my': [
                'scroll-mbs',
                'scroll-mbe',
                'scroll-mt',
                'scroll-mb'
            ],
            'scroll-p': [
                'scroll-px',
                'scroll-py',
                'scroll-ps',
                'scroll-pe',
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pr',
                'scroll-pb',
                'scroll-pl'
            ],
            'scroll-px': [
                'scroll-ps',
                'scroll-pe',
                'scroll-pr',
                'scroll-pl'
            ],
            'scroll-py': [
                'scroll-pbs',
                'scroll-pbe',
                'scroll-pt',
                'scroll-pb'
            ],
            touch: [
                'touch-x',
                'touch-y',
                'touch-pz'
            ],
            'touch-x': [
                'touch'
            ],
            'touch-y': [
                'touch'
            ],
            'touch-pz': [
                'touch'
            ]
        },
        conflictingClassGroupModifiers: {
            'font-size': [
                'leading'
            ]
        },
        postfixLookupClassGroups: [
            'container-type'
        ],
        orderSensitiveModifiers: [
            '*',
            '**',
            'after',
            'backdrop',
            'before',
            'details-content',
            'file',
            'first-letter',
            'first-line',
            'marker',
            'placeholder',
            'selection'
        ]
    };
};
/**
 * @param baseConfig Config where other config will be merged into. This object will be mutated.
 * @param configExtension Partial config to merge into the `baseConfig`.
 */ var $f1e8fdbbd7d56f0d$export$5d86b86a654a7039 = function(baseConfig, param) {
    var cacheSize = param.cacheSize, prefix = param.prefix, experimentalParseClassName = param.experimentalParseClassName, _param_extend = param.extend, extend = _param_extend === void 0 ? {} : _param_extend, _param_override = param.override, override = _param_override === void 0 ? {} : _param_override;
    $f1e8fdbbd7d56f0d$var$overrideProperty(baseConfig, 'cacheSize', cacheSize);
    $f1e8fdbbd7d56f0d$var$overrideProperty(baseConfig, 'prefix', prefix);
    $f1e8fdbbd7d56f0d$var$overrideProperty(baseConfig, 'experimentalParseClassName', experimentalParseClassName);
    $f1e8fdbbd7d56f0d$var$overrideConfigProperties(baseConfig.theme, override.theme);
    $f1e8fdbbd7d56f0d$var$overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    $f1e8fdbbd7d56f0d$var$overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    $f1e8fdbbd7d56f0d$var$overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    $f1e8fdbbd7d56f0d$var$overrideProperty(baseConfig, 'postfixLookupClassGroups', override.postfixLookupClassGroups);
    $f1e8fdbbd7d56f0d$var$overrideProperty(baseConfig, 'orderSensitiveModifiers', override.orderSensitiveModifiers);
    $f1e8fdbbd7d56f0d$var$mergeConfigProperties(baseConfig.theme, extend.theme);
    $f1e8fdbbd7d56f0d$var$mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    $f1e8fdbbd7d56f0d$var$mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    $f1e8fdbbd7d56f0d$var$mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    $f1e8fdbbd7d56f0d$var$mergeArrayProperties(baseConfig, extend, 'postfixLookupClassGroups');
    $f1e8fdbbd7d56f0d$var$mergeArrayProperties(baseConfig, extend, 'orderSensitiveModifiers');
    return baseConfig;
};
var $f1e8fdbbd7d56f0d$var$overrideProperty = function(baseObject, overrideKey, overrideValue) {
    if (overrideValue !== undefined) baseObject[overrideKey] = overrideValue;
};
var $f1e8fdbbd7d56f0d$var$overrideConfigProperties = function(baseObject, overrideObject) {
    if (overrideObject) for(var key in overrideObject)$f1e8fdbbd7d56f0d$var$overrideProperty(baseObject, key, overrideObject[key]);
};
var $f1e8fdbbd7d56f0d$var$mergeConfigProperties = function(baseObject, mergeObject) {
    if (mergeObject) for(var key in mergeObject)$f1e8fdbbd7d56f0d$var$mergeArrayProperties(baseObject, mergeObject, key);
};
var $f1e8fdbbd7d56f0d$var$mergeArrayProperties = function(baseObject, mergeObject, key) {
    var mergeValue = mergeObject[key];
    if (mergeValue !== undefined) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
var $f1e8fdbbd7d56f0d$export$c8d8406b6cd2243e = function(configExtension) {
    for(var _len = arguments.length, createConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        createConfig[_key - 1] = arguments[_key];
    }
    return typeof configExtension === 'function' ? $f1e8fdbbd7d56f0d$export$ea2d4fba4d1bd27f.apply(void 0, [
        $f1e8fdbbd7d56f0d$export$ed30944e0fe6ae5c,
        configExtension
    ].concat((0, $aUGqu._)(createConfig))) : $f1e8fdbbd7d56f0d$export$ea2d4fba4d1bd27f.apply(void 0, [
        function() {
            return $f1e8fdbbd7d56f0d$export$5d86b86a654a7039($f1e8fdbbd7d56f0d$export$ed30944e0fe6ae5c(), configExtension);
        }
    ].concat((0, $aUGqu._)(createConfig)));
};
var $f1e8fdbbd7d56f0d$export$b4660bb6000dfbc9 = /*#__PURE__*/ $f1e8fdbbd7d56f0d$export$ea2d4fba4d1bd27f($f1e8fdbbd7d56f0d$export$ed30944e0fe6ae5c);

});



parcelRegister("7xMzb", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $57e149c1b0ad3db2$export$b3890eb0ae9dca99; });
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
var $6zvdv = parcelRequire("6zvdv");
function $57e149c1b0ad3db2$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $fKAHx.openBlock)(), (0, $fKAHx.createBlock)($setup["Primitive"], {
        as: $props.as,
        "as-child": $props.asChild,
        class: (0, $6zvdv.normalizeClass)($setup.cn($setup.buttonVariants({
            variant: $props.variant,
            size: $props.size
        }), $setup.props.class))
    }, {
        default: (0, $fKAHx.withCtx)(function() {
            return [
                (0, $fKAHx.renderSlot)(_ctx.$slots, "default")
            ];
        }),
        _: 3
    }, 8, [
        "as",
        "as-child",
        "class"
    ]);
}

});

parcelRegister("2d7qy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19c28e8e72ed7de9$export$2e2bcd8739ae039; });
var $19c28e8e72ed7de9$var$NOOP = function() {};
var $19c28e8e72ed7de9$export$2e2bcd8739ae039 = function(script) {};

});



parcelRegister("8kEUo", function(module, exports) {

$parcel$export(module.exports, "createVNodeCache", function () { return (parcelRequire("2HfTm")).createVNodeCache; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("2HfTm")).normalizeClass; });
$parcel$export(module.exports, "normalizeSlot", function () { return (parcelRequire("2HfTm")).normalizeSlot; });
$parcel$export(module.exports, "normalizeSlots", function () { return (parcelRequire("2HfTm")).normalizeSlots; });
$parcel$export(module.exports, "normalizeVNode", function () { return (parcelRequire("2HfTm")).normalizeVNode; });

var $ErPxt = parcelRequire("ErPxt");

var $cnD1A = parcelRequire("cnD1A");

var $lSV2C = parcelRequire("lSV2C");

var $eN6oM = parcelRequire("eN6oM");

var $2HfTm = parcelRequire("2HfTm");
parcelRequire("63vlS");
var $ftLbb = parcelRequire("ftLbb");

});
parcelRegister("ErPxt", function(module, exports) {

$parcel$export(module.exports, "createComponent", function () { return $0799530dc80653ac$export$60e54eaca7e7fb38; });
$parcel$export(module.exports, "createProxyComponent", function () { return $0799530dc80653ac$export$a87d08e0c8a056c5; });
$parcel$export(module.exports, "normalizeNode", function () { return $0799530dc80653ac$export$775064d9a0021ab5; });

var $f9AOD = parcelRequire("f9AOD");

var $aUGqu = parcelRequire("aUGqu");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
var $63vlS = parcelRequire("63vlS");
var $ftLbb = parcelRequire("ftLbb");
//#region src/vapor.ts
/* @__NO_SIDE_EFFECTS__ */ function $0799530dc80653ac$export$8d6d1633f67ec140(comp, extraOptions) {
    if (typeof comp === "function") return Object.assign({
        name: comp.name
    }, extraOptions, {
        setup: function(props, ctx) {
            var result = comp(props, ctx);
            return function() {
                return result;
            };
        },
        __vapor: true
    });
    var setup = comp.setup;
    if (setup) comp.setup = function(props, ctx) {
        var result = setup(props, ctx);
        return function() {
            return result;
        };
    };
    comp.__vapor = true;
    return comp;
}
var $0799530dc80653ac$export$60e54eaca7e7fb38 = function(type) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _Vue;
    if (type === (0, $fKAHx.Fragment)) {
        var slots = args[1];
        return slots ? typeof slots === "function" ? slots() : typeof slots.default === "function" ? slots.default() : [] : [];
    }
    return (_Vue = $63vlS).createComponentWithFallback.apply(_Vue, [
        $0799530dc80653ac$export$a87d08e0c8a056c5($63vlS.resolveDynamicComponent(type))
    ].concat((0, $aUGqu._)(args)));
};
var $0799530dc80653ac$var$proxyCache = /* @__PURE__ */ new WeakMap();
function $0799530dc80653ac$export$a87d08e0c8a056c5(type, normalizeNode) {
    if (typeof type === "function") {
        var existing = $0799530dc80653ac$var$proxyCache.get(type);
        if (existing) return existing;
        var i = $63vlS.currentInstance || (0, $fKAHx.getCurrentInstance)();
        var proxy = new Proxy(type, {
            apply: function(target, ctx, args) {
                if (typeof target.__setup === "function") target.__setup.apply(ctx, args);
                var node = Reflect.apply(target, ctx, args);
                return normalizeNode ? normalizeNode(node) : node;
            },
            get: function(target, p, receiver) {
                if (i && i.appContext.vapor && p === "__vapor") return true;
                return Reflect.get(target, p, receiver);
            }
        });
        $0799530dc80653ac$var$proxyCache.set(type, proxy);
        return proxy;
    }
    return type;
}
function $0799530dc80653ac$export$775064d9a0021ab5(node) {
    if (node == null || typeof node === "boolean") return document.createComment("");
    else if (Array.isArray(node) && node.length) return node.map($0799530dc80653ac$export$775064d9a0021ab5);
    else if ($0799530dc80653ac$export$de5a9e42c1dff8da(node)) return node;
    else if (typeof node === "function") return $0799530dc80653ac$var$resolveValues([
        node
    ], void 0, true)[0];
    else return document.createTextNode(String(node));
}
function $0799530dc80653ac$export$de5a9e42c1dff8da(val) {
    return val instanceof Node || Array.isArray(val) || $63vlS.isVaporComponent(val) || $63vlS.isFragment(val);
}
function $0799530dc80653ac$var$createFragment(nodes) {
    var anchor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.createTextNode("");
    var frag = new $63vlS.VaporFragment(nodes);
    frag.anchor = anchor;
    return frag;
}
function $0799530dc80653ac$var$normalizeBlock(node, anchor) {
    var processFunction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (node instanceof Node || $63vlS.isFragment(node)) return node;
    else if ($63vlS.isVaporComponent(node)) return $0799530dc80653ac$var$createFragment(node, anchor);
    else if (Array.isArray(node)) return $0799530dc80653ac$var$createFragment(node.map(function(i) {
        return $0799530dc80653ac$var$normalizeBlock(i, void 0, processFunction);
    }), anchor);
    else if (processFunction && typeof node === "function") return $0799530dc80653ac$var$resolveValues([
        node
    ], anchor, true)[0];
    else {
        var result = node == null || typeof node === "boolean" ? "" : String(node);
        if (anchor) {
            anchor.textContent = result;
            return anchor;
        } else return document.createTextNode(result);
    }
}
function $0799530dc80653ac$var$resolveValue(current, value, anchor) {
    var processFunction = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    anchor = anchor || (current instanceof Node && current.nodeType === 3 ? current : void 0);
    var node = $0799530dc80653ac$var$normalizeBlock(value, anchor, processFunction);
    if (current) {
        if ($63vlS.isFragment(current)) {
            if (current.anchor && current.anchor.parentNode) {
                $63vlS.remove(current.nodes, current.anchor.parentNode);
                $63vlS.insert(node, current.anchor.parentNode, current.anchor);
                if (!anchor) current.anchor.parentNode.removeChild(current.anchor);
                if (current.scope) current.scope.stop();
            }
        } else if (current instanceof Node) {
            if (current.nodeType === 3 && (!(node instanceof Node) || node.nodeType !== 3)) current.textContent = "";
            if ($63vlS.isFragment(node) && current.parentNode) {
                $63vlS.insert(node, current.parentNode, current);
                if (!anchor || current.nodeType !== 3) current.parentNode.removeChild(current);
            } else if (node instanceof Node) {
                if (current.nodeType === 3 && node.nodeType === 3) {
                    current.textContent = node.textContent;
                    return current;
                } else if (current.parentNode) current.parentNode.replaceChild(node, current);
            }
        }
    }
    return node;
}
function $0799530dc80653ac$var$resolveValues() {
    var values = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], _anchor = arguments.length > 1 ? arguments[1] : void 0, processFunction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var nodes = [];
    var scopes = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $f9AOD._)(_step.value, 2), index = _step_value[0], value = _step_value[1];
            var anchor = index === values.length - 1 ? _anchor : void 0;
            if (typeof value === "function") $63vlS.renderEffect(function() {
                if (scopes[index]) scopes[index].stop();
                scopes[index] = new (0, $ftLbb.EffectScope)();
                nodes[index] = scopes[index].run(function() {
                    return $0799530dc80653ac$var$resolveValue(nodes[index], value(), anchor, processFunction);
                });
            });
            else nodes[index] = $0799530dc80653ac$var$resolveValue(nodes[index], value, anchor, processFunction);
        };
        for(var _iterator = values.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return nodes;
}
function $0799530dc80653ac$export$4d3b7bb67cb076c7(anchor) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    var resolvedValues = $0799530dc80653ac$var$resolveValues(values, anchor);
    if (anchor.parentNode) $63vlS.insert(resolvedValues, anchor.parentNode, anchor);
}
function $0799530dc80653ac$export$953dd193a01bd6ec() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
        values[_key] = arguments[_key];
    }
    return $0799530dc80653ac$var$resolveValues(values);
}
function $0799530dc80653ac$export$6601744ea3d02f7e(slots) {
    if (typeof slots === "function") return {
        name: "default",
        fn: slots
    };
    else if (Object.prototype.toString.call(slots) === "[object Object]" && !$0799530dc80653ac$export$de5a9e42c1dff8da(slots)) return Object.entries(slots).map(function(param) {
        var _param = (0, $f9AOD._)(param, 2), name = _param[0], fn = _param[1];
        return {
            name: name,
            fn: fn
        };
    });
    else return {
        name: "default",
        fn: function() {
            return $0799530dc80653ac$export$953dd193a01bd6ec(slots);
        }
    };
}
/* @__NO_SIDE_EFFECTS__ */ function $0799530dc80653ac$export$bcd4d980d2d74077(comp, extraOptions) {
    if (typeof comp === "function") return Object.assign({
        name: comp.name
    }, extraOptions, {
        setup: comp,
        __vapor: true
    });
    comp.__vapor = true;
    return comp;
}
var $0799530dc80653ac$export$707ab93ec7399045 = /* @__PURE__ */ $0799530dc80653ac$export$bcd4d980d2d74077(function(props, param) {
    var slots = param.slots;
    return $63vlS.createFor(function() {
        return props.in;
    }, function(item, key, index) {
        return slots.default ? slots.default(props.getKey === void 0 ? item.value : item, key, index) : [];
    }, props.getKey === void 0 ? function(item) {
        return item;
    } : props.getKey);
}, {
    props: [
        "in",
        "getKey"
    ]
});

});

parcelRegister("cnD1A", function(module, exports) {

var $7E0eS = parcelRequire("7E0eS");

var $ErPxt = parcelRequire("ErPxt");
parcelRequire("63vlS");
var $51zaq = parcelRequire("51zaq");
//#region src/h.ts
/* @__NO_SIDE_EFFECTS__ */ function $9035e78003cdd779$export$dda1d9f60106f0e9(type, props, children) {
    var _resolveProps = $9035e78003cdd779$var$resolveProps(props), resolvedProps = _resolveProps.props, key = _resolveProps.key, ref = _resolveProps.ref;
    var render = function() {
        var comp = (0, $ErPxt.createComponent)(type, resolvedProps, children ? (typeof children === "undefined" ? "undefined" : (0, $7E0eS._)(children)) === "object" && !Array.isArray(children) ? new Proxy(children, {
            get: function(target, key, receiver) {
                return (0, $ErPxt.createProxyComponent)(Reflect.get(target, key, receiver), (0, $ErPxt.normalizeNode));
            }
        }) : {
            default: typeof children === "function" ? (0, $ErPxt.createProxyComponent)(children, (0, $ErPxt.normalizeNode)) : function() {
                return (0, $ErPxt.normalizeNode)(children);
            }
        } : void 0);
        if (ref) {
            var setRef = $51zaq.createTemplateRefSetter();
            $51zaq.renderEffect(function() {
                return setRef(comp, ref);
            });
        }
        return comp;
    };
    return key ? $51zaq.createKeyedFragment(key, render) : render();
}
var $9035e78003cdd779$var$EVENT_REGEX = /^on[A-Z]/;
function $9035e78003cdd779$var$resolveProps(props) {
    var resolvedProps = {
        props: {}
    };
    if (props) {
        var _loop = function(p) {
            var isFuncton = typeof props[p] === "function";
            if (p === "key") resolvedProps.key = isFuncton ? props[p] : function() {
                return props[p];
            };
            else if (p === "ref") resolvedProps.ref = props[p];
            else if ($9035e78003cdd779$var$EVENT_REGEX.test(p)) resolvedProps.props[p] = function() {
                return props[p];
            };
            else resolvedProps.props[p] = props[p];
        };
        for(var p in props)_loop(p);
        return resolvedProps;
    }
    return resolvedProps;
}

});

parcelRegister("lSV2C", function(module, exports) {

var $1XAnY = parcelRequire("1XAnY");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
//#region src/props.ts
/* @__NO_SIDE_EFFECTS__ */ function $feeae355789f52e6$export$f13e630aa3915748() {
    return $fKAHx.currentInstance || $fKAHx.getCurrentInstance();
}
/**
* Returns the props of the current component instance.
*
* @example
* ```tsx
* import { useProps } from 'vue-jsx-vapor'
*
* defineComponent(({ foo = '' })=>{
*   const props = useProps() // { foo: '' }
* })
* ```
*/ /* @__NO_SIDE_EFFECTS__ */ function $feeae355789f52e6$export$1f264be2c424fccf() {
    return /* @__PURE__ */ $feeae355789f52e6$export$f13e630aa3915748().props;
}
/**
* Returns the merged props and attrs of the current component.\
* Equivalent to `useProps()` + `useAttrs()`.
*
* @example
* ```tsx
* import { useFullProps } from 'vue-jsx-vapor'
*
* defineComponent((props) => {
*   const fullProps = useFullProps() // = useAttrs() + useProps()
* })
*/ /* @__NO_SIDE_EFFECTS__ */ function $feeae355789f52e6$export$d4109d1aaca7f43d() {
    var attrs = (0, $fKAHx.useAttrs)();
    if (!/* @__PURE__ */ $feeae355789f52e6$export$f13e630aa3915748().type.props) return attrs;
    var props = /* @__PURE__ */ $feeae355789f52e6$export$1f264be2c424fccf();
    var fullProps = (0, $fKAHx.computed)(function() {
        return (0, $1XAnY._)({}, props, attrs);
    });
    return new Proxy({}, {
        get: function(_, p, receiver) {
            return Reflect.get(fullProps.value, p, receiver);
        },
        set: function(_, p, v, r) {
            return Reflect.set(fullProps.value, p, v, r);
        },
        deleteProperty: function(_, p) {
            return Reflect.deleteProperty(fullProps.value, p);
        },
        has: function(_, p) {
            return Reflect.has(fullProps.value, p);
        },
        ownKeys: function() {
            return Object.keys(fullProps.value);
        },
        getOwnPropertyDescriptor: function() {
            return {
                enumerable: true,
                configurable: true
            };
        }
    });
}

});

parcelRegister("eN6oM", function(module, exports) {
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
//#region src/ssr.ts
function $ac4a9af48184ab4a$export$6b13f7ca41e206d6(comp, filename) {
    if (typeof comp === "function") comp.__setup = function() {
        var ssrContext = (0, $fKAHx.useSSRContext)();
        (ssrContext.modules || (ssrContext.modules = /* @__PURE__ */ new Set())).add(filename);
    };
    else {
        var setup = comp.setup;
        comp.setup = function(props, ctx) {
            var ssrContext = (0, $fKAHx.useSSRContext)();
            (ssrContext.modules || (ssrContext.modules = /* @__PURE__ */ new Set())).add(filename);
            if (setup) return setup(props, ctx);
        };
    }
}

});

parcelRegister("2HfTm", function(module, exports) {

$parcel$export(module.exports, "createVNodeCache", function () { return $1f6becb80a416e73$export$6f0ea66d4385992f; });
$parcel$export(module.exports, "normalizeVNode", function () { return $1f6becb80a416e73$export$a0e1465ad202d515; });
$parcel$export(module.exports, "normalizeSlot", function () { return $1f6becb80a416e73$export$637957520399b513; });
$parcel$export(module.exports, "normalizeSlots", function () { return $1f6becb80a416e73$export$134da0439a000016; });
$parcel$export(module.exports, "normalizeClass", function () { return $1f6becb80a416e73$export$4f7022d2d68e2c5a; });

var $aUGqu = parcelRequire("aUGqu");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
var $6zvdv = parcelRequire("6zvdv");
//#region src/vdom.ts
var $1f6becb80a416e73$var$cacheMap = /* @__PURE__ */ new WeakMap();
function $1f6becb80a416e73$export$6f0ea66d4385992f(key) {
    var i = (0, $fKAHx.getCurrentInstance)();
    if (i) {
        if (!$1f6becb80a416e73$var$cacheMap.has(i)) $1f6becb80a416e73$var$cacheMap.set(i, {});
        var caches = $1f6becb80a416e73$var$cacheMap.get(i);
        return caches[key] || (caches[key] = []);
    } else return [];
}
function $1f6becb80a416e73$export$a0e1465ad202d515(value) {
    var flag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var create = (0, $fKAHx.createVNode);
    var isBlock = false;
    if (typeof value === "function") {
        isBlock = true;
        (0, $fKAHx.openBlock)();
        create = (0, $fKAHx.createBlock);
        value = value();
    }
    return (0, $fKAHx.isVNode)(value) ? isBlock ? (0, $fKAHx.createBlock)($1f6becb80a416e73$var$cloneIfMounted(value)) : $1f6becb80a416e73$var$cloneIfMounted(value) : Array.isArray(value) ? isBlock ? (0, $fKAHx.createElementBlock)((0, $fKAHx.Fragment), null, value.map(function(n) {
        return $1f6becb80a416e73$export$a0e1465ad202d515(function() {
            return n;
        });
    }), -2) : (0, $fKAHx.createElementVNode)((0, $fKAHx.Fragment), null, value.slice()) : value == null || typeof value === "boolean" ? create((0, $fKAHx.Comment)) : create((0, $fKAHx.Text), null, String(value), flag);
}
function $1f6becb80a416e73$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : (0, $fKAHx.cloneVNode)(child);
}
var $1f6becb80a416e73$var$normalizeSlotValue = function(value) {
    return Array.isArray(value) ? value.map(function(n) {
        return $1f6becb80a416e73$export$a0e1465ad202d515(n);
    }) : [
        $1f6becb80a416e73$export$a0e1465ad202d515(value)
    ];
};
var $1f6becb80a416e73$export$637957520399b513 = function(rawSlot) {
    if (rawSlot._n) return rawSlot;
    return (0, $fKAHx.withCtx)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $1f6becb80a416e73$var$normalizeSlotValue(rawSlot.apply(void 0, (0, $aUGqu._)(args)));
    });
};
var $1f6becb80a416e73$export$134da0439a000016 = function(slots) {
    return typeof slots === "function" || Object.prototype.toString.call(slots) === "[object Object]" && !(0, $fKAHx.isVNode)(slots) ? slots : {
        default: (0, $fKAHx.withCtx)(function() {
            return [
                $1f6becb80a416e73$export$a0e1465ad202d515(function() {
                    return slots;
                })
            ];
        })
    };
};
var $1f6becb80a416e73$export$4f7022d2d68e2c5a = function(value) {
    return (0, $6zvdv.normalizeClass)(value) || null;
};
var $1f6becb80a416e73$export$afa64b67e5a01c3b = (0, $fKAHx.defineComponent);
var $1f6becb80a416e73$export$bdf530073099ce9f = $1f6becb80a416e73$export$afa64b67e5a01c3b(function(props, param) {
    var slots = param.slots;
    var defaultSlot = slots.default;
    return function() {
        return (0, $fKAHx.openBlock)(true), (0, $fKAHx.createElementBlock)((0, $fKAHx.Fragment), null, (0, $fKAHx.renderList)(props.in, function(item, key, index) {
            var result = defaultSlot(item, key, index);
            return Array.isArray(result) ? result.length === 1 ? result[0] : $1f6becb80a416e73$export$a0e1465ad202d515(result) : result;
        }), 128);
    };
}, {
    props: [
        "in"
    ]
});

});


parcelRegister("414kS", function(module, exports) {

module.exports = (parcelRequire("e8PZf"))($parcel$resolve("gVDiD")).then(function() {
    return parcelRequire('kR79P');
});

});
parcelRegister("e8PZf", function(module, exports) {
"use strict";

var $2whz5 = parcelRequire("2whz5");
module.exports = $2whz5(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("2whz5", function(module, exports) {
"use strict";
var $1d5c31fa25ebdcba$var$cachedBundles = {};
var $1d5c31fa25ebdcba$var$cachedPreloads = {};
var $1d5c31fa25ebdcba$var$cachedPrefetches = {};
function $1d5c31fa25ebdcba$var$getCache(type) {
    switch(type){
        case 'preload':
            return $1d5c31fa25ebdcba$var$cachedPreloads;
        case 'prefetch':
            return $1d5c31fa25ebdcba$var$cachedPrefetches;
        default:
            return $1d5c31fa25ebdcba$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $1d5c31fa25ebdcba$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("iBKDt", function(module, exports) {

module.exports = (parcelRequire("e8PZf"))($parcel$resolve("jGy8B")).then(function() {
    return parcelRequire('3cA16');
});

});

parcelRegister("2MILA", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("kVT6Z"))($parcel$resolve("lhIDm")),
    (parcelRequire("e8PZf"))($parcel$resolve("7DzzU")),
    (parcelRequire("e8PZf"))($parcel$resolve("1zGnJ")),
    (parcelRequire("e8PZf"))($parcel$resolve("2P9ZM"))
]).then(function() {
    return parcelRequire('4dIgv');
});

});
parcelRegister("kVT6Z", function(module, exports) {
"use strict";

var $2whz5 = parcelRequire("2whz5");
module.exports = $2whz5(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});


parcelRegister("j1QOD", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("e8PZf"))($parcel$resolve("7DzzU")),
    (parcelRequire("e8PZf"))($parcel$resolve("6D6XJ"))
]).then(function() {
    return parcelRequire('c7X0C');
});

});

parcelRegister("7BWFj", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("e8PZf"))($parcel$resolve("7DzzU")),
    (parcelRequire("e8PZf"))($parcel$resolve("1zGnJ")),
    (parcelRequire("e8PZf"))($parcel$resolve("e1MXL"))
]).then(function() {
    return parcelRequire('1ErsN');
});

});

var $51ba8f5259420664$exports = {};
$parcel$extendImportMap({
    "lL72A": "logo.a72d69c2.png",
    "gVDiD": "ClassDecorator.e2a54fca.js",
    "jGy8B": "FunctionDecorator.84023df8.js",
    "2P9ZM": "Component.49fbe063.js",
    "1zGnJ": "Component.a6c3b719.js",
    "5qKZE": "memory.8e73eb49.js",
    "8cJhl": "sandbox.08edaebe.js",
    "fshZK": "downloader.19b48d2e.js",
    "7DzzU": "Component.4534ecce.js",
    "lhIDm": "Component.966a810f.css",
    "6D6XJ": "Chart.e6a3bdc7.js",
    "e1MXL": "About.990b64c8.js"
});

var $3959ba5a3cb8c567$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $3959ba5a3cb8c567$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $3959ba5a3cb8c567$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $3959ba5a3cb8c567$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $3959ba5a3cb8c567$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $3959ba5a3cb8c567$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype;
    return promise;
};
$3959ba5a3cb8c567$var$InstrumentedPromise$1.__proto__ = $3959ba5a3cb8c567$var$OriginalPromise;
$3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype.__proto__ = $3959ba5a3cb8c567$var$OriginalPromise.prototype;
$3959ba5a3cb8c567$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $3959ba5a3cb8c567$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $3959ba5a3cb8c567$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $3959ba5a3cb8c567$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $3959ba5a3cb8c567$export$cea1c58a6db52bca() {
    Promise = $3959ba5a3cb8c567$var$InstrumentedPromise$1;
}
function $3959ba5a3cb8c567$export$dfb5619354ba860() {
    if ($3959ba5a3cb8c567$export$baf72085f5fb4df()) $3959ba5a3cb8c567$export$cea1c58a6db52bca();
}
var $3959ba5a3cb8c567$export$2e2bcd8739ae039 = $3959ba5a3cb8c567$var$InstrumentedPromise$1;



var $gtaQ6 = parcelRequire("gtaQ6");
parcelRequire("63vlS");
var $3ewO8 = parcelRequire("3ewO8");

var $h2kUE = parcelRequire("h2kUE");
var $cf16d8b2142c1e73$var$script;



var $cf16d8b2142c1e73$var$initialize = function() {
    $cf16d8b2142c1e73$var$script = {};
    $cf16d8b2142c1e73$var$script.render = (parcelRequire("2LnxQ")).render;
    $cf16d8b2142c1e73$var$script.__cssModules = {};
    (parcelRequire("b6j9v")).default($cf16d8b2142c1e73$var$script);
    $cf16d8b2142c1e73$var$script.__scopeId = 'data-v-20a8a5';
    $cf16d8b2142c1e73$var$script.__file = "App.vue";
};
$cf16d8b2142c1e73$var$initialize();
var $cf16d8b2142c1e73$export$2e2bcd8739ae039 = $cf16d8b2142c1e73$var$script;


/*!
* vue-router v5.3.1
* (c) 2026 Eduardo San Martin Morote
* @license MIT
*/ 
var $7Pjls = parcelRequire("7Pjls");

var $f9AOD = parcelRequire("f9AOD");

var $7E0eS = parcelRequire("7E0eS");
/*!
* vue-router v5.3.1
* (c) 2026 Eduardo San Martin Morote
* @license MIT
*/ 
var $7E0eS = parcelRequire("7E0eS");
/*!
* vue-router v5.3.1
* (c) 2026 Eduardo San Martin Morote
* @license MIT
*/ 
var $7Pjls = parcelRequire("7Pjls");

var $7E0eS = parcelRequire("7E0eS");
//#region src/formatters/plain.ts
/**
* Renders a diagnostic into a multi-line, unicode-decorated string suitable
* for terminal output. The first line is `[<name>] <message>`; optional
* details (`fix`, `sources`, `docs`) follow with `├▶`/`╰▶` connectors.
*/ 
var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $hdIku = parcelRequire("hdIku");

var $aUGqu = parcelRequire("aUGqu");

var $1SdK7 = parcelRequire("1SdK7");
function $867abde8d958eafe$export$332cab4fc85226b5(diagnostic) {
    var _diagnostic_sources;
    var header = "[".concat(diagnostic.name, "] ").concat(diagnostic.message);
    var details = [];
    if (diagnostic.fix) details.push("fix: ".concat(diagnostic.fix));
    if ((_diagnostic_sources = diagnostic.sources) === null || _diagnostic_sources === void 0 ? void 0 : _diagnostic_sources.length) details.push("sources: ".concat(diagnostic.sources.join(", ")));
    if (diagnostic.docs) details.push("see: ".concat(diagnostic.docs));
    if (details.length === 0) return header;
    return [
        header
    ].concat((0, $aUGqu._)(details.map(function(detail, i) {
        return "".concat(i < details.length - 1 ? "\u251C\u25B6" : "\u2570\u25B6", " ").concat(detail);
    }))).join("\n");
}
//#endregion
//#region src/utils.ts
/**
* Transforms a value or a function that returns a value to a value.
*
* @param valFn either a value or a function that returns a value
* @param args  arguments to pass to the function if `valFn` is a function
*
* @internal
*/ function $867abde8d958eafe$var$toValueWithArgs(valFn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return typeof valFn === "function" ? valFn.apply(void 0, (0, $aUGqu._)(args)) : valFn;
}
//#endregion
//#region src/diagnostic.ts
/**
* Creates a console reporter that renders each diagnostic with `formatter` and
* prints the result via `console[method]`. Both default sensibly (`'warn'` and
* {@link formatDiagnostic}); `method` can also be overridden per call through
* the reporter options.
*/ /* @__NO_SIDE_EFFECTS__ */ function $867abde8d958eafe$export$28961117abab257d() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.method, defaultMethod = tmp === void 0 ? "warn" : tmp, _ref_formatter = _ref.formatter, formatter = _ref_formatter === void 0 ? $867abde8d958eafe$export$332cab4fc85226b5 : _ref_formatter;
    return function(diagnostic) {
        var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_method = _ref.method, method = _ref_method === void 0 ? defaultMethod : _ref_method;
        console[method](formatter(diagnostic));
    };
}
var $867abde8d958eafe$var$captureStackTrace = Error.captureStackTrace;
var $867abde8d958eafe$export$d3ee506da1643804 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $hdIku._)(Diagnostic, Error1);
    function Diagnostic(init) {
        var captureFrom = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Diagnostic;
        (0, $173N4._)(this, Diagnostic);
        var _this;
        _this = (0, $7qXGD._)(this, Diagnostic, [
            init.why,
            {
                cause: init.cause
            }
        ]), (0, $7Pjls._)(_this, "name", void 0), /**
	* The diagnostic code, e.g. `MATH_E001`.
	* Also appears as the `name` property.
	*/ (0, $7Pjls._)(_this, "code", void 0), /**
	* URL to extended documentation for this diagnostic code.
	* Auto-generated from {@link DefineDiagnosticsOptions.docsBase}.
	*/ (0, $7Pjls._)(_this, "docs", void 0), /**
	* Optional actionable instructions on how to resolve the problem.
	*/ (0, $7Pjls._)(_this, "fix", void 0), /**
	* Locations in user code that contributed to this diagnostic, in
	* `file:line:column` format. Relevant when the stack trace doesn't reflect
	* the user's source (e.g. compilers, bundlers), otherwise redundant with the
	* stack and should be omitted.
	*/ (0, $7Pjls._)(_this, "sources", void 0);
        _this.code = _this.name = init.code;
        _this.fix = init.fix;
        _this.docs = init.docs;
        _this.sources = init.sources;
        $867abde8d958eafe$var$captureStackTrace === null || $867abde8d958eafe$var$captureStackTrace === void 0 ? void 0 : $867abde8d958eafe$var$captureStackTrace(_this, captureFrom);
        return _this;
    }
    (0, $cFHGC._)(Diagnostic, [
        {
            key: "why",
            get: /**
	* Alias for {@link Error.message}: the reason this diagnostic was raised.
	*/ function get() {
                return this.message;
            }
        },
        {
            /**
	* Converts the diagnostic into a serializable structured object.
	*/ key: "toJSON",
            value: function toJSON() {
                return {
                    name: this.name,
                    why: this.why,
                    fix: this.fix,
                    docs: this.docs,
                    sources: this.sources,
                    cause: this.cause,
                    stack: this.stack
                };
            }
        }
    ]);
    return Diagnostic;
}((0, $1SdK7._)(Error));
/**
* Resolves the docs URL for a code from a `docsBase` (string template or
* resolver function). Shared by {@link defineDiagnostics} and
* {@link defineProdDiagnostics}. Per-code `docs` overrides are handled by the
* caller; this only covers the `docsBase`-derived case.
*
* @internal
*/ function $867abde8d958eafe$var$deriveDocs(docsBase, code) {
    return typeof docsBase === "string" ? "".concat(docsBase, "/").concat(code.toLowerCase()) : docsBase === null || docsBase === void 0 ? void 0 : docsBase(code);
}
/**
* Creates a typed diagnostics object from a set of code definitions. Each
* code becomes a callable {@link DiagnosticHandle}: invoke to report, or
* `throw` the result to raise. No `new` required, no proxy.
*/ /* @__NO_SIDE_EFFECTS__ */ function $867abde8d958eafe$export$1656dc1696afae07(options) {
    var _options_reporters;
    var reporters = (_options_reporters = options.reporters) !== null && _options_reporters !== void 0 ? _options_reporters : [];
    var result = {};
    var docsBase = options.docsBase;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var code = _step.value;
            var def = options.codes[code];
            var docs = def.docs === false ? void 0 : def.docs || $867abde8d958eafe$var$deriveDocs(docsBase, code);
            var handle = function() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, reporterOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var diagnostic = new $867abde8d958eafe$export$d3ee506da1643804({
                    code: code,
                    why: $867abde8d958eafe$var$toValueWithArgs(def.why, params),
                    fix: $867abde8d958eafe$var$toValueWithArgs(def.fix, params),
                    docs: docs,
                    cause: params.cause,
                    sources: params.sources
                }, handle);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = reporters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var reporter = _step.value;
                        reporter(diagnostic, reporterOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return diagnostic;
            };
            result[code] = handle;
        };
        for(var _iterator = Object.keys(options.codes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
//#endregion
//#region src/prod-diagnostics.ts
/**
* Production counterpart to {@link defineDiagnostics}. Returns a `Proxy` that
* builds a minimal {@link Diagnostic} for any accessed code: the code becomes
* the instance `name`, `docs` is derived from `docsBase`, and `why` points to
* the docs URL when one exists (empty otherwise, so the thrown header is just
* the code). It carries no catalog text, so it stays tiny in a bundle.
*
* The strip plugin (`@nostics/unplugin`) can rewrite a `defineDiagnostics()`
* call into a `process.env.NODE_ENV === 'production'` ternary that selects this
* factory in production, dropping every `why`/`fix` string from the bundle.
*
* @example
* ```ts
* const diagnostics = defineProdDiagnostics({ docsBase: 'https://docs.example.com' })
* throw diagnostics.NUXT_B2011() // NUXT_B2011: https://docs.example.com/nuxt_b2011
* ```
*/ /* @__NO_SIDE_EFFECTS__ */ function $867abde8d958eafe$export$5deacc2d4b351bec() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var docsBase = options.docsBase, _options_reporters = options.reporters, reporters = _options_reporters === void 0 ? [] : _options_reporters;
    return new Proxy({}, {
        get: function(_target, code) {
            if (typeof code !== "string") return void 0;
            var handle = function() {
                var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, reporterOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var docs = $867abde8d958eafe$var$deriveDocs(docsBase, code);
                var diagnostic = new $867abde8d958eafe$export$d3ee506da1643804({
                    code: code,
                    why: docs !== null && docs !== void 0 ? docs : "",
                    docs: docs,
                    cause: params.cause,
                    sources: params.sources
                }, handle);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = reporters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var reporter = _step.value;
                        reporter(diagnostic, reporterOptions);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return diagnostic;
            };
            return handle;
        }
    });
}


parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ var $629d80bbf56b9c6a$export$953cecd6e717a553 = function(v) {
    return v;
};
/**
* Checks if a path is absolute, meaning it starts with a `/`.
*
* @param path - path to check
*
* @internal
*/ var $629d80bbf56b9c6a$export$dda1d9f60106f0e9 = function(path) {
    return path.startsWith("/");
};
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $629d80bbf56b9c6a$export$90a7f3efeed30595(component) {
    return (typeof component === "undefined" ? "undefined" : (0, $7E0eS._)(component)) === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $629d80bbf56b9c6a$export$71511d61b312f219(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $629d80bbf56b9c6a$export$90a7f3efeed30595(obj.default);
}
var $629d80bbf56b9c6a$export$ffb5f4729a158638 = Object.assign;
function $629d80bbf56b9c6a$export$2d1720544b23b823(fn, params) {
    var newParams = {};
    for(var key in params){
        var value = params[key];
        newParams[key] = $629d80bbf56b9c6a$export$39b482c5e57630a8(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
var $629d80bbf56b9c6a$export$8b22cf2602fb60ce = function() {};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ var $629d80bbf56b9c6a$export$39b482c5e57630a8 = Array.isArray;
function $629d80bbf56b9c6a$export$4a5767248b18ef41(defaults, partialOptions) {
    var options = {};
    for(var key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/errors.ts
var $629d80bbf56b9c6a$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ var $629d80bbf56b9c6a$export$882b5998b3b9117c = /* @__PURE__ */ function(NavigationFailureType) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType[NavigationFailureType["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType[NavigationFailureType["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType[NavigationFailureType["duplicated"] = 16] = "duplicated";
    return NavigationFailureType;
}({});
var $629d80bbf56b9c6a$var$_obj;
var $629d80bbf56b9c6a$var$ErrorTypeMessages = ($629d80bbf56b9c6a$var$_obj = {}, (0, $7Pjls._)($629d80bbf56b9c6a$var$_obj, 1, function(param) {
    var location = param.location, currentLocation = param.currentLocation;
    return "No match for\n ".concat(JSON.stringify(location)).concat(currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : "");
}), (0, $7Pjls._)($629d80bbf56b9c6a$var$_obj, 2, function(param) {
    var from = param.from, to = param.to;
    return 'Redirected from "'.concat(from.fullPath, '" to "').concat($629d80bbf56b9c6a$var$stringifyRoute(to), '" via a navigation guard.');
}), (0, $7Pjls._)($629d80bbf56b9c6a$var$_obj, 4, function(param) {
    var from = param.from, to = param.to;
    return 'Navigation aborted from "'.concat(from.fullPath, '" to "').concat(to.fullPath, '" via a navigation guard.');
}), (0, $7Pjls._)($629d80bbf56b9c6a$var$_obj, 8, function(param) {
    var from = param.from, to = param.to;
    return 'Navigation cancelled from "'.concat(from.fullPath, '" to "').concat(to.fullPath, '" with a new navigation.');
}), (0, $7Pjls._)($629d80bbf56b9c6a$var$_obj, 16, function(param) {
    var from = param.from, _to = param.to;
    return 'Avoided redundant navigation to current location: "'.concat(from.fullPath, '".');
}), $629d80bbf56b9c6a$var$_obj);
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $629d80bbf56b9c6a$export$3b14a55fb2447963(type, params) {
    return $629d80bbf56b9c6a$export$ffb5f4729a158638(/* @__PURE__ */ new Error(), (0, $7Pjls._)({
        type: type
    }, $629d80bbf56b9c6a$var$NavigationFailureSymbol, true), params);
}
function $629d80bbf56b9c6a$export$4368d992c4eafac0(error, type) {
    return error instanceof Error && $629d80bbf56b9c6a$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
var $629d80bbf56b9c6a$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
/**
* Stringifies a raw location for display in dev warnings.
*
* @internal
*/ function $629d80bbf56b9c6a$var$stringifyRoute(to) {
    if (!to || typeof to === "string") return to;
    if (to.path != null) return to.path;
    var location = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $629d80bbf56b9c6a$var$propertiesToLog[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key in to) location[key] = to[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/diagnostics.ts
/**
* Runtime diagnostics catalog for Vue Router.
*
* Every entry has a stable `VUE_ROUTER_R####` code, a `why` that states the problem
* (the diagnosis only, never the remedy) and a `fix` that states the remedy
* (only, never the diagnosis). They are complementary: the reporter prints
* both, so neither repeats the other. The diagnosis substrings asserted by the
* warning tests stay in `why`. All call sites stay behind the existing `__DEV__` (or
* `process.env.NODE_ENV !== 'production'`) guards and remain bare expression
* statements so they tree-shake out of production builds.
*
* Codes are permanent: never rename or reuse one.
* - `VUE_ROUTER_R0###` core runtime warnings
* - `VUE_ROUTER_R1###` experimental data-loaders
*/ var $629d80bbf56b9c6a$export$db3b6bfb95261072 = /*#__PURE__*/ (0, $867abde8d958eafe$export$1656dc1696afae07)({
    reporters: [
        /*#__PURE__*/ (0, $867abde8d958eafe$export$28961117abab257d)()
    ],
    codes: {
        VUE_ROUTER_R0001: {
            why: function(p) {
                return 'Parent route "'.concat(p.name, '" not found when adding child route');
            },
            fix: "Add the parent route before its children, or check the parent name for typos.",
            docs: "https://router.vuejs.org/guide/advanced/dynamic-routing.html#Adding-nested-routes"
        },
        VUE_ROUTER_R0002: {
            why: function(p) {
                return 'Cannot remove non-existent route "'.concat(p.name, '"');
            },
            fix: "Check the route name; it may already have been removed or was never added.",
            docs: "https://router.vuejs.org/guide/advanced/dynamic-routing.html#Removing-routes"
        },
        VUE_ROUTER_R0003: {
            why: function(p) {
                return 'Location "'.concat($629d80bbf56b9c6a$var$stringifyRoute(p.location), '" resolved to "').concat(p.href, '". A resolved location cannot start with multiple slashes.');
            },
            fix: "Remove the leading slashes from the location or fix the route configuration."
        },
        VUE_ROUTER_R0004: {
            why: function(p) {
                return 'No match found for location with path "'.concat($629d80bbf56b9c6a$var$stringifyRoute(p.path), '"');
            },
            fix: "Add a route matching this path or check for typos in the location.",
            docs: "https://router.vuejs.org/guide/essentials/dynamic-matching.html#Catch-all-404-Not-found-Route"
        },
        VUE_ROUTER_R0005: {
            why: function(p) {
                return "router.resolve() was passed an invalid location. This will fail in production.\nLocation: ".concat($629d80bbf56b9c6a$var$stringifyRoute(p.rawLocation));
            },
            fix: "Pass a valid route location: a string path or an object with `path` or `name`."
        },
        VUE_ROUTER_R0006: {
            why: function(p) {
                return 'Path "'.concat(p.path, '" was passed with params but they will be ignored because a "path" was passed.');
            },
            fix: "Use a named route `{ name, params }` instead of `{ path, params }`.",
            docs: "https://router.vuejs.org/guide/essentials/navigation.html#Navigate-to-a-different-location"
        },
        VUE_ROUTER_R0007: {
            why: function(p) {
                return 'A `hash` should always start with the character "#" but received "'.concat(p.hash, '".');
            },
            fix: function(p) {
                return 'Prepend "#" to the hash in your route location: use "#'.concat(p.hash, '".');
            }
        },
        VUE_ROUTER_R0008: {
            why: function(p) {
                return "Invalid redirect found:\n".concat(p.target, '\n when navigating to "').concat(p.to, '".\nThis will break in production.');
            },
            fix: "A redirect must resolve to a location with a `name` or `path`; return one of those (or a string path) from `redirect`.",
            docs: "https://router.vuejs.org/guide/essentials/redirect-and-alias.html#Redirect"
        },
        VUE_ROUTER_R0009: {
            why: function(p) {
                return 'Detected a possibly infinite redirection in a navigation guard when going from "'.concat(p.from, '" to "').concat(p.to, '". Aborting to avoid a Stack Overflow. This might break in production if not fixed.');
            },
            fix: "A guard is returning a new location on every call; make that return conditional so it only redirects when actually needed.",
            docs: "https://router.vuejs.org/guide/advanced/navigation-guards.html#Global-Before-Guards"
        },
        VUE_ROUTER_R0010: {
            why: "Uncaught error during route navigation",
            fix: "Register an error handler with `router.onError()` to handle navigation errors."
        },
        VUE_ROUTER_R0011: {
            why: "Unexpected error when starting the router:",
            fix: "Inspect the actual cause; a navigation guard or async component likely threw during the initial navigation."
        },
        VUE_ROUTER_R0020: {
            why: function(p) {
                return "No active route record was found when calling `".concat(p.fn, "()`. Maybe you called it inside of App.vue?");
            },
            fix: "Call it from a component rendered inside <router-view> (a page component or one of its children), not from App.vue.",
            docs: "https://router.vuejs.org/guide/advanced/composition-api.html#Navigation-Guards"
        },
        VUE_ROUTER_R0021: {
            why: "No active route record was found when reactivating component with navigation guard. This is likely a bug in vue-router.",
            fix: "Report with a minimal reproduction at https://github.com/vuejs/router/issues/new/choose."
        },
        VUE_ROUTER_R0022: {
            why: function(p) {
                return "".concat(p.fn, "() was called outside of component setup but it must be called at the top of a setup function");
            },
            fix: "Call it synchronously at the top of `setup()`, before any `await`.",
            docs: "https://router.vuejs.org/guide/advanced/composition-api.html#Navigation-Guards"
        },
        VUE_ROUTER_R0023: {
            why: function(p) {
                return 'The "next" callback was never called inside of '.concat(p.name ? '"'.concat(p.name, '"') : "", ":\n").concat(p.guard);
            },
            fix: "Make sure `next()` runs on every branch, including early returns and async paths, or drop the `next` parameter and return the value instead.",
            docs: "https://router.vuejs.org/guide/advanced/navigation-guards.html#Optional-third-argument-next"
        },
        VUE_ROUTER_R0024: {
            why: function(p) {
                return 'The "next" callback was called more than once in one navigation guard when going from "'.concat(p.from, '" to "').concat(p.to, '". This will fail in production.');
            },
            fix: "Call `next()` exactly once per guard: remove the extra call, or migrate to returning the value you passed to `next()`.",
            docs: "https://router.vuejs.org/guide/advanced/navigation-guards.html#Optional-third-argument-next"
        },
        VUE_ROUTER_R0025: {
            why: "The `next()` callback in navigation guards is deprecated.",
            fix: "Return the value instead: `next()` becomes `return`, `next(false)` becomes `return false`, `next(\"/path\")` becomes `return \"/path\"`.",
            docs: "https://router.vuejs.org/guide/advanced/navigation-guards.html#Optional-third-argument-next"
        },
        VUE_ROUTER_R0026: {
            why: function(p) {
                return 'Record with path "'.concat(p.path, '" is either missing a "component(s)" or "children" property.');
            },
            fix: "Add a `component`, `components`, or `children` to the route record.",
            docs: "https://router.vuejs.org/guide/essentials/nested-routes.html"
        },
        VUE_ROUTER_R0027: {
            why: function(p) {
                return 'Component "'.concat(p.name, '" in record with path "').concat(p.path, '" is not a valid component. Received "').concat(p.received, '".');
            },
            fix: "Pass a component or a function returning a Promise that resolves to one."
        },
        VUE_ROUTER_R0028: {
            why: function(p) {
                return 'Component "'.concat(p.name, '" in record with path "').concat(p.path, '" is a Promise instead of a function that returns a Promise. This will break in production if not fixed.');
            },
            fix: "Defer the import in an arrow function so it loads lazily: write \"() => import('./MyPage.vue')\", not \"import('./MyPage.vue')\".",
            docs: "https://router.vuejs.org/guide/advanced/lazy-loading.html"
        },
        VUE_ROUTER_R0029: {
            why: function(p) {
                return 'Component "'.concat(p.name, '" in record with path "').concat(p.path, '" is defined using "defineAsyncComponent()".');
            },
            fix: "Drop the wrapper and pass \"() => import('./MyPage.vue')\" directly; the router handles lazy components itself.",
            docs: "https://router.vuejs.org/guide/advanced/lazy-loading.html#Relationship-to-async-components"
        },
        VUE_ROUTER_R0030: {
            why: function(p) {
                return 'Component "'.concat(p.name, '" in record with path "').concat(p.path, '" is a function that does not return a Promise. This will break in production if not fixed.');
            },
            fix: "Return a dynamic import (`() => import(\"./MyPage.vue\")`) from the function, or add a `displayName` if it is a functional component.",
            docs: "https://router.vuejs.org/guide/advanced/lazy-loading.html"
        },
        VUE_ROUTER_R0040: {
            why: function(p) {
                return 'Because "'.concat(p.el, '" starts with "#", scrollBehavior resolves it as an element id via document.getElementById("').concat(p.el.slice(1), '"), not as a CSS selector. No element has that id, but "').concat(p.el, '" does match an element with document.querySelector().');
            },
            fix: function(p) {
                return "Resolve the element yourself and return the node: el: document.querySelector('".concat(p.el, "').");
            },
            docs: "https://router.vuejs.org/guide/advanced/scroll-behavior.html"
        },
        VUE_ROUTER_R0041: {
            why: function(p) {
                return 'The selector "'.concat(p.el, '" is invalid. See https://mathiasbynens.be/notes/css-escapes or CSS.escape (https://developer.mozilla.org/en-US/docs/Web/API/CSS/escape) for the escaping rules.');
            },
            fix: "Build an id selector as `#${CSS.escape(id)}` so special characters in the id are escaped.",
            docs: "https://router.vuejs.org/guide/advanced/scroll-behavior.html"
        },
        VUE_ROUTER_R0042: {
            why: function(p) {
                return "Couldn't find element using selector \"".concat(p.el, '" returned by scrollBehavior.');
            },
            fix: "Return a selector that matches an existing element, or guard against missing elements.",
            docs: "https://router.vuejs.org/guide/advanced/scroll-behavior.html"
        },
        VUE_ROUTER_R0050: {
            why: function(p) {
                var to;
                try {
                    to = p.to === void 0 ? "undefined" : JSON.stringify(p.to);
                } catch (e) {
                    to = String(p.to);
                }
                return 'Invalid value for prop "to" in useLink()\n- to: '.concat(to);
            },
            fix: "Pass a valid route location (a string path or an object) to the \"to\" prop."
        },
        VUE_ROUTER_R0060: {
            why: function(p) {
                return "<router-view> can no longer be used directly inside <".concat(p.comp, ">.");
            },
            fix: function(p) {
                return "Wrap the slot's resolved component with <".concat(p.comp, '> instead of nesting <router-view> in it:\n\n<router-view v-slot="{ Component }">\n  <').concat(p.comp, '>\n    <component :is="Component" />\n  </').concat(p.comp, ">\n</router-view>");
            },
            docs: "https://router.vuejs.org/guide/advanced/router-view-slot.html#KeepAlive-Transition"
        },
        VUE_ROUTER_R0070: {
            why: function(p) {
                return 'Cannot resolve a relative location without an absolute path. Trying to resolve "'.concat(p.to, '" from "').concat(p.from, '".');
            },
            fix: function(p) {
                return 'Resolve from an absolute `from` path that starts with "/", e.g. "/'.concat(p.from, '".');
            }
        },
        VUE_ROUTER_R0080: {
            why: function(p) {
                return 'Error decoding "'.concat(p.text, '". Using original value');
            },
            fix: "Ensure the value is correctly percent-encoded."
        },
        VUE_ROUTER_R0090: {
            why: function(p) {
                return 'Found duplicated params with name "'.concat(p.name, '" for path "').concat(p.path, '". Only the last one will be available on "$route.params".');
            },
            fix: "Give each param a unique name within the path.",
            docs: "https://router.vuejs.org/guide/essentials/route-matching-syntax.html"
        },
        VUE_ROUTER_R0100: {
            why: function(p) {
                return 'Discarded invalid param(s) "'.concat(p.params, '" when navigating.') + p.inherited + " See https://github.com/vuejs/router/commit/e887570 for more details.";
            },
            fix: "Only pass params that exist on the target route."
        },
        VUE_ROUTER_R0101: {
            why: function(p) {
                return 'The Matcher cannot resolve relative paths but received "'.concat(p.path, '". Unless you directly called `matcher.resolve("').concat(p.path, '")`, this is probably a bug in vue-router. Please open an issue at https://github.com/vuejs/router/issues/new/choose.');
            },
            fix: "Pass an absolute path (starting with \"/\") to the matcher."
        },
        VUE_ROUTER_R0102: {
            why: function(p) {
                return 'Alias "'.concat(p.alias, '" and the original record: "').concat(p.original, '" must have the exact same param named "').concat(p.name, '"');
            },
            fix: "Use the same param names in the alias as in the original route.",
            docs: "https://router.vuejs.org/guide/essentials/redirect-and-alias.html#Alias"
        },
        VUE_ROUTER_R0103: {
            why: function(p) {
                return 'The route named "'.concat(p.name, "\" has a child without a name, an empty path, and no children. Using that name won't render the empty path child, so this is probably a mistake.");
            },
            fix: "Move the `name` onto the empty-path child; or, if intentional, give the child its own name to silence this.",
            docs: "https://router.vuejs.org/guide/essentials/nested-routes.html#Nested-Named-Routes"
        },
        VUE_ROUTER_R0104: {
            why: function(p) {
                return 'Absolute path "'.concat(p.path, '" must have the exact same param named "').concat(p.name, '" as its parent "').concat(p.parent, '".');
            },
            fix: "Include the parent route params in the absolute child path.",
            docs: "https://router.vuejs.org/guide/essentials/nested-routes.html"
        },
        VUE_ROUTER_R0105: {
            why: function(p) {
                return 'Finding ancestor route "'.concat(p.ancestor, '" failed for "').concat(p.record, '"');
            },
            fix: "Report a reproduction at https://github.com/vuejs/router/issues/new/choose."
        },
        VUE_ROUTER_R0110: {
            why: 'A hash base must end with a "#"',
            fix: function(p) {
                return 'Append "#" to the "base" argument passed to "createWebHashHistory()": "'.concat(p.base, '" should be "').concat(p.suggestion, '".');
            }
        },
        VUE_ROUTER_R0120: {
            why: "Error with push/replace State",
            fix: "The browser rejected the history API call; check for cross-origin or rate-limit issues."
        },
        VUE_ROUTER_R0121: {
            why: "history.state seems to have been manually replaced without preserving the necessary values.\nYou can find more information at https://router.vuejs.org/guide/migration/#Usage-of-history-state",
            fix: "Merge the router's state into your own when calling it manually: `history.replaceState({ ...history.state, ...yourState }, '', url)`.",
            docs: "https://router.vuejs.org/guide/migration.html#Usage-of-history-state"
        },
        VUE_ROUTER_R1001: {
            why: function(p) {
                return 'Data loader "'.concat(String(p.key), "\" has a different parent than the current context. This shouldn't be happening.");
            },
            fix: "Report a bug with a minimal reproduction at https://github.com/vuejs/router/."
        },
        VUE_ROUTER_R1002: {
            why: "Returning a NavigationResult is deprecated.",
            fix: "Replace `return new NavigationResult(to)` with `reroute(to)`, which throws internally to reroute.",
            docs: "https://router.vuejs.org/data-loaders/navigation-aware.html#Controlling-the-navigation-with-reroute-"
        },
        VUE_ROUTER_R1003: {
            why: function(p) {
                return 'Loader "'.concat(p.key, '"\'s "commit()" was called but there is no staged data.');
            },
            fix: "Ensure the loader resolved before calling `commit()`.",
            docs: "https://router.vuejs.org/data-loaders/defining-loaders.html#Delaying-data-updates-with-commit"
        },
        VUE_ROUTER_R1004: {
            why: function(p) {
                return "A loader returned a NavigationResult but is not registered on the route." + p.key;
            },
            fix: "Export the loader from the page component so it gets registered, e.g. `export const useUserData = defineLoader(...)`.",
            docs: "https://router.vuejs.org/data-loaders/organization.html"
        },
        VUE_ROUTER_R1005: {
            why: function(p) {
                return 'Data loader "'.concat(p.key, "\" has itself as parent. This shouldn't be happening.");
            },
            fix: "Report a bug with a minimal reproduction at https://github.com/vuejs/router/."
        },
        VUE_ROUTER_R1006: {
            why: function(p) {
                return 'A query was defined with the same key as the loader "['.concat(p.key, ']".\nSee https://pinia-colada.esm.dev/#TODO');
            },
            fix: "If the key is meant to match, use the data loader directly; otherwise rename the `useQuery()` key so it no longer collides.",
            docs: "https://router.vuejs.org/data-loaders/colada.html"
        },
        VUE_ROUTER_R1007: {
            why: "Data Loader was setup twice.",
            fix: "Register `DataLoaderPlugin` a single time via `app.use()`.",
            docs: "https://router.vuejs.org/data-loaders.html#Installation"
        },
        VUE_ROUTER_R1008: {
            why: "Data Loader is experimental and subject to breaking changes in the future.",
            docs: "https://router.vuejs.org/data-loaders.html"
        },
        VUE_ROUTER_R1009: {
            why: "Returning a NavigationResult from a loader is deprecated.",
            fix: "Call `reroute(to)` inside the loader instead of returning `new NavigationResult(to)`; it throws internally to reroute.",
            docs: "https://router.vuejs.org/data-loaders/navigation-aware.html#Controlling-the-navigation-with-reroute-"
        }
    }
});
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ var $629d80bbf56b9c6a$export$43caf9889c228507 = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ var $629d80bbf56b9c6a$export$2408f22a0fab9ae5 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ var $629d80bbf56b9c6a$export$407448d2b89b1813 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ var $629d80bbf56b9c6a$export$23f2a1d2818174ef = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ var $629d80bbf56b9c6a$export$ae1af26003f05816 = Symbol("");
//#endregion
//#region src/useApi.ts
/**
* Returns the router instance. Equivalent to using `$router` inside
* templates.
*/ function $629d80bbf56b9c6a$export$7ccc53e8f1e7dfc5() {
    return (0, $fKAHx.inject)($629d80bbf56b9c6a$export$407448d2b89b1813);
}
/**
* Returns the current route location. Equivalent to using `$route` inside
* templates.
*/ function $629d80bbf56b9c6a$export$625550452a3fa3ec(_name) {
    return (0, $fKAHx.inject)($629d80bbf56b9c6a$export$23f2a1d2818174ef);
}


parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");

var $3gP77 = parcelRequire("3gP77");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $dWsrg = parcelRequire("dWsrg");

var $kg0zo = parcelRequire("kg0zo");

var $hdIku = parcelRequire("hdIku");

var $1XAnY = parcelRequire("1XAnY");

var $6fpqi = parcelRequire("6fpqi");

var $f9AOD = parcelRequire("f9AOD");

var $9366V = parcelRequire("9366V");

var $fSnLV = parcelRequire("fSnLV");

var $2aJ1i = parcelRequire("2aJ1i");

var $dyckk = parcelRequire("dyckk");
function $db8bc344974bb245$export$71511d61b312f219(arr) {
    return (0, $9366V._)(arr) || (0, $fSnLV._)(arr) || (0, $dyckk._)(arr) || (0, $2aJ1i._)();
}



var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");
//#region \0rolldown/runtime.js

var $7E0eS = parcelRequire("7E0eS");
var $6430dea643e1c0c1$var$_navigator_userAgent;

var $9iKK3 = parcelRequire("9iKK3");
var $6430dea643e1c0c1$require$Buffer = $9iKK3.Buffer;
var $6430dea643e1c0c1$var$__create = Object.create;
var $6430dea643e1c0c1$var$__defProp = Object.defineProperty;
var $6430dea643e1c0c1$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $6430dea643e1c0c1$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $6430dea643e1c0c1$var$__getProtoOf = Object.getPrototypeOf;
var $6430dea643e1c0c1$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $6430dea643e1c0c1$var$__commonJSMin = function(cb, mod) {
    return function() {
        return mod || cb((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var $6430dea643e1c0c1$var$__copyProps = function(to, from, except, desc) {
    if (from && (typeof from === "undefined" ? "undefined" : (0, $7E0eS._)(from)) === "object" || typeof from === "function") for(var keys = $6430dea643e1c0c1$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$6430dea643e1c0c1$var$__hasOwnProp.call(to, key) && key !== except) $6430dea643e1c0c1$var$__defProp(to, key, {
            get: (function(k) {
                return from[k];
            }).bind(null, key),
            enumerable: !(desc = $6430dea643e1c0c1$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $6430dea643e1c0c1$var$__toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? $6430dea643e1c0c1$var$__create($6430dea643e1c0c1$var$__getProtoOf(mod)) : {}, $6430dea643e1c0c1$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $6430dea643e1c0c1$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
//#endregion
//#region src/constants.ts
var $6430dea643e1c0c1$export$a13f7f627010bccd = "__vue-devtools-view-mode__";
var $6430dea643e1c0c1$export$cb85e77fef76bd8b = "__vue-devtools-vite-plugin-detected__";
var $6430dea643e1c0c1$export$45e7092a470efb27 = "__vue-devtools-vite-plugin-client-url__";
var $6430dea643e1c0c1$export$a7ca7371bc63510e = "__vue-devtools-broadcast-channel__";
//#endregion
//#region src/env.ts
var $6430dea643e1c0c1$export$4e09c449d6c407f7 = typeof navigator !== "undefined";
var $6430dea643e1c0c1$export$44271b4f0c6a3563 = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : typeof $parcel$global !== "undefined" ? $parcel$global : {};
var $6430dea643e1c0c1$export$2a47bd138bf4827c = typeof $6430dea643e1c0c1$export$44271b4f0c6a3563.chrome !== "undefined" && !!$6430dea643e1c0c1$export$44271b4f0c6a3563.chrome.devtools;
var $6430dea643e1c0c1$export$9f140ed41af5108c = $6430dea643e1c0c1$export$4e09c449d6c407f7 && $6430dea643e1c0c1$export$44271b4f0c6a3563.self !== $6430dea643e1c0c1$export$44271b4f0c6a3563.top;
var $6430dea643e1c0c1$export$6272d088ce0bd5ee = typeof navigator !== "undefined" && (($6430dea643e1c0c1$var$_navigator_userAgent = navigator.userAgent) === null || $6430dea643e1c0c1$var$_navigator_userAgent === void 0 ? void 0 : $6430dea643e1c0c1$var$_navigator_userAgent.toLowerCase().includes("electron"));
var $6430dea643e1c0c1$export$e34a31924fd64105 = typeof window !== "undefined" && !!window.__NUXT__;
var $6430dea643e1c0c1$export$cd24a69e3c9a51c8 = !$6430dea643e1c0c1$export$9f140ed41af5108c && !$6430dea643e1c0c1$export$2a47bd138bf4827c && !$6430dea643e1c0c1$export$6272d088ce0bd5ee;
//#endregion
//#region src/general.ts
var $6430dea643e1c0c1$var$import_rfdc = /* @__PURE__ */ $6430dea643e1c0c1$var$__toESM(/* @__PURE__ */ $6430dea643e1c0c1$var$__commonJSMin(function(exports, module) {
    module.exports = rfdc;
    function copyBuffer(cur) {
        if (cur instanceof $6430dea643e1c0c1$require$Buffer) return $6430dea643e1c0c1$require$Buffer.from(cur);
        return new cur.constructor(cur.buffer.slice(), cur.byteOffset, cur.length);
    }
    function rfdc(opts) {
        opts = opts || {};
        if (opts.circles) return rfdcCircles(opts);
        var constructorHandlers = /* @__PURE__ */ new Map();
        constructorHandlers.set(Date, function(o) {
            return new Date(o);
        });
        constructorHandlers.set(Map, function(o, fn) {
            return new Map(cloneArray(Array.from(o), fn));
        });
        constructorHandlers.set(Set, function(o, fn) {
            return new Set(cloneArray(Array.from(o), fn));
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (opts.constructorHandlers) try {
            for(var _iterator = opts.constructorHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var handler = _step.value;
                constructorHandlers.set(handler[0], handler[1]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var handler1 = null;
        return opts.proto ? cloneProto : clone;
        function cloneArray(a, fn) {
            var keys = Object.keys(a);
            var a2 = new Array(keys.length);
            for(var i = 0; i < keys.length; i++){
                var k = keys[i];
                var cur = a[k];
                if ((typeof cur === "undefined" ? "undefined" : (0, $7E0eS._)(cur)) !== "object" || cur === null) a2[k] = cur;
                else if (cur.constructor !== Object && (handler1 = constructorHandlers.get(cur.constructor))) a2[k] = handler1(cur, fn);
                else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                else a2[k] = fn(cur);
            }
            return a2;
        }
        function clone(o) {
            if ((typeof o === "undefined" ? "undefined" : (0, $7E0eS._)(o)) !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, clone);
            if (o.constructor !== Object && (handler1 = constructorHandlers.get(o.constructor))) return handler1(o, clone);
            var o2 = {};
            for(var k in o){
                if (Object.hasOwnProperty.call(o, k) === false) continue;
                var cur = o[k];
                if ((typeof cur === "undefined" ? "undefined" : (0, $7E0eS._)(cur)) !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler1 = constructorHandlers.get(cur.constructor))) o2[k] = handler1(cur, clone);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else o2[k] = clone(cur);
            }
            return o2;
        }
        function cloneProto(o) {
            if ((typeof o === "undefined" ? "undefined" : (0, $7E0eS._)(o)) !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, cloneProto);
            if (o.constructor !== Object && (handler1 = constructorHandlers.get(o.constructor))) return handler1(o, cloneProto);
            var o2 = {};
            for(var k in o){
                var cur = o[k];
                if ((typeof cur === "undefined" ? "undefined" : (0, $7E0eS._)(cur)) !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler1 = constructorHandlers.get(cur.constructor))) o2[k] = handler1(cur, cloneProto);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else o2[k] = cloneProto(cur);
            }
            return o2;
        }
    }
    function rfdcCircles(opts) {
        var refs = [];
        var refsNew = [];
        var constructorHandlers = /* @__PURE__ */ new Map();
        constructorHandlers.set(Date, function(o) {
            return new Date(o);
        });
        constructorHandlers.set(Map, function(o, fn) {
            return new Map(cloneArray(Array.from(o), fn));
        });
        constructorHandlers.set(Set, function(o, fn) {
            return new Set(cloneArray(Array.from(o), fn));
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (opts.constructorHandlers) try {
            for(var _iterator = opts.constructorHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var handler = _step.value;
                constructorHandlers.set(handler[0], handler[1]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var handler1 = null;
        return opts.proto ? cloneProto : clone;
        function cloneArray(a, fn) {
            var keys = Object.keys(a);
            var a2 = new Array(keys.length);
            for(var i = 0; i < keys.length; i++){
                var k = keys[i];
                var cur = a[k];
                if ((typeof cur === "undefined" ? "undefined" : (0, $7E0eS._)(cur)) !== "object" || cur === null) a2[k] = cur;
                else if (cur.constructor !== Object && (handler1 = constructorHandlers.get(cur.constructor))) a2[k] = handler1(cur, fn);
                else if (ArrayBuffer.isView(cur)) a2[k] = copyBuffer(cur);
                else {
                    var index = refs.indexOf(cur);
                    if (index !== -1) a2[k] = refsNew[index];
                    else a2[k] = fn(cur);
                }
            }
            return a2;
        }
        function clone(o) {
            if ((typeof o === "undefined" ? "undefined" : (0, $7E0eS._)(o)) !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, clone);
            if (o.constructor !== Object && (handler1 = constructorHandlers.get(o.constructor))) return handler1(o, clone);
            var o2 = {};
            refs.push(o);
            refsNew.push(o2);
            for(var k in o){
                if (Object.hasOwnProperty.call(o, k) === false) continue;
                var cur = o[k];
                if ((typeof cur === "undefined" ? "undefined" : (0, $7E0eS._)(cur)) !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler1 = constructorHandlers.get(cur.constructor))) o2[k] = handler1(cur, clone);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else {
                    var i = refs.indexOf(cur);
                    if (i !== -1) o2[k] = refsNew[i];
                    else o2[k] = clone(cur);
                }
            }
            refs.pop();
            refsNew.pop();
            return o2;
        }
        function cloneProto(o) {
            if ((typeof o === "undefined" ? "undefined" : (0, $7E0eS._)(o)) !== "object" || o === null) return o;
            if (Array.isArray(o)) return cloneArray(o, cloneProto);
            if (o.constructor !== Object && (handler1 = constructorHandlers.get(o.constructor))) return handler1(o, cloneProto);
            var o2 = {};
            refs.push(o);
            refsNew.push(o2);
            for(var k in o){
                var cur = o[k];
                if ((typeof cur === "undefined" ? "undefined" : (0, $7E0eS._)(cur)) !== "object" || cur === null) o2[k] = cur;
                else if (cur.constructor !== Object && (handler1 = constructorHandlers.get(cur.constructor))) o2[k] = handler1(cur, cloneProto);
                else if (ArrayBuffer.isView(cur)) o2[k] = copyBuffer(cur);
                else {
                    var i = refs.indexOf(cur);
                    if (i !== -1) o2[k] = refsNew[i];
                    else o2[k] = cloneProto(cur);
                }
            }
            refs.pop();
            refsNew.pop();
            return o2;
        }
    }
})(), 1);
function $6430dea643e1c0c1$export$5702a91a6f42969f() {}
var $6430dea643e1c0c1$export$e90fb89750dba83f = function(str) {
    return "".concat(+str) === str;
};
var $6430dea643e1c0c1$export$6159e43e50a41987 = function() {
    var _navigator, _navigator1;
    return ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.platform) ? (_navigator1 = navigator) === null || _navigator1 === void 0 ? void 0 : _navigator1.platform.toLowerCase().includes("mac") : /Macintosh/.test(navigator.userAgent);
};
var $6430dea643e1c0c1$var$classifyRE = /(?:^|[-_/])(\w)/g;
var $6430dea643e1c0c1$var$camelizeRE = /-(\w)/g;
var $6430dea643e1c0c1$var$kebabizeRE = /([a-z0-9])([A-Z])/g;
function $6430dea643e1c0c1$var$toUpper(_, c) {
    return c ? c.toUpperCase() : "";
}
function $6430dea643e1c0c1$export$b04d9b8d414ba5e8(str) {
    return str && "".concat(str).replace($6430dea643e1c0c1$var$classifyRE, $6430dea643e1c0c1$var$toUpper);
}
function $6430dea643e1c0c1$export$161d051f5dd25de7(str) {
    return str && str.replace($6430dea643e1c0c1$var$camelizeRE, $6430dea643e1c0c1$var$toUpper);
}
function $6430dea643e1c0c1$export$3b2e9c066cbbdd4c(str) {
    return str && str.replace($6430dea643e1c0c1$var$kebabizeRE, function(_, lowerCaseCharacter, upperCaseLetter) {
        return "".concat(lowerCaseCharacter, "-").concat(upperCaseLetter);
    }).toLowerCase();
}
function $6430dea643e1c0c1$export$9bf319d8f74f51d1(filename, ext) {
    var normalizedFilename = filename.replace(/^[a-z]:/i, "").replace(/\\/g, "/");
    if (normalizedFilename.endsWith("index".concat(ext))) normalizedFilename = normalizedFilename.replace("/index".concat(ext), ext);
    var lastSlashIndex = normalizedFilename.lastIndexOf("/");
    var baseNameWithExt = normalizedFilename.substring(lastSlashIndex + 1);
    if (ext) {
        var extIndex = baseNameWithExt.lastIndexOf(ext);
        return baseNameWithExt.substring(0, extIndex);
    }
    return "";
}
function $6430dea643e1c0c1$export$584200199479c807(state) {
    return state && state.slice().sort(function(a, b) {
        if (a.key < b.key) return -1;
        if (a.key > b.key) return 1;
        return 0;
    });
}
var $6430dea643e1c0c1$var$HTTP_URL_RE = /^https?:\/\//;
/**
* Check a string is start with `/` or a valid http url
*/ function $6430dea643e1c0c1$export$8092cb61b2731942(str) {
    return str.startsWith("/") || $6430dea643e1c0c1$var$HTTP_URL_RE.test(str);
}
/**
* @copyright [rfdc](https://github.com/davidmarkclements/rfdc)
* @description A really fast deep clone alternative
*/ var $6430dea643e1c0c1$export$b7d58db314e0ac27 = (0, $6430dea643e1c0c1$var$import_rfdc.default)({
    circles: true
});
function $6430dea643e1c0c1$export$e700e91d2b9349e8() {
    return Math.random().toString(36).slice(2);
}
function $6430dea643e1c0c1$export$a6cdc56e425d0d0a(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === "object" && !Array.isArray(value) && value !== null;
}
function $6430dea643e1c0c1$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $6430dea643e1c0c1$export$6750766a7c7ec627(value) {
    return value instanceof Set;
}
function $6430dea643e1c0c1$export$5c90113a285f2241(value) {
    return value instanceof Map;
}


//#region src/index.ts

var $3gP77 = parcelRequire("3gP77");

var $1XAnY = parcelRequire("1XAnY");

var $13u2V = parcelRequire("13u2V");
var $062babd0a85d9d9b$var$DEBOUNCE_DEFAULTS = {
    trailing: true
};
/**
Debounce functions
@param fn - Promise-returning/async function to debounce.
@param wait - Milliseconds to wait before calling `fn`. Default value is 25ms
@returns A function that delays calling `fn` until after `wait` milliseconds have elapsed since the last time it was called.
@example
```
import { debounce } from 'perfect-debounce';
const expensiveCall = async input => input;
const debouncedFn = debounce(expensiveCall, 200);
for (const number of [1, 2, 3]) {
console.log(await debouncedFn(number));
}
//=> 1
//=> 2
//=> 3
```
*/ function $062babd0a85d9d9b$export$61fc7d43ac8f84b0(fn) {
    var _this = this;
    var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 25, options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    options = (0, $1XAnY._)({}, $062babd0a85d9d9b$var$DEBOUNCE_DEFAULTS, options);
    if (!Number.isFinite(wait)) throw new TypeError("Expected `wait` to be a finite number");
    var leadingValue;
    var timeout;
    var resolveList = [];
    var currentPromise;
    var trailingArgs;
    var applyFn = function(_this, args) {
        currentPromise = $062babd0a85d9d9b$var$_applyPromised(fn, _this, args);
        currentPromise.finally(function() {
            currentPromise = null;
            if (options.trailing && trailingArgs && !timeout) {
                var promise = applyFn(_this, trailingArgs);
                trailingArgs = null;
                return promise;
            }
        });
        return currentPromise;
    };
    var debounced = function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (options.trailing) trailingArgs = args;
        if (currentPromise) return currentPromise;
        return new Promise(function(resolve) {
            var shouldCallNow = !timeout && options.leading;
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                timeout = null;
                var promise = options.leading ? leadingValue : applyFn(_this, args);
                trailingArgs = null;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = resolveList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _resolve = _step.value;
                        _resolve(promise);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                resolveList = [];
            }, wait);
            if (shouldCallNow) {
                leadingValue = applyFn(_this, args);
                resolve(leadingValue);
            } else resolveList.push(resolve);
        });
    };
    var _clearTimeout = function(timer) {
        if (timer) {
            clearTimeout(timer);
            timeout = null;
        }
    };
    debounced.isPending = function() {
        return !!timeout;
    };
    debounced.cancel = function() {
        _clearTimeout(timeout);
        resolveList = [];
        trailingArgs = null;
    };
    debounced.flush = function() {
        _clearTimeout(timeout);
        if (!trailingArgs || currentPromise) return;
        var args = trailingArgs;
        trailingArgs = null;
        return applyFn(_this, args);
    };
    return debounced;
}
function $062babd0a85d9d9b$var$_applyPromised(fn, _this, args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fn.apply(_this, args)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}



var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $1XAnY = parcelRequire("1XAnY");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");
function $386a79679df3e70b$export$9089e2fc8ae509cd(configHooks) {
    var hooks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, parentName = arguments.length > 2 ? arguments[2] : void 0;
    for(var key in configHooks){
        var subHook = configHooks[key];
        var name = parentName ? "".concat(parentName, ":").concat(key) : key;
        if ((typeof subHook === "undefined" ? "undefined" : (0, $7E0eS._)(subHook)) === "object" && subHook !== null) $386a79679df3e70b$export$9089e2fc8ae509cd(subHook, hooks, name);
        else if (typeof subHook === "function") hooks[name] = subHook;
    }
    return hooks;
}
function $386a79679df3e70b$export$3de1ffbf114b9f2d() {
    var _loop = function(key1) {
        if (finalHooks[key1].length > 1) {
            var array = finalHooks[key1];
            finalHooks[key1] = function() {
                for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++){
                    arguments_[_key] = arguments[_key];
                }
                return $386a79679df3e70b$export$6c2c9a00e27c07e8(array, function(function_) {
                    return function_.apply(void 0, (0, $aUGqu._)(arguments_));
                });
            };
        } else finalHooks[key1] = finalHooks[key1][0];
    };
    for(var _len = arguments.length, hooks = new Array(_len), _key = 0; _key < _len; _key++){
        hooks[_key] = arguments[_key];
    }
    var finalHooks = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = hooks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var hook = _step.value;
            var flatenHook = $386a79679df3e70b$export$9089e2fc8ae509cd(hook);
            for(var key in flatenHook)if (finalHooks[key]) finalHooks[key].push(flatenHook[key]);
            else finalHooks[key] = [
                flatenHook[key]
            ];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    for(var key1 in finalHooks)_loop(key1);
    return finalHooks;
}
function $386a79679df3e70b$export$6c2c9a00e27c07e8(tasks, function_) {
    return tasks.reduce(function(promise, task) {
        return promise.then(function() {
            return function_(task);
        });
    }, Promise.resolve());
}
var $386a79679df3e70b$var$defaultTask = {
    run: function(function_) {
        return function_();
    }
};
var $386a79679df3e70b$var$_createTask = function() {
    return $386a79679df3e70b$var$defaultTask;
};
var $386a79679df3e70b$var$createTask = typeof console.createTask !== "undefined" ? console.createTask : $386a79679df3e70b$var$_createTask;
function $386a79679df3e70b$var$serialTaskCaller(hooks, args) {
    var name = args.shift();
    var task = $386a79679df3e70b$var$createTask(name);
    return hooks.reduce(function(promise, hookFunction) {
        return promise.then(function() {
            return task.run(function() {
                return hookFunction.apply(void 0, (0, $aUGqu._)(args));
            });
        });
    }, Promise.resolve());
}
function $386a79679df3e70b$var$parallelTaskCaller(hooks, args) {
    var name = args.shift();
    var task = $386a79679df3e70b$var$createTask(name);
    return Promise.all(hooks.map(function(hook) {
        return task.run(function() {
            return hook.apply(void 0, (0, $aUGqu._)(args));
        });
    }));
}
function $386a79679df3e70b$export$e1dd809e3137c513(hooks, arguments_) {
    return hooks.reduce(function(promise, hookFunction) {
        return promise.then(function() {
            return hookFunction.apply(void 0, (0, $aUGqu._)(arguments_ || []));
        });
    }, Promise.resolve());
}
function $386a79679df3e70b$export$23b1f1c6efb4a44a(hooks, args) {
    return Promise.all(hooks.map(function(hook) {
        return hook.apply(void 0, (0, $aUGqu._)(args || []));
    }));
}
function $386a79679df3e70b$var$callEachWith(callbacks, arg0) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, $aUGqu._)(callbacks)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var callback = _step.value;
            callback(arg0);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var $386a79679df3e70b$export$f26845e0fc859724 = /*#__PURE__*/ function() {
    "use strict";
    function Hookable() {
        (0, $173N4._)(this, Hookable);
        this._hooks = {};
        this._before = void 0;
        this._after = void 0;
        this._deprecatedMessages = void 0;
        this._deprecatedHooks = {};
        this.hook = this.hook.bind(this);
        this.callHook = this.callHook.bind(this);
        this.callHookWith = this.callHookWith.bind(this);
    }
    (0, $cFHGC._)(Hookable, [
        {
            key: "hook",
            value: function hook(name, function_) {
                var _this = this;
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                if (!name || typeof function_ !== "function") return function() {};
                var originalName = name;
                var dep;
                while(this._deprecatedHooks[name]){
                    dep = this._deprecatedHooks[name];
                    name = dep.to;
                }
                if (dep && !options.allowDeprecated) {
                    var message = dep.message;
                    if (!message) message = "".concat(originalName, " hook has been deprecated") + (dep.to ? ", please use ".concat(dep.to) : "");
                    if (!this._deprecatedMessages) this._deprecatedMessages = /* @__PURE__ */ new Set();
                    if (!this._deprecatedMessages.has(message)) {
                        console.warn(message);
                        this._deprecatedMessages.add(message);
                    }
                }
                if (!function_.name) try {
                    Object.defineProperty(function_, "name", {
                        get: function() {
                            return "_" + name.replace(/\W+/g, "_") + "_hook_cb";
                        },
                        configurable: true
                    });
                } catch (e) {}
                this._hooks[name] = this._hooks[name] || [];
                this._hooks[name].push(function_);
                return function() {
                    if (function_) {
                        _this.removeHook(name, function_);
                        function_ = void 0;
                    }
                };
            }
        },
        {
            key: "hookOnce",
            value: function hookOnce(name, function_) {
                var _unreg;
                var _function = function() {
                    for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++){
                        arguments_[_key] = arguments[_key];
                    }
                    if (typeof _unreg === "function") _unreg();
                    _unreg = void 0;
                    _function = void 0;
                    return function_.apply(void 0, (0, $aUGqu._)(arguments_));
                };
                _unreg = this.hook(name, _function);
                return _unreg;
            }
        },
        {
            key: "removeHook",
            value: function removeHook(name, function_) {
                if (this._hooks[name]) {
                    var index = this._hooks[name].indexOf(function_);
                    if (index !== -1) this._hooks[name].splice(index, 1);
                    if (this._hooks[name].length === 0) delete this._hooks[name];
                }
            }
        },
        {
            key: "deprecateHook",
            value: function deprecateHook(name, deprecated) {
                this._deprecatedHooks[name] = typeof deprecated === "string" ? {
                    to: deprecated
                } : deprecated;
                var _hooks = this._hooks[name] || [];
                delete this._hooks[name];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _hooks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var hook = _step.value;
                        this.hook(name, hook);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "deprecateHooks",
            value: function deprecateHooks(deprecatedHooks) {
                Object.assign(this._deprecatedHooks, deprecatedHooks);
                for(var name in deprecatedHooks)this.deprecateHook(name, deprecatedHooks[name]);
            }
        },
        {
            key: "addHooks",
            value: function addHooks(configHooks) {
                var _this = this;
                var hooks = $386a79679df3e70b$export$9089e2fc8ae509cd(configHooks);
                var removeFns = Object.keys(hooks).map(function(key) {
                    return _this.hook(key, hooks[key]);
                });
                return function() {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = removeFns.splice(0, removeFns.length)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var unreg = _step.value;
                            unreg();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
            }
        },
        {
            key: "removeHooks",
            value: function removeHooks(configHooks) {
                var hooks = $386a79679df3e70b$export$9089e2fc8ae509cd(configHooks);
                for(var key in hooks)this.removeHook(key, hooks[key]);
            }
        },
        {
            key: "removeAllHooks",
            value: function removeAllHooks() {
                for(var key in this._hooks)delete this._hooks[key];
            }
        },
        {
            key: "callHook",
            value: function callHook(name) {
                for(var _len = arguments.length, arguments_ = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    arguments_[_key - 1] = arguments[_key];
                }
                arguments_.unshift(name);
                return this.callHookWith.apply(this, [
                    $386a79679df3e70b$var$serialTaskCaller,
                    name
                ].concat((0, $aUGqu._)(arguments_)));
            }
        },
        {
            key: "callHookParallel",
            value: function callHookParallel(name) {
                for(var _len = arguments.length, arguments_ = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    arguments_[_key - 1] = arguments[_key];
                }
                arguments_.unshift(name);
                return this.callHookWith.apply(this, [
                    $386a79679df3e70b$var$parallelTaskCaller,
                    name
                ].concat((0, $aUGqu._)(arguments_)));
            }
        },
        {
            key: "callHookWith",
            value: function callHookWith(caller, name) {
                var _this = this;
                for(var _len = arguments.length, arguments_ = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    arguments_[_key - 2] = arguments[_key];
                }
                var event = this._before || this._after ? {
                    name: name,
                    args: arguments_,
                    context: {}
                } : void 0;
                if (this._before) $386a79679df3e70b$var$callEachWith(this._before, event);
                var result = caller(name in this._hooks ? (0, $aUGqu._)(this._hooks[name]) : [], arguments_);
                if (result instanceof Promise) return result.finally(function() {
                    if (_this._after && event) $386a79679df3e70b$var$callEachWith(_this._after, event);
                });
                if (this._after && event) $386a79679df3e70b$var$callEachWith(this._after, event);
                return result;
            }
        },
        {
            key: "beforeEach",
            value: function beforeEach(function_) {
                var _this = this;
                this._before = this._before || [];
                this._before.push(function_);
                return function() {
                    if (_this._before !== void 0) {
                        var index = _this._before.indexOf(function_);
                        if (index !== -1) _this._before.splice(index, 1);
                    }
                };
            }
        },
        {
            key: "afterEach",
            value: function afterEach(function_) {
                var _this = this;
                this._after = this._after || [];
                this._after.push(function_);
                return function() {
                    if (_this._after !== void 0) {
                        var index = _this._after.indexOf(function_);
                        if (index !== -1) _this._after.splice(index, 1);
                    }
                };
            }
        }
    ]);
    return Hookable;
}();
function $386a79679df3e70b$export$39c6a2b4dbabca5d() {
    return new $386a79679df3e70b$export$f26845e0fc859724();
}
var $386a79679df3e70b$var$isBrowser = typeof window !== "undefined";
function $386a79679df3e70b$export$acfdf6f45fa21f5e(hooks) {
    var _options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = (0, $1XAnY._)({
        inspect: $386a79679df3e70b$var$isBrowser,
        group: $386a79679df3e70b$var$isBrowser,
        filter: function() {
            return true;
        }
    }, _options);
    var _filter = options.filter;
    var filter = typeof _filter === "string" ? function(name) {
        return name.startsWith(_filter);
    } : _filter;
    var _tag = options.tag ? "[".concat(options.tag, "] ") : "";
    var logPrefix = function(event) {
        return _tag + event.name + "".padEnd(event._id, "\0");
    };
    var _idCtr = {};
    var unsubscribeBefore = hooks.beforeEach(function(event) {
        if (filter !== void 0 && !filter(event.name)) return;
        _idCtr[event.name] = _idCtr[event.name] || 0;
        event._id = _idCtr[event.name]++;
        console.time(logPrefix(event));
    });
    var unsubscribeAfter = hooks.afterEach(function(event) {
        if (filter !== void 0 && !filter(event.name)) return;
        if (options.group) console.groupCollapsed(event.name);
        if (options.inspect) console.timeLog(logPrefix(event), event.args);
        else console.timeEnd(logPrefix(event));
        if (options.group) console.groupEnd();
        _idCtr[event.name]--;
    });
    return {
        /** Stop debugging and remove listeners */ close: function() {
            unsubscribeBefore();
            unsubscribeAfter();
        }
    };
}



var $3gP77 = parcelRequire("3gP77");

var $1XAnY = parcelRequire("1XAnY");

var $aUGqu = parcelRequire("aUGqu");

var $7E0eS = parcelRequire("7E0eS");

var $13u2V = parcelRequire("13u2V");
var $1e15058b4cd80238$var$TYPE_REQUEST = "q";
var $1e15058b4cd80238$var$TYPE_RESPONSE = "s";
var $1e15058b4cd80238$export$7bd623b29ec8e1eb = 6e4;
function $1e15058b4cd80238$var$defaultSerialize(i) {
    return i;
}
var $1e15058b4cd80238$var$defaultDeserialize = $1e15058b4cd80238$var$defaultSerialize;
var $1e15058b4cd80238$var$clearTimeout = globalThis.clearTimeout, $1e15058b4cd80238$var$setTimeout = globalThis.setTimeout;
var $1e15058b4cd80238$var$random = Math.random.bind(Math);
function $1e15058b4cd80238$export$8de909a09ac6851a($functions, options) {
    var post = options.post, on = options.on, _options_off = options.off, off = _options_off === void 0 ? function() {} : _options_off, _options_eventNames = options.eventNames, eventNames = _options_eventNames === void 0 ? [] : _options_eventNames, _options_serialize = options.serialize, serialize = _options_serialize === void 0 ? $1e15058b4cd80238$var$defaultSerialize : _options_serialize, _options_deserialize = options.deserialize, deserialize = _options_deserialize === void 0 ? $1e15058b4cd80238$var$defaultDeserialize : _options_deserialize, resolver = options.resolver, _options_bind = options.bind, bind = _options_bind === void 0 ? "rpc" : _options_bind, _options_timeout = options.timeout, timeout = _options_timeout === void 0 ? $1e15058b4cd80238$export$7bd623b29ec8e1eb : _options_timeout;
    var $closed = false;
    var _rpcPromiseMap = /* @__PURE__ */ new Map();
    var _promiseInit;
    var rpc;
    function _call(method, args, event, optional) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var req, send, _createPromiseWithResolvers, promise, resolve, reject, id, timeoutId, e, _options_onGeneralError;
            function handler() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var newReq, _timeoutId_unref;
                    var _arguments = arguments;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                newReq = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : req;
                                if (timeout >= 0) {
                                    ;
                                    timeoutId = $1e15058b4cd80238$var$setTimeout(function() {
                                        try {
                                            var _options_onTimeoutError;
                                            var handleResult = (_options_onTimeoutError = options.onTimeoutError) === null || _options_onTimeoutError === void 0 ? void 0 : _options_onTimeoutError.call(rpc, method, args);
                                            if (handleResult !== true) throw new Error('[birpc] timeout on calling "'.concat(method, '"'));
                                        } catch (e) {
                                            reject(e);
                                        }
                                        _rpcPromiseMap.delete(id);
                                    }, timeout);
                                    if ((typeof timeoutId === "undefined" ? "undefined" : (0, $7E0eS._)(timeoutId)) === "object") timeoutId = (_timeoutId_unref = timeoutId.unref) === null || _timeoutId_unref === void 0 ? void 0 : _timeoutId_unref.call(timeoutId);
                                }
                                _rpcPromiseMap.set(id, {
                                    resolve: resolve,
                                    reject: reject,
                                    timeoutId: timeoutId,
                                    method: method
                                });
                                return [
                                    4,
                                    send(newReq)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    promise
                                ];
                        }
                    });
                }).apply(this, arguments);
            }
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ($closed) throw new Error('[birpc] rpc is closed, cannot call "'.concat(method, '"'));
                        req = {
                            m: method,
                            a: args,
                            t: $1e15058b4cd80238$var$TYPE_REQUEST
                        };
                        if (optional) req.o = true;
                        send = function(_req) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                return (0, $13u2V._)(this, function(_state) {
                                    return [
                                        2,
                                        post(serialize(_req))
                                    ];
                                });
                            })();
                        };
                        if (!event) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            send(req)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                    case 2:
                        if (!_promiseInit) return [
                            3,
                            6
                        ];
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            ,
                            5,
                            6
                        ]);
                        return [
                            4,
                            _promiseInit
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        _promiseInit = void 0;
                        return [
                            7
                        ];
                    case 6:
                        _createPromiseWithResolvers = $1e15058b4cd80238$var$createPromiseWithResolvers(), promise = _createPromiseWithResolvers.promise, resolve = _createPromiseWithResolvers.resolve, reject = _createPromiseWithResolvers.reject;
                        id = $1e15058b4cd80238$var$nanoid();
                        req.i = id;
                        _state.label = 7;
                    case 7:
                        _state.trys.push([
                            7,
                            12,
                            13,
                            14
                        ]);
                        if (!options.onRequest) return [
                            3,
                            9
                        ];
                        return [
                            4,
                            options.onRequest.call(rpc, req, handler, resolve)
                        ];
                    case 8:
                        _state.sent();
                        return [
                            3,
                            11
                        ];
                    case 9:
                        return [
                            4,
                            handler()
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        return [
                            3,
                            14
                        ];
                    case 12:
                        e = _state.sent();
                        if (((_options_onGeneralError = options.onGeneralError) === null || _options_onGeneralError === void 0 ? void 0 : _options_onGeneralError.call(rpc, e)) !== true) throw e;
                        return [
                            2
                        ];
                    case 13:
                        $1e15058b4cd80238$var$clearTimeout(timeoutId);
                        _rpcPromiseMap.delete(id);
                        return [
                            7
                        ];
                    case 14:
                        return [
                            2,
                            promise
                        ];
                }
            });
        })();
    }
    var $call = function(method) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return _call(method, args, false);
    };
    var $callOptional = function(method) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return _call(method, args, false, true);
    };
    var $callEvent = function(method) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return _call(method, args, true);
    };
    var $callRaw = function(options2) {
        return _call(options2.method, options2.args, options2.event, options2.optional);
    };
    var builtinMethods = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent,
        $callRaw: $callRaw,
        $rejectPendingCalls: $rejectPendingCalls,
        get $closed () {
            return $closed;
        },
        get $meta () {
            return options.meta;
        },
        $close: $close,
        $functions: $functions
    };
    rpc = new Proxy({}, {
        get: function(_, method) {
            if (Object.prototype.hasOwnProperty.call(builtinMethods, method)) return builtinMethods[method];
            if (method === "then" && !eventNames.includes("then") && !("then" in $functions)) return void 0;
            var sendEvent = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return _call(method, args, true);
            };
            if (eventNames.includes(method)) {
                sendEvent.asEvent = sendEvent;
                return sendEvent;
            }
            var sendCall = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return _call(method, args, false);
            };
            sendCall.asEvent = sendEvent;
            return sendCall;
        }
    });
    function $close(customError) {
        $closed = true;
        _rpcPromiseMap.forEach(function(param) {
            var reject = param.reject, method = param.method;
            var error = new Error('[birpc] rpc is closed, cannot call "'.concat(method, '"'));
            if (customError) {
                var _customError;
                var _cause;
                (_cause = (_customError = customError).cause) !== null && _cause !== void 0 ? _cause : _customError.cause = error;
                return reject(customError);
            }
            reject(error);
        });
        _rpcPromiseMap.clear();
        off(onMessage);
    }
    function $rejectPendingCalls(handler) {
        var entries = Array.from(_rpcPromiseMap.values());
        var handlerResults = entries.map(function(param) {
            var method = param.method, reject = param.reject;
            if (!handler) return reject(new Error('[birpc]: rejected pending call "'.concat(method, '".')));
            return handler({
                method: method,
                reject: reject
            });
        });
        _rpcPromiseMap.clear();
        return handlerResults;
    }
    function onMessage(data) {
        for(var _len = arguments.length, extra = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            extra[_key - 1] = arguments[_key];
        }
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var msg, _options_onGeneralError, method, args, optional, result, error, fn, e, e1, _options_onGeneralError1, e2, _options_onGeneralError2, ack, result1, error1, promise;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        try {
                            msg = deserialize(data);
                        } catch (e) {
                            ;
                            if (((_options_onGeneralError = options.onGeneralError) === null || _options_onGeneralError === void 0 ? void 0 : _options_onGeneralError.call(rpc, e)) !== true) throw e;
                            return [
                                2
                            ];
                        }
                        if (!(msg.t === $1e15058b4cd80238$var$TYPE_REQUEST)) return [
                            3,
                            13
                        ];
                        method = msg.m, args = msg.a, optional = msg.o;
                        return [
                            4,
                            resolver ? resolver.call(rpc, method, $functions[method]) : $functions[method]
                        ];
                    case 1:
                        fn = _state.sent();
                        if (optional) fn || (fn = function() {
                            return void 0;
                        });
                        if (!!fn) return [
                            3,
                            2
                        ];
                        error = new Error('[birpc] function "'.concat(method, '" not found'));
                        return [
                            3,
                            5
                        ];
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fn.apply(bind === "rpc" ? rpc : $functions, args)
                        ];
                    case 3:
                        result = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        error = e;
                        return [
                            3,
                            5
                        ];
                    case 5:
                        if (!msg.i) return [
                            3,
                            12
                        ];
                        if (error && options.onError) options.onError.call(rpc, error, method, args);
                        if (error && options.onFunctionError) {
                            if (options.onFunctionError.call(rpc, error, method, args) === true) return [
                                2
                            ];
                        }
                        if (!!error) return [
                            3,
                            9
                        ];
                        _state.label = 6;
                    case 6:
                        _state.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        return [
                            4,
                            post.apply(void 0, [
                                serialize({
                                    t: $1e15058b4cd80238$var$TYPE_RESPONSE,
                                    i: msg.i,
                                    r: result
                                })
                            ].concat((0, $aUGqu._)(extra)))
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        e1 = _state.sent();
                        error = e1;
                        if (((_options_onGeneralError1 = options.onGeneralError) === null || _options_onGeneralError1 === void 0 ? void 0 : _options_onGeneralError1.call(rpc, e1, method, args)) !== true) throw e1;
                        return [
                            3,
                            9
                        ];
                    case 9:
                        _state.trys.push([
                            9,
                            11,
                            ,
                            12
                        ]);
                        return [
                            4,
                            post.apply(void 0, [
                                serialize({
                                    t: $1e15058b4cd80238$var$TYPE_RESPONSE,
                                    i: msg.i,
                                    e: error
                                })
                            ].concat((0, $aUGqu._)(extra)))
                        ];
                    case 10:
                        _state.sent();
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e2 = _state.sent();
                        if (((_options_onGeneralError2 = options.onGeneralError) === null || _options_onGeneralError2 === void 0 ? void 0 : _options_onGeneralError2.call(rpc, e2, method, args)) !== true) throw e2;
                        return [
                            3,
                            12
                        ];
                    case 12:
                        return [
                            3,
                            14
                        ];
                    case 13:
                        ack = msg.i, result1 = msg.r, error1 = msg.e;
                        promise = _rpcPromiseMap.get(ack);
                        if (promise) {
                            $1e15058b4cd80238$var$clearTimeout(promise.timeoutId);
                            if (error1) promise.reject(error1);
                            else promise.resolve(result1);
                        }
                        _rpcPromiseMap.delete(ack);
                        _state.label = 14;
                    case 14:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    _promiseInit = on(onMessage);
    return rpc;
}
var $1e15058b4cd80238$var$cacheMap = /* @__PURE__ */ new WeakMap();
function $1e15058b4cd80238$export$c26b4cbcfe84a428(items, fn) {
    return items.map(function(i) {
        var r = $1e15058b4cd80238$var$cacheMap.get(i);
        if (!r) {
            r = fn(i);
            $1e15058b4cd80238$var$cacheMap.set(i, r);
        }
        return r;
    });
}
function $1e15058b4cd80238$export$ec516731f3c62ae5(functions, channels) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var getChannels = function() {
        return typeof channels === "function" ? channels() : channels;
    };
    var getClients = function() {
        var channels2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getChannels();
        return $1e15058b4cd80238$export$c26b4cbcfe84a428(channels2, function(s) {
            return $1e15058b4cd80238$export$8de909a09ac6851a(functions, (0, $1XAnY._)({}, options, s));
        });
    };
    function _boardcast(method, args, event, optional) {
        var clients = getClients();
        return Promise.all(clients.map(function(c) {
            return c.$callRaw({
                method: method,
                args: args,
                event: event,
                optional: optional
            });
        }));
    }
    function $call(method) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return _boardcast(method, args, false);
    }
    function $callOptional(method) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return _boardcast(method, args, false, true);
    }
    function $callEvent(method) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        return _boardcast(method, args, true);
    }
    var broadcastBuiltin = {
        $call: $call,
        $callOptional: $callOptional,
        $callEvent: $callEvent
    };
    var broadcastProxy = new Proxy({}, {
        get: function(_, method) {
            if (Object.prototype.hasOwnProperty.call(broadcastBuiltin, method)) return broadcastBuiltin[method];
            var client = getClients();
            var callbacks = client.map(function(c) {
                return c[method];
            });
            var sendCall = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return Promise.all(callbacks.map(function(i) {
                    return i.apply(void 0, (0, $aUGqu._)(args));
                }));
            };
            sendCall.asEvent = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _i;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(callbacks.map(function(i) {
                                        return (_i = i).asEvent.apply(_i, (0, $aUGqu._)(args));
                                    }))
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            };
            return sendCall;
        }
    });
    function updateChannels(fn) {
        var channels2 = getChannels();
        fn === null || fn === void 0 ? void 0 : fn(channels2);
        return getClients(channels2);
    }
    getClients();
    return {
        get clients () {
            return getClients();
        },
        functions: functions,
        updateChannels: updateChannels,
        broadcast: broadcastProxy,
        /**
     * @deprecated use `broadcast`
     */ // @ts-expect-error deprecated
        boardcast: broadcastProxy
    };
}
function $1e15058b4cd80238$var$createPromiseWithResolvers() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}
var $1e15058b4cd80238$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
function $1e15058b4cd80238$var$nanoid() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $1e15058b4cd80238$var$urlAlphabet[$1e15058b4cd80238$var$random() * 64 | 0];
    return id;
}


var //#endregion
//#region src/core/component-inspector/index.ts
$26d6f2f8b43ea981$var$_target, //#endregion
//#region src/ctx/timeline.ts
$26d6f2f8b43ea981$var$_target1, //#endregion
//#region src/ctx/inspector.ts
$26d6f2f8b43ea981$var$_target2, //#endregion
//#region src/ctx/state.ts
$26d6f2f8b43ea981$var$_target3, $26d6f2f8b43ea981$var$_target4, $26d6f2f8b43ea981$var$_target5, $26d6f2f8b43ea981$var$_target6, $26d6f2f8b43ea981$var$_target7, $26d6f2f8b43ea981$var$_target8, $26d6f2f8b43ea981$var$_STATE_KEY, //#endregion
//#region src/ctx/plugin.ts
$26d6f2f8b43ea981$var$_target9, $26d6f2f8b43ea981$var$_target10, //#endregion
//#region src/core/plugin/index.ts
$26d6f2f8b43ea981$var$_target11, $26d6f2f8b43ea981$var$_target12, $26d6f2f8b43ea981$var$_ROUTER_INFO_KEY, $26d6f2f8b43ea981$var$_target13, $26d6f2f8b43ea981$var$_ROUTER_KEY, //#endregion
//#region src/ctx/env.ts
$26d6f2f8b43ea981$var$_target14, $26d6f2f8b43ea981$var$_target15, $26d6f2f8b43ea981$var$_target16, $26d6f2f8b43ea981$var$_target17, //#endregion
//#region src/messaging/index.ts
$26d6f2f8b43ea981$var$_target18, $26d6f2f8b43ea981$var$_target19, $26d6f2f8b43ea981$var$_target20, $26d6f2f8b43ea981$var$_target21, $26d6f2f8b43ea981$var$_target22, $26d6f2f8b43ea981$var$_target23;
//#region \0rolldown/runtime.js
var $26d6f2f8b43ea981$var$__create = Object.create;
var $26d6f2f8b43ea981$var$__defProp = Object.defineProperty;
var $26d6f2f8b43ea981$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $26d6f2f8b43ea981$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $26d6f2f8b43ea981$var$__getProtoOf = Object.getPrototypeOf;
var $26d6f2f8b43ea981$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $26d6f2f8b43ea981$var$__commonJSMin = function(cb, mod) {
    return function() {
        return mod || cb((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
};
var $26d6f2f8b43ea981$var$__copyProps = function(to, from, except, desc) {
    if (from && (typeof from === "undefined" ? "undefined" : (0, $7E0eS._)(from)) === "object" || typeof from === "function") for(var keys = $26d6f2f8b43ea981$var$__getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++){
        key = keys[i];
        if (!$26d6f2f8b43ea981$var$__hasOwnProp.call(to, key) && key !== except) $26d6f2f8b43ea981$var$__defProp(to, key, {
            get: (function(k) {
                return from[k];
            }).bind(null, key),
            enumerable: !(desc = $26d6f2f8b43ea981$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $26d6f2f8b43ea981$var$__toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? $26d6f2f8b43ea981$var$__create($26d6f2f8b43ea981$var$__getProtoOf(mod)) : {}, $26d6f2f8b43ea981$var$__copyProps(isNodeMode || !mod || !mod.__esModule ? $26d6f2f8b43ea981$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
//#endregion
//#region src/compat/index.ts
function $26d6f2f8b43ea981$var$onLegacyDevToolsPluginApiAvailable(cb) {
    if ((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__) {
        cb();
        return;
    }
    Object.defineProperty((0, $6430dea643e1c0c1$export$44271b4f0c6a3563), "__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__", {
        set: function(value) {
            if (value) cb();
        },
        configurable: true
    });
}
//#endregion
//#region src/core/component/utils/index.ts
function $26d6f2f8b43ea981$var$getComponentTypeName(options) {
    var _options___file;
    if (typeof options === "function") return options.displayName || options.name || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || "";
    var name = options.name || options._componentTag || options.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ || options.__name;
    if (name === "index" && ((_options___file = options.__file) === null || _options___file === void 0 ? void 0 : _options___file.endsWith("index.vue"))) return "";
    return name;
}
function $26d6f2f8b43ea981$var$getComponentFileName(options) {
    var file = options.__file;
    if (file) return (0, $6430dea643e1c0c1$export$b04d9b8d414ba5e8)((0, $6430dea643e1c0c1$export$9bf319d8f74f51d1)(file, ".vue"));
}
function $26d6f2f8b43ea981$var$getComponentName(options) {
    var name = options.displayName || options.name || options._componentTag;
    if (name) return name;
    return $26d6f2f8b43ea981$var$getComponentFileName(options);
}
function $26d6f2f8b43ea981$var$saveComponentGussedName(instance, name) {
    instance.type.__VUE_DEVTOOLS_COMPONENT_GUSSED_NAME__ = name;
    return name;
}
function $26d6f2f8b43ea981$var$getAppRecord(instance) {
    if (instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__) return instance.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
    else if (instance.root) return instance.appContext.app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
}
function $26d6f2f8b43ea981$var$getComponentId(options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var app, uid, instance, appRecord, isRoot, e;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    app = options.app, uid = options.uid, instance = options.instance;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    if (instance.__VUE_DEVTOOLS_NEXT_UID__) return [
                        2,
                        instance.__VUE_DEVTOOLS_NEXT_UID__
                    ];
                    return [
                        4,
                        $26d6f2f8b43ea981$var$getAppRecord(app)
                    ];
                case 2:
                    appRecord = _state.sent();
                    if (!appRecord) return [
                        2,
                        null
                    ];
                    isRoot = appRecord.rootInstance === instance;
                    return [
                        2,
                        "".concat(appRecord.id, ":").concat(isRoot ? "root" : uid)
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $26d6f2f8b43ea981$var$isFragment(instance) {
    var _instance_subTree, _appRecord_types;
    var subTreeType = (_instance_subTree = instance.subTree) === null || _instance_subTree === void 0 ? void 0 : _instance_subTree.type;
    var appRecord = $26d6f2f8b43ea981$var$getAppRecord(instance);
    if (appRecord) return (appRecord === null || appRecord === void 0 ? void 0 : (_appRecord_types = appRecord.types) === null || _appRecord_types === void 0 ? void 0 : _appRecord_types.Fragment) === subTreeType;
    return false;
}
function $26d6f2f8b43ea981$var$isBeingDestroyed(instance) {
    return instance._isBeingDestroyed || instance.isUnmounted;
}
/**
* Get the appropriate display name for an instance.
*
* @param {Vue} instance
* @return {string}
*/ function $26d6f2f8b43ea981$var$getInstanceName(instance) {
    var _instance_parent_type, _instance_parent, _instance_appContext;
    var name = $26d6f2f8b43ea981$var$getComponentTypeName((instance === null || instance === void 0 ? void 0 : instance.type) || {});
    if (name) return name;
    if ((instance === null || instance === void 0 ? void 0 : instance.root) === instance) return "Root";
    for(var key in (_instance_parent = instance.parent) === null || _instance_parent === void 0 ? void 0 : (_instance_parent_type = _instance_parent.type) === null || _instance_parent_type === void 0 ? void 0 : _instance_parent_type.components)if (instance.parent.type.components[key] === (instance === null || instance === void 0 ? void 0 : instance.type)) return $26d6f2f8b43ea981$var$saveComponentGussedName(instance, key);
    for(var key1 in (_instance_appContext = instance.appContext) === null || _instance_appContext === void 0 ? void 0 : _instance_appContext.components)if (instance.appContext.components[key1] === (instance === null || instance === void 0 ? void 0 : instance.type)) return $26d6f2f8b43ea981$var$saveComponentGussedName(instance, key1);
    var fileName = $26d6f2f8b43ea981$var$getComponentFileName((instance === null || instance === void 0 ? void 0 : instance.type) || {});
    if (fileName) return fileName;
    return "Anonymous Component";
}
/**
* Returns a devtools unique id for instance.
* @param {Vue} instance
*/ function $26d6f2f8b43ea981$var$getUniqueComponentId(instance) {
    var _instance_appContext_app, _instance_appContext;
    var _instance_appContext_app___VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    return "".concat((_instance_appContext_app___VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ = instance === null || instance === void 0 ? void 0 : (_instance_appContext = instance.appContext) === null || _instance_appContext === void 0 ? void 0 : (_instance_appContext_app = _instance_appContext.app) === null || _instance_appContext_app === void 0 ? void 0 : _instance_appContext_app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__) !== null && _instance_appContext_app___VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ !== void 0 ? _instance_appContext_app___VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ : 0, ":").concat(instance === (instance === null || instance === void 0 ? void 0 : instance.root) ? "root" : instance.uid);
}
function $26d6f2f8b43ea981$var$getRenderKey(value) {
    if (value == null) return "";
    if (typeof value === "number") return value;
    else if (typeof value === "string") return "'".concat(value, "'");
    else if (Array.isArray(value)) return "Array";
    else return "Object";
}
function $26d6f2f8b43ea981$var$returnError(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
function $26d6f2f8b43ea981$var$getComponentInstance(appRecord, instanceId) {
    instanceId = instanceId || "".concat(appRecord.id, ":root");
    return appRecord.instanceMap.get(instanceId) || appRecord.instanceMap.get(":root");
}
function $26d6f2f8b43ea981$var$ensurePropertyExists(obj, key) {
    var skipObjCheck = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return skipObjCheck ? key in obj : (typeof obj === "undefined" ? "undefined" : (0, $7E0eS._)(obj)) === "object" && obj !== null ? key in obj : false;
}
//#endregion
//#region src/core/component/state/bounding-rect.ts
function $26d6f2f8b43ea981$var$createRect() {
    var rect = {
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        get width () {
            return rect.right - rect.left;
        },
        get height () {
            return rect.bottom - rect.top;
        }
    };
    return rect;
}
var $26d6f2f8b43ea981$var$range;
function $26d6f2f8b43ea981$var$getTextRect(node) {
    if (!$26d6f2f8b43ea981$var$range) $26d6f2f8b43ea981$var$range = document.createRange();
    $26d6f2f8b43ea981$var$range.selectNode(node);
    return $26d6f2f8b43ea981$var$range.getBoundingClientRect();
}
function $26d6f2f8b43ea981$var$getFragmentRect(vnode) {
    var rect = $26d6f2f8b43ea981$var$createRect();
    if (!vnode.children) return rect;
    for(var i = 0, l = vnode.children.length; i < l; i++){
        var childVnode = vnode.children[i];
        var childRect = void 0;
        if (childVnode.component) childRect = $26d6f2f8b43ea981$var$getComponentBoundingRect(childVnode.component);
        else if (childVnode.el) {
            var el = childVnode.el;
            if (el.nodeType === 1 || el.getBoundingClientRect) childRect = el.getBoundingClientRect();
            else if (el.nodeType === 3 && el.data.trim()) childRect = $26d6f2f8b43ea981$var$getTextRect(el);
        }
        if (childRect) $26d6f2f8b43ea981$var$mergeRects(rect, childRect);
    }
    return rect;
}
function $26d6f2f8b43ea981$var$mergeRects(a, b) {
    if (!a.top || b.top < a.top) a.top = b.top;
    if (!a.bottom || b.bottom > a.bottom) a.bottom = b.bottom;
    if (!a.left || b.left < a.left) a.left = b.left;
    if (!a.right || b.right > a.right) a.right = b.right;
    return a;
}
var $26d6f2f8b43ea981$var$DEFAULT_RECT = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
};
function $26d6f2f8b43ea981$var$getComponentBoundingRect(instance) {
    var el = instance.subTree.el;
    if (typeof window === "undefined") return $26d6f2f8b43ea981$var$DEFAULT_RECT;
    if ($26d6f2f8b43ea981$var$isFragment(instance)) return $26d6f2f8b43ea981$var$getFragmentRect(instance.subTree);
    else if ((el === null || el === void 0 ? void 0 : el.nodeType) === 1) return el === null || el === void 0 ? void 0 : el.getBoundingClientRect();
    else if (instance.subTree.component) return $26d6f2f8b43ea981$var$getComponentBoundingRect(instance.subTree.component);
    else return $26d6f2f8b43ea981$var$DEFAULT_RECT;
}
//#endregion
//#region src/core/component/tree/el.ts
function $26d6f2f8b43ea981$var$getRootElementsFromComponentInstance(instance) {
    if ($26d6f2f8b43ea981$var$isFragment(instance)) return $26d6f2f8b43ea981$var$getFragmentRootElements(instance.subTree);
    if (!instance.subTree) return [];
    return [
        instance.subTree.el
    ];
}
function $26d6f2f8b43ea981$var$getFragmentRootElements(vnode) {
    if (!vnode.children) return [];
    var list = [];
    vnode.children.forEach(function(childVnode) {
        var _list;
        if (childVnode.component) (_list = list).push.apply(_list, (0, $aUGqu._)($26d6f2f8b43ea981$var$getRootElementsFromComponentInstance(childVnode.component)));
        else if (childVnode === null || childVnode === void 0 ? void 0 : childVnode.el) list.push(childVnode.el);
    });
    return list;
}
//#endregion
//#region src/core/component-highlighter/index.ts
var $26d6f2f8b43ea981$var$CONTAINER_ELEMENT_ID = "__vue-devtools-component-inspector__";
var $26d6f2f8b43ea981$var$CARD_ELEMENT_ID = "__vue-devtools-component-inspector__card__";
var $26d6f2f8b43ea981$var$COMPONENT_NAME_ELEMENT_ID = "__vue-devtools-component-inspector__name__";
var $26d6f2f8b43ea981$var$INDICATOR_ELEMENT_ID = "__vue-devtools-component-inspector__indicator__";
var $26d6f2f8b43ea981$var$containerStyles = {
    display: "block",
    zIndex: 2147483640,
    position: "fixed",
    backgroundColor: "#42b88325",
    border: "1px solid #42b88350",
    borderRadius: "5px",
    transition: "all 0.1s ease-in",
    pointerEvents: "none"
};
var $26d6f2f8b43ea981$var$cardStyles = {
    fontFamily: "Arial, Helvetica, sans-serif",
    padding: "5px 8px",
    borderRadius: "4px",
    textAlign: "left",
    position: "absolute",
    left: 0,
    color: "#e9e9e9",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "24px",
    backgroundColor: "#42b883",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
};
var $26d6f2f8b43ea981$var$indicatorStyles = {
    display: "inline-block",
    fontWeight: 400,
    fontStyle: "normal",
    fontSize: "12px",
    opacity: .7
};
function $26d6f2f8b43ea981$var$getContainerElement() {
    return document.getElementById($26d6f2f8b43ea981$var$CONTAINER_ELEMENT_ID);
}
function $26d6f2f8b43ea981$var$getCardElement() {
    return document.getElementById($26d6f2f8b43ea981$var$CARD_ELEMENT_ID);
}
function $26d6f2f8b43ea981$var$getIndicatorElement() {
    return document.getElementById($26d6f2f8b43ea981$var$INDICATOR_ELEMENT_ID);
}
function $26d6f2f8b43ea981$var$getNameElement() {
    return document.getElementById($26d6f2f8b43ea981$var$COMPONENT_NAME_ELEMENT_ID);
}
function $26d6f2f8b43ea981$var$getStyles(bounds) {
    return {
        left: "".concat(Math.round(bounds.left * 100) / 100, "px"),
        top: "".concat(Math.round(bounds.top * 100) / 100, "px"),
        width: "".concat(Math.round(bounds.width * 100) / 100, "px"),
        height: "".concat(Math.round(bounds.height * 100) / 100, "px")
    };
}
function $26d6f2f8b43ea981$var$create(options) {
    var containerEl = document.createElement("div");
    var _options_elementId;
    containerEl.id = (_options_elementId = options.elementId) !== null && _options_elementId !== void 0 ? _options_elementId : $26d6f2f8b43ea981$var$CONTAINER_ELEMENT_ID;
    Object.assign(containerEl.style, (0, $1XAnY._)({}, $26d6f2f8b43ea981$var$containerStyles, $26d6f2f8b43ea981$var$getStyles(options.bounds), options.style));
    var cardEl = document.createElement("span");
    cardEl.id = $26d6f2f8b43ea981$var$CARD_ELEMENT_ID;
    Object.assign(cardEl.style, (0, $6fpqi._)((0, $1XAnY._)({}, $26d6f2f8b43ea981$var$cardStyles), {
        top: options.bounds.top < 35 ? 0 : "-35px"
    }));
    var nameEl = document.createElement("span");
    nameEl.id = $26d6f2f8b43ea981$var$COMPONENT_NAME_ELEMENT_ID;
    nameEl.innerHTML = "&lt;".concat(options.name, "&gt;&nbsp;&nbsp;");
    var indicatorEl = document.createElement("i");
    indicatorEl.id = $26d6f2f8b43ea981$var$INDICATOR_ELEMENT_ID;
    indicatorEl.innerHTML = "".concat(Math.round(options.bounds.width * 100) / 100, " x ").concat(Math.round(options.bounds.height * 100) / 100);
    Object.assign(indicatorEl.style, $26d6f2f8b43ea981$var$indicatorStyles);
    cardEl.appendChild(nameEl);
    cardEl.appendChild(indicatorEl);
    containerEl.appendChild(cardEl);
    document.body.appendChild(containerEl);
    return containerEl;
}
function $26d6f2f8b43ea981$var$update(options) {
    var containerEl = $26d6f2f8b43ea981$var$getContainerElement();
    var cardEl = $26d6f2f8b43ea981$var$getCardElement();
    var nameEl = $26d6f2f8b43ea981$var$getNameElement();
    var indicatorEl = $26d6f2f8b43ea981$var$getIndicatorElement();
    if (containerEl) {
        Object.assign(containerEl.style, (0, $1XAnY._)({}, $26d6f2f8b43ea981$var$containerStyles, $26d6f2f8b43ea981$var$getStyles(options.bounds)));
        Object.assign(cardEl.style, {
            top: options.bounds.top < 35 ? 0 : "-35px"
        });
        nameEl.innerHTML = "&lt;".concat(options.name, "&gt;&nbsp;&nbsp;");
        indicatorEl.innerHTML = "".concat(Math.round(options.bounds.width * 100) / 100, " x ").concat(Math.round(options.bounds.height * 100) / 100);
    }
}
function $26d6f2f8b43ea981$var$highlight(instance) {
    var bounds = $26d6f2f8b43ea981$var$getComponentBoundingRect(instance);
    if (!bounds.width && !bounds.height) return;
    var name = $26d6f2f8b43ea981$var$getInstanceName(instance);
    $26d6f2f8b43ea981$var$getContainerElement() ? $26d6f2f8b43ea981$var$update({
        bounds: bounds,
        name: name
    }) : $26d6f2f8b43ea981$var$create({
        bounds: bounds,
        name: name
    });
}
function $26d6f2f8b43ea981$var$unhighlight() {
    var el = $26d6f2f8b43ea981$var$getContainerElement();
    if (el) el.style.display = "none";
}
var $26d6f2f8b43ea981$var$inspectInstance = null;
function $26d6f2f8b43ea981$var$inspectFn(e) {
    var _$target = e.target;
    if (_$target) {
        var instance = _$target.__vueParentComponent;
        if (instance) {
            $26d6f2f8b43ea981$var$inspectInstance = instance;
            if (instance.vnode.el) {
                var bounds = $26d6f2f8b43ea981$var$getComponentBoundingRect(instance);
                var name = $26d6f2f8b43ea981$var$getInstanceName(instance);
                $26d6f2f8b43ea981$var$getContainerElement() ? $26d6f2f8b43ea981$var$update({
                    bounds: bounds,
                    name: name
                }) : $26d6f2f8b43ea981$var$create({
                    bounds: bounds,
                    name: name
                });
            }
        }
    }
}
function $26d6f2f8b43ea981$var$selectComponentFn(e, cb) {
    e.preventDefault();
    e.stopPropagation();
    if ($26d6f2f8b43ea981$var$inspectInstance) cb($26d6f2f8b43ea981$var$getUniqueComponentId($26d6f2f8b43ea981$var$inspectInstance));
}
var $26d6f2f8b43ea981$var$inspectComponentHighLighterSelectFn = null;
function $26d6f2f8b43ea981$var$cancelInspectComponentHighLighter() {
    $26d6f2f8b43ea981$var$unhighlight();
    window.removeEventListener("mouseover", $26d6f2f8b43ea981$var$inspectFn);
    window.removeEventListener("click", $26d6f2f8b43ea981$var$inspectComponentHighLighterSelectFn, true);
    $26d6f2f8b43ea981$var$inspectComponentHighLighterSelectFn = null;
}
function $26d6f2f8b43ea981$var$inspectComponentHighLighter() {
    window.addEventListener("mouseover", $26d6f2f8b43ea981$var$inspectFn);
    return new Promise(function(resolve) {
        function onSelect(e) {
            e.preventDefault();
            e.stopPropagation();
            $26d6f2f8b43ea981$var$selectComponentFn(e, function(id) {
                window.removeEventListener("click", onSelect, true);
                $26d6f2f8b43ea981$var$inspectComponentHighLighterSelectFn = null;
                window.removeEventListener("mouseover", $26d6f2f8b43ea981$var$inspectFn);
                var el = $26d6f2f8b43ea981$var$getContainerElement();
                if (el) el.style.display = "none";
                resolve(JSON.stringify({
                    id: id
                }));
            });
        }
        $26d6f2f8b43ea981$var$inspectComponentHighLighterSelectFn = onSelect;
        window.addEventListener("click", onSelect, true);
    });
}
function $26d6f2f8b43ea981$var$scrollToComponent(options) {
    var instance = $26d6f2f8b43ea981$var$getComponentInstance($26d6f2f8b43ea981$export$162128841a7f2877.value, options.id);
    if (instance) {
        var _getRootElementsFromComponentInstance = (0, $f9AOD._)($26d6f2f8b43ea981$var$getRootElementsFromComponentInstance(instance), 1), el = _getRootElementsFromComponentInstance[0];
        if (typeof el.scrollIntoView === "function") el.scrollIntoView({
            behavior: "smooth"
        });
        else {
            var bounds = $26d6f2f8b43ea981$var$getComponentBoundingRect(instance);
            var scrollTarget = document.createElement("div");
            var styles = (0, $6fpqi._)((0, $1XAnY._)({}, $26d6f2f8b43ea981$var$getStyles(bounds)), {
                position: "absolute"
            });
            Object.assign(scrollTarget.style, styles);
            document.body.appendChild(scrollTarget);
            scrollTarget.scrollIntoView({
                behavior: "smooth"
            });
            setTimeout(function() {
                document.body.removeChild(scrollTarget);
            }, 2e3);
        }
        setTimeout(function() {
            var bounds = $26d6f2f8b43ea981$var$getComponentBoundingRect(instance);
            if (bounds.width || bounds.height) {
                var name = $26d6f2f8b43ea981$var$getInstanceName(instance);
                var el = $26d6f2f8b43ea981$var$getContainerElement();
                el ? $26d6f2f8b43ea981$var$update((0, $6fpqi._)((0, $1XAnY._)({}, options), {
                    name: name,
                    bounds: bounds
                })) : $26d6f2f8b43ea981$var$create((0, $6fpqi._)((0, $1XAnY._)({}, options), {
                    name: name,
                    bounds: bounds
                }));
                setTimeout(function() {
                    if (el) el.style.display = "none";
                }, 1500);
            }
        }, 1200);
    }
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = ($26d6f2f8b43ea981$var$_target = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ : $26d6f2f8b43ea981$var$_target.__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = true;
function $26d6f2f8b43ea981$export$56455f68fb6e3b63(enabled) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_COMPONENT_INSPECTOR_ENABLED__ = enabled;
}
function $26d6f2f8b43ea981$var$waitForInspectorInit(cb) {
    var total = 0;
    var timer = setInterval(function() {
        if ((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_INSPECTOR__) {
            clearInterval(timer);
            total += 30;
            cb();
        }
        if (total >= 5e3) clearInterval(timer);
    }, 30);
}
function $26d6f2f8b43ea981$var$setupInspector() {
    var inspector = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_INSPECTOR__;
    var _openInEditor = inspector.openInEditor;
    inspector.openInEditor = function() {
        for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
            params[_key] = arguments[_key];
        }
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                inspector.disable();
                _openInEditor.apply(void 0, (0, $aUGqu._)(params));
                return [
                    2
                ];
            });
        })();
    };
}
function $26d6f2f8b43ea981$var$getComponentInspector() {
    return new Promise(function(resolve) {
        function setup() {
            $26d6f2f8b43ea981$var$setupInspector();
            resolve((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_INSPECTOR__);
        }
        if (!(0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_INSPECTOR__) $26d6f2f8b43ea981$var$waitForInspectorInit(function() {
            setup();
        });
        else setup();
    });
}
//#endregion
//#region src/shared/stub-vue.ts
/**
* To prevent include a **HUGE** vue package in the final bundle of chrome ext / electron
* we stub the necessary vue module.
* This implementation is based on the 1c3327a0fa5983aa9078e3f7bb2330f572435425 commit
*/ /**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/constants.ts#L17-L23)
*/ var $26d6f2f8b43ea981$var$ReactiveFlags = /* @__PURE__ */ function(ReactiveFlags) {
    ReactiveFlags["SKIP"] = "__v_skip";
    ReactiveFlags["IS_REACTIVE"] = "__v_isReactive";
    ReactiveFlags["IS_READONLY"] = "__v_isReadonly";
    ReactiveFlags["IS_SHALLOW"] = "__v_isShallow";
    ReactiveFlags["RAW"] = "__v_raw";
    return ReactiveFlags;
}({});
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L330-L332)
*/ function $26d6f2f8b43ea981$var$isReadonly(value) {
    return !!(value && value[$26d6f2f8b43ea981$var$ReactiveFlags.IS_READONLY]);
}
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L312-L317)
*/ function $26d6f2f8b43ea981$var$isReactive$1(value) {
    if ($26d6f2f8b43ea981$var$isReadonly(value)) return $26d6f2f8b43ea981$var$isReactive$1(value[$26d6f2f8b43ea981$var$ReactiveFlags.RAW]);
    return !!(value && value[$26d6f2f8b43ea981$var$ReactiveFlags.IS_REACTIVE]);
}
function $26d6f2f8b43ea981$var$isRef$1(r) {
    return !!(r && r.__v_isRef === true);
}
/**
* @from [@vue/reactivity](https://github.com/vuejs/core/blob/1c3327a0fa5983aa9078e3f7bb2330f572435425/packages/reactivity/src/reactive.ts#L372-L375)
*/ function $26d6f2f8b43ea981$var$toRaw$1(observed) {
    var raw = observed && observed[$26d6f2f8b43ea981$var$ReactiveFlags.RAW];
    return raw ? $26d6f2f8b43ea981$var$toRaw$1(raw) : observed;
}
//#endregion
//#region src/core/component/state/editor.ts
var $26d6f2f8b43ea981$var$StateEditor = /*#__PURE__*/ function() {
    "use strict";
    function StateEditor() {
        (0, $173N4._)(this, StateEditor);
        this.refEditor = new $26d6f2f8b43ea981$var$RefStateEditor();
    }
    (0, $cFHGC._)(StateEditor, [
        {
            key: "set",
            value: function set(object, path, value, cb) {
                var sections = Array.isArray(path) ? path : path.split(".");
                while(sections.length > 1){
                    var section = sections.shift();
                    if (object instanceof Map) object = object.get(section);
                    else if (object instanceof Set) object = Array.from(object.values())[section];
                    else object = object[section];
                    if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
                }
                var field = sections[0];
                var item = this.refEditor.get(object)[field];
                if (cb) cb(object, field, value);
                else if (this.refEditor.isRef(item)) this.refEditor.set(item, value);
                else object[field] = value;
            }
        },
        {
            key: "get",
            value: function get(object, path) {
                var sections = Array.isArray(path) ? path : path.split(".");
                for(var i = 0; i < sections.length; i++){
                    if (object instanceof Map) object = object.get(sections[i]);
                    else object = object[sections[i]];
                    if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
                    if (!object) return void 0;
                }
                return object;
            }
        },
        {
            key: "has",
            value: function has(object, path) {
                var parent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (typeof object === "undefined") return false;
                var sections = Array.isArray(path) ? path.slice() : path.split(".");
                var size = !parent ? 1 : 2;
                while(object && sections.length > size){
                    var section = sections.shift();
                    object = object[section];
                    if (this.refEditor.isRef(object)) object = this.refEditor.get(object);
                }
                return object != null && Object.prototype.hasOwnProperty.call(object, sections[0]);
            }
        },
        {
            key: "createDefaultSetCallback",
            value: function createDefaultSetCallback(state) {
                var _this = this;
                return function(object, field, value) {
                    if (state.remove || state.newKey) {
                        if (Array.isArray(object)) object.splice(field, 1);
                        else if ($26d6f2f8b43ea981$var$toRaw$1(object) instanceof Map) object.delete(field);
                        else if ($26d6f2f8b43ea981$var$toRaw$1(object) instanceof Set) object.delete(Array.from(object.values())[field]);
                        else Reflect.deleteProperty(object, field);
                    }
                    if (!state.remove) {
                        var _$target = object[state.newKey || field];
                        if (_this.refEditor.isRef(_$target)) _this.refEditor.set(_$target, value);
                        else if ($26d6f2f8b43ea981$var$toRaw$1(object) instanceof Map) object.set(state.newKey || field, value);
                        else if ($26d6f2f8b43ea981$var$toRaw$1(object) instanceof Set) object.add(value);
                        else object[state.newKey || field] = value;
                    }
                };
            }
        }
    ]);
    return StateEditor;
}();
var $26d6f2f8b43ea981$var$RefStateEditor = /*#__PURE__*/ function() {
    "use strict";
    function RefStateEditor() {
        (0, $173N4._)(this, RefStateEditor);
    }
    (0, $cFHGC._)(RefStateEditor, [
        {
            key: "set",
            value: function set(ref, value) {
                if ($26d6f2f8b43ea981$var$isRef$1(ref)) ref.value = value;
                else {
                    if (ref instanceof Set && Array.isArray(value)) {
                        ref.clear();
                        value.forEach(function(v) {
                            return ref.add(v);
                        });
                        return;
                    }
                    var currentKeys = Object.keys(value);
                    if (ref instanceof Map) {
                        var previousKeysSet = new Set(ref.keys());
                        currentKeys.forEach(function(key) {
                            ref.set(key, Reflect.get(value, key));
                            previousKeysSet.delete(key);
                        });
                        previousKeysSet.forEach(function(key) {
                            return ref.delete(key);
                        });
                        return;
                    }
                    var previousKeysSet1 = new Set(Object.keys(ref));
                    currentKeys.forEach(function(key) {
                        Reflect.set(ref, key, Reflect.get(value, key));
                        previousKeysSet1.delete(key);
                    });
                    previousKeysSet1.forEach(function(key) {
                        return Reflect.deleteProperty(ref, key);
                    });
                }
            }
        },
        {
            key: "get",
            value: function get(ref) {
                return $26d6f2f8b43ea981$var$isRef$1(ref) ? ref.value : ref;
            }
        },
        {
            key: "isRef",
            value: function isRef(ref) {
                return $26d6f2f8b43ea981$var$isRef$1(ref) || $26d6f2f8b43ea981$var$isReactive$1(ref);
            }
        }
    ]);
    return RefStateEditor;
}();
function $26d6f2f8b43ea981$var$editComponentState(payload, stateEditor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var path, nodeId, state, type, instance, targetPath, _$target;
        return (0, $13u2V._)(this, function(_state) {
            path = payload.path, nodeId = payload.nodeId, state = payload.state, type = payload.type;
            instance = $26d6f2f8b43ea981$var$getComponentInstance($26d6f2f8b43ea981$export$162128841a7f2877.value, nodeId);
            if (!instance) return [
                2
            ];
            targetPath = path.slice();
            if (Object.keys(instance.props).includes(path[0])) _$target = instance.props;
            else if (instance.devtoolsRawSetupState && Object.keys(instance.devtoolsRawSetupState).includes(path[0])) _$target = instance.devtoolsRawSetupState;
            else if (instance.data && Object.keys(instance.data).includes(path[0])) _$target = instance.data;
            else _$target = instance.proxy;
            if (_$target && targetPath) {
                state.type === "object" && type;
                stateEditor.set(_$target, targetPath, state.value, stateEditor.createDefaultSetCallback(state));
            }
            return [
                2
            ];
        });
    })();
}
var $26d6f2f8b43ea981$var$stateEditor = new $26d6f2f8b43ea981$var$StateEditor();
function $26d6f2f8b43ea981$var$editState(payload) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        return (0, $13u2V._)(this, function(_state) {
            $26d6f2f8b43ea981$var$editComponentState(payload, $26d6f2f8b43ea981$var$stateEditor);
            return [
                2
            ];
        });
    })();
}
//#endregion
//#region src/core/timeline/storage.ts
var $26d6f2f8b43ea981$var$TIMELINE_LAYERS_STATE_STORAGE_ID = "__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS_STATE__";
function $26d6f2f8b43ea981$var$addTimelineLayersStateToStorage(state) {
    if (!(0, $6430dea643e1c0c1$export$4e09c449d6c407f7) || typeof localStorage === "undefined" || localStorage === null) return;
    localStorage.setItem($26d6f2f8b43ea981$var$TIMELINE_LAYERS_STATE_STORAGE_ID, JSON.stringify(state));
}
function $26d6f2f8b43ea981$var$getTimelineLayersStateFromStorage() {
    if (typeof window === "undefined" || !(0, $6430dea643e1c0c1$export$4e09c449d6c407f7) || typeof localStorage === "undefined" || localStorage === null) return {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
    var state = typeof localStorage.getItem !== "undefined" ? localStorage.getItem($26d6f2f8b43ea981$var$TIMELINE_LAYERS_STATE_STORAGE_ID) : null;
    return state ? JSON.parse(state) : {
        recordingState: false,
        mouseEventEnabled: false,
        keyboardEventEnabled: false,
        componentEventEnabled: false,
        performanceEventEnabled: false,
        selected: ""
    };
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_TIMELINE_LAYERS;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = ($26d6f2f8b43ea981$var$_target1 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_TIMELINE_LAYERS !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_TIMELINE_LAYERS : $26d6f2f8b43ea981$var$_target1.__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS = [];
var $26d6f2f8b43ea981$var$devtoolsTimelineLayers = new Proxy((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_TIMELINE_LAYERS, {
    get: function(target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
function $26d6f2f8b43ea981$var$addTimelineLayer(options, descriptor) {
    $26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState[descriptor.id] = false;
    $26d6f2f8b43ea981$var$devtoolsTimelineLayers.push((0, $6fpqi._)((0, $1XAnY._)({}, options), {
        descriptorId: descriptor.id,
        appRecord: $26d6f2f8b43ea981$var$getAppRecord(descriptor.app)
    }));
}
function $26d6f2f8b43ea981$export$736910b7e8839d93(state) {
    var updatedState = (0, $1XAnY._)({}, $26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState, state);
    $26d6f2f8b43ea981$var$addTimelineLayersStateToStorage(updatedState);
    $26d6f2f8b43ea981$export$ee22a7aaf6b41ce2({
        timelineLayersState: updatedState
    });
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_INSPECTOR__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_INSPECTOR__ = ($26d6f2f8b43ea981$var$_target2 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_INSPECTOR__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_INSPECTOR__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_INSPECTOR__ : $26d6f2f8b43ea981$var$_target2.__VUE_DEVTOOLS_KIT_INSPECTOR__ = [];
var $26d6f2f8b43ea981$export$996e3c8abad0143f = new Proxy((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_INSPECTOR__, {
    get: function(target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
var $26d6f2f8b43ea981$export$17f8005932e80cc0 = (0, $062babd0a85d9d9b$export$61fc7d43ac8f84b0)(function() {
    $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.callHook($26d6f2f8b43ea981$export$12aa7e661bddec80.SEND_INSPECTOR_TO_CLIENT, $26d6f2f8b43ea981$export$2844c7432ba9d166());
});
function $26d6f2f8b43ea981$export$e863e3b6c2ff029b(inspector, descriptor) {
    var _inspector_treeFilterPlaceholder, _inspector_stateFilterPlaceholder;
    $26d6f2f8b43ea981$export$996e3c8abad0143f.push({
        options: inspector,
        descriptor: descriptor,
        treeFilterPlaceholder: (_inspector_treeFilterPlaceholder = inspector.treeFilterPlaceholder) !== null && _inspector_treeFilterPlaceholder !== void 0 ? _inspector_treeFilterPlaceholder : "Search tree...",
        stateFilterPlaceholder: (_inspector_stateFilterPlaceholder = inspector.stateFilterPlaceholder) !== null && _inspector_stateFilterPlaceholder !== void 0 ? _inspector_stateFilterPlaceholder : "Search state...",
        treeFilter: "",
        selectedNodeId: "",
        appRecord: $26d6f2f8b43ea981$var$getAppRecord(descriptor.app)
    });
    $26d6f2f8b43ea981$export$17f8005932e80cc0();
}
function $26d6f2f8b43ea981$export$2844c7432ba9d166() {
    return $26d6f2f8b43ea981$export$996e3c8abad0143f.filter(function(inspector) {
        return inspector.descriptor.app === $26d6f2f8b43ea981$export$162128841a7f2877.value.app;
    }).filter(function(inspector) {
        return inspector.descriptor.id !== "components";
    }).map(function(inspector) {
        var _options_icon;
        var descriptor = inspector.descriptor;
        var options = inspector.options;
        return {
            id: options.id,
            label: options.label,
            logo: descriptor.logo,
            icon: "custom-ic-baseline-".concat(options === null || options === void 0 ? void 0 : (_options_icon = options.icon) === null || _options_icon === void 0 ? void 0 : _options_icon.replace(/_/g, "-")),
            packageName: descriptor.packageName,
            homepage: descriptor.homepage,
            pluginId: descriptor.id
        };
    });
}
function $26d6f2f8b43ea981$export$5042bdc6f02e4304(id) {
    var inspector = $26d6f2f8b43ea981$export$aa4140d0f5ce4bbe(id, $26d6f2f8b43ea981$export$162128841a7f2877.value.app);
    if (!inspector) return;
    var descriptor = inspector.descriptor;
    var options = inspector.options;
    var timelineLayers = $26d6f2f8b43ea981$var$devtoolsTimelineLayers.filter(function(layer) {
        return layer.descriptorId === descriptor.id;
    }).map(function(item) {
        return {
            id: item.id,
            label: item.label,
            color: item.color
        };
    });
    return {
        id: options.id,
        label: options.label,
        logo: descriptor.logo,
        packageName: descriptor.packageName,
        homepage: descriptor.homepage,
        timelineLayers: timelineLayers,
        treeFilterPlaceholder: inspector.treeFilterPlaceholder,
        stateFilterPlaceholder: inspector.stateFilterPlaceholder
    };
}
function $26d6f2f8b43ea981$export$aa4140d0f5ce4bbe(id, app) {
    return $26d6f2f8b43ea981$export$996e3c8abad0143f.find(function(inspector) {
        return inspector.options.id === id && (app ? inspector.descriptor.app === app : true);
    });
}
function $26d6f2f8b43ea981$export$54eb86d2eca92815(id) {
    var _getInspector;
    return (_getInspector = $26d6f2f8b43ea981$export$aa4140d0f5ce4bbe(id)) === null || _getInspector === void 0 ? void 0 : _getInspector.options.actions;
}
function $26d6f2f8b43ea981$export$eebdca42b352a0b2(id) {
    var _getInspector;
    return (_getInspector = $26d6f2f8b43ea981$export$aa4140d0f5ce4bbe(id)) === null || _getInspector === void 0 ? void 0 : _getInspector.options.nodeActions;
}
//#endregion
//#region src/ctx/hook.ts
var $26d6f2f8b43ea981$export$3936435a794cb908 = /* @__PURE__ */ function(DevToolsV6PluginAPIHookKeys) {
    DevToolsV6PluginAPIHookKeys["VISIT_COMPONENT_TREE"] = "visitComponentTree";
    DevToolsV6PluginAPIHookKeys["INSPECT_COMPONENT"] = "inspectComponent";
    DevToolsV6PluginAPIHookKeys["EDIT_COMPONENT_STATE"] = "editComponentState";
    DevToolsV6PluginAPIHookKeys["GET_INSPECTOR_TREE"] = "getInspectorTree";
    DevToolsV6PluginAPIHookKeys["GET_INSPECTOR_STATE"] = "getInspectorState";
    DevToolsV6PluginAPIHookKeys["EDIT_INSPECTOR_STATE"] = "editInspectorState";
    DevToolsV6PluginAPIHookKeys["INSPECT_TIMELINE_EVENT"] = "inspectTimelineEvent";
    DevToolsV6PluginAPIHookKeys["TIMELINE_CLEARED"] = "timelineCleared";
    DevToolsV6PluginAPIHookKeys["SET_PLUGIN_SETTINGS"] = "setPluginSettings";
    return DevToolsV6PluginAPIHookKeys;
}({});
var $26d6f2f8b43ea981$export$4c35c03df042a977 = /* @__PURE__ */ function(DevToolsContextHookKeys) {
    DevToolsContextHookKeys["ADD_INSPECTOR"] = "addInspector";
    DevToolsContextHookKeys["SEND_INSPECTOR_TREE"] = "sendInspectorTree";
    DevToolsContextHookKeys["SEND_INSPECTOR_STATE"] = "sendInspectorState";
    DevToolsContextHookKeys["CUSTOM_INSPECTOR_SELECT_NODE"] = "customInspectorSelectNode";
    DevToolsContextHookKeys["TIMELINE_LAYER_ADDED"] = "timelineLayerAdded";
    DevToolsContextHookKeys["TIMELINE_EVENT_ADDED"] = "timelineEventAdded";
    DevToolsContextHookKeys["GET_COMPONENT_INSTANCES"] = "getComponentInstances";
    DevToolsContextHookKeys["GET_COMPONENT_BOUNDS"] = "getComponentBounds";
    DevToolsContextHookKeys["GET_COMPONENT_NAME"] = "getComponentName";
    DevToolsContextHookKeys["COMPONENT_HIGHLIGHT"] = "componentHighlight";
    DevToolsContextHookKeys["COMPONENT_UNHIGHLIGHT"] = "componentUnhighlight";
    return DevToolsContextHookKeys;
}({});
var $26d6f2f8b43ea981$export$12aa7e661bddec80 = /* @__PURE__ */ function(DevToolsMessagingHookKeys) {
    DevToolsMessagingHookKeys["SEND_INSPECTOR_TREE_TO_CLIENT"] = "sendInspectorTreeToClient";
    DevToolsMessagingHookKeys["SEND_INSPECTOR_STATE_TO_CLIENT"] = "sendInspectorStateToClient";
    DevToolsMessagingHookKeys["SEND_TIMELINE_EVENT_TO_CLIENT"] = "sendTimelineEventToClient";
    DevToolsMessagingHookKeys["SEND_INSPECTOR_TO_CLIENT"] = "sendInspectorToClient";
    DevToolsMessagingHookKeys["SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT"] = "sendActiveAppUpdatedToClient";
    DevToolsMessagingHookKeys["DEVTOOLS_STATE_UPDATED"] = "devtoolsStateUpdated";
    DevToolsMessagingHookKeys["DEVTOOLS_CONNECTED_UPDATED"] = "devtoolsConnectedUpdated";
    DevToolsMessagingHookKeys["ROUTER_INFO_UPDATED"] = "routerInfoUpdated";
    return DevToolsMessagingHookKeys;
}({});
function $26d6f2f8b43ea981$export$73be3ac6032ad9bb() {
    var hooks = (0, $386a79679df3e70b$export$39c6a2b4dbabca5d)();
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.ADD_INSPECTOR, function(param) {
        var inspector = param.inspector, plugin = param.plugin;
        $26d6f2f8b43ea981$export$e863e3b6c2ff029b(inspector, plugin.descriptor);
    });
    var debounceSendInspectorTree = (0, $062babd0a85d9d9b$export$61fc7d43ac8f84b0)(function(param) {
        var inspectorId = param.inspectorId, plugin = param.plugin;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _plugin_descriptor, inspector, _payload;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!inspectorId || !(plugin === null || plugin === void 0 ? void 0 : (_plugin_descriptor = plugin.descriptor) === null || _plugin_descriptor === void 0 ? void 0 : _plugin_descriptor.app) || $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return [
                            2
                        ];
                        inspector = $26d6f2f8b43ea981$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
                        _payload = {
                            app: plugin.descriptor.app,
                            inspectorId: inspectorId,
                            filter: (inspector === null || inspector === void 0 ? void 0 : inspector.treeFilter) || "",
                            rootNodes: []
                        };
                        return [
                            4,
                            new Promise(function(resolve) {
                                hooks.callHookWith(function(callbacks) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                        return (0, $13u2V._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        Promise.all(callbacks.map(function(cb) {
                                                            return cb(_payload);
                                                        }))
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    resolve();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                }, $26d6f2f8b43ea981$export$3936435a794cb908.GET_INSPECTOR_TREE);
                            })
                        ];
                    case 1:
                        _state.sent();
                        hooks.callHookWith(function(callbacks) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                return (0, $13u2V._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                Promise.all(callbacks.map(function(cb) {
                                                    return cb({
                                                        inspectorId: inspectorId,
                                                        rootNodes: _payload.rootNodes
                                                    });
                                                }))
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }, $26d6f2f8b43ea981$export$12aa7e661bddec80.SEND_INSPECTOR_TREE_TO_CLIENT);
                        return [
                            2
                        ];
                }
            });
        })();
    }, 120);
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.SEND_INSPECTOR_TREE, debounceSendInspectorTree);
    var debounceSendInspectorState = (0, $062babd0a85d9d9b$export$61fc7d43ac8f84b0)(function(param) {
        var inspectorId = param.inspectorId, plugin = param.plugin;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _plugin_descriptor, inspector, _payload, ctx;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!inspectorId || !(plugin === null || plugin === void 0 ? void 0 : (_plugin_descriptor = plugin.descriptor) === null || _plugin_descriptor === void 0 ? void 0 : _plugin_descriptor.app) || $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return [
                            2
                        ];
                        inspector = $26d6f2f8b43ea981$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
                        _payload = {
                            app: plugin.descriptor.app,
                            inspectorId: inspectorId,
                            nodeId: (inspector === null || inspector === void 0 ? void 0 : inspector.selectedNodeId) || "",
                            state: null
                        };
                        ctx = {
                            currentTab: "custom-inspector:".concat(inspectorId)
                        };
                        if (!_payload.nodeId) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            new Promise(function(resolve) {
                                hooks.callHookWith(function(callbacks) {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                        return (0, $13u2V._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        Promise.all(callbacks.map(function(cb) {
                                                            return cb(_payload, ctx);
                                                        }))
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    resolve();
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                }, $26d6f2f8b43ea981$export$3936435a794cb908.GET_INSPECTOR_STATE);
                            })
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        hooks.callHookWith(function(callbacks) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                return (0, $13u2V._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                Promise.all(callbacks.map(function(cb) {
                                                    return cb({
                                                        inspectorId: inspectorId,
                                                        nodeId: _payload.nodeId,
                                                        state: _payload.state
                                                    });
                                                }))
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }, $26d6f2f8b43ea981$export$12aa7e661bddec80.SEND_INSPECTOR_STATE_TO_CLIENT);
                        return [
                            2
                        ];
                }
            });
        })();
    }, 120);
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.SEND_INSPECTOR_STATE, debounceSendInspectorState);
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.CUSTOM_INSPECTOR_SELECT_NODE, function(param) {
        var inspectorId = param.inspectorId, nodeId = param.nodeId, plugin = param.plugin;
        var inspector = $26d6f2f8b43ea981$export$aa4140d0f5ce4bbe(inspectorId, plugin.descriptor.app);
        if (!inspector) return;
        inspector.selectedNodeId = nodeId;
    });
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.TIMELINE_LAYER_ADDED, function(param) {
        var options = param.options, plugin = param.plugin;
        $26d6f2f8b43ea981$var$addTimelineLayer(options, plugin.descriptor);
    });
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.TIMELINE_EVENT_ADDED, function(param) {
        var options = param.options, plugin = param.plugin;
        var _devtoolsState_timelineLayersState;
        if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled || !((_devtoolsState_timelineLayersState = $26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState) === null || _devtoolsState_timelineLayersState === void 0 ? void 0 : _devtoolsState_timelineLayersState[plugin.descriptor.id]) && ![
            "performance",
            "component-event",
            "keyboard",
            "mouse"
        ].includes(options.layerId)) return;
        hooks.callHookWith(function(callbacks) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all(callbacks.map(function(cb) {
                                    return cb(options);
                                }))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }, $26d6f2f8b43ea981$export$12aa7e661bddec80.SEND_TIMELINE_EVENT_TO_CLIENT);
    });
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.GET_COMPONENT_INSTANCES, function(param) {
        var app = param.app;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var appRecord, appId;
            return (0, $13u2V._)(this, function(_state) {
                appRecord = app.__VUE_DEVTOOLS_NEXT_APP_RECORD__;
                if (!appRecord) return [
                    2,
                    null
                ];
                appId = appRecord.id.toString();
                return [
                    2,
                    (0, $aUGqu._)(appRecord.instanceMap).filter(function(param) {
                        var _param = (0, $f9AOD._)(param, 1), key = _param[0];
                        return key.split(":")[0] === appId;
                    }).map(function(param) {
                        var _param = (0, $f9AOD._)(param, 2), instance = _param[1];
                        return instance;
                    })
                ];
            });
        })();
    });
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.GET_COMPONENT_BOUNDS, function(param) {
        var instance = param.instance;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                return [
                    2,
                    $26d6f2f8b43ea981$var$getComponentBoundingRect(instance)
                ];
            });
        })();
    });
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.GET_COMPONENT_NAME, function(param) {
        var instance = param.instance;
        return $26d6f2f8b43ea981$var$getInstanceName(instance);
    });
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.COMPONENT_HIGHLIGHT, function(param) {
        var uid = param.uid;
        var instance = $26d6f2f8b43ea981$export$162128841a7f2877.value.instanceMap.get(uid);
        if (instance) $26d6f2f8b43ea981$var$highlight(instance);
    });
    hooks.hook($26d6f2f8b43ea981$export$4c35c03df042a977.COMPONENT_UNHIGHLIGHT, function() {
        $26d6f2f8b43ea981$var$unhighlight();
    });
    return hooks;
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_APP_RECORDS__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_APP_RECORDS__ = ($26d6f2f8b43ea981$var$_target3 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_APP_RECORDS__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_APP_RECORDS__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_APP_RECORDS__ : $26d6f2f8b43ea981$var$_target3.__VUE_DEVTOOLS_KIT_APP_RECORDS__ = [];
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = ($26d6f2f8b43ea981$var$_target4 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ : $26d6f2f8b43ea981$var$_target4.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = {};
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = ($26d6f2f8b43ea981$var$_target5 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ : $26d6f2f8b43ea981$var$_target5.__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = "";
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = ($26d6f2f8b43ea981$var$_target6 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CUSTOM_TABS__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CUSTOM_TABS__ : $26d6f2f8b43ea981$var$_target6.__VUE_DEVTOOLS_KIT_CUSTOM_TABS__ = [];
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = ($26d6f2f8b43ea981$var$_target7 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ : $26d6f2f8b43ea981$var$_target7.__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__ = [];
var $26d6f2f8b43ea981$var$STATE_KEY = "__VUE_DEVTOOLS_KIT_GLOBAL_STATE__";
function $26d6f2f8b43ea981$var$initStateFactory() {
    return {
        connected: false,
        clientConnected: false,
        vitePluginDetected: true,
        appRecords: [],
        activeAppRecordId: "",
        tabs: [],
        commands: [],
        highPerfModeEnabled: true,
        devtoolsClientDetected: {},
        perfUniqueGroupId: 0,
        timelineLayersState: $26d6f2f8b43ea981$var$getTimelineLayersStateFromStorage()
    };
}
var $26d6f2f8b43ea981$var$_;
($26d6f2f8b43ea981$var$_ = ($26d6f2f8b43ea981$var$_target8 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563))[$26d6f2f8b43ea981$var$_STATE_KEY = $26d6f2f8b43ea981$var$STATE_KEY]) !== null && $26d6f2f8b43ea981$var$_ !== void 0 ? $26d6f2f8b43ea981$var$_ : $26d6f2f8b43ea981$var$_target8[$26d6f2f8b43ea981$var$_STATE_KEY] = $26d6f2f8b43ea981$var$initStateFactory();
var $26d6f2f8b43ea981$export$ff4fc651602b9735 = (0, $062babd0a85d9d9b$export$61fc7d43ac8f84b0)(function(state) {
    $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.callHook($26d6f2f8b43ea981$export$12aa7e661bddec80.DEVTOOLS_STATE_UPDATED, {
        state: state
    });
});
var $26d6f2f8b43ea981$export$ce292af96ab94f7c = (0, $062babd0a85d9d9b$export$61fc7d43ac8f84b0)(function(state, oldState) {
    $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.callHook($26d6f2f8b43ea981$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, {
        state: state,
        oldState: oldState
    });
});
var $26d6f2f8b43ea981$export$d3c0473489b1d63b = new Proxy((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__, {
    get: function(_target, prop, receiver) {
        if (prop === "value") return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__;
        return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__[prop];
    }
});
var $26d6f2f8b43ea981$export$c1761479e1420543 = function(app) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = (0, $aUGqu._)((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__).concat([
        app
    ]);
};
var $26d6f2f8b43ea981$export$4d20c72f1da170ba = function(app) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_APP_RECORDS__ = $26d6f2f8b43ea981$export$d3c0473489b1d63b.value.filter(function(record) {
        return record.app !== app;
    });
};
var $26d6f2f8b43ea981$export$162128841a7f2877 = new Proxy((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__, {
    get: function(_target, prop, receiver) {
        if (prop === "value") return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__;
        else if (prop === "id") return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__;
        return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__[prop];
    }
});
function $26d6f2f8b43ea981$var$updateAllStates() {
    $26d6f2f8b43ea981$export$ff4fc651602b9735((0, $6fpqi._)((0, $1XAnY._)({}, (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$STATE_KEY]), {
        appRecords: $26d6f2f8b43ea981$export$d3c0473489b1d63b.value,
        activeAppRecordId: $26d6f2f8b43ea981$export$162128841a7f2877.id,
        tabs: (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__,
        commands: (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__
    }));
}
function $26d6f2f8b43ea981$export$1574774def61bdf9(app) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD__ = app;
    $26d6f2f8b43ea981$var$updateAllStates();
}
function $26d6f2f8b43ea981$export$1a7804ab8d8511d1(id) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_ACTIVE_APP_RECORD_ID__ = id;
    $26d6f2f8b43ea981$var$updateAllStates();
}
var $26d6f2f8b43ea981$export$a67dd585df937baa = new Proxy((0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$STATE_KEY], {
    get: function(target$3, property) {
        if (property === "appRecords") return $26d6f2f8b43ea981$export$d3c0473489b1d63b;
        else if (property === "activeAppRecordId") return $26d6f2f8b43ea981$export$162128841a7f2877.id;
        else if (property === "tabs") return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
        else if (property === "commands") return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
        return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$STATE_KEY][property];
    },
    deleteProperty: function(target, property) {
        delete target[property];
        return true;
    },
    set: function(target$4, property, value) {
        target$4[property] = value;
        (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$STATE_KEY][property] = value;
        return true;
    }
});
function $26d6f2f8b43ea981$export$ed70a0f71250535e() {
    Object.assign((0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$STATE_KEY], $26d6f2f8b43ea981$var$initStateFactory());
}
function $26d6f2f8b43ea981$export$ee22a7aaf6b41ce2(state) {
    var oldState = (0, $6fpqi._)((0, $1XAnY._)({}, (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$STATE_KEY]), {
        appRecords: $26d6f2f8b43ea981$export$d3c0473489b1d63b.value,
        activeAppRecordId: $26d6f2f8b43ea981$export$162128841a7f2877.id
    });
    if (oldState.connected !== state.connected && state.connected || oldState.clientConnected !== state.clientConnected && state.clientConnected) $26d6f2f8b43ea981$export$ce292af96ab94f7c((0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$STATE_KEY], oldState);
    Object.assign((0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$STATE_KEY], state);
    $26d6f2f8b43ea981$var$updateAllStates();
}
function $26d6f2f8b43ea981$export$814e9e34f2c01770(fn) {
    return new Promise(function(resolve) {
        if ($26d6f2f8b43ea981$export$a67dd585df937baa.connected) {
            fn();
            resolve();
        }
        $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.hook($26d6f2f8b43ea981$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, function(param) {
            var state = param.state;
            if (state.connected) {
                fn();
                resolve();
            }
        });
    });
}
var $26d6f2f8b43ea981$var$resolveIcon = function(icon) {
    if (!icon) return;
    if (icon.startsWith("baseline-")) return "custom-ic-".concat(icon);
    if (icon.startsWith("i-") || (0, $6430dea643e1c0c1$export$8092cb61b2731942)(icon)) return icon;
    return "custom-ic-baseline-".concat(icon);
};
function $26d6f2f8b43ea981$export$9ce008646970742b(tab) {
    var tabs = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_TABS__;
    if (tabs.some(function(t) {
        return t.name === tab.name;
    })) return;
    tabs.push((0, $6fpqi._)((0, $1XAnY._)({}, tab), {
        icon: $26d6f2f8b43ea981$var$resolveIcon(tab.icon)
    }));
    $26d6f2f8b43ea981$var$updateAllStates();
}
function $26d6f2f8b43ea981$export$faa8225e4ad5293(action) {
    var commands = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    if (commands.some(function(t) {
        return t.id === action.id;
    })) return;
    commands.push((0, $6fpqi._)((0, $1XAnY._)({}, action), {
        icon: $26d6f2f8b43ea981$var$resolveIcon(action.icon),
        children: action.children ? action.children.map(function(child) {
            return (0, $6fpqi._)((0, $1XAnY._)({}, child), {
                icon: $26d6f2f8b43ea981$var$resolveIcon(child.icon)
            });
        }) : void 0
    }));
    $26d6f2f8b43ea981$var$updateAllStates();
}
function $26d6f2f8b43ea981$export$8791c0d68ff21044(actionId) {
    var commands = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CUSTOM_COMMANDS__;
    var index = commands.findIndex(function(t) {
        return t.id === actionId;
    });
    if (index === -1) return;
    commands.splice(index, 1);
    $26d6f2f8b43ea981$var$updateAllStates();
}
function $26d6f2f8b43ea981$export$b2de3679515b1d6b(state) {
    $26d6f2f8b43ea981$export$ee22a7aaf6b41ce2({
        clientConnected: state
    });
}
//#endregion
//#region src/core/open-in-editor/index.ts
function $26d6f2f8b43ea981$export$d4398ad178564033(url) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ = url;
}
function $26d6f2f8b43ea981$var$openInEditor() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var file = options.file, host = options.host, _options_baseUrl = options.baseUrl, baseUrl = _options_baseUrl === void 0 ? window.location.origin : _options_baseUrl, _options_line = options.line, line = _options_line === void 0 ? 0 : _options_line, _options_column = options.column, column = _options_column === void 0 ? 0 : _options_column;
    if (file) {
        if (host === "chrome-extension") {
            var _window_VUE_DEVTOOLS_CONFIG;
            var fileName = file.replace(/\\/g, "\\\\");
            var _window_VUE_DEVTOOLS_CONFIG_openInEditorHost;
            var _baseUrl = (_window_VUE_DEVTOOLS_CONFIG_openInEditorHost = (_window_VUE_DEVTOOLS_CONFIG = window.VUE_DEVTOOLS_CONFIG) === null || _window_VUE_DEVTOOLS_CONFIG === void 0 ? void 0 : _window_VUE_DEVTOOLS_CONFIG.openInEditorHost) !== null && _window_VUE_DEVTOOLS_CONFIG_openInEditorHost !== void 0 ? _window_VUE_DEVTOOLS_CONFIG_openInEditorHost : "/";
            fetch("".concat(_baseUrl, "__open-in-editor?file=").concat(encodeURI(file))).then(function(response) {
                if (!response.ok) {
                    var msg = "Opening component ".concat(fileName, " failed");
                    console.log("%c".concat(msg), "color:red");
                }
            });
        } else if ($26d6f2f8b43ea981$export$a67dd585df937baa.vitePluginDetected) {
            var _target___VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__;
            var _baseUrl1 = (_target___VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__) !== null && _target___VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ !== void 0 ? _target___VUE_DEVTOOLS_OPEN_IN_EDITOR_BASE_URL__ : baseUrl;
            (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_INSPECTOR__.openInEditor(_baseUrl1, file, line, column);
        }
    }
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = ($26d6f2f8b43ea981$var$_target9 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ : $26d6f2f8b43ea981$var$_target9.__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__ = [];
var $26d6f2f8b43ea981$export$df02dcb86618c10f = new Proxy((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_PLUGIN_BUFFER__, {
    get: function(target, prop, receiver) {
        return Reflect.get(target, prop, receiver);
    }
});
function $26d6f2f8b43ea981$export$5158df7771943590(pluginDescriptor, setupFn) {
    $26d6f2f8b43ea981$export$df02dcb86618c10f.push([
        pluginDescriptor,
        setupFn
    ]);
}
//#endregion
//#region src/core/plugin/plugin-settings.ts
function $26d6f2f8b43ea981$var$_getSettings(settings) {
    var _settings = {};
    Object.keys(settings).forEach(function(key) {
        _settings[key] = settings[key].defaultValue;
    });
    return _settings;
}
function $26d6f2f8b43ea981$var$getPluginLocalKey(pluginId) {
    return "__VUE_DEVTOOLS_NEXT_PLUGIN_SETTINGS__".concat(pluginId, "__");
}
function $26d6f2f8b43ea981$var$getPluginSettingsOptions(pluginId) {
    var _this, _devtoolsPluginBuffer_find;
    var _devtoolsPluginBuffer_find_, _settings;
    return (_settings = (_this = (_devtoolsPluginBuffer_find_ = (_devtoolsPluginBuffer_find = $26d6f2f8b43ea981$export$df02dcb86618c10f.find(function(item) {
        var _item_;
        return item[0].id === pluginId && !!((_item_ = item[0]) === null || _item_ === void 0 ? void 0 : _item_.settings);
    })) === null || _devtoolsPluginBuffer_find === void 0 ? void 0 : _devtoolsPluginBuffer_find[0]) !== null && _devtoolsPluginBuffer_find_ !== void 0 ? _devtoolsPluginBuffer_find_ : null) === null || _this === void 0 ? void 0 : _this.settings) !== null && _settings !== void 0 ? _settings : null;
}
function $26d6f2f8b43ea981$var$getPluginSettings(pluginId, fallbackValue) {
    var _this, _devtoolsPluginBuffer_find;
    var localKey = $26d6f2f8b43ea981$var$getPluginLocalKey(pluginId);
    if (localKey) {
        var localSettings = localStorage.getItem(localKey);
        if (localSettings) return JSON.parse(localSettings);
    }
    var _devtoolsPluginBuffer_find_, _settings;
    if (pluginId) return $26d6f2f8b43ea981$var$_getSettings((_settings = (_this = (_devtoolsPluginBuffer_find_ = (_devtoolsPluginBuffer_find = $26d6f2f8b43ea981$export$df02dcb86618c10f.find(function(item) {
        return item[0].id === pluginId;
    })) === null || _devtoolsPluginBuffer_find === void 0 ? void 0 : _devtoolsPluginBuffer_find[0]) !== null && _devtoolsPluginBuffer_find_ !== void 0 ? _devtoolsPluginBuffer_find_ : null) === null || _this === void 0 ? void 0 : _this.settings) !== null && _settings !== void 0 ? _settings : {});
    return $26d6f2f8b43ea981$var$_getSettings(fallbackValue);
}
function $26d6f2f8b43ea981$var$initPluginSettings(pluginId, settings) {
    var localKey = $26d6f2f8b43ea981$var$getPluginLocalKey(pluginId);
    if (!localStorage.getItem(localKey)) localStorage.setItem(localKey, JSON.stringify($26d6f2f8b43ea981$var$_getSettings(settings)));
}
function $26d6f2f8b43ea981$var$setPluginSettings(pluginId, key, value) {
    var localKey = $26d6f2f8b43ea981$var$getPluginLocalKey(pluginId);
    var localSettings = localStorage.getItem(localKey);
    var parsedLocalSettings = JSON.parse(localSettings || "{}");
    var updated = (0, $6fpqi._)((0, $1XAnY._)({}, parsedLocalSettings), (0, $7Pjls._)({}, key, value));
    localStorage.setItem(localKey, JSON.stringify(updated));
    $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.callHookWith(function(callbacks) {
        callbacks.forEach(function(cb) {
            return cb({
                pluginId: pluginId,
                key: key,
                oldValue: parsedLocalSettings[key],
                newValue: value,
                settings: updated
            });
        });
    }, $26d6f2f8b43ea981$export$3936435a794cb908.SET_PLUGIN_SETTINGS);
}
//#endregion
//#region src/types/hook.ts
var $26d6f2f8b43ea981$var$DevToolsHooks = /* @__PURE__ */ function(DevToolsHooks) {
    DevToolsHooks["APP_INIT"] = "app:init";
    DevToolsHooks["APP_UNMOUNT"] = "app:unmount";
    DevToolsHooks["COMPONENT_UPDATED"] = "component:updated";
    DevToolsHooks["COMPONENT_ADDED"] = "component:added";
    DevToolsHooks["COMPONENT_REMOVED"] = "component:removed";
    DevToolsHooks["COMPONENT_EMIT"] = "component:emit";
    DevToolsHooks["PERFORMANCE_START"] = "perf:start";
    DevToolsHooks["PERFORMANCE_END"] = "perf:end";
    DevToolsHooks["ADD_ROUTE"] = "router:add-route";
    DevToolsHooks["REMOVE_ROUTE"] = "router:remove-route";
    DevToolsHooks["RENDER_TRACKED"] = "render:tracked";
    DevToolsHooks["RENDER_TRIGGERED"] = "render:triggered";
    DevToolsHooks["APP_CONNECTED"] = "app:connected";
    DevToolsHooks["SETUP_DEVTOOLS_PLUGIN"] = "devtools-plugin:setup";
    return DevToolsHooks;
}({});
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_HOOK;
//#endregion
//#region src/hook/index.ts
var $26d6f2f8b43ea981$var$devtoolsHooks = ($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_HOOK = ($26d6f2f8b43ea981$var$_target10 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_HOOK) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_HOOK !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_HOOK : $26d6f2f8b43ea981$var$_target10.__VUE_DEVTOOLS_HOOK = (0, $386a79679df3e70b$export$39c6a2b4dbabca5d)();
var $26d6f2f8b43ea981$var$on = {
    vueAppInit: function(fn) {
        $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.APP_INIT, fn);
    },
    vueAppUnmount: function(fn) {
        $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.APP_UNMOUNT, fn);
    },
    vueAppConnected: function(fn) {
        $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.APP_CONNECTED, fn);
    },
    componentAdded: function(fn) {
        return $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_ADDED, fn);
    },
    componentEmit: function(fn) {
        return $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_EMIT, fn);
    },
    componentUpdated: function(fn) {
        return $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_UPDATED, fn);
    },
    componentRemoved: function(fn) {
        return $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_REMOVED, fn);
    },
    setupDevtoolsPlugin: function(fn) {
        $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, fn);
    },
    perfStart: function(fn) {
        return $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.PERFORMANCE_START, fn);
    },
    perfEnd: function(fn) {
        return $26d6f2f8b43ea981$var$devtoolsHooks.hook($26d6f2f8b43ea981$var$DevToolsHooks.PERFORMANCE_END, fn);
    }
};
function $26d6f2f8b43ea981$var$createDevToolsHook() {
    return {
        id: "vue-devtools-next",
        devtoolsVersion: "7.0",
        enabled: false,
        appRecords: [],
        apps: [],
        events: /* @__PURE__ */ new Map(),
        on: function(event, fn) {
            var _this = this;
            var _this_events_get;
            if (!this.events.has(event)) this.events.set(event, []);
            (_this_events_get = this.events.get(event)) === null || _this_events_get === void 0 ? void 0 : _this_events_get.push(fn);
            return function() {
                return _this.off(event, fn);
            };
        },
        once: function(event, fn) {
            var _this = this;
            var onceFn = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                _this.off(event, onceFn);
                fn.apply(void 0, (0, $aUGqu._)(args));
            };
            this.on(event, onceFn);
            return [
                event,
                onceFn
            ];
        },
        off: function(event, fn) {
            if (this.events.has(event)) {
                var eventCallbacks = this.events.get(event);
                var index = eventCallbacks.indexOf(fn);
                if (index !== -1) eventCallbacks.splice(index, 1);
            }
        },
        emit: function(event) {
            for(var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                payload[_key - 1] = arguments[_key];
            }
            if (this.events.has(event)) this.events.get(event).forEach(function(fn) {
                return fn.apply(void 0, (0, $aUGqu._)(payload));
            });
        }
    };
}
function $26d6f2f8b43ea981$var$subscribeDevToolsHook(hook) {
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.APP_INIT, function(app, version, types) {
        var _app__instance_type_devtools, _app__instance_type, _app__instance;
        if (app === null || app === void 0 ? void 0 : (_app__instance = app._instance) === null || _app__instance === void 0 ? void 0 : (_app__instance_type = _app__instance.type) === null || _app__instance_type === void 0 ? void 0 : (_app__instance_type_devtools = _app__instance_type.devtools) === null || _app__instance_type_devtools === void 0 ? void 0 : _app__instance_type_devtools.hide) return;
        $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.APP_INIT, app, version, types);
    });
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.APP_UNMOUNT, function(app) {
        $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.APP_UNMOUNT, app);
    });
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_ADDED, function(app, uid, parentUid, component) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var _app__instance_type_devtools, _app__instance_type, _app__instance;
            return (0, $13u2V._)(this, function(_state) {
                if ((app === null || app === void 0 ? void 0 : (_app__instance = app._instance) === null || _app__instance === void 0 ? void 0 : (_app__instance_type = _app__instance.type) === null || _app__instance_type === void 0 ? void 0 : (_app__instance_type_devtools = _app__instance_type.devtools) === null || _app__instance_type_devtools === void 0 ? void 0 : _app__instance_type_devtools.hide) || $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return [
                    2
                ];
                if (!app || typeof uid !== "number" && !uid || !component) return [
                    2
                ];
                $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_ADDED, app, uid, parentUid, component);
                return [
                    2
                ];
            });
        })();
    });
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_UPDATED, function(app, uid, parentUid, component) {
        if (!app || typeof uid !== "number" && !uid || !component || $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return;
        $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_UPDATED, app, uid, parentUid, component);
    });
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_REMOVED, function(app, uid, parentUid, component) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                if (!app || typeof uid !== "number" && !uid || !component || $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return [
                    2
                ];
                $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_REMOVED, app, uid, parentUid, component);
                return [
                    2
                ];
            });
        })();
    });
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_EMIT, function(app, instance, event, params) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            return (0, $13u2V._)(this, function(_state) {
                if (!app || !instance || $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return [
                    2
                ];
                $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_EMIT, app, instance, event, params);
                return [
                    2
                ];
            });
        })();
    });
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.PERFORMANCE_START, function(app, uid, vm, type, time) {
        if (!app || $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return;
        $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.PERFORMANCE_START, app, uid, vm, type, time);
    });
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.PERFORMANCE_END, function(app, uid, vm, type, time) {
        if (!app || $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return;
        $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.PERFORMANCE_END, app, uid, vm, type, time);
    });
    hook.on($26d6f2f8b43ea981$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, function(pluginDescriptor, setupFn, options) {
        if ((options === null || options === void 0 ? void 0 : options.target) === "legacy") return;
        $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn);
    });
}
var $26d6f2f8b43ea981$var$hook = {
    on: $26d6f2f8b43ea981$var$on,
    setupDevToolsPlugin: function(pluginDescriptor, setupFn) {
        return $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn);
    }
};
//#endregion
//#region src/api/v6/index.ts
var $26d6f2f8b43ea981$var$DevToolsV6PluginAPI = /*#__PURE__*/ function() {
    "use strict";
    function DevToolsV6PluginAPI(param) {
        var plugin = param.plugin, ctx = param.ctx;
        (0, $173N4._)(this, DevToolsV6PluginAPI);
        this.hooks = ctx.hooks;
        this.plugin = plugin;
    }
    (0, $cFHGC._)(DevToolsV6PluginAPI, [
        {
            key: "on",
            get: function get() {
                var _this = this;
                return {
                    visitComponentTree: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.VISIT_COMPONENT_TREE, handler);
                    },
                    inspectComponent: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.INSPECT_COMPONENT, handler);
                    },
                    editComponentState: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.EDIT_COMPONENT_STATE, handler);
                    },
                    getInspectorTree: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.GET_INSPECTOR_TREE, handler);
                    },
                    getInspectorState: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.GET_INSPECTOR_STATE, handler);
                    },
                    editInspectorState: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.EDIT_INSPECTOR_STATE, handler);
                    },
                    inspectTimelineEvent: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.INSPECT_TIMELINE_EVENT, handler);
                    },
                    timelineCleared: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.TIMELINE_CLEARED, handler);
                    },
                    setPluginSettings: function(handler) {
                        _this.hooks.hook($26d6f2f8b43ea981$export$3936435a794cb908.SET_PLUGIN_SETTINGS, handler);
                    }
                };
            }
        },
        {
            key: "notifyComponentUpdate",
            value: function notifyComponentUpdate(instance) {
                var _this = this;
                if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return;
                var inspector = $26d6f2f8b43ea981$export$2844c7432ba9d166().find(function(i) {
                    return i.packageName === _this.plugin.descriptor.packageName;
                });
                if (inspector === null || inspector === void 0 ? void 0 : inspector.id) {
                    if (instance) {
                        var _devtoolsHooks;
                        var _instance_parent;
                        var args = [
                            instance.appContext.app,
                            instance.uid,
                            (_instance_parent = instance.parent) === null || _instance_parent === void 0 ? void 0 : _instance_parent.uid,
                            instance
                        ];
                        (_devtoolsHooks = $26d6f2f8b43ea981$var$devtoolsHooks).callHook.apply(_devtoolsHooks, [
                            $26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_UPDATED
                        ].concat((0, $aUGqu._)(args)));
                    } else $26d6f2f8b43ea981$var$devtoolsHooks.callHook($26d6f2f8b43ea981$var$DevToolsHooks.COMPONENT_UPDATED);
                    this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
                        inspectorId: inspector.id,
                        plugin: this.plugin
                    });
                }
            }
        },
        {
            key: "addInspector",
            value: function addInspector(options) {
                this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.ADD_INSPECTOR, {
                    inspector: options,
                    plugin: this.plugin
                });
                if (this.plugin.descriptor.settings) $26d6f2f8b43ea981$var$initPluginSettings(options.id, this.plugin.descriptor.settings);
            }
        },
        {
            key: "sendInspectorTree",
            value: function sendInspectorTree(inspectorId) {
                if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return;
                this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.SEND_INSPECTOR_TREE, {
                    inspectorId: inspectorId,
                    plugin: this.plugin
                });
            }
        },
        {
            key: "sendInspectorState",
            value: function sendInspectorState(inspectorId) {
                if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return;
                this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
                    inspectorId: inspectorId,
                    plugin: this.plugin
                });
            }
        },
        {
            key: "selectInspectorNode",
            value: function selectInspectorNode(inspectorId, nodeId) {
                this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.CUSTOM_INSPECTOR_SELECT_NODE, {
                    inspectorId: inspectorId,
                    nodeId: nodeId,
                    plugin: this.plugin
                });
            }
        },
        {
            key: "visitComponentTree",
            value: function visitComponentTree(payload) {
                return this.hooks.callHook($26d6f2f8b43ea981$export$3936435a794cb908.VISIT_COMPONENT_TREE, payload);
            }
        },
        {
            key: "now",
            value: function now() {
                if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return 0;
                return Date.now();
            }
        },
        {
            key: "addTimelineLayer",
            value: function addTimelineLayer(options) {
                this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.TIMELINE_LAYER_ADDED, {
                    options: options,
                    plugin: this.plugin
                });
            }
        },
        {
            key: "addTimelineEvent",
            value: function addTimelineEvent(options) {
                if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return;
                this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.TIMELINE_EVENT_ADDED, {
                    options: options,
                    plugin: this.plugin
                });
            }
        },
        {
            key: "getSettings",
            value: function getSettings(pluginId) {
                return $26d6f2f8b43ea981$var$getPluginSettings(pluginId !== null && pluginId !== void 0 ? pluginId : this.plugin.descriptor.id, this.plugin.descriptor.settings);
            }
        },
        {
            key: "getComponentInstances",
            value: function getComponentInstances(app) {
                return this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.GET_COMPONENT_INSTANCES, {
                    app: app
                });
            }
        },
        {
            key: "getComponentBounds",
            value: function getComponentBounds(instance) {
                return this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.GET_COMPONENT_BOUNDS, {
                    instance: instance
                });
            }
        },
        {
            key: "getComponentName",
            value: function getComponentName(instance) {
                return this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.GET_COMPONENT_NAME, {
                    instance: instance
                });
            }
        },
        {
            key: "highlightElement",
            value: function highlightElement(instance) {
                var uid = instance.__VUE_DEVTOOLS_NEXT_UID__;
                return this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.COMPONENT_HIGHLIGHT, {
                    uid: uid
                });
            }
        },
        {
            key: "unhighlightElement",
            value: function unhighlightElement() {
                return this.hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.COMPONENT_UNHIGHLIGHT);
            }
        }
    ]);
    return DevToolsV6PluginAPI;
}();
//#endregion
//#region src/api/index.ts
var $26d6f2f8b43ea981$var$DevToolsPluginAPI = $26d6f2f8b43ea981$var$DevToolsV6PluginAPI;
//#endregion
//#region src/core/component/state/constants.ts
var $26d6f2f8b43ea981$var$vueBuiltins = new Set([
    "nextTick",
    "defineComponent",
    "defineAsyncComponent",
    "defineCustomElement",
    "ref",
    "computed",
    "reactive",
    "readonly",
    "watchEffect",
    "watchPostEffect",
    "watchSyncEffect",
    "watch",
    "isRef",
    "unref",
    "toRef",
    "toRefs",
    "isProxy",
    "isReactive",
    "isReadonly",
    "shallowRef",
    "triggerRef",
    "customRef",
    "shallowReactive",
    "shallowReadonly",
    "toRaw",
    "markRaw",
    "effectScope",
    "getCurrentScope",
    "onScopeDispose",
    "onMounted",
    "onUpdated",
    "onUnmounted",
    "onBeforeMount",
    "onBeforeUpdate",
    "onBeforeUnmount",
    "onErrorCaptured",
    "onRenderTracked",
    "onRenderTriggered",
    "onActivated",
    "onDeactivated",
    "onServerPrefetch",
    "provide",
    "inject",
    "h",
    "mergeProps",
    "cloneVNode",
    "isVNode",
    "resolveComponent",
    "resolveDirective",
    "withDirectives",
    "withModifiers"
]);
var $26d6f2f8b43ea981$var$symbolRE = /^\[native Symbol Symbol\((.*)\)\]$/;
var $26d6f2f8b43ea981$var$rawTypeRE = /^\[object (\w+)\]$/;
var $26d6f2f8b43ea981$var$specialTypeRE = /^\[native (\w+) (.*?)(<>(([\s\S])*))?\]$/;
var $26d6f2f8b43ea981$var$fnTypeRE = /^(?:function|class) (\w+)/;
var $26d6f2f8b43ea981$var$MAX_STRING_SIZE = 1e4;
var $26d6f2f8b43ea981$var$MAX_ARRAY_SIZE = 5e3;
var $26d6f2f8b43ea981$export$6db089fe7b26f5b6 = "__vue_devtool_undefined__";
var $26d6f2f8b43ea981$export$b4bf424ed968e242 = "__vue_devtool_infinity__";
var $26d6f2f8b43ea981$export$95cb88e357cbada8 = "__vue_devtool_negative_infinity__";
var $26d6f2f8b43ea981$export$d7ae0f70ebb9e144 = "__vue_devtool_nan__";
var $26d6f2f8b43ea981$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "&": "&amp;"
};
//#endregion
//#region src/core/component/state/is.ts
function $26d6f2f8b43ea981$var$isVueInstance(value) {
    if (!$26d6f2f8b43ea981$var$ensurePropertyExists(value, "_")) return false;
    if (!$26d6f2f8b43ea981$export$53b83ca8eaab0383(value._)) return false;
    return Object.keys(value._).includes("vnode");
}
function $26d6f2f8b43ea981$export$53b83ca8eaab0383(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
function $26d6f2f8b43ea981$var$isPrimitive$1(data) {
    if (data == null) return true;
    var type = typeof data === "undefined" ? "undefined" : (0, $7E0eS._)(data);
    return type === "string" || type === "number" || type === "boolean";
}
function $26d6f2f8b43ea981$var$isRef(raw) {
    return !!raw.__v_isRef;
}
function $26d6f2f8b43ea981$var$isComputed(raw) {
    return $26d6f2f8b43ea981$var$isRef(raw) && !!raw.effect;
}
function $26d6f2f8b43ea981$var$isReactive(raw) {
    return !!raw.__v_isReactive;
}
function $26d6f2f8b43ea981$var$isReadOnly(raw) {
    return !!raw.__v_isReadonly;
}
var $26d6f2f8b43ea981$var$_obj;
//#endregion
//#region src/core/component/state/util.ts
var $26d6f2f8b43ea981$var$tokenMap = ($26d6f2f8b43ea981$var$_obj = {}, (0, $7Pjls._)($26d6f2f8b43ea981$var$_obj, $26d6f2f8b43ea981$export$6db089fe7b26f5b6, "undefined"), (0, $7Pjls._)($26d6f2f8b43ea981$var$_obj, $26d6f2f8b43ea981$export$d7ae0f70ebb9e144, "NaN"), (0, $7Pjls._)($26d6f2f8b43ea981$var$_obj, $26d6f2f8b43ea981$export$b4bf424ed968e242, "Infinity"), (0, $7Pjls._)($26d6f2f8b43ea981$var$_obj, $26d6f2f8b43ea981$export$95cb88e357cbada8, "-Infinity"), $26d6f2f8b43ea981$var$_obj);
var $26d6f2f8b43ea981$var$reversedTokenMap = Object.entries($26d6f2f8b43ea981$var$tokenMap).reduce(function(acc, param) {
    var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
    acc[value] = key;
    return acc;
}, {});
function $26d6f2f8b43ea981$var$internalStateTokenToString(value) {
    if (value === null) return "null";
    return typeof value === "string" && $26d6f2f8b43ea981$var$tokenMap[value] || false;
}
function $26d6f2f8b43ea981$var$replaceTokenToString(value) {
    var replaceRegex = new RegExp('"('.concat(Object.keys($26d6f2f8b43ea981$var$tokenMap).join("|"), ')"'), "g");
    return value.replace(replaceRegex, function(_, g1) {
        return $26d6f2f8b43ea981$var$tokenMap[g1];
    });
}
function $26d6f2f8b43ea981$var$replaceStringToToken(value) {
    var literalValue = $26d6f2f8b43ea981$var$reversedTokenMap[value.trim()];
    if (literalValue) return '"'.concat(literalValue, '"');
    var replaceRegex = new RegExp(":\\s*(".concat(Object.keys($26d6f2f8b43ea981$var$reversedTokenMap).join("|"), ")"), "g");
    return value.replace(replaceRegex, function(_, g1) {
        return ':"'.concat($26d6f2f8b43ea981$var$reversedTokenMap[g1], '"');
    });
}
/**
* Convert prop type constructor to string.
*/ function $26d6f2f8b43ea981$var$getPropType(type) {
    if (Array.isArray(type)) return type.map(function(t) {
        return $26d6f2f8b43ea981$var$getPropType(t);
    }).join(" or ");
    if (type == null) return "null";
    var match = type.toString().match($26d6f2f8b43ea981$var$fnTypeRE);
    return typeof type === "function" ? match && match[1] || "any" : "any";
}
/**
* Sanitize data to be posted to the other side.
* Since the message posted is sent with structured clone,
* we need to filter out any types that might cause an error.
*/ function $26d6f2f8b43ea981$var$sanitize(data) {
    if (!$26d6f2f8b43ea981$var$isPrimitive$1(data) && !Array.isArray(data) && !$26d6f2f8b43ea981$export$53b83ca8eaab0383(data)) return Object.prototype.toString.call(data);
    else return data;
}
function $26d6f2f8b43ea981$var$getSetupStateType(raw) {
    try {
        return {
            ref: $26d6f2f8b43ea981$var$isRef(raw),
            computed: $26d6f2f8b43ea981$var$isComputed(raw),
            reactive: $26d6f2f8b43ea981$var$isReactive(raw),
            readonly: $26d6f2f8b43ea981$var$isReadOnly(raw)
        };
    } catch (e) {
        return {
            ref: false,
            computed: false,
            reactive: false,
            readonly: false
        };
    }
}
function $26d6f2f8b43ea981$var$toRaw(value) {
    if (value === null || value === void 0 ? void 0 : value.__v_raw) return value.__v_raw;
    return value;
}
function $26d6f2f8b43ea981$export$4e7f196112fea3c5(s) {
    return s.replace(/[<>"&]/g, function(s) {
        return $26d6f2f8b43ea981$var$ESC[s] || s;
    });
}
//#endregion
//#region src/core/component/state/process.ts
function $26d6f2f8b43ea981$var$mergeOptions(to, from, instance) {
    if (typeof from === "function") from = from.options;
    if (!from) return to;
    var mixins = from.mixins, extendsOptions = from.extends;
    extendsOptions && $26d6f2f8b43ea981$var$mergeOptions(to, extendsOptions, instance);
    mixins && mixins.forEach(function(m) {
        return $26d6f2f8b43ea981$var$mergeOptions(to, m, instance);
    });
    for(var _i = 0, _iter = [
        "computed",
        "inject"
    ]; _i < _iter.length; _i++){
        var key = _iter[_i];
        if (Object.prototype.hasOwnProperty.call(from, key)) {
            var _to, _key;
            var _;
            (_ = (_to = to)[_key = key]) !== null && _ !== void 0 ? _ : _to[_key] = {};
            Object.assign(to[key], from[key]);
        }
    }
    return to;
}
function $26d6f2f8b43ea981$var$resolveMergedOptions(instance) {
    var raw = instance === null || instance === void 0 ? void 0 : instance.type;
    if (!raw) return {};
    var mixins = raw.mixins, extendsOptions = raw.extends;
    var globalMixins = instance.appContext.mixins;
    if (!globalMixins.length && !mixins && !extendsOptions) return raw;
    var options = {};
    globalMixins.forEach(function(m) {
        return $26d6f2f8b43ea981$var$mergeOptions(options, m, instance);
    });
    $26d6f2f8b43ea981$var$mergeOptions(options, raw, instance);
    return options;
}
/**
* Process the props of an instance.
* Make sure return a plain object because window.postMessage()
* will throw an Error if the passed object contains Functions.
*
*/ function $26d6f2f8b43ea981$var$processProps(instance) {
    var _loop = function(key) {
        var propDefinition = propDefinitions ? propDefinitions[key] : null;
        var camelizeKey = (0, $6430dea643e1c0c1$export$161d051f5dd25de7)(key);
        props.push({
            type: "props",
            key: camelizeKey,
            value: $26d6f2f8b43ea981$var$returnError(function() {
                return instance.props[key];
            }),
            editable: true,
            meta: propDefinition ? (0, $1XAnY._)({
                type: propDefinition.type ? $26d6f2f8b43ea981$var$getPropType(propDefinition.type) : "any",
                required: !!propDefinition.required
            }, propDefinition.default ? {
                default: propDefinition.default.toString()
            } : {}) : {
                type: "invalid"
            }
        });
    };
    var _instance_type;
    var props = [];
    var propDefinitions = instance === null || instance === void 0 ? void 0 : (_instance_type = instance.type) === null || _instance_type === void 0 ? void 0 : _instance_type.props;
    for(var key in instance === null || instance === void 0 ? void 0 : instance.props)_loop(key);
    return props;
}
/**
* Process state, filtering out props and "clean" the result
* with a JSON dance. This removes functions which can cause
* errors during structured clone used by window.postMessage.
*
*/ function $26d6f2f8b43ea981$var$processState(instance) {
    var type = instance.type;
    var props = type === null || type === void 0 ? void 0 : type.props;
    var getters = type.vuex && type.vuex.getters;
    var computedDefs = type.computed;
    var data = (0, $1XAnY._)({}, instance.data, instance.renderContext);
    return Object.keys(data).filter(function(key) {
        return !(props && key in props) && !(getters && key in getters) && !(computedDefs && key in computedDefs);
    }).map(function(key) {
        return {
            key: key,
            type: "data",
            value: $26d6f2f8b43ea981$var$returnError(function() {
                return data[key];
            }),
            editable: true
        };
    });
}
function $26d6f2f8b43ea981$var$getStateTypeAndName(info) {
    var stateType = info.computed ? "computed" : info.ref ? "ref" : info.reactive ? "reactive" : null;
    return {
        stateType: stateType,
        stateTypeName: stateType ? "".concat(stateType.charAt(0).toUpperCase()).concat(stateType.slice(1)) : null
    };
}
function $26d6f2f8b43ea981$var$processSetupState(instance) {
    var raw = instance.devtoolsRawSetupState || {};
    return Object.keys(instance.setupState).filter(function(key) {
        return !$26d6f2f8b43ea981$var$vueBuiltins.has(key) && key.split(/(?=[A-Z])/)[0] !== "use";
    }).map(function(key) {
        var value = $26d6f2f8b43ea981$var$returnError(function() {
            return $26d6f2f8b43ea981$var$toRaw(instance.setupState[key]);
        });
        var accessError = value instanceof Error;
        var rawData = raw[key];
        var result;
        var isOtherType = accessError || typeof value === "function" || $26d6f2f8b43ea981$var$ensurePropertyExists(value, "render") && typeof value.render === "function" || $26d6f2f8b43ea981$var$ensurePropertyExists(value, "__asyncLoader") && typeof value.__asyncLoader === "function" || (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === "object" && value && ("setup" in value || "props" in value) || /^v[A-Z]/.test(key);
        if (rawData && !accessError) {
            var _rawData_effect_raw, _rawData_effect, _rawData_effect_fn, _rawData_effect1;
            var info = $26d6f2f8b43ea981$var$getSetupStateType(rawData);
            var _getStateTypeAndName = $26d6f2f8b43ea981$var$getStateTypeAndName(info), stateType = _getStateTypeAndName.stateType, stateTypeName = _getStateTypeAndName.stateTypeName;
            var isState = info.ref || info.computed || info.reactive;
            var raw1 = $26d6f2f8b43ea981$var$ensurePropertyExists(rawData, "effect") ? ((_rawData_effect = rawData.effect) === null || _rawData_effect === void 0 ? void 0 : (_rawData_effect_raw = _rawData_effect.raw) === null || _rawData_effect_raw === void 0 ? void 0 : _rawData_effect_raw.toString()) || ((_rawData_effect1 = rawData.effect) === null || _rawData_effect1 === void 0 ? void 0 : (_rawData_effect_fn = _rawData_effect1.fn) === null || _rawData_effect_fn === void 0 ? void 0 : _rawData_effect_fn.toString()) : null;
            if (stateType) isOtherType = false;
            result = (0, $6fpqi._)((0, $1XAnY._)({}, stateType ? {
                stateType: stateType,
                stateTypeName: stateTypeName
            } : {}, raw1 ? {
                raw: raw1
            } : {}), {
                editable: isState && !info.readonly
            });
        }
        return (0, $1XAnY._)({
            key: key,
            value: value,
            type: isOtherType ? "setup (other)" : "setup"
        }, result);
    });
}
/**
* Process the computed properties of an instance.
*/ function $26d6f2f8b43ea981$var$processComputed(instance, mergedType) {
    var _loop = function(key) {
        var def = defs[key];
        var type = typeof def === "function" && def.vuex ? "vuex bindings" : "computed";
        computed.push({
            type: type,
            key: key,
            value: $26d6f2f8b43ea981$var$returnError(function() {
                var _instance_proxy;
                return instance === null || instance === void 0 ? void 0 : (_instance_proxy = instance.proxy) === null || _instance_proxy === void 0 ? void 0 : _instance_proxy[key];
            }),
            editable: typeof def.set === "function"
        });
    };
    var type = mergedType;
    var computed = [];
    var defs = type.computed || {};
    for(var key in defs)_loop(key);
    return computed;
}
function $26d6f2f8b43ea981$var$processAttrs(instance) {
    return Object.keys(instance.attrs).map(function(key) {
        return {
            type: "attrs",
            key: key,
            value: $26d6f2f8b43ea981$var$returnError(function() {
                return instance.attrs[key];
            })
        };
    });
}
function $26d6f2f8b43ea981$var$processProvide(instance) {
    return Reflect.ownKeys(instance.provides).map(function(key) {
        return {
            type: "provided",
            key: key.toString(),
            value: $26d6f2f8b43ea981$var$returnError(function() {
                return instance.provides[key];
            })
        };
    });
}
var $26d6f2f8b43ea981$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $26d6f2f8b43ea981$var$hasOwn = function(val, key) {
    return $26d6f2f8b43ea981$var$hasOwnProperty.call(val, key);
};
function $26d6f2f8b43ea981$var$processInject(instance, mergedType) {
    if (!(mergedType === null || mergedType === void 0 ? void 0 : mergedType.inject)) return [];
    var keys;
    if (Array.isArray(mergedType.inject)) keys = mergedType.inject.map(function(key) {
        return {
            key: key,
            originalKey: key
        };
    });
    else keys = Reflect.ownKeys(mergedType.inject).map(function(key) {
        var value = mergedType.inject[key];
        var originalKey;
        var _value_from;
        if (typeof value === "string" || (typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value)) === "symbol") originalKey = value;
        else originalKey = (_value_from = value.from) !== null && _value_from !== void 0 ? _value_from : key;
        return {
            key: key,
            originalKey: originalKey
        };
    });
    return keys.map(function(param) {
        var key = param.key, originalKey = param.originalKey;
        return {
            type: "injected",
            key: key !== originalKey ? "".concat(String(originalKey), " \u279E ").concat(String(key)) : String(key),
            value: $26d6f2f8b43ea981$var$returnError(function() {
                return $26d6f2f8b43ea981$var$hasOwn(instance.ctx, key) ? instance.ctx[key] : void 0;
            })
        };
    });
}
function $26d6f2f8b43ea981$var$processRefs(instance) {
    return Object.keys(instance.refs).map(function(key) {
        return {
            type: "template refs",
            key: key,
            value: $26d6f2f8b43ea981$var$returnError(function() {
                return instance.refs[key];
            })
        };
    });
}
var $26d6f2f8b43ea981$var$vnodeEvents = new Set([
    "vnode-before-mount",
    "vnode-mounted",
    "vnode-before-update",
    "vnode-updated",
    "vnode-before-unmount",
    "vnode-unmounted"
]);
function $26d6f2f8b43ea981$var$processEventListeners(instance) {
    var _instance_vnode;
    var emitsDefinition = instance.type.emits;
    var declaredEmits = Array.isArray(emitsDefinition) ? emitsDefinition : Object.keys(emitsDefinition !== null && emitsDefinition !== void 0 ? emitsDefinition : {});
    var _instance_vnode_props;
    var keys = Object.keys((_instance_vnode_props = instance === null || instance === void 0 ? void 0 : (_instance_vnode = instance.vnode) === null || _instance_vnode === void 0 ? void 0 : _instance_vnode.props) !== null && _instance_vnode_props !== void 0 ? _instance_vnode_props : {});
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var _key_split = (0, $db8bc344974bb245$export$71511d61b312f219)(key.split(/(?=[A-Z])/)), prefix = _key_split[0], eventNameParts = _key_split.slice(1);
            if (prefix === "on") {
                var eventName = eventNameParts.join("-").toLowerCase();
                var isBuiltIn = $26d6f2f8b43ea981$var$vnodeEvents.has(eventName);
                var isDeclared = declaredEmits.includes(eventName) || declaredEmits.includes((0, $6430dea643e1c0c1$export$161d051f5dd25de7)(eventName));
                var text = isBuiltIn ? "\u2705 Built-in" : isDeclared ? "\u2705 Declared" : "\u26A0\uFE0F Not declared";
                result.push({
                    type: "event listeners",
                    key: eventName,
                    value: {
                        _custom: {
                            displayText: text,
                            key: text,
                            value: text,
                            tooltipText: isBuiltIn ? "The event <code>".concat($26d6f2f8b43ea981$export$4e7f196112fea3c5(eventName), "</code> is part of Vue and doesn't need to be declared by the component") : !isDeclared ? "The event <code>".concat($26d6f2f8b43ea981$export$4e7f196112fea3c5(eventName), "</code> is not declared in the <code>emits</code> option. It will leak into the component's attributes (<code>$attrs</code>).") : null
                        }
                    }
                });
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function $26d6f2f8b43ea981$var$processInstanceState(instance) {
    var mergedType = $26d6f2f8b43ea981$var$resolveMergedOptions(instance);
    return $26d6f2f8b43ea981$var$processProps(instance).concat($26d6f2f8b43ea981$var$processState(instance), $26d6f2f8b43ea981$var$processSetupState(instance), $26d6f2f8b43ea981$var$processComputed(instance, mergedType), $26d6f2f8b43ea981$var$processAttrs(instance), $26d6f2f8b43ea981$var$processProvide(instance), $26d6f2f8b43ea981$var$processInject(instance, mergedType), $26d6f2f8b43ea981$var$processRefs(instance), $26d6f2f8b43ea981$var$processEventListeners(instance));
}
//#endregion
//#region src/core/component/state/index.ts
function $26d6f2f8b43ea981$var$getInstanceState(params) {
    var _instance_type;
    var instance = $26d6f2f8b43ea981$var$getComponentInstance($26d6f2f8b43ea981$export$162128841a7f2877.value, params.instanceId);
    return {
        id: $26d6f2f8b43ea981$var$getUniqueComponentId(instance),
        name: $26d6f2f8b43ea981$var$getInstanceName(instance),
        file: instance === null || instance === void 0 ? void 0 : (_instance_type = instance.type) === null || _instance_type === void 0 ? void 0 : _instance_type.__file,
        state: $26d6f2f8b43ea981$var$processInstanceState(instance),
        instance: instance
    };
}
//#endregion
//#region src/core/component/tree/filter.ts
var $26d6f2f8b43ea981$var$ComponentFilter = /*#__PURE__*/ function() {
    "use strict";
    function ComponentFilter(filter) {
        (0, $173N4._)(this, ComponentFilter);
        this.filter = filter || "";
    }
    (0, $cFHGC._)(ComponentFilter, [
        {
            /**
	* Check if an instance is qualified.
	*
	* @param {Vue|Vnode} instance
	* @return {boolean}
	*/ key: "isQualified",
            value: function isQualified(instance) {
                var name = $26d6f2f8b43ea981$var$getInstanceName(instance);
                return (0, $6430dea643e1c0c1$export$b04d9b8d414ba5e8)(name).toLowerCase().includes(this.filter) || (0, $6430dea643e1c0c1$export$3b2e9c066cbbdd4c)(name).toLowerCase().includes(this.filter);
            }
        }
    ]);
    return ComponentFilter;
}();
function $26d6f2f8b43ea981$var$createComponentFilter(filterText) {
    return new $26d6f2f8b43ea981$var$ComponentFilter(filterText);
}
//#endregion
//#region src/core/component/tree/walker.ts
var $26d6f2f8b43ea981$var$ComponentWalker = /*#__PURE__*/ function() {
    "use strict";
    function ComponentWalker(options) {
        (0, $173N4._)(this, ComponentWalker);
        this.captureIds = /* @__PURE__ */ new Map();
        var _options_filterText = options.filterText, filterText = _options_filterText === void 0 ? "" : _options_filterText, maxDepth = options.maxDepth, recursively = options.recursively, api = options.api;
        this.componentFilter = $26d6f2f8b43ea981$var$createComponentFilter(filterText);
        this.maxDepth = maxDepth;
        this.recursively = recursively;
        this.api = api;
    }
    (0, $cFHGC._)(ComponentWalker, [
        {
            key: "getComponentTree",
            value: function getComponentTree(instance) {
                this.captureIds = /* @__PURE__ */ new Map();
                return this.findQualifiedChildren(instance, 0);
            }
        },
        {
            key: "getComponentParents",
            value: function getComponentParents(instance) {
                this.captureIds = /* @__PURE__ */ new Map();
                var parents = [];
                this.captureId(instance);
                var parent = instance;
                while(parent = parent.parent){
                    this.captureId(parent);
                    parents.push(parent);
                }
                return parents;
            }
        },
        {
            key: "captureId",
            value: function captureId(instance) {
                if (!instance) return null;
                var id = instance.__VUE_DEVTOOLS_NEXT_UID__ != null ? instance.__VUE_DEVTOOLS_NEXT_UID__ : $26d6f2f8b43ea981$var$getUniqueComponentId(instance);
                instance.__VUE_DEVTOOLS_NEXT_UID__ = id;
                if (this.captureIds.has(id)) return null;
                else this.captureIds.set(id, void 0);
                this.mark(instance);
                return id;
            }
        },
        {
            key: "capture",
            value: /**
	* Capture the meta information of an instance. (recursive)
	*
	* @param {Vue} instance
	* @return {object}
	*/ function capture(instance, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, _instance_suspense, id, name, children, parents, inactive, treeNode, cachedComponents, childrenIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, cachedChild, node, err, firstElement, parentInstance, parentRootElements, el, indexList;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!instance) return [
                                    2,
                                    null
                                ];
                                id = this.captureId(instance);
                                name = $26d6f2f8b43ea981$var$getInstanceName(instance);
                                children = this.getInternalInstanceChildren(instance.subTree).filter(function(child) {
                                    return !$26d6f2f8b43ea981$var$isBeingDestroyed(child);
                                });
                                parents = this.getComponentParents(instance) || [];
                                inactive = !!instance.isDeactivated || parents.some(function(parent) {
                                    return parent.isDeactivated;
                                });
                                treeNode = {
                                    uid: instance.uid,
                                    id: id,
                                    name: name,
                                    renderKey: $26d6f2f8b43ea981$var$getRenderKey(instance.vnode ? instance.vnode.key : null),
                                    inactive: inactive,
                                    children: [],
                                    hasChildren: !!children.length,
                                    isFragment: $26d6f2f8b43ea981$var$isFragment(instance),
                                    tags: typeof instance.type !== "function" ? [] : [
                                        {
                                            label: "functional",
                                            textColor: 5592405,
                                            backgroundColor: 15658734
                                        }
                                    ],
                                    autoOpen: this.recursively,
                                    file: instance.type.__file || ""
                                };
                                if (!(depth < this.maxDepth || instance.type.__isKeepAlive || parents.some(function(parent) {
                                    return parent.type.__isKeepAlive;
                                }))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    Promise.all(children.map(function(child) {
                                        return _this.capture(child, depth + 1);
                                    }).filter(Boolean))
                                ];
                            case 1:
                                treeNode.children = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (!this.isKeepAlive(instance)) return [
                                    3,
                                    10
                                ];
                                cachedComponents = this.getKeepAliveCachedInstances(instance);
                                childrenIds = children.map(function(child) {
                                    return child.__VUE_DEVTOOLS_NEXT_UID__;
                                });
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = cachedComponents[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                cachedChild = _step.value;
                                if (!!childrenIds.includes(cachedChild.__VUE_DEVTOOLS_NEXT_UID__)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    this.capture((0, $6fpqi._)((0, $1XAnY._)({}, cachedChild), {
                                        isDeactivated: true
                                    }), depth + 1)
                                ];
                            case 5:
                                node = _state.sent();
                                if (node) treeNode.children.push(node);
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                firstElement = $26d6f2f8b43ea981$var$getRootElementsFromComponentInstance(instance)[0];
                                if (firstElement === null || firstElement === void 0 ? void 0 : firstElement.parentElement) {
                                    parentInstance = instance.parent;
                                    parentRootElements = parentInstance ? $26d6f2f8b43ea981$var$getRootElementsFromComponentInstance(parentInstance) : [];
                                    el = firstElement;
                                    indexList = [];
                                    do {
                                        indexList.push(Array.from(el.parentElement.childNodes).indexOf(el));
                                        el = el.parentElement;
                                    }while (el.parentElement && parentRootElements.length && !parentRootElements.includes(el));
                                    treeNode.domOrder = indexList.reverse();
                                } else treeNode.domOrder = [
                                    -1
                                ];
                                if ((_instance_suspense = instance.suspense) === null || _instance_suspense === void 0 ? void 0 : _instance_suspense.suspenseKey) {
                                    treeNode.tags.push({
                                        label: instance.suspense.suspenseKey,
                                        backgroundColor: 14979812,
                                        textColor: 16777215
                                    });
                                    this.mark(instance, true);
                                }
                                this.api.visitComponentTree({
                                    treeNode: treeNode,
                                    componentInstance: instance,
                                    app: instance.appContext.app,
                                    filter: this.componentFilter.filter
                                });
                                return [
                                    2,
                                    treeNode
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "findQualifiedChildren",
            value: /**
	* Find qualified children from a single instance.
	* If the instance itself is qualified, just return itself.
	* This is ok because [].concat works in both cases.
	*
	* @param {Vue|Vnode} instance
	* @return {Vue|Array}
	*/ function findQualifiedChildren(instance, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _instance_type_devtools, list;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(this.componentFilter.isQualified(instance) && !((_instance_type_devtools = instance.type.devtools) === null || _instance_type_devtools === void 0 ? void 0 : _instance_type_devtools.hide))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.capture(instance, depth)
                                ];
                            case 1:
                                return [
                                    2,
                                    [
                                        _state.sent()
                                    ]
                                ];
                            case 2:
                                if (instance.subTree) {
                                    list = this.isKeepAlive(instance) ? this.getKeepAliveCachedInstances(instance) : this.getInternalInstanceChildren(instance.subTree);
                                    return [
                                        2,
                                        this.findQualifiedChildrenFromList(list, depth)
                                    ];
                                } else return [
                                    2,
                                    []
                                ];
                                _state.label = 3;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "findQualifiedChildrenFromList",
            value: /**
	* Iterate through an array of instances and flatten it into
	* an array of qualified instances. This is a depth-first
	* traversal - e.g. if an instance is not matched, we will
	* recursively go deeper until a qualified child is found.
	*
	* @param {Array} instances
	* @return {Array}
	*/ function findQualifiedChildrenFromList(instances, depth) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                    var _this, _, _1, _tmp;
                    return (0, $13u2V._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                instances = instances.filter(function(child) {
                                    var _child_type_devtools;
                                    return !$26d6f2f8b43ea981$var$isBeingDestroyed(child) && !((_child_type_devtools = child.type.devtools) === null || _child_type_devtools === void 0 ? void 0 : _child_type_devtools.hide);
                                });
                                if (!!this.componentFilter.filter) return [
                                    3,
                                    1
                                ];
                                return [
                                    2,
                                    Promise.all(instances.map(function(child) {
                                        return _this.capture(child, depth);
                                    }))
                                ];
                            case 1:
                                _1 = (_ = Array.prototype.concat).apply;
                                _tmp = [
                                    []
                                ];
                                return [
                                    4,
                                    Promise.all(instances.map(function(i) {
                                        return _this.findQualifiedChildren(i, depth);
                                    }))
                                ];
                            case 2:
                                return [
                                    2,
                                    _1.apply(_, _tmp.concat([
                                        _state.sent()
                                    ]))
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
	* Get children from a component instance.
	*/ key: "getInternalInstanceChildren",
            value: function getInternalInstanceChildren(subTree) {
                var _this = this;
                var suspense = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                var list = [];
                if (subTree) {
                    if (subTree.component) !suspense ? list.push(subTree.component) : list.push((0, $6fpqi._)((0, $1XAnY._)({}, subTree.component), {
                        suspense: suspense
                    }));
                    else if (subTree.suspense) {
                        var _list;
                        var suspenseKey = !subTree.suspense.isInFallback ? "suspense default" : "suspense fallback";
                        (_list = list).push.apply(_list, (0, $aUGqu._)(this.getInternalInstanceChildren(subTree.suspense.activeBranch, (0, $6fpqi._)((0, $1XAnY._)({}, subTree.suspense), {
                            suspenseKey: suspenseKey
                        }))));
                    } else if (Array.isArray(subTree.children)) subTree.children.forEach(function(childSubTree) {
                        var _list;
                        if (childSubTree.component) !suspense ? list.push(childSubTree.component) : list.push((0, $6fpqi._)((0, $1XAnY._)({}, childSubTree.component), {
                            suspense: suspense
                        }));
                        else (_list = list).push.apply(_list, (0, $aUGqu._)(_this.getInternalInstanceChildren(childSubTree, suspense)));
                    });
                }
                return list.filter(function(child) {
                    var _child_type_devtools;
                    return !$26d6f2f8b43ea981$var$isBeingDestroyed(child) && !((_child_type_devtools = child.type.devtools) === null || _child_type_devtools === void 0 ? void 0 : _child_type_devtools.hide);
                });
            }
        },
        {
            /**
	* Mark an instance as captured and store it in the instance map.
	*
	* @param {Vue} instance
	*/ key: "mark",
            value: function mark(instance) {
                var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var instanceMap = $26d6f2f8b43ea981$var$getAppRecord(instance).instanceMap;
                if (force || !instanceMap.has(instance.__VUE_DEVTOOLS_NEXT_UID__)) {
                    instanceMap.set(instance.__VUE_DEVTOOLS_NEXT_UID__, instance);
                    $26d6f2f8b43ea981$export$162128841a7f2877.value.instanceMap = instanceMap;
                }
            }
        },
        {
            key: "isKeepAlive",
            value: function isKeepAlive(instance) {
                return instance.type.__isKeepAlive && instance.__v_cache;
            }
        },
        {
            key: "getKeepAliveCachedInstances",
            value: function getKeepAliveCachedInstances(instance) {
                return Array.from(instance.__v_cache.values()).map(function(vnode) {
                    return vnode.component;
                }).filter(Boolean);
            }
        }
    ]);
    return ComponentWalker;
}();
//#endregion
//#region src/core/timeline/perf.ts
var $26d6f2f8b43ea981$var$markEndQueue = /* @__PURE__ */ new Map();
var $26d6f2f8b43ea981$var$PERFORMANCE_EVENT_LAYER_ID = "performance";
function $26d6f2f8b43ea981$var$performanceMarkStart(api, app, uid, vm, type, time) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
        var appRecord, componentName, groupId, groupKey, _markEndQueue_get, _$app, _$uid, instance, _$type, _$time;
        return (0, $13u2V._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $26d6f2f8b43ea981$var$getAppRecord(app)
                    ];
                case 1:
                    appRecord = _state.sent();
                    if (!appRecord) return [
                        2
                    ];
                    componentName = $26d6f2f8b43ea981$var$getInstanceName(vm) || "Unknown Component";
                    groupId = $26d6f2f8b43ea981$export$a67dd585df937baa.perfUniqueGroupId++;
                    groupKey = "".concat(uid, "-").concat(type);
                    appRecord.perfGroupIds.set(groupKey, {
                        groupId: groupId,
                        time: time
                    });
                    return [
                        4,
                        api.addTimelineEvent({
                            layerId: $26d6f2f8b43ea981$var$PERFORMANCE_EVENT_LAYER_ID,
                            event: {
                                time: Date.now(),
                                data: {
                                    component: componentName,
                                    type: type,
                                    measure: "start"
                                },
                                title: componentName,
                                subtitle: type,
                                groupId: groupId
                            }
                        })
                    ];
                case 2:
                    _state.sent();
                    if (!$26d6f2f8b43ea981$var$markEndQueue.has(groupKey)) return [
                        3,
                        4
                    ];
                    _markEndQueue_get = $26d6f2f8b43ea981$var$markEndQueue.get(groupKey), _$app = _markEndQueue_get.app, _$uid = _markEndQueue_get.uid, instance = _markEndQueue_get.instance, _$type = _markEndQueue_get.type, _$time = _markEndQueue_get.time;
                    $26d6f2f8b43ea981$var$markEndQueue.delete(groupKey);
                    return [
                        4,
                        $26d6f2f8b43ea981$var$performanceMarkEnd(api, _$app, _$uid, instance, _$type, _$time)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $26d6f2f8b43ea981$var$performanceMarkEnd(api, app, uid, vm, type, time) {
    var appRecord = $26d6f2f8b43ea981$var$getAppRecord(app);
    if (!appRecord) return;
    var componentName = $26d6f2f8b43ea981$var$getInstanceName(vm) || "Unknown Component";
    var groupKey = "".concat(uid, "-").concat(type);
    var groupInfo = appRecord.perfGroupIds.get(groupKey);
    if (groupInfo) {
        var groupId = groupInfo.groupId;
        var duration = time - groupInfo.time;
        api.addTimelineEvent({
            layerId: $26d6f2f8b43ea981$var$PERFORMANCE_EVENT_LAYER_ID,
            event: {
                time: Date.now(),
                data: {
                    component: componentName,
                    type: type,
                    measure: "end",
                    duration: {
                        _custom: {
                            type: "Duration",
                            value: duration,
                            display: "".concat(duration, " ms")
                        }
                    }
                },
                title: componentName,
                subtitle: type,
                groupId: groupId
            }
        });
    } else $26d6f2f8b43ea981$var$markEndQueue.set(groupKey, {
        app: app,
        uid: uid,
        instance: vm,
        type: type,
        time: time
    });
}
//#endregion
//#region src/core/timeline/index.ts
var $26d6f2f8b43ea981$var$COMPONENT_EVENT_LAYER_ID = "component-event";
function $26d6f2f8b43ea981$var$setupBuiltinTimelineLayers(api) {
    if (!(0, $6430dea643e1c0c1$export$4e09c449d6c407f7)) return;
    api.addTimelineLayer({
        id: "mouse",
        label: "Mouse",
        color: 10768815
    });
    [
        "mousedown",
        "mouseup",
        "click",
        "dblclick"
    ].forEach(function(eventType) {
        if (!$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.recordingState || !$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.mouseEventEnabled) return;
        window.addEventListener(eventType, function(event) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                api.addTimelineEvent({
                                    layerId: "mouse",
                                    event: {
                                        time: Date.now(),
                                        data: {
                                            type: eventType,
                                            x: event.clientX,
                                            y: event.clientY
                                        },
                                        title: eventType
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: "keyboard",
        label: "Keyboard",
        color: 8475055
    });
    [
        "keyup",
        "keydown",
        "keypress"
    ].forEach(function(eventType) {
        window.addEventListener(eventType, function(event) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.recordingState || !$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.keyboardEventEnabled) return [
                                2
                            ];
                            return [
                                4,
                                api.addTimelineEvent({
                                    layerId: "keyboard",
                                    event: {
                                        time: Date.now(),
                                        data: {
                                            type: eventType,
                                            key: event.key,
                                            ctrlKey: event.ctrlKey,
                                            shiftKey: event.shiftKey,
                                            altKey: event.altKey,
                                            metaKey: event.metaKey
                                        },
                                        title: event.key
                                    }
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }, {
            capture: true,
            passive: true
        });
    });
    api.addTimelineLayer({
        id: $26d6f2f8b43ea981$var$COMPONENT_EVENT_LAYER_ID,
        label: "Component events",
        color: 5226637
    });
    $26d6f2f8b43ea981$var$hook.on.componentEmit(function(app, instance, event, params) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var appRecord, componentId, componentName;
            return (0, $13u2V._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.recordingState || !$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.componentEventEnabled) return [
                            2
                        ];
                        return [
                            4,
                            $26d6f2f8b43ea981$var$getAppRecord(app)
                        ];
                    case 1:
                        appRecord = _state.sent();
                        if (!appRecord) return [
                            2
                        ];
                        componentId = "".concat(appRecord.id, ":").concat(instance.uid);
                        componentName = $26d6f2f8b43ea981$var$getInstanceName(instance) || "Unknown Component";
                        api.addTimelineEvent({
                            layerId: $26d6f2f8b43ea981$var$COMPONENT_EVENT_LAYER_ID,
                            event: {
                                time: Date.now(),
                                data: {
                                    component: {
                                        _custom: {
                                            type: "component-definition",
                                            display: componentName
                                        }
                                    },
                                    event: event,
                                    params: params
                                },
                                title: event,
                                subtitle: "by ".concat(componentName),
                                meta: {
                                    componentId: componentId
                                }
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        })();
    });
    api.addTimelineLayer({
        id: "performance",
        label: $26d6f2f8b43ea981$var$PERFORMANCE_EVENT_LAYER_ID,
        color: 4307050
    });
    $26d6f2f8b43ea981$var$hook.on.perfStart(function(app, uid, vm, type, time) {
        if (!$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.recordingState || !$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $26d6f2f8b43ea981$var$performanceMarkStart(api, app, uid, vm, type, time);
    });
    $26d6f2f8b43ea981$var$hook.on.perfEnd(function(app, uid, vm, type, time) {
        if (!$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.recordingState || !$26d6f2f8b43ea981$export$a67dd585df937baa.timelineLayersState.performanceEventEnabled) return;
        $26d6f2f8b43ea981$var$performanceMarkEnd(api, app, uid, vm, type, time);
    });
}
//#endregion
//#region src/core/vm/index.ts
var $26d6f2f8b43ea981$var$MAX_$VM = 10;
var $26d6f2f8b43ea981$var$$vmQueue = [];
function $26d6f2f8b43ea981$var$exposeInstanceToWindow(componentInstance) {
    if (typeof window === "undefined") return;
    var win = window;
    if (!componentInstance) return;
    win.$vm = componentInstance;
    if ($26d6f2f8b43ea981$var$$vmQueue[0] !== componentInstance) {
        if ($26d6f2f8b43ea981$var$$vmQueue.length >= $26d6f2f8b43ea981$var$MAX_$VM) $26d6f2f8b43ea981$var$$vmQueue.pop();
        for(var i = $26d6f2f8b43ea981$var$$vmQueue.length; i > 0; i--)win["$vm".concat(i)] = $26d6f2f8b43ea981$var$$vmQueue[i] = $26d6f2f8b43ea981$var$$vmQueue[i - 1];
        win.$vm0 = $26d6f2f8b43ea981$var$$vmQueue[0] = componentInstance;
    }
}
//#endregion
//#region src/core/plugin/components.ts
var $26d6f2f8b43ea981$var$INSPECTOR_ID = "components";
function $26d6f2f8b43ea981$export$7e5554ded389d004(app) {
    var descriptor = {
        id: $26d6f2f8b43ea981$var$INSPECTOR_ID,
        label: "Components",
        app: app
    };
    var setupFn = function(api) {
        api.addInspector({
            id: $26d6f2f8b43ea981$var$INSPECTOR_ID,
            label: "Components",
            treeFilterPlaceholder: "Search components"
        });
        $26d6f2f8b43ea981$var$setupBuiltinTimelineLayers(api);
        api.on.getInspectorTree(function(payload) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var instance;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(payload.app === app && payload.inspectorId === $26d6f2f8b43ea981$var$INSPECTOR_ID)) return [
                                3,
                                2
                            ];
                            instance = $26d6f2f8b43ea981$var$getComponentInstance($26d6f2f8b43ea981$export$162128841a7f2877.value, payload.instanceId);
                            if (!instance) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                new $26d6f2f8b43ea981$var$ComponentWalker({
                                    filterText: payload.filter,
                                    maxDepth: 100,
                                    recursively: false,
                                    api: api
                                }).getComponentTree(instance)
                            ];
                        case 1:
                            payload.rootNodes = _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        api.on.getInspectorState(function(payload) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _result_instance, result, componentInstance, _payload;
                return (0, $13u2V._)(this, function(_state) {
                    if (payload.app === app && payload.inspectorId === $26d6f2f8b43ea981$var$INSPECTOR_ID) {
                        ;
                        result = $26d6f2f8b43ea981$var$getInstanceState({
                            instanceId: payload.nodeId
                        });
                        componentInstance = result.instance;
                        _payload = {
                            componentInstance: componentInstance,
                            app: (_result_instance = result.instance) === null || _result_instance === void 0 ? void 0 : _result_instance.appContext.app,
                            instanceData: result
                        };
                        $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.callHookWith(function(callbacks) {
                            callbacks.forEach(function(cb) {
                                return cb(_payload);
                            });
                        }, $26d6f2f8b43ea981$export$3936435a794cb908.INSPECT_COMPONENT);
                        payload.state = result;
                        $26d6f2f8b43ea981$var$exposeInstanceToWindow(componentInstance);
                    }
                    return [
                        2
                    ];
                });
            })();
        });
        api.on.editInspectorState(function(payload) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(payload.app === app && payload.inspectorId === $26d6f2f8b43ea981$var$INSPECTOR_ID)) return [
                                3,
                                2
                            ];
                            $26d6f2f8b43ea981$var$editState(payload);
                            return [
                                4,
                                api.sendInspectorState("components")
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        var debounceSendInspectorTree = (0, $062babd0a85d9d9b$export$61fc7d43ac8f84b0)(function() {
            api.sendInspectorTree($26d6f2f8b43ea981$var$INSPECTOR_ID);
        }, 120);
        var debounceSendInspectorState = (0, $062babd0a85d9d9b$export$61fc7d43ac8f84b0)(function() {
            api.sendInspectorState($26d6f2f8b43ea981$var$INSPECTOR_ID);
        }, 120);
        $26d6f2f8b43ea981$var$hook.on.componentAdded(function(app, uid, parentUid, component) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _app__instance_type_devtools, _app__instance_type, _app__instance, id, appRecord;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return [
                                2
                            ];
                            if (app === null || app === void 0 ? void 0 : (_app__instance = app._instance) === null || _app__instance === void 0 ? void 0 : (_app__instance_type = _app__instance.type) === null || _app__instance_type === void 0 ? void 0 : (_app__instance_type_devtools = _app__instance_type.devtools) === null || _app__instance_type_devtools === void 0 ? void 0 : _app__instance_type_devtools.hide) return [
                                2
                            ];
                            if (!app || typeof uid !== "number" && !uid || !component) return [
                                2
                            ];
                            return [
                                4,
                                $26d6f2f8b43ea981$var$getComponentId({
                                    app: app,
                                    uid: uid,
                                    instance: component
                                })
                            ];
                        case 1:
                            id = _state.sent();
                            return [
                                4,
                                $26d6f2f8b43ea981$var$getAppRecord(app)
                            ];
                        case 2:
                            appRecord = _state.sent();
                            if (component) {
                                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                                if (!(appRecord === null || appRecord === void 0 ? void 0 : appRecord.instanceMap.has(id))) {
                                    appRecord === null || appRecord === void 0 ? void 0 : appRecord.instanceMap.set(id, component);
                                    if ($26d6f2f8b43ea981$export$162128841a7f2877.value.id === (appRecord === null || appRecord === void 0 ? void 0 : appRecord.id)) $26d6f2f8b43ea981$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                                }
                            }
                            if (!appRecord) return [
                                2
                            ];
                            debounceSendInspectorTree();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        $26d6f2f8b43ea981$var$hook.on.componentUpdated(function(app, uid, parentUid, component) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _app__instance_type_devtools, _app__instance_type, _app__instance, id, appRecord;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return [
                                2
                            ];
                            if (app === null || app === void 0 ? void 0 : (_app__instance = app._instance) === null || _app__instance === void 0 ? void 0 : (_app__instance_type = _app__instance.type) === null || _app__instance_type === void 0 ? void 0 : (_app__instance_type_devtools = _app__instance_type.devtools) === null || _app__instance_type_devtools === void 0 ? void 0 : _app__instance_type_devtools.hide) return [
                                2
                            ];
                            if (!app || typeof uid !== "number" && !uid || !component) return [
                                2
                            ];
                            return [
                                4,
                                $26d6f2f8b43ea981$var$getComponentId({
                                    app: app,
                                    uid: uid,
                                    instance: component
                                })
                            ];
                        case 1:
                            id = _state.sent();
                            return [
                                4,
                                $26d6f2f8b43ea981$var$getAppRecord(app)
                            ];
                        case 2:
                            appRecord = _state.sent();
                            if (component) {
                                if (component.__VUE_DEVTOOLS_NEXT_UID__ == null) component.__VUE_DEVTOOLS_NEXT_UID__ = id;
                                if (!(appRecord === null || appRecord === void 0 ? void 0 : appRecord.instanceMap.has(id))) {
                                    appRecord === null || appRecord === void 0 ? void 0 : appRecord.instanceMap.set(id, component);
                                    if ($26d6f2f8b43ea981$export$162128841a7f2877.value.id === (appRecord === null || appRecord === void 0 ? void 0 : appRecord.id)) $26d6f2f8b43ea981$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                                }
                            }
                            if (!appRecord) return [
                                2
                            ];
                            debounceSendInspectorTree();
                            debounceSendInspectorState();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
        $26d6f2f8b43ea981$var$hook.on.componentRemoved(function(app, uid, parentUid, component) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _app__instance_type_devtools, _app__instance_type, _app__instance, appRecord, id;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return [
                                2
                            ];
                            if (app === null || app === void 0 ? void 0 : (_app__instance = app._instance) === null || _app__instance === void 0 ? void 0 : (_app__instance_type = _app__instance.type) === null || _app__instance_type === void 0 ? void 0 : (_app__instance_type_devtools = _app__instance_type.devtools) === null || _app__instance_type_devtools === void 0 ? void 0 : _app__instance_type_devtools.hide) return [
                                2
                            ];
                            if (!app || typeof uid !== "number" && !uid || !component) return [
                                2
                            ];
                            return [
                                4,
                                $26d6f2f8b43ea981$var$getAppRecord(app)
                            ];
                        case 1:
                            appRecord = _state.sent();
                            if (!appRecord) return [
                                2
                            ];
                            return [
                                4,
                                $26d6f2f8b43ea981$var$getComponentId({
                                    app: app,
                                    uid: uid,
                                    instance: component
                                })
                            ];
                        case 2:
                            id = _state.sent();
                            appRecord === null || appRecord === void 0 ? void 0 : appRecord.instanceMap.delete(id);
                            if ($26d6f2f8b43ea981$export$162128841a7f2877.value.id === (appRecord === null || appRecord === void 0 ? void 0 : appRecord.id)) $26d6f2f8b43ea981$export$162128841a7f2877.value.instanceMap = appRecord.instanceMap;
                            debounceSendInspectorTree();
                            return [
                                2
                            ];
                    }
                });
            })();
        });
    };
    return [
        descriptor,
        setupFn
    ];
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = ($26d6f2f8b43ea981$var$_target11 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ : $26d6f2f8b43ea981$var$_target11.__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__ = /* @__PURE__ */ new Set();
function $26d6f2f8b43ea981$export$1f0daed17c8e64f(pluginDescriptor, setupFn) {
    return $26d6f2f8b43ea981$var$hook.setupDevToolsPlugin(pluginDescriptor, setupFn);
}
function $26d6f2f8b43ea981$export$873c261f47a243e7(plugin, app) {
    var _plugin = (0, $f9AOD._)(plugin, 2), pluginDescriptor = _plugin[0], setupFn = _plugin[1];
    if (pluginDescriptor.app !== app) return;
    var api = new $26d6f2f8b43ea981$var$DevToolsPluginAPI({
        plugin: {
            setupFn: setupFn,
            descriptor: pluginDescriptor
        },
        ctx: $26d6f2f8b43ea981$export$4f1904c03898171b
    });
    if (pluginDescriptor.packageName === "vuex") api.on.editInspectorState(function(payload) {
        api.sendInspectorState(payload.inspectorId);
    });
    setupFn(api);
}
function $26d6f2f8b43ea981$export$7f52963080ec618f(app) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.delete(app);
}
function $26d6f2f8b43ea981$export$c357c87447719db2(app, options) {
    if ((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.has(app)) return;
    if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled && !(options === null || options === void 0 ? void 0 : options.inspectingComponent)) return;
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT__REGISTERED_PLUGIN_APPS__.add(app);
    $26d6f2f8b43ea981$export$df02dcb86618c10f.forEach(function(plugin) {
        $26d6f2f8b43ea981$export$873c261f47a243e7(plugin, app);
    });
}
//#endregion
//#region src/ctx/router.ts
var $26d6f2f8b43ea981$export$57206cad6442cbbb = "__VUE_DEVTOOLS_ROUTER__";
var $26d6f2f8b43ea981$export$bcb936c2c1e0b8ba = "__VUE_DEVTOOLS_ROUTER_INFO__";
var $26d6f2f8b43ea981$var$_1;
($26d6f2f8b43ea981$var$_1 = ($26d6f2f8b43ea981$var$_target12 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563))[$26d6f2f8b43ea981$var$_ROUTER_INFO_KEY = $26d6f2f8b43ea981$export$bcb936c2c1e0b8ba]) !== null && $26d6f2f8b43ea981$var$_1 !== void 0 ? $26d6f2f8b43ea981$var$_1 : $26d6f2f8b43ea981$var$_target12[$26d6f2f8b43ea981$var$_ROUTER_INFO_KEY] = {
    currentRoute: null,
    routes: []
};
var $26d6f2f8b43ea981$var$_2;
($26d6f2f8b43ea981$var$_2 = ($26d6f2f8b43ea981$var$_target13 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563))[$26d6f2f8b43ea981$var$_ROUTER_KEY = $26d6f2f8b43ea981$export$57206cad6442cbbb]) !== null && $26d6f2f8b43ea981$var$_2 !== void 0 ? $26d6f2f8b43ea981$var$_2 : $26d6f2f8b43ea981$var$_target13[$26d6f2f8b43ea981$var$_ROUTER_KEY] = {};
var $26d6f2f8b43ea981$export$10a28a01c0e59bea = new Proxy((0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$export$bcb936c2c1e0b8ba], {
    get: function(target$1, property) {
        return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$export$bcb936c2c1e0b8ba][property];
    }
});
var $26d6f2f8b43ea981$export$73b6e4968c970971 = new Proxy((0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$export$57206cad6442cbbb], {
    get: function(target$2, property) {
        if (property === "value") return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$export$57206cad6442cbbb];
    }
});
//#endregion
//#region src/core/router/index.ts
function $26d6f2f8b43ea981$var$getRoutes(router) {
    var routesMap = /* @__PURE__ */ new Map();
    return ((router === null || router === void 0 ? void 0 : router.getRoutes()) || []).filter(function(i) {
        return !routesMap.has(i.path) && routesMap.set(i.path, 1);
    });
}
function $26d6f2f8b43ea981$var$filterRoutes(routes) {
    return routes.map(function(item) {
        var path = item.path, name = item.name, children = item.children, meta = item.meta;
        if (children === null || children === void 0 ? void 0 : children.length) children = $26d6f2f8b43ea981$var$filterRoutes(children);
        return {
            path: path,
            name: name,
            children: children,
            meta: meta
        };
    });
}
function $26d6f2f8b43ea981$var$filterCurrentRoute(route) {
    if (route) {
        var fullPath = route.fullPath, hash = route.hash, href = route.href, path = route.path, name = route.name, matched = route.matched, params = route.params, query = route.query;
        return {
            fullPath: fullPath,
            hash: hash,
            href: href,
            path: path,
            name: name,
            params: params,
            query: query,
            matched: $26d6f2f8b43ea981$var$filterRoutes(matched)
        };
    }
    return route;
}
function $26d6f2f8b43ea981$var$normalizeRouterInfo(appRecord, activeAppRecord) {
    function init() {
        var _appRecord_app;
        var router = (_appRecord_app = appRecord.app) === null || _appRecord_app === void 0 ? void 0 : _appRecord_app.config.globalProperties.$router;
        var currentRoute = $26d6f2f8b43ea981$var$filterCurrentRoute(router === null || router === void 0 ? void 0 : router.currentRoute.value);
        var routes = $26d6f2f8b43ea981$var$filterRoutes($26d6f2f8b43ea981$var$getRoutes(router));
        var c = console.warn;
        console.warn = function() {};
        (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$export$bcb936c2c1e0b8ba] = {
            currentRoute: currentRoute ? (0, $6430dea643e1c0c1$export$b7d58db314e0ac27)(currentRoute) : {},
            routes: (0, $6430dea643e1c0c1$export$b7d58db314e0ac27)(routes)
        };
        (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$export$57206cad6442cbbb] = router;
        console.warn = c;
    }
    init();
    $26d6f2f8b43ea981$var$hook.on.componentUpdated((0, $062babd0a85d9d9b$export$61fc7d43ac8f84b0)(function() {
        var _activeAppRecord_value;
        if (((_activeAppRecord_value = activeAppRecord.value) === null || _activeAppRecord_value === void 0 ? void 0 : _activeAppRecord_value.app) !== appRecord.app) return;
        init();
        if ($26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled) return;
        $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.callHook($26d6f2f8b43ea981$export$12aa7e661bddec80.ROUTER_INFO_UPDATED, {
            state: (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$export$bcb936c2c1e0b8ba]
        });
    }, 200));
}
//#endregion
//#region src/ctx/api.ts
function $26d6f2f8b43ea981$export$bb51459158adb36b(hooks) {
    return {
        getInspectorTree: function(payload) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _payload;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _payload = (0, $6fpqi._)((0, $1XAnY._)({}, payload), {
                                app: $26d6f2f8b43ea981$export$162128841a7f2877.value.app,
                                rootNodes: []
                            });
                            return [
                                4,
                                new Promise(function(resolve) {
                                    hooks.callHookWith(function(callbacks) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                            return (0, $13u2V._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            Promise.all(callbacks.map(function(cb) {
                                                                return cb(_payload);
                                                            }))
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        resolve();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    }, $26d6f2f8b43ea981$export$3936435a794cb908.GET_INSPECTOR_TREE);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                _payload.rootNodes
                            ];
                    }
                });
            })();
        },
        getInspectorState: function(payload) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                var _payload, ctx;
                return (0, $13u2V._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _payload = (0, $6fpqi._)((0, $1XAnY._)({}, payload), {
                                app: $26d6f2f8b43ea981$export$162128841a7f2877.value.app,
                                state: null
                            });
                            ctx = {
                                currentTab: "custom-inspector:".concat(payload.inspectorId)
                            };
                            return [
                                4,
                                new Promise(function(resolve) {
                                    hooks.callHookWith(function(callbacks) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
                                            return (0, $13u2V._)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        return [
                                                            4,
                                                            Promise.all(callbacks.map(function(cb) {
                                                                return cb(_payload, ctx);
                                                            }))
                                                        ];
                                                    case 1:
                                                        _state.sent();
                                                        resolve();
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    }, $26d6f2f8b43ea981$export$3936435a794cb908.GET_INSPECTOR_STATE);
                                })
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2,
                                _payload.state
                            ];
                    }
                });
            })();
        },
        editInspectorState: function(payload) {
            var stateEditor = new $26d6f2f8b43ea981$var$StateEditor();
            var _payload = (0, $6fpqi._)((0, $1XAnY._)({}, payload), {
                app: $26d6f2f8b43ea981$export$162128841a7f2877.value.app,
                set: function(obj) {
                    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : payload.path, value = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : payload.state.value, cb = arguments.length > 3 ? arguments[3] : void 0;
                    stateEditor.set(obj, path, value, cb || stateEditor.createDefaultSetCallback(payload.state));
                }
            });
            hooks.callHookWith(function(callbacks) {
                callbacks.forEach(function(cb) {
                    return cb(_payload);
                });
            }, $26d6f2f8b43ea981$export$3936435a794cb908.EDIT_INSPECTOR_STATE);
        },
        sendInspectorState: function(inspectorId) {
            var inspector = $26d6f2f8b43ea981$export$aa4140d0f5ce4bbe(inspectorId);
            hooks.callHook($26d6f2f8b43ea981$export$4c35c03df042a977.SEND_INSPECTOR_STATE, {
                inspectorId: inspectorId,
                plugin: {
                    descriptor: inspector.descriptor,
                    setupFn: function() {
                        return {};
                    }
                }
            });
        },
        inspectComponentInspector: function() {
            return $26d6f2f8b43ea981$var$inspectComponentHighLighter();
        },
        cancelInspectComponentInspector: function() {
            return $26d6f2f8b43ea981$var$cancelInspectComponentHighLighter();
        },
        getComponentRenderCode: function(id) {
            var instance = $26d6f2f8b43ea981$var$getComponentInstance($26d6f2f8b43ea981$export$162128841a7f2877.value, id);
            if (instance) return !(typeof (instance === null || instance === void 0 ? void 0 : instance.type) === "function") ? instance.render.toString() : instance.type.toString();
        },
        scrollToComponent: function(id) {
            return $26d6f2f8b43ea981$var$scrollToComponent({
                id: id
            });
        },
        openInEditor: $26d6f2f8b43ea981$var$openInEditor,
        getVueInspector: $26d6f2f8b43ea981$var$getComponentInspector,
        toggleApp: function(id, options) {
            var appRecord = $26d6f2f8b43ea981$export$d3c0473489b1d63b.value.find(function(record) {
                return record.id === id;
            });
            if (appRecord) {
                $26d6f2f8b43ea981$export$1a7804ab8d8511d1(id);
                $26d6f2f8b43ea981$export$1574774def61bdf9(appRecord);
                $26d6f2f8b43ea981$var$normalizeRouterInfo(appRecord, $26d6f2f8b43ea981$export$162128841a7f2877);
                $26d6f2f8b43ea981$export$17f8005932e80cc0();
                $26d6f2f8b43ea981$export$c357c87447719db2(appRecord.app, options);
            }
        },
        inspectDOM: function(instanceId) {
            var instance = $26d6f2f8b43ea981$var$getComponentInstance($26d6f2f8b43ea981$export$162128841a7f2877.value, instanceId);
            if (instance) {
                var _getRootElementsFromComponentInstance = (0, $f9AOD._)($26d6f2f8b43ea981$var$getRootElementsFromComponentInstance(instance), 1), el = _getRootElementsFromComponentInstance[0];
                if (el) (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_INSPECT_DOM_TARGET__ = el;
            }
        },
        updatePluginSettings: function(pluginId, key, value) {
            $26d6f2f8b43ea981$var$setPluginSettings(pluginId, key, value);
        },
        getPluginSettings: function(pluginId) {
            return {
                options: $26d6f2f8b43ea981$var$getPluginSettingsOptions(pluginId),
                values: $26d6f2f8b43ea981$var$getPluginSettings(pluginId)
            };
        }
    };
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_ENV__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_ENV__ = ($26d6f2f8b43ea981$var$_target14 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_ENV__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_ENV__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_ENV__ : $26d6f2f8b43ea981$var$_target14.__VUE_DEVTOOLS_ENV__ = {
    vitePluginDetected: false
};
function $26d6f2f8b43ea981$export$6fcf3c68ecb51939() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_ENV__;
}
function $26d6f2f8b43ea981$export$b209b470d7c4ea55(env) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_ENV__ = (0, $1XAnY._)({}, (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_ENV__, env);
}
//#endregion
//#region src/ctx/index.ts
var $26d6f2f8b43ea981$var$hooks = $26d6f2f8b43ea981$export$73be3ac6032ad9bb();
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CONTEXT__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CONTEXT__ = ($26d6f2f8b43ea981$var$_target15 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_CONTEXT__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CONTEXT__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_CONTEXT__ : $26d6f2f8b43ea981$var$_target15.__VUE_DEVTOOLS_KIT_CONTEXT__ = {
    hooks: $26d6f2f8b43ea981$var$hooks,
    get state () {
        return (0, $6fpqi._)((0, $1XAnY._)({}, $26d6f2f8b43ea981$export$a67dd585df937baa), {
            activeAppRecordId: $26d6f2f8b43ea981$export$162128841a7f2877.id,
            activeAppRecord: $26d6f2f8b43ea981$export$162128841a7f2877.value,
            appRecords: $26d6f2f8b43ea981$export$d3c0473489b1d63b.value
        });
    },
    api: $26d6f2f8b43ea981$export$bb51459158adb36b($26d6f2f8b43ea981$var$hooks)
};
var $26d6f2f8b43ea981$export$4f1904c03898171b = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_CONTEXT__;
//#endregion
//#region ../../node_modules/.pnpm/speakingurl@14.0.1/node_modules/speakingurl/lib/speakingurl.js
var $26d6f2f8b43ea981$var$require_speakingurl$1 = /* @__PURE__ */ $26d6f2f8b43ea981$var$__commonJSMin(function(exports, module) {
    (function(root) {
        "use strict";
        /**
		* charMap
		* @type {Object}
		*/ var charMap = {
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "Ae",
            "\xc5": "A",
            "\xc6": "AE",
            "\xc7": "C",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xd0": "D",
            "\xd1": "N",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "Oe",
            "\u0150": "O",
            "\xd8": "O",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "Ue",
            "\u0170": "U",
            "\xdd": "Y",
            "\xde": "TH",
            "\xdf": "ss",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "ae",
            "\xe5": "a",
            "\xe6": "ae",
            "\xe7": "c",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xf0": "d",
            "\xf1": "n",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "oe",
            "\u0151": "o",
            "\xf8": "o",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "ue",
            "\u0171": "u",
            "\xfd": "y",
            "\xfe": "th",
            "\xff": "y",
            "\u1E9E": "SS",
            "\u0627": "a",
            "\u0623": "a",
            "\u0625": "i",
            "\u0622": "aa",
            "\u0624": "u",
            "\u0626": "e",
            "\u0621": "a",
            "\u0628": "b",
            "\u062A": "t",
            "\u062B": "th",
            "\u062C": "j",
            "\u062D": "h",
            "\u062E": "kh",
            "\u062F": "d",
            "\u0630": "th",
            "\u0631": "r",
            "\u0632": "z",
            "\u0633": "s",
            "\u0634": "sh",
            "\u0635": "s",
            "\u0636": "dh",
            "\u0637": "t",
            "\u0638": "z",
            "\u0639": "a",
            "\u063A": "gh",
            "\u0641": "f",
            "\u0642": "q",
            "\u0643": "k",
            "\u0644": "l",
            "\u0645": "m",
            "\u0646": "n",
            "\u0647": "h",
            "\u0648": "w",
            "\u064A": "y",
            "\u0649": "a",
            "\u0629": "h",
            "\uFEFB": "la",
            "\uFEF7": "laa",
            "\uFEF9": "lai",
            "\uFEF5": "laa",
            "\u06AF": "g",
            "\u0686": "ch",
            "\u067E": "p",
            "\u0698": "zh",
            "\u06A9": "k",
            "\u06CC": "y",
            "\u064E": "a",
            "\u064B": "an",
            "\u0650": "e",
            "\u064D": "en",
            "\u064F": "u",
            "\u064C": "on",
            "\u0652": "",
            "\u0660": "0",
            "\u0661": "1",
            "\u0662": "2",
            "\u0663": "3",
            "\u0664": "4",
            "\u0665": "5",
            "\u0666": "6",
            "\u0667": "7",
            "\u0668": "8",
            "\u0669": "9",
            "\u06F0": "0",
            "\u06F1": "1",
            "\u06F2": "2",
            "\u06F3": "3",
            "\u06F4": "4",
            "\u06F5": "5",
            "\u06F6": "6",
            "\u06F7": "7",
            "\u06F8": "8",
            "\u06F9": "9",
            "\u1000": "k",
            "\u1001": "kh",
            "\u1002": "g",
            "\u1003": "ga",
            "\u1004": "ng",
            "\u1005": "s",
            "\u1006": "sa",
            "\u1007": "z",
            "\u1005\u103B": "za",
            "\u100A": "ny",
            "\u100B": "t",
            "\u100C": "ta",
            "\u100D": "d",
            "\u100E": "da",
            "\u100F": "na",
            "\u1010": "t",
            "\u1011": "ta",
            "\u1012": "d",
            "\u1013": "da",
            "\u1014": "n",
            "\u1015": "p",
            "\u1016": "pa",
            "\u1017": "b",
            "\u1018": "ba",
            "\u1019": "m",
            "\u101A": "y",
            "\u101B": "ya",
            "\u101C": "l",
            "\u101D": "w",
            "\u101E": "th",
            "\u101F": "h",
            "\u1020": "la",
            "\u1021": "a",
            "\u103C": "y",
            "\u103B": "ya",
            "\u103D": "w",
            "\u103C\u103D": "yw",
            "\u103B\u103D": "ywa",
            "\u103E": "h",
            "\u1027": "e",
            "\u104F": "-e",
            "\u1023": "i",
            "\u1024": "-i",
            "\u1009": "u",
            "\u1026": "-u",
            "\u1029": "aw",
            "\u101E\u103C\u1031\u102C": "aw",
            "\u102A": "aw",
            "\u1040": "0",
            "\u1041": "1",
            "\u1042": "2",
            "\u1043": "3",
            "\u1044": "4",
            "\u1045": "5",
            "\u1046": "6",
            "\u1047": "7",
            "\u1048": "8",
            "\u1049": "9",
            "\u1039": "",
            "\u1037": "",
            "\u1038": "",
            "\u010D": "c",
            "\u010F": "d",
            "\u011B": "e",
            "\u0148": "n",
            "\u0159": "r",
            "\u0161": "s",
            "\u0165": "t",
            "\u016F": "u",
            "\u017E": "z",
            "\u010C": "C",
            "\u010E": "D",
            "\u011A": "E",
            "\u0147": "N",
            "\u0158": "R",
            "\u0160": "S",
            "\u0164": "T",
            "\u016E": "U",
            "\u017D": "Z",
            "\u0780": "h",
            "\u0781": "sh",
            "\u0782": "n",
            "\u0783": "r",
            "\u0784": "b",
            "\u0785": "lh",
            "\u0786": "k",
            "\u0787": "a",
            "\u0788": "v",
            "\u0789": "m",
            "\u078A": "f",
            "\u078B": "dh",
            "\u078C": "th",
            "\u078D": "l",
            "\u078E": "g",
            "\u078F": "gn",
            "\u0790": "s",
            "\u0791": "d",
            "\u0792": "z",
            "\u0793": "t",
            "\u0794": "y",
            "\u0795": "p",
            "\u0796": "j",
            "\u0797": "ch",
            "\u0798": "tt",
            "\u0799": "hh",
            "\u079A": "kh",
            "\u079B": "th",
            "\u079C": "z",
            "\u079D": "sh",
            "\u079E": "s",
            "\u079F": "d",
            "\u07A0": "t",
            "\u07A1": "z",
            "\u07A2": "a",
            "\u07A3": "gh",
            "\u07A4": "q",
            "\u07A5": "w",
            "\u07A6": "a",
            "\u07A7": "aa",
            "\u07A8": "i",
            "\u07A9": "ee",
            "\u07AA": "u",
            "\u07AB": "oo",
            "\u07AC": "e",
            "\u07AD": "ey",
            "\u07AE": "o",
            "\u07AF": "oa",
            "\u07B0": "",
            "\u10D0": "a",
            "\u10D1": "b",
            "\u10D2": "g",
            "\u10D3": "d",
            "\u10D4": "e",
            "\u10D5": "v",
            "\u10D6": "z",
            "\u10D7": "t",
            "\u10D8": "i",
            "\u10D9": "k",
            "\u10DA": "l",
            "\u10DB": "m",
            "\u10DC": "n",
            "\u10DD": "o",
            "\u10DE": "p",
            "\u10DF": "zh",
            "\u10E0": "r",
            "\u10E1": "s",
            "\u10E2": "t",
            "\u10E3": "u",
            "\u10E4": "p",
            "\u10E5": "k",
            "\u10E6": "gh",
            "\u10E7": "q",
            "\u10E8": "sh",
            "\u10E9": "ch",
            "\u10EA": "ts",
            "\u10EB": "dz",
            "\u10EC": "ts",
            "\u10ED": "ch",
            "\u10EE": "kh",
            "\u10EF": "j",
            "\u10F0": "h",
            "\u03B1": "a",
            "\u03B2": "v",
            "\u03B3": "g",
            "\u03B4": "d",
            "\u03B5": "e",
            "\u03B6": "z",
            "\u03B7": "i",
            "\u03B8": "th",
            "\u03B9": "i",
            "\u03BA": "k",
            "\u03BB": "l",
            "\u03BC": "m",
            "\u03BD": "n",
            "\u03BE": "ks",
            "\u03BF": "o",
            "\u03C0": "p",
            "\u03C1": "r",
            "\u03C3": "s",
            "\u03C4": "t",
            "\u03C5": "y",
            "\u03C6": "f",
            "\u03C7": "x",
            "\u03C8": "ps",
            "\u03C9": "o",
            "\u03AC": "a",
            "\u03AD": "e",
            "\u03AF": "i",
            "\u03CC": "o",
            "\u03CD": "y",
            "\u03AE": "i",
            "\u03CE": "o",
            "\u03C2": "s",
            "\u03CA": "i",
            "\u03B0": "y",
            "\u03CB": "y",
            "\u0390": "i",
            "\u0391": "A",
            "\u0392": "B",
            "\u0393": "G",
            "\u0394": "D",
            "\u0395": "E",
            "\u0396": "Z",
            "\u0397": "I",
            "\u0398": "TH",
            "\u0399": "I",
            "\u039A": "K",
            "\u039B": "L",
            "\u039C": "M",
            "\u039D": "N",
            "\u039E": "KS",
            "\u039F": "O",
            "\u03A0": "P",
            "\u03A1": "R",
            "\u03A3": "S",
            "\u03A4": "T",
            "\u03A5": "Y",
            "\u03A6": "F",
            "\u03A7": "X",
            "\u03A8": "PS",
            "\u03A9": "O",
            "\u0386": "A",
            "\u0388": "E",
            "\u038A": "I",
            "\u038C": "O",
            "\u038E": "Y",
            "\u0389": "I",
            "\u038F": "O",
            "\u03AA": "I",
            "\u03AB": "Y",
            "\u0101": "a",
            "\u0113": "e",
            "\u0123": "g",
            "\u012B": "i",
            "\u0137": "k",
            "\u013C": "l",
            "\u0146": "n",
            "\u016B": "u",
            "\u0100": "A",
            "\u0112": "E",
            "\u0122": "G",
            "\u012A": "I",
            "\u0136": "k",
            "\u013B": "L",
            "\u0145": "N",
            "\u016A": "U",
            "\u040C": "Kj",
            "\u045C": "kj",
            "\u0409": "Lj",
            "\u0459": "lj",
            "\u040A": "Nj",
            "\u045A": "nj",
            "\u0422\u0441": "Ts",
            "\u0442\u0441": "ts",
            "\u0105": "a",
            "\u0107": "c",
            "\u0119": "e",
            "\u0142": "l",
            "\u0144": "n",
            "\u015B": "s",
            "\u017A": "z",
            "\u017C": "z",
            "\u0104": "A",
            "\u0106": "C",
            "\u0118": "E",
            "\u0141": "L",
            "\u0143": "N",
            "\u015A": "S",
            "\u0179": "Z",
            "\u017B": "Z",
            "\u0404": "Ye",
            "\u0406": "I",
            "\u0407": "Yi",
            "\u0490": "G",
            "\u0454": "ye",
            "\u0456": "i",
            "\u0457": "yi",
            "\u0491": "g",
            "\u0103": "a",
            "\u0102": "A",
            "\u0219": "s",
            "\u0218": "S",
            "\u021B": "t",
            "\u021A": "T",
            "\u0163": "t",
            "\u0162": "T",
            "\u0430": "a",
            "\u0431": "b",
            "\u0432": "v",
            "\u0433": "g",
            "\u0434": "d",
            "\u0435": "e",
            "\u0451": "yo",
            "\u0436": "zh",
            "\u0437": "z",
            "\u0438": "i",
            "\u0439": "i",
            "\u043A": "k",
            "\u043B": "l",
            "\u043C": "m",
            "\u043D": "n",
            "\u043E": "o",
            "\u043F": "p",
            "\u0440": "r",
            "\u0441": "s",
            "\u0442": "t",
            "\u0443": "u",
            "\u0444": "f",
            "\u0445": "kh",
            "\u0446": "c",
            "\u0447": "ch",
            "\u0448": "sh",
            "\u0449": "sh",
            "\u044A": "",
            "\u044B": "y",
            "\u044C": "",
            "\u044D": "e",
            "\u044E": "yu",
            "\u044F": "ya",
            "\u0410": "A",
            "\u0411": "B",
            "\u0412": "V",
            "\u0413": "G",
            "\u0414": "D",
            "\u0415": "E",
            "\u0401": "Yo",
            "\u0416": "Zh",
            "\u0417": "Z",
            "\u0418": "I",
            "\u0419": "I",
            "\u041A": "K",
            "\u041B": "L",
            "\u041C": "M",
            "\u041D": "N",
            "\u041E": "O",
            "\u041F": "P",
            "\u0420": "R",
            "\u0421": "S",
            "\u0422": "T",
            "\u0423": "U",
            "\u0424": "F",
            "\u0425": "Kh",
            "\u0426": "C",
            "\u0427": "Ch",
            "\u0428": "Sh",
            "\u0429": "Sh",
            "\u042A": "",
            "\u042B": "Y",
            "\u042C": "",
            "\u042D": "E",
            "\u042E": "Yu",
            "\u042F": "Ya",
            "\u0452": "dj",
            "\u0458": "j",
            "\u045B": "c",
            "\u045F": "dz",
            "\u0402": "Dj",
            "\u0408": "j",
            "\u040B": "C",
            "\u040F": "Dz",
            "\u013E": "l",
            "\u013A": "l",
            "\u0155": "r",
            "\u013D": "L",
            "\u0139": "L",
            "\u0154": "R",
            "\u015F": "s",
            "\u015E": "S",
            "\u0131": "i",
            "\u0130": "I",
            "\u011F": "g",
            "\u011E": "G",
            "\u1EA3": "a",
            "\u1EA2": "A",
            "\u1EB3": "a",
            "\u1EB2": "A",
            "\u1EA9": "a",
            "\u1EA8": "A",
            "\u0111": "d",
            "\u0110": "D",
            "\u1EB9": "e",
            "\u1EB8": "E",
            "\u1EBD": "e",
            "\u1EBC": "E",
            "\u1EBB": "e",
            "\u1EBA": "E",
            "\u1EBF": "e",
            "\u1EBE": "E",
            "\u1EC1": "e",
            "\u1EC0": "E",
            "\u1EC7": "e",
            "\u1EC6": "E",
            "\u1EC5": "e",
            "\u1EC4": "E",
            "\u1EC3": "e",
            "\u1EC2": "E",
            "\u1ECF": "o",
            "\u1ECD": "o",
            "\u1ECC": "o",
            "\u1ED1": "o",
            "\u1ED0": "O",
            "\u1ED3": "o",
            "\u1ED2": "O",
            "\u1ED5": "o",
            "\u1ED4": "O",
            "\u1ED9": "o",
            "\u1ED8": "O",
            "\u1ED7": "o",
            "\u1ED6": "O",
            "\u01A1": "o",
            "\u01A0": "O",
            "\u1EDB": "o",
            "\u1EDA": "O",
            "\u1EDD": "o",
            "\u1EDC": "O",
            "\u1EE3": "o",
            "\u1EE2": "O",
            "\u1EE1": "o",
            "\u1EE0": "O",
            "\u1EDE": "o",
            "\u1EDF": "o",
            "\u1ECB": "i",
            "\u1ECA": "I",
            "\u0129": "i",
            "\u0128": "I",
            "\u1EC9": "i",
            "\u1EC8": "i",
            "\u1EE7": "u",
            "\u1EE6": "U",
            "\u1EE5": "u",
            "\u1EE4": "U",
            "\u0169": "u",
            "\u0168": "U",
            "\u01B0": "u",
            "\u01AF": "U",
            "\u1EE9": "u",
            "\u1EE8": "U",
            "\u1EEB": "u",
            "\u1EEA": "U",
            "\u1EF1": "u",
            "\u1EF0": "U",
            "\u1EEF": "u",
            "\u1EEE": "U",
            "\u1EED": "u",
            "\u1EEC": "\u01B0",
            "\u1EF7": "y",
            "\u1EF6": "y",
            "\u1EF3": "y",
            "\u1EF2": "Y",
            "\u1EF5": "y",
            "\u1EF4": "Y",
            "\u1EF9": "y",
            "\u1EF8": "Y",
            "\u1EA1": "a",
            "\u1EA0": "A",
            "\u1EA5": "a",
            "\u1EA4": "A",
            "\u1EA7": "a",
            "\u1EA6": "A",
            "\u1EAD": "a",
            "\u1EAC": "A",
            "\u1EAB": "a",
            "\u1EAA": "A",
            "\u1EAF": "a",
            "\u1EAE": "A",
            "\u1EB1": "a",
            "\u1EB0": "A",
            "\u1EB7": "a",
            "\u1EB6": "A",
            "\u1EB5": "a",
            "\u1EB4": "A",
            "\u24EA": "0",
            "\u2460": "1",
            "\u2461": "2",
            "\u2462": "3",
            "\u2463": "4",
            "\u2464": "5",
            "\u2465": "6",
            "\u2466": "7",
            "\u2467": "8",
            "\u2468": "9",
            "\u2469": "10",
            "\u246A": "11",
            "\u246B": "12",
            "\u246C": "13",
            "\u246D": "14",
            "\u246E": "15",
            "\u246F": "16",
            "\u2470": "17",
            "\u2471": "18",
            "\u2472": "18",
            "\u2473": "18",
            "\u24F5": "1",
            "\u24F6": "2",
            "\u24F7": "3",
            "\u24F8": "4",
            "\u24F9": "5",
            "\u24FA": "6",
            "\u24FB": "7",
            "\u24FC": "8",
            "\u24FD": "9",
            "\u24FE": "10",
            "\u24FF": "0",
            "\u24EB": "11",
            "\u24EC": "12",
            "\u24ED": "13",
            "\u24EE": "14",
            "\u24EF": "15",
            "\u24F0": "16",
            "\u24F1": "17",
            "\u24F2": "18",
            "\u24F3": "19",
            "\u24F4": "20",
            "\u24B6": "A",
            "\u24B7": "B",
            "\u24B8": "C",
            "\u24B9": "D",
            "\u24BA": "E",
            "\u24BB": "F",
            "\u24BC": "G",
            "\u24BD": "H",
            "\u24BE": "I",
            "\u24BF": "J",
            "\u24C0": "K",
            "\u24C1": "L",
            "\u24C2": "M",
            "\u24C3": "N",
            "\u24C4": "O",
            "\u24C5": "P",
            "\u24C6": "Q",
            "\u24C7": "R",
            "\u24C8": "S",
            "\u24C9": "T",
            "\u24CA": "U",
            "\u24CB": "V",
            "\u24CC": "W",
            "\u24CD": "X",
            "\u24CE": "Y",
            "\u24CF": "Z",
            "\u24D0": "a",
            "\u24D1": "b",
            "\u24D2": "c",
            "\u24D3": "d",
            "\u24D4": "e",
            "\u24D5": "f",
            "\u24D6": "g",
            "\u24D7": "h",
            "\u24D8": "i",
            "\u24D9": "j",
            "\u24DA": "k",
            "\u24DB": "l",
            "\u24DC": "m",
            "\u24DD": "n",
            "\u24DE": "o",
            "\u24DF": "p",
            "\u24E0": "q",
            "\u24E1": "r",
            "\u24E2": "s",
            "\u24E3": "t",
            "\u24E4": "u",
            "\u24E6": "v",
            "\u24E5": "w",
            "\u24E7": "x",
            "\u24E8": "y",
            "\u24E9": "z",
            "\u201C": "\"",
            "\u201D": "\"",
            "\u2018": "'",
            "\u2019": "'",
            "\u2202": "d",
            "\u0192": "f",
            "\u2122": "(TM)",
            "\xa9": "(C)",
            "\u0153": "oe",
            "\u0152": "OE",
            "\xae": "(R)",
            "\u2020": "+",
            "\u2120": "(SM)",
            "\u2026": "...",
            "\u02DA": "o",
            "\xba": "o",
            "\xaa": "a",
            "\u2022": "*",
            "\u104A": ",",
            "\u104B": ".",
            "$": "USD",
            "\u20AC": "EUR",
            "\u20A2": "BRN",
            "\u20A3": "FRF",
            "\xa3": "GBP",
            "\u20A4": "ITL",
            "\u20A6": "NGN",
            "\u20A7": "ESP",
            "\u20A9": "KRW",
            "\u20AA": "ILS",
            "\u20AB": "VND",
            "\u20AD": "LAK",
            "\u20AE": "MNT",
            "\u20AF": "GRD",
            "\u20B1": "ARS",
            "\u20B2": "PYG",
            "\u20B3": "ARA",
            "\u20B4": "UAH",
            "\u20B5": "GHS",
            "\xa2": "cent",
            "\xa5": "CNY",
            "\u5143": "CNY",
            "\u5186": "YEN",
            "\uFDFC": "IRR",
            "\u20A0": "EWE",
            "\u0E3F": "THB",
            "\u20A8": "INR",
            "\u20B9": "INR",
            "\u20B0": "PF",
            "\u20BA": "TRY",
            "\u060B": "AFN",
            "\u20BC": "AZN",
            "\u043B\u0432": "BGN",
            "\u17DB": "KHR",
            "\u20A1": "CRC",
            "\u20B8": "KZT",
            "\u0434\u0435\u043D": "MKD",
            "z\u0142": "PLN",
            "\u20BD": "RUB",
            "\u20BE": "GEL"
        };
        /**
		* special look ahead character array
		* These characters form with consonants to become 'single'/consonant combo
		* @type [Array]
		*/ var lookAheadCharArray = [
            "\u103A",
            "\u07B0"
        ];
        /**
		* diatricMap for languages where transliteration changes entirely as more diatrics are added
		* @type {Object}
		*/ var diatricMap = {
            "\u102C": "a",
            "\u102B": "a",
            "\u1031": "e",
            "\u1032": "e",
            "\u102D": "i",
            "\u102E": "i",
            "\u102D\u102F": "o",
            "\u102F": "u",
            "\u1030": "u",
            "\u1031\u102B\u1004\u103A": "aung",
            "\u1031\u102C": "aw",
            "\u1031\u102C\u103A": "aw",
            "\u1031\u102B": "aw",
            "\u1031\u102B\u103A": "aw",
            "\u103A": "\u103A",
            "\u1000\u103A": "et",
            "\u102D\u102F\u1000\u103A": "aik",
            "\u1031\u102C\u1000\u103A": "auk",
            "\u1004\u103A": "in",
            "\u102D\u102F\u1004\u103A": "aing",
            "\u1031\u102C\u1004\u103A": "aung",
            "\u1005\u103A": "it",
            "\u100A\u103A": "i",
            "\u1010\u103A": "at",
            "\u102D\u1010\u103A": "eik",
            "\u102F\u1010\u103A": "ok",
            "\u103D\u1010\u103A": "ut",
            "\u1031\u1010\u103A": "it",
            "\u1012\u103A": "d",
            "\u102D\u102F\u1012\u103A": "ok",
            "\u102F\u1012\u103A": "ait",
            "\u1014\u103A": "an",
            "\u102C\u1014\u103A": "an",
            "\u102D\u1014\u103A": "ein",
            "\u102F\u1014\u103A": "on",
            "\u103D\u1014\u103A": "un",
            "\u1015\u103A": "at",
            "\u102D\u1015\u103A": "eik",
            "\u102F\u1015\u103A": "ok",
            "\u103D\u1015\u103A": "ut",
            "\u1014\u103A\u102F\u1015\u103A": "nub",
            "\u1019\u103A": "an",
            "\u102D\u1019\u103A": "ein",
            "\u102F\u1019\u103A": "on",
            "\u103D\u1019\u103A": "un",
            "\u101A\u103A": "e",
            "\u102D\u102F\u101C\u103A": "ol",
            "\u1009\u103A": "in",
            "\u1036": "an",
            "\u102D\u1036": "ein",
            "\u102F\u1036": "on",
            "\u07A6\u0787\u07B0": "ah",
            "\u07A6\u0781\u07B0": "ah"
        };
        /**
		* langCharMap language specific characters translations
		* @type   {Object}
		*/ var langCharMap = {
            "en": {},
            "az": {
                "\xe7": "c",
                "\u0259": "e",
                "\u011F": "g",
                "\u0131": "i",
                "\xf6": "o",
                "\u015F": "s",
                "\xfc": "u",
                "\xc7": "C",
                "\u018F": "E",
                "\u011E": "G",
                "\u0130": "I",
                "\xd6": "O",
                "\u015E": "S",
                "\xdc": "U"
            },
            "cs": {
                "\u010D": "c",
                "\u010F": "d",
                "\u011B": "e",
                "\u0148": "n",
                "\u0159": "r",
                "\u0161": "s",
                "\u0165": "t",
                "\u016F": "u",
                "\u017E": "z",
                "\u010C": "C",
                "\u010E": "D",
                "\u011A": "E",
                "\u0147": "N",
                "\u0158": "R",
                "\u0160": "S",
                "\u0164": "T",
                "\u016E": "U",
                "\u017D": "Z"
            },
            "fi": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O"
            },
            "hu": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O",
                "\xfc": "u",
                "\xdc": "U",
                "\u0171": "u",
                "\u0170": "U"
            },
            "lt": {
                "\u0105": "a",
                "\u010D": "c",
                "\u0119": "e",
                "\u0117": "e",
                "\u012F": "i",
                "\u0161": "s",
                "\u0173": "u",
                "\u016B": "u",
                "\u017E": "z",
                "\u0104": "A",
                "\u010C": "C",
                "\u0118": "E",
                "\u0116": "E",
                "\u012E": "I",
                "\u0160": "S",
                "\u0172": "U",
                "\u016A": "U"
            },
            "lv": {
                "\u0101": "a",
                "\u010D": "c",
                "\u0113": "e",
                "\u0123": "g",
                "\u012B": "i",
                "\u0137": "k",
                "\u013C": "l",
                "\u0146": "n",
                "\u0161": "s",
                "\u016B": "u",
                "\u017E": "z",
                "\u0100": "A",
                "\u010C": "C",
                "\u0112": "E",
                "\u0122": "G",
                "\u012A": "i",
                "\u0136": "k",
                "\u013B": "L",
                "\u0145": "N",
                "\u0160": "S",
                "\u016A": "u",
                "\u017D": "Z"
            },
            "pl": {
                "\u0105": "a",
                "\u0107": "c",
                "\u0119": "e",
                "\u0142": "l",
                "\u0144": "n",
                "\xf3": "o",
                "\u015B": "s",
                "\u017A": "z",
                "\u017C": "z",
                "\u0104": "A",
                "\u0106": "C",
                "\u0118": "e",
                "\u0141": "L",
                "\u0143": "N",
                "\xd3": "O",
                "\u015A": "S",
                "\u0179": "Z",
                "\u017B": "Z"
            },
            "sv": {
                "\xe4": "a",
                "\xc4": "A",
                "\xf6": "o",
                "\xd6": "O"
            },
            "sk": {
                "\xe4": "a",
                "\xc4": "A"
            },
            "sr": {
                "\u0459": "lj",
                "\u045A": "nj",
                "\u0409": "Lj",
                "\u040A": "Nj",
                "\u0111": "dj",
                "\u0110": "Dj"
            },
            "tr": {
                "\xdc": "U",
                "\xd6": "O",
                "\xfc": "u",
                "\xf6": "o"
            }
        };
        /**
		* symbolMap language specific symbol translations
		* translations must be transliterated already
		* @type   {Object}
		*/ var symbolMap = {
            "ar": {
                "\u2206": "delta",
                "\u221E": "la-nihaya",
                "\u2665": "hob",
                "&": "wa",
                "|": "aw",
                "<": "aqal-men",
                ">": "akbar-men",
                "\u2211": "majmou",
                "\xa4": "omla"
            },
            "az": {},
            "ca": {
                "\u2206": "delta",
                "\u221E": "infinit",
                "\u2665": "amor",
                "&": "i",
                "|": "o",
                "<": "menys que",
                ">": "mes que",
                "\u2211": "suma dels",
                "\xa4": "moneda"
            },
            "cs": {
                "\u2206": "delta",
                "\u221E": "nekonecno",
                "\u2665": "laska",
                "&": "a",
                "|": "nebo",
                "<": "mensi nez",
                ">": "vetsi nez",
                "\u2211": "soucet",
                "\xa4": "mena"
            },
            "de": {
                "\u2206": "delta",
                "\u221E": "unendlich",
                "\u2665": "Liebe",
                "&": "und",
                "|": "oder",
                "<": "kleiner als",
                ">": "groesser als",
                "\u2211": "Summe von",
                "\xa4": "Waehrung"
            },
            "dv": {
                "\u2206": "delta",
                "\u221E": "kolunulaa",
                "\u2665": "loabi",
                "&": "aai",
                "|": "noonee",
                "<": "ah vure kuda",
                ">": "ah vure bodu",
                "\u2211": "jumula",
                "\xa4": "faisaa"
            },
            "en": {
                "\u2206": "delta",
                "\u221E": "infinity",
                "\u2665": "love",
                "&": "and",
                "|": "or",
                "<": "less than",
                ">": "greater than",
                "\u2211": "sum",
                "\xa4": "currency"
            },
            "es": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amor",
                "&": "y",
                "|": "u",
                "<": "menos que",
                ">": "mas que",
                "\u2211": "suma de los",
                "\xa4": "moneda"
            },
            "fa": {
                "\u2206": "delta",
                "\u221E": "bi-nahayat",
                "\u2665": "eshgh",
                "&": "va",
                "|": "ya",
                "<": "kamtar-az",
                ">": "bishtar-az",
                "\u2211": "majmooe",
                "\xa4": "vahed"
            },
            "fi": {
                "\u2206": "delta",
                "\u221E": "aarettomyys",
                "\u2665": "rakkaus",
                "&": "ja",
                "|": "tai",
                "<": "pienempi kuin",
                ">": "suurempi kuin",
                "\u2211": "summa",
                "\xa4": "valuutta"
            },
            "fr": {
                "\u2206": "delta",
                "\u221E": "infiniment",
                "\u2665": "Amour",
                "&": "et",
                "|": "ou",
                "<": "moins que",
                ">": "superieure a",
                "\u2211": "somme des",
                "\xa4": "monnaie"
            },
            "ge": {
                "\u2206": "delta",
                "\u221E": "usasruloba",
                "\u2665": "siqvaruli",
                "&": "da",
                "|": "an",
                "<": "naklebi",
                ">": "meti",
                "\u2211": "jami",
                "\xa4": "valuta"
            },
            "gr": {},
            "hu": {
                "\u2206": "delta",
                "\u221E": "vegtelen",
                "\u2665": "szerelem",
                "&": "es",
                "|": "vagy",
                "<": "kisebb mint",
                ">": "nagyobb mint",
                "\u2211": "szumma",
                "\xa4": "penznem"
            },
            "it": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amore",
                "&": "e",
                "|": "o",
                "<": "minore di",
                ">": "maggiore di",
                "\u2211": "somma",
                "\xa4": "moneta"
            },
            "lt": {
                "\u2206": "delta",
                "\u221E": "begalybe",
                "\u2665": "meile",
                "&": "ir",
                "|": "ar",
                "<": "maziau nei",
                ">": "daugiau nei",
                "\u2211": "suma",
                "\xa4": "valiuta"
            },
            "lv": {
                "\u2206": "delta",
                "\u221E": "bezgaliba",
                "\u2665": "milestiba",
                "&": "un",
                "|": "vai",
                "<": "mazak neka",
                ">": "lielaks neka",
                "\u2211": "summa",
                "\xa4": "valuta"
            },
            "my": {
                "\u2206": "kwahkhyaet",
                "\u221E": "asaonasme",
                "\u2665": "akhyait",
                "&": "nhin",
                "|": "tho",
                "<": "ngethaw",
                ">": "kyithaw",
                "\u2211": "paungld",
                "\xa4": "ngwekye"
            },
            "mk": {},
            "nl": {
                "\u2206": "delta",
                "\u221E": "oneindig",
                "\u2665": "liefde",
                "&": "en",
                "|": "of",
                "<": "kleiner dan",
                ">": "groter dan",
                "\u2211": "som",
                "\xa4": "valuta"
            },
            "pl": {
                "\u2206": "delta",
                "\u221E": "nieskonczonosc",
                "\u2665": "milosc",
                "&": "i",
                "|": "lub",
                "<": "mniejsze niz",
                ">": "wieksze niz",
                "\u2211": "suma",
                "\xa4": "waluta"
            },
            "pt": {
                "\u2206": "delta",
                "\u221E": "infinito",
                "\u2665": "amor",
                "&": "e",
                "|": "ou",
                "<": "menor que",
                ">": "maior que",
                "\u2211": "soma",
                "\xa4": "moeda"
            },
            "ro": {
                "\u2206": "delta",
                "\u221E": "infinit",
                "\u2665": "dragoste",
                "&": "si",
                "|": "sau",
                "<": "mai mic ca",
                ">": "mai mare ca",
                "\u2211": "suma",
                "\xa4": "valuta"
            },
            "ru": {
                "\u2206": "delta",
                "\u221E": "beskonechno",
                "\u2665": "lubov",
                "&": "i",
                "|": "ili",
                "<": "menshe",
                ">": "bolshe",
                "\u2211": "summa",
                "\xa4": "valjuta"
            },
            "sk": {
                "\u2206": "delta",
                "\u221E": "nekonecno",
                "\u2665": "laska",
                "&": "a",
                "|": "alebo",
                "<": "menej ako",
                ">": "viac ako",
                "\u2211": "sucet",
                "\xa4": "mena"
            },
            "sr": {},
            "tr": {
                "\u2206": "delta",
                "\u221E": "sonsuzluk",
                "\u2665": "ask",
                "&": "ve",
                "|": "veya",
                "<": "kucuktur",
                ">": "buyuktur",
                "\u2211": "toplam",
                "\xa4": "para birimi"
            },
            "uk": {
                "\u2206": "delta",
                "\u221E": "bezkinechnist",
                "\u2665": "lubov",
                "&": "i",
                "|": "abo",
                "<": "menshe",
                ">": "bilshe",
                "\u2211": "suma",
                "\xa4": "valjuta"
            },
            "vn": {
                "\u2206": "delta",
                "\u221E": "vo cuc",
                "\u2665": "yeu",
                "&": "va",
                "|": "hoac",
                "<": "nho hon",
                ">": "lon hon",
                "\u2211": "tong",
                "\xa4": "tien te"
            }
        };
        var uricChars = [
            ";",
            "?",
            ":",
            "@",
            "&",
            "=",
            "+",
            "$",
            ",",
            "/"
        ].join("");
        var uricNoSlashChars = [
            ";",
            "?",
            ":",
            "@",
            "&",
            "=",
            "+",
            "$",
            ","
        ].join("");
        var markChars = [
            ".",
            "!",
            "~",
            "*",
            "'",
            "(",
            ")"
        ].join("");
        /**
		* getSlug
		* @param  {string} input input string
		* @param  {object|string} opts config object or separator string/char
		* @api    public
		* @return {string}  sluggified string
		*/ var getSlug = function getSlug(input, opts) {
            var separator = "-";
            var result = "";
            var diatricString = "";
            var convertSymbols = true;
            var customReplacements = {};
            var maintainCase;
            var titleCase;
            var truncate;
            var uricFlag;
            var uricNoSlashFlag;
            var markFlag;
            var symbol;
            var langChar;
            var lucky;
            var i;
            var ch;
            var l;
            var lastCharWasSymbol;
            var lastCharWasDiatric;
            var allowedChars = "";
            if (typeof input !== "string") return "";
            if (typeof opts === "string") separator = opts;
            symbol = symbolMap.en;
            langChar = langCharMap.en;
            if ((typeof opts === "undefined" ? "undefined" : (0, $7E0eS._)(opts)) === "object") {
                maintainCase = opts.maintainCase || false;
                customReplacements = opts.custom && (0, $7E0eS._)(opts.custom) === "object" ? opts.custom : customReplacements;
                truncate = +opts.truncate > 1 && opts.truncate || false;
                uricFlag = opts.uric || false;
                uricNoSlashFlag = opts.uricNoSlash || false;
                markFlag = opts.mark || false;
                convertSymbols = opts.symbols === false || opts.lang === false ? false : true;
                separator = opts.separator || separator;
                if (uricFlag) allowedChars += uricChars;
                if (uricNoSlashFlag) allowedChars += uricNoSlashChars;
                if (markFlag) allowedChars += markChars;
                symbol = opts.lang && symbolMap[opts.lang] && convertSymbols ? symbolMap[opts.lang] : convertSymbols ? symbolMap.en : {};
                langChar = opts.lang && langCharMap[opts.lang] ? langCharMap[opts.lang] : opts.lang === false || opts.lang === true ? {} : langCharMap.en;
                if (opts.titleCase && typeof opts.titleCase.length === "number" && Array.prototype.toString.call(opts.titleCase)) {
                    opts.titleCase.forEach(function(v) {
                        customReplacements[v + ""] = v + "";
                    });
                    titleCase = true;
                } else titleCase = !!opts.titleCase;
                if (opts.custom && typeof opts.custom.length === "number" && Array.prototype.toString.call(opts.custom)) opts.custom.forEach(function(v) {
                    customReplacements[v + ""] = v + "";
                });
                Object.keys(customReplacements).forEach(function(v) {
                    var r;
                    if (v.length > 1) r = new RegExp("\\b" + escapeChars(v) + "\\b", "gi");
                    else r = new RegExp(escapeChars(v), "gi");
                    input = input.replace(r, customReplacements[v]);
                });
                for(ch in customReplacements)allowedChars += ch;
            }
            allowedChars += separator;
            allowedChars = escapeChars(allowedChars);
            input = input.replace(/(^\s+|\s+$)/g, "");
            lastCharWasSymbol = false;
            lastCharWasDiatric = false;
            for(i = 0, l = input.length; i < l; i++){
                ch = input[i];
                if (isReplacedCustomChar(ch, customReplacements)) lastCharWasSymbol = false;
                else if (langChar[ch]) {
                    ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? " " + langChar[ch] : langChar[ch];
                    lastCharWasSymbol = false;
                } else if (ch in charMap) {
                    if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                        diatricString += ch;
                        ch = "";
                    } else if (lastCharWasDiatric === true) {
                        ch = diatricMap[diatricString] + charMap[ch];
                        diatricString = "";
                    } else ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? " " + charMap[ch] : charMap[ch];
                    lastCharWasSymbol = false;
                    lastCharWasDiatric = false;
                } else if (ch in diatricMap) {
                    diatricString += ch;
                    ch = "";
                    if (i === l - 1) ch = diatricMap[diatricString];
                    lastCharWasDiatric = true;
                } else if (symbol[ch] && !(uricFlag && uricChars.indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars.indexOf(ch) !== -1)) {
                    ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                    ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : "";
                    lastCharWasSymbol = true;
                } else {
                    if (lastCharWasDiatric === true) {
                        ch = diatricMap[diatricString] + ch;
                        diatricString = "";
                        lastCharWasDiatric = false;
                    } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) ch = " " + ch;
                    lastCharWasSymbol = false;
                }
                result += ch.replace(new RegExp("[^\\w\\s" + allowedChars + "_-]", "g"), separator);
            }
            if (titleCase) result = result.replace(/(\w)(\S*)/g, function(_, i, r) {
                var j = i.toUpperCase() + (r !== null ? r : "");
                return Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0 ? j : j.toLowerCase();
            });
            result = result.replace(/\s+/g, separator).replace(new RegExp("\\" + separator + "+", "g"), separator).replace(new RegExp("(^\\" + separator + "+|\\" + separator + "+$)", "g"), "");
            if (truncate && result.length > truncate) {
                lucky = result.charAt(truncate) === separator;
                result = result.slice(0, truncate);
                if (!lucky) result = result.slice(0, result.lastIndexOf(separator));
            }
            if (!maintainCase && !titleCase) result = result.toLowerCase();
            return result;
        };
        /**
		* createSlug curried(opts)(input)
		* @param   {object|string} opts config object or input string
		* @return  {Function} function getSlugWithConfig()
		**/ var createSlug = function createSlug(opts) {
            /**
			* getSlugWithConfig
			* @param   {string} input string
			* @return  {string} slug string
			*/ return function getSlugWithConfig(input) {
                return getSlug(input, opts);
            };
        };
        /**
		* escape Chars
		* @param   {string} input string
		*/ var escapeChars = function escapeChars(input) {
            return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, "\\$&");
        };
        /**
		* check if the char is an already converted char from custom list
		* @param   {char} ch character to check
		* @param   {object} customReplacements custom translation map
		*/ var isReplacedCustomChar = function isReplacedCustomChar(ch, customReplacements) {
            for(var c in customReplacements)if (customReplacements[c] === ch) return true;
        };
        if (typeof module !== "undefined" && module.exports) {
            module.exports = getSlug;
            module.exports.createSlug = createSlug;
        } else if (typeof define !== "undefined" && define.amd) define([], function() {
            return getSlug;
        });
        else try {
            if (root.getSlug || root.createSlug) throw "speakingurl: globals exists /(getSlug|createSlug)/";
            else {
                root.getSlug = getSlug;
                root.createSlug = createSlug;
            }
        } catch (e) {}
    })(exports);
});
//#endregion
//#region src/core/app/index.ts
var $26d6f2f8b43ea981$var$import_speakingurl = /* @__PURE__ */ $26d6f2f8b43ea981$var$__toESM(/* @__PURE__ */ $26d6f2f8b43ea981$var$__commonJSMin(function(exports, module) {
    module.exports = $26d6f2f8b43ea981$var$require_speakingurl$1();
})(), 1);
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__;
var $26d6f2f8b43ea981$var$appRecordInfo = ($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = ($26d6f2f8b43ea981$var$_target16 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ : $26d6f2f8b43ea981$var$_target16.__VUE_DEVTOOLS_NEXT_APP_RECORD_INFO__ = {
    id: 0,
    appIds: /* @__PURE__ */ new Set()
};
function $26d6f2f8b43ea981$var$getAppRecordName(app, fallbackName) {
    var _app__component;
    return (app === null || app === void 0 ? void 0 : (_app__component = app._component) === null || _app__component === void 0 ? void 0 : _app__component.name) || "App ".concat(fallbackName);
}
function $26d6f2f8b43ea981$var$getAppRootInstance(app) {
    var _app__container__vnode, _app__container, _app__container__vnode1, _app__container1;
    if (app._instance) return app._instance;
    else if ((_app__container = app._container) === null || _app__container === void 0 ? void 0 : (_app__container__vnode = _app__container._vnode) === null || _app__container__vnode === void 0 ? void 0 : _app__container__vnode.component) return (_app__container1 = app._container) === null || _app__container1 === void 0 ? void 0 : (_app__container__vnode1 = _app__container1._vnode) === null || _app__container__vnode1 === void 0 ? void 0 : _app__container__vnode1.component;
}
function $26d6f2f8b43ea981$var$removeAppRecordId(app) {
    var id = app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    if (id != null) {
        $26d6f2f8b43ea981$var$appRecordInfo.appIds.delete(id);
        $26d6f2f8b43ea981$var$appRecordInfo.id--;
    }
}
function $26d6f2f8b43ea981$var$getAppRecordId(app, defaultId) {
    if (app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ != null) return app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__;
    var id = defaultId !== null && defaultId !== void 0 ? defaultId : ($26d6f2f8b43ea981$var$appRecordInfo.id++).toString();
    if (defaultId && $26d6f2f8b43ea981$var$appRecordInfo.appIds.has(id)) {
        var count = 1;
        while($26d6f2f8b43ea981$var$appRecordInfo.appIds.has("".concat(defaultId, "_").concat(count)))count++;
        id = "".concat(defaultId, "_").concat(count);
    }
    $26d6f2f8b43ea981$var$appRecordInfo.appIds.add(id);
    app.__VUE_DEVTOOLS_NEXT_APP_RECORD_ID__ = id;
    return id;
}
function $26d6f2f8b43ea981$var$createAppRecord(app, types) {
    var rootInstance = $26d6f2f8b43ea981$var$getAppRootInstance(app);
    if (rootInstance) {
        var _el_ownerDocument_location, _el_ownerDocument;
        $26d6f2f8b43ea981$var$appRecordInfo.id++;
        var name = $26d6f2f8b43ea981$var$getAppRecordName(app, $26d6f2f8b43ea981$var$appRecordInfo.id.toString());
        var id = $26d6f2f8b43ea981$var$getAppRecordId(app, (0, $26d6f2f8b43ea981$var$import_speakingurl.default)(name));
        var _getRootElementsFromComponentInstance = (0, $f9AOD._)($26d6f2f8b43ea981$var$getRootElementsFromComponentInstance(rootInstance), 1), el = _getRootElementsFromComponentInstance[0];
        var record = {
            id: id,
            name: name,
            types: types,
            instanceMap: /* @__PURE__ */ new Map(),
            perfGroupIds: /* @__PURE__ */ new Map(),
            rootInstance: rootInstance,
            iframe: (0, $6430dea643e1c0c1$export$4e09c449d6c407f7) && document !== (el === null || el === void 0 ? void 0 : el.ownerDocument) ? el === null || el === void 0 ? void 0 : (_el_ownerDocument = el.ownerDocument) === null || _el_ownerDocument === void 0 ? void 0 : (_el_ownerDocument_location = _el_ownerDocument.location) === null || _el_ownerDocument_location === void 0 ? void 0 : _el_ownerDocument_location.pathname : void 0
        };
        app.__VUE_DEVTOOLS_NEXT_APP_RECORD__ = record;
        var rootId = "".concat(record.id, ":root");
        record.instanceMap.set(rootId, record.rootInstance);
        record.rootInstance.__VUE_DEVTOOLS_NEXT_UID__ = rootId;
        return record;
    } else return {};
}
//#endregion
//#region src/core/iframe/index.ts
function $26d6f2f8b43ea981$var$detectIframeApp(target) {
    var inIframe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (inIframe) {
        function sendEventToParent(cb) {
            try {
                var hook = window.parent.__VUE_DEVTOOLS_GLOBAL_HOOK__;
                if (hook) cb(hook);
            } catch (e) {}
        }
        var hook = {
            id: "vue-devtools-next",
            devtoolsVersion: "7.0",
            on: function(event, cb) {
                sendEventToParent(function(hook) {
                    hook.on(event, cb);
                });
            },
            once: function(event, cb) {
                sendEventToParent(function(hook) {
                    hook.once(event, cb);
                });
            },
            off: function(event, cb) {
                sendEventToParent(function(hook) {
                    hook.off(event, cb);
                });
            },
            emit: function(event) {
                for(var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    payload[_key - 1] = arguments[_key];
                }
                sendEventToParent(function(hook) {
                    var _hook;
                    (_hook = hook).emit.apply(_hook, [
                        event
                    ].concat((0, $aUGqu._)(payload)));
                });
            }
        };
        Object.defineProperty(target, "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
            get: function() {
                return hook;
            },
            configurable: true
        });
    }
    function injectVueHookToIframe(iframe) {
        if (iframe.__vdevtools__injected) return;
        try {
            iframe.__vdevtools__injected = true;
            var inject = function() {
                try {
                    iframe.contentWindow.__VUE_DEVTOOLS_IFRAME__ = iframe;
                    var script = iframe.contentDocument.createElement("script");
                    script.textContent = ";(".concat($26d6f2f8b43ea981$var$detectIframeApp.toString(), ")(window, true)");
                    iframe.contentDocument.documentElement.appendChild(script);
                    script.parentNode.removeChild(script);
                } catch (e) {}
            };
            inject();
            iframe.addEventListener("load", function() {
                return inject();
            });
        } catch (e) {}
    }
    function injectVueHookToIframes() {
        if (typeof window === "undefined") return;
        var iframes = Array.from(document.querySelectorAll("iframe:not([data-vue-devtools-ignore])"));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = iframes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var iframe = _step.value;
                injectVueHookToIframe(iframe);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    injectVueHookToIframes();
    var iframeAppChecks = 0;
    var iframeAppCheckTimer = setInterval(function() {
        injectVueHookToIframes();
        iframeAppChecks++;
        if (iframeAppChecks >= 5) clearInterval(iframeAppCheckTimer);
    }, 1e3);
}
//#endregion
//#region src/core/index.ts
function $26d6f2f8b43ea981$export$93f430585c3f6d11() {
    var _target___VUE_DEVTOOLS_GLOBAL_HOOK__;
    $26d6f2f8b43ea981$var$detectIframeApp((0, $6430dea643e1c0c1$export$44271b4f0c6a3563));
    $26d6f2f8b43ea981$export$ee22a7aaf6b41ce2({
        vitePluginDetected: $26d6f2f8b43ea981$export$6fcf3c68ecb51939().vitePluginDetected
    });
    var isDevToolsNext = ((_target___VUE_DEVTOOLS_GLOBAL_HOOK__ = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__) === null || _target___VUE_DEVTOOLS_GLOBAL_HOOK__ === void 0 ? void 0 : _target___VUE_DEVTOOLS_GLOBAL_HOOK__.id) === "vue-devtools-next";
    if ((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__ && isDevToolsNext) return;
    var _devtoolsHook = $26d6f2f8b43ea981$var$createDevToolsHook();
    if ((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_HOOK_REPLAY__) try {
        (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_HOOK_REPLAY__.forEach(function(cb) {
            return cb(_devtoolsHook);
        });
        (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_HOOK_REPLAY__ = [];
    } catch (e) {
        console.error("[vue-devtools] Error during hook replay", e);
    }
    _devtoolsHook.once("init", function(Vue) {
        (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_VUE2_APP_DETECTED__ = true;
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
        console.log("%cVue DevTools v7 detected in your Vue2 project. v7 only supports Vue3 and will not work.", "font-bold: 500; font-size: 14px;");
        var legacyChromeUrl = "https://chromewebstore.google.com/detail/vuejs-devtools/iaajmlceplecbljialhhkmedjlpdblhp";
        var legacyFirefoxUrl = "https://addons.mozilla.org/firefox/addon/vue-js-devtools-v6-legacy";
        console.log("%cThe legacy version of chrome extension that supports both Vue 2 and Vue 3 has been moved to %c ".concat(legacyChromeUrl), "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log("%cThe legacy version of firefox extension that supports both Vue 2 and Vue 3 has been moved to %c ".concat(legacyFirefoxUrl), "font-size: 14px;", "text-decoration: underline; cursor: pointer;font-size: 14px;");
        console.log("%cPlease install and enable only the legacy version for your Vue2 app.", "font-bold: 500; font-size: 14px;");
        console.log("%c[_____Vue DevTools v7 log_____]", "color: red; font-bold: 600; font-size: 16px;");
    });
    $26d6f2f8b43ea981$var$hook.on.setupDevtoolsPlugin(function(pluginDescriptor, setupFn) {
        $26d6f2f8b43ea981$export$5158df7771943590(pluginDescriptor, setupFn);
        var app = ($26d6f2f8b43ea981$export$162128841a7f2877 !== null && $26d6f2f8b43ea981$export$162128841a7f2877 !== void 0 ? $26d6f2f8b43ea981$export$162128841a7f2877 : {}).app;
        if (pluginDescriptor.settings) $26d6f2f8b43ea981$var$initPluginSettings(pluginDescriptor.id, pluginDescriptor.settings);
        if (!app) return;
        $26d6f2f8b43ea981$export$873c261f47a243e7([
            pluginDescriptor,
            setupFn
        ], app);
    });
    $26d6f2f8b43ea981$var$onLegacyDevToolsPluginApiAvailable(function() {
        $26d6f2f8b43ea981$export$df02dcb86618c10f.filter(function(param) {
            var _param = (0, $f9AOD._)(param, 1), item = _param[0];
            return item.id !== "components";
        }).forEach(function(param) {
            var _param = (0, $f9AOD._)(param, 2), pluginDescriptor = _param[0], setupFn = _param[1];
            _devtoolsHook.emit($26d6f2f8b43ea981$var$DevToolsHooks.SETUP_DEVTOOLS_PLUGIN, pluginDescriptor, setupFn, {
                target: "legacy"
            });
        });
    });
    $26d6f2f8b43ea981$var$hook.on.vueAppInit(function(app, version, types) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var normalizedAppRecord;
            return (0, $13u2V._)(this, function(_state) {
                normalizedAppRecord = (0, $6fpqi._)((0, $1XAnY._)({}, $26d6f2f8b43ea981$var$createAppRecord(app, types)), {
                    app: app,
                    version: version
                });
                $26d6f2f8b43ea981$export$c1761479e1420543(normalizedAppRecord);
                if ($26d6f2f8b43ea981$export$d3c0473489b1d63b.value.length === 1) {
                    $26d6f2f8b43ea981$export$1574774def61bdf9(normalizedAppRecord);
                    $26d6f2f8b43ea981$export$1a7804ab8d8511d1(normalizedAppRecord.id);
                    $26d6f2f8b43ea981$var$normalizeRouterInfo(normalizedAppRecord, $26d6f2f8b43ea981$export$162128841a7f2877);
                    $26d6f2f8b43ea981$export$c357c87447719db2(normalizedAppRecord.app);
                }
                $26d6f2f8b43ea981$export$1f0daed17c8e64f.apply(void 0, (0, $aUGqu._)($26d6f2f8b43ea981$export$7e5554ded389d004(normalizedAppRecord.app)));
                $26d6f2f8b43ea981$export$ee22a7aaf6b41ce2({
                    connected: true
                });
                _devtoolsHook.apps.push(app);
                return [
                    2
                ];
            });
        })();
    });
    $26d6f2f8b43ea981$var$hook.on.vueAppUnmount(function(app) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $3gP77._)(function() {
            var activeRecords;
            return (0, $13u2V._)(this, function(_state) {
                activeRecords = $26d6f2f8b43ea981$export$d3c0473489b1d63b.value.filter(function(appRecord) {
                    return appRecord.app !== app;
                });
                if (activeRecords.length === 0) $26d6f2f8b43ea981$export$ee22a7aaf6b41ce2({
                    connected: false
                });
                $26d6f2f8b43ea981$export$4d20c72f1da170ba(app);
                $26d6f2f8b43ea981$var$removeAppRecordId(app);
                if ($26d6f2f8b43ea981$export$162128841a7f2877.value.app === app) {
                    $26d6f2f8b43ea981$export$1574774def61bdf9(activeRecords[0]);
                    $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.callHook($26d6f2f8b43ea981$export$12aa7e661bddec80.SEND_ACTIVE_APP_UNMOUNTED_TO_CLIENT);
                }
                (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.splice((0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__.apps.indexOf(app), 1);
                $26d6f2f8b43ea981$export$7f52963080ec618f(app);
                return [
                    2
                ];
            });
        })();
    });
    $26d6f2f8b43ea981$var$subscribeDevToolsHook(_devtoolsHook);
    if (!(0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_GLOBAL_HOOK__) Object.defineProperty((0, $6430dea643e1c0c1$export$44271b4f0c6a3563), "__VUE_DEVTOOLS_GLOBAL_HOOK__", {
        get: function() {
            return _devtoolsHook;
        },
        configurable: true
    });
    else if (!(0, $6430dea643e1c0c1$export$e34a31924fd64105)) Object.assign(__VUE_DEVTOOLS_GLOBAL_HOOK__, _devtoolsHook);
}
function $26d6f2f8b43ea981$export$cb42e76452729606(fn) {
    return new Promise(function(resolve) {
        if ($26d6f2f8b43ea981$export$a67dd585df937baa.connected && $26d6f2f8b43ea981$export$a67dd585df937baa.clientConnected) {
            fn();
            resolve();
            return;
        }
        $26d6f2f8b43ea981$export$4f1904c03898171b.hooks.hook($26d6f2f8b43ea981$export$12aa7e661bddec80.DEVTOOLS_CONNECTED_UPDATED, function(param) {
            var state = param.state;
            if (state.connected && state.clientConnected) {
                fn();
                resolve();
            }
        });
    });
}
//#endregion
//#region src/core/high-perf-mode/index.ts
function $26d6f2f8b43ea981$export$6f15da7a796da26a(state) {
    $26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled = state !== null && state !== void 0 ? state : !$26d6f2f8b43ea981$export$a67dd585df937baa.highPerfModeEnabled;
    if (!state && $26d6f2f8b43ea981$export$162128841a7f2877.value) $26d6f2f8b43ea981$export$c357c87447719db2($26d6f2f8b43ea981$export$162128841a7f2877.value.app);
}
//#endregion
//#region src/core/component/state/reviver.ts
function $26d6f2f8b43ea981$var$reviveSet(val) {
    var result = /* @__PURE__ */ new Set();
    var list = val._custom.value;
    for(var i = 0; i < list.length; i++){
        var value = list[i];
        result.add($26d6f2f8b43ea981$var$revive(value));
    }
    return result;
}
function $26d6f2f8b43ea981$var$reviveMap(val) {
    var result = /* @__PURE__ */ new Map();
    var list = val._custom.value;
    for(var i = 0; i < list.length; i++){
        var _list_i = list[i], key = _list_i.key, value = _list_i.value;
        result.set(key, $26d6f2f8b43ea981$var$revive(value));
    }
    return result;
}
function $26d6f2f8b43ea981$var$revive(val) {
    if (val === "__vue_devtool_undefined__") return;
    else if (val === "__vue_devtool_infinity__") return Number.POSITIVE_INFINITY;
    else if (val === "__vue_devtool_negative_infinity__") return Number.NEGATIVE_INFINITY;
    else if (val === "__vue_devtool_nan__") return NaN;
    else if (val && val._custom) {
        var custom = val._custom;
        if (custom.type === "component") return $26d6f2f8b43ea981$export$162128841a7f2877.value.instanceMap.get(custom.id);
        else if (custom.type === "map") return $26d6f2f8b43ea981$var$reviveMap(val);
        else if (custom.type === "set") return $26d6f2f8b43ea981$var$reviveSet(val);
        else if (custom.type === "bigint") return BigInt(custom.value);
        else return $26d6f2f8b43ea981$var$revive(custom.value);
    } else if ($26d6f2f8b43ea981$var$symbolRE.test(val)) {
        var _symbolRE_exec = (0, $f9AOD._)($26d6f2f8b43ea981$var$symbolRE.exec(val), 2), string = _symbolRE_exec[1];
        return Symbol.for(string);
    } else if ($26d6f2f8b43ea981$var$specialTypeRE.test(val)) {
        var _specialTypeRE_exec = (0, $f9AOD._)($26d6f2f8b43ea981$var$specialTypeRE.exec(val), 5), type = _specialTypeRE_exec[1], string1 = _specialTypeRE_exec[2], details = _specialTypeRE_exec[4];
        var result = new (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[type](string1);
        if (type === "Error" && details) result.stack = details;
        return result;
    } else return val;
}
function $26d6f2f8b43ea981$var$reviver(key, value) {
    return $26d6f2f8b43ea981$var$revive(value);
}
//#endregion
//#region src/core/component/state/format.ts
function $26d6f2f8b43ea981$export$a2acd0fde5480ad5(value) {
    var raw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var type = typeof value === "undefined" ? "undefined" : (0, $7E0eS._)(value);
    if (value == null || value === "__vue_devtool_undefined__" || value === "undefined") return "null";
    else if (type === "boolean" || type === "number" || value === "__vue_devtool_infinity__" || value === "__vue_devtool_negative_infinity__" || value === "__vue_devtool_nan__") return "literal";
    else if (value === null || value === void 0 ? void 0 : value._custom) {
        if (raw || value._custom.display != null || value._custom.displayText != null) return "custom";
        else return $26d6f2f8b43ea981$export$a2acd0fde5480ad5(value._custom.value);
    } else if (typeof value === "string") {
        var typeMatch = $26d6f2f8b43ea981$var$specialTypeRE.exec(value);
        if (typeMatch) {
            var _typeMatch = (0, $f9AOD._)(typeMatch, 2), type1 = _typeMatch[1];
            return "native ".concat(type1);
        } else return "string";
    } else if (Array.isArray(value) || (value === null || value === void 0 ? void 0 : value._isArray)) return "array";
    else if ($26d6f2f8b43ea981$export$53b83ca8eaab0383(value)) return "plain-object";
    else return "unknown";
}
function $26d6f2f8b43ea981$export$6c635c17a78ff695(value) {
    var quotes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, options = arguments.length > 2 ? arguments[2] : void 0;
    var _value__custom_value, _specialTypeRE_exec;
    var customClass = (options !== null && options !== void 0 ? options : {}).customClass;
    var result;
    var type = $26d6f2f8b43ea981$export$a2acd0fde5480ad5(value, false);
    if (type !== "custom" && (value === null || value === void 0 ? void 0 : value._custom)) value = value._custom.value;
    if (result = $26d6f2f8b43ea981$var$internalStateTokenToString(value)) return result;
    else if (type === "custom") return ((_value__custom_value = value._custom.value) === null || _value__custom_value === void 0 ? void 0 : _value__custom_value._custom) && $26d6f2f8b43ea981$export$6c635c17a78ff695(value._custom.value, quotes, options) || value._custom.displayText || value._custom.display;
    else if (type === "array") return "Array[".concat(value.length, "]");
    else if (type === "plain-object") return "Object".concat(Object.keys(value).length ? "" : " (empty)");
    else if (type === null || type === void 0 ? void 0 : type.includes("native")) return $26d6f2f8b43ea981$export$4e7f196112fea3c5((_specialTypeRE_exec = $26d6f2f8b43ea981$var$specialTypeRE.exec(value)) === null || _specialTypeRE_exec === void 0 ? void 0 : _specialTypeRE_exec[2]);
    else if (typeof value === "string") {
        var typeMatch = value.match($26d6f2f8b43ea981$var$rawTypeRE);
        var _customClass_string;
        if (typeMatch) value = $26d6f2f8b43ea981$var$escapeString(typeMatch[1]);
        else if (quotes) value = '<span>"</span>'.concat((customClass === null || customClass === void 0 ? void 0 : customClass.string) ? "<span class=".concat(customClass.string, ">").concat($26d6f2f8b43ea981$var$escapeString(value), "</span>") : $26d6f2f8b43ea981$var$escapeString(value), '<span>"</span>');
        else value = (customClass === null || customClass === void 0 ? void 0 : customClass.string) ? '<span class="'.concat((_customClass_string = customClass === null || customClass === void 0 ? void 0 : customClass.string) !== null && _customClass_string !== void 0 ? _customClass_string : "", '">').concat($26d6f2f8b43ea981$var$escapeString(value), "</span>") : $26d6f2f8b43ea981$var$escapeString(value);
    }
    return value;
}
function $26d6f2f8b43ea981$var$escapeString(value) {
    return $26d6f2f8b43ea981$export$4e7f196112fea3c5(value).replace(/ /g, "&nbsp;").replace(/\n/g, "<span>\\n</span>");
}
function $26d6f2f8b43ea981$export$d049e3525cb8af5d(value) {
    var customType;
    var isCustom = $26d6f2f8b43ea981$export$a2acd0fde5480ad5(value) === "custom";
    var inherit = {};
    if (isCustom) {
        var _data__custom, _data__custom1, _data__custom2;
        var data = value;
        var customValue = (_data__custom = data._custom) === null || _data__custom === void 0 ? void 0 : _data__custom.value;
        var currentCustomType = (_data__custom1 = data._custom) === null || _data__custom1 === void 0 ? void 0 : _data__custom1.type;
        var nestedCustom = (typeof customValue === "undefined" ? "undefined" : (0, $7E0eS._)(customValue)) === "object" && customValue !== null && "_custom" in customValue ? $26d6f2f8b43ea981$export$d049e3525cb8af5d(customValue) : {
            inherit: void 0,
            value: void 0,
            customType: void 0
        };
        inherit = nestedCustom.inherit || ((_data__custom2 = data._custom) === null || _data__custom2 === void 0 ? void 0 : _data__custom2.fields) || {};
        value = nestedCustom.value || customValue;
        customType = nestedCustom.customType || currentCustomType;
    }
    if (value && value._isArray) value = value.items;
    return {
        value: value,
        inherit: inherit,
        customType: customType
    };
}
function $26d6f2f8b43ea981$export$b0067b146e5937f7(value, customType) {
    if (customType === "bigint") return value;
    if (customType === "date") return value;
    return $26d6f2f8b43ea981$var$replaceTokenToString(JSON.stringify(value));
}
function $26d6f2f8b43ea981$export$d61dc8d725d3735e(value, customType) {
    if (customType === "bigint") return BigInt(value);
    if (customType === "date") return new Date(value);
    return JSON.parse($26d6f2f8b43ea981$var$replaceStringToToken(value), $26d6f2f8b43ea981$var$reviver);
}
//#endregion
//#region src/core/devtools-client/detected.ts
function $26d6f2f8b43ea981$export$2fce292577290205(params) {
    $26d6f2f8b43ea981$export$a67dd585df937baa.devtoolsClientDetected = (0, $1XAnY._)({}, $26d6f2f8b43ea981$export$a67dd585df937baa.devtoolsClientDetected, params);
    $26d6f2f8b43ea981$export$6f15da7a796da26a(!Object.values($26d6f2f8b43ea981$export$a67dd585df937baa.devtoolsClientDetected).some(Boolean));
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = ($26d6f2f8b43ea981$var$_target17 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ : $26d6f2f8b43ea981$var$_target17.__VUE_DEVTOOLS_UPDATE_CLIENT_DETECTED__ = $26d6f2f8b43ea981$export$2fce292577290205;
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/double-indexed-kv.js
var $26d6f2f8b43ea981$var$DoubleIndexedKV = /*#__PURE__*/ function() {
    "use strict";
    function DoubleIndexedKV() {
        (0, $173N4._)(this, DoubleIndexedKV);
        this.keyToValue = /* @__PURE__ */ new Map();
        this.valueToKey = /* @__PURE__ */ new Map();
    }
    (0, $cFHGC._)(DoubleIndexedKV, [
        {
            key: "set",
            value: function set(key, value) {
                this.keyToValue.set(key, value);
                this.valueToKey.set(value, key);
            }
        },
        {
            key: "getByKey",
            value: function getByKey(key) {
                return this.keyToValue.get(key);
            }
        },
        {
            key: "getByValue",
            value: function getByValue(value) {
                return this.valueToKey.get(value);
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.keyToValue.clear();
                this.valueToKey.clear();
            }
        }
    ]);
    return DoubleIndexedKV;
}();
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/registry.js
var $26d6f2f8b43ea981$var$Registry = /*#__PURE__*/ function() {
    "use strict";
    function Registry(generateIdentifier) {
        (0, $173N4._)(this, Registry);
        this.generateIdentifier = generateIdentifier;
        this.kv = new $26d6f2f8b43ea981$var$DoubleIndexedKV();
    }
    (0, $cFHGC._)(Registry, [
        {
            key: "register",
            value: function register(value, identifier) {
                if (this.kv.getByValue(value)) return;
                if (!identifier) identifier = this.generateIdentifier(value);
                this.kv.set(identifier, value);
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.kv.clear();
            }
        },
        {
            key: "getIdentifier",
            value: function getIdentifier(value) {
                return this.kv.getByValue(value);
            }
        },
        {
            key: "getValue",
            value: function getValue(identifier) {
                return this.kv.getByKey(identifier);
            }
        }
    ]);
    return Registry;
}();
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/class-registry.js
var $26d6f2f8b43ea981$var$ClassRegistry = /*#__PURE__*/ function(Registry) {
    "use strict";
    (0, $hdIku._)(ClassRegistry, Registry);
    function ClassRegistry() {
        (0, $173N4._)(this, ClassRegistry);
        var _this;
        _this = (0, $7qXGD._)(this, ClassRegistry, [
            function(c) {
                return c.name;
            }
        ]);
        _this.classToAllowedProps = /* @__PURE__ */ new Map();
        return _this;
    }
    (0, $cFHGC._)(ClassRegistry, [
        {
            key: "register",
            value: function register(value, options) {
                if ((typeof options === "undefined" ? "undefined" : (0, $7E0eS._)(options)) === "object") {
                    if (options.allowProps) this.classToAllowedProps.set(value, options.allowProps);
                    (0, $dWsrg._)((0, $kg0zo._)(ClassRegistry.prototype), "register", this).call(this, value, options.identifier);
                } else (0, $dWsrg._)((0, $kg0zo._)(ClassRegistry.prototype), "register", this).call(this, value, options);
            }
        },
        {
            key: "getAllowedProps",
            value: function getAllowedProps(value) {
                return this.classToAllowedProps.get(value);
            }
        }
    ]);
    return ClassRegistry;
}($26d6f2f8b43ea981$var$Registry);
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/util.js
function $26d6f2f8b43ea981$var$valuesOfObj(record) {
    if ("values" in Object) return Object.values(record);
    var values = [];
    for(var key in record)if (record.hasOwnProperty(key)) values.push(record[key]);
    return values;
}
function $26d6f2f8b43ea981$var$find(record, predicate) {
    var values = $26d6f2f8b43ea981$var$valuesOfObj(record);
    if ("find" in values) return values.find(predicate);
    var valuesNotNever = values;
    for(var i = 0; i < valuesNotNever.length; i++){
        var value = valuesNotNever[i];
        if (predicate(value)) return value;
    }
}
function $26d6f2f8b43ea981$var$forEach(record, run) {
    Object.entries(record).forEach(function(param) {
        var _param = (0, $f9AOD._)(param, 2), key = _param[0], value = _param[1];
        return run(value, key);
    });
}
function $26d6f2f8b43ea981$var$includes(arr, value) {
    return arr.indexOf(value) !== -1;
}
function $26d6f2f8b43ea981$var$findArr(record, predicate) {
    for(var i = 0; i < record.length; i++){
        var value = record[i];
        if (predicate(value)) return value;
    }
}
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/custom-transformer-registry.js
var $26d6f2f8b43ea981$var$CustomTransformerRegistry = /*#__PURE__*/ function() {
    "use strict";
    function CustomTransformerRegistry() {
        (0, $173N4._)(this, CustomTransformerRegistry);
        this.transfomers = {};
    }
    (0, $cFHGC._)(CustomTransformerRegistry, [
        {
            key: "register",
            value: function register(transformer) {
                this.transfomers[transformer.name] = transformer;
            }
        },
        {
            key: "findApplicable",
            value: function findApplicable(v) {
                return $26d6f2f8b43ea981$var$find(this.transfomers, function(transformer) {
                    return transformer.isApplicable(v);
                });
            }
        },
        {
            key: "findByName",
            value: function findByName(name) {
                return this.transfomers[name];
            }
        }
    ]);
    return CustomTransformerRegistry;
}();
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/is.js
var $26d6f2f8b43ea981$var$getType$1 = function(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
};
var $26d6f2f8b43ea981$var$isUndefined$1 = function(payload) {
    return typeof payload === "undefined";
};
var $26d6f2f8b43ea981$var$isNull$1 = function(payload) {
    return payload === null;
};
var $26d6f2f8b43ea981$var$isPlainObject$2 = function(payload) {
    if ((typeof payload === "undefined" ? "undefined" : (0, $7E0eS._)(payload)) !== "object" || payload === null) return false;
    if (payload === Object.prototype) return false;
    if (Object.getPrototypeOf(payload) === null) return true;
    return Object.getPrototypeOf(payload) === Object.prototype;
};
var $26d6f2f8b43ea981$var$isEmptyObject = function(payload) {
    return $26d6f2f8b43ea981$var$isPlainObject$2(payload) && Object.keys(payload).length === 0;
};
var $26d6f2f8b43ea981$var$isArray$2 = function(payload) {
    return Array.isArray(payload);
};
var $26d6f2f8b43ea981$var$isString = function(payload) {
    return typeof payload === "string";
};
var $26d6f2f8b43ea981$var$isNumber = function(payload) {
    return typeof payload === "number" && !isNaN(payload);
};
var $26d6f2f8b43ea981$var$isBoolean = function(payload) {
    return typeof payload === "boolean";
};
var $26d6f2f8b43ea981$var$isRegExp = function(payload) {
    return payload instanceof RegExp;
};
var $26d6f2f8b43ea981$var$isMap = function(payload) {
    return payload instanceof Map;
};
var $26d6f2f8b43ea981$var$isSet = function(payload) {
    return payload instanceof Set;
};
var $26d6f2f8b43ea981$var$isSymbol = function(payload) {
    return $26d6f2f8b43ea981$var$getType$1(payload) === "Symbol";
};
var $26d6f2f8b43ea981$var$isDate = function(payload) {
    return payload instanceof Date && !isNaN(payload.valueOf());
};
var $26d6f2f8b43ea981$var$isError = function(payload) {
    return payload instanceof Error;
};
var $26d6f2f8b43ea981$var$isNaNValue = function(payload) {
    return typeof payload === "number" && isNaN(payload);
};
var $26d6f2f8b43ea981$var$isPrimitive = function(payload) {
    return $26d6f2f8b43ea981$var$isBoolean(payload) || $26d6f2f8b43ea981$var$isNull$1(payload) || $26d6f2f8b43ea981$var$isUndefined$1(payload) || $26d6f2f8b43ea981$var$isNumber(payload) || $26d6f2f8b43ea981$var$isString(payload) || $26d6f2f8b43ea981$var$isSymbol(payload);
};
var $26d6f2f8b43ea981$var$isBigint = function(payload) {
    return (typeof payload === "undefined" ? "undefined" : (0, $7E0eS._)(payload)) === "bigint";
};
var $26d6f2f8b43ea981$var$isInfinite = function(payload) {
    return payload === Infinity || payload === -Infinity;
};
var $26d6f2f8b43ea981$var$isTypedArray = function(payload) {
    return ArrayBuffer.isView(payload) && !(payload instanceof DataView);
};
var $26d6f2f8b43ea981$var$isURL = function(payload) {
    return payload instanceof URL;
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/pathstringifier.js
var $26d6f2f8b43ea981$var$escapeKey = function(key) {
    return key.replace(/\./g, "\\.");
};
var $26d6f2f8b43ea981$var$stringifyPath = function(path) {
    return path.map(String).map($26d6f2f8b43ea981$var$escapeKey).join(".");
};
var $26d6f2f8b43ea981$var$parsePath = function(string) {
    var result = [];
    var segment = "";
    for(var i = 0; i < string.length; i++){
        var char = string.charAt(i);
        if (char === "\\" && string.charAt(i + 1) === ".") {
            segment += ".";
            i++;
            continue;
        }
        if (char === ".") {
            result.push(segment);
            segment = "";
            continue;
        }
        segment += char;
    }
    var lastSegment = segment;
    result.push(lastSegment);
    return result;
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/transformer.js
function $26d6f2f8b43ea981$var$simpleTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $26d6f2f8b43ea981$var$simpleRules = [
    $26d6f2f8b43ea981$var$simpleTransformation($26d6f2f8b43ea981$var$isUndefined$1, "undefined", function() {
        return null;
    }, function() {
        return void 0;
    }),
    $26d6f2f8b43ea981$var$simpleTransformation($26d6f2f8b43ea981$var$isBigint, "bigint", function(v) {
        return v.toString();
    }, function(v) {
        if (typeof BigInt !== "undefined") return BigInt(v);
        console.error("Please add a BigInt polyfill.");
        return v;
    }),
    $26d6f2f8b43ea981$var$simpleTransformation($26d6f2f8b43ea981$var$isDate, "Date", function(v) {
        return v.toISOString();
    }, function(v) {
        return new Date(v);
    }),
    $26d6f2f8b43ea981$var$simpleTransformation($26d6f2f8b43ea981$var$isError, "Error", function(v, superJson) {
        var baseError = {
            name: v.name,
            message: v.message
        };
        superJson.allowedErrorProps.forEach(function(prop) {
            baseError[prop] = v[prop];
        });
        return baseError;
    }, function(v, superJson) {
        var e = new Error(v.message);
        e.name = v.name;
        e.stack = v.stack;
        superJson.allowedErrorProps.forEach(function(prop) {
            e[prop] = v[prop];
        });
        return e;
    }),
    $26d6f2f8b43ea981$var$simpleTransformation($26d6f2f8b43ea981$var$isRegExp, "regexp", function(v) {
        return "" + v;
    }, function(regex) {
        var body = regex.slice(1, regex.lastIndexOf("/"));
        var flags = regex.slice(regex.lastIndexOf("/") + 1);
        return new RegExp(body, flags);
    }),
    $26d6f2f8b43ea981$var$simpleTransformation($26d6f2f8b43ea981$var$isSet, "set", function(v) {
        return (0, $aUGqu._)(v.values());
    }, function(v) {
        return new Set(v);
    }),
    $26d6f2f8b43ea981$var$simpleTransformation($26d6f2f8b43ea981$var$isMap, "map", function(v) {
        return (0, $aUGqu._)(v.entries());
    }, function(v) {
        return new Map(v);
    }),
    $26d6f2f8b43ea981$var$simpleTransformation(function(v) {
        return $26d6f2f8b43ea981$var$isNaNValue(v) || $26d6f2f8b43ea981$var$isInfinite(v);
    }, "number", function(v) {
        if ($26d6f2f8b43ea981$var$isNaNValue(v)) return "NaN";
        if (v > 0) return "Infinity";
        else return "-Infinity";
    }, Number),
    $26d6f2f8b43ea981$var$simpleTransformation(function(v) {
        return v === 0 && 1 / v === -Infinity;
    }, "number", function() {
        return "-0";
    }, Number),
    $26d6f2f8b43ea981$var$simpleTransformation($26d6f2f8b43ea981$var$isURL, "URL", function(v) {
        return v.toString();
    }, function(v) {
        return new URL(v);
    })
];
function $26d6f2f8b43ea981$var$compositeTransformation(isApplicable, annotation, transform, untransform) {
    return {
        isApplicable: isApplicable,
        annotation: annotation,
        transform: transform,
        untransform: untransform
    };
}
var $26d6f2f8b43ea981$var$symbolRule = $26d6f2f8b43ea981$var$compositeTransformation(function(s, superJson) {
    if ($26d6f2f8b43ea981$var$isSymbol(s)) return !!superJson.symbolRegistry.getIdentifier(s);
    return false;
}, function(s, superJson) {
    return [
        "symbol",
        superJson.symbolRegistry.getIdentifier(s)
    ];
}, function(v) {
    return v.description;
}, function(_, a, superJson) {
    var value = superJson.symbolRegistry.getValue(a[1]);
    if (!value) throw new Error("Trying to deserialize unknown symbol");
    return value;
});
var $26d6f2f8b43ea981$var$constructorToName = [
    Int8Array,
    Uint8Array,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    Uint8ClampedArray
].reduce(function(obj, ctor) {
    obj[ctor.name] = ctor;
    return obj;
}, {});
var $26d6f2f8b43ea981$var$typedArrayRule = $26d6f2f8b43ea981$var$compositeTransformation($26d6f2f8b43ea981$var$isTypedArray, function(v) {
    return [
        "typed-array",
        v.constructor.name
    ];
}, function(v) {
    return (0, $aUGqu._)(v);
}, function(v, a) {
    var ctor = $26d6f2f8b43ea981$var$constructorToName[a[1]];
    if (!ctor) throw new Error("Trying to deserialize unknown typed array");
    return new ctor(v);
});
function $26d6f2f8b43ea981$var$isInstanceOfRegisteredClass(potentialClass, superJson) {
    if (potentialClass === null || potentialClass === void 0 ? void 0 : potentialClass.constructor) return !!superJson.classRegistry.getIdentifier(potentialClass.constructor);
    return false;
}
var $26d6f2f8b43ea981$var$classRule = $26d6f2f8b43ea981$var$compositeTransformation($26d6f2f8b43ea981$var$isInstanceOfRegisteredClass, function(clazz, superJson) {
    return [
        "class",
        superJson.classRegistry.getIdentifier(clazz.constructor)
    ];
}, function(clazz, superJson) {
    var allowedProps = superJson.classRegistry.getAllowedProps(clazz.constructor);
    if (!allowedProps) return (0, $1XAnY._)({}, clazz);
    var result = {};
    allowedProps.forEach(function(prop) {
        result[prop] = clazz[prop];
    });
    return result;
}, function(v, a, superJson) {
    var clazz = superJson.classRegistry.getValue(a[1]);
    if (!clazz) throw new Error("Trying to deserialize unknown class '".concat(a[1], "' - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564"));
    return Object.assign(Object.create(clazz.prototype), v);
});
var $26d6f2f8b43ea981$var$customRule = $26d6f2f8b43ea981$var$compositeTransformation(function(value, superJson) {
    return !!superJson.customTransformerRegistry.findApplicable(value);
}, function(value, superJson) {
    return [
        "custom",
        superJson.customTransformerRegistry.findApplicable(value).name
    ];
}, function(value, superJson) {
    return superJson.customTransformerRegistry.findApplicable(value).serialize(value);
}, function(v, a, superJson) {
    var transformer = superJson.customTransformerRegistry.findByName(a[1]);
    if (!transformer) throw new Error("Trying to deserialize unknown custom value");
    return transformer.deserialize(v);
});
var $26d6f2f8b43ea981$var$compositeRules = [
    $26d6f2f8b43ea981$var$classRule,
    $26d6f2f8b43ea981$var$symbolRule,
    $26d6f2f8b43ea981$var$customRule,
    $26d6f2f8b43ea981$var$typedArrayRule
];
var $26d6f2f8b43ea981$var$transformValue = function(value, superJson) {
    var applicableCompositeRule = $26d6f2f8b43ea981$var$findArr($26d6f2f8b43ea981$var$compositeRules, function(rule) {
        return rule.isApplicable(value, superJson);
    });
    if (applicableCompositeRule) return {
        value: applicableCompositeRule.transform(value, superJson),
        type: applicableCompositeRule.annotation(value, superJson)
    };
    var applicableSimpleRule = $26d6f2f8b43ea981$var$findArr($26d6f2f8b43ea981$var$simpleRules, function(rule) {
        return rule.isApplicable(value, superJson);
    });
    if (applicableSimpleRule) return {
        value: applicableSimpleRule.transform(value, superJson),
        type: applicableSimpleRule.annotation
    };
};
var $26d6f2f8b43ea981$var$simpleRulesByAnnotation = {};
$26d6f2f8b43ea981$var$simpleRules.forEach(function(rule) {
    $26d6f2f8b43ea981$var$simpleRulesByAnnotation[rule.annotation] = rule;
});
var $26d6f2f8b43ea981$var$untransformValue = function(json, type, superJson) {
    if ($26d6f2f8b43ea981$var$isArray$2(type)) switch(type[0]){
        case "symbol":
            return $26d6f2f8b43ea981$var$symbolRule.untransform(json, type, superJson);
        case "class":
            return $26d6f2f8b43ea981$var$classRule.untransform(json, type, superJson);
        case "custom":
            return $26d6f2f8b43ea981$var$customRule.untransform(json, type, superJson);
        case "typed-array":
            return $26d6f2f8b43ea981$var$typedArrayRule.untransform(json, type, superJson);
        default:
            throw new Error("Unknown transformation: " + type);
    }
    else {
        var transformation = $26d6f2f8b43ea981$var$simpleRulesByAnnotation[type];
        if (!transformation) throw new Error("Unknown transformation: " + type);
        return transformation.untransform(json, superJson);
    }
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/accessDeep.js
var $26d6f2f8b43ea981$var$getNthKey = function(value, n) {
    if (n > value.size) throw new Error("index out of bounds");
    var keys = value.keys();
    while(n > 0){
        keys.next();
        n--;
    }
    return keys.next().value;
};
function $26d6f2f8b43ea981$var$validatePath(path) {
    if ($26d6f2f8b43ea981$var$includes(path, "__proto__")) throw new Error("__proto__ is not allowed as a property");
    if ($26d6f2f8b43ea981$var$includes(path, "prototype")) throw new Error("prototype is not allowed as a property");
    if ($26d6f2f8b43ea981$var$includes(path, "constructor")) throw new Error("constructor is not allowed as a property");
}
var $26d6f2f8b43ea981$var$getDeep = function(object, path) {
    $26d6f2f8b43ea981$var$validatePath(path);
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if ($26d6f2f8b43ea981$var$isSet(object)) object = $26d6f2f8b43ea981$var$getNthKey(object, +key);
        else if ($26d6f2f8b43ea981$var$isMap(object)) {
            var row = +key;
            var type = +path[++i] === 0 ? "key" : "value";
            var keyOfRow = $26d6f2f8b43ea981$var$getNthKey(object, row);
            switch(type){
                case "key":
                    object = keyOfRow;
                    break;
                case "value":
                    object = object.get(keyOfRow);
                    break;
            }
        } else object = object[key];
    }
    return object;
};
var $26d6f2f8b43ea981$var$setDeep = function(object, path, mapper) {
    $26d6f2f8b43ea981$var$validatePath(path);
    if (path.length === 0) return mapper(object);
    var parent = object;
    for(var i = 0; i < path.length - 1; i++){
        var key = path[i];
        if ($26d6f2f8b43ea981$var$isArray$2(parent)) {
            var index = +key;
            parent = parent[index];
        } else if ($26d6f2f8b43ea981$var$isPlainObject$2(parent)) parent = parent[key];
        else if ($26d6f2f8b43ea981$var$isSet(parent)) {
            var row = +key;
            parent = $26d6f2f8b43ea981$var$getNthKey(parent, row);
        } else if ($26d6f2f8b43ea981$var$isMap(parent)) {
            if (i === path.length - 2) break;
            var row1 = +key;
            var type = +path[++i] === 0 ? "key" : "value";
            var keyOfRow = $26d6f2f8b43ea981$var$getNthKey(parent, row1);
            switch(type){
                case "key":
                    parent = keyOfRow;
                    break;
                case "value":
                    parent = parent.get(keyOfRow);
                    break;
            }
        }
    }
    var lastKey = path[path.length - 1];
    if ($26d6f2f8b43ea981$var$isArray$2(parent)) parent[+lastKey] = mapper(parent[+lastKey]);
    else if ($26d6f2f8b43ea981$var$isPlainObject$2(parent)) parent[lastKey] = mapper(parent[lastKey]);
    if ($26d6f2f8b43ea981$var$isSet(parent)) {
        var oldValue = $26d6f2f8b43ea981$var$getNthKey(parent, +lastKey);
        var newValue = mapper(oldValue);
        if (oldValue !== newValue) {
            parent.delete(oldValue);
            parent.add(newValue);
        }
    }
    if ($26d6f2f8b43ea981$var$isMap(parent)) {
        var row2 = +path[path.length - 2];
        var keyToRow = $26d6f2f8b43ea981$var$getNthKey(parent, row2);
        switch(+lastKey === 0 ? "key" : "value"){
            case "key":
                {
                    var newKey = mapper(keyToRow);
                    parent.set(newKey, parent.get(keyToRow));
                    if (newKey !== keyToRow) parent.delete(keyToRow);
                    break;
                }
            case "value":
                parent.set(keyToRow, mapper(parent.get(keyToRow)));
                break;
        }
    }
    return object;
};
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/plainer.js
function $26d6f2f8b43ea981$var$traverse(tree, walker) {
    var origin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (!tree) return;
    if (!$26d6f2f8b43ea981$var$isArray$2(tree)) {
        $26d6f2f8b43ea981$var$forEach(tree, function(subtree, key) {
            return $26d6f2f8b43ea981$var$traverse(subtree, walker, (0, $aUGqu._)(origin).concat((0, $aUGqu._)($26d6f2f8b43ea981$var$parsePath(key))));
        });
        return;
    }
    var _tree = (0, $f9AOD._)(tree, 2), nodeValue = _tree[0], children = _tree[1];
    if (children) $26d6f2f8b43ea981$var$forEach(children, function(child, key) {
        $26d6f2f8b43ea981$var$traverse(child, walker, (0, $aUGqu._)(origin).concat((0, $aUGqu._)($26d6f2f8b43ea981$var$parsePath(key))));
    });
    walker(nodeValue, origin);
}
function $26d6f2f8b43ea981$var$applyValueAnnotations(plain, annotations, superJson) {
    $26d6f2f8b43ea981$var$traverse(annotations, function(type, path) {
        plain = $26d6f2f8b43ea981$var$setDeep(plain, path, function(v) {
            return $26d6f2f8b43ea981$var$untransformValue(v, type, superJson);
        });
    });
    return plain;
}
function $26d6f2f8b43ea981$var$applyReferentialEqualityAnnotations(plain, annotations) {
    function apply(identicalPaths, path) {
        var object = $26d6f2f8b43ea981$var$getDeep(plain, $26d6f2f8b43ea981$var$parsePath(path));
        identicalPaths.map($26d6f2f8b43ea981$var$parsePath).forEach(function(identicalObjectPath) {
            plain = $26d6f2f8b43ea981$var$setDeep(plain, identicalObjectPath, function() {
                return object;
            });
        });
    }
    if ($26d6f2f8b43ea981$var$isArray$2(annotations)) {
        var _annotations = (0, $f9AOD._)(annotations, 2), root = _annotations[0], other = _annotations[1];
        root.forEach(function(identicalPath) {
            plain = $26d6f2f8b43ea981$var$setDeep(plain, $26d6f2f8b43ea981$var$parsePath(identicalPath), function() {
                return plain;
            });
        });
        if (other) $26d6f2f8b43ea981$var$forEach(other, apply);
    } else $26d6f2f8b43ea981$var$forEach(annotations, apply);
    return plain;
}
var $26d6f2f8b43ea981$var$isDeep = function(object, superJson) {
    return $26d6f2f8b43ea981$var$isPlainObject$2(object) || $26d6f2f8b43ea981$var$isArray$2(object) || $26d6f2f8b43ea981$var$isMap(object) || $26d6f2f8b43ea981$var$isSet(object) || $26d6f2f8b43ea981$var$isInstanceOfRegisteredClass(object, superJson);
};
function $26d6f2f8b43ea981$var$addIdentity(object, path, identities) {
    var existingSet = identities.get(object);
    if (existingSet) existingSet.push(path);
    else identities.set(object, [
        path
    ]);
}
function $26d6f2f8b43ea981$var$generateReferentialEqualityAnnotations(identitites, dedupe) {
    var result = {};
    var rootEqualityPaths = void 0;
    identitites.forEach(function(paths) {
        if (paths.length <= 1) return;
        if (!dedupe) paths = paths.map(function(path) {
            return path.map(String);
        }).sort(function(a, b) {
            return a.length - b.length;
        });
        var _paths = (0, $db8bc344974bb245$export$71511d61b312f219)(paths), representativePath = _paths[0], identicalPaths = _paths.slice(1);
        if (representativePath.length === 0) rootEqualityPaths = identicalPaths.map($26d6f2f8b43ea981$var$stringifyPath);
        else result[$26d6f2f8b43ea981$var$stringifyPath(representativePath)] = identicalPaths.map($26d6f2f8b43ea981$var$stringifyPath);
    });
    if (rootEqualityPaths) {
        if ($26d6f2f8b43ea981$var$isEmptyObject(result)) return [
            rootEqualityPaths
        ];
        else return [
            rootEqualityPaths,
            result
        ];
    } else return $26d6f2f8b43ea981$var$isEmptyObject(result) ? void 0 : result;
}
var $26d6f2f8b43ea981$var$walker = function(object, identities, superJson, dedupe) {
    var path = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], objectsInThisPath = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [], seenObjects = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : /* @__PURE__ */ new Map();
    var primitive = $26d6f2f8b43ea981$var$isPrimitive(object);
    if (!primitive) {
        $26d6f2f8b43ea981$var$addIdentity(object, path, identities);
        var seen = seenObjects.get(object);
        if (seen) return dedupe ? {
            transformedValue: null
        } : seen;
    }
    if (!$26d6f2f8b43ea981$var$isDeep(object, superJson)) {
        var transformed = $26d6f2f8b43ea981$var$transformValue(object, superJson);
        var result = transformed ? {
            transformedValue: transformed.value,
            annotations: [
                transformed.type
            ]
        } : {
            transformedValue: object
        };
        if (!primitive) seenObjects.set(object, result);
        return result;
    }
    if ($26d6f2f8b43ea981$var$includes(objectsInThisPath, object)) return {
        transformedValue: null
    };
    var transformationResult = $26d6f2f8b43ea981$var$transformValue(object, superJson);
    var _transformationResult_value;
    var transformed1 = (_transformationResult_value = transformationResult === null || transformationResult === void 0 ? void 0 : transformationResult.value) !== null && _transformationResult_value !== void 0 ? _transformationResult_value : object;
    var transformedValue = $26d6f2f8b43ea981$var$isArray$2(transformed1) ? [] : {};
    var innerAnnotations = {};
    $26d6f2f8b43ea981$var$forEach(transformed1, function(value, index) {
        if (index === "__proto__" || index === "constructor" || index === "prototype") throw new Error("Detected property ".concat(index, ". This is a prototype pollution risk, please remove it from your object."));
        var recursiveResult = $26d6f2f8b43ea981$var$walker(value, identities, superJson, dedupe, (0, $aUGqu._)(path).concat([
            index
        ]), (0, $aUGqu._)(objectsInThisPath).concat([
            object
        ]), seenObjects);
        transformedValue[index] = recursiveResult.transformedValue;
        if ($26d6f2f8b43ea981$var$isArray$2(recursiveResult.annotations)) innerAnnotations[index] = recursiveResult.annotations;
        else if ($26d6f2f8b43ea981$var$isPlainObject$2(recursiveResult.annotations)) $26d6f2f8b43ea981$var$forEach(recursiveResult.annotations, function(tree, key) {
            innerAnnotations[$26d6f2f8b43ea981$var$escapeKey(index) + "." + key] = tree;
        });
    });
    var result1 = $26d6f2f8b43ea981$var$isEmptyObject(innerAnnotations) ? {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type
        ] : void 0
    } : {
        transformedValue: transformedValue,
        annotations: !!transformationResult ? [
            transformationResult.type,
            innerAnnotations
        ] : innerAnnotations
    };
    if (!primitive) seenObjects.set(object, result1);
    return result1;
};
//#endregion
//#region ../../node_modules/.pnpm/is-what@4.1.16/node_modules/is-what/dist/index.js
function $26d6f2f8b43ea981$var$getType(payload) {
    return Object.prototype.toString.call(payload).slice(8, -1);
}
function $26d6f2f8b43ea981$var$isArray$1(payload) {
    return $26d6f2f8b43ea981$var$getType(payload) === "Array";
}
function $26d6f2f8b43ea981$var$isPlainObject$1(payload) {
    if ($26d6f2f8b43ea981$var$getType(payload) !== "Object") return false;
    var prototype = Object.getPrototypeOf(payload);
    return !!prototype && prototype.constructor === Object && prototype === Object.prototype;
}
function $26d6f2f8b43ea981$var$isNull(payload) {
    return $26d6f2f8b43ea981$var$getType(payload) === "Null";
}
function $26d6f2f8b43ea981$var$isOneOf(a, b, c, d, e) {
    return function(value) {
        return a(value) || b(value) || !!c && c(value) || !!d && d(value) || !!e && e(value);
    };
}
function $26d6f2f8b43ea981$var$isUndefined(payload) {
    return $26d6f2f8b43ea981$var$getType(payload) === "Undefined";
}
$26d6f2f8b43ea981$var$isOneOf($26d6f2f8b43ea981$var$isNull, $26d6f2f8b43ea981$var$isUndefined);
//#endregion
//#region ../../node_modules/.pnpm/copy-anything@3.0.5/node_modules/copy-anything/dist/index.js
function $26d6f2f8b43ea981$var$assignProp(carry, key, newVal, originalObject, includeNonenumerable) {
    var propType = ({}).propertyIsEnumerable.call(originalObject, key) ? "enumerable" : "nonenumerable";
    if (propType === "enumerable") carry[key] = newVal;
    if (includeNonenumerable && propType === "nonenumerable") Object.defineProperty(carry, key, {
        value: newVal,
        enumerable: false,
        writable: true,
        configurable: true
    });
}
function $26d6f2f8b43ea981$var$copy(target) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if ($26d6f2f8b43ea981$var$isArray$1(target)) return target.map(function(item) {
        return $26d6f2f8b43ea981$var$copy(item, options);
    });
    if (!$26d6f2f8b43ea981$var$isPlainObject$1(target)) return target;
    var props = Object.getOwnPropertyNames(target);
    var symbols = Object.getOwnPropertySymbols(target);
    return (0, $aUGqu._)(props).concat((0, $aUGqu._)(symbols)).reduce(function(carry, key) {
        if ($26d6f2f8b43ea981$var$isArray$1(options.props) && !options.props.includes(key)) return carry;
        var val = target[key];
        $26d6f2f8b43ea981$var$assignProp(carry, key, $26d6f2f8b43ea981$var$copy(val, options), target, options.nonenumerable);
        return carry;
    }, {});
}
//#endregion
//#region ../../node_modules/.pnpm/superjson@2.2.2/node_modules/superjson/dist/index.js
var $26d6f2f8b43ea981$var$SuperJSON = /*#__PURE__*/ function() {
    "use strict";
    function SuperJSON() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_dedupe = _ref.dedupe, dedupe = _ref_dedupe === void 0 ? false : _ref_dedupe;
        (0, $173N4._)(this, SuperJSON);
        this.classRegistry = new $26d6f2f8b43ea981$var$ClassRegistry();
        this.symbolRegistry = new $26d6f2f8b43ea981$var$Registry(function(s) {
            var _s_description;
            return (_s_description = s.description) !== null && _s_description !== void 0 ? _s_description : "";
        });
        this.customTransformerRegistry = new $26d6f2f8b43ea981$var$CustomTransformerRegistry();
        this.allowedErrorProps = [];
        this.dedupe = dedupe;
    }
    (0, $cFHGC._)(SuperJSON, [
        {
            key: "serialize",
            value: function serialize(object) {
                var identities = /* @__PURE__ */ new Map();
                var output = $26d6f2f8b43ea981$var$walker(object, identities, this, this.dedupe);
                var res = {
                    json: output.transformedValue
                };
                if (output.annotations) res.meta = (0, $6fpqi._)((0, $1XAnY._)({}, res.meta), {
                    values: output.annotations
                });
                var equalityAnnotations = $26d6f2f8b43ea981$var$generateReferentialEqualityAnnotations(identities, this.dedupe);
                if (equalityAnnotations) res.meta = (0, $6fpqi._)((0, $1XAnY._)({}, res.meta), {
                    referentialEqualities: equalityAnnotations
                });
                return res;
            }
        },
        {
            key: "deserialize",
            value: function deserialize(payload) {
                var json = payload.json, meta = payload.meta;
                var result = $26d6f2f8b43ea981$var$copy(json);
                if (meta === null || meta === void 0 ? void 0 : meta.values) result = $26d6f2f8b43ea981$var$applyValueAnnotations(result, meta.values, this);
                if (meta === null || meta === void 0 ? void 0 : meta.referentialEqualities) result = $26d6f2f8b43ea981$var$applyReferentialEqualityAnnotations(result, meta.referentialEqualities);
                return result;
            }
        },
        {
            key: "stringify",
            value: function stringify(object) {
                return JSON.stringify(this.serialize(object));
            }
        },
        {
            key: "parse",
            value: function parse(string) {
                return this.deserialize(JSON.parse(string));
            }
        },
        {
            key: "registerClass",
            value: function registerClass(v, options) {
                this.classRegistry.register(v, options);
            }
        },
        {
            key: "registerSymbol",
            value: function registerSymbol(v, identifier) {
                this.symbolRegistry.register(v, identifier);
            }
        },
        {
            key: "registerCustom",
            value: function registerCustom(transformer, name) {
                this.customTransformerRegistry.register((0, $1XAnY._)({
                    name: name
                }, transformer));
            }
        },
        {
            key: "allowErrorProps",
            value: function allowErrorProps() {
                for(var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++){
                    props[_key] = arguments[_key];
                }
                var _this_allowedErrorProps;
                (_this_allowedErrorProps = this.allowedErrorProps).push.apply(_this_allowedErrorProps, (0, $aUGqu._)(props));
            }
        }
    ]);
    return SuperJSON;
}();
$26d6f2f8b43ea981$var$SuperJSON.defaultInstance = new $26d6f2f8b43ea981$var$SuperJSON();
$26d6f2f8b43ea981$var$SuperJSON.serialize = $26d6f2f8b43ea981$var$SuperJSON.defaultInstance.serialize.bind($26d6f2f8b43ea981$var$SuperJSON.defaultInstance);
$26d6f2f8b43ea981$var$SuperJSON.deserialize = $26d6f2f8b43ea981$var$SuperJSON.defaultInstance.deserialize.bind($26d6f2f8b43ea981$var$SuperJSON.defaultInstance);
$26d6f2f8b43ea981$var$SuperJSON.stringify = $26d6f2f8b43ea981$var$SuperJSON.defaultInstance.stringify.bind($26d6f2f8b43ea981$var$SuperJSON.defaultInstance);
$26d6f2f8b43ea981$var$SuperJSON.parse = $26d6f2f8b43ea981$var$SuperJSON.defaultInstance.parse.bind($26d6f2f8b43ea981$var$SuperJSON.defaultInstance);
$26d6f2f8b43ea981$var$SuperJSON.registerClass = $26d6f2f8b43ea981$var$SuperJSON.defaultInstance.registerClass.bind($26d6f2f8b43ea981$var$SuperJSON.defaultInstance);
$26d6f2f8b43ea981$var$SuperJSON.registerSymbol = $26d6f2f8b43ea981$var$SuperJSON.defaultInstance.registerSymbol.bind($26d6f2f8b43ea981$var$SuperJSON.defaultInstance);
$26d6f2f8b43ea981$var$SuperJSON.registerCustom = $26d6f2f8b43ea981$var$SuperJSON.defaultInstance.registerCustom.bind($26d6f2f8b43ea981$var$SuperJSON.defaultInstance);
$26d6f2f8b43ea981$var$SuperJSON.allowErrorProps = $26d6f2f8b43ea981$var$SuperJSON.defaultInstance.allowErrorProps.bind($26d6f2f8b43ea981$var$SuperJSON.defaultInstance);
$26d6f2f8b43ea981$var$SuperJSON.serialize;
$26d6f2f8b43ea981$var$SuperJSON.deserialize;
$26d6f2f8b43ea981$var$SuperJSON.stringify;
$26d6f2f8b43ea981$var$SuperJSON.parse;
$26d6f2f8b43ea981$var$SuperJSON.registerClass;
$26d6f2f8b43ea981$var$SuperJSON.registerCustom;
$26d6f2f8b43ea981$var$SuperJSON.registerSymbol;
$26d6f2f8b43ea981$var$SuperJSON.allowErrorProps;
//#endregion
//#region src/messaging/presets/broadcast-channel/context.ts
var $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY = "__devtools-kit-broadcast-messaging-event-key__";
//#endregion
//#region src/messaging/presets/broadcast-channel/index.ts
var $26d6f2f8b43ea981$var$BROADCAST_CHANNEL_NAME = "__devtools-kit:broadcast-channel__";
function $26d6f2f8b43ea981$var$createBroadcastChannel() {
    var channel = new BroadcastChannel($26d6f2f8b43ea981$var$BROADCAST_CHANNEL_NAME);
    return {
        post: function(data) {
            channel.postMessage($26d6f2f8b43ea981$var$SuperJSON.stringify({
                event: $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_BROADCAST_MESSAGING_EVENT_KEY,
                data: data
            }));
        },
        on: function(handler) {
            channel.onmessage = function(event) {
                var parsed = $26d6f2f8b43ea981$var$SuperJSON.parse(event.data);
                if (parsed.event === "__devtools-kit-broadcast-messaging-event-key__") handler(parsed.data);
            };
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/context.ts
var $26d6f2f8b43ea981$var$__ELECTRON_CLIENT_CONTEXT__ = "electron:client-context";
var $26d6f2f8b43ea981$var$__ELECTRON_RPOXY_CONTEXT__ = "electron:proxy-context";
var $26d6f2f8b43ea981$var$__ELECTRON_SERVER_CONTEXT__ = "electron:server-context";
var $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__ = {
    CLIENT_TO_PROXY: "client->proxy",
    PROXY_TO_CLIENT: "proxy->client",
    PROXY_TO_SERVER: "proxy->server",
    SERVER_TO_PROXY: "server->proxy"
};
function $26d6f2f8b43ea981$var$getElectronClientContext() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__ELECTRON_CLIENT_CONTEXT__];
}
function $26d6f2f8b43ea981$export$2837faaf25ee2c9a(context) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__ELECTRON_CLIENT_CONTEXT__] = context;
}
function $26d6f2f8b43ea981$var$getElectronProxyContext() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__ELECTRON_RPOXY_CONTEXT__];
}
function $26d6f2f8b43ea981$export$f4b34d15f9836c97(context) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__ELECTRON_RPOXY_CONTEXT__] = context;
}
function $26d6f2f8b43ea981$var$getElectronServerContext() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__ELECTRON_SERVER_CONTEXT__];
}
function $26d6f2f8b43ea981$export$d8c81043a9a1bbbe(context) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__ELECTRON_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/electron/client.ts
function $26d6f2f8b43ea981$var$createElectronClientChannel() {
    var socket = $26d6f2f8b43ea981$var$getElectronClientContext();
    return {
        post: function(data) {
            socket.emit($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, $26d6f2f8b43ea981$var$SuperJSON.stringify(data));
        },
        on: function(handler) {
            socket.on($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, function(e) {
                handler($26d6f2f8b43ea981$var$SuperJSON.parse(e));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/proxy.ts
function $26d6f2f8b43ea981$var$createElectronProxyChannel() {
    var socket = $26d6f2f8b43ea981$var$getElectronProxyContext();
    return {
        post: function(data) {},
        on: function(handler) {
            socket.on($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, function(data) {
                socket.broadcast.emit($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_CLIENT, data);
            });
            socket.on($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.CLIENT_TO_PROXY, function(data) {
                socket.broadcast.emit($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, data);
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/electron/server.ts
function $26d6f2f8b43ea981$var$createElectronServerChannel() {
    var socket = $26d6f2f8b43ea981$var$getElectronServerContext();
    return {
        post: function(data) {
            socket.emit($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY, $26d6f2f8b43ea981$var$SuperJSON.stringify(data));
        },
        on: function(handler) {
            socket.on($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_ELECTRON_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER, function(data) {
                handler($26d6f2f8b43ea981$var$SuperJSON.parse(data));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/extension/context.ts
var $26d6f2f8b43ea981$var$__EXTENSION_CLIENT_CONTEXT__ = "electron:client-context";
var $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__ = {
    CLIENT_TO_PROXY: "client->proxy",
    PROXY_TO_CLIENT: "proxy->client",
    PROXY_TO_SERVER: "proxy->server",
    SERVER_TO_PROXY: "server->proxy"
};
function $26d6f2f8b43ea981$export$6c3de6c2be1b2806() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__EXTENSION_CLIENT_CONTEXT__];
}
function $26d6f2f8b43ea981$export$31a9a778785defb(context) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__EXTENSION_CLIENT_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/extension/client.ts
function $26d6f2f8b43ea981$var$createExtensionClientChannel() {
    var disconnected = false;
    var port = null;
    var reconnectTimer = null;
    var onMessageHandler = null;
    function connect() {
        try {
            clearTimeout(reconnectTimer);
            port = chrome.runtime.connect({
                name: "".concat(chrome.devtools.inspectedWindow.tabId)
            });
            $26d6f2f8b43ea981$export$31a9a778785defb(port);
            disconnected = false;
            port === null || port === void 0 ? void 0 : port.onMessage.addListener(onMessageHandler);
            port.onDisconnect.addListener(function() {
                disconnected = true;
                port === null || port === void 0 ? void 0 : port.onMessage.removeListener(onMessageHandler);
                reconnectTimer = setTimeout(connect, 1e3);
            });
        } catch (e) {
            disconnected = true;
        }
    }
    connect();
    return {
        post: function(data) {
            if (disconnected) return;
            port === null || port === void 0 ? void 0 : port.postMessage($26d6f2f8b43ea981$var$SuperJSON.stringify(data));
        },
        on: function(handler) {
            onMessageHandler = function(data) {
                if (disconnected) return;
                handler($26d6f2f8b43ea981$var$SuperJSON.parse(data));
            };
            port === null || port === void 0 ? void 0 : port.onMessage.addListener(onMessageHandler);
        }
    };
}
//#endregion
//#region src/messaging/presets/extension/proxy.ts
function $26d6f2f8b43ea981$var$createExtensionProxyChannel() {
    var port = chrome.runtime.connect({
        name: "content-script"
    });
    function sendMessageToUserApp(payload) {
        window.postMessage({
            source: $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER,
            payload: payload
        }, "*");
    }
    function sendMessageToDevToolsClient(e) {
        if (e.data && e.data.source === $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY) try {
            port.postMessage(e.data.payload);
        } catch (e) {}
    }
    port.onMessage.addListener(sendMessageToUserApp);
    window.addEventListener("message", sendMessageToDevToolsClient);
    port.onDisconnect.addListener(function() {
        window.removeEventListener("message", sendMessageToDevToolsClient);
        sendMessageToUserApp($26d6f2f8b43ea981$var$SuperJSON.stringify({
            event: "shutdown"
        }));
    });
    sendMessageToUserApp($26d6f2f8b43ea981$var$SuperJSON.stringify({
        event: "init"
    }));
    return {
        post: function(data) {},
        on: function(handler) {}
    };
}
//#endregion
//#region src/messaging/presets/extension/server.ts
function $26d6f2f8b43ea981$var$createExtensionServerChannel() {
    return {
        post: function(data) {
            window.postMessage({
                source: $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.SERVER_TO_PROXY,
                payload: $26d6f2f8b43ea981$var$SuperJSON.stringify(data)
            }, "*");
        },
        on: function(handler) {
            var listener = function(event) {
                if (event.data.source === $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_EXTENSION_MESSAGING_EVENT_KEY__.PROXY_TO_SERVER && event.data.payload) handler($26d6f2f8b43ea981$var$SuperJSON.parse(event.data.payload));
            };
            window.addEventListener("message", listener);
            return function() {
                window.removeEventListener("message", listener);
            };
        }
    };
}
//#endregion
//#region src/messaging/presets/iframe/context.ts
var $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY = "__devtools-kit-iframe-messaging-event-key__";
var $26d6f2f8b43ea981$var$__IFRAME_SERVER_CONTEXT__ = "iframe:server-context";
function $26d6f2f8b43ea981$var$getIframeServerContext() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__IFRAME_SERVER_CONTEXT__];
}
function $26d6f2f8b43ea981$export$918b6d08f99ca1d5(context) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__IFRAME_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/iframe/client.ts
function $26d6f2f8b43ea981$var$createIframeClientChannel() {
    if (!(0, $6430dea643e1c0c1$export$4e09c449d6c407f7)) return {
        post: function(data) {},
        on: function(handler) {}
    };
    return {
        post: function(data) {
            return window.parent.postMessage($26d6f2f8b43ea981$var$SuperJSON.stringify({
                event: $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*");
        },
        on: function(handler) {
            return window.addEventListener("message", function(event) {
                try {
                    var parsed = $26d6f2f8b43ea981$var$SuperJSON.parse(event.data);
                    if (event.source === window.parent && parsed.event === "__devtools-kit-iframe-messaging-event-key__") handler(parsed.data);
                } catch (e) {}
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/iframe/server.ts
function $26d6f2f8b43ea981$var$createIframeServerChannel() {
    if (!(0, $6430dea643e1c0c1$export$4e09c449d6c407f7)) return {
        post: function(data) {},
        on: function(handler) {}
    };
    return {
        post: function(data) {
            var _getIframeServerContext_contentWindow, _getIframeServerContext;
            (_getIframeServerContext = $26d6f2f8b43ea981$var$getIframeServerContext()) === null || _getIframeServerContext === void 0 ? void 0 : (_getIframeServerContext_contentWindow = _getIframeServerContext.contentWindow) === null || _getIframeServerContext_contentWindow === void 0 ? void 0 : _getIframeServerContext_contentWindow.postMessage($26d6f2f8b43ea981$var$SuperJSON.stringify({
                event: $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_IFRAME_MESSAGING_EVENT_KEY,
                data: data
            }), "*");
        },
        on: function(handler) {
            window.addEventListener("message", function(event) {
                var iframe = $26d6f2f8b43ea981$var$getIframeServerContext();
                try {
                    var parsed = $26d6f2f8b43ea981$var$SuperJSON.parse(event.data);
                    if (event.source === (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) && parsed.event === "__devtools-kit-iframe-messaging-event-key__") handler(parsed.data);
                } catch (e) {}
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/vite/context.ts
var $26d6f2f8b43ea981$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY = "__devtools-kit-vite-messaging-event-key__";
var $26d6f2f8b43ea981$var$__VITE_CLIENT_CONTEXT__ = "vite:client-context";
var $26d6f2f8b43ea981$var$__VITE_SERVER_CONTEXT__ = "vite:server-context";
function $26d6f2f8b43ea981$var$getViteClientContext() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__VITE_CLIENT_CONTEXT__];
}
function $26d6f2f8b43ea981$export$8559d72d41937efd(context) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__VITE_CLIENT_CONTEXT__] = context;
}
function $26d6f2f8b43ea981$var$getViteServerContext() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__VITE_SERVER_CONTEXT__];
}
function $26d6f2f8b43ea981$export$4c32fe701137877e(context) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)[$26d6f2f8b43ea981$var$__VITE_SERVER_CONTEXT__] = context;
}
//#endregion
//#region src/messaging/presets/vite/client.ts
function $26d6f2f8b43ea981$var$createViteClientChannel() {
    var client = $26d6f2f8b43ea981$var$getViteClientContext();
    return {
        post: function(data) {
            client === null || client === void 0 ? void 0 : client.send($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $26d6f2f8b43ea981$var$SuperJSON.stringify(data));
        },
        on: function(handler) {
            client === null || client === void 0 ? void 0 : client.on($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, function(event) {
                handler($26d6f2f8b43ea981$var$SuperJSON.parse(event));
            });
        }
    };
}
//#endregion
//#region src/messaging/presets/vite/server.ts
function $26d6f2f8b43ea981$var$createViteServerChannel() {
    var viteServer = $26d6f2f8b43ea981$var$getViteServerContext();
    var _viteServer_hot;
    var ws = (_viteServer_hot = viteServer.hot) !== null && _viteServer_hot !== void 0 ? _viteServer_hot : viteServer.ws;
    return {
        post: function(data) {
            return ws === null || ws === void 0 ? void 0 : ws.send($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, $26d6f2f8b43ea981$var$SuperJSON.stringify(data));
        },
        on: function(handler) {
            return ws === null || ws === void 0 ? void 0 : ws.on($26d6f2f8b43ea981$var$__DEVTOOLS_KIT_VITE_MESSAGING_EVENT_KEY, function(event) {
                handler($26d6f2f8b43ea981$var$SuperJSON.parse(event));
            });
        }
    };
}
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = ($26d6f2f8b43ea981$var$_target18 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ : $26d6f2f8b43ea981$var$_target18.__VUE_DEVTOOLS_KIT_MESSAGE_CHANNELS__ = [];
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_RPC_CLIENT__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_RPC_CLIENT__ = ($26d6f2f8b43ea981$var$_target19 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_RPC_CLIENT__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_RPC_CLIENT__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_RPC_CLIENT__ : $26d6f2f8b43ea981$var$_target19.__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = null;
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_RPC_SERVER__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_RPC_SERVER__ = ($26d6f2f8b43ea981$var$_target20 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_RPC_SERVER__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_RPC_SERVER__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_RPC_SERVER__ : $26d6f2f8b43ea981$var$_target20.__VUE_DEVTOOLS_KIT_RPC_SERVER__ = null;
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = ($26d6f2f8b43ea981$var$_target21 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ : $26d6f2f8b43ea981$var$_target21.__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = null;
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = ($26d6f2f8b43ea981$var$_target22 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ : $26d6f2f8b43ea981$var$_target22.__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = null;
var $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__;
($26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = ($26d6f2f8b43ea981$var$_target23 = (0, $6430dea643e1c0c1$export$44271b4f0c6a3563)).__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__) !== null && $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ !== void 0 ? $26d6f2f8b43ea981$var$___VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ : $26d6f2f8b43ea981$var$_target23.__VUE_DEVTOOLS_KIT_BROADCAST_RPC_SERVER__ = null;
function $26d6f2f8b43ea981$var$setRpcClientToGlobal(rpc) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_CLIENT__ = rpc;
}
function $26d6f2f8b43ea981$export$7f98be55f66c4a0d(rpc) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_SERVER__ = rpc;
}
function $26d6f2f8b43ea981$export$9362d59e25b9feb1() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_CLIENT__;
}
function $26d6f2f8b43ea981$export$380718822fedc343() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_RPC_SERVER__;
}
function $26d6f2f8b43ea981$export$5f8b48d38df9666a(rpc) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__ = rpc;
}
function $26d6f2f8b43ea981$export$5105f0908e5b2002(rpc) {
    (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__ = rpc;
}
function $26d6f2f8b43ea981$export$c7310d0d7eeaac08() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_CLIENT__;
}
function $26d6f2f8b43ea981$export$97b242d29756c723() {
    return (0, $6430dea643e1c0c1$export$44271b4f0c6a3563).__VUE_DEVTOOLS_KIT_VITE_RPC_SERVER__;
}
function $26d6f2f8b43ea981$var$getChannel(preset) {
    var host = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "client";
    var channel = {
        iframe: {
            client: $26d6f2f8b43ea981$var$createIframeClientChannel,
            server: $26d6f2f8b43ea981$var$createIframeServerChannel
        }[host],
        electron: {
            client: $26d6f2f8b43ea981$var$createElectronClientChannel,
            proxy: $26d6f2f8b43ea981$var$createElectronProxyChannel,
            server: $26d6f2f8b43ea981$var$createElectronServerChannel
        }[host],
        vite: {
            client: $26d6f2f8b43ea981$var$createViteClientChannel,
            server: $26d6f2f8b43ea981$var$createViteServerChannel
        }[host],
        broadcast: {
            client: $26d6f2f8b43ea981$var$createBroadcastChannel,
            server: $26d6f2f8b43ea981$var$createBroadcastChannel
        }[host],
        extension: {
            client: $26d6f2f8b43ea981$var$createExtensionClientChannel,
            proxy: $26d6f2f8b43ea981$var$createExtensionProxyChannel,
            server: $26d6f2f8b43ea981$var$createExtensionServerChannel
        }[host]
    }[preset];
    return channel();
}
function $26d6f2f8b43ea981$export$9c13c20c639717e6(functions) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _channel = options.channel, _options = options.options, preset = options.preset;
    var channel = preset ? $26d6f2f8b43ea981$var$getChannel(preset) : _channel;
    var rpc = (0, $1e15058b4cd80238$export$8de909a09ac6851a)(functions, (0, $6fpqi._)((0, $1XAnY._)({}, _options, channel), {
        timeout: -1
    }));
    if (preset === "vite") {
        $26d6f2f8b43ea981$export$5f8b48d38df9666a(rpc);
        return;
    }
    $26d6f2f8b43ea981$var$setRpcClientToGlobal(rpc);
    return rpc;
}
function $26d6f2f8b43ea981$export$fbf8e1689a053c1c(functions) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _channel = options.channel, _options = options.options, preset = options.preset;
    var channel = preset ? $26d6f2f8b43ea981$var$getChannel(preset, "server") : _channel;
    var rpcServer = $26d6f2f8b43ea981$export$380718822fedc343();
    if (!rpcServer) {
        var group = (0, $1e15058b4cd80238$export$ec516731f3c62ae5)(functions, [
            channel
        ], (0, $6fpqi._)((0, $1XAnY._)({}, _options), {
            timeout: -1
        }));
        if (preset === "vite") {
            $26d6f2f8b43ea981$export$5105f0908e5b2002(group);
            return;
        }
        $26d6f2f8b43ea981$export$7f98be55f66c4a0d(group);
    } else rpcServer.updateChannels(function(channels) {
        channels.push(channel);
    });
}
function $26d6f2f8b43ea981$export$490df4aa0eb47722() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _channel = options.channel, _options = options.options, preset = options.preset;
    var channel = preset ? $26d6f2f8b43ea981$var$getChannel(preset, "proxy") : _channel;
    return (0, $1e15058b4cd80238$export$8de909a09ac6851a)({}, (0, $6fpqi._)((0, $1XAnY._)({}, _options, channel), {
        timeout: -1
    }));
}
//#endregion
//#region src/core/component/state/custom.ts
function $26d6f2f8b43ea981$var$getFunctionDetails(func) {
    var string = "";
    var matches = null;
    try {
        string = Function.prototype.toString.call(func);
        matches = String.prototype.match.call(string, /\([\s\S]*?\)/);
    } catch (e) {}
    var match = matches && matches[0];
    var args = typeof match === "string" ? match : "(?)";
    return {
        _custom: {
            type: "function",
            displayText: '<span style="opacity:.8;margin-right:5px;">function</span> <span style="white-space:nowrap;">'.concat($26d6f2f8b43ea981$export$4e7f196112fea3c5(typeof func.name === "string" ? func.name : "")).concat(args, "</span>"),
            tooltipText: string.trim() ? "<pre>".concat($26d6f2f8b43ea981$export$4e7f196112fea3c5(string), "</pre>") : null
        }
    };
}
function $26d6f2f8b43ea981$var$getBigIntDetails(val) {
    var stringifiedBigInt = BigInt.prototype.toString.call(val);
    return {
        _custom: {
            type: "bigint",
            displayText: "BigInt(".concat(stringifiedBigInt, ")"),
            value: stringifiedBigInt
        }
    };
}
function $26d6f2f8b43ea981$var$getDateDetails(val) {
    var date = new Date(val.getTime());
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return {
        _custom: {
            type: "date",
            displayText: Date.prototype.toString.call(val),
            value: date.toISOString().slice(0, -1)
        }
    };
}
function $26d6f2f8b43ea981$var$getMapDetails(val) {
    return {
        _custom: {
            type: "map",
            displayText: "Map",
            value: Object.fromEntries(val),
            readOnly: true,
            fields: {
                abstract: true
            }
        }
    };
}
function $26d6f2f8b43ea981$var$getSetDetails(val) {
    var list = Array.from(val);
    return {
        _custom: {
            type: "set",
            displayText: "Set[".concat(list.length, "]"),
            value: list,
            readOnly: true
        }
    };
}
function $26d6f2f8b43ea981$var$getCaughtGetters(store) {
    var _loop = function(i) {
        var key = keys[i];
        Object.defineProperty(getters, key, {
            enumerable: true,
            get: function() {
                try {
                    return origGetters[key];
                } catch (e) {
                    return e;
                }
            }
        });
    };
    var getters = {};
    var origGetters = store.getters || {};
    var keys = Object.keys(origGetters);
    for(var i = 0; i < keys.length; i++)_loop(i);
    return getters;
}
function $26d6f2f8b43ea981$var$reduceStateList(list) {
    if (!list.length) return void 0;
    return list.reduce(function(map, item) {
        var key = item.type || "data";
        var obj = map[key] = map[key] || {};
        obj[item.key] = item.value;
        return map;
    }, {});
}
function $26d6f2f8b43ea981$var$namedNodeMapToObject(map) {
    var result = {};
    var l = map.length;
    for(var i = 0; i < l; i++){
        var node = map.item(i);
        result[node.name] = node.value;
    }
    return result;
}
function $26d6f2f8b43ea981$var$getStoreDetails(store) {
    return {
        _custom: {
            type: "store",
            displayText: "Store",
            value: {
                state: store.state,
                getters: $26d6f2f8b43ea981$var$getCaughtGetters(store)
            },
            fields: {
                abstract: true
            }
        }
    };
}
function $26d6f2f8b43ea981$var$getInstanceDetails(instance) {
    if (instance._) instance = instance._;
    var state = $26d6f2f8b43ea981$var$processInstanceState(instance);
    return {
        _custom: {
            type: "component",
            id: instance.__VUE_DEVTOOLS_NEXT_UID__,
            displayText: $26d6f2f8b43ea981$var$getInstanceName(instance),
            tooltipText: "Component instance",
            value: $26d6f2f8b43ea981$var$reduceStateList(state),
            fields: {
                abstract: true
            }
        }
    };
}
function $26d6f2f8b43ea981$var$getComponentDefinitionDetails(definition) {
    var display = $26d6f2f8b43ea981$var$getComponentName(definition);
    if (display) {
        if (definition.name && definition.__file) display += " <span>(".concat(definition.__file, ")</span>");
    } else display = "<i>Unknown Component</i>";
    return {
        _custom: (0, $1XAnY._)({
            type: "component-definition",
            displayText: display,
            tooltipText: "Component definition"
        }, definition.__file ? {
            file: definition.__file
        } : {})
    };
}
function $26d6f2f8b43ea981$var$getHTMLElementDetails(value) {
    try {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: '<span class="opacity-30">&lt;</span><span class="text-blue-500">'.concat(value.tagName.toLowerCase(), '</span><span class="opacity-30">&gt;</span>'),
                value: $26d6f2f8b43ea981$var$namedNodeMapToObject(value.attributes)
            }
        };
    } catch (e) {
        return {
            _custom: {
                type: "HTMLElement",
                displayText: '<span class="text-blue-500">'.concat(String(value), "</span>")
            }
        };
    }
}
/**
* - ObjectRefImpl, toRef({ foo: 'foo' }, 'foo'), `_value` is the actual value, (since 3.5.0)
* - GetterRefImpl, toRef(() => state.foo), `_value` is the actual value, (since 3.5.0)
* - RefImpl, ref('foo') / computed(() => 'foo'), `_value` is the actual value
*/ function $26d6f2f8b43ea981$var$tryGetRefValue(ref) {
    if ($26d6f2f8b43ea981$var$ensurePropertyExists(ref, "_value", true)) return ref._value;
    if ($26d6f2f8b43ea981$var$ensurePropertyExists(ref, "value", true)) return ref.value;
}
function $26d6f2f8b43ea981$var$getObjectDetails(object) {
    var info = $26d6f2f8b43ea981$var$getSetupStateType(object);
    if (info.ref || info.computed || info.reactive) {
        var _object_effect_raw, _object_effect, _object_effect_fn, _object_effect1;
        var stateTypeName = info.computed ? "Computed" : info.ref ? "Ref" : info.reactive ? "Reactive" : null;
        var value = $26d6f2f8b43ea981$var$toRaw(info.reactive ? object : $26d6f2f8b43ea981$var$tryGetRefValue(object));
        var raw = $26d6f2f8b43ea981$var$ensurePropertyExists(object, "effect") ? ((_object_effect = object.effect) === null || _object_effect === void 0 ? void 0 : (_object_effect_raw = _object_effect.raw) === null || _object_effect_raw === void 0 ? void 0 : _object_effect_raw.toString()) || ((_object_effect1 = object.effect) === null || _object_effect1 === void 0 ? void 0 : (_object_effect_fn = _object_effect1.fn) === null || _object_effect_fn === void 0 ? void 0 : _object_effect_fn.toString()) : null;
        return {
            _custom: (0, $1XAnY._)({
                type: stateTypeName === null || stateTypeName === void 0 ? void 0 : stateTypeName.toLowerCase(),
                stateTypeName: stateTypeName,
                value: value
            }, raw ? {
                tooltipText: "<pre>".concat($26d6f2f8b43ea981$export$4e7f196112fea3c5(raw), "</pre>")
            } : {})
        };
    }
    if ($26d6f2f8b43ea981$var$ensurePropertyExists(object, "__asyncLoader") && typeof object.__asyncLoader === "function") return {
        _custom: {
            type: "component-definition",
            display: "Async component definition"
        }
    };
}
//#endregion
//#region src/core/component/state/replacer.ts
function $26d6f2f8b43ea981$var$stringifyReplacer(key, _value, depth, seenInstance) {
    if (key === "compilerOptions") return;
    var val = this[key];
    var type = typeof val === "undefined" ? "undefined" : (0, $7E0eS._)(val);
    if (Array.isArray(val)) {
        var l = val.length;
        if (l > 5e3) return {
            _isArray: true,
            length: l,
            items: val.slice(0, $26d6f2f8b43ea981$var$MAX_ARRAY_SIZE)
        };
        return val;
    } else if (typeof val === "string") {
        if (val.length > 1e4) return "".concat(val.substring(0, $26d6f2f8b43ea981$var$MAX_STRING_SIZE), "... (").concat(val.length, " total length)");
        else return val;
    } else if (type === "undefined") return $26d6f2f8b43ea981$export$6db089fe7b26f5b6;
    else if (val === Number.POSITIVE_INFINITY) return $26d6f2f8b43ea981$export$b4bf424ed968e242;
    else if (val === Number.NEGATIVE_INFINITY) return $26d6f2f8b43ea981$export$95cb88e357cbada8;
    else if (typeof val === "function") return $26d6f2f8b43ea981$var$getFunctionDetails(val);
    else if (type === "symbol") return "[native Symbol ".concat(Symbol.prototype.toString.call(val), "]");
    else if ((typeof val === "undefined" ? "undefined" : (0, $7E0eS._)(val)) === "bigint") return $26d6f2f8b43ea981$var$getBigIntDetails(val);
    else if (val !== null && (typeof val === "undefined" ? "undefined" : (0, $7E0eS._)(val)) === "object") {
        var _val_constructor;
        var proto = Object.prototype.toString.call(val);
        if (proto === "[object Map]") return $26d6f2f8b43ea981$var$getMapDetails(val);
        else if (proto === "[object Set]") return $26d6f2f8b43ea981$var$getSetDetails(val);
        else if (proto === "[object RegExp]") return "[native RegExp ".concat(RegExp.prototype.toString.call(val), "]");
        else if (proto === "[object Date]") return $26d6f2f8b43ea981$var$getDateDetails(val);
        else if (proto === "[object Error]") return "[native Error ".concat(val.message, "<>").concat(val.stack, "]");
        else if ($26d6f2f8b43ea981$var$ensurePropertyExists(val, "state", true) && $26d6f2f8b43ea981$var$ensurePropertyExists(val, "_vm", true)) return $26d6f2f8b43ea981$var$getStoreDetails(val);
        else if ($26d6f2f8b43ea981$var$isVueInstance(val)) {
            var componentVal = $26d6f2f8b43ea981$var$getInstanceDetails(val);
            var parentInstanceDepth = seenInstance === null || seenInstance === void 0 ? void 0 : seenInstance.get(val);
            if (parentInstanceDepth && parentInstanceDepth < depth) return "[[CircularRef]] <".concat(componentVal._custom.displayText, ">");
            seenInstance === null || seenInstance === void 0 ? void 0 : seenInstance.set(val, depth);
            return componentVal;
        } else if ($26d6f2f8b43ea981$var$ensurePropertyExists(val, "render", true) && typeof val.render === "function") return $26d6f2f8b43ea981$var$getComponentDefinitionDetails(val);
        else if (val.constructor && val.constructor.name === "VNode") return "[native VNode <".concat(val.tag, ">]");
        else if (typeof HTMLElement !== "undefined" && val instanceof HTMLElement) return $26d6f2f8b43ea981$var$getHTMLElementDetails(val);
        else if (((_val_constructor = val.constructor) === null || _val_constructor === void 0 ? void 0 : _val_constructor.name) === "Store" && "_wrappedGetters" in val) return "[object Store]";
        var customDetails = $26d6f2f8b43ea981$var$getObjectDetails(val);
        if (customDetails != null) return customDetails;
    } else if (Number.isNaN(val)) return $26d6f2f8b43ea981$export$d7ae0f70ebb9e144;
    return $26d6f2f8b43ea981$var$sanitize(val);
}
//#endregion
//#region src/shared/transfer.ts
var $26d6f2f8b43ea981$var$MAX_SERIALIZED_SIZE = 2097152;
function $26d6f2f8b43ea981$var$isObject(_data, proto) {
    return proto === "[object Object]";
}
function $26d6f2f8b43ea981$var$isArray(_data, proto) {
    return proto === "[object Array]";
}
function $26d6f2f8b43ea981$var$isVueReactiveLinkNode(node) {
    var _node_constructor;
    var constructorName = node === null || node === void 0 ? void 0 : (_node_constructor = node.constructor) === null || _node_constructor === void 0 ? void 0 : _node_constructor.name;
    return constructorName === "Dep" && "activeLink" in node || constructorName === "Link" && "dep" in node;
}
/**
* This function is used to serialize object with handling circular references.
*
* ```ts
* const obj = { a: 1, b: { c: 2 }, d: obj }
* const result = stringifyCircularAutoChunks(obj) // call `encode` inside
* console.log(result) // [{"a":1,"b":2,"d":0},1,{"c":4},2]
* ```
*
* Each object is stored in a list and the index is used to reference the object.
* With seen map, we can check if the object is already stored in the list to avoid circular references.
*
* Note: here we have a special case for Vue instance.
* We check if a vue instance includes itself in its properties and skip it
* by using `seenVueInstance` and `depth` to avoid infinite loop.
*/ function $26d6f2f8b43ea981$var$encode(data, replacer, list, seen) {
    var depth = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0, seenVueInstance = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : /* @__PURE__ */ new Map();
    var stored;
    var key;
    var value;
    var i;
    var l;
    var seenIndex = seen.get(data);
    if (seenIndex != null) return seenIndex;
    var index = list.length;
    var proto = Object.prototype.toString.call(data);
    if ($26d6f2f8b43ea981$var$isObject(data, proto)) {
        if ($26d6f2f8b43ea981$var$isVueReactiveLinkNode(data)) return index;
        stored = {};
        seen.set(data, index);
        list.push(stored);
        var keys = Object.keys(data);
        for(i = 0, l = keys.length; i < l; i++){
            key = keys[i];
            if (key === "compilerOptions") return index;
            value = data[key];
            var isVm = value != null && $26d6f2f8b43ea981$var$isObject(value, Object.prototype.toString.call(data)) && $26d6f2f8b43ea981$var$isVueInstance(value);
            try {
                if (replacer) value = replacer.call(data, key, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[key] = $26d6f2f8b43ea981$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
            if (isVm) seenVueInstance.delete(value);
        }
    } else if ($26d6f2f8b43ea981$var$isArray(data, proto)) {
        stored = [];
        seen.set(data, index);
        list.push(stored);
        for(i = 0, l = data.length; i < l; i++){
            try {
                value = data[i];
                if (replacer) value = replacer.call(data, i, value, depth, seenVueInstance);
            } catch (e) {
                value = e;
            }
            stored[i] = $26d6f2f8b43ea981$var$encode(value, replacer, list, seen, depth + 1, seenVueInstance);
        }
    } else list.push(data);
    return index;
}
function $26d6f2f8b43ea981$var$decode(list) {
    var reviver = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var i = list.length;
    var j, k, data, key, value, proto;
    while(i--){
        data = list[i];
        proto = Object.prototype.toString.call(data);
        if (proto === "[object Object]") {
            var keys = Object.keys(data);
            for(j = 0, k = keys.length; j < k; j++){
                key = keys[j];
                value = list[data[key]];
                if (reviver) value = reviver.call(data, key, value);
                data[key] = value;
            }
        } else if (proto === "[object Array]") for(j = 0, k = data.length; j < k; j++){
            value = list[data[j]];
            if (reviver) value = reviver.call(data, j, value);
            data[j] = value;
        }
    }
}
function $26d6f2f8b43ea981$var$stringifyCircularAutoChunks(data) {
    var _this = this;
    var replacer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, space = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var result;
    try {
        result = arguments.length === 1 ? JSON.stringify(data) : JSON.stringify(data, function(k, v) {
            var _replacer;
            return replacer === null || replacer === void 0 ? void 0 : (_replacer = replacer(k, v)) === null || _replacer === void 0 ? void 0 : _replacer.call(_this);
        }, space);
    } catch (e) {
        result = $26d6f2f8b43ea981$var$stringifyStrictCircularAutoChunks(data, replacer, space);
    }
    if (result.length > $26d6f2f8b43ea981$var$MAX_SERIALIZED_SIZE) {
        var chunkCount = Math.ceil(result.length / $26d6f2f8b43ea981$var$MAX_SERIALIZED_SIZE);
        var chunks = [];
        for(var i = 0; i < chunkCount; i++)chunks.push(result.slice(i * $26d6f2f8b43ea981$var$MAX_SERIALIZED_SIZE, (i + 1) * $26d6f2f8b43ea981$var$MAX_SERIALIZED_SIZE));
        return chunks;
    }
    return result;
}
function $26d6f2f8b43ea981$var$stringifyStrictCircularAutoChunks(data) {
    var replacer = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, space = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var list = [];
    $26d6f2f8b43ea981$var$encode(data, replacer, list, /* @__PURE__ */ new Map());
    return space ? " ".concat(JSON.stringify(list, null, space)) : " ".concat(JSON.stringify(list));
}
function $26d6f2f8b43ea981$var$parseCircularAutoChunks(data) {
    var reviver = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (Array.isArray(data)) data = data.join("");
    if (!/^\s/.test(data)) return arguments.length === 1 ? JSON.parse(data) : JSON.parse(data, reviver);
    else {
        var list = JSON.parse(data);
        $26d6f2f8b43ea981$var$decode(list, reviver);
        return list[0];
    }
}
//#endregion
//#region src/shared/util.ts
function $26d6f2f8b43ea981$export$fac44ee5b035f737(data) {
    return $26d6f2f8b43ea981$var$stringifyCircularAutoChunks(data, $26d6f2f8b43ea981$var$stringifyReplacer);
}
function $26d6f2f8b43ea981$export$98e6a39c04603d36(data) {
    var revive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (data == void 0) return {};
    return revive ? $26d6f2f8b43ea981$var$parseCircularAutoChunks(data, $26d6f2f8b43ea981$var$reviver) : $26d6f2f8b43ea981$var$parseCircularAutoChunks(data);
}
//#endregion
//#region src/index.ts
var $26d6f2f8b43ea981$export$6922d3b3a607469e = {
    hook: $26d6f2f8b43ea981$var$hook,
    init: function() {
        $26d6f2f8b43ea981$export$93f430585c3f6d11();
    },
    get ctx () {
        return $26d6f2f8b43ea981$export$4f1904c03898171b;
    },
    get api () {
        return $26d6f2f8b43ea981$export$4f1904c03898171b.api;
    }
};


//#region src/utils/env.ts
var $2d3a1f98237b4166$export$d66501df72047452 = typeof document !== "undefined";
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ var $2d3a1f98237b4166$var$HASH_RE = /#/g;
var $2d3a1f98237b4166$var$AMPERSAND_RE = /&/g;
var $2d3a1f98237b4166$var$SLASH_RE = /\//g;
var $2d3a1f98237b4166$var$EQUAL_RE = /=/g;
var $2d3a1f98237b4166$var$IM_RE = /\?/g;
var $2d3a1f98237b4166$export$ebd11618f299a286 = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ var $2d3a1f98237b4166$var$ENC_BRACKET_OPEN_RE = /%5B/g;
var $2d3a1f98237b4166$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
var $2d3a1f98237b4166$var$ENC_CARET_RE = /%5E/g;
var $2d3a1f98237b4166$var$ENC_BACKTICK_RE = /%60/g;
var $2d3a1f98237b4166$var$ENC_CURLY_OPEN_RE = /%7B/g;
var $2d3a1f98237b4166$var$ENC_PIPE_RE = /%7C/g;
var $2d3a1f98237b4166$var$ENC_CURLY_CLOSE_RE = /%7D/g;
var $2d3a1f98237b4166$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $2d3a1f98237b4166$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($2d3a1f98237b4166$var$ENC_PIPE_RE, "|").replace($2d3a1f98237b4166$var$ENC_BRACKET_OPEN_RE, "[").replace($2d3a1f98237b4166$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $2d3a1f98237b4166$export$3a1a48c8f6ef640e(text) {
    return $2d3a1f98237b4166$var$commonEncode(text).replace($2d3a1f98237b4166$var$ENC_CURLY_OPEN_RE, "{").replace($2d3a1f98237b4166$var$ENC_CURLY_CLOSE_RE, "}").replace($2d3a1f98237b4166$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $2d3a1f98237b4166$var$encodeQueryValue(text) {
    return $2d3a1f98237b4166$var$commonEncode(text).replace($2d3a1f98237b4166$export$ebd11618f299a286, "%2B").replace($2d3a1f98237b4166$var$ENC_SPACE_RE, "+").replace($2d3a1f98237b4166$var$HASH_RE, "%23").replace($2d3a1f98237b4166$var$AMPERSAND_RE, "%26").replace($2d3a1f98237b4166$var$ENC_BACKTICK_RE, "`").replace($2d3a1f98237b4166$var$ENC_CURLY_OPEN_RE, "{").replace($2d3a1f98237b4166$var$ENC_CURLY_CLOSE_RE, "}").replace($2d3a1f98237b4166$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $2d3a1f98237b4166$var$encodeQueryKey(text) {
    return $2d3a1f98237b4166$var$encodeQueryValue(text).replace($2d3a1f98237b4166$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $2d3a1f98237b4166$export$56c0d5a1e737357d(text) {
    return $2d3a1f98237b4166$var$commonEncode(text).replace($2d3a1f98237b4166$var$HASH_RE, "%23").replace($2d3a1f98237b4166$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $2d3a1f98237b4166$export$a07804094c3ecf2d(text) {
    return $2d3a1f98237b4166$export$56c0d5a1e737357d(text).replace($2d3a1f98237b4166$var$SLASH_RE, "%2F");
}
function $2d3a1f98237b4166$export$35e795649ee09318(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch (e) {}
    return "" + text;
}
//#endregion
//#region src/location.ts
var $2d3a1f98237b4166$var$TRAILING_SLASH_RE = /\/$/;
var $2d3a1f98237b4166$var$removeTrailingSlash = function(path) {
    return path.replace($2d3a1f98237b4166$var$TRAILING_SLASH_RE, "");
};
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $2d3a1f98237b4166$export$a9c23c6ac3fc3eca(parseQuery, location) {
    var currentLocation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "/";
    var path, query = {}, searchString = "", hash = "";
    var hashPos = location.indexOf("#");
    var searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $2d3a1f98237b4166$export$96f57966bedc81b4(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $2d3a1f98237b4166$export$35e795649ee09318(hash)
    };
}
function $2d3a1f98237b4166$export$d141bba7fdc215a3(stringifyQuery, path, query) {
    var hash = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    var searchText = stringifyQuery(query);
    return path + (searchText && "?") + searchText + $2d3a1f98237b4166$export$3a1a48c8f6ef640e(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $2d3a1f98237b4166$export$c4ce752e73470fba(stringifyQuery, location) {
    var query = location.query ? stringifyQuery(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $2d3a1f98237b4166$export$342063e11d6c3cad(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $2d3a1f98237b4166$export$e7094788287c5e9b(stringifyQuery, a, b) {
    var aLastIndex = a.matched.length - 1;
    var bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $2d3a1f98237b4166$export$971d5caa766a69d7(a.matched[aLastIndex], b.matched[bLastIndex]) && $2d3a1f98237b4166$export$efccba1c4a2ef57b(a.params, b.params) && stringifyQuery(a.query) === stringifyQuery(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $2d3a1f98237b4166$export$971d5caa766a69d7(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $2d3a1f98237b4166$export$efccba1c4a2ef57b(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$2d3a1f98237b4166$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $2d3a1f98237b4166$var$isSameRouteLocationParamsValue(a, b) {
    return (0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(a) ? $2d3a1f98237b4166$var$isEquivalentArray(a, b) : (0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(b) ? $2d3a1f98237b4166$var$isEquivalentArray(b, a) : (a && a.valueOf()) === (b && b.valueOf());
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $2d3a1f98237b4166$var$isEquivalentArray(a, b) {
    return (0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(b) ? a.length === b.length && a.every(function(value, i) {
        return value === b[i];
    }) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $2d3a1f98237b4166$export$96f57966bedc81b4(to, from) {
    if ((0, $629d80bbf56b9c6a$export$dda1d9f60106f0e9)(to)) return to;
    if (!to) return from;
    var fromSegments = from.split("/");
    var toSegments = to.split("/");
    var lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    var position = fromSegments.length - 1;
    var toPosition;
    var segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ var $2d3a1f98237b4166$export$25ce5a424b770e84 = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $2d3a1f98237b4166$export$8b22cf2602fb60ce(base) {
    if (!base) {
        if ($2d3a1f98237b4166$export$d66501df72047452) {
            var baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $2d3a1f98237b4166$var$removeTrailingSlash(base);
}
var $2d3a1f98237b4166$var$BEFORE_HASH_RE = /^[^#]+#/;
function $2d3a1f98237b4166$export$4a5767248b18ef41(base, location) {
    return base.replace($2d3a1f98237b4166$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $2d3a1f98237b4166$var$getElementPosition(el, offset) {
    var docRect = document.documentElement.getBoundingClientRect();
    var elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
var $2d3a1f98237b4166$export$953cecd6e717a553 = function() {
    return history.scrollRestoration === "manual" ? {
        left: window.scrollX,
        top: window.scrollY
    } : null;
};
function $2d3a1f98237b4166$export$90a7f3efeed30595(position) {
    var scrollToOptions;
    if ("el" in position) {
        var positionEl = position.el;
        var isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $2d3a1f98237b4166$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $2d3a1f98237b4166$export$39b482c5e57630a8(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
var $2d3a1f98237b4166$var$scrollPositions = /* @__PURE__ */ new Map();
function $2d3a1f98237b4166$export$71511d61b312f219(key) {
    $2d3a1f98237b4166$var$scrollPositions.set(key, $2d3a1f98237b4166$export$953cecd6e717a553());
}
function $2d3a1f98237b4166$export$dda1d9f60106f0e9(key) {
    var scroll = $2d3a1f98237b4166$var$scrollPositions.get(key);
    $2d3a1f98237b4166$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $2d3a1f98237b4166$export$2d1720544b23b823(route) {
    return typeof route === "string" || route && (typeof route === "undefined" ? "undefined" : (0, $7E0eS._)(route)) === "object";
}
function $2d3a1f98237b4166$export$ffb5f4729a158638(name) {
    return typeof name === "string" || (typeof name === "undefined" ? "undefined" : (0, $7E0eS._)(name)) === "symbol";
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $2d3a1f98237b4166$export$3b14a55fb2447963(search) {
    var query = {};
    if (search === "" || search === "?") return query;
    var searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(var i = 0; i < searchParams.length; ++i){
        var searchParam = searchParams[i].replace($2d3a1f98237b4166$export$ebd11618f299a286, " ");
        var eqPos = searchParam.indexOf("=");
        var key = $2d3a1f98237b4166$export$35e795649ee09318(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        var value = eqPos < 0 ? null : $2d3a1f98237b4166$export$35e795649ee09318(searchParam.slice(eqPos + 1));
        if (key in query) {
            var currentValue = query[key];
            if (!(0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $2d3a1f98237b4166$export$4368d992c4eafac0(query) {
    var _loop = function(key1) {
        var value = query[key1];
        key1 = $2d3a1f98237b4166$var$encodeQueryKey(key1);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key1;
            return key = key1, "continue";
        }
        ((0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(value) ? value.map(function(v) {
            return v && $2d3a1f98237b4166$var$encodeQueryValue(v);
        }) : [
            value && $2d3a1f98237b4166$var$encodeQueryValue(value)
        ]).forEach(function(value) {
            if (value !== void 0) {
                search += (search.length ? "&" : "") + key1;
                if (value != null) search += "=" + value;
            }
        });
        key = key1, void 0;
    };
    var search = "";
    for(var key in query)_loop(key);
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $2d3a1f98237b4166$export$882b5998b3b9117c(query) {
    var normalizedQuery = {};
    for(var key in query){
        var value = query[key];
        if (value !== void 0) normalizedQuery[key] = (0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(value) ? value.map(function(v) {
            return v == null ? null : "" + v;
        }) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $2d3a1f98237b4166$export$db3b6bfb95261072() {
    var handlers = [];
    function add(handler) {
        handlers.push(handler);
        return function() {
            var i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: function() {
            return handlers.slice();
        },
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $2d3a1f98237b4166$var$registerGuard(activeRecordRef, name, guard) {
    var record = activeRecordRef.value;
    if (!record) return;
    var currentRecord = record;
    var removeFromList = function() {
        currentRecord[name].delete(guard);
    };
    (0, $fKAHx.onUnmounted)(removeFromList);
    (0, $fKAHx.onDeactivated)(removeFromList);
    (0, $fKAHx.onActivated)(function() {
        var newRecord = activeRecordRef.value;
        if (newRecord) currentRecord = newRecord;
        currentRecord[name].add(guard);
    });
    currentRecord[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $2d3a1f98237b4166$export$ae1af26003f05816(leaveGuard) {
    $2d3a1f98237b4166$var$registerGuard((0, $fKAHx.inject)((0, $629d80bbf56b9c6a$export$43caf9889c228507), {}), "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $2d3a1f98237b4166$export$2408f22a0fab9ae5(updateGuard) {
    $2d3a1f98237b4166$var$registerGuard((0, $fKAHx.inject)((0, $629d80bbf56b9c6a$export$43caf9889c228507), {}), "updateGuards", updateGuard);
}
function $2d3a1f98237b4166$export$23f2a1d2818174ef(guard, to, from, record, name) {
    var runWithContext = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function(fn) {
        return fn();
    };
    var enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return function() {
        return new Promise(function(resolve, reject) {
            var next = function(valid) {
                if (valid === false) reject((0, $629d80bbf56b9c6a$export$3b14a55fb2447963)(4, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($2d3a1f98237b4166$export$2d1720544b23b823(valid)) reject((0, $629d80bbf56b9c6a$export$3b14a55fb2447963)(2, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            var guardReturn = runWithContext(function() {
                return guard.call(record && record.instances[name], to, from, next);
            });
            var guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch(function(err) {
                return reject(err);
            });
        });
    };
}
/**
* Wraps the next callback to warn when it is used. Dev-only: when __DEV__ is
* false (production builds), this branch is dead code and is stripped from the
* bundle.
*
* @internal
*/ function $2d3a1f98237b4166$var$withDeprecationWarning(next) {
    var warned = false;
    return function() {
        if (!warned) {
            warned = true;
            (0, $629d80bbf56b9c6a$export$db3b6bfb95261072).VUE_ROUTER_R0025();
        }
        return next.apply(this, arguments);
    };
}
function $2d3a1f98237b4166$var$canOnlyBeCalledOnce(next, to, from) {
    var called = 0;
    return function() {
        if (called++ === 1) (0, $629d80bbf56b9c6a$export$db3b6bfb95261072).VUE_ROUTER_R0024({
            from: from.fullPath,
            to: to.fullPath
        });
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $2d3a1f98237b4166$export$43caf9889c228507(matched, guardType, to, from) {
    var runWithContext = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function(fn) {
        return fn();
    };
    var guards = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _loop = function(name) {
                var rawComponent = record.components[name];
                if (guardType !== "beforeRouteEnter" && !record.instances[name]) return "continue";
                if ((0, $629d80bbf56b9c6a$export$90a7f3efeed30595)(rawComponent)) {
                    var guard = (rawComponent.__vccOpts || rawComponent)[guardType];
                    guard && guards.push($2d3a1f98237b4166$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
                } else {
                    var componentPromise = rawComponent();
                    guards.push(function() {
                        return componentPromise.then(function(resolved) {
                            if (!resolved) throw new Error("Couldn't resolve component \"".concat(name, '" at "').concat(record.path, '"'));
                            var resolvedComponent = (0, $629d80bbf56b9c6a$export$71511d61b312f219)(resolved) ? resolved.default : resolved;
                            record.mods[name] = resolved;
                            record.components[name] = resolvedComponent;
                            var guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                            return guard && $2d3a1f98237b4166$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                        });
                    });
                }
            };
            var record = _step.value;
            for(var name in record.components)_loop(name);
        };
        for(var _iterator = matched[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $2d3a1f98237b4166$export$407448d2b89b1813(route) {
    return route.matched.every(function(record) {
        return record.redirect;
    }) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map(function(record) {
        return record.components && Promise.all(Object.keys(record.components).reduce(function(promises, name) {
            var rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then(function(resolved) {
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error("Couldn't resolve component \"".concat(name, '" at "').concat(record.path, '". Ensure you passed a function that returns a promise.')));
                var resolvedComponent = (0, $629d80bbf56b9c6a$export$71511d61b312f219)(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, []));
    })).then(function() {
        return route;
    });
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $2d3a1f98237b4166$export$7ccc53e8f1e7dfc5(to, from) {
    var _loop = function(i) {
        var recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find(function(record) {
                return $2d3a1f98237b4166$export$971d5caa766a69d7(record, recordFrom);
            })) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        var recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find(function(record) {
                return $2d3a1f98237b4166$export$971d5caa766a69d7(record, recordTo);
            })) enteringRecords.push(recordTo);
        }
    };
    var leavingRecords = [];
    var updatingRecords = [];
    var enteringRecords = [];
    var len = Math.max(from.matched.length, to.matched.length);
    for(var i = 0; i < len; i++)_loop(i);
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $2d3a1f98237b4166$var$formatRouteLocation(routeLocation, tooltip) {
    var copy = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, routeLocation, {
        matched: routeLocation.matched.map(function(matched) {
            return $2d3a1f98237b4166$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]);
        })
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $2d3a1f98237b4166$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
var $2d3a1f98237b4166$var$routerId = 0;
function $2d3a1f98237b4166$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    var id = $2d3a1f98237b4166$var$routerId++;
    (0, $26d6f2f8b43ea981$export$1f0daed17c8e64f)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, function(api) {
        api.on.inspectComponent(function(payload) {
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $2d3a1f98237b4166$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(function(param) {
            var node = param.treeNode, componentInstance = param.componentInstance;
            if (componentInstance.__vrv_devtools) {
                var info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? "".concat(info.name.toString(), ": ") : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $2d3a1f98237b4166$var$PINK_500
                });
            }
            if ((0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach(function(devtoolsData) {
                    var label = devtoolsData.route.path;
                    var backgroundColor = $2d3a1f98237b4166$var$ORANGE_400;
                    var tooltip = "";
                    var textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $2d3a1f98237b4166$var$RED_100;
                        textColor = $2d3a1f98237b4166$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $2d3a1f98237b4166$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $2d3a1f98237b4166$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $fKAHx.watch)(router.currentRoute, function() {
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        var navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: "Router".concat(id ? " " + id : "", " Navigations"),
            color: 4237508
        });
        router.onError(function(error, to) {
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        var navigationId = 0;
        router.beforeEach(function(to, from) {
            var data = {
                guard: $2d3a1f98237b4166$var$formatDisplay("beforeEach"),
                from: $2d3a1f98237b4166$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $2d3a1f98237b4166$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach(function(to, from, failure) {
            var data = {
                guard: $2d3a1f98237b4166$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $2d3a1f98237b4166$var$formatDisplay("\u274C");
            } else data.status = $2d3a1f98237b4166$var$formatDisplay("\u2705");
            data.from = $2d3a1f98237b4166$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $2d3a1f98237b4166$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ var routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            var payload = activeRoutesPayload;
            var routes = matcher.getRoutes().filter(function(route) {
                return !route.parent || !route.parent.record.components;
            });
            routes.forEach($2d3a1f98237b4166$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter(function(route) {
                return $2d3a1f98237b4166$var$isRouteMatching(route, payload.filter.toLowerCase());
            });
            routes.forEach(function(route) {
                return $2d3a1f98237b4166$var$markRouteRecordActive(route, router.currentRoute.value);
            });
            payload.rootNodes = routes.map($2d3a1f98237b4166$var$formatRouteRecordForInspector);
        }
        var activeRoutesPayload;
        api.on.getInspectorTree(function(payload) {
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                var route = matcher.getRoutes().find(function(route) {
                    return route.record.__vd_id === payload.nodeId;
                });
                if (route) payload.state = {
                    options: $2d3a1f98237b4166$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $2d3a1f98237b4166$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $2d3a1f98237b4166$var$formatRouteRecordMatcherForStateInspector(route) {
    var record = route.record;
    var fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map(function(key) {
                    return "".concat(key.name).concat($2d3a1f98237b4166$var$modifierForKey(key));
                }).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map(function(alias) {
            return alias.record.path;
        })
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map(function(score) {
                    return score.join(", ");
                }).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ var $2d3a1f98237b4166$var$PINK_500 = 15485081;
var $2d3a1f98237b4166$var$BLUE_600 = 2450411;
var $2d3a1f98237b4166$var$LIME_500 = 8702998;
var $2d3a1f98237b4166$var$CYAN_400 = 2282478;
var $2d3a1f98237b4166$var$ORANGE_400 = 16486972;
var $2d3a1f98237b4166$var$DARK = 6710886;
var $2d3a1f98237b4166$var$RED_100 = 16704226;
var $2d3a1f98237b4166$var$RED_700 = 12131356;
function $2d3a1f98237b4166$var$formatRouteRecordForInspector(route) {
    var tags = [];
    var record = route.record;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $2d3a1f98237b4166$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $2d3a1f98237b4166$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $2d3a1f98237b4166$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $2d3a1f98237b4166$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $2d3a1f98237b4166$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? "redirect: ".concat(record.redirect) : "redirects",
        textColor: 16777215,
        backgroundColor: $2d3a1f98237b4166$var$DARK
    });
    var id = record.__vd_id;
    if (id == null) {
        id = String($2d3a1f98237b4166$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($2d3a1f98237b4166$var$formatRouteRecordForInspector)
    };
}
var $2d3a1f98237b4166$var$routeRecordId = 0;
var $2d3a1f98237b4166$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $2d3a1f98237b4166$var$markRouteRecordActive(route, currentRoute) {
    var isExactActive = currentRoute.matched.length && $2d3a1f98237b4166$export$971d5caa766a69d7(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some(function(match) {
        return $2d3a1f98237b4166$export$971d5caa766a69d7(match, route.record);
    });
    route.children.forEach(function(childRoute) {
        return $2d3a1f98237b4166$var$markRouteRecordActive(childRoute, currentRoute);
    });
}
function $2d3a1f98237b4166$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($2d3a1f98237b4166$var$resetMatchStateOnRouteRecord);
}
function $2d3a1f98237b4166$var$isRouteMatching(route, filter) {
    var found = String(route.re).match($2d3a1f98237b4166$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach(function(child) {
            return $2d3a1f98237b4166$var$isRouteMatching(child, filter);
        });
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    var path = route.record.path.toLowerCase();
    var decodedPath = $2d3a1f98237b4166$export$35e795649ee09318(path);
    if (!(0, $629d80bbf56b9c6a$export$dda1d9f60106f0e9)(filter) && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some(function(child) {
        return $2d3a1f98237b4166$var$isRouteMatching(child, filter);
    });
}
function $2d3a1f98237b4166$var$omit(obj, keys) {
    var ret = {};
    for(var key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}



parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
var $ftLbb = parcelRequire("ftLbb");
//#region src/history/html5.ts
var $19184f195625c89b$var$createBaseLocation = function() {
    return location.protocol + "//" + location.host;
};
/**
* Creates a normalized history location from a window.location object
* @param base - The base path
* @param location - The window.location object
*/ function $19184f195625c89b$var$createCurrentLocation(base, location1) {
    var pathname = location1.pathname, search = location1.search, hash = location1.hash;
    var hashPos = base.indexOf("#");
    if (hashPos > -1) {
        var slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        var pathFromHash = hash.slice(slicePos);
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return (0, $2d3a1f98237b4166$export$342063e11d6c3cad)(pathFromHash, "");
    }
    return (0, $2d3a1f98237b4166$export$342063e11d6c3cad)(pathname, base) + search + hash;
}
function $19184f195625c89b$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    var listeners = [];
    var teardowns = [];
    var pauseState = null;
    var popStateHandler = function(param) {
        var state = param.state;
        var to = $19184f195625c89b$var$createCurrentLocation(base, location);
        var from = currentLocation.value;
        var fromState = historyState.value;
        var delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        listeners.forEach(function(listener) {
            listener(currentLocation.value, from, {
                delta: delta,
                type: "pop",
                direction: delta ? delta > 0 ? "forward" : "back" : ""
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        listeners.push(callback);
        var teardown = function() {
            var index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        var history1 = window.history;
        if (!history1.state) return;
        history1.replaceState((0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, history1.state, {
            scroll: (0, $2d3a1f98237b4166$export$953cecd6e717a553)()
        }), "");
    }
    function destroy() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = teardowns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var teardown = _step.value;
                teardown();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("pagehide", beforeUnloadListener);
    }
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("pagehide", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
* Creates a state object
*/ function $19184f195625c89b$var$buildState(back, current, forward) {
    var replaced = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: null
    };
}
function $19184f195625c89b$var$useHistoryStateNavigation(base) {
    var history1 = window.history, location1 = window.location;
    var currentLocation = {
        value: $19184f195625c89b$var$createCurrentLocation(base, location1)
    };
    var historyState = {
        value: history1.state
    };
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        position: history1.length - 1,
        replaced: true,
        scroll: null
    }, true);
    function changeLocation(to, state, replace) {
        /**
		* if a base tag is provided, and we are on a normal domain, we have to
		* respect the provided `base` attribute because pushState() will use it and
		* potentially erase anything before the `#` like at
		* https://github.com/vuejs/router/issues/685 where a base of
		* `/folder/#` but a base of `/` would erase the `/folder/` section. If
		* there is no host, the `<base>` tag makes no sense and if there isn't a
		* base tag we can just use everything after the `#`.
		*/ var hashIndex = base.indexOf("#");
        var url = hashIndex > -1 ? (location1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $19184f195625c89b$var$createBaseLocation() + base + to;
        try {
            history1[replace ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            location1[replace ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        changeLocation(to, (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, history1.state, $19184f195625c89b$var$buildState(historyState.value.back, to, historyState.value.forward, true), data, {
            position: historyState.value.position
        }), true);
        currentLocation.value = to;
    }
    function push(to, data) {
        var currentState = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, historyState.value, history1.state, {
            forward: to,
            scroll: (0, $2d3a1f98237b4166$export$953cecd6e717a553)()
        });
        changeLocation(currentState.current, currentState, true);
        changeLocation(to, (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, $19184f195625c89b$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data), false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
* Creates an HTML5 history. Most common history for single page applications.
*
* @param base -
*/ function $19184f195625c89b$export$7b4942f78e7b8a49(base) {
    base = (0, $2d3a1f98237b4166$export$8b22cf2602fb60ce)(base);
    var historyNavigation = $19184f195625c89b$var$useHistoryStateNavigation(base);
    var historyListeners = $19184f195625c89b$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta) {
        var triggerListeners = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    var routerHistory = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({
        location: "",
        base: base,
        go: go,
        createHref: (0, $2d3a1f98237b4166$export$4a5767248b18ef41).bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: function() {
            return historyNavigation.location.value;
        }
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: function() {
            return historyNavigation.state.value;
        }
    });
    return routerHistory;
}
//#endregion
//#region src/history/hash.ts
/**
* Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
* handle any URL is not possible.
*
* @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
* in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
* calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
* after the `#`).
*
* @example
* ```js
* // at https://example.com/folder
* createWebHashHistory() // gives a url of `https://example.com/folder#`
* createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
* // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
* createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
* // you should avoid doing this because it changes the original url and breaks copying urls
* createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
*
* // at file:///usr/etc/folder/index.html
* // for locations with no `host`, the base is ignored
* createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
* ```
*/ function $19184f195625c89b$export$542bc3a76486c94d(base) {
    base = location.host ? base || location.pathname + location.search : "";
    if (!base.includes("#")) base += "#";
    return $19184f195625c89b$export$7b4942f78e7b8a49(base);
}
//#endregion
//#region src/history/memory.ts
/**
* Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
* It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
*
* @param base - Base applied to all urls, defaults to '/'
* @returns a history object that can be passed to the router constructor
*/ function $19184f195625c89b$export$2b76ad033c6e6d08() {
    var base = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var listeners = [];
    var queue = [
        [
            "",
            {}
        ]
    ];
    var position = 0;
    base = (0, $2d3a1f98237b4166$export$8b22cf2602fb60ce)(base);
    function setLocation(location1) {
        var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        position++;
        if (position !== queue.length) queue.splice(position);
        queue.push([
            location1,
            state
        ]);
    }
    function triggerListeners(to, from, param) {
        var direction = param.direction, delta = param.delta;
        var info = {
            direction: direction,
            delta: delta,
            type: "pop"
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                callback(to, from, info);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    var routerHistory = {
        location: "",
        state: {},
        base: base,
        createHref: (0, $2d3a1f98237b4166$export$4a5767248b18ef41).bind(null, base),
        replace: function(to, state) {
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push: function(to, state) {
            setLocation(to, state);
        },
        listen: function(callback) {
            listeners.push(callback);
            return function() {
                var index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy: function() {
            listeners = [];
            queue = [
                [
                    "",
                    {}
                ]
            ];
            position = 0;
        },
        go: function(delta) {
            var shouldTrigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            var from = this.location;
            var direction = delta < 0 ? "back" : "forward";
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: function() {
            return queue[position][0];
        }
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: function() {
            return queue[position][1];
        }
    });
    return routerHistory;
}
//#endregion
//#region src/matcher/pathTokenizer.ts
var $19184f195625c89b$var$ROOT_TOKEN = {
    type: 0,
    value: ""
};
var $19184f195625c89b$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
function $19184f195625c89b$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $19184f195625c89b$var$ROOT_TOKEN
        ]
    ];
    if (!(0, $629d80bbf56b9c6a$export$dda1d9f60106f0e9)(path)) throw new Error('Invalid path "'.concat(path, '"'));
    function crash(message) {
        throw new Error("ERR (".concat(state, ')/"').concat(buffer, '": ').concat(message));
    }
    var state = 0;
    var previousState = state;
    var tokens = [];
    var segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    var i = 0;
    var char;
    var buffer = "";
    var customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === 0) segment.push({
            type: 0,
            value: buffer
        });
        else if (state === 1 || state === 2 || state === 3) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash("A repeatable param (".concat(buffer, ") must be alone in its segment. eg: '/:ids+."));
            segment.push({
                type: 1,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        switch(state){
            case 0:
                if (char === "\\") {
                    previousState = state;
                    state = 4;
                } else if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = 1;
                } else addCharToBuffer();
                break;
            case 4:
                addCharToBuffer();
                state = previousState;
                break;
            case 1:
                if (char === "(") state = 2;
                else if ($19184f195625c89b$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = 0;
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case 2:
                if (char === ")") {
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = 3;
                } else customRe += char;
                break;
            case 3:
                consumeBuffer();
                state = 0;
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
        }
    }
    if (state === 2) crash('Unfinished custom RegExp for param "'.concat(buffer, '"'));
    consumeBuffer();
    finalizeSegment();
    return tokens;
}
//#endregion
//#region src/matcher/pathParserRanker.ts
var $19184f195625c89b$var$BASE_PARAM_PATTERN = "[^/]+?";
var $19184f195625c89b$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
var $19184f195625c89b$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
* Creates a path parser from an array of Segments (a segment is an array of Tokens)
*
* @param segments - array of segments returned by tokenizePath
* @param extraOptions - optional options for the regexp
* @returns a PathParser
*/ function $19184f195625c89b$var$tokensToParser(segments, extraOptions) {
    var options = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, $19184f195625c89b$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    var score = [];
    var pattern = options.start ? "^" : "";
    var keys = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var segment = _step.value;
            var segmentScores = segment.length ? [] : [
                90
            ];
            if (options.strict && !segment.length) pattern += "/";
            for(var tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
                var token = segment[tokenIndex];
                var subSegmentScore = 40 + (options.sensitive ? .25 : 0);
                if (token.type === 0) {
                    if (!tokenIndex) pattern += "/";
                    pattern += token.value.replace($19184f195625c89b$var$REGEX_CHARS_RE, "\\$&");
                    subSegmentScore += 40;
                } else if (token.type === 1) {
                    var value = token.value, repeatable = token.repeatable, optional = token.optional, regexp = token.regexp;
                    keys.push({
                        name: value,
                        repeatable: repeatable,
                        optional: optional
                    });
                    var re = regexp ? regexp : $19184f195625c89b$var$BASE_PARAM_PATTERN;
                    if (re !== $19184f195625c89b$var$BASE_PARAM_PATTERN) {
                        subSegmentScore += 10;
                        try {
                            new RegExp("(".concat(re, ")"));
                        } catch (err) {
                            throw new Error('Invalid custom RegExp for param "'.concat(value, '" (').concat(re, "): ") + err.message);
                        }
                    }
                    var subPattern = repeatable ? "((?:".concat(re, ")(?:/(?:").concat(re, "))*)") : "(".concat(re, ")");
                    if (!tokenIndex) subPattern = optional && segment.length < 2 ? "(?:/".concat(subPattern, ")") : "/" + subPattern;
                    if (optional) subPattern += "?";
                    pattern += subPattern;
                    subSegmentScore += 20;
                    if (optional) subSegmentScore += -8;
                    if (repeatable) subSegmentScore += -20;
                    if (re === ".*") subSegmentScore += -50;
                }
                segmentScores.push(subSegmentScore);
            }
            score.push(segmentScores);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (options.strict && options.end) {
        var i = score.length - 1;
        score[i][score[i].length - 1] += .7000000000000001;
    }
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict && !pattern.endsWith("/")) pattern += "(?:/|$)";
    var re1 = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        var match = path.match(re1);
        var params = {};
        if (!match) return null;
        for(var i = 1; i < match.length; i++){
            var value = match[i] || "";
            var key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        var path = "";
        var avoidDuplicatedSlash = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var segment = _step.value;
                if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
                avoidDuplicatedSlash = false;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = segment[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var token = _step1.value;
                        if (token.type === 0) path += token.value;
                        else if (token.type === 1) {
                            var value = token.value, repeatable = token.repeatable, optional = token.optional;
                            var param = value in params ? params[value] : "";
                            if ((0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(param) && !repeatable) throw new Error('Provided param "'.concat(value, '" is an array but it is not repeatable (* or + modifiers)'));
                            var text = (0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(param) ? param.join("/") : param;
                            if (!text) {
                                if (optional) {
                                    if (segment.length < 2) {
                                        if (path.endsWith("/")) path = path.slice(0, -1);
                                        else avoidDuplicatedSlash = true;
                                    }
                                } else throw new Error('Missing required param "'.concat(value, '"'));
                            }
                            path += text;
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return path || "/";
    }
    return {
        re: re1,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
* Compares an array of numbers as used in PathParser.score and returns a
* number. This function can be used to `sort` an array
*
* @param a - first array of numbers
* @param b - second array of numbers
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
* should be sorted first
*/ function $19184f195625c89b$var$compareScoreArray(a, b) {
    var i = 0;
    while(i < a.length && i < b.length){
        var diff = b[i] - a[i];
        if (diff) return diff;
        i++;
    }
    if (a.length < b.length) return a.length === 1 && a[0] === 80 ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === 80 ? 1 : -1;
    return 0;
}
/**
* Compare function that can be used with `sort` to sort an array of PathParser
*
* @param a - first PathParser
* @param b - second PathParser
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
*/ function $19184f195625c89b$var$comparePathParserScore(a, b) {
    var i = 0;
    var aScore = a.score;
    var bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        var comp = $19184f195625c89b$var$compareScoreArray(aScore[i], bScore[i]);
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($19184f195625c89b$var$isLastScoreNegative(aScore)) return 1;
        if ($19184f195625c89b$var$isLastScoreNegative(bScore)) return -1;
    }
    return bScore.length - aScore.length;
}
/**
* This allows detecting splats at the end of a path: /home/:id(.*)*
*
* @param score - score to check
* @returns true if the last entry is negative
*/ function $19184f195625c89b$var$isLastScoreNegative(score) {
    var last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
var $19184f195625c89b$var$PATH_PARSER_OPTIONS_DEFAULTS = {
    strict: false,
    end: true,
    sensitive: false
};
//#endregion
//#region src/matcher/pathMatcher.ts
function $19184f195625c89b$var$createRouteRecordMatcher(record, parent, options) {
    var parser = $19184f195625c89b$var$tokensToParser($19184f195625c89b$var$tokenizePath(record.path), options);
    var matcher = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)(parser, {
        record: record,
        parent: parent,
        children: [],
        alias: []
    });
    if (parent) {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
//#endregion
//#region src/matcher/index.ts
/**
* Creates a Router Matcher.
*
* @internal
* @param routes - array of initial routes
* @param globalOptions - global route options
*/ function $19184f195625c89b$export$36302c85fdcc95a8(routes, globalOptions) {
    var matchers = [];
    var matcherMap = /* @__PURE__ */ new Map();
    globalOptions = (0, $629d80bbf56b9c6a$export$4a5767248b18ef41)($19184f195625c89b$var$PATH_PARSER_OPTIONS_DEFAULTS, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        var isRootAdd = !originalRecord;
        var mainNormalizedRecord = $19184f195625c89b$var$normalizeRouteRecord(record);
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        var options = (0, $629d80bbf56b9c6a$export$4a5767248b18ef41)(globalOptions, record);
        var normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            var aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = aliases[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var alias = _step.value;
                    normalizedRecords.push($19184f195625c89b$var$normalizeRouteRecord((0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, mainNormalizedRecord, {
                        components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                        path: alias,
                        aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
                    })));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var matcher;
        var originalMatcher;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = normalizedRecords[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var normalizedRecord = _step1.value;
                var path = normalizedRecord.path;
                if (parent && !(0, $629d80bbf56b9c6a$export$dda1d9f60106f0e9)(path)) {
                    var parentPath = parent.record.path;
                    var connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                    normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
                }
                matcher = $19184f195625c89b$var$createRouteRecordMatcher(normalizedRecord, parent, options);
                if (originalRecord) originalRecord.alias.push(matcher);
                else {
                    originalMatcher = originalMatcher || matcher;
                    if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                    if (isRootAdd && record.name && !$19184f195625c89b$var$isAliasRecord(matcher)) removeRoute(record.name);
                }
                if ($19184f195625c89b$var$isMatchable(matcher)) insertMatcher(matcher);
                if (mainNormalizedRecord.children) {
                    var children = mainNormalizedRecord.children;
                    for(var i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
                }
                originalRecord = originalRecord || matcher;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return originalMatcher ? function() {
            removeRoute(originalMatcher);
        } : (0, $629d80bbf56b9c6a$export$8b22cf2602fb60ce);
    }
    function removeRoute(matcherRef) {
        if ((0, $2d3a1f98237b4166$export$ffb5f4729a158638)(matcherRef)) {
            var matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            var index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        var index = $19184f195625c89b$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        if (matcher.record.name && !$19184f195625c89b$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location1, currentLocation) {
        var matcher;
        var params = {};
        var path;
        var name;
        if ("name" in location1 && location1.name) {
            matcher = matcherMap.get(location1.name);
            if (!matcher) throw (0, $629d80bbf56b9c6a$export$3b14a55fb2447963)(1, {
                location: location1
            });
            name = matcher.record.name;
            params = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)($19184f195625c89b$var$pickParams(currentLocation.params, matcher.keys.filter(function(k) {
                return !k.optional;
            }).concat(matcher.parent ? matcher.parent.keys.filter(function(k) {
                return k.optional;
            }) : []).map(function(k) {
                return k.name;
            })), location1.params && $19184f195625c89b$var$pickParams(location1.params, matcher.keys.map(function(k) {
                return k.name;
            })));
            path = matcher.stringify(params);
        } else if (location1.path != null) {
            path = location1.path;
            matcher = matchers.find(function(m) {
                return m.re.test(path);
            });
            if (matcher) {
                params = matcher.parse(path);
                name = matcher.record.name;
                matcher.keys.forEach(function(key) {
                    if (key.optional && !params[key.name]) delete params[key.name];
                });
            }
        } else {
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find(function(m) {
                return m.re.test(currentLocation.path);
            });
            if (!matcher) throw (0, $629d80bbf56b9c6a$export$3b14a55fb2447963)(1, {
                location: location1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            params = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, currentLocation.params, location1.params);
            path = matcher.stringify(params);
        }
        var matched = [];
        var parentMatcher = matcher;
        while(parentMatcher){
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $19184f195625c89b$var$mergeMetaFields(matched)
        };
    }
    routes.forEach(function(route) {
        return addRoute(route);
    });
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
/**
* Picks an object param to contain only specified keys.
*
* @param params - params object to pick from
* @param keys - keys to pick
*/ function $19184f195625c89b$var$pickParams(params, keys) {
    var newParams = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key in params) newParams[key] = params[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return newParams;
}
/**
* Normalizes a RouteRecordRaw. Creates a copy
*
* @param record
* @returns the normalized version
*/ function $19184f195625c89b$var$normalizeRouteRecord(record) {
    var normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $19184f195625c89b$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: /* @__PURE__ */ new Set(),
        updateGuards: /* @__PURE__ */ new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
* Normalize the optional `props` in a record to always be an object similar to
* components. Also accept a boolean for components.
* @param record
*/ function $19184f195625c89b$var$normalizeRecordProps(record) {
    var propsObject = {};
    var props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else for(var name in record.components)propsObject[name] = (typeof props === "undefined" ? "undefined" : (0, $7E0eS._)(props)) === "object" ? props[name] : props;
    return propsObject;
}
/**
* Checks if a record or any of its parent is an alias
* @param record
*/ function $19184f195625c89b$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
* Merge meta fields of an array of records
*
* @param matched - array of matched records
*/ function $19184f195625c89b$var$mergeMetaFields(matched) {
    return matched.reduce(function(meta, record) {
        return (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)(meta, record.meta);
    }, {});
}
function $19184f195625c89b$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
* Check if a path and its alias have the same required params
*
* @param a - original record
* @param b - alias record
*/ function $19184f195625c89b$var$checkSameParams(a, b) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = a.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!key.optional && !b.keys.find($19184f195625c89b$var$isSameParam.bind(null, key))) {
                (0, $629d80bbf56b9c6a$export$db3b6bfb95261072).VUE_ROUTER_R0102({
                    alias: b.record.path,
                    original: a.record.path,
                    name: key.name
                });
                return;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = b.keys[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var key1 = _step1.value;
            if (!key1.optional && !a.keys.find($19184f195625c89b$var$isSameParam.bind(null, key1))) {
                (0, $629d80bbf56b9c6a$export$db3b6bfb95261072).VUE_ROUTER_R0102({
                    alias: b.record.path,
                    original: a.record.path,
                    name: key1.name
                });
                return;
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
/**
* A route with a name and a child with an empty path without a name should warn when adding the route
*
* @param mainNormalizedRecord - RouteRecordNormalized
* @param parent - RouteRecordMatcher
*/ function $19184f195625c89b$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path && mainNormalizedRecord.children.length === 0) (0, $629d80bbf56b9c6a$export$db3b6bfb95261072).VUE_ROUTER_R0103({
        name: String(parent.record.name)
    });
}
function $19184f195625c89b$var$checkSameNameAsAncestor(record, parent) {
    for(var ancestor = parent; ancestor; ancestor = ancestor.parent)if (ancestor.record.name === record.name) throw new Error('A route named "'.concat(String(record.name), '" has been added as a ').concat(parent === ancestor ? "child" : "descendant", " of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor."));
}
function $19184f195625c89b$var$checkMissingParamsInAbsolutePath(record, parent) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parent.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!record.keys.find($19184f195625c89b$var$isSameParam.bind(null, key))) {
                (0, $629d80bbf56b9c6a$export$db3b6bfb95261072).VUE_ROUTER_R0104({
                    path: record.record.path,
                    name: key.name,
                    parent: parent.record.path
                });
                return;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
* Performs a binary search to find the correct insertion index for a new matcher.
*
* Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
* with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
*
* @param matcher - new matcher to be inserted
* @param matchers - existing matchers
*/ function $19184f195625c89b$var$findInsertionIndex(matcher, matchers) {
    var lower = 0;
    var upper = matchers.length;
    while(lower !== upper){
        var mid = lower + upper >> 1;
        if ($19184f195625c89b$var$comparePathParserScore(matcher, matchers[mid]) < 0) upper = mid;
        else lower = mid + 1;
    }
    var insertionAncestor = $19184f195625c89b$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $19184f195625c89b$var$getInsertionAncestor(matcher) {
    var ancestor = matcher;
    while(ancestor = ancestor.parent)if ($19184f195625c89b$var$isMatchable(ancestor) && $19184f195625c89b$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
}
/**
* Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
* a component, or name, or redirect, are just used to group other routes.
* @param matcher
* @param matcher.record record of the matcher
* @returns
*/ function $19184f195625c89b$var$isMatchable(param) {
    var record = param.record;
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
//#endregion
//#region src/RouterLink.ts
/**
* Returns the internal behavior of a {@link RouterLink} without the rendering part.
*
* @param props - a `to` location and an optional `replace` flag
*/ function $19184f195625c89b$export$dcf14c9974fe2767(props) {
    var router = (0, $fKAHx.inject)((0, $629d80bbf56b9c6a$export$407448d2b89b1813));
    var currentRoute = (0, $fKAHx.inject)((0, $629d80bbf56b9c6a$export$23f2a1d2818174ef));
    var hasPrevious = false;
    var previousTo = null;
    var route = (0, $fKAHx.computed)(function() {
        var to = (0, $ftLbb.unref)(props.to);
        return router.resolve(to);
    });
    var activeRecordIndex = (0, $fKAHx.computed)(function() {
        var matched = route.value.matched;
        var length = matched.length;
        var routeMatched = matched[length - 1];
        var currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        var index = currentMatched.findIndex((0, $2d3a1f98237b4166$export$971d5caa766a69d7).bind(null, routeMatched));
        if (index > -1) return index;
        var parentRecordPath = $19184f195625c89b$var$getOriginalPath(matched[length - 2]);
        return length > 1 && $19184f195625c89b$var$getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex((0, $2d3a1f98237b4166$export$971d5caa766a69d7).bind(null, matched[length - 2])) : index;
    });
    var isActive = (0, $fKAHx.computed)(function() {
        return activeRecordIndex.value > -1 && $19184f195625c89b$var$includesParams(currentRoute.params, route.value.params);
    });
    var isExactActive = (0, $fKAHx.computed)(function() {
        return activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && (0, $2d3a1f98237b4166$export$efccba1c4a2ef57b)(currentRoute.params, route.value.params);
    });
    function navigate() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if ($19184f195625c89b$var$guardEvent(e)) {
            var p = router[(0, $ftLbb.unref)(props.replace) ? "replace" : "push"]((0, $ftLbb.unref)(props.to)).catch((0, $629d80bbf56b9c6a$export$8b22cf2602fb60ce));
            if (props.viewTransition && typeof document !== "undefined" && "startViewTransition" in document) document.startViewTransition(function() {
                return p;
            });
            return p;
        }
        return Promise.resolve();
    }
    if (__VUE_PROD_DEVTOOLS__ && (0, $2d3a1f98237b4166$export$d66501df72047452)) {
        var instance = (0, $fKAHx.getCurrentInstance)();
        if (instance) {
            var linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $fKAHx.watchEffect)(function() {
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = (0, $2d3a1f98237b4166$export$2d1720544b23b823)((0, $ftLbb.unref)(props.to)) ? null : "Invalid \"to\" value";
            }, {
                flush: "post"
            });
        }
    }
    /**
	* NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
	*/ return {
        route: route,
        href: (0, $fKAHx.computed)(function() {
            return route.value.href;
        }),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $19184f195625c89b$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
/**
* Component to render a link that triggers a navigation on click.
*/ var $19184f195625c89b$export$fce709ebdac448ed = /* @__PURE__ */ (0, $fKAHx.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        },
        viewTransition: Boolean
    },
    useLink: $19184f195625c89b$export$dcf14c9974fe2767,
    setup: function(props, param) {
        var slots = param.slots;
        var link = (0, $ftLbb.reactive)($19184f195625c89b$export$dcf14c9974fe2767(props));
        var options = (0, $fKAHx.inject)((0, $629d80bbf56b9c6a$export$407448d2b89b1813)).options;
        var elClass = (0, $fKAHx.computed)(function() {
            var _obj;
            return _obj = {}, (0, $7Pjls._)(_obj, $19184f195625c89b$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active"), link.isActive), (0, $7Pjls._)(_obj, $19184f195625c89b$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active"), link.isExactActive), _obj;
        });
        return function() {
            var children = slots.default && $19184f195625c89b$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $fKAHx.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
function $19184f195625c89b$var$guardEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;
    if (e.button !== void 0 && e.button !== 0) return;
    if (e.currentTarget && e.currentTarget.getAttribute) {
        var target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $19184f195625c89b$var$includesParams(outer, inner) {
    var _loop = function(key) {
        var innerValue = inner[key];
        var outerValue = outer[key];
        if ((0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(innerValue)) {
            if (!(0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(outerValue) || outerValue.length !== innerValue.length || innerValue.some(function(value, i) {
                return value.valueOf() !== outerValue[i].valueOf();
            })) return {
                v: false
            };
        } else if (innerValue !== outerValue) return {
            v: false
        };
    };
    for(var key in inner){
        var _ret = _loop(key);
        if ((0, $7E0eS._)(_ret) === "object") return _ret.v;
    }
    return true;
}
/**
* Get the original path value of a record by following its aliasOf
* @param record
*/ function $19184f195625c89b$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
* Utility class to get the active class based on defaults.
* @param propClass
* @param globalClass
* @param defaultClass
*/ var $19184f195625c89b$var$getLinkClass = function(propClass, globalClass, defaultClass) {
    return propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
};
//#endregion
//#region src/RouterView.ts
var $19184f195625c89b$var$RouterViewImpl = /*#__PURE__*/ (0, $fKAHx.defineComponent)({
    name: "RouterView",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    compatConfig: {
        MODE: 3
    },
    setup: function(props, param) {
        var attrs = param.attrs, slots = param.slots;
        var injectedRoute = (0, $fKAHx.inject)((0, $629d80bbf56b9c6a$export$ae1af26003f05816));
        var routeToDisplay = (0, $fKAHx.computed)(function() {
            return props.route || injectedRoute.value;
        });
        var injectedDepth = (0, $fKAHx.inject)((0, $629d80bbf56b9c6a$export$2408f22a0fab9ae5), 0);
        var depth = (0, $fKAHx.computed)(function() {
            var initialDepth = (0, $ftLbb.unref)(injectedDepth);
            var matched = routeToDisplay.value.matched;
            var matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        var matchedRouteRef = (0, $fKAHx.computed)(function() {
            return routeToDisplay.value.matched[depth.value];
        });
        (0, $fKAHx.provide)((0, $629d80bbf56b9c6a$export$2408f22a0fab9ae5), (0, $fKAHx.computed)(function() {
            return depth.value + 1;
        }));
        (0, $fKAHx.provide)((0, $629d80bbf56b9c6a$export$43caf9889c228507), matchedRouteRef);
        (0, $fKAHx.provide)((0, $629d80bbf56b9c6a$export$ae1af26003f05816), routeToDisplay);
        var viewRef = (0, $ftLbb.ref)();
        (0, $fKAHx.watch)(function() {
            return [
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ];
        }, function(param, param1) {
            var _param = (0, $f9AOD._)(param, 3), instance = _param[0], to = _param[1], name = _param[2], _param1 = (0, $f9AOD._)(param1, 3), oldInstance = _param1[0], from = _param1[1], _oldName = _param1[2];
            if (to) {
                to.instances[name] = instance;
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            if (instance && to && (!from || !(0, $2d3a1f98237b4166$export$971d5caa766a69d7)(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach(function(callback) {
                return callback(instance);
            });
        }, {
            flush: "post"
        });
        return function() {
            var route = routeToDisplay.value;
            var currentName = props.name;
            var matchedRoute = matchedRouteRef.value;
            var ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $19184f195625c89b$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            var routePropsOption = matchedRoute.props[currentName];
            var routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            var onVnodeUnmounted = function(vnode) {
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            var component = (0, $fKAHx.h)(ViewComponent, (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && (0, $2d3a1f98237b4166$export$d66501df72047452) && component.ref) {
                var info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                ((0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(component.ref) ? component.ref.map(function(r) {
                    return r.i;
                }) : [
                    component.ref.i
                ]).forEach(function(instance) {
                    if (instance) instance.__vrv_devtools = info;
                });
            }
            return $19184f195625c89b$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component;
        };
    }
});
function $19184f195625c89b$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    var slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
/**
* Component to display the current route the user is at.
*/ var $19184f195625c89b$export$d941f00e9b9a537 = $19184f195625c89b$var$RouterViewImpl;
function $19184f195625c89b$var$warnDeprecatedUsage() {
    var instance = (0, $fKAHx.getCurrentInstance)();
    var parentName = instance.parent && instance.parent.type.name;
    var parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && (typeof parentSubTreeType === "undefined" ? "undefined" : (0, $7E0eS._)(parentSubTreeType)) === "object" && parentSubTreeType.name === "RouterView") {
        var comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        (0, $629d80bbf56b9c6a$export$db3b6bfb95261072).VUE_ROUTER_R0060({
            comp: comp
        });
    }
}
//#endregion
//#region src/router.ts
/**
* Creates a Router instance that can be used by a Vue app.
*
* @param options - {@link RouterOptions}
*/ function $19184f195625c89b$export$baddd0131ee8c05b(options) {
    var matcher = $19184f195625c89b$export$36302c85fdcc95a8(options.routes, options);
    var parseQuery$1 = options.parseQuery || (0, $2d3a1f98237b4166$export$3b14a55fb2447963);
    var stringifyQuery$1 = options.stringifyQuery || (0, $2d3a1f98237b4166$export$4368d992c4eafac0);
    var routerHistory = options.history;
    var beforeGuards = (0, $2d3a1f98237b4166$export$db3b6bfb95261072)();
    var beforeResolveGuards = (0, $2d3a1f98237b4166$export$db3b6bfb95261072)();
    var afterGuards = (0, $2d3a1f98237b4166$export$db3b6bfb95261072)();
    var currentRoute = (0, $ftLbb.shallowRef)((0, $2d3a1f98237b4166$export$25ce5a424b770e84));
    var routesVersion = (0, $ftLbb.shallowRef)(0);
    var pendingLocation = (0, $2d3a1f98237b4166$export$25ce5a424b770e84);
    if ((0, $2d3a1f98237b4166$export$d66501df72047452) && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    var normalizeParams = (0, $629d80bbf56b9c6a$export$2d1720544b23b823).bind(null, function(paramValue) {
        return "" + paramValue;
    });
    var encodeParams = (0, $629d80bbf56b9c6a$export$2d1720544b23b823).bind(null, (0, $2d3a1f98237b4166$export$a07804094c3ecf2d));
    var decodeParams = (0, $629d80bbf56b9c6a$export$2d1720544b23b823).bind(null, (0, $2d3a1f98237b4166$export$35e795649ee09318));
    function addRoute(parentOrRoute, route) {
        var parent;
        var record;
        if ((0, $2d3a1f98237b4166$export$ffb5f4729a158638)(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        var _$removeRoute = matcher.addRoute(record, parent);
        routesVersion.value++;
        return function() {
            _$removeRoute();
            routesVersion.value++;
        };
    }
    function removeRoute(name) {
        var recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) {
            matcher.removeRoute(recordMatcher);
            routesVersion.value++;
        }
    }
    function clearRoutes() {
        matcher.clearRoutes();
        routesVersion.value++;
    }
    function getRoutes() {
        return matcher.getRoutes().map(function(routeMatcher) {
            return routeMatcher.record;
        });
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        routesVersion.value;
        if (typeof rawLocation === "string") {
            currentLocation = currentLocation || (rawLocation.startsWith("/") ? (0, $2d3a1f98237b4166$export$25ce5a424b770e84) : currentRoute.value);
            var locationNormalized = (0, $2d3a1f98237b4166$export$a9c23c6ac3fc3eca)(parseQuery$1, rawLocation, currentLocation.path);
            var matchedRoute = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            var href = routerHistory.createHref(locationNormalized.fullPath);
            return (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)(locationNormalized, matchedRoute, {
                params: decodeParams(matchedRoute.params),
                redirectedFrom: void 0,
                href: href
            });
        }
        currentLocation = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, currentLocation || (rawLocation.path != null && rawLocation.path.startsWith("/") && !("name" in rawLocation && rawLocation.name) ? (0, $2d3a1f98237b4166$export$25ce5a424b770e84) : currentRoute.value));
        var matcherLocation;
        if (rawLocation.path != null) matcherLocation = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, rawLocation, {
            path: (0, $2d3a1f98237b4166$export$a9c23c6ac3fc3eca)(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            var targetParams = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, rawLocation.params);
            for(var key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            matcherLocation = (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            currentLocation.params = encodeParams(currentLocation.params);
        }
        var matchedRoute1 = matcher.resolve(matcherLocation, currentLocation);
        var hash = rawLocation.hash || "";
        matchedRoute1.params = normalizeParams(decodeParams(matchedRoute1.params));
        var fullPath = (0, $2d3a1f98237b4166$export$c4ce752e73470fba)(stringifyQuery$1, (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, rawLocation, {
            hash: (0, $2d3a1f98237b4166$export$3a1a48c8f6ef640e)(hash),
            path: matchedRoute1.path
        }));
        var href1 = routerHistory.createHref(fullPath);
        return (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({
            fullPath: fullPath,
            hash: hash,
            query: stringifyQuery$1 === (0, $2d3a1f98237b4166$export$4368d992c4eafac0) ? (0, $2d3a1f98237b4166$export$882b5998b3b9117c)(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute1, {
            redirectedFrom: void 0,
            href: href1
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? (0, $2d3a1f98237b4166$export$a9c23c6ac3fc3eca)(parseQuery$1, to, currentRoute.value.path) : (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return (0, $629d80bbf56b9c6a$export$3b14a55fb2447963)(8, {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push((0, $629d80bbf56b9c6a$export$ffb5f4729a158638)(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to, from) {
        var lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            var redirect = lastMatched.redirect;
            var newTargetLocation = typeof redirect === "function" ? redirect(to, from) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                newTargetLocation.params = {};
            }
            return (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({
                query: to.query,
                hash: to.hash,
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        var targetLocation = pendingLocation = resolve(to);
        var from = currentRoute.value;
        var data = to.state;
        var force = to.force;
        var _$replace = to.replace === true;
        var shouldRedirect = handleRedirectRecord(targetLocation, from);
        if (shouldRedirect) return pushWithRedirect((0, $629d80bbf56b9c6a$export$ffb5f4729a158638)(locationAsObject(shouldRedirect), {
            state: (typeof shouldRedirect === "undefined" ? "undefined" : (0, $7E0eS._)(shouldRedirect)) === "object" ? (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, data, shouldRedirect.state) : data,
            force: force,
            replace: _$replace
        }), redirectedFrom || targetLocation);
        var toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        var failure;
        if (!force && (0, $2d3a1f98237b4166$export$e7094788287c5e9b)(stringifyQuery$1, from, targetLocation)) {
            failure = (0, $629d80bbf56b9c6a$export$3b14a55fb2447963)(16, {
                to: toLocation,
                from: from
            });
            handleScroll(from, from, true, false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch(function(error) {
            return (0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(error) ? (0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(error, 2) ? error : markAsReady(error) : triggerError(error, toLocation, from);
        }).then(function(failure) {
            if (failure) {
                if ((0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(failure, 2)) return pushWithRedirect((0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({
                    replace: _$replace
                }, locationAsObject(failure.to), {
                    state: (0, $7E0eS._)(failure.to) === "object" ? (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({}, data, failure.to.state) : data,
                    force: force
                }), redirectedFrom || toLocation);
            } else failure = finalizeNavigation(toLocation, from, true, _$replace, data);
            triggerAfterEach(toLocation, from, failure);
            return failure;
        });
    }
    /**
	* Helper to reject and skip all navigation guards if a new navigation happened
	* @param to
	* @param from
	*/ function checkCanceledNavigationAndReject(to, from) {
        var error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        var app = installedApps.values().next().value;
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    function navigate(to, from) {
        var guards;
        var _extractChangingRecords = (0, $f9AOD._)((0, $2d3a1f98237b4166$export$7ccc53e8f1e7dfc5)(to, from), 3), leavingRecords = _extractChangingRecords[0], updatingRecords = _extractChangingRecords[1], enteringRecords = _extractChangingRecords[2];
        guards = (0, $2d3a1f98237b4166$export$43caf9889c228507)(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = leavingRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var record = _step.value;
                record.leaveGuards.forEach(function(guard) {
                    guards.push((0, $2d3a1f98237b4166$export$23f2a1d2818174ef)(guard, to, from));
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        return runGuardQueue(guards).then(function() {
            guards = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = beforeGuards.list()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var guard = _step.value;
                    guards.push((0, $2d3a1f98237b4166$export$23f2a1d2818174ef)(guard, to, from));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(function() {
            guards = (0, $2d3a1f98237b4166$export$43caf9889c228507)(updatingRecords, "beforeRouteUpdate", to, from);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = updatingRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var record = _step.value;
                    record.updateGuards.forEach(function(guard) {
                        guards.push((0, $2d3a1f98237b4166$export$23f2a1d2818174ef)(guard, to, from));
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(function() {
            guards = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = enteringRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var record = _step.value;
                    if (record.beforeEnter) {
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if ((0, $629d80bbf56b9c6a$export$39b482c5e57630a8)(record.beforeEnter)) try {
                            for(var _iterator1 = record.beforeEnter[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var beforeEnter = _step1.value;
                                guards.push((0, $2d3a1f98237b4166$export$23f2a1d2818174ef)(beforeEnter, to, from));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        else guards.push((0, $2d3a1f98237b4166$export$23f2a1d2818174ef)(record.beforeEnter, to, from));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(function() {
            to.matched.forEach(function(record) {
                return record.enterCallbacks = {};
            });
            guards = (0, $2d3a1f98237b4166$export$43caf9889c228507)(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(function() {
            guards = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = beforeResolveGuards.list()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var guard = _step.value;
                    guards.push((0, $2d3a1f98237b4166$export$23f2a1d2818174ef)(guard, to, from));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).catch(function(err) {
            return (0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(err, 8) ? err : Promise.reject(err);
        });
    }
    function triggerAfterEach(to, from, failure) {
        afterGuards.list().forEach(function(guard) {
            return runWithContext(function() {
                return guard(to, from, failure);
            });
        });
    }
    /**
	* - Cleans up any navigation guards
	* - Changes the url if necessary
	* - Calls the scrollBehavior
	*/ function finalizeNavigation(toLocation, from, isPush, replace, data) {
        var error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        var isFirstNavigation = from === (0, $2d3a1f98237b4166$export$25ce5a424b770e84);
        var state = !(0, $2d3a1f98237b4166$export$d66501df72047452) ? {} : history.state;
        if (isPush) {
            if (replace || isFirstNavigation) routerHistory.replace(toLocation.fullPath, (0, $629d80bbf56b9c6a$export$ffb5f4729a158638)({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    var removeHistoryListener;
    function setupListeners() {
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen(function(to, _from, info) {
            if (!router.listening) return;
            var toLocation = resolve(to);
            var shouldRedirect = handleRedirectRecord(toLocation, router.currentRoute.value);
            if (shouldRedirect) {
                pushWithRedirect((0, $629d80bbf56b9c6a$export$ffb5f4729a158638)(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch((0, $629d80bbf56b9c6a$export$8b22cf2602fb60ce));
                return;
            }
            pendingLocation = toLocation;
            var from = currentRoute.value;
            if ((0, $2d3a1f98237b4166$export$d66501df72047452) && info.delta) (0, $2d3a1f98237b4166$export$71511d61b312f219)((0, $2d3a1f98237b4166$export$39b482c5e57630a8)(from.fullPath, info.delta));
            navigate(toLocation, from).catch(function(error) {
                if ((0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(error, 12)) return error;
                if ((0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(error, 2)) {
                    pushWithRedirect((0, $629d80bbf56b9c6a$export$ffb5f4729a158638)(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then(function(failure) {
                        if ((0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(failure, 20) && !info.delta && info.type === "pop") routerHistory.go(-1, false);
                    }).catch((0, $629d80bbf56b9c6a$export$8b22cf2602fb60ce));
                    return Promise.reject();
                }
                if (info.delta) routerHistory.go(-info.delta, false);
                return triggerError(error, toLocation, from);
            }).then(function(failure) {
                failure = failure || finalizeNavigation(toLocation, from, false);
                if (failure) {
                    if (info.delta && !(0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(failure, 8)) routerHistory.go(-info.delta, false);
                    else if (info.type === "pop" && (0, $629d80bbf56b9c6a$export$4368d992c4eafac0)(failure, 20)) routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch((0, $629d80bbf56b9c6a$export$8b22cf2602fb60ce));
        });
    }
    var readyHandlers = (0, $2d3a1f98237b4166$export$db3b6bfb95261072)();
    var errorListeners = (0, $2d3a1f98237b4166$export$db3b6bfb95261072)();
    var ready;
    /**
	* Trigger errorListeners added via onError and throws the error as well
	*
	* @param error - error to throw
	* @param to - location we were navigating to when the error happened
	* @param from - location we were navigating from when the error happened
	* @returns the error as a rejected promise
	*/ function triggerError(error, to, from) {
        markAsReady(error);
        var list = errorListeners.list();
        if (list.length) list.forEach(function(handler) {
            return handler(error, to, from);
        });
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== (0, $2d3a1f98237b4166$export$25ce5a424b770e84)) return Promise.resolve();
        return new Promise(function(resolve, reject) {
            readyHandlers.add([
                resolve,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(function(param) {
                var _param = (0, $f9AOD._)(param, 2), _$resolve = _param[0], reject = _param[1];
                return err ? reject(err) : _$resolve();
            });
            readyHandlers.reset();
        }
        return err;
    }
    function handleScroll(to, from, isPush, isFirstNavigation) {
        var scrollBehavior = options.scrollBehavior;
        if (!(0, $2d3a1f98237b4166$export$d66501df72047452) || !scrollBehavior) return Promise.resolve();
        var scrollPosition = !isPush && (0, $2d3a1f98237b4166$export$dda1d9f60106f0e9)((0, $2d3a1f98237b4166$export$39b482c5e57630a8)(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $fKAHx.nextTick)().then(function() {
            return scrollBehavior(to, from, scrollPosition);
        }).then(function(position) {
            return to === currentRoute.value && position && (0, $2d3a1f98237b4166$export$90a7f3efeed30595)(position);
        }).catch(function(err) {
            return to === currentRoute.value && triggerError(err, to, from);
        });
    }
    var go = function(delta) {
        return routerHistory.go(delta);
    };
    var started;
    var installedApps = /* @__PURE__ */ new Set();
    var router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: function() {
            return go(-1);
        },
        forward: function() {
            return go(1);
        },
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install: function(app) {
            var _loop = function(key) {
                Object.defineProperty(reactiveRoute, key, {
                    get: function() {
                        return currentRoute.value[key];
                    },
                    enumerable: true
                });
            };
            app.component("RouterLink", $19184f195625c89b$export$fce709ebdac448ed);
            app.component("RouterView", $19184f195625c89b$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: function() {
                    return (0, $ftLbb.unref)(currentRoute);
                }
            });
            if ((0, $2d3a1f98237b4166$export$d66501df72047452) && !started && currentRoute.value === (0, $2d3a1f98237b4166$export$25ce5a424b770e84)) {
                started = true;
                push(routerHistory.location).catch(function(err) {});
            }
            var reactiveRoute = {};
            for(var key in 0, $2d3a1f98237b4166$export$25ce5a424b770e84)_loop(key);
            app.provide((0, $629d80bbf56b9c6a$export$407448d2b89b1813), router);
            app.provide((0, $629d80bbf56b9c6a$export$23f2a1d2818174ef), (0, $ftLbb.shallowReactive)(reactiveRoute));
            app.provide((0, $629d80bbf56b9c6a$export$ae1af26003f05816), currentRoute);
            var unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                if (installedApps.size < 1) {
                    pendingLocation = (0, $2d3a1f98237b4166$export$25ce5a424b770e84);
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = (0, $2d3a1f98237b4166$export$25ce5a424b770e84);
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && (0, $2d3a1f98237b4166$export$d66501df72047452) && true) (0, $2d3a1f98237b4166$export$625550452a3fa3ec)(app, router, matcher);
        }
    };
    function runGuardQueue(guards) {
        return guards.reduce(function(promise, guard) {
            return promise.then(function() {
                return runWithContext(guard);
            });
        }, Promise.resolve());
    }
    return router;
}


parcelRequire("65S8r");
var $as4kI = parcelRequire("as4kI");

var $7qXGD = parcelRequire("7qXGD");

var $173N4 = parcelRequire("173N4");

var $cFHGC = parcelRequire("cFHGC");

var $7Pjls = parcelRequire("7Pjls");

var $hdIku = parcelRequire("hdIku");

var $f9AOD = parcelRequire("f9AOD");

var $7E0eS = parcelRequire("7E0eS");
parcelRequire("jBjHf");
var $fTAJe = parcelRequire("fTAJe");
var $hbwBq = parcelRequire("hbwBq");
var $1oPot = parcelRequire("1oPot");
var $8uJ7j = parcelRequire("8uJ7j");
parcelRequire("65S8r");
var $as4kI = parcelRequire("as4kI");
parcelRequire("1A3mN");
var $fy1oX = parcelRequire("fy1oX");
var $78fb4574ceaba4f2$exports = {};


parcelRequire("8kEUo");
var $2HfTm = parcelRequire("2HfTm");
parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
var $4cca4cb0834266f6$var$_TSX;
var $4cca4cb0834266f6$var$_initClass, $4cca4cb0834266f6$var$_msgDecs, $4cca4cb0834266f6$var$_init_msg;
function $4cca4cb0834266f6$var$_applyDecs(e, t, r, n, o, a) {
    function i(e, t, r) {
        return function(n, o) {
            return r && r(n), e[t].call(n, o);
        };
    }
    function c(e, t) {
        for(var _$r = 0; _$r < e.length; _$r++)e[_$r].call(t);
        return t;
    }
    function s(e, t, r, n) {
        if ("function" != typeof e && (n || void 0 !== e)) throw new TypeError(t + " must " + (r || "be") + " a function" + (n ? "" : " or undefined"));
        return e;
    }
    function applyDec(e, t, r, n, o, a, c, u, l, f, p, d, h) {
        function m(e) {
            if (!h(e)) throw new TypeError("Attempted to access private element on non-instance");
        }
        var y, v = t[0], g = t[3], b = !u;
        if (!b) {
            r || Array.isArray(v) || (v = [
                v
            ]);
            var w = {}, S = [], A = 3 === o ? "get" : 4 === o || d ? "set" : "value";
            f ? (p || d ? w = {
                get: $4cca4cb0834266f6$var$_setFunctionName(function() {
                    return g(this);
                }, n, "get"),
                set: function set(e) {
                    t[4](this, e);
                }
            } : w[A] = g, p || $4cca4cb0834266f6$var$_setFunctionName(w[A], n, 2 === o ? "" : A)) : p || (w = Object.getOwnPropertyDescriptor(e, n));
        }
        for(var P = e, j = v.length - 1; j >= 0; j -= r ? 2 : 1){
            var D = v[j], E = r ? v[j - 1] : void 0, I = {}, O = {
                kind: [
                    "field",
                    "accessor",
                    "method",
                    "getter",
                    "setter",
                    "class"
                ][o],
                name: n,
                metadata: a,
                addInitializer: (function(e, t) {
                    if (e.v) throw Error("attempted to call addInitializer after decoration was finished");
                    s(t, "An initializer", "be", !0), c.push(t);
                }).bind(null, I)
            };
            try {
                if (b) (y = s(D.call(E, P, O), "class decorators", "return")) && (P = y);
                else {
                    var k, F;
                    O.static = l, O.private = f, f ? 2 === o ? k = function k(e) {
                        return m(e), w.value;
                    } : (o < 4 && (k = i(w, "get", m)), 3 !== o && (F = i(w, "set", m))) : (k = function k(e) {
                        return e[n];
                    }, (o < 2 || 4 === o) && (F = function F(e, t) {
                        e[n] = t;
                    }));
                    var N = O.access = {
                        has: f ? h.bind() : function(e) {
                            return n in e;
                        }
                    };
                    if (k && (N.get = k), F && (N.set = F), P = D.call(E, d ? {
                        get: w.get,
                        set: w.set
                    } : w[A], O), d) {
                        if ("object" == (typeof P === "undefined" ? "undefined" : (0, $7E0eS._)(P)) && P) (y = s(P.get, "accessor.get")) && (w.get = y), (y = s(P.set, "accessor.set")) && (w.set = y), (y = s(P.init, "accessor.init")) && S.push(y);
                        else if (void 0 !== P) throw new TypeError("accessor decorators must return an object with get, set, or init properties or void 0");
                    } else s(P, (p ? "field" : "method") + " decorators", "return") && (p ? S.push(P) : w[A] = P);
                }
            } finally{
                I.v = !0;
            }
        }
        return (p || d) && u.push(function(e, t) {
            for(var _$r = S.length - 1; _$r >= 0; _$r--)t = S[_$r].call(e, t);
            return t;
        }), p || b || (f ? d ? u.push(i(w, "get"), i(w, "set")) : u.push(2 === o ? w[A] : i.call.bind(w[A])) : Object.defineProperty(e, n, w)), P;
    }
    function u(e, t) {
        return Object.defineProperty(e, Symbol.metadata || Symbol.for("Symbol.metadata"), {
            configurable: !0,
            enumerable: !0,
            value: t
        });
    }
    if (arguments.length >= 6) var l = a[Symbol.metadata || Symbol.for("Symbol.metadata")];
    var f = Object.create(null == l ? null : l), p = function(e, t, r, n) {
        var _$o, _$a, i = [], s = function s(t) {
            return $4cca4cb0834266f6$var$_checkInRHS(t) === e;
        }, _$u = new Map();
        function l(e) {
            e && i.push(c.bind(null, e));
        }
        for(var f = 0; f < t.length; f++){
            var p = t[f];
            if (Array.isArray(p)) {
                var d = p[1], h = p[2], m = p.length > 3, y = 16 & d, v = !!(8 & d), g = 0 == (d &= 7), b = h + "/" + v;
                if (!g && !m) {
                    var w = _$u.get(b);
                    if (!0 === w || 3 === w && 4 !== d || 4 === w && 3 !== d) throw Error("Attempted to decorate a public method/accessor that has the same name as a previously decorated public method/accessor. This is not currently supported by the decorators plugin. Property name was: " + h);
                    _$u.set(b, !(d > 2) || d);
                }
                applyDec(v ? e : e.prototype, p, y, m ? "#" + h : $4cca4cb0834266f6$var$_toPropertyKey(h), d, n, v ? _$a = _$a || [] : _$o = _$o || [], i, v, m, g, 1 === d, v && m ? s : r);
            }
        }
        return l(_$o), l(_$a), i;
    }(e, t, o, f);
    return r.length || u(e, f), {
        e: p,
        get c () {
            var _$t = [];
            return r.length && [
                u(applyDec(e, [
                    r
                ], n, e.name, 5, f, _$t), f),
                c.bind(null, _$t, e)
            ];
        }
    };
}
function $4cca4cb0834266f6$var$_toPropertyKey(t) {
    var i = $4cca4cb0834266f6$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i)) ? i : i + "";
}
function $4cca4cb0834266f6$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $7E0eS._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $7E0eS._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4cca4cb0834266f6$var$_setFunctionName(e, t, n) {
    "symbol" == (typeof t === "undefined" ? "undefined" : (0, $7E0eS._)(t)) && (t = (t = t.description) ? "[" + t + "]" : "");
    try {
        Object.defineProperty(e, "name", {
            configurable: !0,
            value: n ? n + " " + t : t
        });
    } catch (e) {}
    return e;
}
function $4cca4cb0834266f6$var$_checkInRHS(e) {
    if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e === "undefined" ? "undefined" : (0, $7E0eS._)(e) : "null"));
    return e;
}
var $4cca4cb0834266f6$var$_hoisted_1 = [
    "onClick"
];
var $4cca4cb0834266f6$var$_HelloWorld;
var $4cca4cb0834266f6$var$_ref = ($4cca4cb0834266f6$var$_msgDecs = (0, $hbwBq.decorator)({
    type: String,
    required: true
}), "msg");
var $4cca4cb0834266f6$var$HelloWorld = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0, $hdIku._)(HelloWorld, _superClass);
    function HelloWorld() {
        (0, $173N4._)(this, HelloWorld);
        var _this;
        _this = (0, $7qXGD._)(this, HelloWorld, arguments), (0, $7Pjls._)(_this, $4cca4cb0834266f6$var$_ref, $4cca4cb0834266f6$var$_init_msg(_this)), (0, $7Pjls._)(_this, "count", 0);
        return _this;
    }
    (0, $cFHGC._)(HelloWorld, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                return function() {
                    var _cache = (0, $2HfTm.createVNodeCache)("12d7e2a11fd17a6a");
                    return (0, $fKAHx.openBlock)(), (0, $fKAHx.createElementBlock)("div", {
                        class: (0, $2HfTm.normalizeClass)($78fb4574ceaba4f2$exports)
                    }, [
                        (0, $fKAHx.createElementVNode)("h1", null, [
                            (0, $2HfTm.normalizeVNode)(function() {
                                return _this.msg;
                            })
                        ]),
                        _cache[1] || (_cache[1] = (0, $fKAHx.createElementVNode)("p", null, [
                            (0, $2HfTm.normalizeVNode)("See "),
                            (0, $fKAHx.createElementVNode)("code", null, "README.md"),
                            (0, $2HfTm.normalizeVNode)(" for more information.")
                        ], -1)),
                        _cache[2] || (_cache[2] = (0, $fKAHx.createElementVNode)("p", null, [
                            (0, $fKAHx.createElementVNode)("a", {
                                href: "https://parceljs.org/languages/vue/",
                                target: "_blank"
                            }, "Parcel docs"),
                            (0, $2HfTm.normalizeVNode)(" | "),
                            (0, $fKAHx.createElementVNode)("a", {
                                href: "https://v3.vuejs.org/",
                                target: "_blank"
                            }, "Vue 3 docs")
                        ], -1)),
                        (0, $fKAHx.createVNode)((0, $fy1oX.default), {
                            asChild: true
                        }, {
                            default: (0, $fKAHx.withCtx)(function() {
                                return [
                                    (0, $fKAHx.createElementVNode)("button", {
                                        type: "button",
                                        onClick: function() {
                                            return _this.count++;
                                        }
                                    }, [
                                        _cache[0] || (_cache[0] = (0, $2HfTm.normalizeVNode)("count is: ", -1)),
                                        (0, $2HfTm.normalizeVNode)(function() {
                                            return _this.count;
                                        })
                                    ], 8, $4cca4cb0834266f6$var$_hoisted_1)
                                ];
                            }),
                            _: 1
                        }),
                        _cache[3] || (_cache[3] = (0, $fKAHx.createElementVNode)("p", null, [
                            (0, $2HfTm.normalizeVNode)("Edit "),
                            (0, $fKAHx.createElementVNode)("code", null, "components/HelloWorld.vue"),
                            (0, $2HfTm.normalizeVNode)(" to test hot module\n          replacement.")
                        ], -1))
                    ], 2);
                }();
            }
        }
    ]);
    return HelloWorld;
}($4cca4cb0834266f6$var$_TSX = (0, $1oPot.TSX)()((0, $8uJ7j.Base)));
var $4cca4cb0834266f6$var$ref, $4cca4cb0834266f6$var$ref1, $4cca4cb0834266f6$var$ref2;
$4cca4cb0834266f6$var$ref = $4cca4cb0834266f6$var$_applyDecs($4cca4cb0834266f6$var$HelloWorld, [
    [
        $4cca4cb0834266f6$var$_msgDecs,
        0,
        "msg"
    ]
], [
    (0, $fTAJe.ComponentBase),
    (0, $as4kI.observer)
], 0, void 0, $4cca4cb0834266f6$var$_TSX), $4cca4cb0834266f6$var$ref1 = (0, $f9AOD._)($4cca4cb0834266f6$var$ref.e, 1), $4cca4cb0834266f6$var$_init_msg = $4cca4cb0834266f6$var$ref1[0], $4cca4cb0834266f6$var$ref1, $4cca4cb0834266f6$var$ref2 = (0, $f9AOD._)($4cca4cb0834266f6$var$ref.c, 2), $4cca4cb0834266f6$var$_HelloWorld = $4cca4cb0834266f6$var$ref2[0], $4cca4cb0834266f6$var$_initClass = $4cca4cb0834266f6$var$ref2[1], $4cca4cb0834266f6$var$ref2, $4cca4cb0834266f6$var$ref;
$4cca4cb0834266f6$var$_initClass();
var $4cca4cb0834266f6$export$2e2bcd8739ae039 = (0, $fTAJe.toNative)($4cca4cb0834266f6$var$_HelloWorld);


parcelRequire("63vlS");
var $fKAHx = parcelRequire("fKAHx");
var $7702e1277b13dba4$var$_hoisted_1 = {
    class: "home text-center"
};
var $7702e1277b13dba4$var$_hoisted_2 = [
    "src"
];
var $73ff8e26076a2dda$exports = {};
$73ff8e26076a2dda$exports = $parcel$resolve("lL72A");


var $7702e1277b13dba4$var$VueLogo = new URL($73ff8e26076a2dda$exports) + "";
var $7702e1277b13dba4$export$2e2bcd8739ae039 = (0, $as4kI.observer)(function() {
    return (0, $fKAHx.openBlock)(), (0, $fKAHx.createElementBlock)("div", $7702e1277b13dba4$var$_hoisted_1, [
        (0, $fKAHx.createElementVNode)("img", {
            class: "mx-auto block",
            alt: "Vue logo",
            src: $7702e1277b13dba4$var$VueLogo
        }, null, 8, $7702e1277b13dba4$var$_hoisted_2),
        (0, $fKAHx.createVNode)((0, $4cca4cb0834266f6$export$2e2bcd8739ae039), {
            msg: "Welcome to Your Vue.js + MobX + TypeScript + ShadcnVue App"
        })
    ]);
});







var $1d3ce9fbd9681475$export$2e2bcd8739ae039 = (0, $19184f195625c89b$export$baddd0131ee8c05b)({
    history: (0, $19184f195625c89b$export$542bc3a76486c94d)(),
    routes: [
        {
            path: '/',
            name: 'Home',
            component: (0, $7702e1277b13dba4$export$2e2bcd8739ae039)
        },
        {
            path: '/decorator/class',
            component: function() {
                return (parcelRequire("414kS"));
            }
        },
        {
            path: '/decorator/function',
            component: function() {
                return (parcelRequire("iBKDt"));
            }
        },
        {
            path: '/component',
            component: function() {
                return (parcelRequire("2MILA"));
            }
        },
        {
            path: '/chart',
            component: function() {
                return (parcelRequire("j1QOD"));
            }
        },
        {
            path: '/about',
            name: 'About',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: function() {
                return (parcelRequire("7BWFj"));
            }
        }
    ]
});



(0, $3959ba5a3cb8c567$export$dfb5619354ba860)();
(0, $h2kUE.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', function(param) {
    var reason = param.reason;
    var message = reason.message;
    if (message) self.alert(message);
});
var $4872a01b8e2005a6$var$serviceWorker = window.navigator.serviceWorker, $4872a01b8e2005a6$var$NODE_ENV = "production";
if ($4872a01b8e2005a6$var$NODE_ENV !== 'development') $4872a01b8e2005a6$var$serviceWorker === null || $4872a01b8e2005a6$var$serviceWorker === void 0 ? void 0 : $4872a01b8e2005a6$var$serviceWorker.register('sw.js').then((0, $gtaQ6.serviceWorkerUpdate)).then(function(worker) {
    if (window.confirm('New version of this Web App detected, update now?')) worker.postMessage({
        type: 'SKIP_WAITING'
    });
});
$4872a01b8e2005a6$var$serviceWorker === null || $4872a01b8e2005a6$var$serviceWorker === void 0 ? void 0 : $4872a01b8e2005a6$var$serviceWorker.addEventListener('controllerchange', function() {
    return window.location.reload();
});
(0, $3ewO8.createApp)((0, $cf16d8b2142c1e73$export$2e2bcd8739ae039)).use((0, $1d3ce9fbd9681475$export$2e2bcd8739ae039)).mount('#app');

})();
//# sourceMappingURL=Vue-MobX-Shadcn-ts.314883ce.js.map
